import React, { useState, useRef, useEffect, useMemo, useCallback, Fragment, createContext, useContext, useReducer } from 'react';
import styled, { css, keyframes } from 'styled-components';
import Blockies from 'react-blockies';
import { Link } from 'react-router-dom';
import { useMoralis } from 'react-moralis';

var arrowCircleDownIcon = function arrowCircleDownIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "Arrow circle down icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3636 12C19.3636 7.93318 16.0668 4.63636 12 4.63636C7.93318 4.63636 4.63636 7.93318 4.63636 12C4.63636 16.0668 7.93318 19.3636 12 19.3636C16.0668 19.3636 19.3636 16.0668 19.3636 12ZM12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM14.6942 11.4215C15.0137 11.1019 15.5317 11.1019 15.8513 11.4215C16.1708 11.741 16.1708 12.259 15.8513 12.5785L12.5785 15.8513C12.259 16.1708 11.741 16.1708 11.4215 15.8513L8.14873 12.5785C7.82921 12.259 7.82921 11.741 8.14873 11.4215C8.46825 11.1019 8.98629 11.1019 9.30581 11.4215L11.1818 13.2975V8.72727C11.1818 8.2754 11.5481 7.90909 12 7.90909C12.4519 7.90909 12.8182 8.2754 12.8182 8.72727V13.2975L14.6942 11.4215Z",
    fill: fill
  }));
};

var arrowCircleLeftIcon = function arrowCircleLeftIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "Arrow circle left"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.63636C7.93318 4.63636 4.63636 7.93318 4.63636 12C4.63636 16.0668 7.93318 19.3636 12 19.3636C16.0668 19.3636 19.3636 16.0668 19.3636 12C19.3636 7.93318 16.0668 4.63636 12 4.63636ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12.5785 8.14873C12.8981 8.46825 12.8981 8.98629 12.5785 9.30581L10.7025 11.1818H15.2727C15.7246 11.1818 16.0909 11.5481 16.0909 12C16.0909 12.4519 15.7246 12.8182 15.2727 12.8182H10.7025L12.5785 14.6942C12.8981 15.0137 12.8981 15.5317 12.5785 15.8513C12.259 16.1708 11.741 16.1708 11.4215 15.8513L8.14873 12.5785C7.82921 12.259 7.82921 11.741 8.14873 11.4215L11.4215 8.14873C11.741 7.82921 12.259 7.82921 12.5785 8.14873Z",
    fill: fill
  }));
};

var arrowCircleRightIcon = function arrowCircleRightIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "Arrow circle right"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.63636C7.93318 4.63636 4.63636 7.93318 4.63636 12C4.63636 16.0668 7.93318 19.3636 12 19.3636C16.0668 19.3636 19.3636 16.0668 19.3636 12C19.3636 7.93318 16.0668 4.63636 12 4.63636ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM11.4215 9.30581C11.1019 8.98629 11.1019 8.46825 11.4215 8.14873C11.741 7.82921 12.259 7.82921 12.5785 8.14873L15.8513 11.4215C16.1708 11.741 16.1708 12.259 15.8513 12.5785L12.5785 15.8513C12.259 16.1708 11.741 16.1708 11.4215 15.8513C11.1019 15.5317 11.1019 15.0137 11.4215 14.6942L13.2975 12.8182H8.72727C8.2754 12.8182 7.90909 12.4519 7.90909 12C7.90909 11.5481 8.2754 11.1818 8.72727 11.1818H13.2975L11.4215 9.30581Z",
    fill: fill
  }));
};

var bellIcon = function bellIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "bell icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C11.3173 2 10.7862 2.55664 10.7862 3.1875V4C7.97938 4.59375 5.43473 6.86133 5.43473 9.71875C5.43473 13.541 4.03131 15.6914 3.31063 16.4707C3.08305 16.6934 2.96926 16.9902 3.00719 17.25C3.00719 17.8809 3.46235 18.4375 4.22096 18.4375H19.779C20.5376 18.4375 20.9928 17.8809 20.9928 17.25C21.0307 16.9902 20.917 16.6934 20.6894 16.4707C19.9687 15.6914 18.5653 13.541 18.5653 9.71875C18.5653 6.86133 16.0206 4.59375 13.2138 4V3.1875C13.2138 2.55664 12.6827 2 12 2ZM5.54834 16.6562C6.34488 15.6543 7.21728 12.9102 7.25521 9.75586V9.71875C7.26607 7.25551 9.53656 5.56879 11.9998 5.5625C14.4631 5.56879 16.7336 7.25551 16.7444 9.71875V9.75586C16.7824 12.9102 17.6548 15.6543 18.4513 16.6562H5.54834Z",
    fill: fill
  }), React.createElement("path", {
    d: "M12 22C13.3276 22 14.3896 20.9609 14.3896 19.625H9.57246C9.57246 20.9609 10.6345 22 12 22Z",
    fill: fill
  }));
};

var binIcon = function binIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "bin icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 3.50549C9.8619 3.50549 9.74998 3.61742 9.74998 3.75549V4.51006H14.25V3.75549C14.25 3.61742 14.138 3.50549 14 3.50549H9.99998ZM15.75 4.51006V3.75549C15.75 2.78899 14.9665 2.00549 14 2.00549H9.99998C9.03348 2.00549 8.24998 2.78899 8.24998 3.75549V4.51006L4.75011 4.50993C4.3359 4.50991 4.00009 4.84567 4.00006 5.25988C4.00003 5.6741 4.33579 6.00992 4.75002 6.00996L5.24998 6.01V20.2579C5.24998 21.2244 6.03348 22.0079 6.99998 22.0079H17C17.9665 22.0079 18.75 21.2244 18.75 20.2579V6.01006H19.2501C19.6643 6.01006 20.0001 5.67427 20.0001 5.26006C20.0001 4.84585 19.6643 4.51006 19.2501 4.51006H15.75ZM17.25 6.01006H6.74998V20.2579C6.74998 20.396 6.8619 20.5079 6.99998 20.5079H17C17.138 20.5079 17.25 20.396 17.25 20.2579V6.01006ZM10.0001 18.4999C9.58585 18.4999 9.25006 18.1641 9.25006 17.7499V9.24988C9.25006 8.83566 9.58585 8.49988 10.0001 8.49988C10.4143 8.49988 10.7501 8.83566 10.7501 9.24988V17.7499C10.7501 18.1641 10.4143 18.4999 10.0001 18.4999ZM14.0001 18.4999C13.5858 18.4999 13.2501 18.1641 13.2501 17.7499V9.24988C13.2501 8.83566 13.5858 8.49988 14.0001 8.49988C14.4143 8.49988 14.7501 8.83566 14.7501 9.24988V17.7499C14.7501 18.1641 14.4143 18.4999 14.0001 18.4999Z",
    fill: fill
  }));
};

var bookIcon = function bookIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "book icon"), React.createElement("path", {
    d: "M7.49636 6.75C7.49636 6.90625 7.59011 7 7.74636 7H16.2517C16.3767 7 16.5017 6.90625 16.5017 6.75V5.75C16.5017 5.625 16.3767 5.5 16.2517 5.5H7.74636C7.59011 5.5 7.49636 5.625 7.49636 5.75V6.75ZM7.74636 10H16.2517C16.3767 10 16.5017 9.90625 16.5017 9.75V8.75C16.5017 8.625 16.3767 8.5 16.2517 8.5H7.74636C7.59011 8.5 7.49636 8.625 7.49636 8.75V9.75C7.49636 9.90625 7.59011 10 7.74636 10ZM19.5938 18.5C19.8125 18.4688 20 18.25 20 18V2.5C20 2.25 19.75 2 19.5 2H6.5C5.09375 2 4 3.125 4 4.5V19.5C4 20.9062 5.09375 22 6.5 22H19.5C19.75 22 20 21.7812 20 21.5V21C20 20.7812 19.8125 20.5625 19.5938 20.5312C19.4375 20.125 19.4375 18.9062 19.5938 18.5ZM18.3125 18.5C18.2188 19.0625 18.2188 19.9688 18.3125 20.5H6.5C5.9375 20.5 5.5 20.0625 5.5 19.5C5.5 18.9688 5.9375 18.5 6.5 18.5H18.3125ZM18.5 3.5V17H6.5C6.125 17 5.78125 17.0938 5.5 17.2188V4.5C5.5 3.96875 5.9375 3.5 6.5 3.5H18.5Z",
    fill: fill
  }));
};

var calendarIcon = function calendarIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "calendar icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 6.27273C5.95817 6.27273 5.6 6.63904 5.6 7.09091V18.5455C5.6 18.9973 5.95817 19.3636 6.4 19.3636H17.6C18.0418 19.3636 18.4 18.9973 18.4 18.5455V7.09091C18.4 6.63904 18.0418 6.27273 17.6 6.27273H6.4ZM4 7.09091C4 5.7353 5.07452 4.63636 6.4 4.63636H17.6C18.9255 4.63636 20 5.7353 20 7.09091V18.5455C20 19.9011 18.9255 21 17.6 21H6.4C5.07452 21 4 19.9011 4 18.5455V7.09091Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 3C15.6418 3 16 3.36631 16 3.81818V7.09091C16 7.54278 15.6418 7.90909 15.2 7.90909C14.7582 7.90909 14.4 7.54278 14.4 7.09091V3.81818C14.4 3.36631 14.7582 3 15.2 3Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 3C9.24183 3 9.6 3.36631 9.6 3.81818V7.09091C9.6 7.54278 9.24183 7.90909 8.8 7.90909C8.35817 7.90909 8 7.54278 8 7.09091V3.81818C8 3.36631 8.35817 3 8.8 3Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.3636C4 9.91177 4.35817 9.54545 4.8 9.54545H19.2C19.6418 9.54545 20 9.91177 20 10.3636C20 10.8155 19.6418 11.1818 19.2 11.1818H4.8C4.35817 11.1818 4 10.8155 4 10.3636Z",
    fill: fill
  }));
};

var cameraIcon = function cameraIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "camera icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80658 4.0378C8.96113 3.80597 9.22132 3.66672 9.49995 3.66672H14.4999C14.7785 3.66672 15.0387 3.80597 15.1933 4.0378L16.6126 6.1667H19.4999C20.1629 6.1667 20.7988 6.43009 21.2676 6.89893C21.7365 7.36777 21.9999 8.00365 21.9999 8.66668V17.8333C21.9999 18.4963 21.7365 19.1322 21.2676 19.601C20.7988 20.0699 20.1629 20.3333 19.4999 20.3333H4.49998C3.83695 20.3333 3.20107 20.0699 2.73223 19.601C2.26339 19.1322 2 18.4963 2 17.8333V8.66668C2 8.00365 2.26339 7.36777 2.73223 6.89893C3.20107 6.43009 3.83695 6.1667 4.49998 6.1667H7.38731L8.80658 4.0378ZM9.94593 5.33337L8.52666 7.46228C8.37211 7.69411 8.11192 7.83336 7.83329 7.83336H4.49998C4.27897 7.83336 4.06701 7.92115 3.91073 8.07743C3.75445 8.23371 3.66666 8.44567 3.66666 8.66668V17.8333C3.66666 18.0543 3.75445 18.2663 3.91073 18.4225C4.06701 18.5788 4.27897 18.6666 4.49998 18.6666H19.4999C19.7209 18.6666 19.9329 18.5788 20.0891 18.4225C20.2454 18.2663 20.3332 18.0543 20.3332 17.8333V8.66668C20.3332 8.44567 20.2454 8.23371 20.0891 8.07743C19.9329 7.92115 19.7209 7.83336 19.4999 7.83336H16.1666C15.8879 7.83336 15.6278 7.69411 15.4732 7.46228L14.0539 5.33337H9.94593ZM11.9999 10.3333C10.6192 10.3333 9.49995 11.4526 9.49995 12.8333C9.49995 14.214 10.6192 15.3333 11.9999 15.3333C13.3806 15.3333 14.4999 14.214 14.4999 12.8333C14.4999 11.4526 13.3806 10.3333 11.9999 10.3333ZM7.83329 12.8333C7.83329 10.5322 9.69876 8.66668 11.9999 8.66668C14.3011 8.66668 16.1666 10.5322 16.1666 12.8333C16.1666 15.1345 14.3011 17 11.9999 17C9.69876 17 7.83329 15.1345 7.83329 12.8333Z",
    fill: fill
  }));
};

var cartIcon = function cartIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "cart icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.875C0 2.39175 0.391751 2 0.875 2H4.375C4.79205 2 5.15113 2.29434 5.23298 2.70327L5.96788 6.375H20.125C20.3858 6.375 20.6329 6.49131 20.7992 6.69223C20.9654 6.89316 21.0334 7.15775 20.9845 7.41391L19.5833 14.7617C19.4632 15.366 19.1345 15.9088 18.6546 16.2951C18.1771 16.6795 17.5802 16.8846 16.9674 16.875H8.47756C7.86483 16.8846 7.26793 16.6795 6.79042 16.2951C6.31071 15.9089 5.98205 15.3664 5.86191 14.7625C5.86186 14.7622 5.86196 14.7627 5.86191 14.7625L4.40019 7.4593C4.39426 7.43514 4.38933 7.41059 4.38546 7.38569L3.65778 3.75H0.875C0.391751 3.75 0 3.35825 0 2.875ZM6.31814 8.125L7.57823 14.4208C7.61824 14.6222 7.72782 14.8031 7.88778 14.9319C8.04775 15.0607 8.24791 15.1291 8.45323 15.1252L8.47 15.125H16.975L16.9918 15.1252C17.1971 15.1291 17.3972 15.0607 17.5572 14.9319C17.7164 14.8037 17.8257 14.6239 17.8662 14.4236L19.0674 8.125H6.31814ZM6.125 20.375C6.125 19.4085 6.9085 18.625 7.875 18.625C8.8415 18.625 9.625 19.4085 9.625 20.375C9.625 21.3415 8.8415 22.125 7.875 22.125C6.9085 22.125 6.125 21.3415 6.125 20.375ZM15.75 20.375C15.75 19.4085 16.5335 18.625 17.5 18.625C18.4665 18.625 19.25 19.4085 19.25 20.375C19.25 21.3415 18.4665 22.125 17.5 22.125C16.5335 22.125 15.75 21.3415 15.75 20.375Z",
    fill: fill
  }));
};

var chartIcon = function chartIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "chart icon"), React.createElement("path", {
    d: "M4 4H5.68421V20H4V4Z",
    fill: fill
  }), React.createElement("path", {
    d: "M20 11.2V8.8L6.52632 8.8V11.2L20 11.2Z",
    fill: fill
  }), React.createElement("path", {
    d: "M13.2632 7.2V4.8L6.52632 4.8L6.52632 7.2L13.2632 7.2Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17.4737 12.8V15.2H6.52632L6.52632 12.8L17.4737 12.8Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.9474 19.2L14.9474 16.8L6.52632 16.8V19.2H14.9474Z",
    fill: fill
  }));
};

var checkIcon = function checkIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "check icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7071 5.29289C21.0976 5.68342 21.0976 6.31658 20.7071 6.70711L9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L19.2929 5.29289C19.6834 4.90237 20.3166 4.90237 20.7071 5.29289Z",
    fill: fill
  }));
};

var checkmarkIcon = function checkmarkIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "checkmark icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM16.8398 7.65446L17.7872 8.60183C17.952 8.76659 17.952 9.09611 17.7872 9.30206L14.2243 12.8238L10.6613 16.3455C10.4554 16.5515 10.1671 16.5515 9.9611 16.3455L6.21282 12.5561C6.04806 12.3913 6.04806 12.0618 6.21282 11.8558L7.16019 10.9497C7.36614 10.7437 7.65447 10.7437 7.86042 10.9497L10.3318 13.4211L16.1396 7.65446C16.3455 7.44851 16.6751 7.44851 16.8398 7.65446Z",
    fill: fill
  }));
};

var chevronDownIcon = function chevronDownIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "chevron down icon"), React.createElement("path", {
    d: "M11.7348 15.8819C11.8908 16.0394 12.1092 16.0394 12.2652 15.8819L16.883 11.252C17.039 11.126 17.039 10.874 16.883 10.7165L16.259 10.1181C16.1342 9.96063 15.8846 9.96063 15.7285 10.1181L12.0156 13.8346L8.27145 10.1181C8.11544 9.96063 7.89704 9.96063 7.74103 10.1181L7.117 10.7165C6.961 10.874 6.961 11.126 7.117 11.252L11.7348 15.8819Z",
    fill: fill
  }));
};

var chevronLeftIcon = function chevronLeftIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "chevron left icon"), React.createElement("path", {
    d: "M9.11811 11.7348C8.96063 11.8908 8.96063 12.1092 9.11811 12.2652L13.748 16.883C13.874 17.039 14.126 17.039 14.2835 16.883L14.8819 16.259C15.0394 16.1342 15.0394 15.8846 14.8819 15.7285L11.1654 12.0156L14.8819 8.27145C15.0394 8.11544 15.0394 7.89704 14.8819 7.74103L14.2835 7.117C14.126 6.961 13.874 6.961 13.748 7.117L9.11811 11.7348Z",
    fill: fill
  }));
};

var chevronLeftX2Icon = function chevronLeftX2Icon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "chevron left X2 icon"), React.createElement("path", {
    d: "M6.11811 11.7348C5.96063 11.8908 5.96063 12.1092 6.11811 12.2652L10.748 16.883C10.874 17.039 11.126 17.039 11.2835 16.883L11.8819 16.259C12.0394 16.1342 12.0394 15.8846 11.8819 15.7285L8.16535 12.0156L11.8819 8.27145C12.0394 8.11544 12.0394 7.89704 11.8819 7.74103L11.2835 7.117C11.126 6.961 10.874 6.961 10.748 7.117L6.11811 11.7348Z",
    fill: fill
  }), React.createElement("path", {
    d: "M12.1181 11.7348C11.9606 11.8908 11.9606 12.1092 12.1181 12.2652L16.748 16.883C16.874 17.039 17.126 17.039 17.2835 16.883L17.8819 16.259C18.0394 16.1342 18.0394 15.8846 17.8819 15.7285L14.1654 12.0156L17.8819 8.27145C18.0394 8.11544 18.0394 7.89704 17.8819 7.74103L17.2835 7.117C17.126 6.961 16.874 6.961 16.748 7.117L12.1181 11.7348Z",
    fill: fill
  }));
};

var chevronRightIcon = function chevronRightIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "chevron right icon"), React.createElement("path", {
    d: "M14.8819 12.2652C15.0394 12.1092 15.0394 11.8908 14.8819 11.7348L10.252 7.117C10.126 6.961 9.87402 6.961 9.71654 7.117L9.11811 7.74103C8.96063 7.86583 8.96063 8.11544 9.11811 8.27145L12.8346 11.9844L9.11811 15.7285C8.96063 15.8846 8.96063 16.103 9.11811 16.259L9.71654 16.883C9.87402 17.039 10.126 17.039 10.252 16.883L14.8819 12.2652Z",
    fill: fill
  }));
};

var chevronRightX2Icon = function chevronRightX2Icon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "chevron right X2 icon"), React.createElement("path", {
    d: "M17.8819 11.7348C18.0394 11.8908 18.0394 12.1092 17.8819 12.2652L13.252 16.883C13.126 17.039 12.874 17.039 12.7165 16.883L12.1181 16.259C11.9606 16.1342 11.9606 15.8846 12.1181 15.7285L15.8346 12.0156L12.1181 8.27145C11.9606 8.11544 11.9606 7.89704 12.1181 7.74103L12.7165 7.117C12.874 6.961 13.126 6.961 13.252 7.117L17.8819 11.7348Z",
    fill: fill
  }), React.createElement("path", {
    d: "M11.8819 11.7348C12.0394 11.8908 12.0394 12.1092 11.8819 12.2652L7.25197 16.883C7.12598 17.039 6.87402 17.039 6.71654 16.883L6.11811 16.259C5.96063 16.1342 5.96063 15.8846 6.11811 15.7285L9.83465 12.0156L6.11811 8.27145C5.96063 8.11544 5.96063 7.89704 6.11811 7.74103L6.71654 7.117C6.87402 6.961 7.12598 6.961 7.25197 7.117L11.8819 11.7348Z",
    fill: fill
  }));
};

var chevronUpIcon = function chevronUpIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "chevron up icon"), React.createElement("path", {
    d: "M12.2652 9.11811C12.1092 8.96063 11.8908 8.96063 11.7348 9.11811L7.117 13.748C6.961 13.874 6.961 14.126 7.117 14.2835L7.74103 14.8819C7.86583 15.0394 8.11544 15.0394 8.27145 14.8819L11.9844 11.1654L15.7285 14.8819C15.8846 15.0394 16.103 15.0394 16.259 14.8819L16.883 14.2835C17.039 14.126 17.039 13.874 16.883 13.748L12.2652 9.11811Z",
    fill: fill
  }));
};

var cloudIcon = function cloudIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "cloud icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24673 10.1605L6.45645 10.296C4.87436 10.5674 3.66667 12.0123 3.66667 13.75C3.66667 15.683 5.15905 17.25 7 17.25H17.8333C19.214 17.25 20.3333 16.0747 20.3333 14.625C20.3333 13.313 19.415 12.223 18.2167 12.0304L17.1201 11.8542L16.8517 10.724C16.3093 8.44025 14.3405 6.75 12 6.75C10.1312 6.75 8.49953 7.82571 7.6398 9.42794L7.24673 10.1605ZM18.4688 10.3006C17.7457 7.25579 15.1237 5 12 5C9.50539 5 7.3308 6.43867 6.18774 8.56893C3.81262 8.97634 2 11.1409 2 13.75C2 16.6495 4.23858 19 7 19H17.8333C20.1345 19 22 17.0412 22 14.625C22 12.4356 20.4684 10.6219 18.4688 10.3006Z",
    fill: fill
  }));
};

var cogIcon = function cogIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "cog icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.66667C11.779 3.66667 11.567 3.75446 11.4107 3.91074C11.2545 4.06702 11.1667 4.27899 11.1667 4.5V4.64499C11.1649 5.07566 11.0373 5.49644 10.7995 5.85551C10.5617 6.21459 10.2241 6.49629 9.82828 6.66595C9.75781 6.69615 9.68368 6.71641 9.60801 6.7263C9.24831 6.85226 8.8611 6.88331 8.48417 6.81497C8.05 6.73625 7.64937 6.52927 7.33395 6.22072L7.32737 6.21429L7.27741 6.16426C7.20002 6.08677 7.10778 6.02498 7.00662 5.98304C6.90545 5.94111 6.79701 5.91952 6.6875 5.91952C6.57799 5.91952 6.46955 5.94111 6.36838 5.98304C6.26722 6.02498 6.17531 6.08645 6.09792 6.16393L6.09726 6.16458C6.01978 6.24198 5.95831 6.33388 5.91638 6.43505C5.87444 6.53621 5.85286 6.64465 5.85286 6.75417C5.85286 6.86368 5.87444 6.97212 5.91638 7.07328C5.95831 7.17445 6.01978 7.26636 6.09726 7.34375L6.15409 7.40058C6.46264 7.71601 6.66958 8.11667 6.7483 8.55083C6.82546 8.97636 6.77594 9.41497 6.60621 9.81231C6.45157 10.2178 6.18081 10.5689 5.82754 10.8216C5.46712 11.0793 5.03748 11.2227 4.59449 11.2331L4.575 11.2333H4.5C4.27899 11.2333 4.06702 11.3211 3.91074 11.4774C3.75446 11.6337 3.66667 11.8457 3.66667 12.0667C3.66667 12.2877 3.75446 12.4996 3.91074 12.6559C4.06702 12.8122 4.27899 12.9 4.5 12.9H4.64499C5.07566 12.9017 5.49644 13.0293 5.85551 13.2671C6.21334 13.5041 6.49433 13.8402 6.66418 14.2343C6.8409 14.6369 6.89342 15.0831 6.81497 15.5158C6.73625 15.95 6.52927 16.3506 6.22072 16.6661L6.21429 16.6726L6.16425 16.7226C6.08677 16.8 6.02498 16.8922 5.98304 16.9934C5.94111 17.0945 5.91952 17.203 5.91952 17.3125C5.91952 17.422 5.94111 17.5305 5.98304 17.6316C6.02498 17.7328 6.08645 17.8247 6.16393 17.9021L6.16458 17.9027C6.24198 17.9802 6.33388 18.0417 6.43505 18.0836C6.53622 18.1256 6.64465 18.1471 6.75417 18.1471C6.86368 18.1471 6.97212 18.1256 7.07328 18.0836C7.17445 18.0417 7.26636 17.9802 7.34375 17.9027L7.40058 17.8459C7.71601 17.5374 8.11667 17.3304 8.55083 17.2517C8.97635 17.1745 9.41497 17.2241 9.81231 17.3938C10.2178 17.5484 10.5689 17.8192 10.8216 18.1725C11.0793 18.5329 11.2227 18.9625 11.2331 19.4055L11.2333 19.425V19.5C11.2333 19.721 11.3211 19.933 11.4774 20.0893C11.6337 20.2455 11.8457 20.3333 12.0667 20.3333C12.2877 20.3333 12.4996 20.2455 12.6559 20.0893C12.8122 19.933 12.9 19.721 12.9 19.5V19.3583L12.9 19.355C12.9017 18.9243 13.0293 18.5036 13.2671 18.1445C13.5041 17.7866 13.8402 17.5056 14.2344 17.3358C14.637 17.1591 15.0832 17.1066 15.5158 17.185C15.95 17.2638 16.3506 17.4707 16.6661 17.7793L16.6726 17.7857L16.7226 17.8357C16.8 17.9132 16.8922 17.975 16.9934 18.017C17.0945 18.0589 17.203 18.0805 17.3125 18.0805C17.422 18.0805 17.5305 18.0589 17.6316 18.017C17.7328 17.975 17.8247 17.9136 17.9021 17.8361L17.9027 17.8354C17.9802 17.758 18.0417 17.6661 18.0836 17.5649C18.1256 17.4638 18.1471 17.3553 18.1471 17.2458C18.1471 17.1363 18.1256 17.0279 18.0836 16.9267C18.0417 16.8255 17.9802 16.7336 17.9027 16.6562L17.8459 16.5994C17.5374 16.284 17.3304 15.8833 17.2517 15.4492C17.1732 15.0165 17.2258 14.5703 17.4024 14.1677C17.5723 13.7736 17.8533 13.4375 18.2112 13.2005C18.5702 12.9627 18.991 12.8351 19.4217 12.8333L19.425 12.8333L19.5 12.8333C19.721 12.8333 19.933 12.7455 20.0893 12.5893C20.2455 12.433 20.3333 12.221 20.3333 12C20.3333 11.779 20.2455 11.567 20.0893 11.4107C19.933 11.2545 19.721 11.1667 19.5 11.1667H19.3583L19.355 11.1667C18.9243 11.1649 18.5036 11.0373 18.1445 10.7995C17.7854 10.5617 17.5037 10.2241 17.334 9.82828C17.3039 9.75781 17.2836 9.68368 17.2737 9.60801C17.1477 9.24831 17.1167 8.8611 17.185 8.48417C17.2638 8.05 17.4707 7.64938 17.7793 7.33395L17.7857 7.32738L17.8357 7.27741C17.9132 7.20002 17.975 7.10778 18.017 7.00662C18.0589 6.90545 18.0805 6.79701 18.0805 6.6875C18.0805 6.57799 18.0589 6.46955 18.017 6.36838C17.975 6.26722 17.9136 6.17531 17.8361 6.09792L17.8354 6.09726C17.758 6.01978 17.6661 5.95831 17.5649 5.91638C17.4638 5.87444 17.3553 5.85286 17.2458 5.85286C17.1363 5.85286 17.0279 5.87444 16.9267 5.91638C16.8256 5.95832 16.7336 6.01978 16.6562 6.09726L16.5994 6.15409C16.284 6.46264 15.8833 6.66958 15.4492 6.7483C15.0165 6.82676 14.5702 6.77423 14.1676 6.59751C13.7735 6.42767 13.4374 6.14667 13.2005 5.78885C12.9627 5.42977 12.8351 5.009 12.8333 4.57832L12.8333 4.575V4.5C12.8333 4.27899 12.7455 4.06702 12.5893 3.91074C12.433 3.75446 12.221 3.66667 12 3.66667ZM10.2322 2.73223C10.7011 2.26339 11.337 2 12 2C12.663 2 13.2989 2.26339 13.7678 2.73223C14.2366 3.20107 14.5 3.83696 14.5 4.5V4.57292C14.5007 4.67812 14.5319 4.78087 14.59 4.8686C14.6484 4.95667 14.7312 5.02577 14.8283 5.06738L14.8365 5.0709C14.9355 5.1146 15.0453 5.12768 15.1518 5.10837C15.2571 5.08928 15.3544 5.0394 15.4314 4.96509L15.4771 4.91941C15.7093 4.68696 15.985 4.50257 16.2885 4.37676C16.592 4.25095 16.9173 4.18619 17.2458 4.18619C17.5744 4.18619 17.8997 4.25095 18.2032 4.37676C18.5067 4.50257 18.7824 4.68697 19.0146 4.91941C19.2467 5.15145 19.4309 5.42694 19.5566 5.73015C19.6824 6.03364 19.7471 6.35896 19.7471 6.6875C19.7471 7.01604 19.6824 7.34136 19.5566 7.64485C19.4308 7.9482 19.2465 8.22381 19.0143 8.45592C19.0141 8.45603 19.0144 8.45581 19.0143 8.45592L18.9683 8.50192C18.8939 8.5789 18.8441 8.67618 18.825 8.78152C18.8057 8.88801 18.8187 8.99785 18.8624 9.09686C18.8859 9.15023 18.9038 9.20577 18.9156 9.26256C18.9551 9.32066 19.0056 9.37082 19.0647 9.40996C19.1525 9.46806 19.2552 9.49934 19.3604 9.5H19.5C20.163 9.5 20.7989 9.76339 21.2678 10.2322C21.7366 10.7011 22 11.337 22 12C22 12.663 21.7366 13.2989 21.2678 13.7678C20.7989 14.2366 20.163 14.5 19.5 14.5H19.4271C19.3219 14.5007 19.2191 14.5319 19.1314 14.59C19.0433 14.6484 18.9742 14.7312 18.9326 14.8283L18.9291 14.8365C18.8854 14.9355 18.8723 15.0453 18.8916 15.1518C18.9107 15.2571 18.9606 15.3544 19.0349 15.4314L19.0806 15.4771C19.0807 15.4772 19.0805 15.477 19.0806 15.4771C19.3129 15.7092 19.4975 15.9851 19.6232 16.2885C19.7491 16.592 19.8138 16.9173 19.8138 17.2458C19.8138 17.5744 19.7491 17.8997 19.6232 18.2032C19.4974 18.5067 19.313 18.7824 19.0806 19.0146L18.4917 18.425L19.0813 19.0139C18.8491 19.2464 18.5733 19.4308 18.2698 19.5566C17.9664 19.6824 17.641 19.7471 17.3125 19.7471C16.984 19.7471 16.6586 19.6824 16.3551 19.5566C16.0518 19.4308 15.7762 19.2465 15.5441 19.0143C15.544 19.0141 15.5442 19.0144 15.5441 19.0143L15.4981 18.9682C15.4211 18.8939 15.3238 18.8441 15.2185 18.825C15.112 18.8057 15.0022 18.8187 14.9031 18.8624L14.895 18.866C14.7979 18.9076 14.715 18.9767 14.6567 19.0647C14.5986 19.1525 14.5673 19.2552 14.5667 19.3604V19.5C14.5667 20.163 14.3033 20.7989 13.8344 21.2678C13.3656 21.7366 12.7297 22 12.0667 22C11.4036 22 10.7677 21.7366 10.2989 21.2678C9.83006 20.7989 9.56667 20.163 9.56667 19.5V19.437C9.56271 19.331 9.52772 19.2284 9.46595 19.142C9.40272 19.0536 9.31436 18.9863 9.21235 18.9488C9.19587 18.9427 9.17959 18.9361 9.16353 18.9291C9.06451 18.8854 8.95468 18.8723 8.84818 18.8916C8.74285 18.9107 8.64556 18.9606 8.56858 19.0349L8.52292 19.0806C8.52281 19.0807 8.52302 19.0805 8.52292 19.0806C8.2908 19.3129 8.01487 19.4975 7.71152 19.6232C7.40802 19.7491 7.08271 19.8138 6.75417 19.8138C6.42563 19.8138 6.10031 19.7491 5.79682 19.6232C5.49361 19.4976 5.21812 19.3134 4.98607 19.0813C4.75363 18.8491 4.56923 18.5733 4.44342 18.2698C4.31761 17.9664 4.25286 17.641 4.25286 17.3125C4.25286 16.984 4.31761 16.6586 4.44342 16.3551C4.56923 16.0517 4.75363 15.7759 4.98607 15.5437L5.03176 15.4981C5.10607 15.4211 5.15594 15.3238 5.17504 15.2185C5.19435 15.112 5.18131 15.0022 5.13761 14.9031L5.13401 14.895C5.09239 14.7979 5.02334 14.715 4.93526 14.6567C4.84753 14.5986 4.74479 14.5673 4.63958 14.5667H4.5C3.83696 14.5667 3.20107 14.3033 2.73223 13.8344C2.26339 13.3656 2 12.7297 2 12.0667C2 11.4036 2.26339 10.7677 2.73223 10.2989C3.20107 9.83006 3.83696 9.56667 4.5 9.56667H4.56303C4.66903 9.56271 4.7716 9.52772 4.85796 9.46595C4.94636 9.40272 5.0137 9.31436 5.05122 9.21235C5.05728 9.19587 5.06386 9.17959 5.07095 9.16353C5.11465 9.06451 5.12768 8.95468 5.10837 8.84818C5.08927 8.74285 5.0394 8.64557 4.96508 8.56859L4.91941 8.52292C4.68696 8.29073 4.50257 8.01501 4.37676 7.71152C4.25095 7.40802 4.18619 7.08271 4.18619 6.75417C4.18619 6.42563 4.25095 6.10031 4.37676 5.79682C4.50251 5.49346 4.68679 5.21786 4.91908 4.98574C5.15119 4.75346 5.4268 4.56917 5.73015 4.44342C6.03364 4.31761 6.35896 4.25286 6.6875 4.25286C7.01604 4.25286 7.34136 4.31761 7.64485 4.44342C7.94835 4.56923 8.22407 4.75363 8.45625 4.98607L8.50192 5.03175C8.5789 5.10607 8.67619 5.15594 8.78152 5.17504C8.88801 5.19435 8.99785 5.18131 9.09686 5.13761C9.15023 5.11406 9.20577 5.09624 9.26256 5.08435C9.32066 5.04491 9.37082 4.99436 9.40996 4.93526C9.46806 4.84753 9.49934 4.74479 9.5 4.63958V4.5C9.5 3.83696 9.76339 3.20107 10.2322 2.73223ZM12 10.3333C11.0795 10.3333 10.3333 11.0795 10.3333 12C10.3333 12.9205 11.0795 13.6667 12 13.6667C12.9205 13.6667 13.6667 12.9205 13.6667 12C13.6667 11.0795 12.9205 10.3333 12 10.3333ZM8.66667 12C8.66667 10.1591 10.1591 8.66667 12 8.66667C13.8409 8.66667 15.3333 10.1591 15.3333 12C15.3333 13.8409 13.8409 15.3333 12 15.3333C10.1591 15.3333 8.66667 13.8409 8.66667 12Z",
    fill: fill
  }));
};

var copyIcon = function copyIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "copy icon"), React.createElement("path", {
    d: "M13.306 14.501H8.29229C7.82031 14.501 7.44629 14.1256 7.44629 13.6717C7.44629 13.2177 7.82922 12.8424 8.29229 12.8424H13.3149C13.7868 12.8424 14.1609 13.2177 14.1609 13.6717C14.1609 14.1256 13.7779 14.501 13.306 14.501Z",
    fill: fill
  }), React.createElement("path", {
    d: "M13.306 11.1664H8.29229C7.82031 11.1664 7.44629 10.7911 7.44629 10.3371C7.44629 9.88316 7.82922 9.50778 8.29229 9.50778H13.3149C13.7868 9.50778 14.1609 9.88316 14.1609 10.3371C14.1609 10.7911 13.7779 11.1664 13.306 11.1664Z",
    fill: fill
  }), React.createElement("path", {
    d: "M13.306 17.8358H8.29229C7.82031 17.8358 7.44629 17.4605 7.44629 17.0065C7.44629 16.5526 7.82922 16.1772 8.29229 16.1772H13.3149C13.7868 16.1772 14.1609 16.5526 14.1609 17.0065C14.1609 17.4605 13.7779 17.8358 13.306 17.8358Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.9891 22H6.60924C5.1755 22 4 20.8477 4 19.4422V7.89265C4 6.47843 5.1755 5.33482 6.60924 5.33482H14.9891C16.4318 5.33482 17.5983 6.48715 17.5983 7.89265V19.4422C17.5983 20.8477 16.4318 22 14.9891 22ZM6.60924 7.00221C6.11055 7.00221 5.70091 7.40378 5.70091 7.89265V19.4422C5.70091 19.931 6.11055 20.3326 6.60924 20.3326H14.9891C15.4878 20.3326 15.8974 19.931 15.8974 19.4422V7.89265C15.8974 7.40378 15.4878 7.00221 14.9891 7.00221H6.60924Z",
    fill: fill
  }), React.createElement("path", {
    d: "M18.3907 18.6652H16.7522C16.2802 18.6652 15.9062 18.2898 15.9062 17.8358C15.9062 17.3819 16.2891 17.0065 16.7522 17.0065H18.3907C18.8894 17.0065 19.2991 16.6049 19.2991 16.1161V4.55783C19.2991 4.06896 18.8894 3.66739 18.3907 3.66739H10.0109C9.51217 3.66739 9.10253 4.06896 9.10253 4.55783V6.16411C9.10253 6.62679 8.7196 6.99344 8.25653 6.99344C7.79346 6.99344 7.40162 6.62679 7.40162 6.16411V4.55783C7.40162 3.15233 8.56821 2 10.0109 2H18.3907C19.8334 2 21 3.15233 21 4.55783V16.1073C21 17.5216 19.8245 18.6652 18.3907 18.6652Z",
    fill: fill
  }));
};

var creditCardIcon = function creditCardIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "credit card icon"), React.createElement("path", {
    d: "M20.2986 4H3.66667C2.72917 4 2 4.78571 2 5.71429V18.2857C2 19.25 2.72917 20 3.66667 20H20.2986C21.2361 20 22 19.25 22 18.2857V5.71429C22 4.78571 21.2361 4 20.2986 4ZM3.875 5.71429H20.0903C20.2292 5.71429 20.2986 5.82143 20.2986 5.92857V8H3.66667V5.92857C3.66667 5.82143 3.73611 5.71429 3.875 5.71429ZM20.0903 18.2857H3.875C3.73611 18.2857 3.66667 18.2143 3.66667 18.0714V10H20.2986V18.0714C20.2986 18.2143 20.2292 18.2857 20.0903 18.2857ZM8.66667 15C8.66667 14.7857 8.45833 14.5714 8.25 14.5714H5.75C5.50694 14.5714 5.33333 14.7857 5.33333 15V16.1429C5.33333 16.3929 5.50694 16.5714 5.75 16.5714H8.25C8.45833 16.5714 8.66667 16.3929 8.66667 16.1429V15ZM15.3333 15C15.3333 14.7857 15.125 14.5714 14.9167 14.5714H10.1944C9.95139 14.5714 9.77778 14.7857 9.77778 15V16.1429C9.77778 16.3929 9.95139 16.5714 10.1944 16.5714H14.9167C15.125 16.5714 15.3333 16.3929 15.3333 16.1429V15Z",
    fill: fill
  }));
};

var cubeIcon = function cubeIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "cube icon"), React.createElement("path", {
    d: "M4.08247 7.50514C4 7.58743 4 7.66971 4 7.83429V16.2274C4 16.4743 4.08247 16.6389 4.3299 16.7211L11.6701 20.9177C11.7526 21 11.8351 21 12 21C12.0825 21 12.1649 21 12.3299 20.9177L19.6701 16.7211C19.835 16.6389 20 16.392 20 16.2274V7.83429C20 7.752 20 7.58743 19.9175 7.50514C19.8351 7.42286 19.7526 7.34057 19.6701 7.25829L12.1649 3.06171C12 2.97943 11.7526 2.97943 11.5876 3.06171L4.24742 7.25829C4.16495 7.34057 4.08247 7.42286 4.08247 7.50514ZM5.15464 15.8983V8.82171L11.2577 12.36V19.4366L5.15464 15.8983ZM18.5979 15.8983L12.4948 19.4366V12.36L18.5979 8.82171V15.8983ZM11.9175 4.296L18.0206 7.83429L11.9175 11.3726L5.81443 7.83429L11.9175 4.296ZM13.8144 13.1829C13.8969 13.0183 14.1443 12.936 14.3093 13.0183L17.0309 14.5817C17.1959 14.664 17.2783 14.9109 17.1959 15.0754C17.1134 15.24 16.866 15.3223 16.701 15.24L13.9794 13.6766C13.8144 13.5943 13.732 13.3474 13.8144 13.1829ZM11.9175 9.80914C11.6701 9.80914 11.5052 9.64457 11.5052 9.39771V6.18857C11.5052 5.94172 11.6701 5.77714 11.9175 5.77714C12.1649 5.77714 12.3299 5.94172 12.3299 6.18857V9.39771C12.2474 9.64457 12.0825 9.80914 11.9175 9.80914ZM9.93814 13.1829C10.0206 13.3474 10.0206 13.5943 9.7732 13.6766L7.05155 15.24C6.8866 15.3223 6.63918 15.3223 6.5567 15.0754C6.47423 14.9109 6.47423 14.664 6.72165 14.5817L9.4433 13.0183C9.60825 12.936 9.85567 12.936 9.93814 13.1829Z",
    fill: fill
  }));
};

var discordIcon = function discordIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "discord icon"), React.createElement("path", {
    d: "M10.1087 10.987C9.51259 10.987 9.04294 11.5214 9.04294 12.1739C9.04294 12.8241 9.52359 13.3608 10.1087 13.3608C10.7038 13.3608 11.1734 12.8241 11.1734 12.1739C11.1855 11.5203 10.7038 10.987 10.1087 10.987ZM13.9232 10.987C13.327 10.987 12.8574 11.5214 12.8574 12.1739C12.8574 12.8241 13.338 13.3608 13.9232 13.3608C14.5182 13.3608 14.9879 12.8241 14.9879 12.1739C14.9868 11.5203 14.5182 10.987 13.9232 10.987Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17.8585 4H6.14149C4.96131 4 4 4.98325 4 6.20162V17.2761C4 18.4945 4.96131 19.75 6.14149 19.75H15.7049L15.1495 17.4989L16.488 18.7713L17.7518 19.9683L20 22V6.20162C20 4.98325 19.0387 4 17.8585 4ZM14.967 15.9775C14.967 15.9775 14.5908 15.5185 14.2784 15.1101C15.6467 14.7141 16.1691 13.8389 16.1691 13.8389C15.7402 14.1269 15.3332 14.3316 14.967 14.4711C14.4445 14.6939 13.9441 14.8435 13.4524 14.9301C12.4493 15.1214 11.5298 15.0685 10.7456 14.9189C10.1505 14.8008 9.63908 14.6297 9.21012 14.4576C8.97035 14.362 8.70747 14.2461 8.4479 14.0965C8.416 14.0729 8.3852 14.0639 8.35441 14.0425C8.33241 14.0313 8.32251 14.0211 8.31151 14.0087C8.12343 13.903 8.01894 13.8287 8.01894 13.8287C8.01894 13.8287 8.52049 14.6837 9.84806 15.0899C9.53459 15.4949 9.14743 15.9775 9.14743 15.9775C6.83875 15.9021 5.96214 14.353 5.96214 14.353C5.96214 10.9116 7.46679 8.12275 7.46679 8.12275C8.97145 6.96738 10.4024 7 10.4024 7L10.5069 7.12825C8.62608 7.68512 7.75826 8.52888 7.75826 8.52888C7.75826 8.52888 7.98924 8.40062 8.3753 8.2195C9.49279 7.71775 10.3804 7.57825 10.7467 7.54562C10.8094 7.5355 10.8622 7.52425 10.9249 7.52425C11.5628 7.43875 12.2832 7.41738 13.0344 7.50288C14.0277 7.621 15.0945 7.92025 16.1801 8.52888C16.1801 8.52888 15.3541 7.72787 13.5778 7.17212L13.7241 7.00113C13.7241 7.00113 15.1561 6.9685 16.6597 8.12387C16.6597 8.12387 18.1643 10.9128 18.1643 14.3541C18.1643 14.3541 17.2767 15.9021 14.967 15.9775Z",
    fill: fill
  }));
};

var downloadCloudIcon = function downloadCloudIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "download cloud icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08162 15.437C8.40688 15.1247 8.93424 15.1247 9.2595 15.437L12.0021 18.0698L14.7447 15.437C15.07 15.1247 15.5973 15.1247 15.9226 15.437C16.2479 15.7492 16.2479 16.2554 15.9226 16.5677L12.591 19.7658C12.2658 20.0781 11.7384 20.0781 11.4132 19.7658L8.08162 16.5677C7.75636 16.2554 7.75636 15.7492 8.08162 15.437Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0021 11.2051C12.4621 11.2051 12.835 11.5631 12.835 12.0047V19.2005C12.835 19.642 12.4621 20 12.0021 20C11.5421 20 11.1692 19.642 11.1692 19.2005V12.0047C11.1692 11.5631 11.5421 11.2051 12.0021 11.2051Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22658 4.00465C10.3597 3.96553 11.4873 4.17369 12.5245 4.61345C13.5617 5.05321 14.4815 5.71311 15.2146 6.54348C15.8063 7.21377 16.264 7.98105 16.5667 8.80652L16.9988 8.80652C18.0608 8.80586 19.0961 9.13001 19.9533 9.73196C20.8106 10.334 21.4458 11.1827 21.7666 12.1548C22.0874 13.1269 22.0773 14.1719 21.7375 15.138C21.3978 16.1042 20.7462 16.9413 19.8772 17.5278C19.501 17.7818 18.9814 17.6949 18.7168 17.3337C18.4522 16.9725 18.5428 16.4738 18.919 16.2198C19.4983 15.8288 19.9327 15.2707 20.1592 14.6266C20.3857 13.9825 20.3925 13.2858 20.1786 12.6378C19.9647 11.9897 19.5413 11.4239 18.9697 11.0225C18.3982 10.6212 17.7082 10.4051 17.0001 10.4056H15.95C15.5697 10.4056 15.2377 10.1584 15.1432 9.80477C14.924 8.98476 14.5139 8.22317 13.9438 7.57733C13.3736 6.93149 12.6582 6.41823 11.8515 6.07619C11.0448 5.73416 10.1678 5.57226 9.28645 5.60268C8.40513 5.63311 7.54248 5.85507 6.76345 6.25184C5.98442 6.64862 5.3093 7.20988 4.78893 7.89337C4.26856 8.57686 3.91649 9.36476 3.75922 10.1978C3.60196 11.0308 3.6436 11.8872 3.88101 12.7025C4.11843 13.5178 4.54542 14.2708 5.12986 14.9048C5.4347 15.2355 5.40256 15.7408 5.05809 16.0334C4.71361 16.326 4.18723 16.2952 3.8824 15.9645C3.13098 15.1494 2.58198 14.1813 2.27674 13.133C1.97149 12.0847 1.91795 10.9836 2.12015 9.91262C2.32234 8.84161 2.77501 7.82859 3.44406 6.94981C4.11311 6.07104 4.98111 5.34942 5.98272 4.83928C6.98434 4.32914 8.09346 4.04377 9.22658 4.00465Z",
    fill: fill
  }));
};

var downloadIcon = function downloadIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "download icon"), React.createElement("path", {
    d: "M19.5 13H16.5938L18.0625 11.5625C19 10.625 18.3125 9 17 9H15V5.5C15 4.6875 14.3125 4 13.5 4H10.5C9.65625 4 9 4.6875 9 5.5V9H7C5.65625 9 4.96875 10.625 5.9375 11.5625L7.375 13H4.5C3.65625 13 3 13.6875 3 14.5V18.5C3 19.3438 3.65625 20 4.5 20H19.5C20.3125 20 21 19.3438 21 18.5V14.5C21 13.6875 20.3125 13 19.5 13ZM7 10.5H10.5V5.5H13.5V10.5H17L12 15.5L7 10.5ZM19.5 18.5H4.5V14.5H8.875L10.9375 16.5625C11.5 17.1562 12.4688 17.1562 13.0312 16.5625L15.0938 14.5H19.5V18.5ZM16.75 16.5C16.75 16.9375 17.0625 17.25 17.5 17.25C17.9062 17.25 18.25 16.9375 18.25 16.5C18.25 16.0938 17.9062 15.75 17.5 15.75C17.0625 15.75 16.75 16.0938 16.75 16.5Z",
    fill: fill
  }));
};

var editIcon = function editIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "edit icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.125 20C11.125 19.5168 11.5168 19.125 12 19.125H21C21.4833 19.125 21.875 19.5168 21.875 20C21.875 20.4833 21.4833 20.875 21 20.875H12C11.5168 20.875 11.125 20.4833 11.125 20Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.75369C17.6695 3.75369 17.3525 3.885 17.1187 4.11873L4.79011 16.4474L4.20259 18.7974L6.55268 18.2099L18.8813 5.88129C18.997 5.76556 19.0888 5.62817 19.1515 5.47696C19.2141 5.32575 19.2463 5.16368 19.2463 5.00001C19.2463 4.83634 19.2141 4.67428 19.1515 4.52307C19.0888 4.37186 18.997 4.23446 18.8813 4.11873C18.7656 4.003 18.6282 3.9112 18.477 3.84856C18.3258 3.78593 18.1637 3.75369 18 3.75369ZM15.8813 2.88129C16.4432 2.31938 17.2053 2.00369 18 2.00369C18.3935 2.00369 18.7831 2.08119 19.1467 2.23177C19.5102 2.38235 19.8405 2.60306 20.1187 2.88129C20.397 3.15953 20.6177 3.48984 20.7683 3.85337C20.9188 4.2169 20.9963 4.60653 20.9963 5.00001C20.9963 5.3935 20.9188 5.78313 20.7683 6.14666C20.6177 6.51019 20.397 6.8405 20.1187 7.11873L7.61874 19.6187C7.5066 19.7309 7.36609 19.8104 7.21224 19.8489L3.21224 20.8489C2.91406 20.9234 2.59863 20.8361 2.3813 20.6187C2.16397 20.4014 2.0766 20.086 2.15114 19.7878L3.15114 15.7878C3.18961 15.6339 3.26916 15.4934 3.3813 15.3813L15.8813 2.88129Z",
    fill: fill
  }));
};

var exclamationIcon = function exclamationIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "exclamation icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11.9942 14.1048C12.8289 14.1048 13.5184 14.7944 13.5184 15.629C13.5184 16.5 12.8289 17.1532 11.9942 17.1532C11.1232 17.1532 10.47 16.5 10.47 15.629C10.47 14.7944 11.1232 14.1048 11.9942 14.1048ZM10.7966 12.9073L10.5426 7.97177C10.5426 7.71774 10.724 7.5 10.9781 7.5H12.974C13.2281 7.5 13.4095 7.71774 13.4095 7.97177L13.1555 12.9073C13.1555 13.125 12.9377 13.3065 12.72 13.3065H11.2321C11.0143 13.3065 10.7966 13.125 10.7966 12.9073Z",
    fill: fill
  }));
};

var expandIcon = function expandIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "expand icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7552 5.24481C21.0816 5.57121 21.0816 6.10043 20.7552 6.42684L6.42684 20.7552C6.10043 21.0816 5.57121 21.0816 5.24481 20.7552C4.9184 20.4288 4.9184 19.8996 5.24481 19.5732L19.5732 5.24481C19.8996 4.9184 20.4288 4.9184 20.7552 5.24481ZM20.7552 13.8418C21.0816 14.1682 21.0816 14.6974 20.7552 15.0239L15.0239 20.7552C14.6974 21.0816 14.1682 21.0816 13.8418 20.7552C13.5154 20.4288 13.5154 19.8996 13.8418 19.5732L19.5732 13.8418C19.8996 13.5154 20.4288 13.5154 20.7552 13.8418Z",
    fill: fill
  }));
};

var externalLinkIcon = function externalLinkIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "external link icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62025 7.32911C5.34832 7.32911 5.08753 7.43714 4.89524 7.62942C4.70296 7.82171 4.59494 8.0825 4.59494 8.35443V18.3797C4.59494 18.6517 4.70296 18.9125 4.89524 19.1048C5.08753 19.297 5.34832 19.4051 5.62025 19.4051H15.6456C15.9175 19.4051 16.1783 19.297 16.3706 19.1048C16.5629 18.9125 16.6709 18.6517 16.6709 18.3797V12.9114C16.6709 12.471 17.0279 12.1139 17.4684 12.1139C17.9088 12.1139 18.2658 12.471 18.2658 12.9114V18.3797C18.2658 19.0747 17.9898 19.7412 17.4984 20.2325C17.007 20.7239 16.3405 21 15.6456 21H5.62025C4.92532 21 4.25885 20.7239 3.76745 20.2325C3.27606 19.7412 3 19.0747 3 18.3797V8.35443C3 7.6595 3.27606 6.99302 3.76745 6.50163C4.25885 6.01024 4.92532 5.73418 5.62025 5.73418H11.0886C11.529 5.73418 11.8861 6.09122 11.8861 6.53165C11.8861 6.97208 11.529 7.32911 11.0886 7.32911H5.62025Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9367 3.79747C13.9367 3.35704 14.2937 3 14.7342 3H20.2025C20.643 3 21 3.35704 21 3.79747V9.26582C21 9.70625 20.643 10.0633 20.2025 10.0633C19.7621 10.0633 19.4051 9.70625 19.4051 9.26582V4.59494H14.7342C14.2937 4.59494 13.9367 4.2379 13.9367 3.79747Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7664 3.23357C21.0779 3.545 21.0779 4.04993 20.7664 4.36136L10.7411 14.3867C10.4297 14.6981 9.92475 14.6981 9.61332 14.3867C9.30189 14.0752 9.30189 13.5703 9.61332 13.2589L19.6386 3.23357C19.9501 2.92214 20.455 2.92214 20.7664 3.23357Z",
    fill: fill
  }));
};

var eyeClosedIcon = function eyeClosedIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "eye closed icon"), React.createElement("path", {
    d: "M16 12C16 9.79 14.21 8 12 8C11.94 8 11.89 8.01 11.83 8.02L15.98 12.17C15.99 12.11 16 12.06 16 12Z",
    fill: fill
  }), React.createElement("path", {
    d: "M12.68 15.93L8.07 11.32C8.03 11.54 8 11.77 8 12C8 14.21 9.79 16 12 16C12.23 16 12.46 15.97 12.68 15.93Z",
    fill: fill
  }), React.createElement("path", {
    d: "M12 18.01C11.35 18.01 10.71 17.9 10.09 17.73C8.79 17.33 7.61 16.65 6.62 15.76C6.55 15.7 6.48 15.65 6.42 15.58C6.35 15.51 6.28 15.43 6.21 15.36C5.36 14.47 4.65 13.38 4.13 12.13C4.12 12.1 4.09 12.05 4.08 12.01C4.1 11.96 4.12 11.92 4.14 11.87C4.58 10.82 5.16 9.89 5.84 9.08L4.4 7.66C4.35 7.72 4.29 7.78 4.23 7.84C3.48 8.72 2.87 9.71 2.41 10.79C2.29 11.07 2.17 11.36 2.06 11.66C2.02 11.77 2 11.89 2 12.01C2 12.13 2.02 12.25 2.06 12.36C2.17 12.65 2.29 12.94 2.41 13.22C2.87 14.3 3.48 15.29 4.23 16.17C6.23 18.58 9.01 20.01 12 20.01C13.36 20.01 14.68 19.71 15.9 19.15L14.35 17.6C13.6 17.87 12.81 18.01 12 18.01Z",
    fill: fill
  }), React.createElement("path", {
    d: "M21.94 11.66C21.8 11.27 21.63 10.89 21.45 10.52C21.45 10.52 21.45 10.52 21.45 10.51C19.55 6.52 15.96 4 12 4C10.79 4 9.61 4.25 8.51 4.69L10.1 6.28C10.72 6.11 11.35 6 12 6C14.89 6 17.56 7.73 19.19 10.52C19.27 10.66 19.35 10.8 19.42 10.95C19.56 11.22 19.69 11.49 19.82 11.78C19.85 11.86 19.89 11.93 19.92 12.01C19.89 12.09 19.85 12.16 19.82 12.24C19.7 12.53 19.56 12.8 19.42 13.07C19.34 13.21 19.27 13.36 19.19 13.5C18.96 13.9 18.7 14.27 18.43 14.62L19.86 16.05C20.47 15.29 21.01 14.44 21.45 13.51C21.45 13.51 21.45 13.51 21.45 13.5C21.63 13.13 21.79 12.75 21.94 12.36C21.98 12.25 22 12.13 22 12.01C22 11.89 21.98 11.77 21.94 11.66Z",
    fill: fill
  }), React.createElement("path", {
    d: "M15.66 13.61L11.99 9.95L10.05 8.01L8.83 6.78L7.05 5C6.56 4.51 5.77 4.51 5.28 5C4.8 5.49 4.8 6.27 5.27 6.76L5.28 6.77L6.7 8.18L17.54 19.02C17.78 19.26 18.1 19.39 18.42 19.39C18.74 19.39 19.06 19.27 19.3 19.02C19.79 18.53 19.79 17.74 19.3 17.25L15.66 13.61Z",
    fill: fill
  }));
};

var eyeIcon = function eyeIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "eye icon"), React.createElement("path", {
    d: "M16 11.995C16 14.2036 14.21 15.9925 12 15.9925C9.79 15.9925 8 14.2036 8 11.995C8 11.5853 8.08 11.2055 8.19 10.8357C8.51 11.5153 9.2 11.995 10 11.995C11.1 11.995 12 11.0956 12 9.99625C12 9.19675 11.52 8.50718 10.84 8.18738C11.21 8.07745 11.59 7.9975 12 7.9975C14.21 7.9975 16 9.78638 16 11.995ZM21.94 11.6552C21.98 11.7651 22 11.8851 22 12.005C22 12.1249 21.98 12.2448 21.94 12.3548C21.8 12.7445 21.63 13.1243 21.45 13.4941C21.45 13.4941 21.45 13.4941 21.45 13.5041C19.56 17.4916 15.96 20.01 12 20.01C9.02 20.01 6.23 18.5809 4.23 16.1724C3.48 15.2929 2.87 14.2936 2.41 13.2142C2.29 12.9344 2.17 12.6446 2.06 12.3548C2.02 12.2448 2 12.1249 2 12.005C2 11.8851 2.02 11.7651 2.06 11.6552C2.17 11.3654 2.29 11.0756 2.41 10.7958C2.87 9.71643 3.48 8.72705 4.23 7.8476C6.23 5.42911 9.02 4 12 4C15.96 4 19.55 6.51843 21.45 10.5059C21.45 10.5059 21.45 10.5059 21.45 10.5159C21.63 10.8757 21.79 11.2555 21.94 11.6552ZM19.92 12.005C19.89 11.925 19.85 11.8551 19.82 11.7751C19.7 11.4853 19.56 11.2155 19.42 10.9457C19.34 10.8057 19.27 10.6558 19.19 10.5159C17.56 7.72767 14.89 5.99875 12 5.99875C11.35 5.99875 10.71 6.10868 10.09 6.27858C8.79 6.67833 7.61 7.3579 6.62 8.24735C6.55 8.30731 6.48 8.35728 6.42 8.42723C6.35 8.4872 6.28 8.56715 6.21 8.6371C5.37 9.52655 4.66 10.6159 4.13 11.8651C4.12 11.9151 4.09 11.955 4.08 12.005C4.09 12.045 4.12 12.0949 4.13 12.1349C4.65 13.3841 5.36 14.4735 6.21 15.3629C6.28 15.4329 6.34 15.5128 6.42 15.5828C6.48 15.6427 6.56 15.7027 6.62 15.7626C7.61 16.6521 8.79 17.3217 10.09 17.7314C10.71 17.9013 11.35 18.0112 12 18.0112C14.89 18.0112 17.56 16.2823 19.19 13.4941C19.27 13.3542 19.35 13.2142 19.42 13.0643C19.56 12.7945 19.69 12.5247 19.82 12.2349C19.86 12.1549 19.89 12.075 19.92 12.005Z",
    fill: fill
  }));
};

var fileIcon = function fileIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "file icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75905 2.77432C5.24506 2.27853 5.90423 2 6.59155 2H12.9014C13.1106 2 13.3112 2.08477 13.4591 2.23566L19.769 8.67244C19.9169 8.82333 20 9.02799 20 9.24138V19.3563C20 20.0575 19.727 20.7299 19.241 21.2257C18.7549 21.7215 18.0958 22 17.4085 22H6.59155C5.90423 22 5.24506 21.7215 4.75905 21.2257C4.27304 20.7299 4 20.0575 4 19.3563V4.64368C4 3.94253 4.27304 3.2701 4.75905 2.77432ZM6.59155 3.6092C6.3226 3.6092 6.06466 3.71819 5.87448 3.91219C5.68431 4.10619 5.57746 4.36932 5.57746 4.64368V19.3563C5.57746 19.6307 5.68431 19.8938 5.87448 20.0878C6.06466 20.2818 6.3226 20.3908 6.59155 20.3908H17.4085C17.6774 20.3908 17.9353 20.2818 18.1255 20.0878C18.3157 19.8938 18.4225 19.6307 18.4225 19.3563V9.57465L12.5747 3.6092H6.59155Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9014 2C13.337 2 13.6901 2.36023 13.6901 2.8046V8.43678H19.2113C19.6469 8.43678 20 8.79701 20 9.24138C20 9.68575 19.6469 10.046 19.2113 10.046H12.9014C12.4658 10.046 12.1127 9.68575 12.1127 9.24138V2.8046C12.1127 2.36023 12.4658 2 12.9014 2Z",
    fill: fill
  }));
};

var githubIcon = function githubIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "github icon"), React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z",
    fill: fill
  }));
};

var gridIcon = function gridIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "grid icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.79747C3 3.35704 3.35704 3 3.79747 3H10.1772C10.6176 3 10.9747 3.35704 10.9747 3.79747V10.1772C10.9747 10.6176 10.6176 10.9747 10.1772 10.9747H3.79747C3.35704 10.9747 3 10.6176 3 10.1772V3.79747ZM4.59494 4.59494V9.37975H9.37975V4.59494H4.59494Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0253 3.79747C13.0253 3.35704 13.3824 3 13.8228 3H20.2025C20.643 3 21 3.35704 21 3.79747V10.1772C21 10.6176 20.643 10.9747 20.2025 10.9747H13.8228C13.3824 10.9747 13.0253 10.6176 13.0253 10.1772V3.79747ZM14.6203 4.59494V9.37975H19.4051V4.59494H14.6203Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0253 13.8228C13.0253 13.3824 13.3824 13.0253 13.8228 13.0253H20.2025C20.643 13.0253 21 13.3824 21 13.8228V20.2025C21 20.643 20.643 21 20.2025 21H13.8228C13.3824 21 13.0253 20.643 13.0253 20.2025V13.8228ZM14.6203 14.6203V19.4051H19.4051V14.6203H14.6203Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13.8228C3 13.3824 3.35704 13.0253 3.79747 13.0253H10.1772C10.6176 13.0253 10.9747 13.3824 10.9747 13.8228V20.2025C10.9747 20.643 10.6176 21 10.1772 21H3.79747C3.35704 21 3 20.643 3 20.2025V13.8228ZM4.59494 14.6203V19.4051H9.37975V14.6203H4.59494Z",
    fill: fill
  }));
};

var helpCircleIcon = function helpCircleIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "help circle icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.6092C7.36589 3.6092 3.6092 7.36589 3.6092 12C3.6092 16.6341 7.36589 20.3908 12 20.3908C16.6341 20.3908 20.3908 16.6341 20.3908 12C20.3908 7.36589 16.6341 3.6092 12 3.6092ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2568 8.23091C11.802 8.1529 11.3342 8.23837 10.9364 8.47218C10.5385 8.70599 10.2363 9.07307 10.0831 9.50838C9.93568 9.92756 9.47632 10.1478 9.05713 10.0004C8.63795 9.85292 8.41767 9.39356 8.56513 8.97438C8.84437 8.18057 9.39554 7.51121 10.121 7.08484C10.8465 6.65847 11.6995 6.50262 12.5288 6.64488C13.3582 6.78714 14.1105 7.21833 14.6524 7.86209C15.1942 8.5057 15.4908 9.32026 15.4897 10.1615C15.4893 11.5079 14.4902 12.4073 13.7521 12.8993C13.3584 13.1618 12.9706 13.3551 12.6842 13.4824C12.5399 13.5465 12.4186 13.5951 12.3314 13.6283C12.2877 13.645 12.2525 13.6578 12.227 13.6669L12.1961 13.6777L12.1865 13.681L12.1832 13.6821L12.1819 13.6825C12.1819 13.6825 12.1809 13.6828 11.9264 12.9195L12.1809 13.6828C11.7593 13.8234 11.3036 13.5955 11.1631 13.174C11.0228 12.7529 11.2499 12.2979 11.6704 12.1567L11.6716 12.1564L11.6879 12.1507C11.7028 12.1454 11.7268 12.1367 11.7585 12.1245C11.8222 12.1003 11.9164 12.0627 12.0307 12.0119C12.2616 11.9092 12.5634 11.7578 12.8594 11.5604C13.5005 11.133 13.8805 10.6533 13.8805 10.1609L13.8805 10.1597C13.8811 9.69826 13.7185 9.25144 13.4213 8.89841C13.1241 8.54539 12.7116 8.30892 12.2568 8.23091Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1954 16.5977C11.1954 16.1533 11.5556 15.7931 12 15.7931H12.0092C12.4536 15.7931 12.8138 16.1533 12.8138 16.5977C12.8138 17.0421 12.4536 17.4023 12.0092 17.4023H12C11.5556 17.4023 11.1954 17.0421 11.1954 16.5977Z",
    fill: fill
  }));
};

var imagineIcon = function imagineIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "imagine icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62025 4.59494C5.05399 4.59494 4.59494 5.05399 4.59494 5.62025V18.3797C4.59494 18.946 5.05399 19.4051 5.62025 19.4051H18.3797C18.946 19.4051 19.4051 18.946 19.4051 18.3797V5.62025C19.4051 5.05399 18.946 4.59494 18.3797 4.59494H5.62025ZM3 5.62025C3 4.17313 4.17313 3 5.62025 3H18.3797C19.8269 3 21 4.17313 21 5.62025V18.3797C21 19.8269 19.8269 21 18.3797 21H5.62025C4.17313 21 3 19.8269 3 18.3797V5.62025Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81013 8.24051C8.49553 8.24051 8.24051 8.49553 8.24051 8.81013C8.24051 9.12472 8.49553 9.37975 8.81013 9.37975C9.12472 9.37975 9.37975 9.12472 9.37975 8.81013C9.37975 8.49553 9.12472 8.24051 8.81013 8.24051ZM6.64557 8.81013C6.64557 7.61467 7.61467 6.64557 8.81013 6.64557C10.0056 6.64557 10.9747 7.61467 10.9747 8.81013C10.9747 10.0056 10.0056 10.9747 8.81013 10.9747C7.61467 10.9747 6.64557 10.0056 6.64557 8.81013Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0817 9.61332C15.3931 9.30189 15.898 9.30189 16.2095 9.61332L20.7664 14.1703C21.0779 14.4817 21.0779 14.9866 20.7664 15.2981C20.455 15.6095 19.9501 15.6095 19.6386 15.2981L15.6456 11.305L6.18415 20.7664C5.87272 21.0779 5.36779 21.0779 5.05636 20.7664C4.74493 20.455 4.74493 19.9501 5.05636 19.6386L15.0817 9.61332Z",
    fill: fill
  }));
};

var infoIcon = function infoIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "info icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12.0058 9.89516C11.1711 9.89516 10.4816 9.20565 10.4816 8.37097C10.4816 7.5 11.1711 6.84677 12.0058 6.84677C12.8768 6.84677 13.53 7.5 13.53 8.37097C13.53 9.20565 12.8768 9.89516 12.0058 9.89516ZM13.2034 11.0927V16.0282C13.2034 16.2823 13.0219 16.5 12.7679 16.5H11.28C11.026 16.5 10.8445 16.2823 10.8445 16.0282V11.0927C10.8445 10.875 11.0623 10.6935 11.28 10.6935H12.7679C12.9857 10.6935 13.2034 10.875 13.2034 11.0927Z",
    fill: fill
  }));
};

var lifeRingIcon = function lifeRingIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "life ring icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66925 6.90669C4.54685 8.30001 3.875 10.0715 3.875 12C3.875 13.9285 4.54685 15.7 5.66925 17.0933L8.27772 14.4848C7.80226 13.774 7.525 12.9194 7.525 12C7.525 11.0806 7.80226 10.226 8.27772 9.51515L5.66925 6.90669ZM6.90669 5.66925L9.51515 8.27772C10.226 7.80226 11.0806 7.525 12 7.525C12.9194 7.525 13.774 7.80226 14.4848 8.27772L17.0933 5.66925C15.7 4.54685 13.9285 3.875 12 3.875C10.0715 3.875 8.30001 4.54685 6.90669 5.66925ZM18.3307 6.90669L15.7223 9.51515C16.1977 10.226 16.475 11.0806 16.475 12C16.475 12.9194 16.1977 13.774 15.7223 14.4848L18.3307 17.0933C19.4532 15.7 20.125 13.9285 20.125 12C20.125 10.0715 19.4532 8.30001 18.3307 6.90669ZM17.0933 18.3307L14.4848 15.7223C13.774 16.1977 12.9194 16.475 12 16.475C11.0806 16.475 10.226 16.1977 9.51515 15.7223L6.90669 18.3307C8.30001 19.4532 10.0715 20.125 12 20.125C13.9285 20.125 15.7 19.4532 17.0933 18.3307ZM2.125 12C2.125 6.54619 6.54619 2.125 12 2.125C17.4538 2.125 21.875 6.54619 21.875 12C21.875 17.4538 17.4538 21.875 12 21.875C6.54619 21.875 2.125 17.4538 2.125 12ZM12 9.275C10.495 9.275 9.275 10.495 9.275 12C9.275 13.505 10.495 14.725 12 14.725C13.505 14.725 14.725 13.505 14.725 12C14.725 10.495 13.505 9.275 12 9.275Z",
    fill: fill
  }));
};

var linkIcon = function linkIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "link icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6376 4.38641C13.5682 3.48675 14.8147 2.98893 16.1085 3.00019C17.4023 3.01144 18.6399 3.53086 19.5547 4.44658C20.4696 5.36229 20.9886 6.60104 20.9998 7.89601C21.0111 9.19098 20.5137 10.4386 19.6149 11.3701L19.6048 11.3803L17.1377 13.8496C16.6375 14.3505 16.0355 14.7378 15.3725 14.9853C14.7096 15.2329 14.0012 15.3348 13.2955 15.2842C12.5897 15.2336 11.9031 15.0317 11.2821 14.6921C10.6612 14.3526 10.1205 13.8833 9.69665 13.3162C9.42459 12.9522 9.49889 12.4363 9.8626 12.164C10.2263 11.8917 10.7417 11.9661 11.0137 12.3301C11.2963 12.7082 11.6568 13.021 12.0707 13.2474C12.4847 13.4738 12.9424 13.6084 13.413 13.6421C13.8835 13.6758 14.3557 13.6079 14.7977 13.4429C15.2396 13.2778 15.641 13.0196 15.9745 12.6857L18.4365 10.2215C19.0327 9.60101 19.3625 8.77137 19.3551 7.91031C19.3476 7.047 19.0016 6.22117 18.3917 5.61069C17.7818 5.00021 16.9567 4.65393 16.0942 4.64643C15.2335 4.63895 14.4043 4.96936 13.7843 5.56667L12.3742 6.96984C12.0521 7.29037 11.5314 7.28885 11.2112 6.96645C10.891 6.64405 10.8925 6.12286 11.2146 5.80234L12.6291 4.39475L12.6376 4.38641Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62745 9.01466C9.2904 8.76713 9.99878 8.66521 10.7045 8.7158C11.4103 8.76639 12.0969 8.96831 12.7179 9.30787C13.3388 9.64743 13.8795 10.1167 14.3034 10.6838C14.5754 11.0478 14.5011 11.5637 14.1374 11.836C13.7737 12.1083 13.2583 12.0339 12.9863 11.6699C12.7037 11.2918 12.3432 10.979 11.9293 10.7526C11.5153 10.5262 11.0576 10.3916 10.587 10.3579C10.1165 10.3242 9.64428 10.3921 9.20232 10.5571C8.76036 10.7222 8.35902 10.9804 8.02553 11.3143L5.56355 13.7785C4.96728 14.399 4.63745 15.2286 4.64493 16.0897C4.65242 16.953 4.99839 17.7788 5.60831 18.3893C6.21823 18.9998 7.0433 19.3461 7.90582 19.3536C8.76609 19.3611 9.59496 19.0309 10.2149 18.4341L11.6159 17.0318C11.937 16.7104 12.4577 16.7104 12.7789 17.0318C13.1001 17.3533 13.1001 17.8745 12.7789 18.196L11.3726 19.6036L11.3624 19.6136C10.4318 20.5133 9.18532 21.0111 7.89153 20.9998C6.59775 20.9886 5.36013 20.4691 4.44526 19.5534C3.53038 18.6377 3.01143 17.399 3.00019 16.104C2.98894 14.809 3.4863 13.5614 4.38515 12.63L4.39516 12.6197L6.86226 10.1504C6.8623 10.1504 6.86223 10.1504 6.86226 10.1504C7.36248 9.64957 7.96455 9.26216 8.62745 9.01466Z",
    fill: fill
  }));
};

var linuxIcon = function linuxIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "linux icon"), React.createElement("path", {
    d: "M11.8574 6.8409C11.8952 6.8409 11.9331 6.87994 11.971 6.87994C12.0089 6.87994 12.0846 6.87994 12.0846 6.8409C12.0846 6.80186 12.0089 6.76283 11.971 6.72379C11.8952 6.68475 11.8195 6.68475 11.7816 6.72379C11.7438 6.72379 11.7438 6.76283 11.7438 6.76283C11.7438 6.80186 11.8195 6.80186 11.8574 6.8409ZM11.0242 6.87994C11.0999 6.87994 11.0999 6.8409 11.1378 6.8409C11.2135 6.80186 11.2893 6.80186 11.2893 6.76283C11.2893 6.76283 11.2893 6.72379 11.2514 6.72379C11.2135 6.68475 11.1378 6.68475 11.062 6.72379C11.0242 6.76283 10.9106 6.80186 10.9484 6.8409C10.9484 6.87994 10.9863 6.91898 11.0242 6.87994ZM19.4319 17.772C19.2804 17.6158 19.2047 17.3425 19.1289 17.0302C19.0911 16.6789 18.9774 16.3666 18.7502 16.1323C18.7123 16.0933 18.6366 16.0542 18.5987 16.0152C18.5608 15.9762 18.4851 15.9762 18.4472 15.9371C18.7881 14.8831 18.6366 13.829 18.2957 12.853C17.8791 11.6818 17.1217 10.6668 16.5536 9.96407C15.8719 9.1052 15.2659 8.32441 15.2659 7.15322C15.3038 5.3574 15.4553 2.03904 12.3876 2C8.52458 2 9.50927 6.06011 9.43352 7.30938C9.39565 8.20729 9.20629 8.91 8.60033 9.80791C7.88074 10.7058 6.85818 12.1112 6.40371 13.5947C6.17647 14.2975 6.06286 15.0002 6.17647 15.6638C5.91136 15.8981 5.722 16.2494 5.53264 16.4837C5.38115 16.6398 5.15391 16.6789 4.8888 16.796C4.62369 16.8741 4.35859 17.0302 4.20709 17.3425C4.09348 17.4987 4.09348 17.6549 4.09348 17.8501C4.09348 18.0062 4.09348 18.1624 4.13135 18.3185C4.16922 18.6308 4.20709 18.9041 4.16922 19.0993C3.97986 19.6849 3.94199 20.0753 4.09348 20.3486C4.20709 20.6219 4.51008 20.778 4.85093 20.8171C5.49477 20.9732 6.36584 20.9342 7.08542 21.3246C7.84287 21.715 8.60033 21.8711 9.20629 21.715C9.62289 21.6369 10.0016 21.3636 10.191 20.9342C10.6454 20.9342 11.1757 20.739 12.0089 20.6609C12.577 20.6219 13.2965 20.8951 14.0919 20.8561C14.1297 20.9342 14.1676 21.0123 14.2055 21.0903C14.5085 21.754 15.0766 22.0663 15.7204 21.9882C16.3642 21.9492 17.0081 21.5588 17.5383 20.8951C18.0685 20.2705 18.9017 19.9972 19.4698 19.6459C19.7728 19.4897 20 19.2555 20 18.9432C20 18.6308 19.8485 18.2795 19.4319 17.772ZM11.971 5.43548C12.3497 4.57661 13.2587 4.57661 13.6374 5.39644C13.9025 5.98203 13.7889 6.60667 13.4859 6.99706C13.4102 6.95802 13.2587 6.87994 12.9936 6.80186C13.0314 6.76283 13.1072 6.68475 13.145 6.60667C13.3344 6.13819 13.145 5.5526 12.8042 5.5526C12.5391 5.51356 12.274 5.98203 12.3497 6.45051C12.1982 6.37243 12.0089 6.29435 11.8574 6.29435C11.8195 6.02107 11.8574 5.70876 11.971 5.43548ZM10.4561 4.96701C10.8348 4.96701 11.2135 5.51356 11.1757 6.29435C11.0242 6.33339 10.9106 6.37243 10.7591 6.45051C10.8348 6.09915 10.6454 5.66972 10.4182 5.70876C10.0774 5.70876 10.0395 6.52859 10.3425 6.80186C10.3803 6.8409 10.4182 6.80186 10.1152 6.99706C9.54714 6.45051 9.73651 4.96701 10.4561 4.96701ZM9.92587 7.34842C10.1531 7.15322 10.4561 6.95802 10.4561 6.91898C10.6454 6.76283 10.9863 6.37243 11.5165 6.37243C11.7816 6.37243 12.1225 6.48955 12.5012 6.72379C12.7284 6.87994 12.9178 6.91898 13.3344 7.07514C13.6753 7.2313 13.8646 7.46554 13.751 7.81689C13.6374 8.09017 13.3344 8.36345 12.8799 8.5196C12.4633 8.63672 12.1225 9.14424 11.4408 9.1052C11.2893 9.06616 11.1757 9.06616 11.062 9.02712C10.7591 8.87096 10.6076 8.59768 10.3046 8.44153C10.0016 8.24633 9.81225 8.01209 9.77438 7.81689C9.69863 7.6217 9.77438 7.46554 9.92587 7.34842ZM10.0395 20.3876C9.96374 21.754 8.37309 21.715 7.19904 21.0903C6.06286 20.4657 4.58582 20.8171 4.28284 20.2315C4.20709 20.0363 4.20709 19.724 4.39646 19.2164V19.1774C4.4722 18.9041 4.43433 18.5528 4.35859 18.2795C4.32071 17.9672 4.32071 17.6939 4.39646 17.4987C4.54795 17.2254 4.73731 17.1083 4.96455 17.0302C5.34327 16.9131 5.41902 16.9131 5.722 16.6398C5.91136 16.4446 6.06286 16.1323 6.25222 15.9371C6.44158 15.7419 6.63095 15.6248 6.93393 15.6638C7.23691 15.7419 7.50202 15.9371 7.76713 16.2885L8.48671 17.6939C8.86543 18.4747 10.1152 19.5678 10.0395 20.3876ZM10.0016 19.3726C9.85012 19.0993 9.62289 18.826 9.43352 18.5918C9.73651 18.5918 10.0016 18.5137 10.0774 18.2795C10.1531 18.0062 10.0774 17.6939 9.81225 17.3035C9.28203 16.5618 8.33522 16.0152 8.33522 16.0152C7.84287 15.7029 7.53989 15.2734 7.42627 14.844C7.27478 14.4146 7.31265 13.9461 7.42627 13.4776C7.61564 12.5797 8.10798 11.7208 8.44883 11.1743C8.52458 11.0962 8.48671 11.2914 8.10798 11.9941C7.805 12.6188 7.19904 14.0632 7.99436 15.1954C8.03223 14.3755 8.2216 13.5557 8.52458 12.814C8.97905 11.7208 9.96374 9.88599 10.0395 8.40249C10.0774 8.44153 10.191 8.5196 10.2667 8.55864C10.4182 8.67576 10.5697 8.83192 10.7212 8.94904C11.2135 9.33944 11.8195 9.3004 12.3497 8.98808C12.577 8.87096 12.7663 8.7148 12.9557 8.63672C13.3344 8.5196 13.5995 8.32441 13.7889 8.05113C14.0919 9.26136 14.7736 10.9791 15.1902 11.7989C15.4174 12.2674 15.8719 13.2044 16.0991 14.3365C16.2127 14.3365 16.3642 14.3365 16.5157 14.3755C17.0081 12.9701 16.0612 11.4866 15.6068 11.0572C15.4553 10.901 15.4174 10.8229 15.531 10.8229C15.9855 11.2524 16.6293 12.1112 16.8566 13.1263C16.9702 13.5557 16.9702 14.0242 16.8566 14.4927C17.5004 14.7659 18.22 15.1954 18.0306 15.859C17.9549 15.859 17.917 15.859 17.8791 15.859C17.9927 15.4686 17.7276 15.1954 17.0081 14.844C16.2506 14.5317 15.6446 14.5317 15.5689 15.3515C15.1144 15.5077 14.8493 15.8981 14.7357 16.4056C14.66 16.835 14.6221 17.3816 14.5842 17.9672C14.5463 18.2795 14.4327 18.6699 14.3191 19.0993C13.1072 19.9972 11.4029 20.3876 10.0016 19.3726ZM19.7349 18.9432C19.697 19.5678 18.1821 19.6849 17.3489 20.739C16.8566 21.3636 16.2506 21.6759 15.6825 21.754C15.1523 21.7931 14.6978 21.5588 14.4327 20.9732C14.2434 20.5438 14.3191 20.0753 14.4706 19.5678C14.6221 19.0212 14.8114 18.4356 14.8493 17.9672C14.8872 17.3816 14.8872 16.8741 15.0008 16.4837C15.1144 16.0542 15.2659 15.781 15.531 15.6638C15.531 15.6248 15.531 15.6248 15.5689 15.6248C15.5689 16.1323 15.834 16.6789 16.2506 16.796C16.7429 16.9131 17.4247 16.4837 17.7276 16.1323C18.0685 16.1323 18.3336 16.0933 18.5608 16.3275C18.9396 16.6789 18.8638 17.5377 19.2425 17.9672C19.6213 18.4356 19.7728 18.7089 19.7349 18.9432ZM10.0774 7.81689C10.1531 7.89497 10.2667 8.01209 10.3803 8.09017C10.6076 8.28537 10.9863 8.5196 11.4029 8.5196C11.8574 8.5196 12.274 8.28537 12.6148 8.09017C12.8042 7.97305 13.0314 7.81689 13.1829 7.69977C13.3344 7.54362 13.4102 7.4265 13.2965 7.4265C13.1829 7.4265 13.1829 7.54362 13.0693 7.6217C12.8799 7.73881 12.6906 7.93401 12.5391 8.01209C12.274 8.16825 11.7816 8.40249 11.4029 8.40249C11.0242 8.40249 10.6833 8.20729 10.4561 8.01209C10.3425 7.93401 10.2289 7.81689 10.1531 7.77785C10.1152 7.69977 10.1152 7.58266 10.0016 7.58266C9.96374 7.58266 9.92587 7.69977 10.0774 7.81689Z",
    fill: fill
  }));
};

var listIcon = function listIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "list icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C7 5.44772 7.44772 5 8 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H8C7.44772 7 7 6.55228 7 6Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12C7 11.4477 7.44772 11 8 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H8C7.44772 13 7 12.5523 7 12Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 5.44772 2.44772 5 3 5H3.01C3.56228 5 4.01 5.44772 4.01 6C4.01 6.55228 3.56228 7 3.01 7H3C2.44772 7 2 6.55228 2 6Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 11.4477 2.44772 11 3 11H3.01C3.56228 11 4.01 11.4477 4.01 12C4.01 12.5523 3.56228 13 3.01 13H3C2.44772 13 2 12.5523 2 12Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C2 17.4477 2.44772 17 3 17H3.01C3.56228 17 4.01 17.4477 4.01 18C4.01 18.5523 3.56228 19 3.01 19H3C2.44772 19 2 18.5523 2 18Z",
    fill: fill
  }));
};

var lockClosedIcon = function lockClosedIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "lock closed icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14768 9.625H4.88574C3.85021 9.625 3.01074 10.4645 3.01074 11.5V19.1245C3.01074 20.16 3.85021 20.9995 4.88574 20.9995H19.1315C20.167 20.9995 21.0065 20.16 21.0065 19.1245V11.5C21.0065 10.4645 20.167 9.625 19.1315 9.625H17.8518C17.7225 7.23291 17.0511 5.60461 15.9844 4.5618C14.793 3.39713 13.2733 3.125 11.9998 3.125C10.7262 3.125 9.20657 3.39713 8.01517 4.5618C6.94843 5.60461 6.27706 7.23291 6.14768 9.625ZM7.9004 9.625H16.0991C15.9733 7.56658 15.4015 6.43932 14.761 5.8132C14.0344 5.10287 13.054 4.875 11.9998 4.875C10.9455 4.875 9.96512 5.10287 9.23849 5.8132C8.598 6.43932 8.02618 7.56658 7.9004 9.625ZM4.88574 11.375C4.81671 11.375 4.76074 11.431 4.76074 11.5V19.1245C4.76074 19.1935 4.81671 19.2495 4.88574 19.2495H19.1315C19.2005 19.2495 19.2565 19.1935 19.2565 19.1245V11.5C19.2565 11.431 19.2005 11.375 19.1315 11.375H4.88574ZM11.9998 13.625C12.483 13.625 12.8748 14.0168 12.8748 14.5V16.5C12.8748 16.9832 12.483 17.375 11.9998 17.375C11.5165 17.375 11.1248 16.9832 11.1248 16.5V14.5C11.1248 14.0168 11.5165 13.625 11.9998 13.625Z",
    fill: fill
  }));
};

var lockOpenIcon = function lockOpenIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "lock open icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88574 9.625H6.14768C6.27706 7.23291 6.94843 5.60461 8.01517 4.5618C9.20657 3.39713 10.7262 3.125 11.9998 3.125C13.2733 3.125 14.793 3.39713 15.9844 4.5618C17.0511 5.60461 17.7225 7.23291 17.8518 9.625H19.1315C20.167 9.625 21.0065 10.4645 21.0065 11.5V19.1245C21.0065 20.16 20.167 20.9995 19.1315 20.9995H4.88574C3.85021 20.9995 3.01074 20.16 3.01074 19.1245V11.5C3.01074 10.4645 3.85021 9.625 4.88574 9.625ZM7.9004 9.625C8.02618 7.56658 8.598 6.43932 9.23849 5.8132C9.96512 5.10287 10.9455 4.875 11.9998 4.875C13.054 4.875 14.0344 5.10286 14.761 5.81317L15.9844 4.5618C17.0511 5.60461 17.7225 7.23291 17.8518 9.625H7.9004ZM4.76074 11.5C4.76074 11.431 4.81671 11.375 4.88574 11.375H19.1315C19.2005 11.375 19.2565 11.431 19.2565 11.5V19.1245C19.2565 19.1935 19.2005 19.2495 19.1315 19.2495H4.88574C4.81671 19.2495 4.76074 19.1935 4.76074 19.1245V11.5ZM12.8748 14.5C12.8748 14.0168 12.483 13.625 11.9998 13.625C11.5165 13.625 11.1248 14.0168 11.1248 14.5V16.5C11.1248 16.9832 11.5165 17.375 11.9998 17.375C12.483 17.375 12.8748 16.9832 12.8748 16.5V14.5Z",
    fill: fill
  }));
};

var logOutIcon = function logOutIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "log out icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.875C6.70163 3.875 6.41548 3.99353 6.2045 4.2045C5.99353 4.41548 5.875 4.70163 5.875 5V19C5.875 19.2984 5.99353 19.5845 6.2045 19.7955C6.41548 20.0065 6.70163 20.125 7 20.125H11C11.4832 20.125 11.875 20.5168 11.875 21C11.875 21.4832 11.4832 21.875 11 21.875H7C6.2375 21.875 5.50623 21.5721 4.96707 21.0329C4.4279 20.4938 4.125 19.7625 4.125 19V5C4.125 4.2375 4.4279 3.50624 4.96707 2.96707C5.50624 2.4279 6.2375 2.125 7 2.125H11C11.4832 2.125 11.875 2.51675 11.875 3C11.875 3.48325 11.4832 3.875 11 3.875H7Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3813 7.38128C16.723 7.03957 17.277 7.03957 17.6187 7.38128L21.6187 11.3813C21.9604 11.723 21.9604 12.277 21.6187 12.6187L17.6187 16.6187C17.277 16.9604 16.723 16.9604 16.3813 16.6187C16.0396 16.277 16.0396 15.723 16.3813 15.3813L19.7626 12L16.3813 8.61872C16.0396 8.27701 16.0396 7.72299 16.3813 7.38128Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.125 12C11.125 11.5168 11.5168 11.125 12 11.125H21C21.4832 11.125 21.875 11.5168 21.875 12C21.875 12.4832 21.4832 12.875 21 12.875H12C11.5168 12.875 11.125 12.4832 11.125 12Z",
    fill: fill
  }));
};

var mailIcon = function mailIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "mail icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64373 5.57746C4.07661 5.57746 3.60925 6.0356 3.60925 6.59155V17.4085C3.60925 17.9644 4.07661 18.4225 4.64373 18.4225H19.3563C19.9234 18.4225 20.3907 17.9644 20.3907 17.4085V6.59155C20.3907 6.0356 19.9234 5.57746 19.3563 5.57746H4.64373ZM2.00007 6.59155C2.00007 5.1644 3.18788 4 4.64373 4H19.3563C20.8121 4 21.9999 5.1644 21.9999 6.59155V17.4085C21.9999 18.8356 20.8121 20 19.3563 20H4.64373C3.18788 20 2.00007 18.8356 2.00007 17.4085V6.59155Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14551 6.13924C2.40034 5.78238 2.90203 5.69559 3.26606 5.94539L12 11.9386L20.7339 5.94539C21.098 5.69559 21.5997 5.78238 21.8545 6.13924C22.1093 6.4961 22.0208 6.9879 21.6567 7.2377L12.4614 13.5476C12.1844 13.7377 11.8156 13.7377 11.5386 13.5476L2.34326 7.2377C1.97922 6.9879 1.89069 6.4961 2.14551 6.13924Z",
    fill: fill
  }));
};

var maximizeIcon = function maximizeIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "maximize icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8 3.9C13.8 3.40294 14.2029 3 14.7 3H20.1C20.5971 3 21 3.40294 21 3.9V9.3C21 9.79706 20.5971 10.2 20.1 10.2C19.6029 10.2 19.2 9.79706 19.2 9.3V4.8H14.7C14.2029 4.8 13.8 4.39706 13.8 3.9Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 13.8C4.39706 13.8 4.8 14.2029 4.8 14.7V19.2H9.3C9.79706 19.2 10.2 19.6029 10.2 20.1C10.2 20.5971 9.79706 21 9.3 21H3.9C3.40294 21 3 20.5971 3 20.1V14.7C3 14.2029 3.40294 13.8 3.9 13.8Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7364 3.2636C21.0879 3.61508 21.0879 4.18492 20.7364 4.5364L14.4364 10.8364C14.0849 11.1879 13.5151 11.1879 13.1636 10.8364C12.8121 10.4849 12.8121 9.91508 13.1636 9.5636L19.4636 3.2636C19.8151 2.91213 20.3849 2.91213 20.7364 3.2636Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8364 13.1636C11.1879 13.5151 11.1879 14.0849 10.8364 14.4364L4.5364 20.7364C4.18492 21.0879 3.61508 21.0879 3.2636 20.7364C2.91213 20.3849 2.91213 19.8151 3.2636 19.4636L9.5636 13.1636C9.91508 12.8121 10.4849 12.8121 10.8364 13.1636Z",
    fill: fill
  }));
};

var messageCircleIcon = function messageCircleIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "message circle icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4783 5.79245C7.98559 5.79245 4.74596 8.59717 4.74596 11.6179C4.74596 12.3661 4.93466 13.085 5.28588 13.7513C5.33403 13.8427 5.38529 13.9331 5.4396 14.0226C5.63061 14.3373 5.66791 14.7367 5.51027 15.0934L4.28263 17.8711L8.26357 16.7754C8.50482 16.709 8.75683 16.7242 8.98307 16.8113C10.0292 17.214 11.2158 17.4434 12.4783 17.4434C16.9711 17.4434 20.2107 14.6387 20.2107 11.6179C20.2107 8.59717 16.9711 5.79245 12.4783 5.79245ZM2.95665 11.6179C2.95665 7.2141 7.44192 4 12.4783 4C17.5147 4 22 7.2141 22 11.6179C22 16.0217 17.5147 19.2358 12.4783 19.2358C11.0778 19.2358 9.7431 18.9948 8.5391 18.5584L3.45767 19.957C2.52235 20.2145 1.70845 19.2679 2.10113 18.3794L3.74363 14.6631C3.73012 14.6382 3.71678 14.6133 3.70359 14.5882C3.22534 13.6809 2.95665 12.6764 2.95665 11.6179Z",
    fill: fill
  }));
};

var minimizeIcon = function minimizeIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "minimize icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.875C4 13.3918 4.39175 13 4.875 13H10.125C10.6082 13 11 13.3918 11 13.875V19.125C11 19.6082 10.6082 20 10.125 20C9.64175 20 9.25 19.6082 9.25 19.125V14.75H4.875C4.39175 14.75 4 14.3582 4 13.875Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.875 4C14.3582 4 14.75 4.39175 14.75 4.875V9.25H19.125C19.6082 9.25 20 9.64175 20 10.125C20 10.6082 19.6082 11 19.125 11H13.875C13.3918 11 13 10.6082 13 10.125V4.875C13 4.39175 13.3918 4 13.875 4Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7397 3.26035C21.0868 3.60748 21.0868 4.1703 20.7397 4.51743L14.5174 10.7397C14.1703 11.0868 13.6075 11.0868 13.2603 10.7397C12.9132 10.3925 12.9132 9.8297 13.2603 9.48257L19.4826 3.26035C19.8297 2.91322 20.3925 2.91322 20.7397 3.26035Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7397 13.2603C11.0868 13.6075 11.0868 14.1703 10.7397 14.5174L4.51743 20.7397C4.1703 21.0868 3.60748 21.0868 3.26035 20.7397C2.91322 20.3925 2.91322 19.8297 3.26035 19.4826L9.48257 13.2603C9.8297 12.9132 10.3925 12.9132 10.7397 13.2603Z",
    fill: fill
  }));
};

var minusIcon = function minusIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "minus icon"), React.createElement("path", {
    d: "M11 11H13V13H11V11Z",
    fill: fill
  }), React.createElement("path", {
    d: "M18 11V13L6 13L6 11L18 11Z",
    fill: fill
  }));
};

var monitorIcon = function monitorIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "monitor icon"), React.createElement("path", {
    d: "M5.8905 10.7906H9.78794C10.064 10.7906 10.2751 10.5877 10.2751 10.3223C10.2751 10.0569 10.064 9.854 9.78794 9.854H5.8905C5.61443 9.854 5.40332 10.0569 5.40332 10.3223C5.40332 10.5877 5.61443 10.7906 5.8905 10.7906Z",
    fill: fill
  }), React.createElement("path", {
    d: "M5.8905 12.5078H10.5999C10.876 12.5078 11.0871 12.3049 11.0871 12.0395C11.0871 11.7741 10.876 11.5712 10.5999 11.5712H5.8905C5.61443 11.5712 5.40332 11.7741 5.40332 12.0395C5.40332 12.3049 5.61443 12.5078 5.8905 12.5078Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17.7457 13.2883H15.9593C15.6833 13.2883 15.4722 13.4913 15.4722 13.7567C15.4722 14.022 15.6833 14.225 15.9593 14.225H17.7457C18.0217 14.225 18.2329 14.022 18.2329 13.7567C18.2329 13.4913 18.0055 13.2883 17.7457 13.2883Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.4973 13.2883H5.8905C5.61443 13.2883 5.40332 13.4913 5.40332 13.7567C5.40332 14.022 5.61443 14.225 5.8905 14.225H14.4973C14.7734 14.225 14.9845 14.022 14.9845 13.7567C14.9845 13.4913 14.7572 13.2883 14.4973 13.2883Z",
    fill: fill
  }), React.createElement("path", {
    d: "M21.0094 4H12.7598C12.2077 4 11.7692 4.42149 11.7692 4.95225V5.40496H3.79573C3.35726 5.40496 3 5.74839 3 6.16988V15.3958V15.5675V17.0817C3 17.3471 3.24359 17.5813 3.51966 17.5813H10.2103V18.0964C10.2103 18.5491 10.0966 18.9862 9.88547 19.3765C9.86923 19.3921 9.86923 19.4233 9.86923 19.4389H8.68376C8.55385 19.4389 8.44017 19.5482 8.44017 19.6731V20.7658C8.44017 20.8907 8.55385 21 8.68376 21H15.1795C15.3094 21 15.4231 20.8907 15.4231 20.7658V19.6731C15.4231 19.5482 15.3094 19.4389 15.1795 19.4389H13.8154C13.8154 19.4233 13.7991 19.3921 13.7991 19.3765C13.588 18.9862 13.4744 18.5335 13.4744 18.0964V17.5813H20.0188C20.3111 17.5813 20.5385 17.3471 20.5385 17.0817V15.5675V15.3958V10.5565H21.0094C21.5615 10.5565 22 10.135 22 9.60422V4.95225C22 4.42149 21.5615 4 21.0094 4ZM4.46154 14.9275V6.80992H11.7692V9.60422C11.7692 10.1038 12.1752 10.5253 12.6949 10.5565L12.5812 12.1331C12.5812 12.2268 12.6299 12.3205 12.7274 12.3673C12.7598 12.3829 12.7923 12.3829 12.8248 12.3829C12.8897 12.3829 12.9547 12.3673 13.0034 12.3205L14.8547 10.5565H19.0769V14.9275H4.46154ZM13.4581 6.57576C13.4581 6.35721 13.6368 6.18549 13.8641 6.18549H17.7615C17.9889 6.18549 18.1675 6.35721 18.1675 6.57576C18.1675 6.79431 17.9889 6.96602 17.7615 6.96602H13.8641C13.6368 6.96602 13.4581 6.79431 13.4581 6.57576ZM18.9795 8.29293C18.9795 8.51148 18.8009 8.6832 18.5735 8.6832H13.8641C13.6368 8.6832 13.4581 8.51148 13.4581 8.29293C13.4581 8.07438 13.6368 7.90266 13.8641 7.90266H18.5735C18.8009 7.90266 18.9795 8.07438 18.9795 8.29293Z",
    fill: fill
  }));
};

var moreIcon = function moreIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "more icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12Z",
    fill: fill
  }));
};

var moreVertIcon = function moreVertIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "more vert icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C10.8954 21 10 20.1046 10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21Z",
    fill: fill
  }));
};

var networkIcon = function networkIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "network icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45455 4.63636C5.00268 4.63636 4.63636 5.00268 4.63636 5.45455V8.72727C4.63636 9.17914 5.00268 9.54545 5.45455 9.54545H18.5455C18.9973 9.54545 19.3636 9.17914 19.3636 8.72727V5.45455C19.3636 5.00268 18.9973 4.63636 18.5455 4.63636H5.45455ZM3 5.45455C3 4.09894 4.09894 3 5.45455 3H18.5455C19.9011 3 21 4.09894 21 5.45455V8.72727C21 10.0829 19.9011 11.1818 18.5455 11.1818H5.45455C4.09894 11.1818 3 10.0829 3 8.72727V5.45455Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1818 17.7273V10.3636H12.8182V17.7273H11.1818Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27273 7.09091C6.27273 6.63904 6.63904 6.27273 7.09091 6.27273H7.09909C7.55096 6.27273 7.91727 6.63904 7.91727 7.09091C7.91727 7.54278 7.55096 7.90909 7.09909 7.90909H7.09091C6.63904 7.90909 6.27273 7.54278 6.27273 7.09091Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54545 7.09091C9.54545 6.63904 9.91177 6.27273 10.3636 6.27273H10.3718C10.8237 6.27273 11.19 6.63904 11.19 7.09091C11.19 7.54278 10.8237 7.90909 10.3718 7.90909H10.3636C9.91177 7.90909 9.54545 7.54278 9.54545 7.09091Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.3636C12.4519 19.3636 12.8182 18.9973 12.8182 18.5455C12.8182 18.0936 12.4519 17.7273 12 17.7273C11.5481 17.7273 11.1818 18.0936 11.1818 18.5455C11.1818 18.9973 11.5481 19.3636 12 19.3636ZM12 21C13.3556 21 14.4545 19.9011 14.4545 18.5455C14.4545 17.1898 13.3556 16.0909 12 16.0909C10.6444 16.0909 9.54545 17.1898 9.54545 18.5455C9.54545 19.9011 10.6444 21 12 21Z",
    fill: fill
  }));
};

var offIcon = function offIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "off icon"), React.createElement("path", {
    d: "M11.6154 12H12.3846C12.6923 12 13 11.5833 13 11.1667V10.5417V5.54167V5.02083V3.45833V2.9375V2.83333C12.9231 2.41667 12.6923 2 12.3846 2H11.6154C11.2308 2 11 2.41667 11 2.83333V2.9375V3.45833V5.02083V5.54167V10.4375V11.0625C11 11.5833 11.2308 12 11.6154 12Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9 3.51212C5.50442 4.74762 3 8.08134 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 8.08134 18.4956 4.74762 15 3.51212V5.67363C17.3649 6.79709 19 9.2076 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 9.2076 6.63505 6.79709 9 5.67363V3.51212Z",
    fill: fill
  }));
};

var paperclipIcon = function paperclipIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "paperclip icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2562 3.68063C14.5959 3.68063 13.9626 3.94643 13.4956 4.41955L5.87402 12.142C5.09585 12.9305 4.65867 13.9999 4.65867 15.115C4.65867 16.2301 5.09585 17.2995 5.87402 18.0879C6.6522 18.8764 7.70763 19.3194 8.80813 19.3194C9.90863 19.3194 10.9641 18.8764 11.7422 18.0879L18.5842 11.1554C18.9081 10.8272 19.4332 10.8272 19.7571 11.1554C20.081 11.4835 20.081 12.0156 19.7571 12.3438L12.9151 19.2763C11.8259 20.38 10.3485 21 8.80813 21C7.26772 21 5.7904 20.38 4.70116 19.2763C3.61193 18.1727 3 16.6758 3 15.115C3 13.5542 3.61193 12.0573 4.70116 10.9537L12.3228 3.23116C13.1008 2.44286 14.156 2 15.2562 2C16.3565 2 17.4117 2.44286 18.1897 3.23116C18.9677 4.01946 19.4048 5.08862 19.4048 6.20345C19.4048 7.31827 18.9677 8.38743 18.1897 9.17573L10.5598 16.8982C10.093 17.3712 9.45994 17.6369 8.79984 17.6369C8.13973 17.6369 7.50666 17.3712 7.03989 16.8982C6.57313 16.4253 6.3109 15.7838 6.3109 15.115C6.3109 14.4461 6.57313 13.8047 7.03989 13.3318L12.9116 7.38232C13.2355 7.05416 13.7606 7.05416 14.0845 7.38232C14.4083 7.71048 14.4083 8.24254 14.0845 8.57071L8.21275 14.5201C8.05705 14.6779 7.96958 14.8919 7.96958 15.115C7.96958 15.3381 8.05705 15.5521 8.21275 15.7098C8.36846 15.8676 8.57964 15.9562 8.79984 15.9562C9.02003 15.9562 9.23121 15.8676 9.38692 15.7098L17.0168 7.98735C17.4836 7.51426 17.7461 6.87239 17.7461 6.20345C17.7461 5.53435 17.4838 4.89267 17.0168 4.41955C16.5499 3.94643 15.9166 3.68063 15.2562 3.68063Z",
    fill: fill
  }));
};

var pinIcon = function pinIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "pin icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.875C10.3903 3.875 8.83691 4.54728 7.68443 5.75962C6.53052 6.97347 5.875 8.62885 5.875 10.3636C5.875 12.8919 7.43803 15.3428 9.15019 17.244C9.99091 18.1775 10.8343 18.9417 11.4681 19.4727C11.6696 19.6414 11.8492 19.7861 12 19.9045C12.1508 19.7861 12.3304 19.6414 12.5319 19.4727C13.1657 18.9417 14.0091 18.1775 14.8498 17.244C16.562 15.3428 18.125 12.8919 18.125 10.3636C18.125 8.62885 17.4695 6.97347 16.3156 5.75962C15.1631 4.54728 13.6097 3.875 12 3.875ZM12 21C11.4976 21.7164 11.4971 21.7161 11.4971 21.7161L11.4948 21.7144L11.4894 21.7106L11.4712 21.6977C11.4559 21.6867 11.434 21.671 11.4061 21.6507C11.3504 21.6101 11.2705 21.551 11.1699 21.4746C10.9687 21.3218 10.6843 21.099 10.3444 20.8142C9.66574 20.2458 8.75909 19.4248 7.84981 18.4151C6.06197 16.4299 4.125 13.5626 4.125 10.3636C4.125 8.19251 4.94447 6.10195 6.41607 4.5539C7.88911 3.00434 9.89671 2.125 12 2.125C14.1033 2.125 16.1109 3.00434 17.5839 4.5539C19.0555 6.10195 19.875 8.19251 19.875 10.3636C19.875 13.5626 17.938 16.4299 16.1502 18.4151C15.2409 19.4248 14.3343 20.2458 13.6556 20.8142C13.3157 21.099 13.0313 21.3218 12.8301 21.4746C12.7295 21.551 12.6496 21.6101 12.5939 21.6507C12.566 21.671 12.5441 21.6867 12.5288 21.6977L12.5106 21.7106L12.5052 21.7144L12.5035 21.7156C12.5035 21.7156 12.5024 21.7164 12 21ZM12 21L12.5024 21.7164C12.2008 21.9279 11.7987 21.9275 11.4971 21.7161L12 21Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.875C11.1025 8.875 10.375 9.60254 10.375 10.5C10.375 11.3975 11.1025 12.125 12 12.125C12.8975 12.125 13.625 11.3975 13.625 10.5C13.625 9.60254 12.8975 8.875 12 8.875ZM8.625 10.5C8.625 8.63604 10.136 7.125 12 7.125C13.864 7.125 15.375 8.63604 15.375 10.5C15.375 12.364 13.864 13.875 12 13.875C10.136 13.875 8.625 12.364 8.625 10.5Z",
    fill: fill
  }));
};

var plugIcon = function plugIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "plug icon"), React.createElement("path", {
    d: "M5.086 19.6986C0.971332 15.4551 0.971332 8.54493 5.086 4.30145L5.3783 4H18.6217L18.914 4.30145C23.0287 8.54493 23.0287 15.4551 18.914 19.6986L18.6217 20H5.3783L5.086 19.6986ZM6.23271 6.08696C3.28724 9.42609 3.28724 14.5739 6.23271 17.913H17.7673C20.7128 14.5739 20.7128 9.42609 17.7673 6.08696H6.23271Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9 8H7V13H9V8Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14 14H10V16H14V14Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17 8H15V13H17V8Z",
    fill: fill
  }));
};

var plusIcon = function plusIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "plus icon"), React.createElement("path", {
    d: "M11 6H13V18H11V6Z",
    fill: fill
  }), React.createElement("path", {
    d: "M18 11V13L6 13L6 11L18 11Z",
    fill: fill
  }));
};

var pulseIcon = function pulseIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "pulse icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24138 3C9.5877 3 9.89517 3.21965 10.0047 3.54529L14.7586 17.6807L16.7539 11.7478C16.8635 11.4222 17.1709 11.2025 17.5172 11.2025H21.1954C21.6398 11.2025 22 11.5596 22 12C22 12.4404 21.6398 12.7975 21.1954 12.7975H18.0972L15.5219 20.4547C15.4124 20.7804 15.1049 21 14.7586 21C14.4123 21 14.1048 20.7804 13.9953 20.4547L9.24138 6.31928L7.24607 12.2522C7.13655 12.5778 6.82908 12.7975 6.48276 12.7975H2.8046C2.36023 12.7975 2 12.4404 2 12C2 11.5596 2.36023 11.2025 2.8046 11.2025H5.90284L8.47807 3.54529C8.58759 3.21965 8.89506 3 9.24138 3Z",
    fill: fill
  }));
};

var redditIcon = function redditIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "reddit icon"), React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fill: fill,
    d: "M19.522,7.196c-1.062-1.064-2.775-1.077-3.896-0.069c-1.305-0.627-2.815-1.026-4.437-1.121   c0.6-1.862,1.834-4.465,3.077-4.715c0.418-0.083,0.874,0.137,1.353,0.657c-0.035,0.138-0.061,0.28-0.061,0.427   c0,0.921,0.748,1.669,1.669,1.669c0.921,0,1.669-0.746,1.669-1.669c0-0.921-0.748-1.667-1.669-1.667   c-0.3,0-0.581,0.086-0.825,0.226c-0.758-0.753-1.558-1.055-2.386-0.89c-2.417,0.487-3.88,5.023-4.157,5.955   C8.152,6.076,6.563,6.485,5.202,7.146c-1.119-1.031-2.849-1.022-3.92,0.049C0.227,8.25,0.207,9.942,1.189,11.064   c-0.319,0.731-0.498,1.512-0.498,2.324c0,4.089,4.371,7.417,9.744,7.417s9.746-3.327,9.746-7.417c0-0.831-0.189-1.628-0.522-2.375   C20.597,9.893,20.561,8.235,19.522,7.196z M1.731,7.645C2.506,6.869,3.73,6.818,4.598,7.467c-1.344,0.769-2.422,1.79-3.101,2.977   C0.904,9.58,0.977,8.398,1.731,7.645z M10.435,19.531c-4.673,0-8.473-2.755-8.473-6.143c0-3.385,3.8-6.142,8.473-6.142   c4.674,0,8.474,2.757,8.474,6.142C18.909,16.778,15.109,19.531,10.435,19.531z M16.234,7.446c0.868-0.627,2.071-0.567,2.838,0.2   c0.742,0.74,0.825,1.891,0.27,2.749C18.656,9.217,17.578,8.205,16.234,7.446z M6.886,13.284c-0.877,0-1.589-0.711-1.589-1.589   c0-0.877,0.711-1.589,1.589-1.589c0.878,0,1.589,0.711,1.589,1.589S7.763,13.284,6.886,13.284z M15.56,11.694   c0,0.877-0.711,1.589-1.589,1.589c-0.877,0-1.589-0.711-1.589-1.589c0-0.878,0.711-1.589,1.589-1.589   C14.848,10.105,15.56,10.816,15.56,11.694z M14.222,15.912c0.217,0.275,0.167,0.676-0.112,0.893   c-1.326,1.028-2.614,1.375-3.742,1.375c-2.255,0-3.874-1.378-3.898-1.4c-0.264-0.228-0.291-0.632-0.061-0.896   c0.231-0.264,0.63-0.291,0.894-0.063c0.118,0.101,2.884,2.42,6.027-0.02C13.606,15.584,14.005,15.637,14.222,15.912z"
  })));
};

var reloadIcon = function reloadIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "reload icon"), React.createElement("path", {
    d: "M21.7951 11.1753C21.6971 11.0809 21.501 10.9865 21.3049 10.9865L20.3246 11.0809C20.1285 7.30441 16.5992 4.09441 12.5798 4C12.1876 4 11.8935 4.28324 11.8935 4.66088C11.8935 5.22735 11.7955 6.07706 12.5798 6.07706C15.2267 6.07706 17.6776 8.24853 18.0697 10.7976C18.0697 10.8921 18.0697 10.9865 18.0697 11.1753L16.9914 11.2697C16.4031 11.2697 16.109 12.025 16.5992 12.3082L18.854 15.235C19.1481 15.4238 19.5403 15.4238 19.8344 15.235L21.8931 12.1194C22.0892 11.8362 21.9912 11.4585 21.7951 11.1753Z",
    fill: fill
  }), React.createElement("path", {
    d: "M11.9636 18.5838C11.9636 18.3006 11.6695 18.0174 11.2773 18.0174C10.6891 18.0174 10.199 17.9229 9.61075 17.7341C7.45397 17.0732 5.8854 15.0906 5.78737 12.9191H6.86576C7.45397 12.9191 7.74807 12.1638 7.2579 11.8806L5.10112 8.85942C4.80701 8.6706 4.41487 8.6706 4.12077 8.95383L2.16006 11.975C1.76792 12.3527 2.16006 13.1079 2.65023 13.0135L3.63059 12.9191C3.82666 15.7515 5.68933 18.395 8.43432 19.4335C9.02253 19.6224 9.51271 19.8112 10.1009 19.9056C10.4931 20 10.8852 20 11.2773 20C11.6695 20 11.9636 19.7168 11.9636 19.3391V18.5838Z",
    fill: fill
  }));
};

var searchIcon = function searchIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "search icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.875C7.61726 4.875 4.875 7.61726 4.875 11C4.875 14.3827 7.61726 17.125 11 17.125C14.3827 17.125 17.125 14.3827 17.125 11C17.125 7.61726 14.3827 4.875 11 4.875ZM3.125 11C3.125 6.65076 6.65076 3.125 11 3.125C15.3492 3.125 18.875 6.65076 18.875 11C18.875 15.3492 15.3492 18.875 11 18.875C6.65076 18.875 3.125 15.3492 3.125 11Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3813 15.3813C15.723 15.0396 16.277 15.0396 16.6187 15.3813L20.6187 19.3813C20.9604 19.723 20.9604 20.277 20.6187 20.6187C20.277 20.9604 19.723 20.9604 19.3813 20.6187L15.3813 16.6187C15.0396 16.277 15.0396 15.723 15.3813 15.3813Z",
    fill: fill
  }));
};

var serverIcon = function serverIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "server icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45455 19.3636C5.00268 19.3636 4.63636 18.9973 4.63636 18.5455V15.2727C4.63636 14.8209 5.00268 14.4545 5.45455 14.4545H18.5455C18.9973 14.4545 19.3636 14.8209 19.3636 15.2727V18.5455C19.3636 18.9973 18.9973 19.3636 18.5455 19.3636H5.45455ZM3 18.5455C3 19.9011 4.09894 21 5.45455 21H18.5455C19.9011 21 21 19.9011 21 18.5455V15.2727C21 13.9171 19.9011 12.8182 18.5455 12.8182H5.45455C4.09894 12.8182 3 13.9171 3 15.2727V18.5455ZM6.27273 16.9091C6.27273 17.361 6.63904 17.7273 7.09091 17.7273H7.09909C7.55096 17.7273 7.91727 17.361 7.91727 16.9091C7.91727 16.4572 7.55096 16.0909 7.09909 16.0909H7.09091C6.63904 16.0909 6.27273 16.4572 6.27273 16.9091ZM5.45455 9.54545C5.00268 9.54545 4.63636 9.17914 4.63636 8.72727V5.45455C4.63636 5.00268 5.00268 4.63636 5.45455 4.63636H18.5455C18.9973 4.63636 19.3636 5.00268 19.3636 5.45455V8.72727C19.3636 9.17914 18.9973 9.54545 18.5455 9.54545H5.45455ZM3 8.72727C3 10.0829 4.09894 11.1818 5.45455 11.1818H18.5455C19.9011 11.1818 21 10.0829 21 8.72727V5.45455C21 4.09894 19.9011 3 18.5455 3H5.45455C4.09894 3 3 4.09894 3 5.45455V8.72727ZM6.27273 7.09091C6.27273 7.54278 6.63904 7.90909 7.09091 7.90909H7.09909C7.55096 7.90909 7.91727 7.54278 7.91727 7.09091C7.91727 6.63904 7.55096 6.27273 7.09909 6.27273H7.09091C6.63904 6.27273 6.27273 6.63904 6.27273 7.09091Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.5 7.09091C9.5 7.54278 9.86631 7.90909 10.3182 7.90909H10.3264C10.7782 7.90909 11.1445 7.54278 11.1445 7.09091C11.1445 6.63904 10.7782 6.27272 10.3264 6.27272H10.3182C9.86631 6.27272 9.5 6.63904 9.5 7.09091Z",
    fill: fill
  }));
};

var starIcon = function starIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "star icon"), React.createElement("path", {
    d: "M11.2039 2.5507C11.4545 1.81643 12.5455 1.81643 12.7961 2.5507L14.819 8.4784C14.9311 8.80677 15.2525 9.0291 15.6151 9.0291H22.1613C22.9722 9.0291 23.3094 10.0171 22.6533 10.4709L17.3573 14.1344C17.0639 14.3373 16.9412 14.6971 17.0532 15.0254L19.0761 20.9531C19.3267 21.6874 18.4441 22.298 17.788 21.8442L12.492 18.1807C12.1986 17.9777 11.8014 17.9777 11.508 18.1807L6.21197 21.8442C5.55595 22.298 4.67328 21.6874 4.92386 20.9531L6.94675 15.0254C7.05882 14.6971 6.93605 14.3373 6.64267 14.1344L1.34666 10.4709C0.690636 10.0171 1.02778 9.0291 1.83867 9.0291H8.38491C8.74755 9.0291 9.06894 8.80677 9.181 8.4784L11.2039 2.5507Z",
    fill: fill
  }));
};

var starsIcon = function starsIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "stars icon"), React.createElement("path", {
    d: "M7.81001 2.57768C7.87031 2.39433 8.12969 2.39433 8.18999 2.57768L9.45337 6.41913C9.47321 6.47946 9.52054 6.52679 9.58087 6.54663L13.4223 7.81001C13.6057 7.87031 13.6057 8.12969 13.4223 8.18999L9.58087 9.45337C9.52054 9.47321 9.47321 9.52054 9.45337 9.58087L8.18999 13.4223C8.12969 13.6057 7.87031 13.6057 7.81001 13.4223L6.54663 9.58087C6.52679 9.52054 6.47946 9.47321 6.41913 9.45337L2.57768 8.18999C2.39433 8.12969 2.39433 7.87031 2.57768 7.81001L6.41913 6.54663C6.47946 6.52679 6.52679 6.47946 6.54663 6.41913L7.81001 2.57768Z",
    fill: fill
  }), React.createElement("path", {
    d: "M5.15305 17.4215C5.06604 17.2492 5.24944 17.0658 5.42173 17.1528L6.91007 17.9044C6.96676 17.9331 7.03369 17.9331 7.09039 17.9044L8.57872 17.1528C8.75101 17.0658 8.93442 17.2492 8.84741 17.4215L8.09576 18.9098C8.06713 18.9665 8.06713 19.0334 8.09576 19.0901L8.84741 20.5785C8.93442 20.7508 8.75101 20.9342 8.57872 20.8472L7.09039 20.0955C7.03369 20.0669 6.96676 20.0669 6.91007 20.0955L5.42173 20.8472C5.24944 20.9342 5.06604 20.7508 5.15305 20.5785L5.90469 19.0901C5.93333 19.0334 5.93333 18.9665 5.90469 18.9098L5.15305 17.4215Z",
    fill: fill
  }), React.createElement("path", {
    d: "M19.9926 11.8097C20.1649 11.7227 20.3483 11.9061 20.2613 12.0783L18.7954 14.9809C18.7668 15.0376 18.7668 15.1045 18.7954 15.1612L20.2613 18.0638C20.3483 18.2361 20.1649 18.4195 19.9926 18.3324L17.09 16.8666C17.0334 16.838 16.9664 16.838 16.9097 16.8666L14.0072 18.3324C13.8349 18.4195 13.6515 18.2361 13.7385 18.0638L15.2044 15.1612C15.233 15.1045 15.233 15.0376 15.2044 14.9809L13.7385 12.0783C13.6515 11.9061 13.8349 11.7227 14.0072 11.8097L16.9097 13.2755C16.9664 13.3042 17.0334 13.3042 17.09 13.2755L19.9926 11.8097Z",
    fill: fill
  }));
};

var telegramIcon = function telegramIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "telegram icon"), React.createElement("path", {
    fill: fill,
    d: "M 20.572266 3.0117188 C 20.239891 2.9764687 19.878625 3.028375 19.515625 3.171875 C 19.065625 3.348875 12.014406 6.3150313 5.4414062 9.0820312 L 3.2695312 9.9960938 C 2.4285313 10.337094 2.0039062 10.891672 2.0039062 11.638672 C 2.0039062 12.161672 2.22525 12.871063 3.28125 13.289062 L 6.9472656 14.757812 C 7.2642656 15.708813 8.0005469 17.916906 8.1855469 18.503906 C 8.2955469 18.851906 8.5733906 19.728594 9.2753906 19.933594 C 9.4193906 19.982594 9.5696563 20.007813 9.7226562 20.007812 C 10.165656 20.007812 10.484625 19.801641 10.640625 19.681641 L 12.970703 17.710938 L 15.800781 20.328125 C 15.909781 20.439125 16.486719 21 17.261719 21 C 18.228719 21 18.962234 20.195016 19.115234 19.416016 C 19.198234 18.989016 21.927734 5.2870625 21.927734 5.2890625 C 22.172734 4.1900625 21.732219 3.6199531 21.449219 3.3769531 C 21.206719 3.1694531 20.904641 3.0469688 20.572266 3.0117188 z M 19.910156 5.171875 C 19.533156 7.061875 17.478016 17.378234 17.166016 18.865234 L 13.029297 15.039062 L 10.222656 17.416016 L 11 14.375 C 11 14.375 16.362547 8.9468594 16.685547 8.6308594 C 16.945547 8.3778594 17 8.2891719 17 8.2011719 C 17 8.0841719 16.939781 8 16.800781 8 C 16.675781 8 16.506016 8.1197812 16.416016 8.1757812 C 15.272669 8.8885973 10.404094 11.662239 8.0078125 13.025391 L 4.53125 11.636719 L 6.21875 10.927734 C 10.51775 9.1177344 18.174156 5.893875 19.910156 5.171875 z"
  }));
};

var testnetIcon = function testnetIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "testnet icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97641 3.0467C5.13171 3.01598 5.29167 3 5.45455 3H5.86364C6.31551 3 6.68182 3.36631 6.68182 3.81818C6.68182 4.27005 6.31551 4.63636 5.86364 4.63636H5.45455C5.39886 4.63636 5.34525 4.64181 5.29397 4.65195C4.85069 4.73965 4.42026 4.45139 4.33256 4.00811C4.24487 3.56483 4.53313 3.1344 4.97641 3.0467ZM7.5 3.81818C7.5 3.36631 7.86631 3 8.31818 3H9.13636C9.58823 3 9.95455 3.36631 9.95455 3.81818C9.95455 4.27005 9.58823 4.63636 9.13636 4.63636H8.31818C7.86631 4.63636 7.5 4.27005 7.5 3.81818ZM10.7727 3.81818C10.7727 3.36631 11.139 3 11.5909 3H12.4091C12.861 3 13.2273 3.36631 13.2273 3.81818C13.2273 4.27005 12.861 4.63636 12.4091 4.63636H11.5909C11.139 4.63636 10.7727 4.27005 10.7727 3.81818ZM14.0455 3.81818C14.0455 3.36631 14.4118 3 14.8636 3H15.6818C16.1337 3 16.5 3.36631 16.5 3.81818C16.5 4.27005 16.1337 4.63636 15.6818 4.63636H14.8636C14.4118 4.63636 14.0455 4.27005 14.0455 3.81818ZM17.3182 3.81818C17.3182 3.36631 17.6845 3 18.1364 3H18.5455C18.7083 3 18.8683 3.01598 19.0236 3.0467C19.4669 3.1344 19.7551 3.56483 19.6674 4.00811C19.5797 4.45139 19.1493 4.73965 18.706 4.65195C18.6548 4.64181 18.6011 4.63636 18.5455 4.63636H18.1364C17.6845 4.63636 17.3182 4.27005 17.3182 3.81818ZM19.9919 4.33256C20.4352 4.24487 20.8656 4.53313 20.9533 4.97641C20.984 5.13171 21 5.29167 21 5.45455V5.86364C21 6.31551 20.6337 6.68182 20.1818 6.68182C19.7299 6.68182 19.3636 6.31551 19.3636 5.86364V5.45455C19.3636 5.39886 19.3582 5.34525 19.348 5.29397C19.2604 4.85069 19.5486 4.42026 19.9919 4.33256ZM4.00811 4.33256C4.45139 4.42026 4.73965 4.85069 4.65195 5.29397C4.64181 5.34525 4.63636 5.39886 4.63636 5.45455V5.86364C4.63636 6.31551 4.27005 6.68182 3.81818 6.68182C3.36631 6.68182 3 6.31551 3 5.86364V5.45455C3 5.29167 3.01598 5.13171 3.0467 4.97641C3.1344 4.53313 3.56483 4.24487 4.00811 4.33256ZM3.81818 7.5C4.27005 7.5 4.63636 7.86631 4.63636 8.31818V8.72727C4.63636 8.78296 4.64181 8.83657 4.65195 8.88785C4.73965 9.33112 4.45139 9.76156 4.00811 9.84926C3.56483 9.93695 3.1344 9.64869 3.0467 9.20541C3.01598 9.05011 3 8.89015 3 8.72727V8.31818C3 7.86631 3.36631 7.5 3.81818 7.5ZM20.1818 7.5C20.6337 7.5 21 7.86631 21 8.31818V8.72727C21 8.89015 20.984 9.05011 20.9533 9.20541C20.8656 9.64869 20.4352 9.93695 19.9919 9.84925C19.5486 9.76156 19.2604 9.33112 19.348 8.88785C19.3582 8.83657 19.3636 8.78296 19.3636 8.72727V8.31818C19.3636 7.86631 19.7299 7.5 20.1818 7.5ZM4.33256 10.1737C4.42026 9.73043 4.85069 9.44217 5.29397 9.52986C5.34525 9.54001 5.39886 9.54545 5.45455 9.54545H5.86364C6.31551 9.54545 6.68182 9.91177 6.68182 10.3636C6.68182 10.8155 6.31551 11.1818 5.86364 11.1818H5.45455C5.29167 11.1818 5.13171 11.1658 4.97641 11.1351C4.53313 11.0474 4.24487 10.617 4.33256 10.1737ZM19.6674 10.1737C19.7551 10.617 19.4669 11.0474 19.0236 11.1351C18.8683 11.1658 18.7083 11.1818 18.5455 11.1818H18.1364C17.6845 11.1818 17.3182 10.8155 17.3182 10.3636C17.3182 9.91177 17.6845 9.54545 18.1364 9.54545H18.5455C18.6011 9.54545 18.6548 9.54001 18.706 9.52986C19.1493 9.44217 19.5797 9.73043 19.6674 10.1737ZM7.5 10.3636C7.5 9.91177 7.86631 9.54545 8.31818 9.54545H9.13636C9.58823 9.54545 9.95455 9.91177 9.95455 10.3636C9.95455 10.8155 9.58823 11.1818 9.13636 11.1818H8.31818C7.86631 11.1818 7.5 10.8155 7.5 10.3636ZM10.7727 10.3636C10.7727 9.91177 11.139 9.54545 11.5909 9.54545H12.4091C12.861 9.54545 13.2273 9.91177 13.2273 10.3636C13.2273 10.8155 12.861 11.1818 12.4091 11.1818H11.5909C11.139 11.1818 10.7727 10.8155 10.7727 10.3636ZM14.0455 10.3636C14.0455 9.91177 14.4118 9.54545 14.8636 9.54545H15.6818C16.1337 9.54545 16.5 9.91177 16.5 10.3636C16.5 10.8155 16.1337 11.1818 15.6818 11.1818H14.8636C14.4118 11.1818 14.0455 10.8155 14.0455 10.3636Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97641 12.8649C5.13171 12.8342 5.29167 12.8182 5.45455 12.8182H5.86364C6.31551 12.8182 6.68182 13.1845 6.68182 13.6364C6.68182 14.0882 6.31551 14.4545 5.86364 14.4545H5.45455C5.39886 14.4545 5.34525 14.46 5.29397 14.4701C4.85069 14.5578 4.42026 14.2696 4.33256 13.8263C4.24487 13.383 4.53313 12.9526 4.97641 12.8649ZM7.5 13.6364C7.5 13.1845 7.86631 12.8182 8.31818 12.8182H9.13636C9.58823 12.8182 9.95455 13.1845 9.95455 13.6364C9.95455 14.0882 9.58823 14.4545 9.13636 14.4545H8.31818C7.86631 14.4545 7.5 14.0882 7.5 13.6364ZM10.7727 13.6364C10.7727 13.1845 11.139 12.8182 11.5909 12.8182H12.4091C12.861 12.8182 13.2273 13.1845 13.2273 13.6364C13.2273 14.0882 12.861 14.4545 12.4091 14.4545H11.5909C11.139 14.4545 10.7727 14.0882 10.7727 13.6364ZM14.0455 13.6364C14.0455 13.1845 14.4118 12.8182 14.8636 12.8182H15.6818C16.1337 12.8182 16.5 13.1845 16.5 13.6364C16.5 14.0882 16.1337 14.4545 15.6818 14.4545H14.8636C14.4118 14.4545 14.0455 14.0882 14.0455 13.6364ZM17.3182 13.6364C17.3182 13.1845 17.6845 12.8182 18.1364 12.8182H18.5455C18.7083 12.8182 18.8683 12.8342 19.0236 12.8649C19.4669 12.9526 19.7551 13.383 19.6674 13.8263C19.5797 14.2696 19.1493 14.5578 18.706 14.4701C18.6548 14.46 18.6011 14.4545 18.5455 14.4545H18.1364C17.6845 14.4545 17.3182 14.0882 17.3182 13.6364ZM19.9919 14.1507C20.4352 14.0631 20.8656 14.3513 20.9533 14.7946C20.984 14.9499 21 15.1098 21 15.2727V15.6818C21 16.1337 20.6337 16.5 20.1818 16.5C19.7299 16.5 19.3636 16.1337 19.3636 15.6818V15.2727C19.3636 15.217 19.3582 15.1634 19.348 15.1122C19.2604 14.6689 19.5486 14.2384 19.9919 14.1507ZM4.00811 14.1507C4.45139 14.2384 4.73965 14.6689 4.65195 15.1122C4.64181 15.1634 4.63636 15.217 4.63636 15.2727V15.6818C4.63636 16.1337 4.27005 16.5 3.81818 16.5C3.36631 16.5 3 16.1337 3 15.6818V15.2727C3 15.1098 3.01598 14.9499 3.0467 14.7946C3.1344 14.3513 3.56483 14.0631 4.00811 14.1507ZM3.81818 17.3182C4.27005 17.3182 4.63636 17.6845 4.63636 18.1364V18.5455C4.63636 18.6011 4.64181 18.6548 4.65195 18.706C4.73965 19.1493 4.45139 19.5797 4.00811 19.6674C3.56483 19.7551 3.1344 19.4669 3.0467 19.0236C3.01598 18.8683 3 18.7083 3 18.5455V18.1364C3 17.6845 3.36631 17.3182 3.81818 17.3182ZM20.1818 17.3182C20.6337 17.3182 21 17.6845 21 18.1364V18.5455C21 18.7083 20.984 18.8683 20.9533 19.0236C20.8656 19.4669 20.4352 19.7551 19.9919 19.6674C19.5486 19.5797 19.2604 19.1493 19.348 18.706C19.3582 18.6548 19.3636 18.6011 19.3636 18.5455V18.1364C19.3636 17.6845 19.7299 17.3182 20.1818 17.3182ZM4.33256 19.9919C4.42026 19.5486 4.85069 19.2604 5.29397 19.348C5.34525 19.3582 5.39886 19.3636 5.45455 19.3636H5.86364C6.31551 19.3636 6.68182 19.7299 6.68182 20.1818C6.68182 20.6337 6.31551 21 5.86364 21H5.45455C5.29167 21 5.13171 20.984 4.97641 20.9533C4.53313 20.8656 4.24487 20.4352 4.33256 19.9919ZM19.6674 19.9919C19.7551 20.4352 19.4669 20.8656 19.0236 20.9533C18.8683 20.984 18.7083 21 18.5455 21H18.1364C17.6845 21 17.3182 20.6337 17.3182 20.1818C17.3182 19.7299 17.6845 19.3636 18.1364 19.3636H18.5455C18.6011 19.3636 18.6548 19.3582 18.706 19.348C19.1493 19.2604 19.5797 19.5486 19.6674 19.9919ZM7.5 20.1818C7.5 19.7299 7.86631 19.3636 8.31818 19.3636H9.13636C9.58823 19.3636 9.95455 19.7299 9.95455 20.1818C9.95455 20.6337 9.58823 21 9.13636 21H8.31818C7.86631 21 7.5 20.6337 7.5 20.1818ZM10.7727 20.1818C10.7727 19.7299 11.139 19.3636 11.5909 19.3636H12.4091C12.861 19.3636 13.2273 19.7299 13.2273 20.1818C13.2273 20.6337 12.861 21 12.4091 21H11.5909C11.139 21 10.7727 20.6337 10.7727 20.1818ZM14.0455 20.1818C14.0455 19.7299 14.4118 19.3636 14.8636 19.3636H15.6818C16.1337 19.3636 16.5 19.7299 16.5 20.1818C16.5 20.6337 16.1337 21 15.6818 21H14.8636C14.4118 21 14.0455 20.6337 14.0455 20.1818Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27273 7.09091C6.27273 6.63904 6.63904 6.27273 7.09091 6.27273H7.09909C7.55096 6.27273 7.91727 6.63904 7.91727 7.09091C7.91727 7.54278 7.55096 7.90909 7.09909 7.90909H7.09091C6.63904 7.90909 6.27273 7.54278 6.27273 7.09091Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54545 7.09091C9.54545 6.63904 9.91177 6.27273 10.3636 6.27273H10.3718C10.8237 6.27273 11.19 6.63904 11.19 7.09091C11.19 7.54278 10.8237 7.90909 10.3718 7.90909H10.3636C9.91177 7.90909 9.54545 7.54278 9.54545 7.09091Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27273 16.9091C6.27273 16.4572 6.63904 16.0909 7.09091 16.0909H7.09909C7.55096 16.0909 7.91727 16.4572 7.91727 16.9091C7.91727 17.361 7.55096 17.7273 7.09909 17.7273H7.09091C6.63904 17.7273 6.27273 17.361 6.27273 16.9091Z",
    fill: fill
  }));
};

var triangleDownIcon = function triangleDownIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "triangleDown icon"), React.createElement("path", {
    d: "M11.6464 16.6464L6.85355 11.8536C6.53857 11.5386 6.76165 11 7.20711 11H16.7929C17.2383 11 17.4614 11.5386 17.1464 11.8536L12.3536 16.6464C12.1583 16.8417 11.8417 16.8417 11.6464 16.6464Z",
    fill: fill
  }));
};

var triangleUpIcon = function triangleUpIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "triangle up icon"), React.createElement("path", {
    d: "M11.6464 9.35355L6.85355 14.1464C6.53857 14.4614 6.76165 15 7.20711 15H16.7929C17.2383 15 17.4614 14.4614 17.1464 14.1464L12.3536 9.35355C12.1583 9.15829 11.8417 9.15829 11.6464 9.35355Z",
    fill: fill
  }));
};

var twitterIcon = function twitterIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 30 30",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "twitter icon"), React.createElement("path", {
    fill: fill,
    d: "M28,6.937c-0.957,0.425-1.985,0.711-3.064,0.84c1.102-0.66,1.947-1.705,2.345-2.951c-1.03,0.611-2.172,1.055-3.388,1.295 c-0.973-1.037-2.359-1.685-3.893-1.685c-2.946,0-5.334,2.389-5.334,5.334c0,0.418,0.048,0.826,0.138,1.215 c-4.433-0.222-8.363-2.346-10.995-5.574C3.351,6.199,3.088,7.115,3.088,8.094c0,1.85,0.941,3.483,2.372,4.439 c-0.874-0.028-1.697-0.268-2.416-0.667c0,0.023,0,0.044,0,0.067c0,2.585,1.838,4.741,4.279,5.23 c-0.447,0.122-0.919,0.187-1.406,0.187c-0.343,0-0.678-0.034-1.003-0.095c0.679,2.119,2.649,3.662,4.983,3.705 c-1.825,1.431-4.125,2.284-6.625,2.284c-0.43,0-0.855-0.025-1.273-0.075c2.361,1.513,5.164,2.396,8.177,2.396 c9.812,0,15.176-8.128,15.176-15.177c0-0.231-0.005-0.461-0.015-0.69C26.38,8.945,27.285,8.006,28,6.937z"
  }));
};

var updateIcon = function updateIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "update icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 12.0187C19.6029 12.0187 19.2058 12.4232 19.1436 12.9164C19.0044 14.0193 18.61 15.0794 17.9866 16.0105C17.1954 17.1921 16.0709 18.113 14.7553 18.6568C13.4397 19.2006 11.992 19.3429 10.5954 19.0657C9.19869 18.7884 7.91577 18.1041 6.90883 17.0993C5.9019 16.0944 5.21616 14.8142 4.93835 13.4204C4.66054 12.0267 4.80312 10.582 5.34807 9.26911C5.89302 7.95622 6.81586 6.83407 7.9999 6.04456C9.18393 5.25506 10.576 4.83367 12 4.83367V3.03741C11.1455 3.03741 10.3001 3.15881 9.48837 3.39423C8.6092 3.6492 7.76939 4.03792 6.99987 4.55103C5.51983 5.53791 4.36628 6.94059 3.68509 8.58171C3.0039 10.2228 2.82567 12.0287 3.17294 13.7709C3.5202 15.5131 4.37737 17.1134 5.63604 18.3694C6.89471 19.6255 8.49836 20.4809 10.2442 20.8274C11.99 21.174 13.7996 20.9961 15.4442 20.3163C17.0887 19.6366 18.4943 18.4854 19.4832 17.0084C19.9974 16.2405 20.3869 15.4025 20.6424 14.5251C20.7951 14.001 20.8999 13.4628 20.9549 12.9172C21.0047 12.4226 20.5971 12.0187 20.1 12.0187Z",
    fill: fill
  }), React.createElement("path", {
    d: "M15.3988 3.43747C15.811 3.67985 15.811 4.27478 15.3988 4.51715L12.5281 6.86691C12.1095 7.11306 11.5814 6.81191 11.5814 6.32707V1.62755C11.5814 1.14271 12.1095 0.841562 12.5281 1.08771L15.3988 3.43747Z",
    fill: fill
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8732 8.78017C16.2206 9.12683 16.2206 9.68889 15.8732 10.0356L11.3732 14.5262C11.2064 14.6927 10.9801 14.7862 10.7442 14.7862C10.5083 14.7862 10.282 14.6927 10.1152 14.5262L8.12682 12.542C7.77943 12.1953 7.77943 11.6332 8.12682 11.2866C8.4742 10.9399 9.03742 10.9399 9.38481 11.2866L10.7442 12.6431L14.6152 8.78017C14.9626 8.43351 15.5258 8.43351 15.8732 8.78017Z",
    fill: fill
  }));
};

var userIcon = function userIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "user icon"), React.createElement("path", {
    d: "M15.5759 13.875C14.4107 13.875 13.8884 14.5 12 14.5C10.0714 14.5 9.54911 13.875 8.38393 13.875C5.41071 13.875 3 16.2578 3 19.1484V20.125C3 21.1797 3.84375 22 4.92857 22H19.0714C20.1161 22 21 21.1797 21 20.125V19.1484C21 16.2578 18.5491 13.875 15.5759 13.875ZM19.0714 20.125H4.92857V19.1484C4.92857 17.2734 6.45536 15.75 8.38393 15.75C8.98661 15.75 9.91071 16.375 12 16.375C14.0491 16.375 14.9732 15.75 15.5759 15.75C17.5045 15.75 19.0714 17.2734 19.0714 19.1484V20.125ZM12 13.25C15.1741 13.25 17.7857 10.75 17.7857 7.625C17.7857 4.53906 15.1741 2 12 2C8.78571 2 6.21429 4.53906 6.21429 7.625C6.21429 10.75 8.78571 13.25 12 13.25ZM12 3.875C14.0893 3.875 15.8571 5.59375 15.8571 7.625C15.8571 9.69531 14.0893 11.375 12 11.375C9.87054 11.375 8.14286 9.69531 8.14286 7.625C8.14286 5.59375 9.87054 3.875 12 3.875Z",
    fill: fill
  }));
};

var windowsIcon = function windowsIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "windows icon"), React.createElement("path", {
    d: "M4 4V11.6786H11.6786V4H4ZM12.3214 4V11.6786H20V4H12.3214ZM4 12.3214V20H11.6786V12.3214H4ZM12.3214 12.3214V20H20V12.3214H12.3214Z",
    fill: fill
  }));
};

/* eslint-disable linebreak-style */

var btcIcon = function btcIcon(fill, size, style) {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24.003",
    style: style
  }, React.createElement("title", null, "btc icon"), React.createElement("g", {
    id: "Layer1",
    transform: "translate(0 -0.001)"
  }, React.createElement("g", {
    id: "1",
    transform: "translate(0 0.001)"
  }, React.createElement("path", {
    id: "Path1",
    "data-name": "Path1",
    d: "M23.641,14.905A12,12,0,1,1,14.9.36a12,12,0,0,1,8.739,14.545h0Z",
    transform: "translate(0 -0.001)",
    fill: fill || '#F7931A'
  }), React.createElement("path", {
    id: "Path2",
    "data-name": "Path2",
    d: "M1006.912,718.858c.239-1.6-.976-2.455-2.638-3.027l.539-2.162-1.316-.328-.525,2.106c-.346-.086-.7-.168-1.054-.248l.529-2.119-1.315-.328-.539,2.162c-.286-.065-.567-.13-.84-.2l0-.007-1.815-.453-.35,1.406s.976.224.956.238a.7.7,0,0,1,.613.766l-.614,2.463a1.086,1.086,0,0,1,.137.044l-.139-.034-.86,3.451a.479.479,0,0,1-.6.313c.013.019-.956-.239-.956-.239l-.653,1.507,1.712.427c.318.08.631.164.938.242l-.544,2.187,1.314.328.539-2.164c.359.1.708.188,1.049.272l-.537,2.154,1.316.328.544-2.183c2.244.425,3.931.253,4.641-1.777a2.31,2.31,0,0,0-1.209-3.192,2.1,2.1,0,0,0,1.68-1.933h0Zm-3.006,4.217c-.407,1.635-3.158.751-4.05.529l.723-2.9c.892.223,3.752.664,3.327,2.368Zm.407-4.241c-.371,1.487-2.661.732-3.4.546l.655-2.628c.743.185,3.135.531,2.748,2.082Z",
    transform: "translate(-989.626 -708.566)",
    fill: "#fff"
  }))));
};

/* eslint-disable linebreak-style */

var bnbIcon = function bnbIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "Layer2",
    "data-name": "Layer2",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    style: style
  }, React.createElement("title", null, "bnb icon"), React.createElement("g", {
    id: "Layer1",
    "data-name": "Layer1"
  }, React.createElement("path", {
    id: "Path_1",
    "data-name": "Path1",
    d: "M7.339,10.085,12,5.424l4.663,4.663,2.712-2.712L12,0,4.627,7.373l2.712,2.712M0,12,2.712,9.288,5.424,12,2.712,14.712Zm7.339,1.915L12,18.576l4.663-4.663,2.713,2.711h0L12,24,4.627,16.627l0,0,2.716-2.708M18.576,12l2.712-2.712L24,12l-2.712,2.712Z",
    fill: fill || '#F3BA2F'
  }), React.createElement("path", {
    id: "Path_2",
    "data-name": "Path2",
    d: "M968.7,965.943h0l-2.753-2.753-2.034,2.034h0l-.234.234-.482.482,0,0,0,0,2.75,2.751,2.753-2.753v0h0",
    transform: "translate(-953.944 -953.944)",
    fill: fill || '#F3BA2F'
  })));
};

/* eslint-disable linebreak-style */

var oneinchIcon = function oneinchIcon(fill, size, style) {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size / 1.0605,
    viewBox: "0 0 24 22.63",
    style: style
  }, React.createElement("title", null, "oneinch icon"), React.createElement("g", {
    id: "_1inch-1inch-logo",
    "data-name": "1inch-1inch-logo",
    transform: "translate(0.099 0.01)"
  }, React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M29.571,42.027l.635-4.78L24.7,33.417l5.03,1.708L30.918,33.3l4.338-2.7,9.562,5.28.5,8.056-4.26,5.933-3.367.517,1.741-3.194V44.116l-1.266-2.4-1.286-.854L34.9,42.9v2.164l-1.544,1.449-1.962.238-.869.493L29.1,46.793,28.5,44.65l1.069-1.507Z",
    transform: "translate(-23.955 -29.569)",
    fill: "#fff"
  }), React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M287.519,107.462a10.042,10.042,0,0,0-2.2-.16,3.216,3.216,0,0,1-2.718,2.2A4.207,4.207,0,0,0,287.519,107.462Z",
    transform: "translate(-273.104 -103.655)",
    fill: "#94a6c3"
  }), React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M186.464,182.227a7.652,7.652,0,0,0,2.66-3.909c.02-.058.2-.16.316-.238.2-.119.4-.218.435-.378a8.372,8.372,0,0,0,.119-1.408c0-.177-.18-.357-.357-.534-.139-.119-.279-.259-.279-.357A7.542,7.542,0,0,0,187,170.681l-.139.139a7.405,7.405,0,0,1,2.3,4.6,1.007,1.007,0,0,0,.337.476c.139.119.3.3.3.378a8.074,8.074,0,0,1-.119,1.368c-.02.078-.2.16-.337.238-.2.1-.378.2-.415.357a7.336,7.336,0,0,1-3.017,4.11c.259-.555,1.072-2.361,1.507-3.276l-.078-2.936-2.521-2.439-1.429.2-1.568,2.541a1.521,1.521,0,0,1-.3,2.024,4.7,4.7,0,0,1-1.806,1.31l-.735-.4a7.737,7.737,0,0,1,.993-.973c.575-.476,1.15-.517,1.15-1.031.024-1.075-1.129-.779-1.129-.779l-.418.4-.177,1.47-.871,1.092-.1-.02L177,179.213s.874-.456,1.014-.973a7.993,7.993,0,0,0-.3-2.242,2.164,2.164,0,0,1,.6.912,7.206,7.206,0,0,1,.854-1.786c.119-.078,1.725-.932,1.725-.932l-.534,1.408.4-.218.953-2.341a4.67,4.67,0,0,1,1.626-.456c1.249-.02,3.1-1.548,2.262-4.286.238.1,4.365,2.164,5.079,6.212C191.206,177.625,189.441,180.54,186.464,182.227Z",
    transform: "translate(-171.101 -162.584)",
    fill: "#94a6c3"
  }), React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M286.534,87.23a1.7,1.7,0,0,0,.279-1.33l-1.33,1.966A1.539,1.539,0,0,0,286.534,87.23Z",
    transform: "translate(-275.885 -82.988)",
    fill: "#1b314f"
  }), React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M168.864,418.093l.16-.793s-.657,1.15-.714,1.31c-.061.18.041.5.3.476a.789.789,0,0,0,.575-.674A.284.284,0,0,0,168.864,418.093Z",
    transform: "translate(-162.673 -403.114)",
    fill: "#1b314f"
  }), React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M17.955,2.358s.991.041,2.02.16a10.041,10.041,0,0,0-6.3-2.361A8.6,8.6,0,0,0,9.456,1.229L10.23,0a4.112,4.112,0,0,0-4.18,2.977,16.334,16.334,0,0,1-.533-1.708,3.592,3.592,0,0,0-.852,3.752C2.821,4.345.19,3.409.088,3.392c-.139-.02-.18.041-.18.041s-.041.058.078.16c.221.173,4.38,3.252,5.293,3.848-.2.714-.2,1.051,0,1.388a1.386,1.386,0,0,1,.258,1.031c-.041.337-.4,3.256-.475,3.613s-.91,1.626-.873,2,.553,1.983,1.012,2.164a6.348,6.348,0,0,0,1.721.378.7.7,0,0,0,.455-.119c.336-.3.435-.357.672-.357h.058c.1,0,.217.02.357.02a1.5,1.5,0,0,0,1.029-.337c.435-.435,1.188-1.031,1.426-1.31a1.845,1.845,0,0,0,.377-1.408,1.889,1.889,0,0,1,.5-1.31c.377-.5,1.07-1.388,1.07-1.388a5.419,5.419,0,0,1,2.221,4.341,5.815,5.815,0,0,1-6.02,5.6,6.361,6.361,0,0,1-1.5-.177,11.664,11.664,0,0,0,3.864.714,6.428,6.428,0,0,0,3.426-.813,9.88,9.88,0,0,1-1.09,1.15h.02a8.115,8.115,0,0,0,5.507-3.572s-.139.993-.316,1.667C23.9,17,23.065,12.36,23.045,12.2c.041.058.536.653.791.973A10.276,10.276,0,0,0,17.955,2.358Zm-7.585,13.06c-.078.1-.414.4-.652.616s-.5.435-.693.636a.691.691,0,0,1-.475.119H7.955a10.53,10.53,0,0,1,1.467-1.507c.357-.238.536-.476.316-.891s-.791-.316-.791-.316a1.963,1.963,0,0,1,.635-.139,1.221,1.221,0,0,0-1.07.218c-.238.218-.2.993-.3,1.487-.1.517-.435.776-.951,1.252a.978.978,0,0,1-.635.337,6.755,6.755,0,0,1-1.012-.259,5.685,5.685,0,0,1-.574-1.47,8.064,8.064,0,0,1,.414-.854,3.742,3.742,0,0,0,.418-.953c.078-.337.336-2.422.435-3.293.258.337.615.895.533,1.252A1.678,1.678,0,0,0,6.8,9.726,2.188,2.188,0,0,1,6.587,8.1c.2-.674.91-2.541.91-2.541s.238.418.574.337A39.472,39.472,0,0,0,11.12,1.729a3.228,3.228,0,0,1-.041,2.779A3.265,3.265,0,0,1,9.514,5.9a2.961,2.961,0,0,0,2.1-.538c.414.973.812,1.983.832,2.123-.061.139-.852,2.045-.93,2.164A1.978,1.978,0,0,1,11,9.8a2.8,2.8,0,0,0-.615.218,22.181,22.181,0,0,0-1.07,2.718,1.644,1.644,0,0,0-.971.694,2.8,2.8,0,0,1,.893-.2,1.777,1.777,0,0,1,1.348,1.289v.041A1.228,1.228,0,0,1,10.369,15.418Zm-1.861.238a1.845,1.845,0,0,0,.18-.833c.02-.139.058-.4.217-.435s.536.02.536.3c0,.259-.278.316-.475.5C8.825,15.316,8.546,15.615,8.509,15.656Zm7.9-3.793a9.544,9.544,0,0,0,.16-2.6,7.3,7.3,0,0,1,1.385,3.572,1.007,1.007,0,0,0,.336.476c.139.119.3.279.3.378a8.158,8.158,0,0,1-.119,1.371c-.02.058-.2.16-.336.238-.2.1-.377.2-.414.357a7.4,7.4,0,0,1-2.614,3.831C16.946,17.561,17.836,14.384,16.41,11.863Zm-1.246,7.8a7.637,7.637,0,0,0,2.713-3.95c.02-.058.2-.16.316-.238.2-.1.4-.218.435-.378a8.387,8.387,0,0,0,.119-1.408c0-.177-.18-.357-.357-.534-.1-.119-.258-.259-.258-.357a7.79,7.79,0,0,0-1.623-3.95,4.1,4.1,0,0,0-2.02-3.137,3.642,3.642,0,0,1,.357,3.293,2.65,2.65,0,0,1-2.774,1.507,6.452,6.452,0,0,0-1.545,2.262,2.134,2.134,0,0,0-.991-.058c.357-.993.893-2.4.991-2.521a3.016,3.016,0,0,1,.536-.177c.377-.1.553-.16.615-.238.041-.061.238-.517.435-.993a4.463,4.463,0,0,0,.672-.061A7.4,7.4,0,0,0,13.2,7.6c0-.1-.774-2.024-1.07-2.759a4.575,4.575,0,0,0,.414-.575,8.123,8.123,0,0,1,2.618,15.4Z",
    transform: "translate(0 0)",
    fill: "#1b314f"
  }), React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M216.86,188.436a.866.866,0,0,0-.517-1.388c.18-.415.435-1.248.435-1.248s-2.024,3.174-2.2,3.235-.357-.636-.357-.636c-.378,1.449.636,1.647.755,1.191A5.077,5.077,0,0,0,216.86,188.436Z",
    transform: "translate(-206.962 -179.489)",
    fill: "#1b314f"
  }), React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M243.4,235.866l1.031-1.766s.6.3.3.776A3.85,3.85,0,0,1,243.4,235.866Z",
    transform: "translate(-235.232 -226.146)",
    fill: fill || '#ffd923'
  }), React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M589.231,288.093A11.624,11.624,0,0,1,588.2,289.3a10.662,10.662,0,0,0,.02-9.6c.18.18.357.378.517.555A6.282,6.282,0,0,1,589.231,288.093Z",
    transform: "translate(-568.331 -270.195)",
    fill: fill || '#d82122'
  }), React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M383.057,98.412a11.925,11.925,0,0,0-4.96-6.29,10.093,10.093,0,0,0-5.756-1.626H372.3a1.361,1.361,0,0,1,.3-.078,12.68,12.68,0,0,1,2.2-.456,6.529,6.529,0,0,1,5.678,1.943l.041.041A9.327,9.327,0,0,1,383.057,98.412Z",
    transform: "translate(-359.776 -86.845)",
    fill: fill || '#d82122'
  }), React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M276.129,22.81a11.293,11.293,0,0,0-6.232.238,5.891,5.891,0,0,0-.3-.735c-.412.5-.85,1.092-1.126,1.47A4.032,4.032,0,0,0,267.4,24.8a4.136,4.136,0,0,1,3.256-2.878,8.088,8.088,0,0,1,1.429-.119A9.342,9.342,0,0,1,276.129,22.81Z",
    transform: "translate(-258.426 -21.068)",
    fill: fill || '#d82122'
  }), React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M155.391,80.136c-2.32-.078-1.548-2.779-1.507-2.936C153.884,77.22,154.04,79.323,155.391,80.136Z",
    transform: "translate(-148.604 -74.583)",
    fill: fill || '#d82122'
  }), React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M214.235,20.6c-1.786,1.072-1.429,3.63-1.429,3.63C211.1,21.634,214.1,20.661,214.235,20.6Z",
    transform: "translate(-205.171 -19.909)",
    fill: fill || '#d82122'
  }), React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M91.535,149.628a.4.4,0,0,1,.1.538c-.078.139-.2.119-.378.041-.238-.119-1.667-.953-2.956-1.806,1.47.517,2.956,1.072,3.194,1.191C91.494,149.591,91.515,149.611,91.535,149.628Z",
    transform: "translate(-85.391 -143.361)",
    fill: "#fff"
  })));
};

/* eslint-disable linebreak-style */

var shibIcon = function shibIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "Group_938",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size * 0.996,
    viewBox: "0 0 24 24.28",
    style: style
  }, React.createElement("title", null, "shib icon"), React.createElement("g", {
    id: "Group_931",
    transform: "translate(0 0.797)"
  }, React.createElement("path", {
    id: "Path_8573",
    d: "M1136.1,254.544a15.524,15.524,0,0,0-1.713,2.032l-.162-.053a11.721,11.721,0,0,0-2.869-.556c-.293-.023-1.386-.023-1.743,0a10.134,10.134,0,0,0-2.843.56c-.038.015-.071.026-.105.038a15.285,15.285,0,0,0-1.769-2.017,12.3,12.3,0,0,1,10.027-.53c.349.131.691.285,1.025.451Z",
    transform: "translate(-1118.51 -253.196)",
    fill: fill || 'rgb(240, 5, 0)',
    fillOpacity: "0.7"
  }), React.createElement("path", {
    id: "Path_8574",
    d: "M976.829,394.915a11.664,11.664,0,0,1-2.094,3.669,13.013,13.013,0,0,1-1.638,1.6,12.092,12.092,0,0,1-4.724,2.328,12.394,12.394,0,0,1-5.8,0,12.068,12.068,0,0,1-4.724-2.328,13.012,13.012,0,0,1-1.638-1.6,11.521,11.521,0,0,1-2.095-11.239,12.19,12.19,0,0,1,.954-2.055c.176-.3.393-.635.5-.773.359,1.543.8,2.9.965,3.389a.84.84,0,0,1-.041.082,13.535,13.535,0,0,0-1.455,5.272c0,.022,0,.049,0,.071a3.25,3.25,0,0,0,.075,1.14,7.31,7.31,0,0,0,2.5,3.389,14.415,14.415,0,0,0,7.5,3.4c2.375.161,5.88-1.225,8.214-3.25a11.724,11.724,0,0,0,1.032-1.035,5.665,5.665,0,0,0,.55-.732c-.008,0,0-.007.015-.015s.022-.019.015-.026,0-.015.015-.019.019-.011.015-.019,0-.015.015-.019a.017.017,0,0,0,.011-.022c0-.007,0-.015.007-.015s.015-.011.015-.019.008-.019.015-.019a.016.016,0,0,0,.015-.015.392.392,0,0,1,.049-.086c.056-.086.281-.486.31-.553a5.148,5.148,0,0,0,.411-1.341,3.8,3.8,0,0,0,.034-.673c0-.015,0-.041-.007-.082-.007-.075-.011-.187-.019-.3-.008-.168-.023-.4-.034-.519a10.95,10.95,0,0,0-1.418-4.551,1.305,1.305,0,0,1-.082-.157.215.215,0,0,1-.015-.03h0c.116-.348.591-1.8.969-3.464l.007.007.056.075c.1.131.355.519.471.706a11.466,11.466,0,0,1,1.058,9.826Z",
    transform: "translate(-953.47 -379.376)",
    fill: fill || 'rgb(240, 5, 0)',
    fillOpacity: "0.7"
  }), React.createElement("path", {
    id: "Path_8575",
    d: "M1343.393,516.332a1.264,1.264,0,0,1-.364.372,6.277,6.277,0,0,1-2.388.9,2.938,2.938,0,0,1-1.236.034c-.105-.053-.12-.094-.083-.229a1.827,1.827,0,0,1,.732-.879c.2-.147,1.025-.646,1.408-.856a4.978,4.978,0,0,1,1.487-.6.765.765,0,0,1,.282,0c.068.026.143.225.173.466A6.127,6.127,0,0,1,1343.393,516.332Z",
    transform: "translate(-1324.884 -505.272)",
    fill: "#806b6b"
  }), React.createElement("path", {
    id: "Path_8576",
    d: "M1105.859,518.575a.408.408,0,0,1-.263.113,4.242,4.242,0,0,1-.74-.019,7.774,7.774,0,0,1-2.257-.65,2.842,2.842,0,0,1-.777-.522l-.105-.109-.011-.143a3.936,3.936,0,0,1,.015-.777,1.02,1.02,0,0,1,.116-.331c.03-.038.03-.038.165-.038a1.626,1.626,0,0,1,.529.1,10.355,10.355,0,0,1,1.987.992,3.446,3.446,0,0,1,1.149.894A.75.75,0,0,1,1105.859,518.575Z",
    transform: "translate(-1096.155 -506.272)",
    fill: "#806b6b"
  }), React.createElement("path", {
    id: "Path_8577",
    d: "M1213.683,630.826c0,.011-.045.191-.1.406s-.1.387-.1.394a.644.644,0,0,1-.12,0h-.12l-.165.391c-.09.214-.173.413-.184.443l-.022.053-.079-.128-.079-.128v-1.04l-.03.008c-.064.015-.518.075-.717.094a10.228,10.228,0,0,1-2.468-.053c-.131-.019-.244-.034-.248-.03s0,.244.008.541l.011.533-.064.1c-.034.053-.068.1-.068.1s-.049-.049-.135-.222a2.548,2.548,0,0,1-.21-.571l-.026-.109-.116.008-.116.011-.03-.139c-.015-.075-.034-.191-.041-.255l-.011-.12-.1-.086c-.056-.049-.113-.1-.124-.105a.082.082,0,0,1-.026-.064v-.045l.469,0,.469,0,.015.049.015.049.161.008c.09,0,.376.011.631.019l.47.011.12-.188.124-.188h.158l0-.391,0-.391-.206-.09a2.016,2.016,0,0,1-1.2-1.033,1.444,1.444,0,0,1-.037-.488,1.487,1.487,0,0,1,.023-.488.545.545,0,0,1,.387-.383,8.927,8.927,0,0,1,1.119-.019l1.044,0,.117.056a.653.653,0,0,1,.281.222.62.62,0,0,1,.117.443,3.306,3.306,0,0,1-.056.721,1.555,1.555,0,0,1-.218.432,2,2,0,0,1-.841.59l-.09.034,0,.394,0,.394.083.008.083.008.113.169.109.169h.5c.278,0,.522,0,.545.008.038.008.045,0,.083-.06l.045-.068h.432A1.363,1.363,0,0,1,1213.683,630.826Z",
    transform: "translate(-1198.684 -613.323)"
  }), React.createElement("path", {
    id: "Path_8578",
    d: "M1254.144,741.719c-.072.041-.12.06-.131.053s-.064-.049-.12-.09l-.1-.083-.105.113c-.229.248-.236.259-.3.263-.105.011-.128-.007-.255-.2-.068-.1-.12-.18-.12-.18s-.049-.008-.105-.011l-.1-.011-.049.1-.049.1-.086-.026a1.838,1.838,0,0,1-.2-.079l-.113-.056V741.4l1,0,1,0,0,.1C1254.3,741.629,1254.309,741.625,1254.144,741.719Z",
    transform: "translate(-1241.126 -723.142)"
  })), React.createElement("path", {
    id: "Path_8579",
    d: "M1015.534,581.8c0-.015,0-.041-.007-.083a7.923,7.923,0,0,0-5.835,1.814,4.537,4.537,0,0,0-4.355-3.53c-3.589,0-4.919,3.53-4.919,3.53a6.44,6.44,0,0,0-5.674-1.874c0,.023,0,.049,0,.071a3.285,3.285,0,0,0,.075,1.145,7.346,7.346,0,0,0,2.5,3.406,14.365,14.365,0,0,0,7.5,3.418c2.374.161,5.876-1.232,8.209-3.267a11.742,11.742,0,0,0,1.032-1.04,5.693,5.693,0,0,0,.55-.736c-.008,0,0-.007.015-.015s.023-.019.015-.026,0-.015.015-.019.019-.011.015-.019,0-.015.015-.019a.017.017,0,0,0,.011-.022c0-.008,0-.015.007-.015s.015-.011.015-.019.007-.019.015-.019a.016.016,0,0,0,.015-.015.39.39,0,0,1,.049-.086c.056-.086.28-.488.31-.556a5.2,5.2,0,0,0,.411-1.348A4.576,4.576,0,0,0,1015.534,581.8Zm-9.345,4.582c-.071.041-.12.06-.131.053s-.064-.049-.12-.09l-.1-.083-.1.113c-.228.248-.236.259-.3.263-.1.011-.127-.007-.254-.2-.067-.1-.12-.18-.12-.18s-.049-.007-.1-.011l-.1-.011-.049.1-.049.1-.086-.026a1.828,1.828,0,0,1-.2-.079l-.112-.056v-.214l.994,0,.994,0,0,.1C1006.35,586.291,1006.354,586.287,1006.189,586.381Zm1.869-.676c-.056.214-.1.387-.1.394a.632.632,0,0,1-.12,0h-.12l-.161.394c-.09.214-.172.413-.183.443l-.022.053-.078-.128-.079-.128V585.7l-.03.008c-.064.015-.516.075-.714.094a10.141,10.141,0,0,1-2.456-.053,2.474,2.474,0,0,0-.247-.03s0,.244.007.541l.011.533-.064.1c-.034.053-.067.1-.067.1s-.049-.049-.135-.222a2.547,2.547,0,0,1-.209-.571l-.026-.109-.116.008-.116.011-.03-.139c-.015-.075-.034-.192-.041-.255l-.011-.12-.1-.086c-.056-.049-.112-.1-.123-.105a.083.083,0,0,1-.026-.064v-.045l.467,0,.467,0,.015.049.015.049.161.008c.09,0,.374.011.628.019l.467.011.12-.188.123-.188h.157l0-.391,0-.391-.206-.09a2.009,2.009,0,0,1-1.2-1.033,1.442,1.442,0,0,1-.037-.488,1.5,1.5,0,0,1,.022-.488.545.545,0,0,1,.385-.383,8.877,8.877,0,0,1,1.114-.019l1.039,0,.116.056a.65.65,0,0,1,.28.222.623.623,0,0,1,.116.443,3.326,3.326,0,0,1-.056.721,1.562,1.562,0,0,1-.217.432,1.992,1.992,0,0,1-.837.59l-.09.034,0,.394,0,.394.082.008.082.007.112.169.108.169h.5c.277,0,.52,0,.542.008.037.008.045,0,.082-.06l.045-.068h.43a1.8,1.8,0,0,1,.43.015A2.592,2.592,0,0,0,1008.058,585.7Z",
    transform: "translate(-993.176 -567.025)",
    fill: "#fff"
  }), React.createElement("path", {
    id: "Path_8580",
    d: "M985.376,624.1a3.483,3.483,0,0,0-.376.071",
    transform: "translate(-983.816 -609.431)",
    fill: "none"
  }), React.createElement("path", {
    id: "Path_8581",
    d: "M1551.534,625.749a3.374,3.374,0,0,0-.334-.049",
    transform: "translate(-1528.849 -610.971)",
    fill: "none"
  }), React.createElement("path", {
    id: "Path_8582",
    d: "M1015.768,246.449c-.007-.169-.022-.406-.034-.522a11.052,11.052,0,0,0-1.417-4.574,1.313,1.313,0,0,1-.082-.158.225.225,0,0,1-.015-.03h0c.116-.349.591-1.81.968-3.481.512-2.268.837-4.92-.157-5.716,0,0-1.72-.128-4.022,2.141a15.5,15.5,0,0,0-1.7,2.032l-.161-.053a11.62,11.62,0,0,0-2.856-.556c-.292-.023-1.379-.023-1.734,0a10.046,10.046,0,0,0-2.83.56c-.037.015-.071.026-.1.038a15.267,15.267,0,0,0-1.761-2.017c-2.4-2.28-4.179-2.148-4.179-2.148-1.054.822-.7,3.594-.15,5.938.359,1.551.8,2.914.964,3.406a.865.865,0,0,1-.041.083,13.667,13.667,0,0,0-1.454,5.3,6.436,6.436,0,0,1,5.678,1.874s1.331-3.53,4.919-3.53a4.537,4.537,0,0,1,4.355,3.53,7.94,7.94,0,0,1,5.835-1.814C1015.783,246.675,1015.776,246.562,1015.768,246.449ZM997.2,239.892s-1.4-3.512-1.039-5.517h0a1.939,1.939,0,0,1,.348-.86s1.585.158,4.142,3.012a7.3,7.3,0,0,0-1.136.74.013.013,0,0,1-.007,0,9.015,9.015,0,0,0-2.306,2.621Zm5.932,5.217a.406.406,0,0,1-.262.113,4.209,4.209,0,0,1-.736-.019,7.71,7.71,0,0,1-2.246-.65,2.829,2.829,0,0,1-.774-.522l-.1-.109-.011-.143a3.943,3.943,0,0,1,.015-.777,1.021,1.021,0,0,1,.116-.331c.03-.038.03-.038.164-.038a1.612,1.612,0,0,1,.527.1,10.274,10.274,0,0,1,1.977.992,3.431,3.431,0,0,1,1.144.894A.753.753,0,0,1,1003.134,245.109Zm8.807-1.243a1.261,1.261,0,0,1-.363.372,6.231,6.231,0,0,1-2.377.9,2.909,2.909,0,0,1-1.23.034c-.1-.053-.12-.094-.082-.229a1.825,1.825,0,0,1,.729-.879c.2-.146,1.02-.646,1.4-.856a4.939,4.939,0,0,1,1.48-.6.756.756,0,0,1,.28,0c.067.026.142.225.172.466A6.138,6.138,0,0,1,1011.94,243.865Zm-.62-6.6-.007,0a6.973,6.973,0,0,0-1.1-.74c2.471-2.854,4-3.012,4-3.012a2.043,2.043,0,0,1,.336.86h0c.348,2.006-1,5.521-1,5.521a8.933,8.933,0,0,0-2.228-2.625Z",
    transform: "translate(-993.44 -231.963)",
    fill: fill || '#ffa409'
  }), React.createElement("path", {
    id: "Path_8583",
    d: "M1377.119,343.2c-.008.008-.011.019-.019.026",
    transform: "translate(-1361.255 -339.022)",
    fill: "none"
  }), React.createElement("path", {
    id: "Path_8584",
    d: "M1508.426,476.9c-.019.053-.026.079-.026.079",
    transform: "translate(-1487.657 -467.737)",
    fill: "none"
  }), React.createElement("g", {
    id: "Group_934",
    transform: "translate(16.747 1.549)"
  }, React.createElement("g", {
    id: "Group_933"
  }, React.createElement("g", {
    id: "Group_932"
  }, React.createElement("path", {
    id: "Path_8585",
    d: "M1406.36,274.06c-.293-.038-1.679-.045-3.249,2.9l-.008,0a7.008,7.008,0,0,0-1.1-.74c2.482-2.854,4.019-3.012,4.019-3.012A1.993,1.993,0,0,1,1406.36,274.06Z",
    transform: "translate(-1402 -273.2)",
    fill: fill || '#ff9300',
    fillOpacity: "0.3"
  })), React.createElement("path", {
    id: "Path_8586",
    d: "M1433.842,301.43a8.913,8.913,0,0,0-2.242-2.625c1.57-2.941,2.952-2.933,3.248-2.9h0C1435.2,297.918,1433.842,301.43,1433.842,301.43Z",
    transform: "translate(-1430.488 -295.049)",
    fill: fill || '#ff8300',
    fillOpacity: "0.2"
  }), React.createElement("path", {
    id: "Path_8587",
    d: "M1518.156,296.111l-.056-.011Z",
    transform: "translate(-1513.74 -295.24)",
    fill: fill || '#ff8300',
    fillOpacity: "0.2"
  }))), React.createElement("path", {
    id: "Path_8588",
    d: "M1172.116,343.058c-.037-.053-.079-.105-.116-.158",
    transform: "translate(-1163.826 -338.734)",
    fill: "none"
  }), React.createElement("path", {
    id: "Path_8589",
    d: "M1035,480.8c.041.128.068.2.068.2",
    transform: "translate(-1031.938 -471.492)",
    fill: "none"
  }), React.createElement("g", {
    id: "Group_937",
    transform: "translate(2.668 1.549)"
  }, React.createElement("g", {
    id: "Group_936"
  }, React.createElement("g", {
    id: "Group_935",
    transform: "translate(0.056)"
  }, React.createElement("path", {
    id: "Path_8590",
    d: "M1030.514,276.212a7.349,7.349,0,0,0-1.142.74.013.013,0,0,1-.007,0c-1.626-2.944-3.057-2.933-3.365-2.9a1.936,1.936,0,0,1,.349-.86S1027.945,273.358,1030.514,276.212Z",
    transform: "translate(-1026 -273.2)",
    fill: fill || '#ff9300',
    fillOpacity: "0.3"
  })), React.createElement("path", {
    id: "Path_8591",
    d: "M1027.948,298.8a9,9,0,0,0-2.321,2.625s-1.4-3.511-1.044-5.521h0C1024.887,295.871,1026.322,295.864,1027.948,298.8Z",
    transform: "translate(-1024.523 -295.049)",
    fill: fill || '#ff8300',
    fillOpacity: "0.2"
  }), React.createElement("path", {
    id: "Path_8592",
    d: "M1024.56,296.1l-.06.011Z",
    transform: "translate(-1024.5 -295.24)",
    fill: fill || '#ff8300',
    fillOpacity: "0.2"
  }))), React.createElement("path", {
    id: "Path_8593",
    d: "M1362.818,446.722s-1.2.075-1.052-.864a1.241,1.241,0,0,1,1.352-1.014c.263.038,1.314.413,1.127,1.2s-.451.638-.6.676A5.952,5.952,0,0,1,1362.818,446.722Z",
    transform: "translate(-1346.49 -436.877)",
    fill: "#fff"
  }), React.createElement("path", {
    id: "Path_8594",
    d: "M1126.818,446.722s-1.2.075-1.052-.864a1.241,1.241,0,0,1,1.352-1.014c.263.038,1.314.413,1.127,1.2s-.451.638-.6.676A5.951,5.951,0,0,1,1126.818,446.722Z",
    transform: "translate(-1119.313 -436.877)",
    fill: "#fff"
  }));
};

/* eslint-disable linebreak-style */

var dogeIcon = function dogeIcon(fill, size, style) {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    style: style
  }, React.createElement("title", null, "doge icon"), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-469.979 -469.979)"
  }, React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(470.073 470.073)"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1",
    transform: "translate(0 0)"
  }, React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: "12",
    cy: "12",
    r: "12",
    transform: "translate(-0.095 -0.095)",
    fill: "#988430"
  }), React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: "11.608",
    cy: "11.608",
    r: "11.608",
    transform: "translate(0.285 0.285)",
    fill: "#7a6a2a"
  }), React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: "11.364",
    cy: "11.364",
    r: "11.364",
    transform: "translate(0.529 0.529)",
    fill: fill || '#BA9F33'
  }), React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M135.525,720.583c-.068-.062-.14-.124-.206-.186s-.134-.124-.2-.186l-.2-.192c-.033-.033-.068-.062-.1-.1l-.1-.091c-.268-.254-.537-.508-.8-.763.274.25.541.5.815.753l.1.1c.033.033.068.062.1.1l.2.186c.068.062.134.124.2.192s.134.13.2.192Zm-3.555-.038s.974.1,1.45.169c.44.062,1.818.274,1.818.274Zm0,0c.274.023.547.052.821.081.14.014.274.029.408.043l.206.023.2.029.815.13.407.068c.134.023.268.049.408.072-.134-.014-.274-.033-.408-.052l-.407-.058-.815-.12c-.068-.01-.134-.023-.2-.033l-.206-.024c-.134-.013-.274-.033-.408-.049-.274-.033-.547-.068-.821-.111Zm3.171.7s-1.04.264-1.391.365-1.391.413-1.391.413l2.783-.778Z",
    transform: "translate(-130.381 -709.971)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M165.7,888.8c-.231.068-.461.134-.695.2l-.695.186-.691.2-.345.1c-.114.033-.231.062-.349.1.114-.038.231-.078.345-.111l.345-.111c.231-.072.46-.14.691-.212s.466-.12.7-.177.458-.112.693-.165h0Zm-2.637,1.419c.114-.043,1.434-.658,1.741-.8.154-.072.6-.23.6-.23Z",
    transform: "translate(-160.945 -877.53)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M173.69,920.931c.1-.038.2-.085.293-.13l.287-.134.576-.277c.192-.091.378-.192.576-.278.1-.043.2-.078.3-.11l.153-.049c.052-.013.1-.029.154-.043-.192.091-.394.169-.586.258s-.388.173-.586.258l-.586.258c-.2.08-.389.165-.584.246h0Zm.128.537s1.2-.7,1.607-.926c.215-.12.912-.466.912-.466Z",
    transform: "translate(-171.568 -908.242)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M183.71,934.045c.2-.124.407-.25.613-.378l.307-.186.313-.182c.1-.062.206-.124.312-.182a1.129,1.129,0,0,1,.159-.082l.163-.082c.215-.1.431-.211.658-.3-.206.13-.417.241-.629.355-.1.058-.212.111-.316.169s-.206.12-.312.177-.206.12-.312.177l-.316.173-.638.345h0Zm2.509-1.238s-.743.57-.984.753-.949.695-.949.695Z",
    transform: "translate(-181.459 -920.819)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M683.94,695.246l-.38-.72.221-.9,1.578-.609-.672-1.378.332-1.391.623-1.246,1.925-.3,1.415-1.349,3.054.231.6,3.266-1.155,4.112-.658,2.129-2.666.1-1.238-.858-1.45-.606Z",
    transform: "translate(-674.915 -678.657)",
    fill: "#e2cc85",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M401.823,1087.44a2.25,2.25,0,0,1-1,.13c-.182-.244-1.457-.359-1.457-.359a.714.714,0,0,0-.441.068,4.891,4.891,0,0,1-.8.163c-.25.062-.5-.264-.691-.332a2.7,2.7,0,0,1-.446-.244l-.537-.052-1.079-.456-1.714-1.708-.466.729-.144.9.518,1.069,1.4,1.271,2.721.691,1.613-.475,2.02-.854.507-.543Z",
    transform: "translate(-388.121 -1070.875)",
    fill: "#f1d789",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M304.4,689.632l.345-1.046.412-.675,1.325-.111-.4,1.16-1.108,1.972.46,1.76-.815.407-.25-.384-.2-.881-.014-.99Z",
    transform: "translate(-300.369 -679.101)",
    fill: "#f4ecb4",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M310.817,853.143l-.254-.355a.583.583,0,0,1-.029-.316c.038-.149.033-.159.014-.215s-.182-.25-.173-.417-.014-.225.111-.359a.45.45,0,0,0,.091-.355l.169.1.038-.058a.173.173,0,0,1,.062.124c.014-.1-.043-.59.085-.7s.355.518.355.518l-.14-.912-.359-.935-.638-.854-.038-.941v-.081a3.167,3.167,0,0,0-.375.806c-.058.244.082.541.052.893s-.052.322.033.46.293.423.212.629c-.072.177-.316.052-.316.052a.531.531,0,0,1-.114.2.435.435,0,0,0-.1-.192c0,.033-.014.078-.014.078s-.043-.134-.085-.3c-.058-.225-.12-.522-.176-.681-.023.091-.081.369-.081.369l.033.427.159.586.154.384.149.47.13.315.1.24.091.542.44.466.235.1.171-.087h0Z",
    transform: "translate(-305.295 -836.649)",
    fill: "#f3e19d",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M299.51,716.843a3.688,3.688,0,0,0-.407,1.079,7.137,7.137,0,0,0-.115,1.851,7.667,7.667,0,0,0,.258,1.525,8.5,8.5,0,0,0,.551,1.294l.014-.029a2.045,2.045,0,0,1-.159-.4c-.052-.206-.072-.45-.12-.561a2.677,2.677,0,0,1-.149-.341,1.461,1.461,0,0,0-.14-.489.991.991,0,0,1-.111-.388c-.019-.245.01-.518-.014-.743a2.987,2.987,0,0,1-.033-.825c.039-.2.241-.753.365-1.2.082-.283.033-.522.182-.769a2.172,2.172,0,0,0,.274-.609c.038-.136-.4.6-.4.6h0Z",
    transform: "translate(-295.243 -707.166)",
    fill: "#f2e8b0",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M375.94,747.42a.634.634,0,0,0-.241.134,3.5,3.5,0,0,0-.215.287,2.256,2.256,0,0,0-.2.423c-.085.169-.274.423-.3.514s-.062.518-.111.72a.969.969,0,0,0,.048.45l.111-.023a.349.349,0,0,0,.111.241c.111.095.13-.322.13-.322l.413-1.4.623-.423.068-.342-.444-.264h0Z",
    transform: "translate(-370.173 -737.958)",
    fill: "#f5eec0",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M396.252,783.977a1.043,1.043,0,0,0-.437.124c-.058.043-.081.078-.144.13a.949.949,0,0,0-.287.307,2.037,2.037,0,0,0-.177.667c-.019.149-.019.287-.033.408a1.693,1.693,0,0,0-.033.384c.019.186.212.283.23.495l.4-.2.375-1.477.8-.5-.45-.5-.239.166h0Z",
    transform: "translate(-390.183 -773.883)",
    fill: "#e6db9d",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M318.17,1211.916l0-.044c.058-.5.068-.877.111-1.114a2.92,2.92,0,0,0,.1-.586,2.637,2.637,0,0,1-.01-.5c.029-.206.231-.45.225-.619a.524.524,0,0,0-.13-.3c-.058-.082-.1-.15-.1-.15s.4-.273.394-1.376a.106.106,0,0,1,.023.01l.2.557.134.163.514.959.662.642.978.658.613.667.062,1.779-.8,1.04-.131.238a11.4,11.4,0,0,1-2.835-2.017Z",
    transform: "translate(-314.199 -1191.877)",
    fill: "#e5cb7a",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M509.56,1308.558a.548.548,0,0,1,.2-.365.218.218,0,0,1,.043.13,1.155,1.155,0,0,1,.786-.528.808.808,0,0,0,.648-.475l1.108-1.007,1.267-1.167,1.541-.541.72-.177a.4.4,0,0,1-.014.169,3.507,3.507,0,0,0,.739-.186c.124-.048.241-.068.3,0a.666.666,0,0,1,.111.407c.149-.033.322-.177.461-.163.221.023.417.283.642.283.3,0,.431-.182.638-.326.124-.085.3-.192.4-.264.241-.177,2.787-.955,2.787-.955l.893.058.144.959-.077,2.506-.029.028-4.059,2.12-5.626.862a11.284,11.284,0,0,1-3.6-1.237l-.029-.128h0Z",
    transform: "translate(-503.141 -1286.817)",
    fill: "#d8c173",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M344.85,1571.657c.08-.167.152-.307.164-.357.01.1.028.322.065.557Q344.964,1571.758,344.85,1571.657Z",
    transform: "translate(-340.538 -1551.299)",
    fill: "#f1d789",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M666.051,1427.9l.728-.2.062.02s.033.019.033.085c.091-.052.169-.043.225-.078.029.062.058.268.186.293a.571.571,0,0,0,.423-.169,2.82,2.82,0,0,1,.431-.316,2.284,2.284,0,0,1,.12.258c.163-.13.446-.658.85-.648a1.531,1.531,0,0,1,.56-.677,1.219,1.219,0,0,1,.9-.25,1.541,1.541,0,0,1,.423-.378.39.39,0,0,0,.349.023c.169-.078.359-.378.609-.417a.587.587,0,0,1,.388.081,6.33,6.33,0,0,1,1.232-.964c-.019-.058-.058-.277.532-.763.033.029.01.111.033.115a1.372,1.372,0,0,0,.336-.2,2.723,2.723,0,0,1,.658-.394.921.921,0,0,1,.633.095.3.3,0,0,1,.091-.043,1.207,1.207,0,0,0,.177-.038,1.228,1.228,0,0,1,0,.423.94.94,0,0,0,.192.082.868.868,0,0,1-.225.342c.1.048.114.1.258.153a2.842,2.842,0,0,0-.2.307c-.043.091-.2.47-.264.613s-.169.407-.215.461a3.7,3.7,0,0,1-.345.388c.115-.043.586-.186.786-.241l-.651.965a11.386,11.386,0,0,1-9.321,1.079Z",
    transform: "translate(-657.629 -1405.187)",
    fill: "#e0cd81",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M470.152,703.25a.7.7,0,0,0-.2.023c-.033.023.169.072.231.1a.53.53,0,0,1,.231.215,9.856,9.856,0,0,0,1.213.557l.834-.043.288-.4-.547-.479.384-1.131-.508.081-1.223.729-.613.235-.087.115Z",
    transform: "translate(-464.035 -693.208)",
    fill: "#dfc57c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M629.053,792.849a.131.131,0,0,0,.115.062.516.516,0,0,1,.4.13c.111.14.417.586.417.586l.734.264.047-.864-.8-.557-.912.336v.043h0Z",
    transform: "translate(-621.103 -782.432)",
    fill: "#e5cc7c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M583.922,831.046a.8.8,0,0,0,.3-.052c.169-.062.446-.2.567-.144.169.072.134.3.316.5.11.124.312.12.427.254s.508.072.508.072l.149.806-.6.769-.2.955h-.811l-.741-.294-.365-.883.182-.893.259-1.089Z",
    transform: "translate(-576.115 -820.309)",
    fill: "#d2c281",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M738.961,760.166a.22.22,0,0,0,.062.01.161.161,0,0,0-.052.173c.019.111.081.25.029.336a.42.42,0,0,1,.091.159c.033.1.043.182.258.2a.453.453,0,0,0-.085.068,1.412,1.412,0,0,1,.225.25,1.853,1.853,0,0,0,.283-.067l.043.029.091-.038s-.085-.033-.023-.241c.058-.182.111-.173.115-.186a1.908,1.908,0,0,0,.043-.283,3.414,3.414,0,0,0,.052-.407l-.062-.677-.349-.211L739.4,759l-.268.5-.176.176-.014.437.021.049Z",
    transform: "translate(-729.587 -749.39)",
    fill: "#e2c270",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M806.28,517.1a2.357,2.357,0,0,1,.085.312.3.3,0,0,0,.014-.081s.048.268.058.378c.019,0,.038-.01.043.01a1.621,1.621,0,0,1,.038.355.967.967,0,0,1,.326-.326.57.57,0,0,1,.264-.1c.15,0,.258.1.437.1a3.32,3.32,0,0,0,1.108-.413,1.465,1.465,0,0,0,.522-.241,1.362,1.362,0,0,0,.274-.341c.134-.23.274-.431.413-.456a.872.872,0,0,1-.192.014s.043-.043.115-.1a.448.448,0,0,1,.283-.13c.221,0,.332.033.456.033a.62.62,0,0,0,.2-.033.781.781,0,0,0,.423.091c.293,0,.489.029.642.043s.667-.043.815-.038a.716.716,0,0,1,.278.068l-.476-1.382-1.708-1.493-1.017.72-1.564,1.564-1.514.561-.316.355v.541Z",
    transform: "translate(-796.066 -506.893)",
    fill: "#ccb360",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1023.387,548.068s.043-.043.114-.1a.445.445,0,0,1,.283-.13c.221,0,.332.033.456.033a.62.62,0,0,0,.2-.033.783.783,0,0,0,.423.091c.293,0,.489.029.642.043s.667-.043.815-.038a.71.71,0,0,1,.277.068l-.215-.623-.25-.475-.714-.782-.864-.508s-.3-.081-.3-.081l-.776.469-.7,1.822-.014.384.456.216c.115-.192.241-.345.359-.365-.107.012-.188.012-.188.012h0Z",
    transform: "translate(-1009.776 -538.651)",
    fill: "#d5b457",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M858.417,733.28c-.068,0-.124-.01-.14-.058-.058-.163-.1-.186-.153-.186s-.115.1-.154.114-.085-.12-.085-.12l-.043-.019a2.6,2.6,0,0,0-.427.355,3.553,3.553,0,0,1-.6.576,6.416,6.416,0,0,1-.729.111.946.946,0,0,0-.345.169c-.023.025.068.052.082.078s-.15.013-.163.038a.629.629,0,0,0,.062.186.316.316,0,0,1,.134-.033c.149,0,.258.1.437.1a3.316,3.316,0,0,0,1.108-.413,1.465,1.465,0,0,0,.522-.241,1.373,1.373,0,0,0,.274-.341,2.424,2.424,0,0,1,.217-.31h0Z",
    transform: "translate(-844.816 -723.733)",
    fill: "#d2b257",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M382.068,1242.976a1.622,1.622,0,0,0-.394-.514c-.1-.1-.163-.192-.231-.254a3.1,3.1,0,0,0-.388-.293c-.264-.2-.551-.2-.772-.437a4.02,4.02,0,0,1-.658-1.17c-.177-.47-.225-.619-.225-.633s.049-.1.111-.091.062.134.078.163a.975.975,0,0,0,.1.134,1.275,1.275,0,0,1,.287.417,1.892,1.892,0,0,0-.068-.336s.342.215.633.44.413.3.5.446a6.913,6.913,0,0,0,.384.633,10.892,10.892,0,0,0,1.42.528l.63.469.313.685-.245.384-.47.1-.763-.342-.244-.331h0Z",
    transform: "translate(-374.646 -1223.826)",
    fill: "#d2b159",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M455.55,1277.062a1.779,1.779,0,0,0,.547.495,5.255,5.255,0,0,0,1.4.518,3.914,3.914,0,0,0,.821.124,11.819,11.819,0,0,0,1.741-.25,8.349,8.349,0,0,0,1.108-.153,5.7,5.7,0,0,0,1.242-.46c.3-.14.58-.245.805-.379a3.426,3.426,0,0,1,.815-.456.691.691,0,0,1-.332.423c.14,0,.332-.013.332-.013a6.183,6.183,0,0,0-.514.359c-.2.153-.47.413-.743.586-.177.111-.369.192-.495.258a2.223,2.223,0,0,0-.633.46.287.287,0,0,1,.078,0,1.51,1.51,0,0,0-.437.13.589.589,0,0,0-.221.019c-.091.029-.212.1-.336.13a.423.423,0,0,1-.235.029l.029.058s-.23,0-.307,0c.014,0,.01.01.01.01a.123.123,0,0,0-.038.014.4.4,0,0,1-.12.052c-.023,0-.043,0-.072.01.01.023.086.153.12.23-.029.019-.466.349-.466.349a.337.337,0,0,1,.033.068c.014.042.019.1.033.134.033.058.052.068.052.068s-.052.01-.144.033a2.5,2.5,0,0,1-.307.072,1.2,1.2,0,0,1-.124.01.339.339,0,0,1-.052.394c-.157.188-.206.216-.254.336a.514.514,0,0,0-.078-.049.326.326,0,0,1-.149-.1,1.251,1.251,0,0,1-.058.182,2.26,2.26,0,0,0-.134.355c-.052-.058-.149-.173-.283-.15s-.241.206-.264.258c0-.033-.023-.058-.029-.019a1.476,1.476,0,0,1-.489.85c0-.091,0-.293-.014-.359a.944.944,0,0,1-.365.215c-.274.12-.23.241-.23.241a.6.6,0,0,1,.124-.394c.149-.2.241-.3.241-.312a.087.087,0,0,0-.019-.043c-.019-.019-.058-.043-.058-.058a.39.39,0,0,0,.241-.349.62.62,0,0,0-.163-.388c-.01-.01.091-.082.078-.1s-.134-.1-.149-.154a.453.453,0,0,1,.019-.085.24.24,0,0,0,.019-.1.8.8,0,0,0-.078-.2,1.068,1.068,0,0,0,.111,0,.959.959,0,0,1-.091-.182,2.342,2.342,0,0,0-.058-.241c.033,0,.115.01.115,0,0-.029-.072-.078-.038-.115a.194.194,0,0,1,.11.078.444.444,0,0,0-.144-.231.353.353,0,0,1,.283.019.38.38,0,0,1,.154.163s.068.052.173.13a1.884,1.884,0,0,0,.518.326.536.536,0,0,0,.283.01.434.434,0,0,0,.12-.048.227.227,0,0,1,.043-.02.928.928,0,0,0-.072-.12c.033,0,.072,0,.072,0s.023-.052-.081-.153c.023-.023.052-.038.052-.078a.228.228,0,0,1-.1-.072c.019-.013.048-.058.081-.072-.029-.023-.1-.12-.134-.13a.6.6,0,0,0,.091-.043,1.115,1.115,0,0,1-.215-.078,1.293,1.293,0,0,0-.177-.124c-.049-.02-.134-.029-.169-.068a.528.528,0,0,0,.124,0c.029,0,.043,0,.052,0s0-.043.072-.052a.356.356,0,0,0,.1-.033.268.268,0,0,1-.154-.081.6.6,0,0,0-.2-.15c-.048-.01-.14.033-.2.029a.177.177,0,0,1-.111-.049,1.623,1.623,0,0,1-.83-.326,2.929,2.929,0,0,1-.71-.571.855.855,0,0,1-.134-.062c-.186-.1-.444-.3-.437-.563h0Z",
    transform: "translate(-449.822 -1260.271)",
    fill: "#c2a44d",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1008.556,390.56a.252.252,0,0,1,.115.078.358.358,0,0,1-.058.514.331.331,0,0,0,.186.029.907.907,0,0,0-.244.427.163.163,0,0,0,.072.169.645.645,0,0,0-.13.384,1.547,1.547,0,0,1,.192-.182,5.088,5.088,0,0,1,.475-.326.274.274,0,0,0,.014.1s.25-.206.461-.114c.095.043.052.177.052.177a.222.222,0,0,1,.221.043,4.142,4.142,0,0,1,.286.418,3.077,3.077,0,0,1,.182.25,3.171,3.171,0,0,1,.264.557c0-.1.029-.258.316-.159a1.762,1.762,0,0,1,.887.729c.274.417.341.887.479,1.066a1.519,1.519,0,0,1,.293.58,5.082,5.082,0,0,0,.245,1.558c.081-.326.206-1.05.206-1.05l.068-.638.078-1.975-2.063-1.714-1.613-1.17-1.05.1.066.149h0Z",
    transform: "translate(-995.689 -385.417)",
    fill: "#caa13e",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1107.832,237.008s-.029-.192-.514-.518-.863-.322-1.213-.6c-.268-.215-.547-.71-.729-.873a1.189,1.189,0,0,1-.206-.627l.6-.5.886-1.281.749-.825.359.5.5.586.277,1.176.1,1.721-.806,1.236Z",
    transform: "translate(-1091.132 -228.924)",
    fill: "#b59544",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1309.423,518.066a2.182,2.182,0,0,0-.1-.772,14.264,14.264,0,0,0-.537-1.369c-.052-.293-.014-.316.043-.349a.859.859,0,0,0,.384-.576.547.547,0,0,1,.475-.437l.221-.163.336.84.293.759.091.58.068.495-.159,1.046-.786.71-.334-.764h0Z",
    transform: "translate(-1292.124 -507.919)",
    fill: "#c89d3a",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M502.89,1700.5v-.021a.158.158,0,0,0,.043-.038c.014-.019.023-.043.033-.049a.371.371,0,0,1,.159-.029,1.232,1.232,0,0,0,.245.058,1.6,1.6,0,0,1,.561-.062c.388.072.479.335.7.485a.446.446,0,0,0,.336.058h.052c.01,0,.081-.082.12-.078.078,0,.085.068.134.072a4.284,4.284,0,0,1,.446-.029.214.214,0,0,1,.087.355.857.857,0,0,0-.258.307,1.089,1.089,0,0,1,.085.072,11.287,11.287,0,0,1-2.748-1.1Z",
    transform: "translate(-496.556 -1678.699)",
    fill: "#ceb052",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1310.68,694.048a6.672,6.672,0,0,0,.407-.6,20.861,20.861,0,0,0-.332-2.815l.877-2.874-.023-.935a8.6,8.6,0,0,1,.144-1.238c.12.215.495.475.576.613a7.143,7.143,0,0,0,.15-1.415,10.607,10.607,0,0,1,.244,1.223l.173.749.225.8.25.84.149.58.085.14.072.245.068.264.2.619.115.508.091.922a1.425,1.425,0,0,1,.043.215.908.908,0,0,1-.014.177,2.122,2.122,0,0,1,.019.375.526.526,0,0,1-.14.384,2.322,2.322,0,0,0-.2.768l-.215-.143a.584.584,0,0,0-.058-.375.378.378,0,0,0-.407-.186,1.231,1.231,0,0,0-.4.12,2.368,2.368,0,0,1-.388.342,2.333,2.333,0,0,1-.671.163,1.8,1.8,0,0,0-.551.287,3.08,3.08,0,0,1-.485.256h0Z",
    transform: "translate(-1294.013 -676.12)",
    fill: "#cca847",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1310.68,1287.424l.037.022a11.4,11.4,0,0,0,3.633-2.693c-.011-.393-.026-.8-.041-.944-.033-.316-.01-.638-.019-.825s-.114-.945-.163-1.141a.5.5,0,0,0-.169-.293,2.336,2.336,0,0,0-.1.46c0,.092-.019.313-.019.369-.014,0-.019-.038-.019-.052-.019.049-.043.134-.052.144s.014-.082,0-.1-.038-.01-.033-.058a.543.543,0,0,1,.013-.085.893.893,0,0,0-.1.3c-.043.215-.043.221-.058.241s-.091.1-.1.13c0,.052.072.1.078.134,0,.048-.068.273-.091.384s-.013.326-.038.437-.038.159-.1.2c.048.01.095.023.095.023a.717.717,0,0,1-.1.532c-.062.085-.078.124-.143.2a.891.891,0,0,0-.241.413.7.7,0,0,1-.013-.1,4.533,4.533,0,0,0-.287.369c-.111.173-.264.163-.307.206a.2.2,0,0,0-.038.182c-.038.01-.11.023-.159.173a.364.364,0,0,1-.173.206.923.923,0,0,1-.258.082.313.313,0,0,1,.091.029,1.556,1.556,0,0,1-.312.221.652.652,0,0,0-.258.312.224.224,0,0,1-.186.144c.038.023.1.078.124.095a.432.432,0,0,0-.244.12c-.136.113-.182.146-.245.155h0Z",
    transform: "translate(-1294.013 -1265.256)",
    fill: "#c39d3c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1099.551,1777.89a1.092,1.092,0,0,1,.24-.127,5.106,5.106,0,0,1,.749-.182,2.744,2.744,0,0,1,.365-.12c0,.034-.007.066-.011.1a11.289,11.289,0,0,1-1.343.333Z",
    transform: "translate(-1085.584 -1754.822)",
    fill: "#d2ba6b",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1194.544,805.051a2.392,2.392,0,0,1-.173.547c-.111.212-.23.5-.23.5a.923.923,0,0,1,.023-.2,5.506,5.506,0,0,0-.576.365,1.949,1.949,0,0,0-.283.293,5.845,5.845,0,0,0,.2-.619,12.476,12.476,0,0,0-1.131.994l-1.058.856a3.65,3.65,0,0,1-.376.176c-.182.078-.4.143-.557.206a.885.885,0,0,1,.206-.312,2.288,2.288,0,0,0,.45-.576.524.524,0,0,0,0-.388c-.052.014-.173.02-.254.043a.5.5,0,0,0-.169.11,3.959,3.959,0,0,1,.2-.691c-.1,0-.274.033-.274.033a2.462,2.462,0,0,1,.652-.685,2.118,2.118,0,0,0-.369.114c-.24.1-.5.25-.7.332a15.443,15.443,0,0,0,1.348-2.294,7.961,7.961,0,0,0,.734-1.847,8.412,8.412,0,0,0,.052-1.04,7.006,7.006,0,0,0,.029-.9,2.131,2.131,0,0,1,.586,1.512,5.788,5.788,0,0,1-.9,2.9c.115.033.413.072.72-.46a6.267,6.267,0,0,0,.413-.9.793.793,0,0,1,.01.149,4.063,4.063,0,0,0,.658-1.223,1.685,1.685,0,0,1-.029,1.089,1.078,1.078,0,0,1-.407.6.919.919,0,0,0,.283-.12c.029.072.023.153.072.182s.115.078.124.124a1.406,1.406,0,0,0,.159-.25,5.3,5.3,0,0,0,.038,1.166.4.4,0,0,0,.407-.293,1.2,1.2,0,0,0-.023.648.763.763,0,0,0,.151-.151h0Z",
    transform: "translate(-1174.995 -789.944)",
    fill: "#c0993a",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M859.817,350.753a1.144,1.144,0,0,1-.4.062c-.221,0-.159-.085-.5-.085-.531,0-2.389.307-2.715.3a7.149,7.149,0,0,0,.714.091l2.366.033.475-.038.177-.359Z",
    transform: "translate(-845.31 -346.343)",
    fill: "#a88f33",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M602.712,681.077a2.7,2.7,0,0,0-.431.408,3.006,3.006,0,0,1-.342.437.3.3,0,0,0,.1-.014s0,.038-.023.048a.136.136,0,0,1,.111.038.2.2,0,0,0-.068.278.3.3,0,0,0,.212.114s-.033.1.1.085a7.828,7.828,0,0,1,.782-.111.428.428,0,0,1,.349.241c.115.186.215.215.215.215a1.1,1.1,0,0,0,.052-.431,1.284,1.284,0,0,0,.091-.437l-.1-.743-.44-.557-.57.316-.043.11Z",
    transform: "translate(-594.339 -672.043)",
    fill: "#e3c571",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M704.64,478.2s.043.1.221.11a.1.1,0,0,0-.014.081l.01.081a.178.178,0,0,0,.052-.038c.01.043-.01.111,0,.159a.351.351,0,0,0,.029.085.164.164,0,0,1,.01-.019.759.759,0,0,0,.134.192.08.08,0,0,1,.01-.038.135.135,0,0,0,.023.068.07.07,0,0,1-.019-.014,2.212,2.212,0,0,0,.062.466.215.215,0,0,0,.023-.033c0-.01,0,.085-.014.154a.674.674,0,0,0,0,.163.507.507,0,0,1,.114-.068.414.414,0,0,0,.212-.254,1.681,1.681,0,0,0,.078-.277.388.388,0,0,1,.038.115c0,.049.1.023.1.023l.02-.212.115-.479.1-.3.5-.786.912-.7.8.182.671-.912-1.157-.695-1.094.115-.993,1.376-.8,1.248-.144.206h0Z",
    transform: "translate(-695.726 -469.28)",
    fill: "#d8b65b",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M794.816,404.413a1.264,1.264,0,0,0-.264.115c-.2.1-.332.134-.408.283a.732.732,0,0,0-.081.268,1.85,1.85,0,0,1,.212-.078c.081-.019.173-.014.163.019a.224.224,0,0,1-.038.062s.154,0,.149.072a.4.4,0,0,1-.058.2c-.029.038-.149.1-.163.14-.033.091.014.1,0,.169a1.166,1.166,0,0,1-.287.456,2.45,2.45,0,0,0-.307.417,2.654,2.654,0,0,1-.159-.365c-.038.019-.244.134-.244.134l-.477-1.663.01-.111a.3.3,0,0,0,.052-.149c-.072-.023-.081-.043-.177-.134a1.189,1.189,0,0,0-.332-.278.211.211,0,0,0-.169-.124c-.117-.023-.186-.043-.186-.043a.2.2,0,0,0,.091-.072,1.2,1.2,0,0,1-.287.029,1.2,1.2,0,0,0-.264,0c-.087.014-.192.052-.231-.081-.043-.033-.134,0-.212.111s-.1.206-.254.25a.52.52,0,0,1-.068.186,2.115,2.115,0,0,1-.2.25c-.144.169-.12.446-.349.658s.038-.586.038-.586l.369-.883,1.05-1.027,1.63-.111.159.844.8.274.5.766h0Z",
    transform: "translate(-780.17 -397.48)",
    fill: "#d3ae4d",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1011.067,404.837l-.685-.988-.479-.369s-.342-.629-.365-.648a4.507,4.507,0,0,0-.547-.062l.038.1a.252.252,0,0,1,.115.078.358.358,0,0,1-.058.514.332.332,0,0,0,.186.029.906.906,0,0,0-.244.427.162.162,0,0,0,.072.169.646.646,0,0,0-.13.384,1.55,1.55,0,0,1,.192-.182,4.97,4.97,0,0,1,.475-.326.275.275,0,0,0,.014.1s.25-.206.46-.115c.095.043.052.177.052.177a.222.222,0,0,1,.221.043,4.114,4.114,0,0,1,.287.417c.029.043.1.124.182.25a3.172,3.172,0,0,1,.264.557c0-.078.019-.186.153-.186l-.2-.365Z",
    transform: "translate(-996.163 -397.717)",
    fill: "#caa13e",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M368.487,621.205a.668.668,0,0,1,0-.355,3.577,3.577,0,0,0,.149-.691,2.462,2.462,0,0,1,.25-.776l.623-.283.441.12.13.59-.557.307a.428.428,0,0,1-.186.235c-.157.1-.375.186-.427.293a.855.855,0,0,0-.068.206.292.292,0,0,0-.254.072.372.372,0,0,0-.1.283Z",
    transform: "translate(-363.852 -611.28)",
    fill: "#f4efc8",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M338.751,495.061a.284.284,0,0,0-.091.115,2.336,2.336,0,0,1-.134-.763c0-.332-.024-.414.053-.529s.378-.235.335-.441a.322.322,0,0,0-.441-.221c-.154.038-.268.365-.427.528-.12.124-.264.1-.3.173-.052.091,0,.182-.019.241a1.157,1.157,0,0,1-.14.25,2.506,2.506,0,0,0-.514.935,1.6,1.6,0,0,1,.052-.388l-.029-.048.192-.629.124-.518.278-.868.489-.887.476-.532.495.033.058.743.283,1.4.6.733-.955.643-.378.033h0Z",
    transform: "translate(-332.858 -485.292)",
    fill: "#ebcc73",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M461.708,703.333a.241.241,0,0,1-.111,0c-.029-.016-.058-.033-.048-.052s.062-.052.062-.068a.054.054,0,0,0-.049-.058.053.053,0,0,0-.058.023.218.218,0,0,0-.078-.038.528.528,0,0,1,.062,0,.607.607,0,0,0-.169-.049c.049-.029.144-.114.206-.114s.1-.01.091-.043a.2.2,0,0,0-.111-.1c.019-.023.033-.058-.014-.153a.184.184,0,0,1-.014-.182,1.218,1.218,0,0,1,.085-.114.311.311,0,0,1,.081-.1,1.022,1.022,0,0,1,.144-.062c.068-.023.124-.052.163-.023a.053.053,0,0,1,.023.068.35.35,0,0,1,.254.014,1.92,1.92,0,0,0,.413.095l.105.212-.695.6-.287.144-.058.01h0Z",
    transform: "translate(-455.518 -693.301)",
    fill: "#e5c66b",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M493.069,606.695a2.682,2.682,0,0,0-.264.2c.029,0,.078.023.058.052a3.121,3.121,0,0,0-.241.225,1.488,1.488,0,0,0-.186.274.984.984,0,0,1-.326.225c.159,0,.479-.2.6-.2a.118.118,0,0,0,.1.13.754.754,0,0,0,.528-.12c.264-.159.177-.278.287-.355.212-.14.3-.264.413-.342a.757.757,0,0,1,.177-.1s0-.058.038-.052a.052.052,0,0,1,.043.033,1.191,1.191,0,0,1,.461-.182.027.027,0,0,1-.014-.013s.019-.01.023-.019.014-.019.023-.01.023.081.043.111c.043-.019.124-.2.124-.2l.2-.561v-.512l-.154.029-1.151.489-.7.724-.082.173Z",
    transform: "translate(-485.914 -597.637)",
    fill: "#e6bd62",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M705.928,487.02a.651.651,0,0,0,.177-.072.8.8,0,0,1-.124.278,2.332,2.332,0,0,0-.186.322c-.082.159-.091.388-.169.489a.357.357,0,0,1,.111-.033.512.512,0,0,0-.111.14.663.663,0,0,1-.235.313,1.867,1.867,0,0,0-.522.365c-.2.211-.4.479-.5.576a1.442,1.442,0,0,0,.144-.394c.019-.12,0-.264.029-.423a1.385,1.385,0,0,1,.192-.551,9.435,9.435,0,0,0,.431-1.242l.586-.186.177.419h0Z",
    transform: "translate(-695.459 -480.475)",
    fill: "#b6933f",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M772.163,399a1.634,1.634,0,0,0-.225.479c-.048.225,0,.206-.033.316a.413.413,0,0,0,0,.206.73.73,0,0,1,.244-.241,2,2,0,0,0,.384-.258,1.417,1.417,0,0,1,.326-.355c-.072-.01-.173-.043-.192-.038a4.337,4.337,0,0,1,.5-.355,1.945,1.945,0,0,1,.551-.369,2.4,2.4,0,0,1-.264,0c.038-.081.173-.12.307-.254s-.085-.332-.085-.332l-1.023.619-.495.582Z",
    transform: "translate(-762.117 -392.811)",
    fill: "#c49937",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M576,156.485l.023-.186.293-.47.307-.825v-1.127l-.023-.652.048-.427.037-.136.039-.052.25.13.346.47.033.906-.336,1.43-.959,1.046Z",
    transform: "translate(-568.731 -150.757)",
    fill: "#dfc068",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M339.546,148.139s-.154,0-.186.642-.049.974-.072,1.29a6.934,6.934,0,0,1-.1.695,1.911,1.911,0,0,1-.13.6,1.369,1.369,0,0,1-.312.466,1.926,1.926,0,0,1-.586.326,3.024,3.024,0,0,0-.695.159,1.056,1.056,0,0,0-.287.182,3.665,3.665,0,0,0-.772,1.046,14.578,14.578,0,0,0-.691,2.6l.078-.13a1.233,1.233,0,0,1,.182-.475c.169-.3.12-.642.355-1.223a6.664,6.664,0,0,1,.345-.753,2.8,2.8,0,0,1,.759-.926,2.4,2.4,0,0,1,.926-.369l.522-.345s.091-.177.212-.378a2.45,2.45,0,0,0,.431-1.059,9.822,9.822,0,0,0-.091-1.531c.01-.4.014-.7.1-.772s.023-.045.023-.045h0Z",
    transform: "translate(-331.515 -146.339)",
    fill: "#a88f33",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M631.533,149.259a7.417,7.417,0,0,0,.336-1.069c.02-.1.058-.2.068-.283a2.561,2.561,0,0,0,0-.932,1.661,1.661,0,0,0-.332-.5c-.095-.14-.14-.192-.12-.221a.215.215,0,0,1,.169-.072.578.578,0,0,1,.413.192,2.5,2.5,0,0,1,.268.759l.125.773.316.974-1.242.379h0Z",
    transform: "translate(-623.502 -144.412)",
    fill: "#c99e3d",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M663.53,155.459a.2.2,0,0,1-.12,0,.173.173,0,0,1-.078.163,6.552,6.552,0,0,0-.844.033.648.648,0,0,1-.466-.532c-.078-.312.058-.743.014-1.027a6.291,6.291,0,0,0-.173-.629c-.01-.13-.019-.163-.019-.244a.45.45,0,0,0-.111-.023c-.01-.038.01-.072-.033-.14a.772.772,0,0,1,.369.206.692.692,0,0,1,.177.225,1.8,1.8,0,0,1,.365.431c.1.2.3.84.342.945a.7.7,0,0,0,.115.182c.113.14.277.371.464.409h0Z",
    transform: "translate(-653.335 -151.201)",
    fill: "#b58634",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M706.47,187.5a5.391,5.391,0,0,1,.316.59,2.677,2.677,0,0,0,.326.642c-.078-.225-.215-.667-.3-.825a1.892,1.892,0,0,0-.345-.407h0Z",
    transform: "translate(-697.532 -185.201)",
    fill: "#a88f33",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M449.829,436.89a2.834,2.834,0,0,0-.561.241c-.12.062-.235.114-.345.163a6.017,6.017,0,0,1-.84.316c.019.023.029.033.029.033a.244.244,0,0,0,.052.149c-.029.029-.417.293-.3,1.176.078-.029.169-.068.182-.068s.029.068.058.068a.389.389,0,0,0,.225-.169,1.31,1.31,0,0,0,.25.935c.058-.068.206-.293.206-.293l0-.072a1.944,1.944,0,0,1,.1-.479,1.275,1.275,0,0,1,.241-.4l.83-1.186-.124-.417h0Z",
    transform: "translate(-442.211 -431.401)",
    fill: "#e6c367",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M532.241,358.361a.459.459,0,0,1-.124.062.48.48,0,0,1,.082-.378,5.061,5.061,0,0,0,.508-.652,1.415,1.415,0,0,1,.495-.873c.466-.417.648-.561.648-.561l.753-.378.926.365-.46,1.8-.357.844-1.42-.268-1.05.037h0Z",
    transform: "translate(-525.399 -351.131)",
    fill: "#dcba5a",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M585,438.2l.177-.221v-.157a1,1,0,0,0,.407-.268c.211-.215.5-.629.763-.6s.283.561.293.71a4.094,4.094,0,0,0,.1.671c.058.182-.629.873-.629.873l-.467.355L585,438.2Z",
    transform: "translate(-577.616 -431.464)",
    fill: "#e9ce77",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M627.73,530.293s.144-.225.038-.274a1.657,1.657,0,0,1,.176-.287,1.451,1.451,0,0,1,.345-.45,1.5,1.5,0,0,0,.47-.58,1.531,1.531,0,0,0,.043-.332.63.63,0,0,0,.091.062.542.542,0,0,1,.215.522.857.857,0,0,1-.154.475,2.286,2.286,0,0,1-.206.182c-.091.062-.124.134-.278.14a.185.185,0,0,1,.052-.029.357.357,0,0,0-.245.058c-.085.078-.267.316-.358.388l-.192.124h0Z",
    transform: "translate(-619.799 -521.711)",
    fill: "#cdae50",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M685.7,342.875a2.336,2.336,0,0,0-.714-.14c-.408-.014-1,.01-1.587.014-.629,0-1.2-.215-1.991-.254-.13-.078-.46-.417-1.492.3.062,0,.749-.159.988.14a1.2,1.2,0,0,1,.14.922c-.062.268-.264.658-.345.931s-.062.417-.12.609-.186.287-.111.508c.1-.062.153-.062.322-.44s.134-.648.413-.968a6.3,6.3,0,0,1,.9-.873,3.363,3.363,0,0,1,2.988-.144c.347-.037.607-.608.607-.608h0Z",
    transform: "translate(-671.322 -338.066)",
    fill: "#d2a83e",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M588.21,350.125a.183.183,0,0,0-.01-.043.313.313,0,0,0-.052-.078,2.49,2.49,0,0,0-.514-.043c-.3.033-.576.408-.7.6a3.544,3.544,0,0,1-.46.642.064.064,0,0,0-.01-.043s.01.014-.01.033-.019.029-.01.038l.029.029a2.378,2.378,0,0,0,.642-.461,3.237,3.237,0,0,1,.84-.6,1.186,1.186,0,0,1,.258-.076h0Z",
    transform: "translate(-579.032 -345.581)",
    fill: "#c29637",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1081.288,248.94s-.062.078-.14.163c-.173.182-.4.388-.59.6s-.388.359-.619.623-.5.557-.567.642a.632.632,0,0,0-.111.3l-.072-.048a.478.478,0,0,0,.058.085c.049.068.124.154.163.206a.623.623,0,0,1,.1.221c.023,0,.173.033.359-.274s.431-.642.431-.642l.388-.576.245-.489.307-.547.047-.26h0Z",
    transform: "translate(-1065.484 -245.855)",
    fill: "#ac8132",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1225.423,218.3a2.945,2.945,0,0,0-.326.307c-.091.115-.307.417-.307.417l.078-.01.394-.349.153-.274.008-.091Z",
    transform: "translate(-1209.222 -215.607)",
    fill: "#a88f33",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1268.581,1149.011a.4.4,0,0,1,.086-.254,1.846,1.846,0,0,0,.547-.759,4.97,4.97,0,0,0,.25-.642,2.816,2.816,0,0,1-.652.427c.058-.12.091-.206.12-.268-.033-.029-.173-.062-.186-.078.078-.078.12-.268.277-.394.2-.154.571-.417.857-.652a5.713,5.713,0,0,0,.922-.941.352.352,0,0,1,.052.1s-.283.369-.431.6a.574.574,0,0,0-.12.316l.268-.115s.077.287-.274.724c.153-.058.215-.023.3-.072a1.361,1.361,0,0,0-.528.557,2.4,2.4,0,0,1-.85.988,7.069,7.069,0,0,0-.642.458h0Z",
    transform: "translate(-1252.452 -1130.897)",
    fill: "#a67a2e",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1128.772,295.8a2.144,2.144,0,0,0-.183.59c0,.062-.019.111-.019.182a2.242,2.242,0,0,1-.038.609.321.321,0,0,0-.049-.1c-.029.081-.081.336-.124.431a2.028,2.028,0,0,1-.058-.532c0-.254.01-.3.01-.355a1.539,1.539,0,0,1-.082.244c-.029-.052-.062-.12-.1-.177a1.088,1.088,0,0,1-.077.124c0-.023-.014-.085-.02-.173a2.452,2.452,0,0,1,0-.258,1.169,1.169,0,0,1,.264-.446,3.724,3.724,0,0,0,.479-.792c.062-.134.326-.691.326-.691h.2l-.293.667s-.177.365-.268.5-.283.518-.369.668c.062-.081.114-.124.177-.2a3.2,3.2,0,0,0,.227-.289h0Z",
    transform: "translate(-1113.695 -290.793)",
    fill: "#8c6228",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1203.167,216.32a.841.841,0,0,1-.154.278c-.12.144-.379.336-.5.489a1.322,1.322,0,0,0-.241,1.04,1.744,1.744,0,0,1,.3-.547,4.2,4.2,0,0,0,.5-.714,1.2,1.2,0,0,0,.115-.378l.038-.048-.023-.111-.033-.008Z",
    transform: "translate(-1186.963 -213.652)",
    fill: "#cba94c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1395.139,513.446a2.112,2.112,0,0,1-.1-.4c-.023-.192.038-.23-.033-.45-.043-.134-.12-.115-.14-.134a1.131,1.131,0,0,1-.029-.332,1.253,1.253,0,0,0-.023-.316c-.029-.023-.049-.043-.091-.186a2.119,2.119,0,0,0-.095-.258c-.023-.043-.092-.081-.092-.124,0-.085.078-.13.078-.154,0-.048-.062-.01-.078-.023s.049-.163.023-.182c-.01-.01-.078.072-.095.049s-.043-.254-.078-.408-.068-.258-.072-.3-.268-.8-.332-.978a4.6,4.6,0,0,1-.13-.47,2.448,2.448,0,0,0-.043-.258c-.01.019,0,.115-.02.111s-.062-.336-.078-.388a2.709,2.709,0,0,1-.115-.359c-.019-.13-.062-.47-.091-.7s-.042-.326-.042-.384a2.393,2.393,0,0,0-.023-.423,3.95,3.95,0,0,0-.182-.714c-.13-.326-.475-1.16-.537-1.368,0-.052.068-.023.068-.023s.169.423.293.749a5,5,0,0,0,.264.642,2.408,2.408,0,0,1,.287.873c.081.524.111,1.007.159,1.329a3.427,3.427,0,0,0,.091.479c.052.177.134.359.24.638a4.214,4.214,0,0,1,.2.6c.043.215.043.378.068.485.023.091.058.274.14.537s.2.6.283.815a4.519,4.519,0,0,1,.254.965,9.293,9.293,0,0,1,.073,1.067h0Z",
    transform: "translate(-1375.004 -497.907)",
    fill: "#a88f33",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1250.136,213.019l-.01.023a.041.041,0,0,1,.023.049,1.175,1.175,0,0,1-.01.159c-.01.068-.029.12-.033.163a.817.817,0,0,1-.115.456c-.038.072-.062.134-.081.177a.525.525,0,0,1-.1.169c.068-.038.313-.192.437-.169a.911.911,0,0,0-.3.268.669.669,0,0,0,.23,0,3.2,3.2,0,0,1,.667-.1c.231.014.14-.277.14-.277l-.267-.586-.5-.355-.08.019Z",
    transform: "translate(-1233.922 -210.375)",
    fill: "#be9c44",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1276.8,193.446a1.8,1.8,0,0,1-.316-1,18,18,0,0,1-.072-1.919l-.182-.446a1.042,1.042,0,0,0-.134-.407c-.1-.111-.283-.3-.369-.388s-.182-.215-.24-.235a.665.665,0,0,1,.658-.326.7.7,0,0,1,.7.375,3.664,3.664,0,0,1,.374,1.369,4.691,4.691,0,0,1-.082,2.1,2.14,2.14,0,0,1-.342.875Z",
    transform: "translate(-1259.274 -186.412)",
    fill: "#a17c34",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1316.61,588.264a.381.381,0,0,0,.215-.049.606.606,0,0,0,.532-.225.453.453,0,0,1-.043.355.806.806,0,0,1,.13-.081,1.223,1.223,0,0,1-.215.83.34.34,0,0,1,.25-.091.988.988,0,0,1-.085.623.253.253,0,0,1-.25.085.478.478,0,0,0,0-.081c0-.052-.023-.1-.01-.14a.692.692,0,0,1-.2-.14,1.257,1.257,0,0,1-.4-.633.249.249,0,0,1,.182-.274.216.216,0,0,1-.043-.053.294.294,0,0,0-.058-.128Z",
    transform: "translate(-1299.786 -580.568)",
    fill: "#8c6228",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1201.212,296.156s-.01-.014-.062.048c.01-.062.019-.12.023-.177a.611.611,0,0,1,.1-.144c-.029.058-.049.111-.049.111a.782.782,0,0,1,.177-.215c.072-.058.163-.085.2-.14a.359.359,0,0,0,.043-.078,1.209,1.209,0,0,0,.241-.245c.019-.023.048-.048.068-.072s.111-.048.2-.1.2-.124.268-.154c.13-.058.268-.052.332-.144.048-.014.1-.159.091-.283a1.176,1.176,0,0,1,.567.759,2.752,2.752,0,0,1-.14,1.166,1.782,1.782,0,0,1-.173.58c-.12.159-.508.384-.6.495-.081.091-.326.322-.316.489.01.124.163.192.2.215s.033.052.095.038.085-.043.11-.043.029.01.043.01a.14.14,0,0,0,.029,0s-.01.177-.423.23c-.029,0-.058.014-.1.019a.237.237,0,0,0,.13-.1c-.058-.01-.225-.019-.268-.033a.511.511,0,0,1,.095-.114c.033-.029,0-.038-.033-.023a1.548,1.548,0,0,0-.144.111,1.407,1.407,0,0,1-.169.154.378.378,0,0,1,.072-.332c-.023,0-.068.072-.111.058a.614.614,0,0,1,.013-.212.965.965,0,0,1,.15-.241l.609-1.089.13-.825-1.4.271h0Z",
    transform: "translate(-1185.885 -290.901)",
    fill: "#92723a",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1164.791,409.721s-.033.023.033.068a.746.746,0,0,1-.062.1c-.033.038-.068.062-.082.1a.528.528,0,0,0-.052.144.71.71,0,0,1-.091.336,1.434,1.434,0,0,0-.086.163,1.2,1.2,0,0,0-.1.192,2.04,2.04,0,0,0-.033.254l.058-.072a.543.543,0,0,1-.085.14c.023-.019.091-.068.206-.169a5.1,5.1,0,0,1,.71-.537,1.042,1.042,0,0,1-.231.043c.048-.049.485-.561.714-.609a.091.091,0,0,0,.019-.062l-.2-.019-.4.085-.058-.307-.266.161Z",
    transform: "translate(-1149.496 -404.42)",
    fill: "#b18e3e",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1198.495,386.482a.538.538,0,0,0-.1.182.615.615,0,0,1-.1-.13.334.334,0,0,0-.44-.186.814.814,0,0,1,0-.182,1,1,0,0,0,.3-.268,1.24,1.24,0,0,0,.235-.378c.038-.029.1-.078.192-.134.124-.085.274-.2.3-.332a.793.793,0,0,1-.369.072c.072-.033.182-.068.169-.212.029-.019.052-.033.052-.033a.193.193,0,0,0-.068-.01c0-.014-.01-.033-.043-.023s-.038.01-.043.023a.206.206,0,0,0-.091.023,1.407,1.407,0,0,1-.159.114l.033-.058a.674.674,0,0,0-.163.038,3.4,3.4,0,0,0-.413.2c.014-.023.02-.038.029-.043s.033-.01.033-.014a.138.138,0,0,1,0-.052,1.788,1.788,0,0,1,.153-.264.514.514,0,0,0,.082-.221l.3-.149.834-.192.541.033-.068.375-.32.654-.274.6-.312.365-.287.21Z",
    transform: "translate(-1182.567 -379.434)",
    fill: "#543e26",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1204.3,355.807a4.85,4.85,0,0,1-.417.466c.058-.124.417-.864.547-1.069-.029-.023-.068-.023.023-.384-.077.182-.1.277-.169.326a.12.12,0,0,1-.115.033.08.08,0,0,0,.01-.048s-.274-.033-.461-.033a2.75,2.75,0,0,0-.763.182,3.118,3.118,0,0,0-.312.111c-.058.048-.091.1-.12.114s-.134.048-.159.085-.062.081-.062.091-.01.023.02.014c.01,0,.081-.043.163-.091.11-.062.244-.134.341-.177a1.582,1.582,0,0,1,.489-.115,3.05,3.05,0,0,1,.44-.078,3.681,3.681,0,0,1,.413.01c-.023.019-.043.043-.033.124a.61.61,0,0,1-.038.1c-.058.159-.169.423-.23.557-.085.182-.182.336-.23.431a3.128,3.128,0,0,1-.258.479c-.1.134-.159.215-.192.245s-.268.2-.25.264a1.3,1.3,0,0,0,.508-.336,4.078,4.078,0,0,1,.388-.475,1.3,1.3,0,0,0,.345-.489,2.141,2.141,0,0,1,.122-.342h0Z",
    transform: "translate(-1187.018 -350.381)",
    fill: "#806031",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M776.522,664.775a.609.609,0,0,1-.14.264c-.095.086-.264.159-.283.3s.169.215.169.215a.747.747,0,0,0-.1.3,2.014,2.014,0,0,0,.01.287.129.129,0,0,0-.038.038.316.316,0,0,0,.1.2c.1.078.177.124.225.1a.435.435,0,0,1,.02.049s.072-.182.12-.342.091-.14.11-.359a2.1,2.1,0,0,1,.23-.6l.144-.322-.235-.182-.332.035Z",
    transform: "translate(-766.269 -656.336)",
    fill: "#b6903c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M806.449,692.2a1.409,1.409,0,0,0-.134.159.466.466,0,0,1-.2.2c-.091.033-.149.033-.144.124s.091.13.14.177a.227.227,0,0,1,.072.221.222.222,0,0,0,.13-.134c.049-.1.388-.743.388-.743h-.25Z",
    transform: "translate(-795.759 -683.445)",
    fill: "#685026",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M804.634,539.643a.191.191,0,0,0,0-.134c-.029-.058-.206-.078-.293-.144a.347.347,0,0,0-.293-.085c.014-.033.068-.1.023-.12a.526.526,0,0,0-.244.091c-.043.033-.14.072-.159.1s-.052.068-.072.048-.029-.048-.062-.029a.792.792,0,0,0-.221.225,1.15,1.15,0,0,1-.293.437c-.2.192-.283.316-.225.388s.086.019.1.081a.526.526,0,0,1-.01.182c-.023.1-.062.2-.01.215.134.043.264-.038.293-.014.058.052-.033.241.1.277a.428.428,0,0,0,.278-.033l.508-.274.489-.258.25-.495-.134-.413-.026-.043Z",
    transform: "translate(-792.607 -532.361)",
    fill: "#d4b968",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M907.968,552.9a.2.2,0,0,1,.02-.245c.1-.115.254-.163.312-.235a.089.089,0,0,0-.043-.029.386.386,0,0,1,.169-.159.162.162,0,0,0-.111-.052c-.1,0-.153.058-.241.058s-.1-.043-.1-.043.144-.013.13-.078-.038-.068-.038-.068a1.456,1.456,0,0,0,.326-.177.355.355,0,0,0,.052-.163c.033,0,.225-.1.3-.058s.023.159.023.159a1.913,1.913,0,0,0,.355-.35c.1.01.153-.072.23-.072.1,0,.245.13.274.407a1.743,1.743,0,0,1,.02.532,2.454,2.454,0,0,0,.038.667c.033.134.11.12.11.12a.218.218,0,0,1-.068.1.324.324,0,0,0-.052.225.923.923,0,0,0,.029.1.484.484,0,0,0-.078.12.136.136,0,0,1-.124.081.592.592,0,0,0-.085,0c-.062,0-.082.013-.12,0s-.068-.029-.052-.154-.479-.413-.479-.413l-.806-.287h0Z",
    transform: "translate(-896.42 -544.436)",
    fill: "#cca849",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M838.091,706.621s.177.235.9.235a1.827,1.827,0,0,0,.537-.052,1.466,1.466,0,0,0,.662-.479c.264-.312.206-.44.206-.44l-.153-.023-.5.068-1.476.629-.179.064Z",
    transform: "translate(-827.469 -696.93)",
    fill: "#585136",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M831.939,671.169s-.629.14-.629-.258a1.383,1.383,0,0,1,.485-.867,1.812,1.812,0,0,1,.342-.154h.58l.11.293-.048.633-.84.353Z",
    transform: "translate(-820.775 -661.42)",
    fill: "#252211",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M856.136,676.111s-.12-.111-.394.038a.985.985,0,0,0-.509.743c-.014.25.206.437.547.446a1.743,1.743,0,0,0,.485-.038l-.12-.149-.01-1.04h0Z",
    transform: "translate(-844.393 -667.522)",
    fill: "#c3b378",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M865,683.551s-.029-.023-.115.023a1.887,1.887,0,0,0-.258.212,1.055,1.055,0,0,0-.115.1c-.12.144-.221.378-.163.495s.25.25.739.159l-.09-.984h0Z",
    transform: "translate(-853.373 -674.901)",
    fill: "#e6d89c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M869.232,659.548a.618.618,0,0,0-.078.312.515.515,0,0,0,.518.532c.312.019.522-.45.749-.633a.544.544,0,0,1,.277-.144,2.579,2.579,0,0,0-.648-.44.955.955,0,0,0-1.271.1c.134-.01.567-.12.567-.12l.211.068-.326.324h0Z",
    transform: "translate(-857.766 -650.657)",
    fill: "#252211",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M943.761,694.387c-.013-.029-.023-.068.033-.078s.081,0,.1.038.038.078.01.1a.135.135,0,0,1-.144-.056Zm-.091-.274s-.019.014-.01-.014.029-.091.091-.078.049.082.038.1a.1.1,0,0,1-.1.038.032.032,0,0,1-.019-.048Z",
    transform: "translate(-931.685 -685.242)",
    fill: "#6f674d",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M534,662.627a.6.6,0,0,0,.332.111.9.9,0,0,0,.508-.3c.062-.068.115-.14.173-.2a1.035,1.035,0,0,0,.1-.1c.033-.038.068-.111.085-.134a1.783,1.783,0,0,1-.169.13,2.009,2.009,0,0,1-.25.13c-.052.019-.6.307-.6.307l-.188.06Z",
    transform: "translate(-527.268 -653.631)",
    fill: "#ac924c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M552.34,586.323a.782.782,0,0,1,.25-.1,4.679,4.679,0,0,1,.479-.068l.264.115.1.4-.192.413-.244.154-.278-.446-.384-.47h0Z",
    transform: "translate(-545.374 -578.761)",
    fill: "#9f8e57",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M518.291,531.448l-.091.068a.59.59,0,0,0,.043-.173,1.6,1.6,0,0,1,.268-.629,2.03,2.03,0,0,1,.144-.173.1.1,0,0,0-.078.019.928.928,0,0,1,.268-.273c.124-.077.173-.1.3-.038s.163.1.258.091a.291.291,0,0,0,.177-.1s.019.062-.052.206a2.9,2.9,0,0,1-.355.437l-.59.4-.293.166h0Z",
    transform: "translate(-511.671 -523.531)",
    fill: "#eac970",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M559.421,532.376s.427.058.557-.062c0,.014.02.014.02.023a.034.034,0,0,1-.01.019l.043,0a.254.254,0,0,0,.052.01.3.3,0,0,0,.043,0,.073.073,0,0,1-.029.049c.019,0,.038,0,.038.019s0,.062-.019.072a.088.088,0,0,1-.058,0,.239.239,0,0,0,.029.1.219.219,0,0,0,.23.13s.058.14-.186.45c-.033.043-.068.1-.11.149a.56.56,0,0,0-.038.114.97.97,0,0,0,.532-.522,2.74,2.74,0,0,0,.12-1.059.547.547,0,0,0-.043-.212.183.183,0,0,0-.287-.033,3.51,3.51,0,0,1-.476.495,1.62,1.62,0,0,1-.408.264h0Z",
    transform: "translate(-552.363 -524.863)",
    fill: "#d7bc6b",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M508.9,634.125a.359.359,0,0,0-.124.23.753.753,0,0,0,.085.485.489.489,0,0,0,.375.277.408.408,0,0,0,.159-.033,1.006,1.006,0,0,0,.215-.134c.1-.072.173-.134.163-.14s-.586-.475-.586-.475l-.212-.236-.076.026Z",
    transform: "translate(-502.36 -626.088)",
    fill: "#585136",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M544.375,653.477a.49.49,0,0,0,.182-.052c.068-.043-.4-.5-.4-.5l.033.5Z",
    transform: "translate(-537.299 -644.667)",
    fill: "#453a25",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M517.66,613.26a.671.671,0,0,0-.058.14,2.451,2.451,0,0,0,.043.489.354.354,0,0,0,.313.254.443.443,0,0,0,.241-.078c0-.019-.144-.038-.182-.111a.653.653,0,0,1-.038-.23c0-.062,0-.13.019-.154a.5.5,0,0,0,.062-.225l.186-.346H518l-.293.182Z",
    transform: "translate(-511.078 -605.258)",
    fill: "#84754b",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M516.69,596.584a1.062,1.062,0,0,1,.365-.312.374.374,0,0,1,.25-.023l-.1.258-.144.159.01.081a.5.5,0,0,0,.12.365.376.376,0,0,0,.312.144.407.407,0,0,0,.332-.268.753.753,0,0,0-.014-.72.586.586,0,0,0-.495-.268.692.692,0,0,0-.636.584h0Z",
    transform: "translate(-510.18 -588.475)",
    fill: "#252211",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M899.493,675.169c-.072-.033,0-.235.068-.3a.506.506,0,0,1,.322-.144c.058,0,.114.033.1.072a.576.576,0,0,1-.206.245C899.656,675.144,899.575,675.206,899.493,675.169Z",
    transform: "translate(-888.056 -666.197)",
    fill: "#f7f7e7",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M588.864,623.161a.139.139,0,0,1,.134.1c.014.062-.033.186-.134.186-.081,0-.124-.1-.124-.13a.148.148,0,0,1,.019-.068A.111.111,0,0,1,588.864,623.161Z",
    transform: "translate(-581.308 -615.289)",
    fill: "#f8f6de",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M520.538,626.67a.451.451,0,0,0-.2.192.509.509,0,0,0-.038.307.753.753,0,0,0,.091.211.146.146,0,0,0,.111.068.2.2,0,0,0,.1-.144,1.023,1.023,0,0,1,.068-.394c.056-.12-.136-.241-.136-.241h0Z",
    transform: "translate(-513.739 -618.753)",
    fill: "#d4c38b",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M536.647,614.219c-.023.014-.062.033-.052.058s.091.038.12.1a.2.2,0,0,1,.023.149.235.235,0,0,0,.068-.049c.043-.048.095-.114.14-.114.029,0,.058.014.085.014.043,0,.085-.014.091-.058s-.081-.111-.134-.1a.127.127,0,0,0-.019-.134c-.043-.039-.177.029-.206.049s-.116.091-.116.091h0Z",
    transform: "translate(-529.828 -606.312)",
    fill: "#e2d59d",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M683.919,938.085l.287-.085.081.058s.058.124.149.14c-.029.062-.1.115-.1.159a.135.135,0,0,0,.043.078.668.668,0,0,0,.25.857c-.12.048-.274.115-.355.153a.63.63,0,0,1,.235.086c.052.047.052.062.1.091s.078.068.068.085c-.033-.019-.144-.078-.163-.023s-.479.033-.479.033l-.776.149a.14.14,0,0,0-.052-.149c-.095-.085-.211,0-.336-.091-.163-.124-.169-.268-.221-.322a1.027,1.027,0,0,1,.413-.115.171.171,0,0,1-.023-.13c.023-.068.12-.111.091-.192.043-.01.062-.01.169-.144s.163-.163.241-.173a.354.354,0,0,0,.268-.134c.1-.1.068-.177.068-.177s.066-.021.043-.155h0Z",
    transform: "translate(-674.017 -926.101)",
    fill: "#cbac5a",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M715.084,940.552c0-.019.019-.029.124-.019s.768-.062.949-.072a5.95,5.95,0,0,1,1.137.062c.313.066.629.144.782.182s.2.058.2.078a.056.056,0,0,1-.058.033c-.019,0-.528-.159-.685-.192a6.2,6.2,0,0,0-1-.115,5.218,5.218,0,0,0-.623.023,5.014,5.014,0,0,1-.739.053c-.115-.014-.091-.014-.086-.033h0Z",
    transform: "translate(-706.029 -928.524)",
    fill: "#d6bc6f",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M453.113,1064.363a1.579,1.579,0,0,1,.542.479.208.208,0,0,1-.062.293s.225,0,.2.124a1.874,1.874,0,0,1-.638.4,1.034,1.034,0,0,1-.369.124c-.12.019-.45-.038-.518.058a.189.189,0,0,0-.019.212,1.111,1.111,0,0,0,.177.033s-.033.091-.359.1-.408.033-.427.068.062.014.212.038.359.038.359.038a.66.66,0,0,1-.244.1,4.08,4.08,0,0,0-.613.159.568.568,0,0,0,.154.085.957.957,0,0,0-.215.078c.029.019.068.043.068.043a1.338,1.338,0,0,1-.258.245,2.109,2.109,0,0,1-.831.254c-.47-.124-.528-.639-.642-.677-.173-.058-.254.058-.408-.023a.969.969,0,0,1,.177-.11c-.078-.038-.479-.293-.479-.293a2.983,2.983,0,0,0-.14-.268c-.078-.134-.192-.312-.278-.47a3.831,3.831,0,0,0-.365-.7c.029-.038.13-.033.13-.033l1.415.466,2.509.073.652-.931.277.033Z",
    transform: "translate(-442.497 -1050.815)",
    fill: "#dfc677",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M547.18,1120.889a.218.218,0,0,0,.052.043.758.758,0,0,1,.169.13c.019-.029.068-.082.154,0s.192.023.258.043.072.033.072.033a.492.492,0,0,1,.124-.068c.052-.019.115-.033.182-.052a1.025,1.025,0,0,1,.177-.033c.043.029.2.192.811-.048.58-.225.714-.25.811-.215.01-.023.019-.068.169-.062a1.157,1.157,0,0,0-.124-.274l-.685-.235h-.375l-1.123.206-.623.355-.048.179Z",
    transform: "translate(-540.28 -1105.921)",
    fill: "#c4a859",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M517.9,1077.078a.363.363,0,0,0,.169.215.971.971,0,0,1,.2.176s.029-.038.052-.077.043-.091.082-.1c.078-.033.254.029.293.019s.023-.078.058-.078c.081,0,.134.052.163.052s.1,0,.111-.019.013-.177.124-.254a.331.331,0,0,1,.307-.029c0,.029,0,.1.082.1a.4.4,0,0,1,.153.014c.068.023.149,0,.186.111.033-.01.111-.019.091-.13a.566.566,0,0,0,.153-.163c.02-.029.052-.062.078-.1a.316.316,0,0,1,.258.081c-.033.023-.053.038-.062.062a.686.686,0,0,1,.078.091c.029.038.049.085.085.1a3.241,3.241,0,0,0,.365,0,.732.732,0,0,1,.316.095c.019-.01.019-.014.068,0s.085.014.033-.048c.029.014.062.043.091.014a.191.191,0,0,1,.134-.082c.082-.01.111,0,.144-.081.043-.1-.1-.1-.1-.1s.068-.062.144-.144a.655.655,0,0,0,.221-.332.234.234,0,0,0-.2-.283l-1.186.365-1.45-.072-1.236.615h0Z",
    transform: "translate(-511.374 -1062.503)",
    fill: "#927d49",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M412.719,849.278a.417.417,0,0,0-.062.163c-.024.115-.014.1-.033.182a3.4,3.4,0,0,0-.169,1.166c.09.274.245.375.342.6a.86.86,0,0,1,.048.12c.033.144,0,.254.043.4a.44.44,0,0,0,.1.163c.115.12.3.235.384.316.114.12.277.365.485.388a.7.7,0,0,0,.4-.111,3.343,3.343,0,0,1,.307-.23,1.156,1.156,0,0,1,.258-.078,1.17,1.17,0,0,1,.413-.019,3.983,3.983,0,0,0,.652.13,1.775,1.775,0,0,0,.423-.058c.277-.082.613-.221.834-.283.13-.038.235-.048.341-.072a.735.735,0,0,0,.423-.212c-.058-.068-.13-.173-.518-.169a6.851,6.851,0,0,0-1.2.293,1.008,1.008,0,0,1-.638-.029c-.274-.1-.283-.169-.283-.169a1.227,1.227,0,0,1-.408-.714,1.278,1.278,0,0,1,.313-1.242.205.205,0,0,0,.062-.173.782.782,0,0,0,.149-.537c-.062-.258-.46-.206-.46-.206l-2.206.386h0Z",
    transform: "translate(-407.259 -838.128)",
    fill: "#6e6342",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M458.743,946.91a.2.2,0,0,0-.023.1c0,.052.019.12.177.274a.335.335,0,0,1,.1.283.489.489,0,0,0,.25-.072c.144-.068.192.052.192.052a.405.405,0,0,1,.134-.043.3.3,0,0,0,.12-.038,1.734,1.734,0,0,0,.316.254c.134.072.212.12.278.072a.184.184,0,0,0,.058-.169.5.5,0,0,0-.058-.1c-.043-.062-.111-.134-.115-.192-.01-.134.1-.293.077-.332s-.11-.049-.326.029a4.851,4.851,0,0,1-1.186-.122h0Z",
    transform: "translate(-452.951 -934.897)",
    fill: "#39331f",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M494.126,967.388s-.11-.1-.072-.613a.639.639,0,0,1,.14.014A1.1,1.1,0,0,1,494.126,967.388Z",
    transform: "translate(-487.825 -954.507)",
    fill: "#292311",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M432.2,810.084a.311.311,0,0,0,.043-.038.963.963,0,0,0-.072.811,1.075,1.075,0,0,0,.949.8,1.087,1.087,0,0,0,.945-.528c.1-.13.225-.293.332-.4.159-.173.283-.221.283-.388,0-.342-.349-.495-.864-.648a1.961,1.961,0,0,0-1.219-.029.667.667,0,0,0-.4.423h0Z",
    transform: "translate(-426.689 -799.323)",
    fill: "#252211",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M567.78,1013.663l.038-.019s.01-.154.072-.149a.12.12,0,0,1,.085.12.072.072,0,0,1-.082.072.191.191,0,0,1-.114-.023Z",
    transform: "translate(-560.616 -1000.629)",
    fill: "#3f3824",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M554.31,975.588s.038-.014.085.033a.7.7,0,0,1,.258.014.2.2,0,0,1,.068.062.673.673,0,0,1-.3,0C554.31,975.66,554.31,975.588,554.31,975.588Z",
    transform: "translate(-547.319 -963.206)",
    fill: "#2d2815",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M596.227,968.108a.481.481,0,0,0-.215-.1c-.019,0-.023.01-.038.01s-.014-.033-.014-.033l-.063.033s-.01.014.023.038.078.043.091.081a.334.334,0,0,0,.019.058.207.207,0,0,0,.1-.019c.033-.019.1-.051.091-.064h0Z",
    transform: "translate(-588.372 -955.697)",
    fill: "#82764f",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M545.21,997.98a.163.163,0,0,1,.149-.14.15.15,0,0,1,.159.12l-.078.078s-.058-.083-.23-.058Z",
    transform: "translate(-538.335 -985.174)",
    fill: "#2d2816",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M591.654,956.9a.406.406,0,0,1-.231.1.092.092,0,0,1,0-.12c.043-.062.091-.082.14-.062A.113.113,0,0,1,591.654,956.9Z",
    transform: "translate(-583.935 -944.67)",
    fill: "#574f35",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M631.563,952.759c0-.019-.01-.023,0-.033s.062-.029.072-.019,0,.019,0,.038a.093.093,0,0,1-.01.052.078.078,0,0,1-.072.023c-.019-.006-.023-.033-.023-.038S631.563,952.768,631.563,952.759Zm.331-.209c0-.01.033-.029.052-.029s.029.023.033.029.01,0,.019.014.023.049.014.068a.071.071,0,0,1-.058.029A.515.515,0,0,1,631.894,952.549Z",
    transform: "translate(-623.551 -940.435)",
    fill: "#82764f",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M607.86,974.66a.27.27,0,0,1,.1.058.544.544,0,0,1-.049.029.145.145,0,0,0-.052-.087Z",
    transform: "translate(-600.184 -962.292)",
    fill: "#6e6342",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M600.312,896.622c-.01-.01.029-.033.052-.029s.033.02.058.023.029-.01.038-.02.043,0,.048,0l.01.014a.054.054,0,0,1,.019-.038.062.062,0,0,1,.052-.01.287.287,0,0,1,.019.072c0,.01-.062.023-.072.014a.69.69,0,0,0,.058.082c.006.01-.043.033-.062.029a.793.793,0,0,1-.223-.136Zm.254-.322a.045.045,0,0,0-.02-.023c-.013,0-.058,0-.058.023a.721.721,0,0,0,.082.221c.048.068.081.124.114.14a.045.045,0,0,0,.058-.019,1.181,1.181,0,0,0,.01-.25,2.3,2.3,0,0,0-.02-.342.052.052,0,0,0-.062.01,1.82,1.82,0,0,0-.1.241h0Z",
    transform: "translate(-592.73 -884.681)",
    fill: "#585136",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M591.969,991.947a.157.157,0,0,0-.134-.014c-.062.029-.058.144-.058.144a.092.092,0,0,0,.085-.01.261.261,0,0,0,.107-.12Z",
    transform: "translate(-584.306 -979.334)",
    fill: "#574f35",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M613.848,940.239c0-.038-.038-.038-.038-.058a.043.043,0,0,1,.042-.033c.019,0,.038.023.062.038s.058.038.062.068-.038.11-.085.11-.033-.087-.043-.126Zm.375-.052s-.078.023-.072,0,.023-.029.048-.029a.077.077,0,0,1,.049-.023.041.041,0,0,1,.029.01s.052-.023.068-.01,0,.014.014.029a.139.139,0,0,1,.023.058c0,.016-.058.049-.1.043S614.232,940.2,614.223,940.187Zm.452-.087s.023.014,0,.029a.317.317,0,0,1-.14.043c-.058,0-.11.01-.11-.01s.049-.058.078-.068a.062.062,0,0,1,.049-.023c.023,0,.114-.01.14-.014s.043.01.029.029S614.675,940.1,614.675,940.1Zm.134-.6s-.029.062-.062.062-.033-.014-.033-.023.033-.048.029-.058-.033,0-.029-.023.033-.043.062-.038a.128.128,0,0,1,.078-.029c.033,0,.062.01.062.029s-.038.062-.052.072-.035.026-.054.01Zm-.442,1.147s-.038,0-.038.023.01.01.023,0l.023,0s0,.023.033.023a.184.184,0,0,0,.068-.023c.023-.01.043-.019.043-.038a.058.058,0,0,0-.058-.049.079.079,0,0,0-.043.01s-.01-.019-.043,0-.029.02-.019.029.012.026.012.026Zm-.219.2c0-.01.048-.029.062-.023a.249.249,0,0,1,.052.085c0,.01-.048.033-.068.033a.09.09,0,0,1-.052-.038s.023-.01.023-.014-.017-.033-.017-.043Zm-.154-.283c.01,0,.01-.014.023-.023a.033.033,0,0,1,.029,0,.047.047,0,0,1,.033-.023c.023,0,.043,0,.038.01,0,.029.019.048.019.072s-.014.052-.062.072a.341.341,0,0,1-.124.01.064.064,0,0,1-.01-.062.161.161,0,0,1,.053-.05h0Z",
    transform: "translate(-606.058 -927.473)",
    fill: "#82764f",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M630.152,1032.31s-.033.019-.033.029a.089.089,0,0,0,0,.029c0,.006.043,0,.049-.01S630.152,1032.32,630.152,1032.31Z",
    transform: "translate(-622.154 -1019.204)",
    fill: "#6e6342",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M603.83,1024.4a.418.418,0,0,1,.078.01c.019.01.033.029.014.052s-.038.058-.081.052-.1-.029-.1-.049a.093.093,0,0,1,.023-.068c.019-.016.029-.006.062,0h0Z",
    transform: "translate(-596.12 -1011.382)",
    fill: "#585136",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M587.617,1026.7a.548.548,0,0,0-.078.072c-.02.023-.115.143-.144.169a.353.353,0,0,1,.033-.049.2.2,0,0,0-.081.1c-.023.072.13.111.231.14s.14.038.14.038a1.079,1.079,0,0,1-.1-.177c-.038-.091-.058-.1-.033-.144s.049-.072.049-.1S587.617,1026.7,587.617,1026.7Z",
    transform: "translate(-579.931 -1013.666)",
    fill: "#574f35",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M435.66,1031.16a.114.114,0,0,0,.043,0,1.979,1.979,0,0,1,.648-.1,3.465,3.465,0,0,1,.7.115c.4.1.893.312,1.213.431.085.033.169.091.23.114a1.462,1.462,0,0,0,.4.12,1.553,1.553,0,0,0,.522-.072c.221-.049.6-.072.931-.12a1.909,1.909,0,0,0,.316-.072,1.666,1.666,0,0,1-.9.359,2.8,2.8,0,0,1-.772.01,2.344,2.344,0,0,1-.437-.078c-.115-.033-.349-.12-.638-.192-.2-.053-.427-.091-.685-.14a8.1,8.1,0,0,1-1.573-.38Z",
    transform: "translate(-430.187 -1017.973)",
    fill: "#252211",
    fillRule: "evenodd"
  }), React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: "1.617",
    y1: "1.51",
    transform: "translate(3.527 9.217)",
    fill: "none"
  }), React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M230.229,944.94c-.154.13-.316.254-.475.375l-.479.368c-.163.12-.322.244-.485.365s-.326.235-.5.345c.153-.13.316-.25.479-.369s.332-.234.489-.354l.479-.369c.165-.12.324-.244.491-.361Zm-.848,1.358s.173-.144.388-.345a8.305,8.305,0,0,1,.7-.629l-1.089.974Z",
    transform: "translate(-225.469 -932.952)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M313.56,975.638c.085-.085.177-.169.268-.25l.14-.12c.043-.038.091-.081.134-.124.085-.085.169-.177.254-.264a1.632,1.632,0,0,1,.134-.124.362.362,0,0,1,.078-.052.226.226,0,0,1,.081-.043c-.019.029-.043.043-.062.068s-.043.043-.062.062c-.043.043-.091.082-.134.12-.091.078-.186.154-.277.235s-.176.169-.268.25-.19.165-.285.243Zm1.16-.776s-.633.619-.763.72Z",
    transform: "translate(-309.648 -962.292)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M345.423,990.44a2.066,2.066,0,0,1-.183.186l-.192.182c-.062.062-.12.124-.186.186s-.13.115-.2.169l.186-.182c.062-.062.13-.115.2-.177l.186-.182C345.293,990.558,345.355,990.5,345.423,990.44Zm.029.336a4.039,4.039,0,0,1-.206.475c-.163.326-.407.734-.514.941Z",
    transform: "translate(-340.35 -977.87)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M351.138,1016.69a.544.544,0,0,1-.043.2,1.946,1.946,0,0,1-.078.182c-.029.058-.062.12-.1.177s-.072.114-.1.173l-.2.345c-.068.115-.134.231-.206.342a3.169,3.169,0,0,1,.177-.355c.068-.115.13-.23.192-.349a1.963,1.963,0,0,0,.081-.182c.029-.062.058-.12.081-.177s.052-.12.081-.177a1.139,1.139,0,0,1,.1-.175Z",
    transform: "translate(-346.037 -1003.784)",
    fill: "#cfb66c",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M447.129,1141.08a.961.961,0,0,0-.173.576C447.008,1141.487,447.074,1141.229,447.129,1141.08Zm.182.255s-.068.691-.124,1.03A4.161,4.161,0,0,0,447.311,1141.335Zm1.271,1.071a7.31,7.31,0,0,0-.293,1.079c.062-.241.182-.734.293-1.08Z",
    transform: "translate(-441.337 -1126.583)",
    fill: "#dec270",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M626.67,1137s.466.768.815,1.424A3.234,3.234,0,0,0,626.67,1137Z",
    transform: "translate(-618.753 -1122.555)",
    fill: "#cbaf59",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M724.52,1225.43a14.12,14.12,0,0,1,.691,1.4A2.133,2.133,0,0,0,724.52,1225.43Z",
    transform: "translate(-715.352 -1209.854)",
    fill: "#e3c677",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M874.182,987.886c.078-.048.231-.312.365-.378a.917.917,0,0,0,.355-.215.855.855,0,0,1,.417-.336c.369-.159.115-.365.115-.365a1.2,1.2,0,0,1,.13-.111.368.368,0,0,0,.2-.312,1.36,1.36,0,0,0-.274-.85c.206-.043.6-.072.844-.134a1.207,1.207,0,0,0,.413-.173.471.471,0,0,1,.1-.557,3.245,3.245,0,0,0,.638-.759,1.864,1.864,0,0,0-1.17.149.894.894,0,0,1,.111.062,2.193,2.193,0,0,0-.6.254c-.278.235-.312.427-.613.571s-.6.1-.854.221a2.259,2.259,0,0,0-.378.258c.019.023,0,.062.033.1-.023.033-.159.254-.3.254.014.053.13.091.13.091a.627.627,0,0,1-.3.078,2.206,2.206,0,0,0,.5.423c-.023.048-.12.12-.081.212s.153.215.6.316a3.908,3.908,0,0,1-.844.014,1.4,1.4,0,0,0-.633-.014c.023.023.085.023.14.085-.058,0-.423-.043-.547.12a1.059,1.059,0,0,0-.177.633.165.165,0,0,0-.1.212c.033.12.206.159.316.235s.12.11.225.091.274-.134.369-.134a.248.248,0,0,1,.163.072s.258-.124.283-.1,0,.173.029.2a1.866,1.866,0,0,0,.394-.2Z",
    transform: "translate(-861.335 -971.177)",
    fill: "#ecd592",
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M468,420.432a6.105,6.105,0,0,0-4.211-3.712H455.24l.033,3.19h1.7v7.124H455.24v3.184h8.317c2,0,3.611-2.014,3.611-2.014a8.608,8.608,0,0,0,.836-7.772Zm-4.4,5.625s-.652.941-1.362.941h-1.42l-.034-7.081h1.822s.844.177,1.434,1.847A5.57,5.57,0,0,1,463.6,426.058Z",
    transform: "translate(-449.516 -411.489)",
    fill: "rgba(255,255,255,0.8)",
    fillRule: "evenodd"
  })))));
};

/* eslint-disable linebreak-style */

var ethIcon = function ethIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 39.1",
    style: style
  }, React.createElement("title", null, "eth icon"), React.createElement("g", {
    id: "12"
  }, React.createElement("g", {
    id: "Group_1522",
    "data-name": "Group 1522"
  }, React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M383.762,0,383.5.891V26.756l.262.262,12.006-7.1Z",
    transform: "translate(-371.776)",
    // fill={fill || '#343434'}
    fill: fill,
    fillOpacity: "0.8"
  }), React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M12.006,0,0,19.921l12.006,7.1V0Z",
    // fill={fill || '#8c8c8c'}
    fill: fill,
    fillOpacity: "0.4"
  }), React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M387.388,731.983l-.148.18v9.214l.148.432L399.4,724.89Z",
    transform: "translate(-375.401 -702.709)",
    // fill={fill || '#3c3c3b'}
    fill: fill,
    fillOpacity: "0.8"
  }), React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M12.006,741.809v-9.826L0,724.89Z",
    transform: "translate(0 -702.709)",
    // fill={fill || '#8c8c8c'}
    fill: fill,
    fillOpacity: "0.4"
  }), React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M392.07,484.884l12.006-7.1L392.07,472.33Z",
    transform: "translate(-380.083 -457.875)",
    // fill={fill || '#141414'}
    fill: fill,
    fillOpacity: "0.8"
  }), React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M0,477.787l12.006,7.1V472.33Z",
    transform: "translate(0 -457.875)",
    // fill={fill || '#393939'}
    fill: fill,
    fillOpacity: "0.4"
  }))));
};

/* eslint-disable linebreak-style */

var filIcon = function filIcon(fill, size, style) {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    style: style
  }, React.createElement("title", null, "fil icon"), React.createElement("g", {
    id: "filecoin-fil-logo",
    transform: "translate(0 0.001)"
  }, React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M12,24a12,12,0,1,1,12-11.88A12.048,12.048,0,0,1,12,24",
    transform: "translate(0 0)",
    fill: fill || '#0090FF',
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M17.321,13.068l-.361,1.917,3.43.479-.241.9-3.37-.479c-.241.779-.361,1.618-.662,2.337-.3.839-.6,1.678-.963,2.456a3.246,3.246,0,0,1-2.467,1.917,2.42,2.42,0,0,1-1.926-.359A.8.8,0,0,1,10.4,21.7a.857.857,0,0,1,.3-.659,1.089,1.089,0,0,1,.6.06,2.661,2.661,0,0,1,.481.659.861.861,0,0,0,1.324.18,3.616,3.616,0,0,0,1.023-1.8c.361-1.438.722-2.816,1.023-4.254v-.24l-3.19-.479.12-.9,3.31.479.421-1.857-3.43-.539.12-.959,3.551.479c.12-.359.181-.659.3-.959A8.87,8.87,0,0,1,17.682,7.8,3.176,3.176,0,0,1,20.51,6.3a1.871,1.871,0,0,1,1.444.6.509.509,0,0,1,.181.3,1,1,0,0,1-.181.719.58.58,0,0,1-.782-.12c-.181-.18-.3-.359-.481-.539a.823.823,0,0,0-1.324-.12,3.837,3.837,0,0,0-.782,1.138c-.421,1.258-.722,2.576-1.143,3.894l3.31.479-.241.9-3.19-.479",
    transform: "translate(-4.178 -2.506)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};

/* eslint-disable linebreak-style */

var maticIcon = function maticIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "polygon-matic-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size / 1.13690194,
    viewBox: "0 0 24 21.11",
    style: style
  }, React.createElement("title", null, "matic icon"), React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M18.172,6.352a1.6,1.6,0,0,0-1.5,0L13.159,8.419,10.778,9.735,7.332,11.8a1.6,1.6,0,0,1-1.5,0L3.133,10.173a1.527,1.527,0,0,1-.752-1.315V5.726A1.545,1.545,0,0,1,3.133,4.41L5.828,2.844a1.6,1.6,0,0,1,1.5,0l2.695,1.629a1.527,1.527,0,0,1,.752,1.315V7.855l2.381-1.378V4.348a1.545,1.545,0,0,0-.752-1.315L7.394.088a1.6,1.6,0,0,0-1.5,0L.752,3.095A1.378,1.378,0,0,0,0,4.348v5.888a1.545,1.545,0,0,0,.752,1.315L5.828,14.5a1.6,1.6,0,0,0,1.5,0l3.446-2,2.381-1.378,3.446-2a1.6,1.6,0,0,1,1.5,0L20.8,10.674a1.527,1.527,0,0,1,.752,1.315v3.132a1.545,1.545,0,0,1-.752,1.315L18.172,18a1.6,1.6,0,0,1-1.5,0l-2.695-1.566a1.527,1.527,0,0,1-.752-1.315v-2L10.841,14.5v2.067a1.545,1.545,0,0,0,.752,1.315l5.076,2.944a1.6,1.6,0,0,0,1.5,0l5.076-2.944A1.527,1.527,0,0,0,24,16.562V10.612A1.545,1.545,0,0,0,23.248,9.3Z",
    transform: "translate(0 0.1)",
    fill: fill || '#8247E5'
  }));
};

/* eslint-disable linebreak-style */

var avaxIcon = function avaxIcon(fill, size, style) {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    style: style
  }, React.createElement("title", null, "avax icon"), React.createElement("g", {
    id: "avalanche-avax-logo",
    transform: "translate(-0.5 54.497)"
  }, React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    height: "24",
    transform: "translate(24.5 -54.497)",
    fill: "#fff"
  }), React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M24.5,13a12,12,0,1,1-12-12A12,12,0,0,1,24.5,13ZM9.1,17.775H6.771a1.87,1.87,0,0,1-.878-.094.592.592,0,0,1-.268-.463c-.009-.174.112-.386.354-.811l5.75-10.136c.245-.43.368-.646.525-.725a.593.593,0,0,1,.537,0c.156.08.28.295.525.725L14.5,8.335l.006.011a3.871,3.871,0,0,1,.457.942,1.751,1.751,0,0,1,0,.82,3.885,3.885,0,0,1-.46.952L11.479,16.4l-.008.014a3.83,3.83,0,0,1-.588.879,1.758,1.758,0,0,1-.716.416A4.214,4.214,0,0,1,9.1,17.775Zm5.881,0h3.337a1.856,1.856,0,0,0,.887-.1.59.59,0,0,0,.268-.466c.008-.168-.11-.372-.341-.772l-.024-.042-1.672-2.859-.019-.032c-.235-.4-.353-.6-.506-.675a.587.587,0,0,0-.534,0c-.153.08-.277.289-.522.71L14.191,16.4l-.006.01c-.244.421-.366.631-.357.8a.6.6,0,0,0,.268.466A1.886,1.886,0,0,0,14.981,17.775Z",
    transform: "translate(0 -55.497)",
    fill: fill || '#E84142',
    fillRule: "evenodd"
  })));
};

/* eslint-disable linebreak-style */

var uniIcon = function uniIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "uniswap-uni-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size * 1.1517916,
    viewBox: "0 0 24 27.643",
    style: style
  }, React.createElement("title", null, "uni icon"), React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M64.444,43.585c-.3-.043-.314-.057-.171-.071a4.7,4.7,0,0,1,1.34.114,5.762,5.762,0,0,1,2.937,1.967l.257.3.371-.057a7.949,7.949,0,0,1,4.562.57,5.909,5.909,0,0,1,1.026.6,1.378,1.378,0,0,1,.1.4,2.417,2.417,0,0,1-.157,1.554.417.417,0,0,0-.043.456.429.429,0,0,0,.385.242c.342,0,.7-.542.87-1.3l.071-.3.128.143A5.614,5.614,0,0,1,77.5,50.941l.029.214L77.4,50.97a2.407,2.407,0,0,0-.684-.727,4.282,4.282,0,0,0-2.352-.5,9.638,9.638,0,0,1-2.609-.4c-1.169-.385-1.768-.884-3.151-2.723A13.1,13.1,0,0,0,67.224,45,4.836,4.836,0,0,0,64.444,43.585Z",
    transform: "translate(-55.034 -37.298)",
    fill: fill || '#FF007A'
  }), React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M128.92,47.968a3.083,3.083,0,0,1,.257-1.226.982.982,0,0,1,.128-.242c.014,0-.014.1-.057.214a2.723,2.723,0,0,0-.057,1.255c.1.642.143.727.827,1.426.314.328.684.741.827.912l.242.314-.242-.228a8.677,8.677,0,0,0-1.14-.9c-.1-.057-.114-.057-.185.014s-.071.143-.071.556a3.054,3.054,0,0,1-.314,1.454c-.114.214-.128.171-.029-.071a2.077,2.077,0,0,0,.086-.884c0-1.24-.143-1.54-1.012-2.039-.214-.128-.585-.314-.8-.413a3.158,3.158,0,0,1-.385-.185,6.37,6.37,0,0,1,1.2.356c.5.2.585.214.642.2C128.877,48.439,128.905,48.325,128.92,47.968Z",
    transform: "translate(-108.889 -39.871)",
    fill: fill || '#FF007A'
  }), React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M64.627,51.464a5.037,5.037,0,0,1-.9-3.065l.029-.3.143.029a3.345,3.345,0,0,1,.912.342c.57.342.827.813,1.069,1.982.071.342.171.741.214.87a5.146,5.146,0,0,0,.57,1.026c.157.228.057.342-.3.314A2.921,2.921,0,0,1,64.627,51.464Z",
    transform: "translate(-54.633 -41.243)",
    fill: fill || '#FF007A'
  }), React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M112.421,89.734c-2.823-1.141-3.821-2.124-3.821-3.792,0-.242.014-.442.014-.442a2.676,2.676,0,0,1,.242.185c.57.456,1.212.656,2.994.912a12.42,12.42,0,0,1,2.181.456,4.165,4.165,0,0,1,3.051,3.322A5.766,5.766,0,0,1,117,92.158a3.574,3.574,0,0,1-.456,1.026c-.014,0-.043-.071-.043-.185a2.32,2.32,0,0,0-.827-1.611A11.392,11.392,0,0,0,112.421,89.734Z",
    transform: "translate(-93.117 -73.311)",
    fill: fill || '#FF007A'
  }), React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M84.951,113.613a3.377,3.377,0,0,0-.143-.6l-.071-.214.128.157a2.51,2.51,0,0,1,.456.827,1.78,1.78,0,0,1,.1.8,1.819,1.819,0,0,1-.1.77,2.58,2.58,0,0,1-.6.955,3.431,3.431,0,0,1-2.138.941c-.171.014-.656.057-1.083.086a8.362,8.362,0,0,0-2.424.4c-.086.029-.171.057-.185.043a3.229,3.229,0,0,1,.77-.456,7.759,7.759,0,0,1,2.138-.57,9.766,9.766,0,0,0,1.269-.257A2.465,2.465,0,0,0,84.951,113.613Z",
    transform: "translate(-67.643 -96.719)",
    fill: fill || '#FF007A'
  }), React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M128.326,119.852a3.327,3.327,0,0,1-.257-2.309c.029-.071.057-.143.086-.143a.613.613,0,0,1,.2.1c.171.114.527.314,1.44.813a7.281,7.281,0,0,1,2.267,1.668,3.526,3.526,0,0,1,.756,1.725,5.655,5.655,0,0,1-.071,1.7,4.2,4.2,0,0,1-2.067,2.737,1.981,1.981,0,0,1-.3.143,1.134,1.134,0,0,1,.128-.314,2.83,2.83,0,0,0,.128-2.21,9.077,9.077,0,0,0-1.141-2.053A13.544,13.544,0,0,1,128.326,119.852Z",
    transform: "translate(-109.722 -100.663)",
    fill: fill || '#FF007A'
  }), React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M54.2,154.617a7.75,7.75,0,0,1,3.55-1.711,5.282,5.282,0,0,1,1.839.071,3.175,3.175,0,0,1,1.8,1.155,4.257,4.257,0,0,1,.656,1.939c.057.385.128.784.143.87a1.913,1.913,0,0,0,.627,1.126,2.169,2.169,0,0,0,1.967.057.956.956,0,0,1,.242-.071,2.185,2.185,0,0,1-.613.413,2.018,2.018,0,0,1-1.026.242,2.058,2.058,0,0,1-1.739-1.069,8.012,8.012,0,0,1-.47-.941,3.428,3.428,0,0,0-1.34-1.882,1.757,1.757,0,0,0-1.668-.157,1.074,1.074,0,0,0-.371,1.668,1.458,1.458,0,0,0,.813.428.87.87,0,0,0,.984-.87.683.683,0,0,0-.47-.7c-.456-.2-.955.029-.941.47a.392.392,0,0,0,.271.385c.114.057.114.057.029.043a.529.529,0,0,1-.185-.927,1.026,1.026,0,0,1,1.525.328,1.494,1.494,0,0,1,.029.969,1.333,1.333,0,0,1-1.625.77,2.325,2.325,0,0,1-1.24-.841,3.788,3.788,0,0,0-2.808-1.44L53.9,154.9Z",
    transform: "translate(-46.215 -131.066)",
    fill: fill || '#FF007A'
  }), React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M.481.613C3.8,4.647,8.921,10.92,9.177,11.262c.214.285.128.556-.228.756a2.181,2.181,0,0,1-.813.228,1.029,1.029,0,0,1-.684-.3c-.128-.128-.684-.941-1.939-2.894C4.558,7.556,3.746,6.315,3.731,6.3c-.057-.029-.057-.029,1.682,3.079a24.954,24.954,0,0,1,1.454,2.737c0,.185-.057.285-.285.542A3.172,3.172,0,0,0,5.9,14.584a5.965,5.965,0,0,1-1.625,3.279,5.867,5.867,0,0,0-.9,1.269,2.411,2.411,0,0,0-.285,1.14,3.567,3.567,0,0,0,.185,1.4,4.762,4.762,0,0,0,.684,1.34,3.317,3.317,0,0,1,.527,1.041c0,.114.029.114.542,0a5.639,5.639,0,0,0,2.794-1.369A1.29,1.29,0,0,0,8.25,21.6a1.163,1.163,0,0,0-.1-.6,2.559,2.559,0,0,0-1-.969A2.253,2.253,0,0,1,5.969,18.5a2.683,2.683,0,0,1,.442-1.711,5.113,5.113,0,0,0,.627-2.252c.043-.6.114-.841.285-1.026a1.063,1.063,0,0,1,.784-.328,2.613,2.613,0,0,0,1.568-.642,1.34,1.34,0,0,0,.485-1.041l.014-.328-.185-.2C9.32,10.207.039,0,0,0-.018,0,.21.271.481.613ZM4.858,20.885a.589.589,0,0,0-.185-.784c-.242-.157-.613-.086-.613.128a.146.146,0,0,0,.114.143c.128.071.143.143.043.3s-.1.3.029.4A.408.408,0,0,0,4.858,20.885Z",
    transform: "translate(0.004)",
    fill: fill || '#FF007A',
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M69.8,93.69a1.266,1.266,0,0,0-.77.841,1.228,1.228,0,0,0,.071.77c.157.2.3.257.7.257.784,0,1.454-.342,1.525-.756a1.1,1.1,0,0,0-.642-1.026A1.449,1.449,0,0,0,69.8,93.69Zm.912.713a.321.321,0,0,0-.143-.485c-.385-.242-.969-.043-.969.328,0,.185.3.385.585.385A.787.787,0,0,0,70.707,94.4Z",
    transform: "translate(-59.159 -80.304)",
    fill: fill || '#FF007A',
    fillRule: "evenodd"
  }));
};

/* eslint-disable linebreak-style */

var chainlinkIcon = function chainlinkIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size * 1.153916,
    viewBox: "0 0 24 27.694",
    style: style
  }, React.createElement("title", null, "chainlink icon"), React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M12,0,9.46,1.461l-6.921,4L0,6.923V20.77l2.54,1.461,6.984,4,2.54,1.461,2.54-1.461,6.857-4L24,20.77V6.923L21.46,5.463l-6.921-4ZM5.079,17.848v-8l6.921-4,6.921,4v8L12,21.85Z",
    fill: fill || '#2A5ADA'
  })));
};

/* eslint-disable linebreak-style */

var xrpIcon = function xrpIcon(fill, size, style) {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size / 1.230769230769231,
    viewBox: "0 0 24 19.8"
  }, React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    opacity: "0.7",
    style: style
  }, React.createElement("title", null, "xrp icon"), React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, React.createElement("path", {
    id: "Path_1",
    "data-name": "Path1",
    d: "M21.38,0h3.469L17.63,7.153a6.742,6.742,0,0,1-9.469,0L.94,0H4.412L9.9,5.434a4.268,4.268,0,0,0,6,0Z",
    transform: "translate(-0.896)",
    fill: fill || '#23292F'
  }), React.createElement("path", {
    id: "Path_2",
    "data-name": "Path2",
    d: "M3.471,238.327H0l7.266-7.2a6.742,6.742,0,0,1,9.469,0l7.266,7.2H20.531L15,232.849a4.268,4.268,0,0,0-6,0Z",
    transform: "translate(0 -218.527)",
    fill: fill || '#23292F'
  }))));
};

/* eslint-disable linebreak-style */

var adaIcon = function adaIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size / 1.08181,
    viewBox: "0 0 24 22.185"
  }, React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(0 0)",
    style: style
  }, React.createElement("title", null, "ada icon"), React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M102.761,149.629a1.617,1.617,0,0,0,1.524,1.7h.1a1.616,1.616,0,1,0-1.62-1.7Z",
    transform: "translate(-96.182 -138.617)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M.543,165.483a.523.523,0,1,0,.493.551.519.519,0,0,0-.493-.551Z",
    transform: "translate(0.008 -154.887)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M90.1,10.929a.524.524,0,0,0-.474-.935.524.524,0,0,0,.474.935Z",
    transform: "translate(-83.621 -9.302)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M109.737,47.8a.806.806,0,1,0-1.082-.359A.808.808,0,0,0,109.737,47.8Z",
    transform: "translate(-101.621 -43.306)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M36.179,82.942a.666.666,0,1,0-.192-.922h0A.663.663,0,0,0,36.179,82.942Z",
    transform: "translate(-33.579 -76.488)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M43.432,160.98a.808.808,0,1,0,.762.851h0A.808.808,0,0,0,43.432,160.98Z",
    transform: "translate(-39.852 -150.672)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M36.648,244.654a.667.667,0,1,0,.9.295h0a.67.67,0,0,0-.9-.295Z",
    transform: "translate(-33.959 -228.923)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M84.694,109.406a.948.948,0,1,0-.275-1.312.942.942,0,0,0,.275,1.312Z",
    transform: "translate(-78.869 -100.769)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M241.136,47.422a.809.809,0,1,0-.23-1.12h0a.8.8,0,0,0,.23,1.12Z",
    transform: "translate(-225.36 -42.997)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M268.862,10.516a.523.523,0,1,0-.154-.73.539.539,0,0,0,.154.73Z",
    transform: "translate(-251.435 -8.94)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M223.463,147.861a1.616,1.616,0,1,0-.179,3.227h.09a1.615,1.615,0,0,0,.09-3.227Z",
    transform: "translate(-207.566 -138.391)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M132.551,98.728a1.618,1.618,0,1,0,.717-2.177,1.62,1.62,0,0,0-.717,2.177Z",
    transform: "translate(-123.905 -90.206)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M318.8,82.419a.666.666,0,1,0-.9-.294.677.677,0,0,0,.9.294Z",
    transform: "translate(-297.487 -75.965)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M261.337,107.356a.949.949,0,1,0,1.274.423A.949.949,0,0,0,261.337,107.356Z",
    transform: "translate(-244.122 -100.389)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M177.314,1.318a.675.675,0,0,0,.7-.627.667.667,0,0,0-1.332-.083.677.677,0,0,0,.627.711Z",
    transform: "translate(-165.378 0.015)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M173.279,58.369a.949.949,0,1,0-.9-1,.943.943,0,0,0,.9,1Z",
    transform: "translate(-161.35 -52.856)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M85.888,211.411a.949.949,0,1,0-1.274-.423A.949.949,0,0,0,85.888,211.411Z",
    transform: "translate(-79.104 -196.193)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M192.146,97.13a1.616,1.616,0,1,0,1.351-.73A1.612,1.612,0,0,0,192.146,97.13Z",
    transform: "translate(-179.603 -90.228)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M195.139,200.368a1.616,1.616,0,1,0-.717,2.17h0a1.609,1.609,0,0,0,.723-2.157C195.145,200.375,195.145,200.375,195.139,200.368Z",
    transform: "translate(-179.785 -186.706)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M262.531,209.318a.948.948,0,1,0,.275,1.312.942.942,0,0,0-.275-1.312Z",
    transform: "translate(-244.355 -195.771)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M308.793,161.232a.808.808,0,1,0-.851.762h0A.813.813,0,0,0,308.793,161.232Z",
    transform: "translate(-287.521 -150.11)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M359.243,164.683a.523.523,0,1,0,.493.551A.527.527,0,0,0,359.243,164.683Z",
    transform: "translate(-335.736 -154.138)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M319.35,244.128a.666.666,0,1,0,.192.922.663.663,0,0,0-.192-.922Z",
    transform: "translate(-297.949 -228.397)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M90.762,320.639a.522.522,0,1,0,.147.723h0A.514.514,0,0,0,90.762,320.639Z",
    transform: "translate(-84.196 -300.03)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M269.625,320.255a.524.524,0,0,0,.474.935.524.524,0,0,0-.474-.935Z",
    transform: "translate(-252.102 -299.698)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M135.513,202.087a1.618,1.618,0,1,0-2.241.467,1.624,1.624,0,0,0,2.241-.467Z",
    transform: "translate(-124.056 -186.804)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M110.191,275.471a.809.809,0,1,0,.23,1.12h0A.8.8,0,0,0,110.191,275.471Z",
    transform: "translate(-101.967 -257.711)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M177.081,325.686a.667.667,0,1,0,.627.711.675.675,0,0,0-.627-.711Z",
    transform: "translate(-165.087 -304.834)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M172.873,260.374a.949.949,0,1,0,.9,1,.943.943,0,0,0-.9-1Z",
    transform: "translate(-160.873 -243.702)",
    fill: fill || '#0033AD'
  }), React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M241.746,275.114a.809.809,0,1,0,1.095.358.809.809,0,0,0-1.095-.358Z",
    transform: "translate(-225.862 -257.418)",
    fill: fill || '#0033AD'
  })));
};

/* eslint-disable linebreak-style */

var dappsIcon = function dappsIcon(fill, size, style) {
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_359_27721)",
    style: style
  }, React.createElement("path", {
    d: "M5.62538 12.5953C5.54545 12.6079 5.46415 12.6079 5.38422 12.5953L2.55464 11.5978C2.45223 11.5662 2.35688 11.5137 2.27416 11.4432C2.19144 11.3728 2.12301 11.2859 2.07286 11.1875C2.02272 11.0892 1.99187 10.9814 1.98212 10.8705C1.97237 10.7596 1.9839 10.6478 2.01605 10.5416L2.93245 7.59947C2.96553 7.49487 3.01806 7.3981 3.08702 7.31468C3.15599 7.23126 3.24004 7.16283 3.33438 7.1133C3.52367 7.01307 3.74329 6.99499 3.94532 7.06301L6.76686 8.01858C6.86783 8.05191 6.96148 8.10572 7.04244 8.17691C7.12341 8.2481 7.19008 8.33527 7.23863 8.43342C7.28719 8.53156 7.31666 8.63874 7.32537 8.7488C7.33408 8.85886 7.32184 8.96962 7.28937 9.07474L6.39708 12.0169C6.32589 12.2255 6.18255 12.3989 5.99516 12.5031C5.88074 12.5642 5.75394 12.5958 5.62538 12.5953ZM3.8167 10.265L5.11091 10.7009L5.53696 9.33459L4.24274 8.89871L3.8167 10.265Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M10.6093 6.81986C10.3961 6.81986 10.1916 6.73155 10.0409 6.57435C9.89011 6.41716 9.80542 6.20395 9.80542 5.98164V2.88022C9.80844 2.65912 9.89512 2.44822 10.0466 2.29346C10.195 2.13553 10.3972 2.04514 10.6093 2.04199H13.5755C13.7887 2.04199 13.9932 2.1303 14.1439 2.2875C14.2947 2.4447 14.3794 2.6579 14.3794 2.88022V5.98164C14.3794 6.20395 14.2947 6.41716 14.1439 6.57435C13.9932 6.73155 13.7887 6.81986 13.5755 6.81986H10.6093ZM11.4131 3.71844V5.14342H12.7717V3.71844H11.4131Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M18.3746 12.8638C18.1983 12.8728 18.024 12.8211 17.8788 12.7165C17.7335 12.612 17.6252 12.4605 17.5707 12.2855L16.6945 9.33491C16.6286 9.12371 16.6457 8.89386 16.7422 8.69584C16.8386 8.49781 17.0065 8.3478 17.209 8.27875L20.0305 7.31479C20.1313 7.28093 20.2376 7.26817 20.3431 7.27725C20.4487 7.28633 20.5514 7.31707 20.6456 7.3677C20.7397 7.41833 20.8233 7.48785 20.8916 7.57228C20.9598 7.6567 21.0114 7.75436 21.0434 7.85964L21.9598 10.8018C21.9959 10.9054 22.0103 11.0159 22.0019 11.1258C21.9936 11.2357 21.9628 11.3424 21.9116 11.4389C21.8641 11.5372 21.7984 11.6249 21.7184 11.6968C21.6384 11.7687 21.5456 11.8235 21.4453 11.858L18.6238 12.8135C18.5434 12.8425 18.4595 12.8594 18.3746 12.8638ZM18.471 9.61991L18.8971 11.0114L20.1913 10.5671L19.7733 9.22594L18.471 9.61991Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M16.0514 21.9996C15.9246 22 15.7995 21.969 15.6863 21.9093C15.5731 21.8496 15.4751 21.7627 15.4003 21.656L13.6559 19.1413C13.5392 18.9713 13.4876 18.7621 13.5112 18.5545C13.5451 18.3357 13.6607 18.1398 13.8328 18.0097L16.2443 16.1907C16.3279 16.1237 16.424 16.0757 16.5264 16.0497C16.6289 16.0237 16.7354 16.0203 16.8392 16.0399C17.049 16.0752 17.2369 16.1957 17.3617 16.3751L19.1061 18.8898C19.2166 19.0705 19.2565 19.2885 19.2176 19.499C19.1788 19.7095 19.064 19.8964 18.8971 20.0214L16.4855 21.8404C16.3588 21.9364 16.2079 21.9918 16.0514 21.9996ZM15.4324 18.8479L16.2363 19.9963L17.3376 19.158L16.5337 18.0097L15.4324 18.8479Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M7.64306 21.8405C7.47188 21.8387 7.30572 21.7799 7.16878 21.6728L4.75721 19.8539C4.58645 19.7231 4.47208 19.5274 4.43896 19.3092C4.40585 19.0911 4.45666 18.8681 4.58036 18.6887L6.32473 16.1741C6.39056 16.0861 6.47255 16.0128 6.56591 15.9583C6.65927 15.9038 6.76213 15.8693 6.86844 15.8568C6.97475 15.8443 7.08238 15.8541 7.18503 15.8855C7.28768 15.917 7.38327 15.9695 7.46621 16.04L9.87779 17.8589C10.0498 17.989 10.1654 18.1849 10.1993 18.4037C10.2163 18.5133 10.2123 18.6253 10.1874 18.7332C10.1626 18.8411 10.1175 18.9428 10.0546 19.0324L8.31026 21.5471C8.22881 21.647 8.12602 21.7256 8.01014 21.7765C7.89426 21.8275 7.76853 21.8494 7.64306 21.8405ZM6.36493 18.9905L7.46621 19.8287L8.27007 18.6804L7.16878 17.8421L6.36493 18.9905Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M5.62538 12.5953C5.54545 12.6079 5.46415 12.6079 5.38422 12.5953L2.55464 11.5978C2.45223 11.5662 2.35688 11.5137 2.27416 11.4432C2.19144 11.3728 2.12301 11.2859 2.07286 11.1875C2.02272 11.0892 1.99187 10.9814 1.98212 10.8705C1.97237 10.7596 1.9839 10.6478 2.01605 10.5416L2.93245 7.59947C2.96553 7.49487 3.01806 7.3981 3.08702 7.31468C3.15599 7.23126 3.24004 7.16283 3.33438 7.1133C3.52367 7.01307 3.74329 6.99499 3.94532 7.06301L6.76686 8.01858C6.86783 8.05191 6.96148 8.10572 7.04244 8.17691C7.12341 8.2481 7.19008 8.33527 7.23863 8.43342C7.28719 8.53156 7.31666 8.63874 7.32537 8.7488C7.33408 8.85886 7.32184 8.96962 7.28937 9.07474L6.39708 12.0169C6.32589 12.2255 6.18255 12.3989 5.99516 12.5031C5.88074 12.5642 5.75394 12.5958 5.62538 12.5953ZM3.8167 10.265L5.11091 10.7009L5.53696 9.33459L4.24274 8.89871L3.8167 10.265Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M8.22992 8.11039C8.10309 8.11073 7.97797 8.07977 7.8648 8.02004C7.75164 7.96031 7.65363 7.8735 7.5788 7.76671C7.5163 7.67764 7.47129 7.57656 7.44634 7.4693C7.4214 7.36203 7.41702 7.25069 7.43345 7.14165C7.44988 7.03262 7.4868 6.92804 7.54209 6.83392C7.59738 6.7398 7.66996 6.658 7.75565 6.5932L8.13346 6.3082C8.21889 6.24303 8.31582 6.1961 8.41868 6.17009C8.52155 6.14408 8.62833 6.13951 8.7329 6.15665C8.83746 6.17378 8.93775 6.21228 9.02801 6.26993C9.11827 6.32759 9.19672 6.40326 9.25886 6.49261C9.32136 6.58169 9.36638 6.68276 9.39132 6.79003C9.41626 6.89729 9.42064 7.00864 9.40421 7.11768C9.38778 7.22671 9.35086 7.33129 9.29557 7.42541C9.24028 7.51952 9.1677 7.60133 9.08201 7.66612L8.7042 7.95112C8.56627 8.05525 8.4002 8.11102 8.22992 8.11039Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M15.9148 8.21935C15.7473 8.21822 15.5843 8.16254 15.4486 8.06009L15.0547 7.76671C14.969 7.70192 14.8965 7.62011 14.8412 7.52599C14.7859 7.43188 14.749 7.3273 14.7325 7.21826C14.7161 7.10923 14.7205 6.99788 14.7454 6.89062C14.7704 6.78335 14.8154 6.68228 14.8779 6.5932C14.94 6.50385 15.0185 6.42817 15.1087 6.37052C15.199 6.31286 15.2993 6.27437 15.4038 6.25723C15.5084 6.2401 15.6152 6.24467 15.718 6.27067C15.8209 6.29668 15.9178 6.34362 16.0033 6.40879L16.3891 6.70217C16.5269 6.8062 16.6295 6.95313 16.6821 7.12182C16.7348 7.29051 16.7347 7.47226 16.682 7.64092C16.6293 7.80957 16.5266 7.95644 16.3887 8.06039C16.2509 8.16433 16.085 8.21999 15.9148 8.21935Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M5.76208 15.5713C5.59256 15.5711 5.42742 15.5151 5.29027 15.4112C5.15311 15.3074 5.05096 15.1609 4.99841 14.9929L4.79745 14.3642C4.76009 14.2584 4.74358 14.1459 4.7489 14.0333C4.75422 13.9207 4.78125 13.8104 4.82839 13.709C4.87553 13.6076 4.94181 13.5171 5.02326 13.443C5.1047 13.3689 5.19965 13.3126 5.30241 13.2777C5.40518 13.2427 5.51364 13.2297 5.62134 13.2395C5.72903 13.2492 5.83373 13.2815 5.92917 13.3344C6.02461 13.3874 6.10884 13.4598 6.17682 13.5474C6.24479 13.6351 6.29511 13.7361 6.32478 13.8445L6.52574 14.4816C6.59039 14.6884 6.57538 14.9134 6.48387 15.1089C6.39237 15.3044 6.23155 15.4552 6.03539 15.5293C5.94786 15.5621 5.85495 15.5764 5.76208 15.5713Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M12.2411 20.4323H11.373C11.1598 20.4323 10.9553 20.344 10.8045 20.1868C10.6538 20.0296 10.5691 19.8164 10.5691 19.5941C10.5691 19.3718 10.6538 19.1586 10.8045 19.0014C10.9553 18.8442 11.1598 18.7559 11.373 18.7559H12.2411C12.4543 18.7559 12.6588 18.8442 12.8095 19.0014C12.9603 19.1586 13.045 19.3718 13.045 19.5941C13.045 19.8164 12.9603 20.0296 12.8095 20.1868C12.6588 20.344 12.4543 20.4323 12.2411 20.4323Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M18.1495 15.8808C18.0668 15.8928 17.9829 15.8928 17.9003 15.8808C17.6978 15.8117 17.5299 15.6617 17.4335 15.4637C17.337 15.2657 17.3199 15.0358 17.3858 14.8246L17.5948 14.154C17.6667 13.9505 17.8114 13.784 17.9986 13.6894C18.1857 13.5948 18.4008 13.5795 18.5985 13.6468C18.7962 13.7141 18.9613 13.8587 19.0589 14.0502C19.1565 14.2417 19.1792 14.4652 19.1221 14.6737L18.9131 15.3443C18.8539 15.5045 18.7488 15.6419 18.6123 15.7378C18.4757 15.8338 18.3141 15.8837 18.1495 15.8808Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M12.0965 15.7136C11.4698 15.7152 10.8566 15.523 10.3347 15.1611C9.81282 14.7992 9.40562 14.284 9.16467 13.6807C8.92372 13.0773 8.85985 12.413 8.98115 11.7718C9.10244 11.1306 9.40346 10.5414 9.84608 10.0787C10.2887 9.61596 10.853 9.30059 11.4676 9.17247C12.0822 9.04436 12.7194 9.10927 13.2986 9.35899C13.8778 9.60871 14.373 10.032 14.7213 10.5753C15.0697 11.1186 15.2557 11.7574 15.2557 12.411C15.2557 13.2854 14.9231 14.1242 14.3309 14.7433C13.7386 15.3624 12.9351 15.7114 12.0965 15.7136ZM12.0965 10.7932C11.7874 10.7916 11.4848 10.8857 11.2271 11.0638C10.9694 11.2418 10.7683 11.4957 10.6493 11.7932C10.5302 12.0907 10.4987 12.4183 10.5586 12.7345C10.6185 13.0508 10.7672 13.3413 10.9858 13.5692C11.2043 13.7971 11.483 13.9522 11.7862 14.0147C12.0895 14.0771 12.4037 14.0442 12.689 13.9201C12.9743 13.796 13.2177 13.5863 13.3885 13.3176C13.5592 13.0489 13.6495 12.7333 13.648 12.411C13.648 11.9819 13.4845 11.5704 13.1935 11.267C12.9026 10.9637 12.508 10.7932 12.0965 10.7932Z",
    fill: fill || '#2E7DAF'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_359_27721"
  }, React.createElement("rect", {
    width: "20",
    height: "20",
    fill: "white",
    transform: "translate(2 2)"
  }))));
};

/* eslint-disable linebreak-style */

var speedyNodeIcon = function speedyNodeIcon(fill, size, style) {
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_359_27730)",
    style: style
  }, React.createElement("path", {
    d: "M14.2947 20.5122C14.1464 20.5132 14.0004 20.4753 13.8713 20.4023L7.01273 16.445C6.88352 16.3705 6.77631 16.2633 6.70196 16.1341C6.62762 16.0049 6.58877 15.8584 6.58936 15.7094V7.80328C6.58877 7.65428 6.62762 7.50777 6.70196 7.37859C6.77631 7.2494 6.88352 7.14213 7.01273 7.06763L13.8544 3.11036C13.9831 3.03614 14.1291 2.99707 14.2778 2.99707C14.4264 2.99707 14.5724 3.03614 14.7011 3.11036L21.5767 7.07609C21.7059 7.15059 21.8131 7.25786 21.8874 7.38704C21.9618 7.51623 22.0006 7.66274 22 7.81174V15.7178C22.0006 15.8668 21.9618 16.0133 21.8874 16.1425C21.8131 16.2717 21.7059 16.379 21.5767 16.4535L14.7011 20.4023C14.5771 20.4725 14.4373 20.5103 14.2947 20.5122ZM8.28284 15.2274L14.2947 18.6942L20.3066 15.2274V8.28525L14.2947 4.81841L8.28284 8.28525V15.2274Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.2947 12.6061C14.1456 12.6046 13.9995 12.5637 13.8713 12.4877L7.01269 8.53047C6.88437 8.45614 6.77787 8.34945 6.70383 8.22109C6.62979 8.09272 6.59082 7.94719 6.59082 7.79905C6.59082 7.65092 6.62979 7.50538 6.70383 7.37702C6.77787 7.24865 6.88437 7.14196 7.01269 7.06763L13.8543 3.11036C13.9831 3.03614 14.1291 2.99707 14.2777 2.99707C14.4264 2.99707 14.5724 3.03614 14.7011 3.11036L21.5766 7.07609C21.7049 7.15042 21.8114 7.25711 21.8855 7.38547C21.9595 7.51384 21.9985 7.65937 21.9985 7.80751C21.9985 7.95564 21.9595 8.10118 21.8855 8.22954C21.8114 8.35791 21.7049 8.4646 21.5766 8.53893L14.7011 12.4877C14.5778 12.5609 14.438 12.6017 14.2947 12.6061ZM9.12954 7.80328L14.2947 10.7797L19.4598 7.80328L14.2947 4.81841L9.12954 7.80328Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.2946 20.5123C14.07 20.5123 13.8547 20.4232 13.6959 20.2646C13.5371 20.106 13.4479 19.891 13.4479 19.6667V11.7606C13.4479 11.5364 13.5371 11.3213 13.6959 11.1627C13.8547 11.0041 14.07 10.915 14.2946 10.915C14.5192 10.915 14.7346 11.0041 14.8934 11.1627C15.0521 11.3213 15.1414 11.5364 15.1414 11.7606V19.6667C15.1414 19.891 15.0521 20.106 14.8934 20.2646C14.7346 20.4232 14.5192 20.5123 14.2946 20.5123Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.2947 12.6057C14.1072 12.607 13.9246 12.5461 13.7755 12.4326C13.6264 12.3191 13.5192 12.1594 13.4708 11.9785C13.4223 11.7977 13.4354 11.6059 13.5079 11.4332C13.5804 11.2605 13.7082 11.1168 13.8713 11.0245L19.4598 7.80283L13.8544 4.5812C13.659 4.46907 13.5162 4.28403 13.4575 4.06678C13.3987 3.84953 13.4288 3.61788 13.5411 3.42277C13.6534 3.22767 13.8387 3.08509 14.0562 3.02642C14.2738 2.96775 14.5058 2.99778 14.7011 3.10991L21.5767 7.07564C21.705 7.14997 21.8115 7.25666 21.8855 7.38502C21.9596 7.51339 21.9985 7.65893 21.9985 7.80706C21.9985 7.9552 21.9596 8.10073 21.8855 8.2291C21.8115 8.35746 21.705 8.46415 21.5767 8.53848L14.7011 12.4873C14.5779 12.5605 14.438 12.6012 14.2947 12.6057Z",
    fill: fill
  }), React.createElement("path", {
    d: "M3.18543 11.9881C2.99794 11.9894 2.81533 11.9286 2.66621 11.8151C2.5171 11.7016 2.40993 11.5418 2.3615 11.361C2.31307 11.1801 2.32613 10.9883 2.39862 10.8156C2.47111 10.643 2.59894 10.4992 2.76206 10.4069L3.78661 9.81499C3.98199 9.70286 4.21396 9.67282 4.43151 9.7315C4.64906 9.79017 4.83436 9.93274 4.94664 10.1279C5.05893 10.323 5.089 10.5546 5.03025 10.7719C4.97149 10.9891 4.82873 11.1742 4.63335 11.2863L3.6088 11.8697C3.48057 11.9457 3.33452 11.9866 3.18543 11.9881Z",
    fill: fill
  }), React.createElement("path", {
    d: "M3.18543 15.3709C2.99794 15.3722 2.81533 15.3114 2.66621 15.1979C2.5171 15.0844 2.40993 14.9247 2.3615 14.7438C2.31307 14.5629 2.32613 14.3711 2.39862 14.1984C2.47111 14.0258 2.59894 13.882 2.76206 13.7897L3.78661 13.1978C3.98199 13.0857 4.21396 13.0556 4.43151 13.1143C4.64906 13.173 4.83436 13.3156 4.94664 13.5107C5.05893 13.7058 5.089 13.9374 5.03025 14.1547C4.97149 14.3719 4.82873 14.557 4.63335 14.6691L3.6088 15.2525C3.48057 15.3285 3.33452 15.3694 3.18543 15.3709Z",
    fill: fill
  }), React.createElement("path", {
    d: "M5.92886 20.7822C5.78109 20.7813 5.63613 20.7419 5.50839 20.6677C5.38064 20.5935 5.27455 20.4872 5.20066 20.3594C5.14433 20.2634 5.10752 20.1573 5.09235 20.047C5.07719 19.9368 5.08396 19.8247 5.11227 19.717C5.14059 19.6094 5.1899 19.5084 5.25738 19.4199C5.32486 19.3313 5.40917 19.257 5.50549 19.201L6.68246 18.5246C6.77883 18.4634 6.8866 18.4223 6.99929 18.4038C7.11197 18.3853 7.22724 18.3897 7.33816 18.4169C7.44908 18.444 7.55336 18.4932 7.64473 18.5617C7.73609 18.6301 7.81265 18.7163 7.8698 18.815C7.92695 18.9137 7.96351 19.023 7.97728 19.1362C7.99105 19.2494 7.98175 19.3642 7.94993 19.4737C7.91811 19.5833 7.86443 19.6852 7.79213 19.7735C7.71983 19.8618 7.63039 19.9345 7.5292 19.9874L6.35223 20.6639C6.22401 20.7399 6.07796 20.7807 5.92886 20.7822Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.29046 22.0001C9.10495 22.0001 8.92459 21.9392 8.77711 21.8268C8.62962 21.7144 8.52317 21.5568 8.47411 21.3781C8.42506 21.1995 8.43611 21.0097 8.50558 20.8379C8.57505 20.6661 8.69908 20.5219 8.85862 20.4274L9.22272 20.216C9.31909 20.1548 9.42687 20.1137 9.53955 20.0952C9.65224 20.0767 9.76751 20.0811 9.87843 20.1083C9.98934 20.1354 10.0936 20.1847 10.185 20.2531C10.2763 20.3215 10.3529 20.4077 10.4101 20.5064C10.4672 20.6051 10.5038 20.7144 10.5175 20.8276C10.5313 20.9408 10.522 21.0556 10.4902 21.1652C10.4584 21.2747 10.4047 21.3766 10.3324 21.4649C10.2601 21.5532 10.1707 21.6259 10.0695 21.6788L9.70536 21.8902C9.57881 21.9618 9.43592 21.9997 9.29046 22.0001Z",
    fill: fill
  }), React.createElement("path", {
    d: "M2.8468 18.99C2.65932 18.9913 2.4767 18.9304 2.32759 18.8169C2.17848 18.7034 2.07131 18.5437 2.02288 18.3628C1.97445 18.1819 1.9875 17.9901 2.05999 17.8175C2.13248 17.6448 2.26031 17.501 2.42343 17.4087L4.60802 16.1573C4.80142 16.0463 5.03085 16.0161 5.24647 16.0731C5.46209 16.1301 5.64648 16.2697 5.75958 16.4617C5.81592 16.5577 5.85273 16.6639 5.86789 16.7741C5.88306 16.8843 5.87629 16.9965 5.84797 17.1041C5.81966 17.2117 5.77035 17.3127 5.70287 17.4013C5.63539 17.4898 5.55108 17.5642 5.45476 17.6201L3.27017 18.9139C3.13796 18.9752 2.99213 19.0014 2.8468 18.99Z",
    fill: fill
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_359_27730"
  }, React.createElement("rect", {
    width: "20",
    height: "19",
    fill: "white",
    transform: "translate(2 3)"
  }))));
};

/* eslint-disable linebreak-style */

var usdtIcon = function usdtIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "tether-usdt-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size / 1.14997,
    viewBox: "0 0 24 20.87",
    style: style
  }, React.createElement("title", null, "usdt icon"), React.createElement("path", {
    id: "Path_1",
    "data-name": "Path1",
    d: "M4.4.1.023,9.291A.178.178,0,0,0,.062,9.5L11.881,20.82a.18.18,0,0,0,.25,0L23.949,9.5a.178.178,0,0,0,.038-.208L19.611.1A.177.177,0,0,0,19.45,0H4.562A.177.177,0,0,0,4.4.1Z",
    transform: "translate(-0.005 0)",
    fill: fill || '#50AF95',
    fillRule: "evenodd"
  }), React.createElement("path", {
    id: "Path_2",
    "data-name": "Path2",
    d: "M73.083,47.642h0c-.085.006-.522.033-1.5.033-.777,0-1.328-.023-1.522-.033h0c-3-.133-5.242-.657-5.242-1.285s2.24-1.152,5.242-1.286v2.049c.2.014.758.047,1.535.047.932,0,1.4-.039,1.483-.047V45.072c3,.134,5.23.658,5.23,1.285s-2.235,1.151-5.23,1.284h0Zm0-2.782V43.026h4.18v-2.8H65.882v2.8h4.179v1.833c-3.4.157-5.951.832-5.951,1.642s2.555,1.484,5.951,1.642v5.876h3.021V48.14c3.389-.157,5.939-.831,5.939-1.64s-2.548-1.483-5.939-1.641h0Zm0,0Z",
    transform: "translate(-59.566 -37.379)",
    fill: "#fff",
    fillRule: "evenodd"
  }));
};

/* eslint-disable linebreak-style */

var usdcIcon = function usdcIcon(fill, size, style) {
  return React.createElement("svg", {
    id: "usdc",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    style: style
  }, React.createElement("title", null, "usdc icon"), React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M12,24A12,12,0,1,0,0,12,11.971,11.971,0,0,0,12,24Z",
    fill: fill || '#2775CA'
  }), React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M723.4,516.17c0-1.759-1.055-2.362-3.166-2.613-1.508-.2-1.809-.6-1.809-1.307s.5-1.156,1.508-1.156a1.487,1.487,0,0,1,1.658,1.055.378.378,0,0,0,.352.251h.8a.344.344,0,0,0,.352-.352V512a2.511,2.511,0,0,0-2.262-2.061v-1.206c0-.2-.151-.352-.4-.4h-.754c-.2,0-.352.151-.4.4v1.156a2.563,2.563,0,0,0-2.463,2.463c0,1.659,1.005,2.312,3.116,2.563,1.407.251,1.859.553,1.859,1.357s-.7,1.357-1.658,1.357c-1.307,0-1.759-.553-1.91-1.307a.367.367,0,0,0-.352-.3h-.854a.344.344,0,0,0-.352.352v.05a2.807,2.807,0,0,0,2.664,2.412v1.206c0,.2.151.352.4.4h.754c.2,0,.352-.151.4-.4v-1.206A2.753,2.753,0,0,0,723.4,516.17Z",
    transform: "translate(-708.087 -502.262)",
    fill: "#fff"
  }), React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M254.429,307.289a7.466,7.466,0,0,1,0-14.022.5.5,0,0,0,.3-.5v-.7a.379.379,0,0,0-.3-.4.3.3,0,0,0-.2.05,8.979,8.979,0,0,0,0,17.116.3.3,0,0,0,.449-.2c.05-.05.05-.1.05-.2v-.7A.665.665,0,0,0,254.429,307.289Zm5.291-15.569a.3.3,0,0,0-.449.2c-.05.05-.05.1-.05.2v.7a.662.662,0,0,0,.3.5,7.466,7.466,0,0,1,0,14.022.5.5,0,0,0-.3.5v.7a.379.379,0,0,0,.3.4.3.3,0,0,0,.2-.05,9.017,9.017,0,0,0,0-17.166Z",
    transform: "translate(-244.975 -288.152)",
    fill: "#fff"
  }));
};

var xCircleIcon = function xCircleIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "x circle icon"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3636 12C19.3636 7.93318 16.0668 4.63636 12 4.63636C7.93318 4.63636 4.63636 7.93318 4.63636 12C4.63636 16.0668 7.93318 19.3636 12 19.3636C16.0668 19.3636 19.3636 16.0668 19.3636 12ZM12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.695 8.19964C15.0145 7.88012 15.5326 7.88012 15.8521 8.19964C16.1716 8.51916 16.1716 9.0372 15.8521 9.35672L12.5794 12.6295C12.2598 12.949 11.7418 12.949 11.4223 12.6295L8.14955 9.35672C7.83003 9.0372 7.83003 8.51916 8.14955 8.19964C8.46907 7.88012 8.98712 7.88012 9.30664 8.19964L12.0008 10.8938L14.695 8.19964Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.30664 15.7989C8.98712 16.1184 8.46907 16.1184 8.14955 15.7989C7.83003 15.4794 7.83003 14.9613 8.14955 14.6418L11.4223 11.3691C11.7418 11.0496 12.2598 11.0496 12.5794 11.3691L15.8521 14.6418C16.1716 14.9613 16.1716 15.4794 15.8521 15.7989C15.5326 16.1184 15.0145 16.1184 14.695 15.7989L12.0008 13.1047L9.30664 15.7989Z",
    fill: fill
  }));
};

var xIcon = function xIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "x icon"), React.createElement("path", {
    d: "M16.0001 6.58575L17.4143 7.99997L8.00015 17.4138L6.58594 15.9996L16.0001 6.58575Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17.4142 15.9999L16 17.4141L6.58592 8.00006L8.00013 6.58585L17.4142 15.9999Z",
    fill: fill
  }));
};

var youtubeIcon = function youtubeIcon(fill, size, style) {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "test-icon",
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "youtube icon"), React.createElement("path", {
    d: "M14.2033 4.07915L7.93592 3.85759C7.47327 3.83718 7.04672 3.95148 6.65626 4.20047L1.33936 7.52602C0.932468 7.80348 0.74288 8.26334 0.869205 8.73479C0.989515 9.18379 1.38363 9.48724 1.87474 9.52408L2.41075 9.54889C2.39593 9.67317 2.3811 9.79746 2.39475 9.93817C2.17787 10.1166 2.08689 10.4057 2.16509 10.6975C2.22525 10.922 2.39164 11.094 2.60733 11.1806L2.29198 14.3988C2.30723 14.6353 2.51852 14.7953 2.74303 14.7351L4.10236 14.7351C4.32686 14.675 4.42988 14.4308 4.32482 14.2183L3.43799 10.958C3.58149 10.7752 3.66206 10.537 3.6019 10.3125C3.53573 10.0656 3.34689 9.8996 3.1312 9.81303C3.1356 9.73966 3.15644 9.63783 3.18329 9.55845L4.52031 9.60925L4.89178 12.2528C5.10833 13.061 7.18503 13.1783 9.58719 12.5346C11.9669 11.897 13.7292 10.751 13.5126 9.94283L12.4901 7.47375L14.7386 6.07721C15.1455 5.79975 15.3576 5.33388 15.2373 4.88488C15.1109 4.41343 14.6944 4.11599 14.2033 4.07915ZM8.83073 8.45427C8.64673 8.57576 8.39978 8.64193 8.17968 8.62872L4.513 8.50436L8.09212 6.77535C8.28816 6.69876 8.36872 6.46062 8.27569 6.29305C8.1991 6.09701 7.96096 6.01645 7.79339 6.10948L3.44216 8.18974C3.29102 8.2543 3.17437 8.35774 3.0517 8.43874L2.05304 8.39352L7.24728 5.14896C7.43128 5.02747 7.67823 4.9613 7.89833 4.97451L14.025 5.20971L8.83073 8.45427Z",
    fill: fill
  }), React.createElement("path", {
    d: "M20.6031 10.7615C20.713 11.2771 20.8229 12.0792 20.8778 13.1104L20.9053 14.5427L20.8778 15.975C20.8229 17.0636 20.713 17.837 20.6031 18.3526C20.4932 18.6964 20.3284 18.9828 20.1086 19.212C19.8613 19.4698 19.5866 19.6417 19.2569 19.7276C18.7624 19.8708 17.6635 19.9568 15.9053 20.0141L13.4053 20.0427L10.9053 20.0141C9.14703 19.9568 8.02066 19.8708 7.55363 19.7276C7.22395 19.6417 6.92176 19.4698 6.70198 19.212C6.45472 18.9828 6.28989 18.6964 6.20747 18.3526C6.07011 17.837 5.98769 17.0636 5.93275 15.975L5.90527 14.5427C5.90527 14.1417 5.90527 13.6547 5.93275 13.1104C5.98769 12.0792 6.07011 11.2771 6.20747 10.7615C6.28989 10.4177 6.45472 10.1313 6.70198 9.87345C6.92176 9.64429 7.22395 9.47241 7.55363 9.35783C8.02066 9.24325 9.14703 9.12866 10.9053 9.07137L13.4053 9.04272L15.9053 9.07137C17.6635 9.12866 18.7624 9.24325 19.2569 9.35783C19.5866 9.47241 19.8613 9.64429 20.1086 9.87345C20.3284 10.1313 20.4932 10.4177 20.6031 10.7615ZM11.8668 16.8917L15.7954 14.5427L11.8668 12.2224V16.8917Z",
    fill: fill
  }));
};

/* eslint-disable linebreak-style */

var web3apiIcon = function web3apiIcon(fill, size, style) {
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_12659_107961)",
    style: style
  }, React.createElement("path", {
    d: "M21.1951 19.982H15.0648C14.8515 19.982 14.6468 19.8972 14.4959 19.7463C14.345 19.5954 14.2603 19.3908 14.2603 19.1774C14.2603 18.964 14.345 18.7593 14.4959 18.6085C14.6468 18.4576 14.8515 18.3728 15.0648 18.3728H19.9447L19.2814 16.9162C19.1957 16.7224 19.19 16.5026 19.2654 16.3046C19.3408 16.1066 19.4913 15.9463 19.6842 15.8586C19.8771 15.7708 20.0968 15.7628 20.2957 15.8361C20.4945 15.9094 20.6563 16.0582 20.7461 16.2501L21.9276 18.8443C21.9833 18.9669 22.0074 19.1015 21.9977 19.2358C21.9879 19.3701 21.9446 19.4998 21.8717 19.613C21.7988 19.7262 21.6986 19.8193 21.5804 19.8838C21.4622 19.9482 21.3297 19.982 21.1951 19.982Z",
    fill: fill
  }), React.createElement("path", {
    d: "M15.0651 19.982H8.93447C8.72108 19.982 8.51643 19.8972 8.36554 19.7463C8.21465 19.5954 8.12988 19.3908 8.12988 19.1774C8.12988 18.964 8.21465 18.7593 8.36554 18.6085C8.51643 18.4576 8.72108 18.3728 8.93447 18.3728H15.0651C15.2784 18.3728 15.4831 18.4576 15.634 18.6085C15.7849 18.7593 15.8696 18.964 15.8696 19.1774C15.8696 19.3908 15.7849 19.5954 15.634 19.7463C15.4831 19.8972 15.2784 19.982 15.0651 19.982Z",
    fill: fill
  }), React.createElement("path", {
    d: "M15.064 19.982C14.8728 19.9817 14.6879 19.9134 14.5425 19.7892C14.3971 19.665 14.3007 19.4931 14.2707 19.3043L13.8558 16.71C13.8391 16.6057 13.8431 16.4991 13.8676 16.3964C13.8921 16.2936 13.9366 16.1967 13.9985 16.1111C14.0604 16.0256 14.1386 15.9531 14.2286 15.8977C14.3186 15.8424 14.4186 15.8053 14.5229 15.7886C14.6272 15.7719 14.7337 15.7759 14.8365 15.8003C14.9393 15.8248 15.0362 15.8693 15.1218 15.9312C15.2073 15.9932 15.2798 16.0714 15.3352 16.1613C15.3905 16.2513 15.4276 16.3513 15.4443 16.4556L15.8592 19.0498C15.8759 19.1542 15.8719 19.2607 15.8474 19.3635C15.8229 19.4662 15.7785 19.5632 15.7165 19.6487C15.6546 19.7343 15.5764 19.8068 15.4864 19.8622C15.3964 19.9175 15.2964 19.9546 15.1921 19.9713C15.1498 19.9784 15.1069 19.9819 15.064 19.982Z",
    fill: fill
  }), React.createElement("path", {
    d: "M8.93438 19.9819H2.8038C2.67054 19.9819 2.53936 19.9488 2.42207 19.8856C2.30477 19.8223 2.20503 19.7309 2.1318 19.6196C2.05858 19.5082 2.01417 19.3804 2.00257 19.2477C1.99096 19.1149 2.01253 18.9814 2.06532 18.859L3.18322 16.2648C3.26761 16.0689 3.42634 15.9146 3.6245 15.8358C3.82266 15.757 4.04401 15.7601 4.23987 15.8445C4.43572 15.9289 4.59004 16.0876 4.66886 16.2858C4.74768 16.4839 4.74456 16.7053 4.66018 16.9011L4.02635 18.3737H8.93438C9.14777 18.3737 9.35242 18.4585 9.50331 18.6094C9.6542 18.7602 9.73897 18.9649 9.73897 19.1783C9.73897 19.3917 9.6542 19.5963 9.50331 19.7472C9.35242 19.8981 9.14777 19.9829 8.93438 19.9829V19.9819Z",
    fill: fill
  }), React.createElement("path", {
    d: "M8.93538 19.982C8.89882 19.9819 8.86229 19.9795 8.82603 19.9748C8.72129 19.9606 8.62036 19.9259 8.52902 19.8727C8.43768 19.8195 8.35772 19.7488 8.2937 19.6647C8.22969 19.5806 8.18288 19.4847 8.15595 19.3825C8.12902 19.2802 8.12249 19.1737 8.13674 19.069L8.48859 16.4747C8.51743 16.2632 8.62912 16.0717 8.79911 15.9425C8.9691 15.8133 9.18345 15.7569 9.39502 15.7858C9.60658 15.8146 9.79802 15.9263 9.92723 16.0963C10.0564 16.2663 10.1128 16.4806 10.084 16.6922L9.73183 19.2864C9.70543 19.479 9.61024 19.6555 9.46385 19.7833C9.31745 19.9112 9.12974 19.9817 8.93538 19.982Z",
    fill: fill
  }), React.createElement("path", {
    d: "M20.0145 17.3874C19.8601 17.3876 19.7089 17.3434 19.5789 17.2601C19.449 17.1767 19.3457 17.0578 19.2813 16.9175L18.0992 14.3223C18.0553 14.2261 18.0307 14.1223 18.0269 14.0166C18.0231 13.911 18.0401 13.8056 18.0771 13.7065C18.114 13.6075 18.17 13.5166 18.2421 13.4392C18.3141 13.3618 18.4006 13.2994 18.4968 13.2555C18.691 13.1667 18.9125 13.1587 19.1126 13.2333C19.2116 13.2702 19.3025 13.3263 19.3799 13.3983C19.4572 13.4703 19.5197 13.5569 19.5636 13.653L20.7461 16.2482C20.802 16.3708 20.8263 16.5054 20.8166 16.6397C20.807 16.7741 20.7638 16.9038 20.691 17.0172C20.6182 17.1305 20.5181 17.2237 20.3999 17.2883C20.2817 17.3529 20.1492 17.3867 20.0145 17.3868V17.3874Z",
    fill: fill
  }), React.createElement("path", {
    d: "M20.0137 17.3874H14.6498C14.4364 17.3874 14.2318 17.3027 14.0809 17.1518C13.93 17.0009 13.8452 16.7962 13.8452 16.5828C13.8452 16.3695 13.93 16.1648 14.0809 16.0139C14.2318 15.863 14.4364 15.7783 14.6498 15.7783H20.0137C20.2271 15.7783 20.4317 15.863 20.5826 16.0139C20.7335 16.1648 20.8183 16.3695 20.8183 16.5828C20.8183 16.7962 20.7335 17.0009 20.5826 17.1518C20.4317 17.3027 20.2271 17.3874 20.0137 17.3874Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.6501 17.3874H9.28652C9.07313 17.3874 8.86848 17.3027 8.71759 17.1518C8.5667 17.0009 8.48193 16.7962 8.48193 16.5828C8.48193 16.3695 8.5667 16.1648 8.71759 16.0139C8.86848 15.863 9.07313 15.7783 9.28652 15.7783H14.6501C14.8635 15.7783 15.0682 15.863 15.219 16.0139C15.3699 16.1648 15.4547 16.3695 15.4547 16.5828C15.4547 16.7962 15.3699 17.0009 15.219 17.1518C15.0682 17.3027 14.8635 17.3874 14.6501 17.3874Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.6494 17.3874C14.4582 17.3872 14.2734 17.319 14.1279 17.1948C13.9825 17.0707 13.886 16.8989 13.8558 16.7101L13.6443 15.3763C13.6135 15.1669 13.6664 14.9538 13.7916 14.7831C13.9167 14.6125 14.1041 14.498 14.3131 14.4645C14.5221 14.4311 14.7358 14.4813 14.9081 14.6043C15.0803 14.7274 15.197 14.9133 15.2331 15.1219L15.4459 16.4544C15.4626 16.5587 15.4586 16.6653 15.4341 16.768C15.4096 16.8708 15.3651 16.9677 15.3032 17.0533C15.2413 17.1389 15.1631 17.2114 15.0731 17.2667C14.9831 17.3221 14.8831 17.3592 14.7788 17.3759C14.7361 17.3833 14.6928 17.3872 14.6494 17.3874Z",
    fill: fill
  }), React.createElement("path", {
    d: "M3.92183 17.3874C3.7887 17.3871 3.65774 17.3538 3.54066 17.2904C3.42358 17.2271 3.32403 17.1357 3.25093 17.0244C3.17782 16.9132 3.13344 16.7855 3.12176 16.6529C3.11008 16.5203 3.13145 16.3869 3.18398 16.2645L4.30281 13.6697C4.3446 13.5727 4.40507 13.4849 4.4808 13.4112C4.55652 13.3376 4.646 13.2796 4.74413 13.2406C4.84227 13.2015 4.94713 13.1822 5.05273 13.1837C5.15834 13.1852 5.26262 13.2074 5.35961 13.2492C5.45661 13.291 5.54443 13.3515 5.61806 13.4272C5.69168 13.5029 5.74967 13.5924 5.78872 13.6905C5.82776 13.7887 5.84709 13.8935 5.84561 13.9991C5.84413 14.1047 5.82186 14.209 5.78008 14.306L4.66124 16.9009C4.59916 17.0454 4.496 17.1686 4.36456 17.2551C4.23312 17.3416 4.07918 17.3876 3.92183 17.3874Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.28618 17.3874H3.92226C3.70887 17.3874 3.50422 17.3027 3.35333 17.1518C3.20244 17.0009 3.11768 16.7962 3.11768 16.5828C3.11768 16.3695 3.20244 16.1648 3.35333 16.0139C3.50422 15.863 3.70887 15.7783 3.92226 15.7783H9.28618C9.49957 15.7783 9.70422 15.863 9.85511 16.0139C10.006 16.1648 10.0908 16.3695 10.0908 16.5828C10.0908 16.7962 10.006 17.0009 9.85511 17.1518C9.70422 17.3027 9.49957 17.3874 9.28618 17.3874Z",
    fill: fill
  }), React.createElement("path", {
    d: "M9.28707 17.3874C9.25061 17.3873 9.2142 17.3849 9.17804 17.3802C8.96653 17.3515 8.77508 17.2399 8.64582 17.07C8.51656 16.9002 8.46006 16.6859 8.48876 16.4744L8.66954 15.1419C8.69991 14.9318 8.81206 14.7422 8.98157 14.6144C9.15107 14.4866 9.36421 14.4309 9.57456 14.4595C9.78492 14.4881 9.97546 14.5986 10.1047 14.767C10.2339 14.9354 10.2914 15.1481 10.2646 15.3587L10.0838 16.6921C10.0572 16.8846 9.96192 17.061 9.8155 17.1888C9.66908 17.3166 9.4814 17.3871 9.28707 17.3874Z",
    fill: fill
  }), React.createElement("path", {
    d: "M18.8319 14.7923C18.6774 14.7923 18.5261 14.7478 18.3962 14.6642C18.2662 14.5806 18.1631 14.4613 18.099 14.3207L17.1318 12.198H16.5707C16.3573 12.198 16.1527 12.1133 16.0018 11.9624C15.8509 11.8115 15.7661 11.6068 15.7661 11.3935C15.7661 11.1801 15.8509 10.9754 16.0018 10.8245C16.1527 10.6736 16.3573 10.5889 16.5707 10.5889H17.6494C17.8037 10.5888 17.9547 10.6331 18.0845 10.7164C18.2143 10.7998 18.3174 10.9186 18.3816 11.0588L19.5635 13.654C19.6517 13.8482 19.6592 14.0695 19.5843 14.2692C19.5095 14.469 19.3584 14.6308 19.1643 14.7193C19.0601 14.7673 18.9467 14.7922 18.8319 14.7923Z",
    fill: fill
  }), React.createElement("path", {
    d: "M18.8317 14.7923H16.14C15.9267 14.7923 15.722 14.7075 15.5711 14.5566C15.4202 14.4057 15.3354 14.2011 15.3354 13.9877C15.3354 13.7743 15.4202 13.5697 15.5711 13.4188C15.722 13.2679 15.9267 13.1831 16.14 13.1831H18.8317C19.0451 13.1831 19.2498 13.2679 19.4007 13.4188C19.5516 13.5697 19.6363 13.7743 19.6363 13.9877C19.6363 14.2011 19.5516 14.4057 19.4007 14.5566C19.2498 14.7075 19.0451 14.7923 18.8317 14.7923Z",
    fill: fill
  }), React.createElement("path", {
    d: "M5.0402 14.7923C4.90711 14.7919 4.77619 14.7586 4.65914 14.6953C4.54209 14.6319 4.44258 14.5405 4.3695 14.4293C4.29642 14.3181 4.25207 14.1905 4.2404 14.0579C4.22874 13.9253 4.25013 13.7919 4.30266 13.6697L5.42056 11.0751C5.48259 10.9307 5.58562 10.8077 5.71688 10.7213C5.84814 10.6348 6.00188 10.5888 6.15904 10.5889H7.38096C7.59435 10.5889 7.799 10.6736 7.94989 10.8245C8.10078 10.9754 8.18555 11.1801 8.18555 11.3935C8.18555 11.6068 8.10078 11.8115 7.94989 11.9624C7.799 12.1133 7.59435 12.198 7.38096 12.198H6.68854L5.77993 14.306C5.71788 14.4506 5.61468 14.5739 5.48315 14.6603C5.35163 14.7468 5.19759 14.7927 5.0402 14.7923Z",
    fill: fill
  }), React.createElement("path", {
    d: "M7.73308 14.7923H5.0414C4.82801 14.7923 4.62336 14.7075 4.47247 14.5566C4.32159 14.4057 4.23682 14.2011 4.23682 13.9877C4.23682 13.7743 4.32159 13.5697 4.47247 13.4188C4.62336 13.2679 4.82801 13.1831 5.0414 13.1831H7.73308C7.94647 13.1831 8.15112 13.2679 8.30201 13.4188C8.4529 13.5697 8.53767 13.7743 8.53767 13.9877C8.53767 14.2011 8.4529 14.4057 8.30201 14.5566C8.15112 14.7075 7.94647 14.7923 7.73308 14.7923Z",
    fill: fill
  }), React.createElement("path", {
    d: "M10.3158 9.02321C10.1504 9.02338 9.98889 8.97256 9.85335 8.87765C9.71781 8.78275 9.61481 8.64838 9.55837 8.49284C9.50194 8.3373 9.49481 8.16814 9.53796 8.0084C9.5811 7.84867 9.67243 7.70611 9.79951 7.60014L12.1675 5.62627H9.64003C9.53436 5.62631 9.42972 5.60552 9.33208 5.5651C9.23445 5.52468 9.14574 5.46542 9.07101 5.3907C8.99629 5.31598 8.93703 5.22727 8.89661 5.12963C8.85619 5.03199 8.83541 4.92735 8.83545 4.82168C8.83541 4.71601 8.85619 4.61136 8.89661 4.51373C8.93703 4.41609 8.99629 4.32738 9.07101 4.25266C9.14574 4.17794 9.23445 4.11867 9.33208 4.07825C9.42972 4.03783 9.53436 4.01705 9.64003 4.01709H14.3902C14.5559 4.01691 14.7176 4.06787 14.8533 4.16303C14.989 4.25819 15.0921 4.3929 15.1484 4.54878C15.2048 4.70428 15.2118 4.87337 15.1687 5.03304C15.1255 5.19271 15.0342 5.3352 14.9071 5.4411L10.8303 8.83678C10.6859 8.95719 10.5039 9.02316 10.3158 9.02321Z",
    fill: fill
  }), React.createElement("path", {
    d: "M12.0124 13.7784C10.5637 13.7784 9.63127 13.398 8.99555 12.5449C8.93231 12.4603 8.88636 12.3641 8.8603 12.2617C8.83425 12.1593 8.82861 12.0529 8.84371 11.9483C8.85881 11.8438 8.89435 11.7433 8.94831 11.6525C9.00226 11.5617 9.07357 11.4824 9.15816 11.4191C9.32901 11.2914 9.54359 11.2368 9.75471 11.2673C9.96582 11.2978 10.1562 11.4109 10.2839 11.5817C10.5126 11.8866 10.8792 12.1695 12.0124 12.1695C12.219 12.1695 12.4234 12.1288 12.6142 12.0498C12.805 11.9708 12.9784 11.855 13.1244 11.7089C13.2704 11.5629 13.3862 11.3896 13.4653 11.1988C13.5443 11.008 13.585 10.8035 13.585 10.597C13.585 10.3905 13.5443 10.186 13.4653 9.99523C13.3862 9.80444 13.2704 9.63109 13.1244 9.48507C12.9784 9.33905 12.805 9.22322 12.6142 9.14419C12.4234 9.06516 12.219 9.02449 12.0124 9.02449H10.3146C10.1012 9.02449 9.89656 8.93972 9.74567 8.78883C9.59478 8.63794 9.51001 8.43329 9.51001 8.2199C9.51001 8.00651 9.59478 7.80186 9.74567 7.65098C9.89656 7.50009 10.1012 7.41532 10.3146 7.41532H12.0124C12.4329 7.41115 12.85 7.49036 13.2397 7.64837C13.6294 7.80639 13.9838 8.04007 14.2826 8.33592C14.5814 8.63177 14.8186 8.98391 14.9805 9.37198C15.1424 9.76005 15.2257 10.1764 15.2257 10.5968C15.2257 11.0173 15.1424 11.4336 14.9805 11.8217C14.8186 12.2098 14.5814 12.5619 14.2826 12.8578C13.9838 13.1536 13.6294 13.3873 13.2397 13.5453C12.85 13.7033 12.4329 13.7825 12.0124 13.7784Z",
    fill: fill
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_12659_107961"
  }, React.createElement("rect", {
    width: "20",
    height: "15.9633",
    fill: "white",
    transform: "translate(2 4.01837)"
  }))));
};

/* eslint-disable linebreak-style */

var atomicApiIcon = function atomicApiIcon(fill, size, style) {
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_12659_107960)",
    style: style
  }, React.createElement("path", {
    d: "M12.3135 21.9666C10.7069 21.9575 9.12723 21.5427 7.71427 20.7591C6.30131 19.9755 5.09863 18.8471 4.21262 17.4738C3.32662 16.1005 2.7846 14.5247 2.63454 12.8856C2.48447 11.2466 2.73097 9.59494 3.35224 8.07677C3.44244 7.88736 3.59924 7.73991 3.79115 7.66405C3.98306 7.58818 4.19587 7.58951 4.38686 7.66776C4.58553 7.75423 4.74258 7.91795 4.82354 8.12298C4.90449 8.328 4.90273 8.55756 4.81863 8.76125C4.15895 10.7588 4.26161 12.9381 5.10597 14.8613C5.95034 16.7845 7.47383 18.3089 9.37026 19.1282C11.2667 19.9476 13.3955 20.0011 15.3289 19.278C17.2622 18.5549 18.8568 17.1088 19.7922 15.2304C19.8764 15.0256 20.0366 14.8635 20.2375 14.7797C20.4384 14.696 20.6636 14.6974 20.8634 14.7838C21.0633 14.8701 21.2215 15.0343 21.3032 15.2401C21.385 15.446 21.3836 15.6767 21.2993 15.8814C20.5543 17.6883 19.308 19.2313 17.715 20.3189C16.1219 21.4066 14.2523 21.9911 12.338 22L12.3135 21.9666Z",
    fill: fill
  }), React.createElement("path", {
    d: "M20.5498 16.3907C20.4433 16.3893 20.3381 16.3667 20.2402 16.3239C20.1411 16.2819 20.0511 16.2202 19.9753 16.1424C19.8995 16.0647 19.8395 15.9723 19.7986 15.8707C19.7577 15.7692 19.7368 15.6603 19.7371 15.5504C19.7374 15.4405 19.7589 15.3318 19.8003 15.2304C20.0932 14.5303 20.2879 13.7911 20.3787 13.0351C20.4068 12.8137 20.5195 12.6128 20.6922 12.4766C20.8648 12.3404 21.0832 12.2801 21.2992 12.3089C21.5153 12.3376 21.7114 12.4532 21.8443 12.6301C21.9772 12.807 22.0361 13.0307 22.008 13.2521C21.8907 14.1559 21.6578 15.0399 21.3155 15.8815C21.2521 16.035 21.1453 16.1655 21.0088 16.2563C20.8723 16.347 20.7124 16.3938 20.5498 16.3907ZM21.006 10.6644C20.8199 10.67 20.6375 10.6101 20.4893 10.4947C20.3411 10.3792 20.2359 10.2153 20.1913 10.0301C20.0123 9.29221 19.7384 8.58203 19.3766 7.91821C19.3231 7.82284 19.2885 7.71761 19.2747 7.60853C19.2609 7.49945 19.2682 7.38865 19.2962 7.28246C19.3242 7.17627 19.3723 7.07676 19.4378 6.98963C19.5034 6.9025 19.585 6.82944 19.6781 6.77463C19.7711 6.71982 19.8738 6.68434 19.9803 6.6702C20.0868 6.65605 20.1949 6.66354 20.2985 6.69222C20.4022 6.72089 20.4993 6.77021 20.5843 6.83734C20.6694 6.90448 20.7407 6.98811 20.7942 7.08348C21.2304 7.86842 21.5593 8.71102 21.7717 9.58766C21.7972 9.69455 21.8018 9.80554 21.7853 9.91425C21.7687 10.023 21.7313 10.1273 21.6753 10.2211C21.6193 10.315 21.5457 10.3966 21.4588 10.4612C21.3719 10.5258 21.2734 10.5722 21.1689 10.5977L21.006 10.6644ZM18.0406 5.78966C17.8502 5.79004 17.6658 5.72211 17.5192 5.59767C16.9459 5.12565 16.3129 4.73535 15.6373 4.43741C15.5394 4.39246 15.4511 4.3282 15.3775 4.2483C15.3038 4.16839 15.2463 4.07441 15.2081 3.9717C15.1699 3.869 15.1518 3.75959 15.1548 3.64973C15.1579 3.53987 15.1821 3.4317 15.2259 3.3314C15.2698 3.2311 15.3325 3.14063 15.4105 3.06516C15.4885 2.9897 15.5802 2.93071 15.6804 2.89157C15.7807 2.85242 15.8874 2.83389 15.9947 2.83703C16.1019 2.84017 16.2075 2.86492 16.3054 2.90986C17.1162 3.28414 17.875 3.76692 18.562 4.34559C18.6911 4.45525 18.7841 4.6031 18.8282 4.76894C18.8723 4.93478 18.8653 5.11052 18.8083 5.27216C18.7513 5.4338 18.6469 5.57346 18.5095 5.67206C18.3721 5.77065 18.2083 5.82338 18.0406 5.82305V5.78966ZM7.17297 5.33891C6.99908 5.34028 6.82932 5.2846 6.68854 5.18001C6.54775 5.07543 6.44331 4.92743 6.39051 4.75766C6.33771 4.58789 6.33931 4.40527 6.39508 4.2365C6.45085 4.06774 6.55786 3.92168 6.70046 3.81971L6.96116 3.64442C7.05089 3.58369 7.15147 3.54176 7.25709 3.52105C7.36271 3.50035 7.47129 3.50127 7.57656 3.52378C7.68183 3.54628 7.78171 3.58992 7.87044 3.65217C7.95917 3.71442 8.035 3.79406 8.09354 3.88649C8.20991 4.07254 8.24953 4.29827 8.20372 4.51421C8.1579 4.73014 8.03039 4.91865 7.84914 5.03841L7.64548 5.18866C7.50698 5.28772 7.34186 5.34022 7.17297 5.33891ZM10.4316 3.88649C10.2156 3.90973 9.99934 3.84408 9.83052 3.70398C9.6617 3.56387 9.55411 3.36079 9.53143 3.13941C9.50874 2.91803 9.57281 2.69648 9.70955 2.5235C9.84628 2.35052 10.0445 2.24028 10.2605 2.21704C11.1297 2.02374 12.0202 1.95075 12.9082 2.00001C13.1229 2.01294 13.3239 2.11234 13.4674 2.27653C13.6108 2.44073 13.6851 2.65639 13.674 2.87647C13.6615 3.08906 13.5702 3.28872 13.4188 3.43459C13.2673 3.58046 13.0672 3.66149 12.8593 3.66111C12.1187 3.6215 11.3763 3.68326 10.6516 3.84475C10.5682 3.87607 10.4796 3.89025 10.3909 3.88649H10.4316Z",
    fill: fill
  }), React.createElement("path", {
    d: "M4.88401 5.33058C4.95484 5.27341 5.03932 5.23671 5.12868 5.2243C5.21803 5.21188 5.30899 5.2242 5.39213 5.25998C5.47526 5.29576 5.54754 5.35369 5.60144 5.42775C5.65535 5.50181 5.68892 5.58931 5.69867 5.68116L6.54592 8.61104C6.55818 8.70235 6.54679 8.79536 6.51291 8.88074C6.47903 8.96612 6.42385 9.04088 6.35289 9.09752C6.28193 9.15417 6.19769 9.19071 6.1086 9.20348C6.01952 9.21626 5.92872 9.20482 5.84531 9.17031L2.31781 7.64276C2.23368 7.60825 2.16017 7.55117 2.10497 7.47752C2.04978 7.40387 2.01494 7.31636 2.00411 7.22417C1.99328 7.13198 2.00686 7.0385 2.04342 6.95354C2.07998 6.86857 2.13818 6.79525 2.21191 6.74126L4.88401 5.33058Z",
    fill: fill
  }), React.createElement("path", {
    d: "M15.6537 15.99C15.5626 15.932 15.4836 15.8562 15.4212 15.7669C15.3588 15.6775 15.3142 15.5765 15.29 15.4695C15.2657 15.3624 15.2624 15.2516 15.2801 15.1432C15.2978 15.0349 15.3361 14.9312 15.393 14.838C15.5072 14.6519 15.6885 14.5194 15.8975 14.4694C16.1064 14.4194 16.3262 14.4559 16.5091 14.5709C16.6002 14.6289 16.6792 14.7047 16.7416 14.794C16.804 14.8833 16.8486 14.9844 16.8728 15.0914C16.8971 15.1984 16.9004 15.3093 16.8828 15.4177C16.8651 15.526 16.8267 15.6297 16.7698 15.7228C16.6964 15.8431 16.5943 15.9423 16.4732 16.0109C16.352 16.0796 16.2158 16.1154 16.0773 16.1152C15.9276 16.1141 15.781 16.0708 15.6537 15.99ZM13.5763 14.6627C13.4 14.5405 13.2774 14.3523 13.2348 14.1386C13.1921 13.9249 13.2328 13.7025 13.3482 13.5192C13.4624 13.333 13.6437 13.2005 13.8527 13.1505C14.0616 13.1005 14.2814 13.137 14.4643 13.2521C14.6474 13.3677 14.7783 13.5529 14.8287 13.7671C14.8791 13.9813 14.8447 14.2073 14.7331 14.3956C14.6598 14.5159 14.5577 14.6151 14.4365 14.6837C14.3154 14.7524 14.1791 14.7882 14.0407 14.788C13.8767 14.7989 13.7138 14.755 13.5763 14.6627ZM11.1323 12.6177C11.1323 12.3963 11.2182 12.184 11.3709 12.0274C11.5237 11.8709 11.7309 11.7829 11.947 11.7829C12.1631 11.7829 12.3703 11.8709 12.523 12.0274C12.6758 12.184 12.7617 12.3963 12.7617 12.6177C12.7617 12.8391 12.6758 13.0514 12.523 13.2079C12.3703 13.3645 12.1631 13.4524 11.947 13.4524C11.7338 13.448 11.5307 13.3582 11.3814 13.2021C11.2322 13.046 11.1486 12.8362 11.1486 12.6177H11.1323ZM11.1323 10.1135C11.1323 9.89211 11.2182 9.6798 11.3709 9.52326C11.5237 9.36672 11.7309 9.27877 11.947 9.27877C12.1631 9.27877 12.3703 9.36672 12.523 9.52326C12.6758 9.6798 12.7617 9.89211 12.7617 10.1135C12.7617 10.3349 12.6758 10.5472 12.523 10.7037C12.3703 10.8603 12.1631 10.9482 11.947 10.9482C11.7338 10.9438 11.5307 10.854 11.3814 10.6979C11.2322 10.5418 11.1486 10.332 11.1486 10.1135H11.1323ZM11.1323 7.60932C11.1323 7.38794 11.2182 7.17562 11.3709 7.01908C11.5237 6.86254 11.7309 6.7746 11.947 6.7746C12.1631 6.7746 12.3703 6.86254 12.523 7.01908C12.6758 7.17562 12.7617 7.38794 12.7617 7.60932C12.7617 7.8307 12.6758 8.04302 12.523 8.19956C12.3703 8.3561 12.1631 8.44405 11.947 8.44405C11.7338 8.43968 11.5307 8.34981 11.3814 8.19374C11.2322 8.03767 11.1486 7.82784 11.1486 7.60932H11.1323Z",
    fill: fill
  }), React.createElement("path", {
    d: "M17.1366 16.7829C16.9868 16.7819 16.8403 16.7386 16.713 16.6577L13.6009 14.6794C13.4534 14.5525 13.3545 14.3762 13.3219 14.1816C13.2892 13.9871 13.3249 13.787 13.4225 13.6169C13.5202 13.4468 13.6736 13.3176 13.8554 13.2523C14.0372 13.1871 14.2357 13.1899 14.4156 13.2604L17.5276 15.2387C17.6784 15.3345 17.7946 15.478 17.8585 15.6476C17.9224 15.8171 17.9305 16.0034 17.8816 16.1781C17.8328 16.3528 17.7296 16.5065 17.5878 16.6156C17.446 16.7248 17.2732 16.7835 17.0959 16.7829H17.1366Z",
    fill: fill
  }), React.createElement("path", {
    d: "M11.9631 10.99C11.747 10.99 11.5398 10.902 11.387 10.7455C11.2343 10.5889 11.1484 10.3766 11.1484 10.1552V5.93989C11.1484 5.71851 11.2343 5.50619 11.387 5.34965C11.5398 5.19311 11.747 5.10516 11.9631 5.10516C12.1792 5.10516 12.3864 5.19311 12.5392 5.34965C12.6919 5.50619 12.7778 5.71851 12.7778 5.93989V10.1552C12.7778 10.3766 12.6919 10.5889 12.5392 10.7455C12.3864 10.902 12.1792 10.99 11.9631 10.99Z",
    fill: fill
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_12659_107960"
  }, React.createElement("rect", {
    width: "20",
    height: "20",
    fill: "white",
    transform: "translate(2 2)"
  }))));
};

var metamaskIcon = function metamaskIcon(_fill, size, style) {
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "metamask-logo",
    style: style
  }, React.createElement("title", null, "Metamask"), React.createElement("g", {
    clipPath: "url(#clip0_9993_54207)"
  }, React.createElement("path", {
    d: "M21.0114 2.75L13.1982 8.53117L14.6512 5.12414L21.0114 2.75Z",
    fill: "url(#paint0_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M21.0114 2.75L13.1982 8.53117L14.6512 5.12414L21.0114 2.75Z",
    fill: "url(#paint1_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M2.98926 2.75L10.7328 8.58512L9.34951 5.12413L2.98926 2.75Z",
    fill: "url(#paint2_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M2.98926 2.75L10.7328 8.58512L9.34951 5.12413L2.98926 2.75Z",
    fill: "url(#paint3_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M18.1985 16.1545L16.1196 19.3303L20.571 20.556L21.8462 16.224L18.1985 16.1545Z",
    fill: "url(#paint4_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M18.1985 16.1545L16.1196 19.3303L20.571 20.556L21.8462 16.224L18.1985 16.1545Z",
    fill: "url(#paint5_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M2.1626 16.224L3.43 20.556L7.87368 19.3303L5.80253 16.1545L2.1626 16.224Z",
    fill: "url(#paint6_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M2.1626 16.224L3.43 20.556L7.87368 19.3303L5.80253 16.1545L2.1626 16.224Z",
    fill: "url(#paint7_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M7.63394 10.7897L6.39746 12.6551L10.8025 12.8555L10.6557 8.11499L7.63394 10.7897Z",
    fill: "url(#paint8_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M7.63394 10.7897L6.39746 12.6551L10.8025 12.8555L10.6557 8.11499L7.63394 10.7897Z",
    fill: "url(#paint9_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M16.3667 10.7897L13.2987 8.06104L13.1982 12.8556L17.6032 12.6551L16.3667 10.7897Z",
    fill: "url(#paint10_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M7.87354 19.3304L10.5397 18.0432L8.2445 16.2549L7.87354 19.3304Z",
    fill: "#E27625"
  }), React.createElement("path", {
    d: "M13.4604 18.0432L16.1189 19.3304L15.7557 16.2549L13.4604 18.0432Z",
    fill: "#E27625"
  }), React.createElement("path", {
    d: "M16.1189 19.3302L13.4604 18.043L13.6768 19.7696L13.6536 20.5019L16.1189 19.3302Z",
    fill: "url(#paint11_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M7.87354 19.3302L10.3465 20.5019L10.3311 19.7696L10.5397 18.043L7.87354 19.3302Z",
    fill: "url(#paint12_radial_9993_54207)"
  }), React.createElement("path", {
    d: "M10.3929 15.1136L8.18262 14.4662L9.74369 13.7493L10.3929 15.1136Z",
    fill: "url(#paint13_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M13.6084 15.1136L14.2576 13.7493L15.8264 14.4662L13.6084 15.1136Z",
    fill: "url(#paint14_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M7.87336 19.3303L8.25979 16.1545L5.80225 16.224L7.87336 19.3303Z",
    fill: "#CC6228"
  }), React.createElement("path", {
    d: "M15.7402 16.1545L16.1189 19.3303L18.1978 16.224L15.7402 16.1545Z",
    fill: "#CC6228"
  }), React.createElement("path", {
    d: "M17.6032 12.6548L13.1982 12.8552L13.6078 15.1138L14.257 13.7494L15.8258 14.4662L17.6032 12.6548Z",
    fill: "#CC6228"
  }), React.createElement("path", {
    d: "M8.18265 14.4662L9.74372 13.7494L10.3929 15.1138L10.8025 12.8552L6.39746 12.6548L8.18265 14.4662Z",
    fill: "#CC6228"
  }), React.createElement("path", {
    d: "M6.39746 12.6548L8.24449 16.2545L8.18263 14.4662L6.39746 12.6548Z",
    fill: "#E27525"
  }), React.createElement("path", {
    d: "M15.8259 14.4662L15.7563 16.2545L17.6034 12.6548L15.8259 14.4662Z",
    fill: "#E27525"
  }), React.createElement("path", {
    d: "M10.8027 12.8555L10.3931 15.114L10.9108 17.781L11.0268 14.2661L10.8027 12.8555Z",
    fill: "#E27525"
  }), React.createElement("path", {
    d: "M13.1974 12.8555L12.981 14.2584L13.0892 17.781L13.6069 15.114L13.1974 12.8555Z",
    fill: "#E27525"
  }), React.createElement("path", {
    d: "M13.6071 15.1138L13.0894 17.7808L13.4603 18.0429L15.7556 16.2546L15.8251 14.4663L13.6071 15.1138Z",
    fill: "url(#paint15_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M8.18262 14.4663L8.24448 16.2546L10.5397 18.0429L10.9107 17.7808L10.3929 15.1138L8.18262 14.4663Z",
    fill: "url(#paint16_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M13.6542 20.502L13.6773 19.7697L13.4764 19.6001L10.5243 19.6001L10.3311 19.7697L10.3465 20.502L7.87354 19.3303L8.73908 20.0395L10.4934 21.2497L13.4996 21.2497L15.2616 20.0395L16.1194 19.3303L13.6542 20.502Z",
    fill: "#C0AC9D"
  }), React.createElement("path", {
    d: "M13.46 18.0433L13.089 17.7812L10.9097 17.7812L10.5388 18.0433L10.3301 19.77L10.5233 19.6004L13.4754 19.6004L13.6764 19.77L13.46 18.0433Z",
    fill: "url(#paint17_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M21.3431 8.90885L22 5.71767L21.0108 2.75L13.4604 8.33849L16.3662 10.7897L20.4698 11.9845L21.374 10.9285L20.9799 10.6432L21.6058 10.0728L21.1267 9.70283L21.7527 9.22491L21.3431 8.90885Z",
    fill: "url(#paint18_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M2 5.71791L2.66462 8.9091L2.23957 9.22516L2.87328 9.70308L2.39413 10.0731L3.02011 10.6435L2.62597 10.9287L3.53017 11.9847L7.63382 10.7899L10.5395 8.33873L2.9892 2.75024L2 5.71791Z",
    fill: "url(#paint19_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M20.4705 11.9845L16.3669 10.7898L17.6034 12.6552L15.7563 16.2549L18.1984 16.2241L21.8461 16.2241L20.4705 11.9845Z",
    fill: "url(#paint20_radial_9993_54207)"
  }), React.createElement("path", {
    d: "M20.4705 11.9845L16.3669 10.7898L17.6034 12.6552L15.7563 16.2549L18.1984 16.2241L21.8461 16.2241L20.4705 11.9845Z",
    fill: "url(#paint21_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M7.63407 10.7898L3.53047 11.9845L2.1626 16.2241L5.80254 16.2241L8.24459 16.2549L6.3976 12.6552L7.63407 10.7898Z",
    fill: "url(#paint22_radial_9993_54207)"
  }), React.createElement("path", {
    d: "M7.63407 10.7898L3.53047 11.9845L2.1626 16.2241L5.80254 16.2241L8.24459 16.2549L6.3976 12.6552L7.63407 10.7898Z",
    fill: "url(#paint23_linear_9993_54207)"
  }), React.createElement("path", {
    d: "M13.1992 12.8556L13.4619 8.33857L14.652 5.12427L9.35059 5.12427L10.5407 8.33857L10.8034 12.8556L10.9039 14.2739L10.9117 17.7812L13.091 17.7812L13.0987 14.2739L13.1992 12.8556Z",
    fill: "url(#paint24_linear_9993_54207)"
  })), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_9993_54207",
    x1: "14.1751",
    y1: "8.126",
    x2: "24.2155",
    y2: "-2.07259",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E17726"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E17726",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_9993_54207",
    x1: "17.1744",
    y1: "8.16694",
    x2: "14.5312",
    y2: "-0.344985",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_9993_54207",
    x1: "11.4878",
    y1: "8.60035",
    x2: "1.60542",
    y2: "-1.75635",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_9993_54207",
    x1: "6.93005",
    y1: "8.21749",
    x2: "4.22192",
    y2: "-0.345899",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_9993_54207",
    x1: "15.1243",
    y1: "16.1901",
    x2: "20.7392",
    y2: "24.1949",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.256463",
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_9993_54207",
    x1: "19.0339",
    y1: "20.2787",
    x2: "16.958",
    y2: "13.8429",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_9993_54207",
    x1: "8.32455",
    y1: "16.1901",
    x2: "1.05114",
    y2: "22.8311",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.247205",
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_9993_54207",
    x1: "5.06903",
    y1: "20.2787",
    x2: "2.98854",
    y2: "13.8462",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_9993_54207",
    x1: "7.2177",
    y1: "12.079",
    x2: "15.677",
    y2: "5.1218",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_9993_54207",
    x1: "8.63922",
    y1: "12.5569",
    x2: "5.76845",
    y2: "6.20062",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_9993_54207",
    x1: "15.44",
    y1: "12.5535",
    x2: "12.5148",
    y2: "6.14973",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_9993_54207",
    x1: "14.7897",
    y1: "18.043",
    x2: "17.6521",
    y2: "24.4464",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D5BFB2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D5BFB2",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_9993_54207",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5112 17.509) rotate(116.98) scale(12.5928 13.6543)"
  }, React.createElement("stop", {
    stopColor: "#D5BFB2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D5BFB2",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_9993_54207",
    x1: "9.28774",
    y1: "13.7493",
    x2: "9.28774",
    y2: "15.1136",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#17396B"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_9993_54207",
    x1: "14.7174",
    y1: "13.7493",
    x2: "14.7174",
    y2: "15.1136",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#17396B"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_9993_54207",
    x1: "15.5183",
    y1: "14.4508",
    x2: "8.48202",
    y2: "22.5148",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.200338",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_9993_54207",
    x1: "8.16656",
    y1: "14.4508",
    x2: "13.7797",
    y2: "21.8033",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.32798",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_9993_54207",
    x1: "12.0032",
    y1: "17.7812",
    x2: "12.0032",
    y2: "19.77",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#17396B"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_9993_54207",
    x1: "15.9241",
    y1: "10.012",
    x2: "21.9712",
    y2: "5.83055",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#592B0D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#763E1A"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_9993_54207",
    x1: "9.94157",
    y1: "8.72543",
    x2: "2.41488",
    y2: "4.67259",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#592B0D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#763E1A"
  })), React.createElement("radialGradient", {
    id: "paint20_radial_9993_54207",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1692 13.1899) rotate(11.6894) scale(8.80836 9.81509)"
  }, React.createElement("stop", {
    offset: "0.263819",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_9993_54207",
    x1: "18.8555",
    y1: "15.9106",
    x2: "15.9454",
    y2: "8.1841",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("radialGradient", {
    id: "paint22_radial_9993_54207",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.87796 16.1901) rotate(-159.818) scale(15.5826 17.3415)"
  }, React.createElement("stop", {
    offset: "0.299865",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "0.567167",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_9993_54207",
    x1: "5.25779",
    y1: "15.9106",
    x2: "2.34497",
    y2: "8.18654",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_9993_54207",
    x1: "11.9617",
    y1: "5.1218",
    x2: "11.9617",
    y2: "30.5787",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.267932",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFC796",
    stopOpacity: "0.89"
  })), React.createElement("clipPath", {
    id: "clip0_9993_54207"
  }, React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var metamaskLinedIcon = function metamaskLinedIcon(fill, size, style) {
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, React.createElement("title", null, "Metamask"), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5691 11.9595C20.554 11.9847 20.5445 12.0129 20.5411 12.0422C20.5378 12.0714 20.5408 12.101 20.5498 12.129L21.8241 16.1199C21.8358 16.1588 21.8358 16.2003 21.8241 16.2391L20.6451 20.4554C20.6377 20.4818 20.6252 20.5065 20.6082 20.5281C20.5912 20.5496 20.5701 20.5676 20.5462 20.581C20.5222 20.5944 20.4959 20.6029 20.4686 20.6061C20.4414 20.6093 20.4138 20.6071 20.3874 20.5995L16.289 19.4304C16.2589 19.4216 16.2273 19.4198 16.1964 19.4251C16.1656 19.4304 16.1364 19.4426 16.111 19.461L13.5362 21.2921C13.5009 21.3173 13.4585 21.3308 13.415 21.3306H10.5886C10.5451 21.3308 10.5027 21.3173 10.4674 21.2921L7.89306 19.461C7.86759 19.4427 7.83828 19.4304 7.80737 19.4251C7.77646 19.4198 7.74475 19.4217 7.71464 19.4304L3.61623 20.5995C3.56294 20.6146 3.50585 20.6078 3.45752 20.5808C3.40919 20.5538 3.37356 20.5087 3.35847 20.4554L2.17763 16.2396C2.16591 16.2007 2.16591 16.1592 2.17763 16.1204L3.4519 12.1295C3.4609 12.1015 3.46387 12.0719 3.46064 12.0427C3.4574 12.0135 3.44802 11.9853 3.43312 11.96L3.32231 11.7722C3.31098 11.7531 3.30274 11.7323 3.2979 11.7107L2.00485 5.80413C1.99683 5.76767 1.99878 5.72972 2.01049 5.69427L2.93262 2.89313C2.94147 2.86634 2.95568 2.84162 2.97437 2.82049C2.99306 2.79935 3.01585 2.78222 3.04136 2.77015C3.06686 2.75808 3.09455 2.75131 3.12275 2.75025C3.15095 2.7492 3.17907 2.75388 3.20541 2.76401L9.20207 5.06136C9.22578 5.07034 9.25091 5.07495 9.27626 5.07497L11.9995 5.08061L14.7226 5.07497C14.748 5.07499 14.7731 5.07038 14.7968 5.06136L20.7944 2.76401C20.8207 2.75386 20.8488 2.74914 20.8769 2.75013C20.9051 2.75112 20.9327 2.75781 20.9582 2.76979C20.9837 2.78177 21.0065 2.79879 21.0253 2.81983C21.044 2.84087 21.0583 2.86548 21.0672 2.89219L21.9894 5.69333C22.0011 5.72878 22.003 5.76673 21.995 5.80319L20.7019 11.7097C20.6979 11.7315 20.6903 11.7524 20.6794 11.7717L20.5691 11.9595ZM19.468 11.2672L20.6613 5.81653L20.1908 4.38734L15.2595 6.27626C15.0885 6.34135 14.9072 6.37479 14.7243 6.37497M14.7243 6.37497L15.462 7.1358L13.7153 8.50655L9.27514 6.37497M9.27357 6.37497C9.09177 6.37462 8.91151 6.34145 8.74145 6.27702L8.737 6.27533L3.8093 4.3875L3.33856 5.81747L4.53032 11.2613L4.55363 11.3008C4.66145 11.4841 4.72931 11.6882 4.75273 11.8995C4.77605 12.11 4.75479 12.3231 4.69031 12.5249L4.68953 12.5273L3.51671 16.2005L4.31443 19.0485L7.35031 18.1825C7.35231 18.182 7.35431 18.1814 7.35631 18.1808C7.57417 18.1182 7.80327 18.1055 8.02656 18.1437C8.25036 18.182 8.46269 18.2704 8.64762 18.4024L8.65146 18.4051L10.9367 20.0306H13.0669L15.3553 18.4031C15.5402 18.2709 15.7527 18.1822 15.9767 18.1438C16.2004 18.1054 16.43 18.1181 16.6482 18.1811L19.6887 19.0484L20.4851 16.2003L19.3128 12.5287L19.3119 12.5258C19.2466 12.3225 19.2253 12.1076 19.2494 11.8955C19.2734 11.6848 19.3415 11.4815 19.4494 11.299L19.468 11.2672M20.5794 15.8639L20.5733 15.8851C20.5752 15.878 20.5773 15.871 20.5794 15.8639ZM10.5821 20.0306C10.5842 20.0306 10.5864 20.0306 10.5886 20.0306L10.5821 20.0306ZM3.4223 15.8644C3.42438 15.8713 3.42638 15.8782 3.42832 15.8851L3.4223 15.8644Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M3.52205 3.65639L2.62387 5.93308C2.60758 5.9742 2.60494 6.01947 2.61636 6.0622L3.99157 11.3156C3.99855 11.3423 4.01073 11.3673 4.02742 11.3892C4.04411 11.4111 4.06498 11.4294 4.08882 11.4432C4.11265 11.457 4.13899 11.466 4.1663 11.4695C4.19361 11.4731 4.22135 11.4712 4.24793 11.464L7.84396 10.4874C7.87088 10.48 7.89609 10.4674 7.91814 10.4503L10.4596 8.44546C10.4852 8.42525 10.5057 8.3993 10.5195 8.36972C10.5333 8.34013 10.5399 8.30773 10.5388 8.27512C10.5378 8.24251 10.5291 8.2106 10.5135 8.18196C10.4978 8.15332 10.4757 8.12875 10.4488 8.11023L3.83381 3.55967C3.80789 3.54199 3.77831 3.5304 3.74728 3.52574C3.71624 3.52109 3.68456 3.5235 3.65459 3.5328C3.62462 3.5421 3.59714 3.55804 3.57419 3.57944C3.55124 3.60084 3.53342 3.62715 3.52205 3.65639Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M20.4769 3.65579L21.3751 5.93247C21.3905 5.97318 21.3926 6.01772 21.3812 6.05971L20.0055 11.3131C19.9986 11.3398 19.9864 11.3648 19.9697 11.3868C19.9531 11.4087 19.9322 11.4271 19.9083 11.4409C19.8845 11.4547 19.8581 11.4637 19.8308 11.4672C19.8035 11.4707 19.7757 11.4688 19.7491 11.4615L16.1536 10.4849C16.1265 10.4776 16.1011 10.465 16.0789 10.4478L13.5402 8.44486C13.5146 8.42464 13.4941 8.3987 13.4804 8.36911C13.4666 8.33953 13.46 8.30713 13.461 8.27452C13.4621 8.24191 13.4708 8.21 13.4864 8.18136C13.502 8.15272 13.5242 8.12815 13.551 8.10962L20.1651 3.5586C20.1911 3.54093 20.2207 3.52935 20.2517 3.52473C20.2828 3.52011 20.3145 3.52256 20.3445 3.53191C20.3744 3.54125 20.4019 3.55725 20.4248 3.5787C20.4478 3.60015 20.4656 3.6265 20.4769 3.65579Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M12.0207 18.4083L13.4231 18.3886C13.4525 18.3883 13.4814 18.3817 13.5081 18.3693C13.5347 18.357 13.5585 18.3391 13.5777 18.317C13.597 18.2948 13.6113 18.2688 13.6198 18.2407C13.6282 18.2126 13.6307 18.183 13.6269 18.1539L13.5006 17.1796C13.5006 17.1796 13.4715 17.0873 13.4363 17.0542L13.1719 16.8063C13.1337 16.7706 13.0834 16.7505 13.0311 16.75H10.9652C10.9128 16.7503 10.8625 16.7705 10.8244 16.8063L10.5595 17.0542C10.5244 17.0875 10.5018 17.1317 10.4952 17.1796L10.3689 18.1539C10.3651 18.183 10.3676 18.2126 10.376 18.2407C10.3845 18.2688 10.3989 18.2948 10.4181 18.317C10.4374 18.3391 10.4611 18.357 10.4877 18.3693C10.5144 18.3817 10.5433 18.3883 10.5727 18.3886L11.9751 18.4083H12.0221H12.0207Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M10.5996 14.2627L9.97633 12.997C9.94507 12.9342 9.89024 12.8864 9.82382 12.864C9.7574 12.8415 9.6848 12.8463 9.62188 12.8772L8.15021 13.5957C8.10132 13.6194 8.06089 13.6576 8.03436 13.705C8.00783 13.7525 7.99648 13.8069 8.00183 13.861C8.00718 13.9151 8.02897 13.9662 8.06428 14.0075C8.09959 14.0488 8.14671 14.0783 8.1993 14.092L10.2949 14.6411C10.3446 14.6543 10.397 14.6528 10.4459 14.6368C10.4948 14.6208 10.5379 14.591 10.5702 14.5509C10.6025 14.5109 10.6224 14.4623 10.6276 14.4112C10.6328 14.36 10.6231 14.3084 10.5996 14.2627Z",
    fill: fill || '#2E7DAF'
  }), React.createElement("path", {
    d: "M13.6584 14.2626L14.2817 12.9968C14.3131 12.9341 14.368 12.8864 14.4343 12.864C14.5007 12.8416 14.5733 12.8462 14.6362 12.877L16.1081 13.5956C16.1569 13.6193 16.1974 13.6575 16.2239 13.7049C16.2504 13.7524 16.2618 13.8068 16.2565 13.8609C16.2511 13.915 16.2293 13.9661 16.194 14.0074C16.1587 14.0488 16.1116 14.0783 16.059 14.092L13.9632 14.6411C13.9135 14.6543 13.861 14.6528 13.8121 14.6368C13.7632 14.6208 13.7201 14.591 13.6878 14.5509C13.6555 14.5108 13.6356 14.4623 13.6304 14.4111C13.6251 14.36 13.6349 14.3084 13.6584 14.2626Z",
    fill: fill || '#2E7DAF'
  }));
};

var iconTypes = {
  ada: 'ada',
  arrowCircleDown: 'arrowCircleDown',
  arrowCircleLeft: 'arrowCircleLeft',
  arrowCircleRight: 'arrowCircleRight',
  atomicApi: 'atomicApi',
  avax: 'avax',
  bell: 'bell',
  bin: 'bin',
  bnb: 'bnb',
  book: 'book',
  btc: 'btc',
  calendar: 'calendar',
  camera: 'camera',
  cart: 'cart',
  chainlink: 'chainlink',
  chart: 'chart',
  check: 'check',
  checkmark: 'checkmark',
  chevronDown: 'chevronDown',
  chevronLeft: 'chevronLeft',
  chevronLeftX2: 'chevronLeftX2',
  chevronRight: 'chevronRight',
  chevronRightX2: 'chevronRightX2',
  chevronUp: 'chevronUp',
  cloud: 'cloud',
  cog: 'cog',
  copy: 'copy',
  creditCard: 'credit card',
  cube: 'cube',
  dapps: 'dapps',
  discord: 'discord',
  doge: 'doge',
  download: 'download',
  downloadCloud: 'downloadCloud',
  edit: 'edit',
  eth: 'eth',
  exclamation: 'exclamation',
  expand: 'expand',
  externalLink: 'externalLink',
  eye: 'eye',
  eyeClosed: 'eyeClosed',
  fil: 'fil',
  file: 'file',
  github: 'github',
  grid: 'grid',
  helpCircle: 'helpCircle',
  image: 'image',
  info: 'info',
  lifeRing: 'lifeRing',
  link: 'link',
  linux: 'linux',
  list: 'list',
  lockClosed: 'lockClosed',
  lockOpen: 'lockOpen',
  logOut: 'logOut',
  mail: 'mail',
  matic: 'matic',
  maximize: 'maximize',
  metamask: 'metamask',
  metamaskLined: 'metamaskLined',
  messageCircle: 'messageCircle',
  minimize: 'minimize',
  minus: 'minus',
  monitor: 'monitor',
  more: 'more',
  moreVert: 'moreVert',
  network: 'network',
  off: 'off',
  oneinch: 'oneinch',
  paperclip: 'paperclip',
  pin: 'pin',
  plug: 'plug',
  plus: 'plus',
  pulse: 'pulse',
  reddit: 'reddit',
  reload: 'reload',
  search: 'search',
  server: 'server',
  shib: 'shib',
  speedyNode: 'speedyNode',
  star: 'star',
  stars: 'stars',
  telegram: 'telegram',
  testnet: 'testnet',
  triangleDown: 'triangleDown',
  triangleUp: 'triangleUp',
  twitter: 'twitter',
  uni: 'uni',
  update: 'update',
  usdc: 'usdc',
  usdt: 'usdt',
  user: 'user',
  web3api: 'web3api',
  windows: 'windows',
  x: 'x',
  xCircle: 'xCircle',
  xrp: 'xrp',
  youtube: 'youtube'
};
var collection = {
  adaIcon: adaIcon,
  arrowCircleDownIcon: arrowCircleDownIcon,
  arrowCircleLeftIcon: arrowCircleLeftIcon,
  arrowCircleRightIcon: arrowCircleRightIcon,
  atomicApiIcon: atomicApiIcon,
  avaxIcon: avaxIcon,
  bellIcon: bellIcon,
  binIcon: binIcon,
  bnbIcon: bnbIcon,
  bookIcon: bookIcon,
  btcIcon: btcIcon,
  calendarIcon: calendarIcon,
  cameraIcon: cameraIcon,
  cartIcon: cartIcon,
  chainlinkIcon: chainlinkIcon,
  chartIcon: chartIcon,
  checkIcon: checkIcon,
  checkmarkIcon: checkmarkIcon,
  chevronDownIcon: chevronDownIcon,
  chevronLeftIcon: chevronLeftIcon,
  chevronLeftX2Icon: chevronLeftX2Icon,
  chevronRightIcon: chevronRightIcon,
  chevronRightX2Icon: chevronRightX2Icon,
  chevronUpIcon: chevronUpIcon,
  cloudIcon: cloudIcon,
  cogIcon: cogIcon,
  copyIcon: copyIcon,
  creditCardIcon: creditCardIcon,
  cubeIcon: cubeIcon,
  dappsIcon: dappsIcon,
  discordIcon: discordIcon,
  dogeIcon: dogeIcon,
  downloadCloudIcon: downloadCloudIcon,
  downloadIcon: downloadIcon,
  editIcon: editIcon,
  ethIcon: ethIcon,
  exclamationIcon: exclamationIcon,
  expandIcon: expandIcon,
  externalLinkIcon: externalLinkIcon,
  eyeClosedIcon: eyeClosedIcon,
  eyeIcon: eyeIcon,
  fileIcon: fileIcon,
  filIcon: filIcon,
  githubIcon: githubIcon,
  gridIcon: gridIcon,
  helpCircleIcon: helpCircleIcon,
  imageIcon: imagineIcon,
  infoIcon: infoIcon,
  lifeRingIcon: lifeRingIcon,
  linkIcon: linkIcon,
  linuxIcon: linuxIcon,
  listIcon: listIcon,
  lockClosedIcon: lockClosedIcon,
  lockOpenIcon: lockOpenIcon,
  logOutIcon: logOutIcon,
  mailIcon: mailIcon,
  maticIcon: maticIcon,
  maximizeIcon: maximizeIcon,
  messageCircleIcon: messageCircleIcon,
  metamaskIcon: metamaskIcon,
  metamaskLinedIcon: metamaskLinedIcon,
  minimizeIcon: minimizeIcon,
  minusIcon: minusIcon,
  monitorIcon: monitorIcon,
  moreIcon: moreIcon,
  moreVertIcon: moreVertIcon,
  networkIcon: networkIcon,
  offIcon: offIcon,
  oneinchIcon: oneinchIcon,
  paperclipIcon: paperclipIcon,
  pinIcon: pinIcon,
  plugIcon: plugIcon,
  plusIcon: plusIcon,
  pulseIcon: pulseIcon,
  redditIcon: redditIcon,
  reloadIcon: reloadIcon,
  searchIcon: searchIcon,
  serverIcon: serverIcon,
  shibIcon: shibIcon,
  speedyNodeIcon: speedyNodeIcon,
  starIcon: starIcon,
  starsIcon: starsIcon,
  telegramIcon: telegramIcon,
  testnetIcon: testnetIcon,
  triangleDownIcon: triangleDownIcon,
  triangleUpIcon: triangleUpIcon,
  twitterIcon: twitterIcon,
  uniIcon: uniIcon,
  updateIcon: updateIcon,
  usdcIcon: usdcIcon,
  usdtIcon: usdtIcon,
  userIcon: userIcon,
  web3apiIcon: web3apiIcon,
  windowsIcon: windowsIcon,
  xCircleIcon: xCircleIcon,
  xIcon: xIcon,
  xrpIcon: xrpIcon,
  youtubeIcon: youtubeIcon
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;
var StyledIconDiv = /*#__PURE__*/styled.div(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    line-height: 0px;\n    pointer-events: none;\n"])));

/* eslint-disable linebreak-style */

var Icon = function Icon(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'inherit' : _ref$fill,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size,
      svg = _ref.svg,
      style = _ref.style;

  var getIcon = function getIcon(fill, size, svg, style) {
    var key = svg + 'Icon';
    if (!collection[key]) throw new Error("no icon found: '" + key + "'");
    return collection[key](fill, size, style);
  };

  return React.createElement(StyledIconDiv, null, getIcon(fill, size, svg, style));
};

var color = {
  beauBlue: '#CEE4F3',
  black: '#000000',
  blue: '#2E7DAF',
  blueCloud: '#EEF6FB',
  blueCloudDark: '#3092CF',
  blueDark: '#041836',
  blueDark2: '#112F5C',
  blueLight: '#F2F6FF',
  blueLight2: '#E5EDFF',
  blueLight3: '#E6EDFF',
  blueSky: '#9ECCEA',
  blueSkyDark: '#51A5DA',
  blueSkyLight: '#E8EAED',
  green: '#21BF96',
  greenDark: '#0FA67F',
  greenForestDark: '#3BC49D',
  greenForestLight: '#EBF9F5',
  greenLight: '#7AD9C0',
  grey: '#68738D',
  greyDark: '#333333',
  greyDisabled: '#D7DAE0',
  greyIcons: '#B0B5BF',
  greyLight: '#C5CDD9',
  paleBlue2: '#C1D8E7',
  paleCerulean: '#9EC7EA',
  pink: '#DA51BE',
  pinkDark: '#E01FB3',
  pinkLight: '#FDF0FA',
  purple: '#8851DA',
  purpleDark: '#6D30CF',
  purpleLight: '#F3EEFB',
  red: '#EB5757',
  redDark: '#E01F1F',
  redLight: '#FDF0F0',
  white: '#FFFFFF',
  yellow: '#ECA609',
  yellowDark: '#F1A90E',
  yellowLight: '#FEF9EE'
};
var gradientColors = {
  beauBlue: 'radial-gradient(106.45% 108.64% at 32.33% -4.84%, #ECF5FC 0.52%, #CEE4F3 100%)',
  blue: 'linear-gradient(113.54deg, rgba(60, 87, 140, 0.5) 14.91%, rgba(70, 86, 169, 0.5) 30.39%, rgba(129, 161, 225, 0.185) 55.76%), linear-gradient(151.07deg, #145559 33.25%, #414FA7 98.24%)',
  goldShiny: 'linear-gradient(113.54deg, rgba(199, 148, 37, 0.6) 14.91%, rgba(204, 147, 23, 0.6) 14.92%, rgba(181, 147, 24, 0) 45.98%, rgba(250, 228, 30, 0) 55.76%, rgba(219, 200, 26, 0) 55.76%), linear-gradient(147.17deg, #DBBB14 48.73%, #B38311 98.22%)',
  lightBlue: 'linear-gradient(113.54deg, rgba(117, 183, 251, 0.531738) 14.91%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #427ACB 41.37%, #45FFFF 98.29%)',
  lightGrey: 'linear-gradient(90deg,rgba(221, 221, 221, 0),rgba(232, 232, 232, 0.6),rgba(221, 221, 221, 0))',
  purpleToPink: 'linear-gradient(113.54deg, rgba(103, 58, 194, 0.6) 14.91%, rgba(122, 74, 221, 0.498) 25.92%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #7A4ADD 41.37%, #D57BFF 98.29%)'
};
var getShade = function getShade(shade, percent) {
  return "rgba(\n    " + (shade === 'light' ? '255, 255, 255,' : '0, 0, 0,') + "\n    " + String(percent / 100) + "\n  )";
};
var colorPercentage = function colorPercentage(color, percentage) {
  var r = parseInt(color.slice(1, 3), 16);
  var g = parseInt(color.slice(3, 5), 16);
  var b = parseInt(color.slice(5, 7), 16);
  return "rgba(" + r + "," + g + "," + b + "," + Number(percentage) / 100 + ")";
};

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var coloredGreen = /*#__PURE__*/css(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.greenForestLight, color.green);
var coloredGreenDark = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.greenForestDark, color.white);
var coloredRed = /*#__PURE__*/css(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.redLight, color.red);
var coloredRedDark = /*#__PURE__*/css(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.redDark, color.white);
var coloredGrey = /*#__PURE__*/css(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.blueSkyLight, color.blueDark);
var coloredGrayDark = /*#__PURE__*/css(_templateObject6 || (_templateObject6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.grey, color.white);
var coloredYellow = /*#__PURE__*/css(_templateObject7 || (_templateObject7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.yellowLight, color.yellow);
var coloredYellowDark = /*#__PURE__*/css(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.yellowDark, color.white);
var coloredBlue = /*#__PURE__*/css(_templateObject9 || (_templateObject9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.blueCloud, color.blueSkyDark);
var coloredBlueDark = /*#__PURE__*/css(_templateObject10 || (_templateObject10 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.blueCloudDark, color.white);
var coloredPurple = /*#__PURE__*/css(_templateObject11 || (_templateObject11 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.purpleLight, color.purple);
var coloredPurpleDark = /*#__PURE__*/css(_templateObject12 || (_templateObject12 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.purpleDark, color.white);
var coloredPink = /*#__PURE__*/css(_templateObject13 || (_templateObject13 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.pinkLight, color.pink);
var coloredPinkDark = /*#__PURE__*/css(_templateObject14 || (_templateObject14 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.pinkDark, color.white);
var coloredBlueLight = /*#__PURE__*/css(_templateObject15 || (_templateObject15 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), color.blueLight3, color.blue);

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16, _templateObject17, _templateObject18;
var heading = /*#__PURE__*/css(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    -webkit-font-smoothing: antialiased;\n    color: ", ";\n    fill: ", ";\n    font-family: 'Montserrat', sans-serif;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n    letter-spacing: 0;\n"])), color.grey, color.grey);
var h1 = /*#__PURE__*/css(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 36px;\n    line-height: 40px;\n    letter-spacing: -0.75px;\n"])));
var h2 = /*#__PURE__*/css(_templateObject3$1 || (_templateObject3$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 28px;\n    line-height: 36px;\n"])));
var h3 = /*#__PURE__*/css(_templateObject4$1 || (_templateObject4$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32px;\n"])));
var h4 = /*#__PURE__*/css(_templateObject5$1 || (_templateObject5$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 20px;\n    line-height: 28px;\n"])));
var h5 = /*#__PURE__*/css(_templateObject6$1 || (_templateObject6$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 16px;\n    line-height: 25px;\n"])));
var ibm = /*#__PURE__*/css(_templateObject7$1 || (_templateObject7$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: IBM Plex Mono, sans-serif;\n    font-size: 16px;\n    font-style: normal;\n"])));
var ibmMono = /*#__PURE__*/css(_templateObject8$1 || (_templateObject8$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: IBM Plex Mono, monospace;\n    font-size: 14px;\n"])));
var text = /*#__PURE__*/css(_templateObject9$1 || (_templateObject9$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    -webkit-font-smoothing: antialiased;\n    color: ", ";\n    fill: ", ";\n    font-family: 'Open Sans', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0;\n    line-height: 24px;\n"])), color.grey, color.grey);
var textBold500 = /*#__PURE__*/css(_templateObject10$1 || (_templateObject10$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-weight: 500;\n"])));
var textBold = /*#__PURE__*/css(_templateObject11$1 || (_templateObject11$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-weight: 600;\n"])));
var textBold700 = /*#__PURE__*/css(_templateObject12$1 || (_templateObject12$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-weight: 700;\n"])));
var textSmall = /*#__PURE__*/css(_templateObject13$1 || (_templateObject13$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0;\n    line-height: 24px;\n"])));
var semiBold = /*#__PURE__*/css(_templateObject14$1 || (_templateObject14$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-weight: 600;\n"])), text);
var argentumSans = /*#__PURE__*/css(_templateObject15$1 || (_templateObject15$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @import url('//db.onlinewebfonts.com/c/203f1615b37d6fb2fcd85695bc4c4b00?family=Argentum+Sans');\n    font-family: 'Argentum Sans', sans-serif;\n"])));
var openSans = /*#__PURE__*/css(_templateObject16 || (_templateObject16 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @import url('//fonts.googleapis.com/css?family=Open+Sans');\n    font-family: 'Open Sans', sans-serif;\n"])));
var montserrat = /*#__PURE__*/css(_templateObject17 || (_templateObject17 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @import url('//fonts.googleapis.com/css2?family=Montserrat');\n    font-family: 'Montserrat', sans-serif;\n"])));
var creepster = /*#__PURE__*/css(_templateObject18 || (_templateObject18 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @import url('//fonts.googleapis.com/css2?family=Creepster&display=swap');\n    font-family: 'Creepster', cursive;\n"])));
var fonts = {
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  h5: h5,
  heading: heading,
  ibm: ibm,
  ibmMono: ibmMono,
  text: text,
  textBold: textBold,
  textBold700: textBold700,
  textSmall: textSmall,
  semiBold: semiBold,
  textBold500: textBold500,
  openSans: openSans,
  montserrat: montserrat,
  argentumSans: argentumSans,
  creepster: creepster
};

var _templateObject$3, _templateObject2$2;
var resetCSS = /*#__PURE__*/css(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border: none;\n    box-sizing: border-box;\n    line-height: 1;\n    margin: 0;\n    outline: none;\n    padding: 0;\n"])));
var resetButtonCSS = /*#__PURE__*/css(_templateObject2$2 || (_templateObject2$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: none;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    font: inherit;\n    outline: inherit;\n    padding: 0;\n"])));

var _templateObject$4, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$2;
var initialStyles = /*#__PURE__*/css(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    ", ";\n    align-items: center;\n    border-radius: 20px;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    overflow: hidden;\n    padding: 2px 20px;\n    text-align: center;\n    width: 100%;\n"])), resetCSS, fonts.text, fonts.textBold700);
var regular = /*#__PURE__*/css(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n"])), color.blueLight);
var activeStatus = /*#__PURE__*/css(_templateObject3$2 || (_templateObject3$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n    display: flex;\n\n    svg {\n        fill: ", ";\n        padding-right: 5px;\n    }\n"])), color.greenForestLight, color.green, color.green);
var inactiveStatus = /*#__PURE__*/css(_templateObject4$2 || (_templateObject4$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n"])), color.blueLight);
var discount = /*#__PURE__*/css(_templateObject5$2 || (_templateObject5$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    background: ", ";\n    border-radius: 30px;\n    color: ", ";\n    display: flex;\n    font-size: 12px;\n    height: 32px;\n    justify-content: center;\n    padding: 0 4px;\n    width: 32px;\n"])), color.green, color.white);

var _templateObject$5, _templateObject2$4;

var getTheme = function getTheme(theme, active) {
  switch (theme) {
    case 'status':
      return active ? activeStatus : inactiveStatus;

    case 'discount':
      return discount;

    default:
      return regular;
  }
};

var getColors = function getColors(color, tone) {
  switch (color) {
    case 'green':
      return tone === 'light' ? coloredGreen : coloredGreenDark;

    case 'red':
      return tone === 'light' ? coloredRed : coloredRedDark;

    case 'yellow':
      return tone === 'light' ? coloredYellow : coloredYellowDark;

    case 'blue':
      return tone === 'light' ? coloredBlue : coloredBlueDark;

    case 'blueLight':
      return coloredBlueLight;

    case 'purple':
      return tone === 'light' ? coloredPurple : coloredPurpleDark;

    case 'pink':
      return tone === 'light' ? coloredPink : coloredPinkDark;

    case 'grey':
      return tone === 'light' ? coloredGrey : coloredGrayDark;

    default:
      return coloredGrey;
  }
};

var SpanStyled = /*#__PURE__*/styled.div(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    cursor: pointer;\n    margin-left: 16px;\n"])));
var TagStyled = /*#__PURE__*/styled.div(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    ", "\n    width: ", ";\n\n    ", ";\n\n    ", ";\n"])), initialStyles, function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return getTheme(theme, active);
}, function (_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme,
      tone = _ref2.tone;
  return theme !== 'status' && color && getColors(color, tone);
}, function (_ref3) {
  var width = _ref3.width;
  return width;
}, function (_ref4) {
  var width = _ref4.width,
      theme = _ref4.theme;
  return theme === 'discount' && Boolean(width) && "height: " + width + "; width: " + width + "; border-radius: 50%;";
}, function (_ref5) {
  var fontSize = _ref5.fontSize;
  return Boolean(fontSize) && "font-size: " + fontSize;
});

var Tag = function Tag(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      color$1 = _ref.color,
      fontSize = _ref.fontSize,
      id = _ref.id,
      _ref$hasCancel = _ref.hasCancel,
      hasCancel = _ref$hasCancel === void 0 ? false : _ref$hasCancel,
      onCancelClick = _ref.onCancelClick,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Tag' : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'regular' : _ref$theme,
      _ref$tone = _ref.tone,
      tone = _ref$tone === void 0 ? 'light' : _ref$tone,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'fit-content' : _ref$width;
  return React.createElement(TagStyled, {
    active: active,
    color: color$1,
    "data-testid": "test-tag-id",
    fontSize: fontSize,
    id: id,
    role: "status",
    theme: theme,
    tone: tone,
    width: width
  }, theme === 'status' && active && React.createElement(Icon, {
    fill: "inherit",
    size: 16,
    svg: iconTypes.checkmark
  }), React.createElement("strong", {
    "data-testid": "test-tag-text"
  }, text), hasCancel && React.createElement(SpanStyled, {
    onClick: onCancelClick
  }, React.createElement(Icon, {
    fill: color.blue,
    size: 16,
    svg: "x",
    style: {
      marginLeft: '8px'
    }
  })));
};

var _templateObject$6, _templateObject2$5, _templateObject3$3, _templateObject4$3, _templateObject5$3;
var getThemeColor = function getThemeColor(theme) {
  switch (theme) {
    case 'blue':
      return color.blue;

    case 'red':
      return color.red;

    case 'green':
      return color.green;

    case 'yellow':
      return color.yellow;

    default:
      return color.blue;
  }
};
var SectionStyled = /*#__PURE__*/styled.section(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 20px;\n    opacity: 0%;\n    overflow: hidden;\n    transition-delay: 0.3s;\n    transition: opacity 0.3s ease-out;\n"])), color.white, function (p) {
  return getThemeColor(p.theme);
});
var HeaderStyled = /*#__PURE__*/styled.header(_templateObject2$5 || (_templateObject2$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    cursor: pointer;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding: 8px 12px;\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), color.paleBlue2);
var H4Styled = /*#__PURE__*/styled.h4(_templateObject3$3 || (_templateObject3$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    ", "\n    line-height: 1;\n    padding: 8px 0;\n"])), resetCSS, fonts.heading, fonts.h4);
var DivStyled = /*#__PURE__*/styled.div(_templateObject4$3 || (_templateObject4$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    justify-content: center;\n\n    p {\n        ", "\n        ", "\n        margin: 0 6px;\n        min-width: 100px;\n        text-align: right;\n    }\n\n    svg {\n        margin: 0 6px;\n        min-width: 18px;\n    }\n\n    div {\n        margin: 0 6px;\n    }\n\n    &:last-of-type {\n        margin-left: auto;\n    }\n"])), resetCSS, fonts.text);
var DivStyledContent = /*#__PURE__*/styled.div(_templateObject5$3 || (_templateObject5$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    overflow: hidden;\n    transition: max-height 0.3s ease-out;\n"])));

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      hasLockIcon = _ref.hasLockIcon,
      id = _ref.id,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      subTitle = _ref.subTitle,
      tagText = _ref.tagText,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'blue' : _ref$theme,
      title = _ref.title;

  var _useState = useState(isExpanded),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(''),
      height = _useState2[0],
      setHeight = _useState2[1];

  var _useState3 = useState('0%'),
      opacity = _useState3[0],
      setOpacity = _useState3[1];

  var _useState4 = useState(''),
      heightWhenOpen = _useState4[0],
      setHeightWhenOpen = _useState4[1];

  var formattedID = id.replace(/\s/g, '-');
  var divElement = useRef(null);
  useEffect(function () {
    var _divElement$current;

    setHeightWhenOpen(((_divElement$current = divElement.current) == null ? void 0 : _divElement$current.clientHeight) + "px");
    setHeight(isOpen ? heightWhenOpen : '0px');
    setOpacity('100%');
  }, []);

  var toggleOpen = function toggleOpen() {
    setHeight(isOpen ? '0px' : heightWhenOpen);
    setIsOpen(!isOpen);
  };

  return React.createElement(SectionStyled, {
    "aria-label": "Accordion item",
    "data-testid": "test-accordion",
    id: id,
    style: {
      opacity: opacity
    },
    theme: theme
  }, React.createElement(HeaderStyled, {
    "aria-controls": "content-" + formattedID,
    "aria-expanded": isOpen,
    "data-testid": "test-accordion-header",
    id: "accordion-control-" + formattedID,
    role: "button",
    onClick: toggleOpen
  }, React.createElement(DivStyled, null, React.createElement(Icon, {
    svg: isOpen ? iconTypes.minus : iconTypes.plus,
    fill: getThemeColor(theme)
  }), React.createElement(H4Styled, {
    "data-testid": "test-accordion-title"
  }, title)), React.createElement(DivStyled, null, subTitle && React.createElement("p", {
    "data-testid": "test-accordion-subtitle"
  }, subTitle), hasLockIcon && React.createElement(Icon, {
    svg: isOpen ? iconTypes.lockOpen : iconTypes.lockClosed,
    fill: getThemeColor(theme)
  }), tagText && React.createElement(Tag, {
    text: tagText,
    color: theme,
    tone: "dark"
  }))), React.createElement(DivStyledContent, {
    "aria-hidden": isOpen,
    "data-testid": "test-accordion-content",
    id: "content-" + formattedID,
    ref: divElement,
    style: {
      maxHeight: height
    }
  }, children));
};

var _templateObject$7, _templateObject2$6, _templateObject3$4;
var roundedEdgeValue = '50%';
var customBackgroundImage = /*#__PURE__*/css(_templateObject$7 || (_templateObject$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-image: url(", ");\n    background-position: center;\n    background-size: cover;\n"])), function (p) {
  return p.image;
});
var DivStyled$1 = /*#__PURE__*/styled.div(_templateObject2$6 || (_templateObject2$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: radial-gradient(\n        106.45% 108.64% at 32.33% -4.84%,\n        #ecf5fc 0.52%,\n        #cee4f3 100%\n    );\n    color: ", ";\n    height: ", "px;\n    overflow: hidden;\n    position: static;\n    text-transform: uppercase;\n    width: ", "px;\n    word-break: break-all;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: ", "px;\n\n    span {\n        display: none;\n    }\n    border-radius: ", ";\n    background: ", ";\n    ", "\n"])), function (props) {
  return props.textColor;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.fontSize;
}, function (p) {
  return "" + (p.isRounded ? roundedEdgeValue : p.borderRadius ? p.borderRadius + "px" : 0 + "px");
}, function (p) {
  return p.avatarBackground;
}, function (p) {
  return p.theme === 'image' && p.image && customBackgroundImage;
});
var H4Styled$1 = /*#__PURE__*/styled.h4(_templateObject3$4 || (_templateObject3$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    color: ", ";\n    font-size: inherit;\n"])), fonts.h4, fonts.openSans, fonts.textBold700, resetCSS, function (props) {
  return props.color;
});

var renderAvatarSVG = function renderAvatarSVG() {
  return React.createElement("svg", {
    fill: "none",
    height: "40",
    viewBox: "0 0 40 40",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_10877_58906)"
  }, React.createElement("rect", {
    width: "40",
    height: "40",
    fill: "white"
  }), React.createElement("path", {
    d: "M2655.97 1057.92L2057.33 379.103C1974.04 358.083 1855.23 342.077 1768.36 386.995C1562.46 493.432 1477.8 775.773 1221.78 809.817C1021.37 836.472 989.753 682.586 779.595 788.994C548.347 906.028 635.71 1038.26 388.719 1188.91C141.728 1339.56 56.6274 1011.8 -190.072 1158.21C-252.53 1195.35 -301.639 1253.8 -340.231 1320.53L840.276 2659.15L2655.97 1057.92Z",
    fill: "url(#paint0_linear_10877_58906)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.737 116.96C511.511 272.122 425.49 442.871 300.446 558.684C185.56 665.091 21.4207 705.627 -117.844 633.385C-261.418 558.908 -339.193 399.814 -313.765 240.07C-287.201 73.1916 -168.35 -67.7567 -1.90678 -94.951C175.938 -124.008 363.851 -47.093 439.737 116.96Z",
    fill: "#21BF96"
  }), React.createElement("g", {
    opacity: "0.6",
    filter: "url(#filter0_f_10877_58906)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.359 394.15C264.368 312.52 332.423 143.281 391.099 155.128C445.008 166.014 402.95 286.025 358.726 367.158C313.132 450.802 223.772 536.204 137.68 579.776C47.742 625.295 -116.532 625.735 -125.499 567.1C-135.08 504.447 85.365 480.457 177.359 394.15Z",
    fill: "url(#paint1_radial_10877_58906)"
  })), React.createElement("g", {
    filter: "url(#filter1_d_10877_58906)"
  }, React.createElement("path", {
    d: "M41.5756 40.4351C41.5141 39.8975 41.3817 32.4488 40.4484 27.2467C40.4484 27.2467 53.821 28.186 54.7487 27.7444C55.0811 27.5837 56.6429 26.0358 58.5677 24.1074C61.8308 20.8758 66.1678 16.5713 67.6046 16.1229C69.8984 15.3833 71.1984 14.878 72.6334 15.572C74.0684 16.266 74.9137 16.8282 74.0474 17.8074C73.0553 18.9364 71.0015 18.2202 71.0015 18.2202C71.0015 18.2202 70.6387 19.6055 69.1798 22.6828C69.1798 22.6828 64.0753 33.8454 57.1038 37.6459C55.1911 38.6936 41.5756 40.4351 41.5756 40.4351Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M-0.986503 43.669C-0.986503 43.669 3.8564 49.2966 7.91557 50.2329L8.27048 49.4256C8.27048 49.4256 9.31383 65.7372 12.5173 73.9434C13.0355 75.2856 39.3018 69.8623 41.5502 67.4015C41.5502 67.4015 37.7196 47.6658 36.9513 41.4612L42.0353 40.8835C42.0353 40.8835 42.1205 29.5839 40.4329 27.2346C40.4329 27.2346 28.4281 25.8873 22.0257 28.319C15.6233 30.7507 8.33864 31.2984 3.60985 36.0929C-0.49119 40.249 -0.986503 43.669 -0.986503 43.669Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M42.0356 40.9101L36.9516 41.4877L36.191 39.7568L42.0356 40.9101Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M23.2713 12.7689C24.3024 14.8339 27.2744 20.8483 26.1859 22.9945C25.0974 25.1407 22.7183 26.0994 22.7183 26.0994L21.8438 28.689C22.2184 29.4649 21.3266 31.311 19.6239 33.1047C18.3677 34.4365 15.9175 33.536 15.1141 31.9283C14.7526 31.1939 12.7221 27.7663 12.7221 27.7663C12.7221 27.7663 9.08349 21.2061 9.33543 18.8695C9.58737 16.533 9.78318 14.2782 14.5973 12.3066C21.9843 9.29647 23.2713 12.7689 23.2713 12.7689Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M12.9772 23.2278C13.6899 24.435 14.5718 27.3514 13.5774 27.6407C12.583 27.93 11.4777 27.268 10.2826 25.1182C9.08758 22.9683 5.69286 18.6962 6.33899 16.7091C6.98511 14.722 8.34359 14.9745 8.34359 14.9745C8.34359 14.9745 5.00401 12.7129 6.33897 10.6526C6.33897 10.6526 6.66675 9.81739 8.31551 11.9872C8.31551 11.9872 7.23424 9.56359 9.59795 7.72377C11.9617 5.88396 15.6038 8.14973 15.6038 8.14973C15.6038 8.14973 14.9703 7.19132 15.9462 6.24108C16.9221 5.29083 19.7834 5.30229 20.9814 7.23193C20.9814 7.23193 22.7033 4.03441 25.9543 4.72565C29.2052 5.4169 31.1543 7.75596 28.8031 11.702C26.3393 15.8392 22.5957 11.934 21.6054 11.9205C20.6151 11.907 19.5016 11.8505 18.3117 14.3671C17.1219 16.8836 13.1897 16.7199 13.1897 16.7199C13.1897 16.7199 15.2978 19.5016 15.2078 20.051C15.1178 20.6003 14.8028 21.5045 13.8166 20.1834C12.8303 18.8623 13.1476 18.7978 12.7376 18.5995C12.3276 18.4012 10.8482 17.9406 10.5743 19.8639C10.27 22.0071 12.9772 23.2278 12.9772 23.2278Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M13.9268 23.1445C12.5774 23.2362 11.0034 22.6504 10.587 20.9104C10.1705 19.1704 11.0943 17.9992 11.822 18.1055C12.5496 18.2118 13.3534 18.7871 13.8471 19.9087",
    stroke: "#041836",
    strokeWidth: "2.1688",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.34365 14.9752C8.34365 14.9752 6.54126 13.9871 4.87842 14.873",
    stroke: "#041836",
    strokeWidth: "2.1688",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M11.9285 73.7021L6.29912 36.5714",
    stroke: "#041836",
    strokeWidth: "2.1688",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M14.248 31.8201C14.4094 33.1025 17.2106 36.513 20.0072 34.1973C22.8039 31.8817 23.3505 29.1224 23.3505 29.1224",
    stroke: "#041836",
    strokeWidth: "2.1688",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M12.9428 91.8226L12.9443 71.0192C12.9443 71.0192 11.1314 46.8785 11.3347 43.7516L11.6749 33.5597",
    stroke: "#041836",
    strokeWidth: "2.1688",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M39.0663 26.6921C41.1035 29.6242 40.6686 40.3409 40.6686 40.3409",
    stroke: "#041836",
    strokeWidth: "2.1688",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M21.8292 28.7024L22.7036 26.1127C22.7036 26.1127 21.1097 26.9857 19.8753 26.7212C19.258 26.5889 18.8624 27.3543 19.3101 27.8146C19.7853 28.2753 20.5642 28.6576 21.8292 28.7024Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M18.7236 18.4468C18.8152 18.7922 19.0598 19.0158 19.2806 18.9637C19.5014 18.9117 19.6159 18.5829 19.5243 18.2375C19.4328 17.8921 19.1882 17.6686 18.9674 17.7206C18.7466 17.7727 18.6456 18.1154 18.7236 18.4468Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M22.5884 17.4805C22.68 17.8259 22.9246 18.0495 23.1454 17.9974C23.3662 17.9454 23.4807 17.6166 23.3892 17.2712C23.2976 16.9258 23.053 16.7023 22.8322 16.7543C22.6114 16.8064 22.4968 17.1352 22.5884 17.4805Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M21.3989 17.9601C21.3989 17.9601 22.6816 19.7257 23.7722 20.4563C23.3084 21.1794 22.2216 21.1784 22.2216 21.1784L21.3989 17.9601Z",
    fill: "#21BF96"
  }), React.createElement("path", {
    d: "M20.6904 22.479C20.9244 22.4684 21.1999 22.4447 21.4621 22.3794C21.5175 22.3527 21.5593 22.3119 21.5326 22.2565C21.5058 22.2011 21.4651 22.1592 21.4097 22.186C19.9051 22.5647 18.954 21.6983 18.9404 21.6844C18.8997 21.6425 18.8308 21.6554 18.7889 21.6961C18.7471 21.7368 18.7599 21.8058 18.8006 21.8476C18.8417 21.862 19.5347 22.4908 20.6904 22.479Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M17.2094 17.5042C17.2919 17.5053 17.3612 17.4649 17.3899 17.3827C17.7591 16.5343 18.4901 16.3929 18.5041 16.3793C18.6145 16.3533 18.6846 16.2579 18.6725 16.1338C18.6465 16.0233 18.5512 15.9532 18.4272 15.9653C18.3857 15.9785 17.4478 16.1584 17.007 17.2123C16.9644 17.3081 17.0175 17.4465 17.1133 17.4891C17.1543 17.5034 17.1819 17.5038 17.2094 17.5042Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M23.8919 15.7228C23.9469 15.7235 23.9883 15.7103 24.0302 15.6696C24.1138 15.5882 24.1292 15.4645 24.0478 15.3808C23.3032 14.5035 22.3525 14.6144 22.325 14.6141C22.201 14.6261 22.1309 14.7215 22.143 14.8456C22.1551 14.9696 22.2644 15.0262 22.3744 15.0277C22.4158 15.0145 23.1457 14.9556 23.7415 15.6519C23.7683 15.7073 23.8369 15.722 23.8919 15.7228Z",
    fill: "#041836"
  })), React.createElement("path", {
    d: "M-1.07651 45.8184C-0.633859 49.0539 4.02847 57.6014 13.4115 60.397C19.1449 62.1096 26.8011 61.8608 36.868 56.6284C37.1865 56.4506 40.9735 54.7479 41.8552 53.1975C42.7068 51.7242 39.349 53.239 39.7547 52.9974C40.3012 52.6686 41.1528 52.219 41.6557 51.8197C42.4352 51.1905 43.2131 50.1334 42.3011 49.9185C41.3891 49.7035 39.535 50.7839 39.535 50.7839C39.535 50.7839 42.5794 48.8882 41.9088 48.0557C41.2382 47.2232 38.1201 48.921 38.1201 48.921C38.1201 48.921 41.6506 46.646 40.4637 46.0652C39.783 45.7362 38.4335 46.4357 37.54 46.8333C36.1821 47.4406 34.8141 48.3465 33.8385 48.8632C33.8385 48.8632 35.9457 45.8614 34.9449 45.6918C33.944 45.5221 30.9232 49.1094 30.3147 49.7789C29.6894 50.4685 18.0785 52.4166 13.77 47.9689C9.46146 43.5211 9.23008 41.9973 7.76487 41.4232C6.2829 40.8691 -1.72874 41.0944 -1.07651 45.8184Z",
    fill: "white",
    stroke: "#041836",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M3.63442 55.7202C3.63442 55.7202 9.651 50.5207 13.8336 48.0562C13.8336 48.0562 8.48903 41.0038 7.82001 35.0715C6.69849 35.4154 3.35568 34.4348 0.0431878 40.3379C-1.71699 43.4757 -3.71183 48.5333 3.63442 55.7202Z",
    fill: "#041836"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "filter0_f_10877_58906",
    x: "-245.802",
    y: "34.5374",
    width: "782.296",
    height: "698.094",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React.createElement("feGaussianBlur", {
    stdDeviation: "60",
    result: "effect1_foregroundBlur_10877_58906"
  })), React.createElement("filter", {
    id: "filter1_d_10877_58906",
    x: "-91.406",
    y: "-85.3722",
    width: "277.847",
    height: "321.256",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dx: "10",
    dy: "10"
  }), React.createElement("feGaussianBlur", {
    stdDeviation: "50"
  }), React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0159375 0 0 0 0 0.0945625 0 0 0 0 0.2125 0 0 0 0.2 0"
  }), React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10877_58906"
  }), React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10877_58906",
    result: "shape"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_10877_58906",
    x1: "1748.12",
    y1: "1858.54",
    x2: "548.994",
    y2: "498.799",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#21BF96"
  }), React.createElement("stop", {
    offset: "0.9999",
    stopColor: "#DAFF51"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#DAFF51"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_10877_58906",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.676 395.235) rotate(-43.7182) scale(263.015 120.42)"
  }, React.createElement("stop", {
    stopColor: "#B7E803"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#DAFF51"
  })), React.createElement("clipPath", {
    id: "clip0_10877_58906"
  }, React.createElement("rect", {
    width: "40",
    height: "40",
    fill: "white"
  }))));
};

var avatarColors = ['#FEB7B7', '#E1B5F6', '#A7D6F9', '#AADCD6', '#F0DC7D'];

var Avatar = function Avatar(_ref) {
  var avatarBackground = _ref.avatarBackground,
      borderRadius = _ref.borderRadius,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 15 : _ref$fontSize,
      image = _ref.image,
      _ref$isRounded = _ref.isRounded,
      isRounded = _ref$isRounded === void 0 ? false : _ref$isRounded,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size,
      text = _ref.text,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? color.white : _ref$textColor,
      theme = _ref.theme,
      _ref$avatarKey = _ref.avatarKey,
      avatarKey = _ref$avatarKey === void 0 ? 1 : _ref$avatarKey;

  var getRandomColor = function getRandomColor() {
    if (avatarBackground) {
      return avatarBackground;
    }

    if (theme == 'image' || image) {
      return 'transparent';
    }

    var pos = avatarKey < avatarColors.length ? avatarKey % avatarColors.length : avatarColors.length % avatarKey;
    return avatarColors[pos - 1];
  };

  return React.createElement(DivStyled$1, {
    "aria-label": "users avatar",
    avatarBackground: getRandomColor(),
    borderRadius: borderRadius,
    "data-testid": "test-avatar",
    fontSize: fontSize,
    image: image,
    isRounded: isRounded,
    role: theme === 'image' ? 'img' : 'generic',
    size: size,
    textColor: textColor,
    theme: theme
  }, theme === 'image' ? !image && renderAvatarSVG() : React.createElement(H4Styled$1, {
    "data-testid": "test-text",
    textColor: textColor
  }, text && text.length > 1 ? "" + text[0] + text[1] : text));
};

var _templateObject$8;

var getBackgroundColor = function getBackgroundColor(type) {
  switch (type) {
    case 'danger':
      return color.red;

    case 'success':
      return color.green;

    case 'warning':
      return color.yellow;

    default:
      return color.blue;
  }
};

var DivStyled$2 = /*#__PURE__*/styled.div(_templateObject$8 || (_templateObject$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    align-items: center;\n    border-radius: 6px;\n    display: flex;\n    height: min-content;\n    justify-content: center;\n    overflow: hidden;\n    padding: 4px 10px;\n    width: min-content;\n    background-color: ", ";\n"])), resetCSS, fonts.text, function (_ref) {
  var _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'normal' : _ref$state;
  return getBackgroundColor(state);
});

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var _templateObject$9;
var ButtonStyled = /*#__PURE__*/styled.button(_templateObject$9 || (_templateObject$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    display: inline-block;\n    vertical-align: sub;\n\n    &:first-child {\n        fill: ", ";\n        transition: fill 0.2s ease-out;\n    }\n\n    &:hover > svg {\n        fill: ", ";\n    }\n"])), resetButtonCSS, color.grey, color.blue);

var useCopyToClipboard = function useCopyToClipboard() {
  var _useState = useState(null),
      copiedText = _useState[0],
      setCopiedText = _useState[1];

  var copy = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(text) {
      var _navigator;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if ((_navigator = navigator) != null && _navigator.clipboard) {
                _context.next = 3;
                break;
              }

              console.warn('Clipboard not supported');
              return _context.abrupt("return", false);

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return navigator.clipboard.writeText(text);

            case 6:
              setCopiedText(text);
              return _context.abrupt("return", true);

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.warn('Copy failed', _context.t0);
              setCopiedText(null);
              return _context.abrupt("return", false);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function copy(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return [copiedText, copy];
};

var CopyButton = function CopyButton(_ref2) {
  var text = _ref2.text,
      _ref2$iconSize = _ref2.iconSize,
      iconSize = _ref2$iconSize === void 0 ? 24 : _ref2$iconSize,
      _ref2$onCopy = _ref2.onCopy,
      onCopy = _ref2$onCopy === void 0 ? function () {} : _ref2$onCopy,
      _ref2$revertIn = _ref2.revertIn,
      revertIn = _ref2$revertIn === void 0 ? 3000 : _ref2$revertIn;

  var _useCopyToClipboard = useCopyToClipboard(),
      copy = _useCopyToClipboard[1];

  var _useState2 = useState(false),
      value = _useState2[0],
      set = _useState2[1];

  var copyToClipboard = function copyToClipboard() {
    copy("" + text);
    set(true);
    setTimeout(function () {
      set(false);
    }, revertIn);
  };

  return React.createElement(ButtonStyled, {
    className: "input_copy",
    "data-testid": "copy-icon",
    iconSize: iconSize,
    onClick: function onClick(e) {
      onCopy(e);
      copyToClipboard();
    }
  }, React.createElement(Icon, {
    fill: value ? color.green : color.blue,
    size: iconSize,
    svg: value ? iconTypes.check : iconTypes.copy
  }));
};

var _templateObject$a, _templateObject2$7, _templateObject3$5, _templateObject4$4, _templateObject5$4, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$1, _templateObject17$1, _templateObject18$1, _templateObject19, _templateObject20, _templateObject21;
var openSans$1 = /*#__PURE__*/css(_templateObject$a || (_templateObject$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @import url('https://fonts.googleapis.com/css?family=Open+Sans');\n    font-family: 'Open Sans', sans-serif;\n"])));
var argentumSans$1 = /*#__PURE__*/css(_templateObject2$7 || (_templateObject2$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/76f34d19f76c1aeaf5b5b59d9337b83f/ArgentumSansBlack.ttf')\n                format('opentype');\n        font-weight: 800;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/d57a3801b79be79d871a9d09f3ee3c12/ArgentumSansBold.ttf')\n                format('opentype');\n        font-weight: 700;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/7f1fb27c262e3a9af6389bb4ab5b5f53/ArgentumSansLight.ttf')\n                format('opentype');\n        font-weight: 200;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/dfdbaee7cbe33f00a439f4cc1fb02c70/ArgentumSansLightItalic.ttf')\n                format('opentype');\n        font-weight: 200;\n        font-style: italic;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/e37732e4248ec8c6c333010a98620f0b/ArgentumSansMedium.ttf')\n                format('opentype');\n        font-weight: 500;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/c71775e3bd01672203acd6a7747652e6/ArgentumSansMediumItalic.ttf')\n                format('opentype');\n        font-weight: 500;\n        font-style: italic;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/065ae922c6d96030bc9d4ba7c0e5f9dc/ArgentumSansRegular.ttf')\n                format('opentype');\n        font-weight: 400;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/3ef4fc069019bcba041e2bf33dd650c8/ArgentumSansSemiBold.ttf')\n                format('opentype');\n        font-weight: 600;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: 'Argentum Sans';\n        src: local('Argentum Sans'),\n            url('https://fontlibrary.org/assets/fonts/argentum-sans/9d2a529d403d28ea06c79fc969fe3cbf/4b9a3149d9c2fa53aeb22d9482e758e1/ArgentumSansSemiBoldItalic.ttf')\n                format('opentype');\n        font-weight: 600;\n        font-style: italic;\n    }\n"])));
var getCSSWeight = function getCSSWeight(weight) {
  switch (weight) {
    case 'regular':
    case '400':
      return css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n                font-weight: 400;\n            "])));

    case 'medium':
    case '500':
      return css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n                font-weight: 500;\n            "])));

    case 'semibold':
    case '600':
      return css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n                font-weight: 600;\n            "])));

    case 'bold':
    case '700':
      return css(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n                font-weight: 700;\n            "])));

    default:
      throw new Error('Not correct font weight');
  }
};
var text$1 = /*#__PURE__*/css(_templateObject7$2 || (_templateObject7$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    -webkit-font-smoothing: antialiased;\n    color: ", ";\n    fill: ", ";\n    font-style: normal;\n    letter-spacing: 0;\n"])), openSans$1, color.grey, color.grey);
var heading$1 = /*#__PURE__*/css(_templateObject8$2 || (_templateObject8$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    -webkit-font-smoothing: antialiased;\n    font-family: 'Argentum Sans';\n    color: ", ";\n    fill: ", ";\n    font-style: normal;\n    letter-spacing: 0;\n"])), argentumSans$1, color.blueDark, color.blueDark);
var h1$1 = /*#__PURE__*/css(_templateObject9$2 || (_templateObject9$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-weight: 600;\n    font-size: 36px;\n    line-height: 40px;\n    letter-spacing: -0.75px;\n"])), heading$1);
var h2$1 = /*#__PURE__*/css(_templateObject10$2 || (_templateObject10$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-size: 32px;\n    font-weight: 400;\n    line-height: 36px;\n"])), heading$1);
var h3$1 = /*#__PURE__*/css(_templateObject11$2 || (_templateObject11$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 32px;\n"])), heading$1);
var h4$1 = /*#__PURE__*/css(_templateObject12$2 || (_templateObject12$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 28px;\n"])), heading$1);
var subtitle1 = /*#__PURE__*/css(_templateObject13$2 || (_templateObject13$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-weight: 600;\n    color: ", ";\n    fill: ", ";\n    font-size: 18px;\n    line-height: 24px;\n"])), heading$1, color.blueDark, color.blueDark);
var subtitle2 = /*#__PURE__*/css(_templateObject14$2 || (_templateObject14$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-weight: 600;\n    color: ", ";\n    fill: ", ";\n    font-size: 16px;\n    line-height: 24px;\n"])), heading$1, color.blueDark, color.blueDark);
var caption14 = /*#__PURE__*/css(_templateObject15$2 || (_templateObject15$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-size: 14px;\n    line-height: 24px;\n"])), text$1);
var caption12 = /*#__PURE__*/css(_templateObject16$1 || (_templateObject16$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-size: 12px;\n    line-height: 1.5;\n"])), text$1);
var body18 = /*#__PURE__*/css(_templateObject17$1 || (_templateObject17$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-size: 18px;\n    line-height: 24px;\n"])), text$1);
var body16 = /*#__PURE__*/css(_templateObject18$1 || (_templateObject18$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    font-size: 16px;\n    line-height: 24px;\n"])), text$1);
var italicFont = /*#__PURE__*/css(_templateObject19 || (_templateObject19 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-style: italic;\n"])));
var ibm$1 = /*#__PURE__*/css(_templateObject20 || (_templateObject20 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @import url('//fonts.googleapis.com/css?family=IBM+Plex+Mono');\n    font-family: 'IBM Plex Mono', monospace;\n"])));
var getFontStyle = function getFontStyle(variant) {
  switch (variant) {
    case 'h1':
      return h1$1;

    case 'h2':
      return h2$1;

    case 'h3':
      return h3$1;

    case 'h4':
      return h4$1;

    case 'subtitle1':
      return subtitle1;

    case 'subtitle2':
      return subtitle2;

    case 'body18':
      return body18;

    case 'body16':
      return body16;

    case 'caption14':
      return caption14;

    case 'caption12':
      return caption12;

    default:
      return body16;
  }
};
var getTypographyStyle = function getTypographyStyle(p) {
  return css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), getFontStyle(p.variant || 'body16'), (p == null ? void 0 : p.monospace) && ibm$1, (p == null ? void 0 : p.color) && "color: " + p.color, (p == null ? void 0 : p.italic) && italicFont, (p == null ? void 0 : p.weight) && getCSSWeight(p.weight));
};

var _templateObject$b;

var _excluded = ["variant", "italic", "monospace", "copyable", "children", "iconSize", "onCopy"];

var getTag = function getTag(variant) {
  switch (variant) {
    case 'h1':
      return 'h1';

    case 'h2':
      return 'h2';

    case 'h3':
      return 'h3';

    case 'h4':
      return 'h4';

    case 'subtitle1':
    case 'subtitle2':
      return 'h2';

    case 'body18':
    case 'body16':
    case 'caption12':
    case 'caption14':
    default:
      return 'span';
  }
};

var DynamicText = function DynamicText(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body16' : _ref$variant,
      copyable = _ref.copyable,
      children = _ref.children,
      iconSize = _ref.iconSize,
      _ref$onCopy = _ref.onCopy,
      onCopy = _ref$onCopy === void 0 ? function () {} : _ref$onCopy,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Tag = getTag(variant);
  return (// @ts-ignore
    React.createElement(Tag, Object.assign({}, otherProps), children, copyable && React.createElement(CopyButton, {
      iconSize: iconSize,
      text: "" + children,
      onCopy: onCopy
    }))
  );
};

var Typography = /*#__PURE__*/styled(DynamicText)(_templateObject$b || (_templateObject$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    position: relative;\n    margin: 0;\n"])), function (p) {
  return getTypographyStyle(p);
});

var Badge = function Badge(_ref) {
  var _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'normal' : _ref$state,
      text = _ref.text,
      _ref$textVariant = _ref.textVariant,
      textVariant = _ref$textVariant === void 0 ? 'body16' : _ref$textVariant;
  return React.createElement(DivStyled$2, {
    "data-testid": "test-badge-id",
    state: state
  }, React.createElement(Typography, {
    color: "white",
    "data-testid": "test-badge-text",
    variant: textVariant,
    weight: "bold"
  }, text));
};

var _templateObject$c;
var section = /*#__PURE__*/css(_templateObject$c || (_templateObject$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    color: ", ";\n    display: flex;\n    height: 40px;\n    justify-content: center;\n    left: 0;\n    max-width: 100%;\n    padding: 0;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: 10001;\n\n    button {\n        padding: 0 8px;\n        margin: 2px 6px;\n        border: 0;\n    }\n\n    strong {\n        margin: 0 8px;\n        padding: 2px 8px;\n        line-height: 16px;\n    }\n"])), color.white);
var bannerStripStyles = {
  section: section
};

var _templateObject$d, _templateObject2$8, _templateObject3$6, _templateObject4$5;
var rotate = /*#__PURE__*/keyframes(_templateObject$d || (_templateObject$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n"])));
var StyledSpinnerParent = /*#__PURE__*/styled.div(_templateObject2$8 || (_templateObject2$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    display: flex;\n    flex-direction: ", ";\n    align-items: center;\n    justify-content: center;\n    max-width: fit-content;\n    text-align: center;\n    & > span {\n        color: ", ";\n        font-weight: 500;\n        font-size: ", ";\n        line-height: 5px;\n        margin: 8px;\n    }\n"])), fonts.text, function (props) {
  return props.direction == 'bottom' ? 'column' : 'row';
}, function (props) {
  return props.spinnerColor;
}, function (props) {
  return (props.fontSize ? props.fontSize : props.size && props.size / 2) + "px";
});
var StyledSpinnerDiv = /*#__PURE__*/styled.div(_templateObject3$6 || (_templateObject3$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    width: ", ";\n    height: ", ";\n    box-sizing: border-box;\n    border: 2px solid ", ";\n    border-bottom: transparent;\n    border-right: transparent;\n    border-radius: 50%;\n    animation: 1s ", " infinite;\n"])), function (props) {
  return props.size + "px";
}, function (props) {
  return props.size + "px";
}, function (props) {
  return props.spinnerColor;
}, rotate);
var DivStyledWaveLoader = /*#__PURE__*/styled.div(_templateObject4$5 || (_templateObject4$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    column-gap: 8px;\n    & > span {\n        width: ", "px;\n        height: ", "px;\n        transition: all 1000ms;\n        background-color: ", ";\n        border-radius: 50%;\n    }\n    & > .active {\n        width: ", "px;\n        height: ", "px;\n    }\n"])), function (props) {
  return props.size && props.size / 2;
}, function (props) {
  return props.size && props.size / 2;
}, function (props) {
  return props.spinnerColor && props.spinnerColor;
}, function (props) {
  return props.size && props.size;
}, function (props) {
  return props.size && props.size;
});

var state1 = {
  ball0: false,
  ball1: true,
  ball2: true,
  ball3: false
};
var state2 = {
  ball0: false,
  ball1: false,
  ball2: true,
  ball3: true
};
var state3 = {
  ball0: true,
  ball1: false,
  ball2: false,
  ball3: true
};
var state4 = {
  ball0: true,
  ball1: true,
  ball2: false,
  ball3: false
};

var Loading = function Loading(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size,
      _ref$spinnerColor = _ref.spinnerColor,
      spinnerColor = _ref$spinnerColor === void 0 ? color.white : _ref$spinnerColor,
      text = _ref.text,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'bottom' : _ref$direction,
      _ref$spinnerType = _ref.spinnerType,
      spinnerType = _ref$spinnerType === void 0 ? 'loader' : _ref$spinnerType,
      fontSize = _ref.fontSize;
  return React.createElement(StyledSpinnerParent, {
    "data-testid": "test-loading",
    direction: direction,
    role: "spinner",
    size: size,
    spinnerColor: spinnerColor,
    fontSize: fontSize
  }, spinnerType == 'loader' ? React.createElement(StyledSpinnerDiv, {
    spinnerColor: spinnerColor,
    size: size
  }) : React.createElement(WaveLoader, {
    size: size,
    spinnerColor: spinnerColor
  }), text && React.createElement("span", null, text));
};

var WaveLoader = function WaveLoader(_ref2) {
  var size = _ref2.size,
      spinnerColor = _ref2.spinnerColor;
  var states = [state1, state2, state3, state4];

  var _useState = useState(0),
      activeBalls = _useState[0],
      setActiveBalls = _useState[1];

  useEffect(function () {
    var interval = setInterval(function () {
      setActiveBalls(function (prevState) {
        if (prevState + 1 == states.length) {
          return 0;
        }

        return prevState + 1;
      });
    }, 1000);
    return function () {
      return clearInterval(interval);
    }; // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, []);
  return React.createElement(DivStyledWaveLoader, {
    size: size,
    spinnerColor: spinnerColor
  }, React.createElement("span", {
    className: "" + (states[activeBalls].ball0 && 'active')
  }), React.createElement("span", {
    className: "" + (states[activeBalls].ball1 && 'active')
  }), React.createElement("span", {
    className: "" + (states[activeBalls].ball2 && 'active')
  }), React.createElement("span", {
    className: "" + (states[activeBalls].ball3 && 'active')
  }));
};

var _templateObject$e, _templateObject2$9, _templateObject3$7, _templateObject4$6;

var initialStyles$1 = /*#__PURE__*/css(_templateObject$e || (_templateObject$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    align-items: center;\n    background-origin: border-box;\n    border-radius: 12px;\n    border: 2px solid transparent;\n    cursor: pointer;\n    display: flex;\n    font-weight: 600;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    text-align: left;\n    transition: all 0.2s ease;\n\n    span {\n        pointer-events: none;\n        z-index: 1;\n    }\n\n    svg {\n        height: 20px;\n        pointer-events: none;\n        width: 20px;\n        z-index: 1;\n    }\n\n    :after {\n        background-color: ", ";\n        content: '';\n        display: block;\n        height: 100%;\n        left: 0;\n        pointer-events: none;\n        position: absolute;\n        top: 0;\n        transition: all 0.3s ease;\n        width: 100%;\n        z-index: 0;\n    }\n\n    :active {\n        border-color: ", ";\n    }\n\n    :disabled {\n        opacity: 50%;\n        pointer-events: none;\n    }\n"])), resetCSS, fonts.text, /*#__PURE__*/getShade('dark', 0), color.blue);
var isLoadingMode = /*#__PURE__*/css(_templateObject2$9 || (_templateObject2$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    span {\n        margin-left: 12px;\n    }\n"])));
var transparent = /*#__PURE__*/css(_templateObject3$7 || (_templateObject3$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: transparent;\n"])));
var hoverEffect = /*#__PURE__*/css(_templateObject4$6 || (_templateObject4$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    :hover {\n        :after {\n            background-color: ", ";\n        }\n    }\n"])), /*#__PURE__*/getShade('dark', 10));

var _templateObject$f, _templateObject2$a, _templateObject3$8, _templateObject4$7, _templateObject5$5, _templateObject6$3;

var secondary = /*#__PURE__*/css(_templateObject$f || (_templateObject$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    :active {\n        border-color: ", ";\n    }\n\n    svg {\n        fill: ", ";\n    }\n"])), color.blueLight, color.blueLight, color.blue, color.blue, color.blue);
var primary = /*#__PURE__*/css(_templateObject2$a || (_templateObject2$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    :hover {\n        background: radial-gradient(\n                71.63% 130.21% at 50% 0%,\n                #aadcd6 0%,\n                rgba(33, 191, 150, 0) 100%\n            ),\n            #21bf96;\n    }\n\n    :active {\n        border-color: ", ";\n        background: linear-gradient(\n                83.64deg,\n                #aadcd6 -9.46%,\n                rgba(33, 191, 150, 0) 45.97%,\n                #aadcd6 103.7%\n            ),\n            #21bf96;\n    }\n\n    svg {\n        fill: ", ";\n    }\n"])), color.green, color.greenLight, color.white, color.greenLight, color.white);
var outlineLarge = /*#__PURE__*/css(_templateObject3$8 || (_templateObject3$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    :hover {\n        background-color: ", ";\n        border-color: ", ";\n        color: ", ";\n\n        svg {\n            fill: ", ";\n        }\n    }\n\n    :active {\n        border-width: 4px;\n        padding: 2px 18px;\n    }\n\n    svg {\n        fill: ", ";\n    }\n"])), color.white, color.paleBlue2, color.grey, color.blueDark, color.grey, color.white, color.white, color.grey);
var outlineRegular = /*#__PURE__*/css(_templateObject4$7 || (_templateObject4$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n\n    border-color: ", ";\n    color: ", ";\n\n    :hover {\n        background-image: ", ";\n        border-color: transparent;\n    }\n\n    :active {\n        border-color: ", ";\n    }\n\n    svg {\n        fill: ", ";\n    }\n"])), color.white, color.beauBlue, color.blue, gradientColors.beauBlue, color.paleCerulean, color.blue);
var outlineSmall = /*#__PURE__*/css(_templateObject5$5 || (_templateObject5$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n\n    border-color: ", ";\n    color: ", ";\n\n    :hover {\n        background-color: ", ";\n        color: ", ";\n\n        svg {\n            fill: ", ";\n        }\n    }\n\n    :active {\n        border-color: ", ";\n        background-color: ", ";\n        color: ", ";\n\n        svg {\n            fill: ", ";\n        }\n    }\n\n    svg {\n        fill: ", ";\n    }\n"])), color.white, color.green, color.green, color.green, color.white, color.white, color.greenDark, color.greenDark, color.white, color.white, color.green);
var translucent = /*#__PURE__*/css(_templateObject6$3 || (_templateObject6$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-style: inset;\n    color: ", ";\n    svg {\n        fill: ", ";\n    }\n"])), /*#__PURE__*/getShade('dark', 20), color.white, color.white);

var _templateObject$g, _templateObject2$b, _templateObject3$9;

var sizeSmall = /*#__PURE__*/css(_templateObject$g || (_templateObject$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 20px;\n    border-width: 2px;\n    font-size: 14px;\n    padding: 0 16px;\n"])));
var sizeRegular = /*#__PURE__*/css(_templateObject2$b || (_templateObject2$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 12px;\n    font-size: 14px;\n    padding: 4px 16px;\n"])));
var sizeLarge = /*#__PURE__*/css(_templateObject3$9 || (_templateObject3$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 16px;\n    border-width: 2px;\n    font-size: 16px;\n    padding: 4px 20px;\n"])));

var _templateObject$h, _templateObject2$c, _templateObject3$a, _templateObject4$8, _templateObject5$6;

var coloredShades = /*#__PURE__*/css(_templateObject$h || (_templateObject$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    :after {\n        background-color: ", ";\n    }\n\n    :hover {\n        :after {\n            background-color: ", ";\n        }\n    }\n\n    :active {\n        :after {\n            background-color: ", ";\n        }\n    }\n"])), /*#__PURE__*/getShade('light', 90), /*#__PURE__*/getShade('light', 70), /*#__PURE__*/getShade('light', 50)); // theme = colored

var coloredRed$1 = /*#__PURE__*/css(_templateObject2$c || (_templateObject2$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    svg {\n        fill: ", ";\n    }\n\n    ", "\n"])), color.red, color.red, color.red, color.red, coloredShades);
var coloredGreen$1 = /*#__PURE__*/css(_templateObject3$a || (_templateObject3$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    svg {\n        fill: ", ";\n    }\n\n    ", "\n"])), color.green, color.green, color.green, color.green, coloredShades);
var coloredBlue$1 = /*#__PURE__*/css(_templateObject4$8 || (_templateObject4$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    svg {\n        fill: ", ";\n    }\n\n    ", "\n"])), color.blue, color.blue, color.blue, color.blue, coloredShades);
var coloredYellow$1 = /*#__PURE__*/css(_templateObject5$6 || (_templateObject5$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    svg {\n        fill: ", ";\n    }\n\n    ", "\n"])), color.yellow, color.yellow, color.yellow, color.yellow, coloredShades);

var _templateObject$i, _templateObject2$d, _templateObject3$b, _templateObject4$9, _templateObject5$7;

var iconLeading = /*#__PURE__*/css(_templateObject$i || (_templateObject$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    flex-direction: row;\n\n    svg {\n        margin-right: 8px;\n    }\n"])));
var iconTrailing = /*#__PURE__*/css(_templateObject2$d || (_templateObject2$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    flex-direction: row-reverse;\n\n    svg {\n        margin-left: 8px;\n    }\n"])));
var iconOnly = /*#__PURE__*/css(_templateObject3$b || (_templateObject3$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    border-radius: 12px;\n    border-width: 0;\n    display: flex;\n    height: 32px;\n    justify-content: center;\n    padding: 0;\n    text-indent: -99999px;\n    width: 32px;\n"])));
var smallIconResize = function smallIconResize() {
  return css(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n    height: 24px;\n    width: 24px;\n"])));
};
var largeIconResize = function largeIconResize() {
  return css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n    border-width: 4px;\n    height: 40px;\n    width: 40px;\n"])));
};

var _templateObject$j;

var getThemeStyles = function getThemeStyles(theme, size) {
  switch (theme) {
    case 'primary':
      return primary;

    case 'outline':
      switch (size) {
        case 'large':
          return outlineLarge;

        case 'small':
          return outlineSmall;

        case 'regular':
        default:
          return outlineRegular;
      }

    case 'translucent':
      return translucent;

    case 'secondary':
    default:
      return secondary;
  }
};

var getIconLayoutStyles = function getIconLayoutStyles(iconLayout) {
  switch (iconLayout) {
    case 'trailing':
      return iconTrailing;

    case 'icon-only':
      return iconOnly;

    default:
      return iconLeading;
  }
};

var getSizeStyles = function getSizeStyles(size) {
  switch (size) {
    case 'large':
      return sizeLarge;

    case 'small':
      return sizeSmall;

    default:
      return sizeRegular;
  }
};

var getColored = function getColored(color) {
  switch (color) {
    case 'red':
      return coloredRed$1;

    case 'green':
      return coloredGreen$1;

    case 'blue':
      return coloredBlue$1;

    case 'yellow':
      return coloredYellow$1;

    default:
      return secondary;
  }
};

var iconOnlyBorderFix = function iconOnlyBorderFix(theme) {
  switch (theme) {
    case 'colored':
      return 'border-width: 2px;';

    case 'outline':
      return 'border-width: 2px;';

    default:
      return;
  }
};

var getIconColor = function getIconColor(color) {
  return "\n    svg \n        {\n            fill: " + color + ";\n        }\n    ";
};

var ButtonStyled$1 = /*#__PURE__*/styled.button(_templateObject$j || (_templateObject$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n    ", "\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"])), initialStyles$1, function (p) {
  return p.isFullWidth && 'width: 100%;';
}, function (p) {
  return p.theme && p.size && getThemeStyles(p.theme, p.size);
}, function (p) {
  return p.color && p.theme === 'colored' && getColored(p.color);
}, function (p) {
  return p.size && getSizeStyles(p.size);
}, function (p) {
  return p.iconLayout && getIconLayoutStyles(p.iconLayout);
}, function (p) {
  return p.iconLayout === 'icon-only' && p.size === 'small' && smallIconResize();
}, function (p) {
  return p.iconLayout === 'icon-only' && p.size === 'large' && largeIconResize();
}, function (p) {
  return p.iconLayout === 'icon-only' && iconOnlyBorderFix(p.theme);
}, function (p) {
  return p.isLoading && isLoadingMode;
}, function (p) {
  return p.radius && "border-radius: " + p.radius + "px;";
}, function (p) {
  return p.iconColor && getIconColor(p.iconColor);
}, function (p) {
  return p.isTransparent ? transparent : hoverEffect;
});

var Button = function Button(_ref) {
  var color = _ref.color,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      icon = _ref.icon,
      _ref$iconLayout = _ref.iconLayout,
      iconLayout = _ref$iconLayout === void 0 ? 'leading' : _ref$iconLayout,
      id = _ref.id,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$loadingText = _ref.loadingText,
      loadingText = _ref$loadingText === void 0 ? 'Loading...' : _ref$loadingText,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function (e) {
    return e.preventDefault;
  } : _ref$onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'click' : _ref$text,
      theme = _ref.theme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      loadingProps = _ref.loadingProps,
      radius = _ref.radius,
      _ref$isTransparent = _ref.isTransparent,
      isTransparent = _ref$isTransparent === void 0 ? false : _ref$isTransparent,
      iconColor = _ref.iconColor;
  return React.createElement(ButtonStyled$1, {
    isTransparent: isTransparent,
    color: color,
    "data-testid": "test-button",
    disabled: disabled || isLoading,
    iconLayout: iconLayout,
    id: id,
    isFullWidth: isFullWidth,
    isLoading: isLoading,
    onClick: onClick,
    size: size,
    theme: theme,
    type: type,
    radius: radius,
    iconColor: iconColor
  }, isLoading ? React.createElement(Loading, Object.assign({
    size: 15
  }, loadingProps)) : icon && React.createElement(Icon, {
    svg: icon,
    fill: "inherit",
    size: 20
  }), React.createElement("span", null, isLoading ? loadingText : text));
};

var _templateObject$k;

var getBackgroundColor$1 = function getBackgroundColor(type) {
  switch (type) {
    case 'success':
      return color.green;

    case 'warning':
      return color.yellow;

    case 'error':
      return color.red;

    default:
      return color.blue;
  }
};

var Section = /*#__PURE__*/styled.section(_templateObject$k || (_templateObject$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    background-color: ", ";\n    height: ", ";\n"])), fonts.text, bannerStripStyles.section, function (p) {
  return p.type && getBackgroundColor$1(p.type);
}, function (_ref) {
  var height = _ref.height;
  return height;
});

var BannerStrip = function BannerStrip(_ref2) {
  var buttonConfig = _ref2.buttonConfig,
      _ref2$buttonDisplayed = _ref2.buttonDisplayed,
      buttonDisplayed = _ref2$buttonDisplayed === void 0 ? false : _ref2$buttonDisplayed,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 'auto' : _ref2$height,
      text = _ref2.text,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'standard' : _ref2$type;
  return React.createElement(Section, {
    type: type,
    height: height,
    "data-testid": "banner-strip"
  }, React.createElement("strong", null, text), buttonDisplayed && React.createElement(Button, Object.assign({}, buttonConfig)));
};

var _templateObject$l;
var BlockieStyled = /*#__PURE__*/styled.div(_templateObject$l || (_templateObject$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    border-radius: 50%;\n    display: inline-flex;\n    overflow: hidden;\n"])), resetCSS);
var BlockieStyles = {
  BlockieStyled: BlockieStyled
};

var BlockieStyled$1 = BlockieStyles.BlockieStyled;
/**
 * Shows a blockie image for the provided wallet address
 * @param {*} props
 * @returns <Blockies> JSX Elemenet
 */

var Blockie = function Blockie(props) {
  var _props$seed;

  return React.createElement(BlockieStyled$1, {
    "data-testid": "test-div"
  }, React.createElement(Blockies, Object.assign({}, props, {
    seed: props == null ? void 0 : (_props$seed = props.seed) == null ? void 0 : _props$seed.toLowerCase(),
    className: "identicon"
  })));
};

var _templateObject$m, _templateObject2$e, _templateObject3$c, _templateObject4$a, _templateObject5$8, _templateObject6$4, _templateObject7$3, _templateObject8$3;
var olStyle = /*#__PURE__*/css(_templateObject$m || (_templateObject$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    list-style: none;\n"])), resetCSS);
var navStyle = /*#__PURE__*/css(_templateObject2$e || (_templateObject2$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n"])), resetCSS);
var separatorStyle = /*#__PURE__*/css(_templateObject3$c || (_templateObject3$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    color: ", ";\n    display: flex;\n    margin: 0 2px;\n    user-select: none;\n"])), resetCSS, color.greyIcons);
var NavStyled = /*#__PURE__*/styled.nav(_templateObject4$a || (_templateObject4$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    color: ", ";\n"])), navStyle, function (p) {
  return (p == null ? void 0 : p.color) || color.grey;
});
var ListStyled = /*#__PURE__*/styled.ol(_templateObject5$8 || (_templateObject5$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n"])), olStyle);
var ListItemStyled = /*#__PURE__*/styled.li(_templateObject6$4 || (_templateObject6$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n\n    svg:first-child {\n        margin-right: 5px;\n    }\n\n    &:last-child {\n        pointer-events: none;\n    }\n"])));
var Breadcrumb = /*#__PURE__*/styled(Link)(_templateObject7$3 || (_templateObject7$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    align-items: center;\n    display: flex;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    user-select: none;\n    &:hover {\n        color: ", ";\n    }\n"])), fonts.semiBold, color.blueDark);
var BreadcrumbsSeparator = /*#__PURE__*/styled.li(_templateObject8$3 || (_templateObject8$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n"])), separatorStyle);

function getNumberOfRoutesToRender(routes, currentLocation) {
  if (!currentLocation) return routes.length - 1;

  for (var i = 0; i < routes.length; i++) {
    if (routes[i].path === currentLocation) return i;
  }

  throw new Error('Routes list does not match currentLocation');
}

function renderList(routes, separator, currentLocation) {
  var separatedRoutes = [];
  routes.forEach(function (route, i) {
    var crumb = React.createElement(ListItemStyled, {
      key: "breadcrumb-" + i,
      "data-testid": i == 0 ? 'breadcrumb-test-id' : "breadcrumb-test-id-" + i
    }, React.createElement(Breadcrumb, {
      to: route.path
    }, route == null ? void 0 : route.icon, route.breadcrumb));
    var routesWithSeparator = getNumberOfRoutesToRender(routes, currentLocation);

    if (i < routesWithSeparator) {
      separatedRoutes = separatedRoutes.concat(crumb, React.createElement(BreadcrumbsSeparator, {
        key: "separator-" + i,
        "data-testid": 'breadcrumbs-separator-test-id'
      }, separator != null ? separator : React.createElement(Icon, {
        svg: iconTypes.chevronRight,
        fill: "currentColor",
        size: 24
      })));
    } else if (routesWithSeparator === i) {
      separatedRoutes.push(crumb);
    }
  });
  return separatedRoutes;
}

var Breadcrumbs = function Breadcrumbs(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? color.greyIcons : _ref$theme,
      style = _ref.style,
      routes = _ref.routes,
      separator = _ref.separator,
      currentLocation = _ref.currentLocation;
  return React.createElement(NavStyled, {
    color: theme,
    "data-testid": 'breadcrumbs-nav-test-id'
  }, React.createElement(ListStyled, {
    style: style,
    "data-testid": 'breadcrumbs-ol-test-id'
  }, renderList(routes, separator, currentLocation)));
};

Breadcrumbs.Item = ListItemStyled;

var _templateObject$n, _templateObject2$f, _templateObject3$d, _templateObject4$b, _templateObject5$9, _templateObject6$5, _templateObject7$4, _templateObject8$4, _templateObject9$3, _templateObject10$3, _templateObject11$3, _templateObject12$3;
var StyledTooltipParentDiv = /*#__PURE__*/styled.div(_templateObject$n || (_templateObject$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    color: #252525;\n    position: relative;\n    &:hover > div:nth-child(2) {\n        opacity: 1;\n        transition: 0.5s;\n        transition-delay: 0.1s;\n    }\n"])), fonts.openSans, resetCSS); // Left Position comps

var leftPositionPopover = /*#__PURE__*/css(_templateObject2$f || (_templateObject2$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    right: ", ";\n    top: 0px;\n    ", "\n"])), function (props) {
  return props.width && "calc(" + props.width + "px + 10px)";
}, function (props) {
  return "transform: translateY(-" + (props.popoverHeight - props.height) / 2 + "px)";
});
var leftPositionTriangle = /*#__PURE__*/css(_templateObject3$d || (_templateObject3$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-bottom: 10px solid transparent;\n    border-left: 10px solid ", ";\n    border-top: 10px solid transparent;\n    height: 0;\n    position: absolute;\n    right: -10px;\n    top: calc(50% - 10px);\n    width: 0;\n"])), color.blueDark2); // Right position comps

var rightPositionPopover = /*#__PURE__*/css(_templateObject4$b || (_templateObject4$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    left: ", ";\n    top: 0px;\n    ", "}\n"])), function (props) {
  return props.width && "calc(" + props.width + "px + 10px)";
}, function (props) {
  return "transform: translateY(-" + (props.popoverHeight - props.height) / 2 + "px)";
});
var rightPositionTriangle = /*#__PURE__*/css(_templateObject5$9 || (_templateObject5$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-bottom: 10px solid transparent;\n    border-right: 10px solid ", ";\n    border-top: 10px solid transparent;\n    height: 0;\n    left: -10px;\n    position: absolute;\n    top: calc(50% - 10px);\n    width: 0;\n"])), color.blueDark2); // Top Position Comps

var topPositionPopover = /*#__PURE__*/css(_templateObject6$5 || (_templateObject6$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    bottom: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n"])), function (props) {
  return props.height && "calc(" + props.height + "px + 10px)";
});
var topPositionTriangle = /*#__PURE__*/css(_templateObject7$4 || (_templateObject7$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid ", ";\n    height: 0;\n    left: calc(50% - 10px);\n    position: absolute;\n    top: 100%;\n    width: 0;\n"])), color.blueDark2); // bottom Position Comps

var bottomPositionPopover = /*#__PURE__*/css(_templateObject8$4 || (_templateObject8$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    left: 50%;\n    top: ", ";\n    transform: translateX(-50%);\n"])), function (props) {
  return props.height && "calc(" + props.height + "px + 10px)";
});
var bottomPositionTriangle = /*#__PURE__*/css(_templateObject9$3 || (_templateObject9$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-bottom: 10px solid ", ";\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    height: 0;\n    left: calc(50% - 10px);\n    position: absolute;\n    top: -10px;\n    width: 0;\n"])), color.blueDark2);

var getTriangleComp = function getTriangleComp(position) {
  switch (position) {
    case 'top':
      return topPositionTriangle;

    case 'bottom':
      return bottomPositionTriangle;

    case 'left':
      return leftPositionTriangle;

    case 'right':
      return rightPositionTriangle;
  }
};

var getPopoverComp = function getPopoverComp(position) {
  switch (position) {
    case 'top':
      return topPositionPopover;

    case 'bottom':
      return bottomPositionPopover;

    case 'left':
      return leftPositionPopover;

    case 'right':
      return rightPositionPopover;
  }
};

var StyledHoverDiv = /*#__PURE__*/styled.div(_templateObject10$3 || (_templateObject10$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    opacity: 0;\n    position: absolute;\n    z-index: 1;\n    min-width: ", "px;\n    ", "\n"])), function (props) {
  return props.minWidth;
}, function (props) {
  return getPopoverComp(props.position);
});
var StyledTooltipTextDiv = /*#__PURE__*/styled.div(_templateObject11$3 || (_templateObject11$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-radius: 5px;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    max-width: ", ";\n    min-width: fit-content;\n    padding: 10px;\n    transition: 0.5ms;\n"])), color.blueDark2, function (props) {
  return props.maxWidth && props.maxWidth + "px";
});
var StyledPopoverArrowDiv = /*#__PURE__*/styled.div(_templateObject12$3 || (_templateObject12$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n"])), function (props) {
  return getTriangleComp(props.position);
});

var Tooltip = function Tooltip(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      content = _ref.content,
      children = _ref.children,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth;
  var parretnRef = useRef(null);
  var popoverRef = useRef(null);

  var _useState = useState(0),
      width = _useState[0],
      setWidth = _useState[1];

  var _useState2 = useState(0),
      height = _useState2[0],
      setHeight = _useState2[1];

  var _useState3 = useState(0),
      popverWidth = _useState3[0],
      setPopoverWidth = _useState3[1];

  var _useState4 = useState(0),
      popoverHeight = _useState4[0],
      setPopoverHeight = _useState4[1];

  useEffect(function () {
    setWidth(parretnRef.current ? parretnRef.current.offsetWidth : 0);
    setHeight(parretnRef.current ? parretnRef.current.offsetHeight : 0);
    setPopoverWidth(popoverRef.current ? popoverRef.current.offsetWidth : 0);
    setPopoverHeight(popoverRef.current ? popoverRef.current.offsetHeight : 0);
  }, [parretnRef.current, popoverRef.current]);
  return React.createElement(StyledTooltipParentDiv, {
    ref: parretnRef,
    "data-testid": 'tooltip-container-test-id'
  }, React.createElement("div", null, children), React.createElement(StyledHoverDiv, {
    ref: popoverRef,
    popoverWidth: popverWidth,
    popoverHeight: popoverHeight,
    height: height,
    width: width,
    minWidth: minWidth,
    position: position,
    "data-testid": 'tooltip-children-test-id'
  }, React.createElement(StyledTooltipTextDiv, {
    maxWidth: maxWidth,
    minWidth: minWidth
  }, content), React.createElement(StyledPopoverArrowDiv, {
    position: position
  })));
};

var _templateObject$o, _templateObject2$g, _templateObject3$e, _templateObject4$c;
var DivStyled$3 = /*#__PURE__*/styled.div(_templateObject$o || (_templateObject$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    outline: 2px solid transparent;\n    background: ", ";\n    border-radius: 20px;\n    display: grid;\n    min-height: fit-content;\n    padding: 11px;\n    position: relative;\n    transition: all 0.2s ease;\n    width: 100%;\n    ", "\n    ", "\n    ", "\n"])), resetCSS, fonts.text, color.blueLight, function (p) {
  return p.isDisabled ? 'opacity:70%;' : "&:hover {\n        background: radial-gradient(\n            102.8% 102.8% at 3.14% -9.06%,\n            #e9fffc 0%,\n            #e8fefb 4.74%,\n            #e4f4f7 50.11%,\n            #e1eef4 83.07%,\n            #e0ecf3 100%\n        );\n    }";
}, function (p) {
  return p.cursorType === 'pointer' && 'cursor: pointer;';
}, function (p) {
  return p.isSelected && "outline-color: " + color.green + ";";
});
var AbsoluteIconStyled = /*#__PURE__*/styled.div(_templateObject2$g || (_templateObject2$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: -2px;\n    ", "\n"])), function (p) {
  return p.position === 'topL' ? 'left: -2px;' : 'right: -2px;';
});
var FooterStyled = /*#__PURE__*/styled.footer(_templateObject3$e || (_templateObject3$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: grid;\n    text-align: center;\n"])));
var HeaderStyled$1 = /*#__PURE__*/styled.div(_templateObject4$c || (_templateObject4$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: relative;\n"])));
var CardStyles = {
  AbsoluteIconStyled: AbsoluteIconStyled,
  DivStyled: DivStyled$3,
  FooterStyled: FooterStyled,
  HeaderStyled: HeaderStyled$1
};

var AbsoluteIconStyled$1 = CardStyles.AbsoluteIconStyled,
    DivStyled$4 = CardStyles.DivStyled,
    FooterStyled$1 = CardStyles.FooterStyled,
    HeaderStyled$2 = CardStyles.HeaderStyled;

var Card = function Card(_ref) {
  var id = _ref.id,
      children = _ref.children,
      _ref$cursorType = _ref.cursorType,
      cursorType = _ref$cursorType === void 0 ? 'pointer' : _ref$cursorType,
      description = _ref.description,
      isSelected = _ref.isSelected,
      title = _ref.title,
      tooltipText = _ref.tooltipText,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      setIsSelected = _ref.setIsSelected,
      _onClick = _ref.onClick;
  return React.createElement(DivStyled$4, {
    "aria-label": isSelected ? 'card not selected' : 'card selected',
    "data-testid": 'card-test-id',
    id: id,
    onClick: function onClick() {
      if (isDisabled) return;
      _onClick && _onClick();
      if (!setIsSelected) return;
      setIsSelected(!isSelected);
    },
    role: "button",
    isSelected: isSelected,
    isDisabled: isDisabled,
    cursorType: cursorType
  }, React.createElement(HeaderStyled$2, {
    "data-testid": 'header-test-id'
  }, isSelected && React.createElement(AbsoluteIconStyled$1, {
    position: "topL"
  }, React.createElement(Icon, {
    "data-testid": 'check-test-id',
    fill: color.green,
    size: 24,
    svg: iconTypes.checkmark
  })), !isDisabled && tooltipText && React.createElement(AbsoluteIconStyled$1, {
    position: "topR"
  }, React.createElement(Tooltip, {
    position: 'bottom',
    children: [React.createElement(Icon, {
      key: "ttip-card",
      "data-testid": 'help-test-id',
      fill: color.blue,
      size: 22,
      svg: iconTypes.helpCircle
    })],
    content: tooltipText
  }))), React.createElement("div", null, children), (title || description) && React.createElement(FooterStyled$1, null, title && React.createElement(Typography, {
    variant: "subtitle2",
    "data-testid": 'title-test-id',
    color: color.blue
  }, title), description && React.createElement(Typography, {
    variant: "caption14",
    "data-testid": 'desc-test-id',
    color: color.blue
  }, description)));
};

var _templateObject$p, _templateObject2$h, _templateObject3$f, _templateObject4$d, _templateObject5$a, _templateObject6$6, _templateObject7$5, _templateObject8$5, _templateObject9$4;
var inputStyles = /*#__PURE__*/css(_templateObject$p || (_templateObject$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    position: absolute;\n    top: -30px;\n"])), resetCSS);
var labelStyles = /*#__PURE__*/css(_templateObject2$h || (_templateObject2$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    cursor: pointer;\n    display: block;\n    margin-bottom: 4px;\n    overflow: hidden;\n    position: relative;\n    width: fit-content;\n"])), resetCSS, fonts.text);
var labelDisabled = /*#__PURE__*/css(_templateObject3$f || (_templateObject3$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    opacity: 50%;\n    pointer-events: none;\n"])));
var boxStyles = /*#__PURE__*/css(_templateObject4$d || (_templateObject4$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding-left: 28px;\n\n    &:before,\n    .after {\n        border-radius: 5px;\n        content: '';\n        display: block;\n        height: 20px;\n        left: 0;\n        pointer-events: none;\n        position: absolute;\n        top: 0;\n        transition: all 0.1s ease-out;\n        width: 20px;\n    }\n\n    &:before {\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 0;\n    }\n\n    .after {\n        align-items: center;\n        display: flex;\n        justify-content: center;\n        left: 1px;\n        opacity: 0;\n        top: 1px;\n        z-index: 1;\n    }\n\n    &:hover {\n        &:before {\n            filter: brightness(95%);\n        }\n    }\n\n    &:active {\n        &:before {\n            filter: brightness(90%);\n        }\n    }\n"])), color.blueLight, color.blueSky);
var boxCheckedStyles = /*#__PURE__*/css(_templateObject5$a || (_templateObject5$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    &:before {\n        background-color: ", ";\n        border-color: ", ";\n    }\n    .after {\n        opacity: 1;\n    }\n"])), color.green, color.greenLight);
var switchStyles = /*#__PURE__*/css(_templateObject6$6 || (_templateObject6$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding-left: 48px;\n\n    &:before {\n        background-color: ", ";\n        border-radius: 7px;\n        content: '';\n        display: block;\n        height: 14px;\n        left: 3px;\n        opacity: 0.4;\n        position: absolute;\n        top: calc(50% - 7px);\n        transition: all 0.1s ease-out;\n        width: 34px;\n    }\n\n    &:after {\n        background-color: ", ";\n        border-radius: 50%;\n        border: 1px solid ", ";\n        content: '';\n        display: block;\n        height: 20px;\n        left: 0;\n        position: absolute;\n        top: calc(50% - 11px);\n        transition: all 0.1s ease-out;\n        width: 20px;\n    }\n\n    &:hover {\n        &:after {\n            filter: brightness(95%);\n        }\n    }\n\n    &:active {\n        &:after {\n            filter: brightness(90%);\n        }\n    }\n"])), color.greyLight, color.blueLight, color.blue);
var switchOnStyles = /*#__PURE__*/css(_templateObject7$5 || (_templateObject7$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    &:before {\n        background-color: ", ";\n    }\n\n    &:after {\n        background-color: ", ";\n        border: 1px solid ", ";\n        left: 18px;\n    }\n"])), color.green, color.green, color.green);
var StyledInput = /*#__PURE__*/styled.input(_templateObject8$5 || (_templateObject8$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n"])), inputStyles);
var StyledLabel = /*#__PURE__*/styled.label(_templateObject9$4 || (_templateObject9$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), labelStyles, function (p) {
  return p.disabled && labelDisabled;
}, function (p) {
  return p.layout === 'box' && boxStyles;
}, function (p) {
  return p.layout === 'box' && p.checked && boxCheckedStyles;
}, function (p) {
  return p.layout === 'switch' && switchStyles;
}, function (p) {
  return p.layout === 'switch' && p.checked && switchOnStyles;
});

var Checkbox = function Checkbox(_ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      label = _ref.label,
      labelWhenChecked = _ref.labelWhenChecked,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'box' : _ref$layout,
      name = _ref.name,
      onChange = _ref.onChange,
      validation = _ref.validation;

  var _useState = useState(checked),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  var valueChanged = function valueChanged(event) {
    setIsChecked(Boolean(event.target.checked));
    if (disabled) return;
    onChange(event);
  };

  useEffect(function () {
    return setIsChecked(checked);
  }, [checked]);
  return React.createElement(StyledLabel, {
    checked: isChecked,
    "data-layout": layout,
    "data-testid": "test-checkbox-label",
    disabled: disabled,
    layout: layout
  }, layout === 'box' && React.createElement("span", {
    className: "after"
  }, React.createElement(Icon, {
    svg: iconTypes.check,
    fill: "white"
  })), React.createElement(StyledInput, {
    "data-testid": "test-checkbox-input",
    defaultChecked: isChecked,
    disabled: disabled,
    id: id,
    layout: layout,
    name: name,
    onChange: valueChanged,
    required: validation == null ? void 0 : validation.required,
    type: "checkbox",
    value: "" + isChecked
  }), React.createElement("span", {
    "data-testid": "test-checkbox-text"
  }, isChecked ? labelWhenChecked || label : label));
};

var _templateObject$q, _templateObject2$i, _templateObject3$g, _templateObject4$e, _templateObject5$b, _templateObject6$7, _templateObject7$6;
var TextAreaStyled = /*#__PURE__*/styled.textarea(_templateObject$q || (_templateObject$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", "\n    background: ", ";\n    overflow-x: auto;\n    padding: 16px 8px;\n    position: relative;\n    width: 100vw;\n\n    color: ", ";\n    font-style: italic;\n    overflow-y: hidden;\n    white-space: nowrap;\n\n    ::-webkit-resizer {\n        visibility: hidden;\n    }\n"])), resetCSS, fonts.ibmMono, fonts.textSmall, color.blueLight, color.blueDark);
var ContentStyled = /*#__PURE__*/styled.div(_templateObject2$i || (_templateObject2$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n"])));
var SideStyled = /*#__PURE__*/styled.div(_templateObject3$g || (_templateObject3$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    overflow: hidden;\n    padding: 16px 8px 0px 23px;\n"])), color.blueLight2);
var StyledUl = /*#__PURE__*/styled.ul(_templateObject4$e || (_templateObject4$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    list-style: none;\n    text-align: right;\n"])), resetCSS);
var WrapperStyled = /*#__PURE__*/styled.div(_templateObject5$b || (_templateObject5$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 16px;\n    border: 2px solid ", ";\n    display: flex;\n    max-width: fit-content;\n    overflow: hidden;\n    position: relative;\n    flex-direction: column;\n"])), color.paleBlue2);
var WidthWrapperStyled = /*#__PURE__*/styled.div(_templateObject6$7 || (_templateObject6$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    max-width: ", ";\n"])), function (p) {
  return p.maxWidth;
});
var HeaderStyled$3 = /*#__PURE__*/styled.div(_templateObject7$6 || (_templateObject7$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: 8px 16px;\n    border-bottom: 1px solid ", ";\n"])), color.paleBlue2);
var CodeAreaStyles = {
  WidthWrapperStyled: WidthWrapperStyled,
  SideStyled: SideStyled,
  StyledUl: StyledUl,
  TextAreaStyled: TextAreaStyled,
  WrapperStyled: WrapperStyled,
  ContentStyled: ContentStyled,
  HeaderStyled: HeaderStyled$3
};

var SideStyled$1 = CodeAreaStyles.SideStyled,
    StyledUl$1 = CodeAreaStyles.StyledUl;

var LineNumbers = function LineNumbers(_ref) {
  var currentValue = _ref.currentValue;
  var rowNumbers = useMemo(function () {
    var rowsAmount = currentValue.split(/\r\n|\r|\n/).length;
    var numberComps = [];

    for (var i = 1; i < rowsAmount + 1; i++) {
      numberComps.push(React.createElement("li", {
        key: i
      }, React.createElement(Typography, {
        variant: "caption14",
        monospace: true,
        color: color.grey,
        italic: true
      }, i)));
    }

    return numberComps;
  }, [currentValue]);
  return React.createElement(SideStyled$1, null, React.createElement(StyledUl$1, null, rowNumbers));
};

var ContentStyled$1 = CodeAreaStyles.ContentStyled,
    HeaderStyled$4 = CodeAreaStyles.HeaderStyled,
    TextAreaStyled$1 = CodeAreaStyles.TextAreaStyled,
    WidthWrapperStyled$1 = CodeAreaStyles.WidthWrapperStyled,
    WrapperStyled$1 = CodeAreaStyles.WrapperStyled;

var CodeArea = function CodeArea(_ref) {
  var text = _ref.text,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '100%' : _ref$maxWidth,
      onChange = _ref.onChange,
      headerComponent = _ref.headerComponent;

  var _useState = useState(text),
      currentValue = _useState[0],
      setCurrentValue = _useState[1];

  useEffect(function () {
    return setCurrentValue(text);
  }, [text]);
  var textareaRef = useRef(null);

  var valueChanged = function valueChanged(event) {
    setCurrentValue(event.target.value);
    onChange && onChange(event);
  };

  useEffect(function () {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = '0px';
      textareaRef.current.style.minHeight = '0px';
      var scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + 'px';
      textareaRef.current.style.minHeight = scrollHeight + 'px';
    }
  }, [currentValue]);
  return React.createElement(WidthWrapperStyled$1, {
    maxWidth: maxWidth
  }, React.createElement(WrapperStyled$1, null, headerComponent && React.createElement(HeaderStyled$4, null, headerComponent), React.createElement(ContentStyled$1, null, React.createElement(LineNumbers, {
    currentValue: currentValue
  }), React.createElement(TextAreaStyled$1, {
    ref: textareaRef,
    onChange: function onChange(event) {
      return valueChanged(event);
    },
    value: currentValue
  })), React.createElement(Icon, {
    svg: "expand",
    style: {
      position: 'absolute',
      bottom: '8px',
      right: '8px',
      zIndex: '1'
    },
    fill: color.blue
  })));
};

var n6 = /*#__PURE__*/new Intl.NumberFormat('en-us', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 6
});
var n4 = /*#__PURE__*/new Intl.NumberFormat('en-us', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 4
});
var c2 = /*#__PURE__*/new Intl.NumberFormat('en-us', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
/**
 * Returns a string of form "abc...xyz"
 * @param {string} str string to string
 * @param {number} n number of chars to keep at front/end
 * @returns {string}
 */

var getEllipsisTxt = function getEllipsisTxt(str, n) {
  if (n === void 0) {
    n = 6;
  }

  if (str) {
    return str.slice(0, n) + "..." + str.slice(str.length - n);
  }

  return '';
};

var networkConfigs = {
  '0x1': {
    currencySymbol: 'ETH',
    blockExplorerUrl: 'https://etherscan.io/',
    wrapped: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'
  },
  '0x3': {
    currencySymbol: 'ETH',
    blockExplorerUrl: 'https://ropsten.etherscan.io/'
  },
  '0x4': {
    currencySymbol: 'ETH',
    blockExplorerUrl: 'https://kovan.etherscan.io/'
  },
  '0x2a': {
    currencySymbol: 'ETH',
    blockExplorerUrl: 'https://rinkeby.etherscan.io/'
  },
  '0x5': {
    currencySymbol: 'ETH',
    blockExplorerUrl: 'https://goerli.etherscan.io/'
  },
  '0x539': {
    chainName: 'Local Chain',
    currencyName: 'ETH',
    currencySymbol: 'ETH',
    rpcUrl: 'http://127.0.0.1:7545'
  },
  '0xa86a': {
    chainId: 43114,
    chainName: 'Avalanche Mainnet',
    currencyName: 'AVAX',
    currencySymbol: 'AVAX',
    rpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
    blockExplorerUrl: 'https://cchain.explorer.avax.network/'
  },
  '0x38': {
    chainId: 56,
    chainName: 'Smart Chain',
    currencyName: 'BNB',
    currencySymbol: 'BNB',
    rpcUrl: 'https://bsc-dataseed.binance.org/',
    blockExplorerUrl: 'https://bscscan.com/',
    wrapped: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
  },
  '0x61': {
    chainId: 97,
    chainName: 'Smart Chain - Testnet',
    currencyName: 'BNB',
    currencySymbol: 'BNB',
    rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
    blockExplorerUrl: 'https://testnet.bscscan.com/'
  },
  '0x89': {
    chainId: 137,
    chainName: 'Polygon Mainnet',
    currencyName: 'MATIC',
    currencySymbol: 'MATIC',
    rpcUrl: 'https://rpc-mainnet.maticvigil.com/',
    blockExplorerUrl: 'https://explorer-mainnet.maticvigil.com/',
    wrapped: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270'
  },
  '0x13881': {
    chainId: 80001,
    chainName: 'Mumbai',
    currencyName: 'MATIC',
    currencySymbol: 'MATIC',
    rpcUrl: 'https://rpc-mumbai.matic.today/',
    blockExplorerUrl: 'https://mumbai.polygonscan.com/'
  }
};
var getNativeByChain = function getNativeByChain(chain) {
  var _networkConfigs$chain;

  return ((_networkConfigs$chain = networkConfigs[chain]) == null ? void 0 : _networkConfigs$chain.currencySymbol) || 'NATIVE';
};
var getChainById = function getChainById(chain) {
  var _networkConfigs$chain2;

  return ((_networkConfigs$chain2 = networkConfigs[chain]) == null ? void 0 : _networkConfigs$chain2.chainId) || null;
};
var getExplorer = function getExplorer(chain) {
  var _networkConfigs$chain3;

  return (_networkConfigs$chain3 = networkConfigs[chain]) == null ? void 0 : _networkConfigs$chain3.blockExplorerUrl;
};
var getWrappedNative = function getWrappedNative(chain) {
  var _networkConfigs$chain4;

  return ((_networkConfigs$chain4 = networkConfigs[chain]) == null ? void 0 : _networkConfigs$chain4.wrapped) || null;
};
var chainToHex = {
  'eth': '0x1',
  'ropsten': '0x3',
  'rinkeby': '0x4',
  'goerli': '0x5',
  'kovan': '0x2a',
  'bsc': '0x38',
  'bsc testnet': '0x61',
  'polygon': '0x89',
  'mumbai': '0x13881',
  'fantom': '0xfa',
  'avalanche': '0xa86a',
  'avalanche testnet': '0xa869',
  '0x1': '0x1',
  '0x3': '0x3',
  '0x4': '0x4',
  '0x5': '0x5',
  '0x2a': '0x2a',
  '0x38': '0x38',
  '0x61': '0x61',
  '0x89': '0x89',
  '0x13881': '0x13881',
  '0xfa': '0xfa',
  '0xa86a': '0xa86a',
  '0xa869': '0xa869'
};
var getChainHex = function getChainHex(chain) {
  return chainToHex[chain];
};

var _templateObject$r;
var BalanceStyled = /*#__PURE__*/styled.span(_templateObject$r || (_templateObject$r = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    white-space: nowrap;\n    line-height: 25px;\n"])), fonts.semiBold);
var NativeBalanceStyles = {
  BalanceStyled: BalanceStyled
};

var BalanceStyled$1 = NativeBalanceStyles.BalanceStyled;

var NativeBalance = function NativeBalance(_ref) {
  var style = _ref.style;

  var _useMoralis = useMoralis(),
      account = _useMoralis.account,
      chainId = _useMoralis.chainId,
      web3 = _useMoralis.web3,
      Moralis = _useMoralis.Moralis;

  var _useState = useState({}),
      balance = _useState[0],
      setBalance = _useState[1];

  useEffect(function () {
    if (account && chainId) {
      web3 == null ? void 0 : web3.getBalance(account).then(function (result) {
        // eslint-disable-next-line new-cap
        setBalance({
          formatted: String(Number(Moralis.Units.FromWei(result.toString())).toFixed(8)),
          balance: result
        });
      });
    }
  }, [account, chainId]);
  if (!(balance != null && balance.formatted) || !account) return null;
  return React.createElement(BalanceStyled$1, {
    style: style
  }, balance.formatted);
};

var WC = function WC() {
  return React.createElement("svg", {
    width: "65",
    height: "40",
    viewBox: "0 0 300 185",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("title", null, "WalletConnect"), React.createElement("defs", null), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "walletconnect-logo-alt",
    fill: "#3B99FC",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M61.4385429,36.2562612 C110.349767,-11.6319051 189.65053,-11.6319051 238.561752,36.2562612 L244.448297,42.0196786 C246.893858,44.4140867 246.893858,48.2961898 244.448297,50.690599 L224.311602,70.406102 C223.088821,71.6033071 221.106302,71.6033071 219.883521,70.406102 L211.782937,62.4749541 C177.661245,29.0669724 122.339051,29.0669724 88.2173582,62.4749541 L79.542302,70.9685592 C78.3195204,72.1657633 76.337001,72.1657633 75.1142214,70.9685592 L54.9775265,51.2530561 C52.5319653,48.8586469 52.5319653,44.9765439 54.9775265,42.5821357 L61.4385429,36.2562612 Z M280.206339,77.0300061 L298.128036,94.5769031 C300.573585,96.9713 300.573599,100.85338 298.128067,103.247793 L217.317896,182.368927 C214.872352,184.763353 210.907314,184.76338 208.461736,182.368989 C208.461726,182.368979 208.461714,182.368967 208.461704,182.368957 L151.107561,126.214385 C150.496171,125.615783 149.504911,125.615783 148.893521,126.214385 C148.893517,126.214389 148.893514,126.214393 148.89351,126.214396 L91.5405888,182.368927 C89.095052,184.763359 85.1300133,184.763399 82.6844276,182.369014 C82.6844133,182.369 82.684398,182.368986 82.6843827,182.36897 L1.87196327,103.246785 C-0.573596939,100.852377 -0.573596939,96.9702735 1.87196327,94.5758653 L19.7936929,77.028998 C22.2392531,74.6345898 26.2042918,74.6345898 28.6498531,77.028998 L86.0048306,133.184355 C86.6162214,133.782957 87.6074796,133.782957 88.2188704,133.184355 C88.2188796,133.184346 88.2188878,133.184338 88.2188969,133.184331 L145.571,77.028998 C148.016505,74.6345347 151.981544,74.6344449 154.427161,77.028798 C154.427195,77.0288316 154.427229,77.0288653 154.427262,77.028899 L211.782164,133.184331 C212.393554,133.782932 213.384814,133.782932 213.996204,133.184331 L271.350179,77.0300061 C273.79574,74.6355969 277.760778,74.6355969 280.206339,77.0300061 Z",
    id: "WalletConnect"
  }))));
};

var MathWallet = function MathWallet() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 128 128"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("g", {
    transform: "translate(-216 -334)"
  }, React.createElement("g", {
    transform: "translate(216 334)"
  }, React.createElement("path", {
    fill: "#000",
    d: "M90.847 57.761a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246zM71.263 77.345a4.373 4.373 0 116.184-6.184 4.373 4.373 0 01-6.184 6.184zm30.922-10.307a4.373 4.373 0 116.184-6.185 4.373 4.373 0 01-6.184 6.185zM91.878 77.345a4.373 4.373 0 116.184-6.184 4.373 4.373 0 01-6.184 6.184zm21.645-1.03a2.915 2.915 0 114.123-4.124 2.915 2.915 0 01-4.123 4.123zm-10.307 10.307a2.915 2.915 0 114.123-4.123 2.915 2.915 0 01-4.123 4.123zM80.54 68.068a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246zm0-20.614a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246zM70.232 57.76a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246zm-20.71 0a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246zM29.938 77.345a4.373 4.373 0 116.184-6.184 4.373 4.373 0 01-6.184 6.184zM60.86 67.038a4.373 4.373 0 116.184-6.185 4.373 4.373 0 01-6.184 6.185zM50.553 77.345a4.373 4.373 0 116.184-6.184 4.373 4.373 0 01-6.184 6.184zm-40.2-1.03a2.915 2.915 0 114.124-4.124 2.915 2.915 0 01-4.123 4.123zm10.308 10.307a2.915 2.915 0 114.123-4.123 2.915 2.915 0 01-4.123 4.123zm41.23 0a2.915 2.915 0 114.123-4.123 2.915 2.915 0 01-4.123 4.123zM19.63 67.038a4.373 4.373 0 116.184-6.185 4.373 4.373 0 01-6.184 6.185zm19.583 1.03a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246zm0-20.614a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246zM28.907 57.76a5.83 5.83 0 118.246-8.246 5.83 5.83 0 01-8.246 8.246z"
  })))));
};

var TokenPocket = function TokenPocket() {
  return React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    mask: "url(#mask0_408_225)"
  }, React.createElement("path", {
    d: "M1041.52 0H-27V1024H1041.52V0Z",
    fill: "#2980FE"
  }), React.createElement("g", {
    clipPath: "url(#clip0_408_225)"
  }, React.createElement("path", {
    d: "M406.796 438.643H406.927C406.796 437.857 406.796 436.94 406.796 436.154V438.643Z",
    fill: "#29AEFF"
  }), React.createElement("path", {
    d: "M667.602 463.533H523.249V724.076C523.249 736.389 533.204 746.345 545.517 746.345H645.333C657.647 746.345 667.602 736.389 667.602 724.076V463.533Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M453.563 277H448.716H190.269C177.955 277 168 286.955 168 299.269V389.653C168 401.967 177.955 411.922 190.269 411.922H250.918H275.021V438.644V724.731C275.021 737.045 284.976 747 297.289 747H392.128C404.441 747 414.396 737.045 414.396 724.731V438.644V436.156V411.922H438.499H448.323H453.17C490.372 411.922 520.631 381.663 520.631 344.461C521.024 307.259 490.765 277 453.563 277Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M667.735 463.533V645.35C672.713 646.529 677.821 647.446 683.061 648.232C690.397 649.28 697.994 649.935 705.592 650.066C705.985 650.066 706.378 650.066 706.902 650.066V505.45C685.026 504.009 667.735 485.801 667.735 463.533Z",
    fill: "url(#paint0_linear_408_225)"
  }), React.createElement("path", {
    d: "M709.781 277C606.822 277 523.249 360.573 523.249 463.533C523.249 552.084 584.946 626.225 667.733 645.35V463.533C667.733 440.347 686.596 421.484 709.781 421.484C732.967 421.484 751.83 440.347 751.83 463.533C751.83 483.051 738.6 499.425 720.523 504.14C717.117 505.057 713.449 505.581 709.781 505.581V650.066C713.449 650.066 716.986 649.935 720.523 649.804C818.505 644.171 896.314 562.956 896.314 463.533C896.445 360.573 812.872 277 709.781 277Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M709.78 650.066V505.581C708.733 505.581 707.816 505.581 706.768 505.45V650.066C707.816 650.066 708.864 650.066 709.78 650.066Z",
    fill: "white"
  }))), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_408_225",
    x1: "709.844",
    y1: "556.827",
    x2: "667.753",
    y2: "556.827",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.9667",
    stopColor: "white",
    stopOpacity: "0.3233"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("clipPath", {
    id: "clip0_408_225"
  }, React.createElement("rect", {
    width: "728.448",
    height: "470",
    fill: "white",
    transform: "translate(168 277)"
  }))));
};

var SafePal = function SafePal() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40",
    height: "40",
    version: "1.1",
    viewBox: "0 0 256 256"
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: "linearGradient1452"
  }, React.createElement("stop", {
    offset: "0",
    stopColor: "#4a69fe",
    stopOpacity: "1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4d2bd9",
    stopOpacity: "1"
  })), React.createElement("linearGradient", {
    id: "linearGradient1454",
    x1: "37.515",
    x2: "222.687",
    y1: "43.175",
    y2: "212.735",
    gradientTransform: "translate(-1.028 -1.028)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient1452"
  })), React.createElement("circle", {
    cx: "128",
    cy: "128",
    r: "128",
    style: {
      fillRule: 'evenodd',
      strokeWidth: '9.005'
    },
    fill: "url(#linearGradient1454)",
    fillOpacity: "1",
    opacity: "0.98"
  }), React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M205.421 142.02v12.504c0 34.738-51.032 54.731-66.675 60.034l-5.689 1.942v-21.61l2.78-1.037c24.337-9.047 48.892-24.717 48.892-39.33V142.02zM128.133 39.5l20.855 6.351v22.05l-20.855-6.374-1.364.418v49.609h22.22v20.44h-22.22v84.203l-5.794-2.131c-2.69-.988-7.022-2.67-12.383-5.072l-2.518-1.135V46.223zm-28.605 8.8v21.948l-28.257 8.664v32.642h28.257v94.538l-6.258-3.179c-19.476-9.9-42.691-26.595-42.691-49.905V142.02H71.27v10.988c0 4.824 2.541 9.891 7.562 15.11v-36.124H50.58V63.223zm55.742-.523l50.151 15.33v68.887h-29.445v29.828s-6.583 8.524-20.688 15.662l-.014-101.545zm20.706 28.367v35.41h8.753V78.813z",
    style: {
      fillRule: 'evenodd',
      strokeWidth: '4.99763'
    }
  }));
};

var TWT = function TWT() {
  return React.createElement("svg", {
    width: "41",
    height: "40",
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    d: "M32.3999 64C50.073 64 64.3999 49.6731 64.3999 32C64.3999 14.3269 50.073 0 32.3999 0C14.7268 0 0.399902 14.3269 0.399902 32C0.399902 49.6731 14.7268 64 32.3999 64Z",
    fill: "#3375BB"
  }), React.createElement("path", {
    d: "M32.6267 14C38.9508 19.2816 46.2029 18.9559 48.275 18.9559C47.8217 48.9937 44.3683 43.0373 32.6267 51.46C20.8851 43.0373 17.4533 48.9937 17 18.9559C19.0505 18.9559 26.3026 19.2816 32.6267 14Z",
    stroke: "white",
    strokeWidth: "4",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "64",
    height: "64",
    fill: "white",
    transform: "translate(0.399902)"
  }))));
};

var Metamask = function Metamask() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "43",
    height: "40",
    fill: "none",
    viewBox: "0 0 54 50"
  }, React.createElement("path", {
    fill: "url(#paint0_linear_11808_11417)",
    d: "M51.03.333L30.195 15.75l3.875-9.085L51.03.333z"
  }), React.createElement("path", {
    fill: "url(#paint1_linear_11808_11417)",
    d: "M51.03.333L30.195 15.75l3.875-9.085L51.03.333z"
  }), React.createElement("path", {
    fill: "url(#paint2_linear_11808_11417)",
    d: "M2.97.333l20.65 15.56-3.689-9.228L2.971.333z"
  }), React.createElement("path", {
    fill: "url(#paint3_linear_11808_11417)",
    d: "M2.97.333l20.65 15.56-3.689-9.228L2.971.333z"
  }), React.createElement("path", {
    fill: "url(#paint4_linear_11808_11417)",
    d: "M43.529 36.079l-5.544 8.468 11.87 3.269 3.401-11.552-9.727-.185z"
  }), React.createElement("path", {
    fill: "url(#paint5_linear_11808_11417)",
    d: "M43.529 36.079l-5.544 8.468 11.87 3.269 3.401-11.552-9.727-.185z"
  }), React.createElement("path", {
    fill: "url(#paint6_linear_11808_11417)",
    d: "M.767 36.264l3.38 11.552 11.85-3.269-5.524-8.468-9.706.185z"
  }), React.createElement("path", {
    fill: "url(#paint7_linear_11808_11417)",
    d: "M.767 36.264l3.38 11.552 11.85-3.269-5.524-8.468-9.706.185z"
  }), React.createElement("path", {
    fill: "url(#paint8_linear_11808_11417)",
    d: "M15.357 21.773l-3.297 4.974 11.746.535-.391-12.642-8.058 7.133z"
  }), React.createElement("path", {
    fill: "url(#paint9_linear_11808_11417)",
    d: "M15.357 21.773l-3.297 4.974 11.746.535-.391-12.642-8.058 7.133z"
  }), React.createElement("path", {
    fill: "url(#paint10_linear_11808_11417)",
    d: "M38.645 21.773l-8.182-7.277-.268 12.786 11.747-.535-3.297-4.974z"
  }), React.createElement("path", {
    fill: "#E27625",
    d: "M15.996 44.548l7.11-3.433-6.12-4.769-.99 8.202zM30.895 41.115l7.089 3.433-.969-8.202-6.12 4.769z"
  }), React.createElement("path", {
    fill: "url(#paint11_linear_11808_11417)",
    d: "M37.984 44.547l-7.09-3.432.578 4.604-.062 1.953 6.574-3.125z"
  }), React.createElement("path", {
    fill: "url(#paint12_radial_11808_11417)",
    d: "M15.996 44.547l6.595 3.125-.042-1.953.557-4.604-7.11 3.432z"
  }), React.createElement("path", {
    fill: "url(#paint13_linear_11808_11417)",
    d: "M22.714 33.303l-5.894-1.726 4.163-1.912 1.731 3.638z"
  }), React.createElement("path", {
    fill: "url(#paint14_linear_11808_11417)",
    d: "M31.29 33.303l1.73-3.638 4.184 1.912-5.915 1.726z"
  }), React.createElement("path", {
    fill: "#CC6228",
    d: "M15.996 44.547l1.03-8.468-6.553.185 5.523 8.283zM36.974 36.079l1.01 8.468 5.543-8.283-6.553-.185zM41.942 26.747l-11.747.534 1.093 6.023 1.73-3.639 4.184 1.912 4.74-4.83zM16.82 31.577l4.163-1.912 1.731 3.639 1.092-6.023-11.746-.534 4.76 4.83z"
  }), React.createElement("path", {
    fill: "#E27525",
    d: "M12.06 26.747l4.925 9.599-.165-4.769-4.76-4.83zM37.202 31.577l-.185 4.769 4.925-9.6-4.74 4.831zM23.807 27.281l-1.092 6.023 1.38 7.112.31-9.373-.598-3.762zM30.192 27.281l-.577 3.742.289 9.393 1.38-7.112-1.092-6.023z"
  }), React.createElement("path", {
    fill: "url(#paint15_linear_11808_11417)",
    d: "M31.285 33.304l-1.38 7.112.988.699 6.121-4.769.186-4.769-5.915 1.727z"
  }), React.createElement("path", {
    fill: "url(#paint16_linear_11808_11417)",
    d: "M16.82 31.577l.165 4.769 6.12 4.769.99-.7-1.38-7.111-5.895-1.727z"
  }), React.createElement("path", {
    fill: "#C0AC9D",
    d: "M31.411 47.672l.062-1.953-.536-.452h-7.872l-.516.452.042 1.953-6.595-3.124 2.308 1.89 4.678 3.228H31l4.698-3.227 2.288-1.891-6.574 3.124z"
  }), React.createElement("path", {
    fill: "url(#paint17_linear_11808_11417)",
    d: "M30.893 41.115l-.989-.699h-5.812l-.989.7-.556 4.604.515-.453h7.872l.536.453-.577-4.605z"
  }), React.createElement("path", {
    fill: "url(#paint18_linear_11808_11417)",
    d: "M51.915 16.757l1.752-8.51L51.029.333 30.894 15.236l7.75 6.537 10.942 3.186 2.411-2.816-1.05-.76 1.668-1.522-1.277-.987 1.67-1.274-1.093-.843z"
  }), React.createElement("path", {
    fill: "url(#paint19_linear_11808_11417)",
    d: "M.333 8.248l1.772 8.51-1.133.842 1.69 1.275-1.278.987 1.67 1.52-1.052.761 2.411 2.816 10.944-3.186 7.748-6.536L2.971.334.333 8.248z"
  }), React.createElement("path", {
    fill: "url(#paint20_radial_11808_11417)",
    d: "M49.588 24.959l-10.943-3.186 3.297 4.974-4.925 9.6 6.512-.083h9.727L49.588 24.96z"
  }), React.createElement("path", {
    fill: "url(#paint21_linear_11808_11417)",
    d: "M49.588 24.959l-10.943-3.186 3.297 4.974-4.925 9.6 6.512-.083h9.727L49.588 24.96z"
  }), React.createElement("path", {
    fill: "url(#paint22_radial_11808_11417)",
    d: "M15.357 21.773L4.414 24.959.767 36.264h9.706l6.512.083-4.925-9.6 3.297-4.974z"
  }), React.createElement("path", {
    fill: "url(#paint23_linear_11808_11417)",
    d: "M15.357 21.773L4.414 24.959.767 36.264h9.706l6.512.083-4.925-9.6 3.297-4.974z"
  }), React.createElement("path", {
    fill: "url(#paint24_linear_11808_11417)",
    d: "M30.198 27.282l.7-12.046 3.174-8.571H19.935l3.173 8.571.7 12.046.269 3.782.02 9.353h5.812l.02-9.353.269-3.782z"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_11808_11417",
    x1: "32.8",
    x2: "59.575",
    y1: "14.669",
    y2: "-12.527",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E17726"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E17726",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_11808_11417",
    x1: "40.798",
    x2: "33.75",
    y1: "14.779",
    y2: "-7.92",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_11808_11417",
    x1: "25.633",
    x2: "-0.72",
    y1: "15.934",
    y2: "-11.683",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_11808_11417",
    x1: "13.479",
    x2: "6.258",
    y1: "14.914",
    y2: "-7.922",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_11808_11417",
    x1: "35.331",
    x2: "50.304",
    y1: "36.173",
    y2: "57.52",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.256",
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_11808_11417",
    x1: "45.757",
    x2: "40.221",
    y1: "47.076",
    y2: "29.914",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_11808_11417",
    x1: "17.198",
    x2: "-2.197",
    y1: "36.173",
    y2: "53.883",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.247",
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_11808_11417",
    x1: "8.517",
    x2: "2.969",
    y1: "47.076",
    y2: "29.923",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_11808_11417",
    x1: "14.247",
    x2: "36.805",
    y1: "25.211",
    y2: "6.658",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E27625",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_11808_11417",
    x1: "18.038",
    x2: "10.382",
    y1: "26.485",
    y2: "9.535",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_11808_11417",
    x1: "36.173",
    x2: "28.373",
    y1: "26.476",
    y2: "9.399",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_11808_11417",
    x1: "34.439",
    x2: "42.072",
    y1: "41.115",
    y2: "58.191",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D5BFB2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D5BFB2",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_11808_11417",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(-15.23496 29.92612 -32.44847 -16.51906 23.03 39.69)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D5BFB2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D5BFB2",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_11808_11417",
    x1: "19.767",
    x2: "19.767",
    y1: "29.665",
    y2: "33.303",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#17396B"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_11808_11417",
    x1: "34.246",
    x2: "34.246",
    y1: "29.665",
    y2: "33.303",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#17396B"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_11808_11417",
    x1: "36.381",
    x2: "17.618",
    y1: "31.536",
    y2: "53.04",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.2",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_11808_11417",
    x1: "16.777",
    x2: "31.746",
    y1: "31.536",
    y2: "51.142",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.328",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_11808_11417",
    x1: "27.009",
    x2: "27.009",
    y1: "40.416",
    y2: "45.72",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#17396B"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_11808_11417",
    x1: "37.464",
    x2: "53.59",
    y1: "19.699",
    y2: "8.548",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#592B0D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#763E1A"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_11808_11417",
    x1: "21.511",
    x2: "1.439",
    y1: "16.268",
    y2: "5.46",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#592B0D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#763E1A"
  })), React.createElement("radialGradient", {
    id: "paint20_radial_11808_11417",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "rotate(11.689 -117.22 213.297) scale(23.489 26.1736)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.264",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_11808_11417",
    x1: "45.281",
    x2: "37.521",
    y1: "35.428",
    y2: "14.824",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("radialGradient", {
    id: "paint22_radial_11808_11417",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "rotate(-159.818 12.556 16.425) scale(41.5536 46.244)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.3",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "0.567",
    stopColor: "#F5841F",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_11808_11417",
    x1: "9.02",
    x2: "1.253",
    y1: "35.428",
    y2: "14.831",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E27625"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FCA15C",
    stopOpacity: "0.83"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_11808_11417",
    x1: "26.898",
    x2: "26.898",
    y1: "6.658",
    y2: "74.544",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.268",
    stopColor: "#F5841F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFC796",
    stopOpacity: "0.89"
  }))));
};

/**
 * We have here connectorId : 'metamask' but actually it's 'injected' type
 * Currently there is no type 'injected' in react-moralis
 * so it's temporary
 */

var connectors = [{
  title: 'Metamask',
  icon: Metamask,
  connectorId: 'metamask',
  priority: 1
}, {
  title: 'WalletConnect',
  icon: WC,
  connectorId: 'walletconnect',
  priority: 2
}, {
  title: 'Trust Wallet',
  icon: TWT,
  connectorId: 'metamask',
  priority: 3
}, {
  title: 'MathWallet',
  icon: MathWallet,
  connectorId: 'metamask',
  priority: 999
}, {
  title: 'TokenPocket',
  icon: TokenPocket,
  connectorId: 'metamask',
  priority: 999
}, {
  title: 'SafePal',
  icon: SafePal,
  connectorId: 'metamask',
  priority: 999
}];

var _templateObject$s, _templateObject2$j, _templateObject3$h, _templateObject4$f, _templateObject5$c, _templateObject6$8, _templateObject7$7, _templateObject8$6, _templateObject9$5;
var WrapperStyled$2 = /*#__PURE__*/styled.div(_templateObject$s || (_templateObject$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    height: 100vh;\n    justify-content: center;\n    left: 0;\n    pointer-events: auto;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: 10;\n"])));
var ModalStyled = /*#__PURE__*/styled.div(_templateObject2$j || (_templateObject2$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-radius: 20px;\n    box-shadow: 0 4px 10px rgba(48, 71, 105, 0.1);\n    display: flex;\n    flex-direction: column;\n    margin: 10px;\n    max-height: 98%;\n    max-width: 568px;\n    width: 100%;\n"])), color.white);
var TitleStyled = /*#__PURE__*/styled.span(_templateObject3$h || (_templateObject3$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    color: ", ";\n    font-size: 22px;\n"])), fonts.semiBold, color.blue);
var HeaderStyled$5 = /*#__PURE__*/styled.div(_templateObject4$f || (_templateObject4$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    padding: 20px 20px 12px;\n"])));
var GridStyled = /*#__PURE__*/styled.div(_templateObject5$c || (_templateObject5$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(256px, 1fr));\n    overflow-y: auto;\n    width: 100%;\n\n    &::-webkit-scrollbar {\n        background: none;\n        height: 0;\n        width: 14px;\n    }\n    &::-webkit-scrollbar-thumb {\n        background-clip: padding-box;\n        background-color: ", ";\n        border-radius: 30px;\n        border: 3px solid transparent;\n    }\n    &::-webkit-scrollbar-button {\n        height: 5px;\n    }\n    &::-webkit-scrollbar-corner {\n        background-color: transparent;\n    }\n"])), color.greyIcons);
var WalletCardStyled = /*#__PURE__*/styled.div(_templateObject6$8 || (_templateObject6$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    border-radius: 20px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 24px;\n\n    @media (max-width: 400px) {\n        padding: 8px;\n    }\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    &:active {\n        background-color: ", ";\n    }\n"])), color.blueLight, color.blueLight2);
var GridItemStyled = /*#__PURE__*/styled.div(_templateObject7$7 || (_templateObject7$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border: 1px solid rgba(195, 195, 195, 0.13);\n    padding: 4px;\n"])));
var WalletLogo = /*#__PURE__*/styled.div(_templateObject8$6 || (_templateObject8$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-self: center;\n    height: 40px;\n    width: fit-content;\n    margin-bottom: 8px;\n    pointer-events: none;\n"])));
var WalletNameStyled = /*#__PURE__*/styled.span(_templateObject9$5 || (_templateObject9$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    color: ", ";\n    font-size: 18px;\n"])), fonts.semiBold, color.blue);
var WalletModalStyles = {
  GridItemStyled: GridItemStyled,
  GridStyled: GridStyled,
  HeaderStyled: HeaderStyled$5,
  ModalStyled: ModalStyled,
  TitleStyled: TitleStyled,
  WalletCardStyled: WalletCardStyled,
  WalletLogo: WalletLogo,
  WalletNameStyled: WalletNameStyled,
  WrapperStyled: WrapperStyled$2
};

var GridItemStyled$1 = WalletModalStyles.GridItemStyled,
    GridStyled$1 = WalletModalStyles.GridStyled,
    HeaderStyled$6 = WalletModalStyles.HeaderStyled,
    ModalStyled$1 = WalletModalStyles.ModalStyled,
    TitleStyled$1 = WalletModalStyles.TitleStyled,
    WalletCardStyled$1 = WalletModalStyles.WalletCardStyled,
    WalletLogo$1 = WalletModalStyles.WalletLogo,
    WalletNameStyled$1 = WalletModalStyles.WalletNameStyled,
    WrapperStyled$3 = WalletModalStyles.WrapperStyled;

var WalletModal = function WalletModal(_ref) {
  var _ref$isOpened = _ref.isOpened,
      isOpened = _ref$isOpened === void 0 ? true : _ref$isOpened,
      moralisAuth = _ref.moralisAuth,
      setIsOpened = _ref.setIsOpened;

  var _useMoralis = useMoralis(),
      authenticate = _useMoralis.authenticate,
      isInitialized = _useMoralis.isInitialized,
      enableWeb3 = _useMoralis.enableWeb3;

  function connectWallet(connectorId) {
    // to avoid problems in Next.JS apps because of localStorage
    if (typeof window == 'undefined') return;
    var connectProps = {
      provider: connectorId,
      onSuccess: function onSuccess() {
        window.localStorage.setItem('connectorId', connectorId);
        setIsOpened(false);
      }
    };
    isInitialized && moralisAuth ? authenticate(connectProps) : enableWeb3(connectProps);
  }

  if (!isOpened) return null;
  return React.createElement(WrapperStyled$3, null, React.createElement(ModalStyled$1, null, React.createElement(HeaderStyled$6, null, React.createElement(TitleStyled$1, null, "Connect Wallet"), React.createElement(Button, {
    icon: iconTypes.x,
    iconLayout: "icon-only",
    theme: "outline",
    onClick: function onClick() {
      return setIsOpened(!isOpened);
    }
  })), React.createElement(GridStyled$1, null, connectors.map(function (_ref2, key) {
    var title = _ref2.title,
        icon = _ref2.icon,
        connectorId = _ref2.connectorId;
    return React.createElement(GridItemStyled$1, {
      key: key
    }, React.createElement(WalletCardStyled$1, {
      onClick: function onClick() {
        return connectWallet(connectorId);
      }
    }, React.createElement(WalletLogo$1, null, icon()), React.createElement(WalletNameStyled$1, null, title)));
  }))));
};

var _templateObject$t, _templateObject2$k, _templateObject3$i, _templateObject4$g, _templateObject5$d, _templateObject6$9, _templateObject7$8;
var flexBox = /*#__PURE__*/css(_templateObject$t || (_templateObject$t = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    align-items: center;\n    display: flex;\n"])), resetCSS);
var WrapperStyled$4 = /*#__PURE__*/styled.div(_templateObject2$k || (_templateObject2$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    height: 40px;\n    margin: 0 16px;\n    white-space: nowrap;\n"])), flexBox);
var AccountInfoStyled = /*#__PURE__*/styled.div(_templateObject3$i || (_templateObject3$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background-color: ", ";\n    border-radius: 16px;\n    flex-direction: row;\n    flex-wrap: wrap;\n    height: 100%;\n    justify-content: space-between;\n    padding: 3px;\n    user-select: none;\n    width: max-content;\n"])), flexBox, color.blueLight);
var ConnectButtonStyled = /*#__PURE__*/styled.button(_templateObject4$g || (_templateObject4$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", "\n    background-color: ", ";\n    border-radius: 16px;\n    border: 2px solid transparent;\n    height: 100%;\n    padding: 4px 16px;\n    transition: all 0.1s ease-out;\n\n    &:hover {\n        border-color: ", ";\n    }\n"])), resetButtonCSS, fonts.semiBold, color.blueLight, color.paleBlue2);
var AddressStyled = /*#__PURE__*/styled.div(_templateObject5$d || (_templateObject5$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background: ", ";\n    border-radius: 12px;\n    border: 1px solid transparent;\n    cursor: pointer;\n    height: 100%;\n    line-height: 25px;\n    padding: 2px 8px;\n    transition: all 0.1s ease-out;\n\n    &:hover {\n        border-color: ", ";\n    }\n"])), flexBox, color.white, color.paleBlue2);
var TextStyled = /*#__PURE__*/styled.span(_templateObject6$9 || (_templateObject6$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    color: ", ";\n"])), fonts.semiBold, color.blue);
var BalanceBlockStyled = /*#__PURE__*/styled.div(_templateObject7$8 || (_templateObject7$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    @media (max-width: 450px) {\n        display: none;\n    }\n"])));
var ConnectButtonStyles = {
  AccountInfoStyled: AccountInfoStyled,
  AddressStyled: AddressStyled,
  BalanceBlockStyled: BalanceBlockStyled,
  ConnectButtonStyled: ConnectButtonStyled,
  TextStyled: TextStyled,
  WrapperStyled: WrapperStyled$4
};

var WrapperStyled$5 = ConnectButtonStyles.WrapperStyled,
    TextStyled$1 = ConnectButtonStyles.TextStyled,
    ConnectButtonStyled$1 = ConnectButtonStyles.ConnectButtonStyled,
    AccountInfoStyled$1 = ConnectButtonStyles.AccountInfoStyled,
    AddressStyled$1 = ConnectButtonStyles.AddressStyled,
    BalanceBlockStyled$1 = ConnectButtonStyles.BalanceBlockStyled;

var ConnectButton = function ConnectButton(_ref) {
  var _ref$moralisAuth = _ref.moralisAuth,
      moralisAuth = _ref$moralisAuth === void 0 ? true : _ref$moralisAuth;

  var _useMoralis = useMoralis(),
      account = _useMoralis.account,
      isAuthenticated = _useMoralis.isAuthenticated,
      logout = _useMoralis.logout,
      deactivateWeb3 = _useMoralis.deactivateWeb3,
      enableWeb3 = _useMoralis.enableWeb3,
      isWeb3Enabled = _useMoralis.isWeb3Enabled,
      isInitialized = _useMoralis.isInitialized,
      isWeb3EnableLoading = _useMoralis.isWeb3EnableLoading,
      isAuthenticating = _useMoralis.isAuthenticating,
      authenticate = _useMoralis.authenticate,
      Moralis = _useMoralis.Moralis;

  var _useState = useState(false),
      isConnectModalOpen = _useState[0],
      setIsConnectModalOpen = _useState[1];

  var _useState2 = useState('disconnected'),
      web3Status = _useState2[0],
      setWeb3Status = _useState2[1];

  useEffect(function () {
    // to avoid problems in Next.JS apps because of window object
    if (typeof window == 'undefined') return;
    var connectorId = window.localStorage.getItem('connectorId');

    if (!isWeb3Enabled && !isWeb3EnableLoading && connectorId && web3Status === 'disconnected') {
      // @ts-ignore
      setWeb3Status('pending');
      enableWeb3({
        provider: connectorId,
        onSuccess: function onSuccess() {
          return setWeb3Status('only_web3');
        }
      });
    }
  }, [isWeb3Enabled, isWeb3EnableLoading, web3Status]);
  useEffect(function () {
    // to avoid problems in Next.JS apps because of window object
    if (typeof window == 'undefined') return;
    var connectorId = window.localStorage.getItem('connectorId');

    if (isInitialized && !isAuthenticated && !isAuthenticating && isWeb3Enabled && moralisAuth && web3Status === 'only_web3') {
      authenticate({
        provider: connectorId
      });
    }
  }, [isAuthenticated, isInitialized, isWeb3Enabled, isAuthenticating]);
  useEffect(function () {
    Moralis.onAccountChanged(function (address) {
      if (!address) disconnectWallet();
    });
  }, []);

  function disconnectWallet() {
    return _disconnectWallet.apply(this, arguments);
  }

  function _disconnectWallet() {
    _disconnectWallet = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof window == 'undefined')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              window.localStorage.removeItem('connectorId');
              setWeb3Status('disconnected');
              deactivateWeb3();
              if (isInitialized) logout();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _disconnectWallet.apply(this, arguments);
  }

  if (!account || moralisAuth && isInitialized && !isAuthenticated) {
    return React.createElement(WrapperStyled$5, null, React.createElement(ConnectButtonStyled$1, {
      onClick: function onClick() {
        return setIsConnectModalOpen(true);
      }
    }, React.createElement(TextStyled$1, null, "Connect Wallet")), React.createElement(WalletModal, {
      isOpened: isConnectModalOpen,
      moralisAuth: moralisAuth,
      setIsOpened: setIsConnectModalOpen
    }));
  }

  return React.createElement(WrapperStyled$5, null, React.createElement(AccountInfoStyled$1, null, React.createElement(BalanceBlockStyled$1, null, React.createElement(NativeBalance, {
    style: {
      margin: '0 8px 0 12px'
    }
  })), React.createElement(AddressStyled$1, {
    onClick: function onClick() {
      return disconnectWallet();
    }
  }, React.createElement(TextStyled$1, {
    style: {
      marginRight: '8px'
    }
  }, account && getEllipsisTxt(account)), React.createElement(Blockie, {
    scale: 2.5,
    seed: account
  }))));
};

var _templateObject$u, _templateObject2$l, _templateObject3$j, _templateObject4$h;
var CredentialsStyled = /*#__PURE__*/styled.div(_templateObject$u || (_templateObject$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    padding: 16px;\n    position: relative;\n    width: ", ";\n"])), color.blueLight, function (p) {
  return p.width;
});
var PreformattedStyled = /*#__PURE__*/styled.pre(_templateObject2$l || (_templateObject2$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    display: flex;\n    height: max-content;\n    justify-content: space-between;\n    overflow-x: auto;\n    position: relative;\n"])), resetCSS);
var ToolsStyled = /*#__PURE__*/styled.div(_templateObject3$j || (_templateObject3$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-self: flex-end;\n    display: flex;\n    font-size: 24px;\n    margin-left: 8px;\n"])));
var DividerStyled = /*#__PURE__*/styled.div(_templateObject4$h || (_templateObject4$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: relative;\n    margin: 0 8px;\n    &:before {\n        border-left: 2px solid ", ";\n        content: '';\n        height: 24px;\n        position: absolute;\n        width: 0;\n    }\n"])), color.paleBlue2);
var CredentialsStyles = {
  CredentialsStyled: CredentialsStyled,
  DividerStyled: DividerStyled,
  PreformattedStyled: PreformattedStyled,
  ToolsStyled: ToolsStyled
};

var _templateObject$v;
var HeaderStyled$7 = /*#__PURE__*/styled.div(_templateObject$v || (_templateObject$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n"])));

var CredentialsHeader = function CredentialsHeader(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? color.grey : _ref$iconColor,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 24 : _ref$iconSize;
  if (!title && !icon) return null;
  return React.createElement(HeaderStyled$7, null, icon && React.createElement(Icon, {
    svg: icon,
    fill: "" + iconColor,
    size: iconSize,
    "data-testid": "cred-test-header-icon"
  }), title && React.createElement(Typography, {
    variant: "body16",
    weight: "600",
    color: color.blueDark,
    "data-testid": "cred-test-header-text"
  }, title));
};

var _templateObject$w;
var HideButtonStyled = /*#__PURE__*/styled.button(_templateObject$w || (_templateObject$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    cursor: pointer;\n"])), resetButtonCSS);

var HideButton = function HideButton(_ref) {
  var _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? color.blue : _ref$iconColor,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 24 : _ref$iconSize,
      _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
      onToggle = _ref.onToggle;
  return React.createElement(HideButtonStyled, {
    onClick: onToggle,
    "data-testid": "test-hidebutton"
  }, isHidden ? React.createElement(Icon, {
    svg: "eyeClosed",
    size: iconSize,
    fill: "" + iconColor
  }) : React.createElement(Icon, {
    svg: "eye",
    size: iconSize,
    fill: "" + iconColor
  }));
};

var CredentialsStyled$1 = CredentialsStyles.CredentialsStyled,
    DividerStyled$1 = CredentialsStyles.DividerStyled,
    PreformattedStyled$1 = CredentialsStyles.PreformattedStyled,
    ToolsStyled$1 = CredentialsStyles.ToolsStyled;

var Credentials = function Credentials(_ref) {
  var _ref$hasCopyButton = _ref.hasCopyButton,
      hasCopyButton = _ref$hasCopyButton === void 0 ? true : _ref$hasCopyButton,
      _ref$hasHideButton = _ref.hasHideButton,
      hasHideButton = _ref$hasHideButton === void 0 ? true : _ref$hasHideButton,
      title = _ref.title,
      icon = _ref.icon,
      iconColor = _ref.iconColor,
      iconSize = _ref.iconSize,
      _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
      text = _ref.text,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      _ref$hiddenText = _ref.hiddenText,
      hiddenText = _ref$hiddenText === void 0 ? '•••••••••••••••••••••••••••••••' : _ref$hiddenText;

  var _useState = useState(isHidden),
      isValueHidden = _useState[0],
      setIsValueHidden = _useState[1];

  useEffect(function () {
    return setIsValueHidden(isHidden);
  }, [isHidden]);
  return React.createElement(CredentialsStyled$1, {
    width: width,
    "data-testid": "test-credentials"
  }, React.createElement(CredentialsHeader, {
    title: title,
    icon: icon,
    iconColor: iconColor,
    iconSize: iconSize
  }), React.createElement(PreformattedStyled$1, null, React.createElement(Typography, {
    monospace: true,
    color: color.blueDark,
    "data-testid": "cred-test-text"
  }, isValueHidden ? hiddenText : text), React.createElement(ToolsStyled$1, null, hasHideButton && React.createElement(HideButton, {
    onToggle: function onToggle() {
      return setIsValueHidden(!isValueHidden);
    },
    isHidden: isValueHidden
  }), hasHideButton && hasCopyButton && React.createElement(DividerStyled$1, null), hasCopyButton && React.createElement(CopyButton, {
    text: text,
    iconSize: 24
  }))));
};

var getMoralisLogo = function getMoralisLogo(color) {
  switch (color) {
    case 'blue':
      return moralisLogoIconBlue();

    case 'black':
      return moralisLogoIconBlack();

    default:
    case 'white':
      return moralisLogoIconWhite();
  }
};

var moralisLogoIconBlue = function moralisLogoIconBlue() {
  return React.createElement("svg", {
    width: "29",
    height: "24",
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000794955 9.9629C0.111307 5.13346 3.82658 1.25555 8.3883 1.25555C12.957 1.25555 16.6653 5.13519 16.7758 9.9629C16.8119 11.5393 15.6401 12.8484 14.1585 12.8867C12.677 12.9251 11.4467 11.6783 11.4106 10.1019C11.3708 8.36267 10.0343 6.96593 8.3883 6.96593C6.75598 6.96593 5.42205 8.34747 5.36687 10.0703C5.37579 12.3802 6.19923 14.6527 7.13472 16.4591C7.59419 17.3464 8.05422 18.0703 8.39522 18.5666C8.56495 18.8136 8.70305 19.0011 8.79389 19.121C8.83925 19.1808 8.87263 19.2235 8.89205 19.2481C8.90176 19.2604 8.90795 19.2681 8.9104 19.2711L8.90943 19.27L8.90819 19.2684C8.90912 19.2696 8.91006 19.2707 8.91099 19.2719C9.881 20.4593 9.76544 22.2588 8.65135 23.2947C7.53541 24.3323 5.84022 24.211 4.86502 23.0236L6.8856 21.1448C4.86502 23.0236 4.8645 23.0229 4.86397 23.0223L4.86023 23.0177L4.8539 23.01C4.84917 23.0042 4.84342 22.9971 4.83669 22.9887C4.82323 22.972 4.80583 22.9503 4.78476 22.9236C4.74262 22.8703 4.68572 22.7972 4.61618 22.7055C4.47721 22.5221 4.28701 22.2631 4.06279 21.9367C3.61588 21.2863 3.02536 20.3564 2.43428 19.215C1.27377 16.974 0 13.7054 0 10.0324V9.99764L0.000794955 9.9629ZM8.90761 19.2677L8.90799 19.2682L8.90819 19.2684C8.908 19.2682 8.9078 19.268 8.90761 19.2677Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9012 9.9649V10.3426C16.9012 11.9002 15.6998 13.1629 14.2178 13.1629C12.7358 13.1629 11.5344 11.9002 11.5344 10.3426V9.89088L11.5352 9.85656C11.6457 5.0861 15.361 1.25555 19.9227 1.25555C24.4845 1.25555 28.1997 5.0861 28.3102 9.85656L28.311 9.89088V9.92521C28.311 12.9187 27.4215 15.6034 26.6026 17.4609C26.1861 18.4057 25.769 19.1786 25.4515 19.7225C25.2922 19.9953 25.1566 20.213 25.0565 20.3686C25.0064 20.4464 24.9652 20.5089 24.9341 20.5551C24.9186 20.5782 24.9057 20.5973 24.8955 20.6122C24.8904 20.6197 24.8859 20.6261 24.8822 20.6315L24.8772 20.6388L24.8741 20.6433C24.8737 20.6439 24.8732 20.6445 22.7975 19.0473L24.8732 20.6445C23.9977 21.9013 22.3186 22.1742 21.1229 21.254C19.9294 20.3356 19.6685 18.5759 20.5379 17.3196C20.5392 17.3177 20.5425 17.3129 20.5476 17.3052C20.5594 17.2877 20.5808 17.2554 20.6106 17.2091C20.6702 17.1165 20.7626 16.9688 20.8771 16.7727C21.107 16.3789 21.4198 15.8001 21.7332 15.0894C22.3697 13.6456 22.9366 11.8184 22.9442 9.96254C22.8889 8.26081 21.555 6.89619 19.9227 6.89619C18.2897 6.89619 16.9553 8.26208 16.9012 9.9649Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M22.7185 22.1659C24.2627 22.1659 25.5146 20.8519 25.5146 19.2311C25.5146 17.6103 24.2627 16.2963 22.7185 16.2963C21.1742 16.2963 19.9224 17.6103 19.9224 19.2311C19.9224 20.8519 21.1742 22.1659 22.7185 22.1659Z",
    fill: "#51A5DA"
  }));
};

var moralisLogoIconWhite = function moralisLogoIconWhite() {
  return React.createElement("svg", {
    width: "29",
    height: "23",
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000794955 8.9629C0.111307 4.13346 3.82658 0.255554 8.3883 0.255554C12.957 0.255554 16.6653 4.13519 16.7758 8.9629C16.8119 10.5393 15.6401 11.8484 14.1585 11.8867C12.677 11.9251 11.4467 10.6783 11.4106 9.10189C11.3708 7.36267 10.0343 5.96593 8.3883 5.96593C6.75598 5.96593 5.42205 7.34747 5.36687 9.07027C5.37579 11.3802 6.19923 13.6527 7.13472 15.4591C7.59419 16.3464 8.05422 17.0703 8.39522 17.5666C8.56495 17.8136 8.70305 18.0011 8.79389 18.121C8.83925 18.1808 8.87263 18.2235 8.89205 18.2481C8.90176 18.2604 8.90795 18.2681 8.9104 18.2711L8.90943 18.27L8.90819 18.2684C8.90912 18.2696 8.91006 18.2707 8.91099 18.2719C9.881 19.4593 9.76544 21.2588 8.65135 22.2947C7.53541 23.3323 5.84022 23.211 4.86502 22.0236L6.8856 20.1448C4.86502 22.0236 4.8645 22.0229 4.86397 22.0223L4.86023 22.0177L4.8539 22.01C4.84917 22.0042 4.84342 21.9971 4.83669 21.9887C4.82323 21.972 4.80583 21.9503 4.78476 21.9236C4.74262 21.8703 4.68572 21.7972 4.61618 21.7055C4.47721 21.5221 4.28701 21.2631 4.06279 20.9367C3.61588 20.2863 3.02536 19.3564 2.43428 18.215C1.27377 15.974 0 12.7054 0 9.0324V8.99764L0.000794955 8.9629ZM8.90761 18.2677L8.90799 18.2682L8.90819 18.2684C8.908 18.2682 8.9078 18.268 8.90761 18.2677Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9012 8.9649V9.34261C16.9012 10.9002 15.6998 12.1629 14.2178 12.1629C12.7358 12.1629 11.5344 10.9002 11.5344 9.34261V8.89088L11.5352 8.85656C11.6457 4.0861 15.361 0.255554 19.9227 0.255554C24.4845 0.255554 28.1997 4.0861 28.3102 8.85656L28.311 8.89088V8.92521C28.311 11.9187 27.4215 14.6034 26.6026 16.4609C26.1861 17.4057 25.769 18.1786 25.4515 18.7225C25.2922 18.9953 25.1566 19.213 25.0565 19.3686C25.0064 19.4464 24.9652 19.5089 24.9341 19.5551C24.9186 19.5782 24.9057 19.5973 24.8955 19.6122C24.8904 19.6197 24.8859 19.6261 24.8822 19.6315L24.8772 19.6388L24.8741 19.6433C24.8737 19.6439 24.8732 19.6445 22.7975 18.0473L24.8732 19.6445C23.9977 20.9013 22.3186 21.1742 21.1229 20.254C19.9294 19.3356 19.6685 17.5759 20.5379 16.3196C20.5392 16.3177 20.5425 16.3129 20.5476 16.3052C20.5594 16.2877 20.5808 16.2554 20.6106 16.2091C20.6702 16.1165 20.7626 15.9688 20.8771 15.7727C21.107 15.3789 21.4198 14.8001 21.7332 14.0894C22.3697 12.6456 22.9366 10.8184 22.9442 8.96254C22.8889 7.26081 21.555 5.89619 19.9227 5.89619C18.2897 5.89619 16.9553 7.26208 16.9012 8.9649Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M22.7185 21.1659C24.2627 21.1659 25.5146 19.8519 25.5146 18.2311C25.5146 16.6103 24.2627 15.2963 22.7185 15.2963C21.1742 15.2963 19.9224 16.6103 19.9224 18.2311C19.9224 19.8519 21.1742 21.1659 22.7185 21.1659Z",
    fill: "#B7E803"
  }));
};

var moralisLogoIconBlack = function moralisLogoIconBlack() {
  return React.createElement("svg", {
    width: "29",
    height: "23",
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000794955 8.9629C0.111307 4.13346 3.82658 0.255554 8.3883 0.255554C12.957 0.255554 16.6653 4.13519 16.7758 8.9629C16.8119 10.5393 15.6401 11.8484 14.1585 11.8867C12.677 11.9251 11.4467 10.6783 11.4106 9.10189C11.3708 7.36267 10.0343 5.96593 8.3883 5.96593C6.75598 5.96593 5.42205 7.34747 5.36687 9.07027C5.37579 11.3802 6.19923 13.6527 7.13472 15.4591C7.59419 16.3464 8.05422 17.0703 8.39522 17.5666C8.56495 17.8136 8.70305 18.0011 8.79389 18.121C8.83925 18.1808 8.87263 18.2235 8.89205 18.2481C8.90176 18.2604 8.90795 18.2681 8.9104 18.2711L8.90943 18.27L8.90819 18.2684C8.90912 18.2696 8.91006 18.2707 8.91099 18.2719C9.881 19.4593 9.76544 21.2588 8.65135 22.2947C7.53541 23.3323 5.84022 23.211 4.86502 22.0236L6.8856 20.1448C4.86502 22.0236 4.8645 22.0229 4.86397 22.0223L4.86023 22.0177L4.8539 22.01C4.84917 22.0042 4.84342 21.9971 4.83669 21.9887C4.82323 21.972 4.80583 21.9503 4.78476 21.9236C4.74262 21.8703 4.68572 21.7972 4.61618 21.7055C4.47721 21.5221 4.28701 21.2631 4.06279 20.9367C3.61588 20.2863 3.02536 19.3564 2.43428 18.215C1.27377 15.974 0 12.7054 0 9.0324V8.99764L0.000794955 8.9629ZM8.90761 18.2677L8.90799 18.2682L8.90819 18.2684C8.908 18.2682 8.9078 18.268 8.90761 18.2677Z",
    fill: "#041836"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9012 8.9649V9.34261C16.9012 10.9002 15.6998 12.1629 14.2178 12.1629C12.7358 12.1629 11.5344 10.9002 11.5344 9.34261V8.89088L11.5352 8.85656C11.6457 4.0861 15.361 0.255554 19.9227 0.255554C24.4845 0.255554 28.1997 4.0861 28.3102 8.85656L28.311 8.89088V8.92521C28.311 11.9187 27.4215 14.6034 26.6026 16.4609C26.1861 17.4057 25.769 18.1786 25.4515 18.7225C25.2922 18.9953 25.1566 19.213 25.0565 19.3686C25.0064 19.4464 24.9652 19.5089 24.9341 19.5551C24.9186 19.5782 24.9057 19.5973 24.8955 19.6122C24.8904 19.6197 24.8859 19.6261 24.8822 19.6315L24.8772 19.6388L24.8741 19.6433C24.8737 19.6439 24.8732 19.6445 22.7975 18.0473L24.8732 19.6445C23.9977 20.9013 22.3186 21.1742 21.1229 20.254C19.9294 19.3356 19.6685 17.5759 20.5379 16.3196C20.5392 16.3177 20.5425 16.3129 20.5476 16.3052C20.5594 16.2877 20.5808 16.2554 20.6106 16.2091C20.6702 16.1165 20.7626 15.9688 20.8771 15.7727C21.107 15.3789 21.4198 14.8001 21.7332 14.0894C22.3697 12.6456 22.9366 10.8184 22.9442 8.96254C22.8889 7.26081 21.555 5.89619 19.9227 5.89619C18.2897 5.89619 16.9553 7.26208 16.9012 8.9649Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M22.7185 21.1659C24.2627 21.1659 25.5146 19.8519 25.5146 18.2311C25.5146 16.6103 24.2627 15.2963 22.7185 15.2963C21.1742 15.2963 19.9224 16.6103 19.9224 18.2311C19.9224 19.8519 21.1742 21.1659 22.7185 21.1659Z",
    fill: "#B7E803"
  }));
};

var getMoralisDefault = function getMoralisDefault(color) {
  switch (color) {
    case 'blue':
      return moralisLogoDefaultBlue();

    case 'black':
      return moralisLogoDefaultBlack();

    default:
    case 'white':
      return moralisLogoDefaultWhite();
  }
};

var moralisLogoDefaultWhite = function moralisLogoDefaultWhite() {
  return React.createElement("svg", {
    width: "124",
    height: "24",
    viewBox: "0 0 124 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000794955 9.9629C0.111307 5.13346 3.82658 1.25555 8.3883 1.25555C12.957 1.25555 16.6653 5.13519 16.7758 9.9629C16.8119 11.5393 15.6401 12.8484 14.1585 12.8867C12.677 12.9251 11.4467 11.6783 11.4106 10.1019C11.3708 8.36267 10.0343 6.96593 8.3883 6.96593C6.75598 6.96593 5.42205 8.34747 5.36687 10.0703C5.37579 12.3802 6.19923 14.6527 7.13472 16.4591C7.59419 17.3464 8.05422 18.0703 8.39522 18.5666C8.56495 18.8136 8.70305 19.0011 8.79389 19.121C8.83925 19.1808 8.87263 19.2235 8.89205 19.2481C8.90176 19.2604 8.90795 19.2681 8.9104 19.2711L8.90943 19.27L8.90819 19.2684C8.90912 19.2696 8.91006 19.2707 8.91099 19.2719C9.881 20.4593 9.76544 22.2588 8.65135 23.2947C7.53541 24.3323 5.84022 24.211 4.86502 23.0236L6.8856 21.1448C4.86502 23.0236 4.8645 23.0229 4.86397 23.0223L4.86023 23.0177L4.8539 23.01C4.84917 23.0042 4.84342 22.9971 4.83669 22.9887C4.82323 22.972 4.80583 22.9503 4.78476 22.9236C4.74262 22.8703 4.68572 22.7972 4.61618 22.7055C4.47721 22.5221 4.28701 22.2631 4.06279 21.9367C3.61588 21.2863 3.02536 20.3564 2.43428 19.215C1.27377 16.974 0 13.7054 0 10.0324V9.99764L0.000794955 9.9629ZM8.90761 19.2677L8.90799 19.2682L8.90819 19.2684C8.908 19.2682 8.9078 19.268 8.90761 19.2677Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9012 9.9649V10.3426C16.9012 11.9002 15.6998 13.1629 14.2178 13.1629C12.7358 13.1629 11.5344 11.9002 11.5344 10.3426V9.89088L11.5352 9.85656C11.6457 5.0861 15.361 1.25555 19.9227 1.25555C24.4845 1.25555 28.1997 5.0861 28.3102 9.85656L28.311 9.89088V9.92521C28.311 12.9187 27.4215 15.6034 26.6026 17.4609C26.1861 18.4057 25.769 19.1786 25.4515 19.7225C25.2922 19.9953 25.1566 20.213 25.0565 20.3686C25.0064 20.4464 24.9652 20.5089 24.9341 20.5551C24.9186 20.5782 24.9057 20.5973 24.8955 20.6122C24.8904 20.6197 24.8859 20.6261 24.8822 20.6315L24.8772 20.6388L24.8741 20.6433C24.8737 20.6439 24.8732 20.6445 22.7975 19.0473L24.8732 20.6445C23.9977 21.9013 22.3186 22.1742 21.1229 21.254C19.9294 20.3356 19.6685 18.5759 20.5379 17.3196C20.5392 17.3177 20.5425 17.3129 20.5476 17.3052C20.5594 17.2877 20.5808 17.2554 20.6106 17.2091C20.6702 17.1165 20.7626 16.9688 20.8771 16.7727C21.107 16.3789 21.4198 15.8001 21.7332 15.0894C22.3697 13.6456 22.9366 11.8184 22.9442 9.96254C22.8889 8.26081 21.555 6.89619 19.9227 6.89619C18.2897 6.89619 16.9553 8.26208 16.9012 9.9649Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M22.7185 22.1659C24.2627 22.1659 25.5146 20.8519 25.5146 19.2311C25.5146 17.6103 24.2627 16.2963 22.7185 16.2963C21.1742 16.2963 19.9224 17.6103 19.9224 19.2311C19.9224 20.8519 21.1742 22.1659 22.7185 22.1659Z",
    fill: "#B7E803"
  }), React.createElement("path", {
    d: "M50.7363 5.83561C52.2538 5.83561 53.4774 6.34551 54.3911 7.36533C55.3128 8.38514 55.7736 9.7368 55.7736 11.4284V19.7164H51.793V11.7764C51.793 11.0885 51.6261 10.5543 51.3004 10.1577C50.9746 9.76108 50.4979 9.56683 49.8782 9.56683C49.2267 9.56683 48.7182 9.79345 48.3527 10.2386C47.9872 10.6919 47.8124 11.307 47.8124 12.1002V19.7164H43.8318V11.7764C43.8318 11.0885 43.6649 10.5543 43.3392 10.1577C43.0134 9.76108 42.5367 9.56683 41.917 9.56683C41.2655 9.56683 40.757 9.79345 40.3915 10.2386C40.026 10.6919 39.8512 11.307 39.8512 12.1002V19.7164H35.8865V6.20792H39.8671V7.44626C40.5901 6.3698 41.774 5.82751 43.4186 5.82751C44.96 5.82751 46.1121 6.41836 46.8907 7.60814C47.7012 6.42645 48.9804 5.83561 50.7363 5.83561Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M69.8447 18.0248C68.4861 19.4007 66.8255 20.0887 64.863 20.0887C62.9005 20.0887 61.24 19.4007 59.8813 18.0248C58.5227 16.6489 57.8394 14.9573 57.8394 12.9581C57.8394 10.959 58.5227 9.27545 59.8813 7.89142C61.24 6.51548 62.9005 5.82751 64.863 5.82751C66.8255 5.82751 68.4861 6.51548 69.8447 7.89142C71.2034 9.26736 71.8867 10.959 71.8867 12.9581C71.8867 14.9654 71.2113 16.6489 69.8447 18.0248ZM62.686 15.2567C63.266 15.8476 63.997 16.147 64.863 16.147C65.7291 16.147 66.4521 15.8476 67.04 15.2567C67.628 14.6659 67.914 13.897 67.914 12.9581C67.914 12.0192 67.62 11.2584 67.04 10.6595C66.46 10.0605 65.7291 9.76917 64.863 9.76917C63.997 9.76917 63.274 10.0686 62.686 10.6595C62.098 11.2503 61.812 12.0192 61.812 12.9581C61.812 13.897 62.106 14.6659 62.686 15.2567Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M78.1157 8.61167C78.362 7.74564 78.8626 7.08195 79.6174 6.6287C80.3722 6.16736 81.1985 5.94073 82.0963 5.94073V10.5299C81.127 10.368 80.2212 10.538 79.379 11.0317C78.5368 11.5254 78.1237 12.3834 78.1237 13.6136V19.7163H74.1431V6.20783H78.1237V8.61167H78.1157Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M93.1798 6.20792H97.1604V19.7083H93.1798V18.4376C92.2423 19.5383 90.9234 20.0887 89.231 20.0887C87.483 20.0887 85.9893 19.4007 84.7498 18.0248C83.5104 16.6489 82.8906 14.9573 82.8906 12.9581C82.8906 10.959 83.5104 9.27545 84.7498 7.89142C85.9893 6.51548 87.483 5.82751 89.231 5.82751C90.9313 5.82751 92.2423 6.37789 93.1798 7.47864V6.20792ZM87.7452 15.37C88.3252 15.9609 89.088 16.2604 90.0255 16.2604C90.9631 16.2604 91.7258 15.9609 92.3058 15.37C92.8859 14.7792 93.1798 13.9779 93.1798 12.9662C93.1798 11.9545 92.8859 11.1532 92.3058 10.5624C91.7258 9.97152 90.9631 9.67205 90.0255 9.67205C89.088 9.67205 88.3252 9.97152 87.7452 10.5624C87.1652 11.1532 86.8712 11.9545 86.8712 12.9662C86.8633 13.9698 87.1573 14.7711 87.7452 15.37Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M100.069 19.7164V0H104.049V19.7164H100.069Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M110.636 4.30593C110.167 4.78346 109.603 5.01818 108.951 5.01818C108.3 5.01818 107.736 4.78346 107.267 4.30593C106.798 3.8284 106.568 3.25374 106.568 2.59005C106.568 1.92636 106.798 1.35171 107.267 0.874177C107.736 0.396645 108.3 0.161926 108.951 0.161926C109.603 0.161926 110.167 0.404739 110.636 0.874177C111.105 1.35171 111.335 1.92636 111.335 2.59005C111.335 3.26183 111.105 3.8284 110.636 4.30593ZM106.965 19.7164V6.20796H110.946V19.7083H106.965V19.7164Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M117.485 10.1577C117.485 10.4248 117.707 10.6514 118.16 10.8214C118.613 10.9913 119.153 11.1613 119.789 11.3313C120.425 11.5012 121.06 11.7198 121.696 11.995C122.331 12.2621 122.872 12.7072 123.325 13.3304C123.777 13.9537 124 14.7307 124 15.6695C124 17.1264 123.468 18.2272 122.411 18.9799C121.354 19.7245 120.043 20.0968 118.486 20.0968C115.689 20.0968 113.79 19.0284 112.789 16.8836L116.237 14.8844C116.587 15.9447 117.342 16.4789 118.494 16.4789C119.447 16.4789 119.924 16.2037 119.924 15.6453C119.924 15.3782 119.701 15.1515 119.249 14.9735C118.796 14.7954 118.255 14.6173 117.62 14.4474C116.984 14.2774 116.349 14.0508 115.713 13.7756C115.077 13.5004 114.537 13.0633 114.084 12.4644C113.631 11.8655 113.409 11.137 113.409 10.2791C113.409 8.87078 113.909 7.78621 114.91 7.00921C115.912 6.23221 117.143 5.85181 118.605 5.85181C119.701 5.85181 120.703 6.10271 121.6 6.59643C122.498 7.09015 123.229 7.8105 123.777 8.74128L120.385 10.6028C119.964 9.80965 119.368 9.41306 118.605 9.41306C117.858 9.39687 117.485 9.64778 117.485 10.1577Z",
    fill: "white"
  }));
};

var moralisLogoDefaultBlack = function moralisLogoDefaultBlack() {
  return React.createElement("svg", {
    width: "124",
    height: "24",
    viewBox: "0 0 124 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000794955 9.9629C0.111307 5.13346 3.82658 1.25555 8.3883 1.25555C12.957 1.25555 16.6653 5.13519 16.7758 9.9629C16.8119 11.5393 15.6401 12.8484 14.1585 12.8867C12.677 12.9251 11.4467 11.6783 11.4106 10.1019C11.3708 8.36267 10.0343 6.96593 8.3883 6.96593C6.75598 6.96593 5.42205 8.34747 5.36687 10.0703C5.37579 12.3802 6.19924 14.6527 7.13472 16.4591C7.59419 17.3464 8.05422 18.0703 8.39522 18.5666C8.56495 18.8136 8.70305 19.0011 8.79389 19.121C8.83925 19.1808 8.87263 19.2235 8.89205 19.2481C8.90176 19.2604 8.90795 19.2681 8.9104 19.2711L8.90943 19.27L8.90819 19.2684C8.90912 19.2696 8.91006 19.2707 8.91099 19.2719C9.881 20.4593 9.76544 22.2588 8.65135 23.2947C7.53541 24.3323 5.84022 24.211 4.86502 23.0236L6.8856 21.1448C4.86502 23.0236 4.8645 23.0229 4.86397 23.0223L4.86023 23.0177L4.8539 23.01C4.84917 23.0042 4.84342 22.9971 4.83669 22.9887C4.82323 22.972 4.80583 22.9503 4.78476 22.9236C4.74262 22.8703 4.68572 22.7972 4.61618 22.7055C4.47721 22.5221 4.28701 22.2631 4.06279 21.9367C3.61588 21.2863 3.02536 20.3564 2.43428 19.215C1.27377 16.974 0 13.7054 0 10.0324V9.99764L0.000794955 9.9629ZM8.90761 19.2677L8.90799 19.2682L8.90819 19.2684C8.908 19.2682 8.9078 19.268 8.90761 19.2677Z",
    fill: "#041836"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9012 9.9649V10.3426C16.9012 11.9002 15.6998 13.1629 14.2178 13.1629C12.7358 13.1629 11.5344 11.9002 11.5344 10.3426V9.89088L11.5352 9.85656C11.6457 5.0861 15.361 1.25555 19.9227 1.25555C24.4845 1.25555 28.1997 5.0861 28.3102 9.85656L28.311 9.89088V9.92521C28.311 12.9187 27.4215 15.6034 26.6026 17.4609C26.1861 18.4057 25.769 19.1786 25.4515 19.7225C25.2922 19.9953 25.1566 20.213 25.0565 20.3686C25.0064 20.4464 24.9652 20.5089 24.9341 20.5551C24.9186 20.5782 24.9057 20.5973 24.8955 20.6122C24.8904 20.6197 24.8859 20.6261 24.8822 20.6315L24.8772 20.6388L24.8741 20.6433C24.8737 20.6439 24.8732 20.6445 22.7975 19.0473L24.8732 20.6445C23.9977 21.9013 22.3186 22.1742 21.1229 21.254C19.9294 20.3356 19.6685 18.5759 20.5379 17.3196C20.5392 17.3177 20.5425 17.3129 20.5476 17.3052C20.5594 17.2877 20.5808 17.2554 20.6106 17.2091C20.6702 17.1165 20.7626 16.9688 20.8771 16.7727C21.107 16.3789 21.4198 15.8001 21.7332 15.0894C22.3697 13.6456 22.9366 11.8184 22.9442 9.96254C22.8889 8.26081 21.555 6.89619 19.9227 6.89619C18.2897 6.89619 16.9553 8.26208 16.9012 9.9649Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M22.7185 22.1659C24.2627 22.1659 25.5146 20.8519 25.5146 19.2311C25.5146 17.6103 24.2627 16.2963 22.7185 16.2963C21.1742 16.2963 19.9224 17.6103 19.9224 19.2311C19.9224 20.8519 21.1742 22.1659 22.7185 22.1659Z",
    fill: "#B7E803"
  }), React.createElement("path", {
    d: "M50.7363 5.83561C52.2538 5.83561 53.4774 6.34551 54.3911 7.36533C55.3128 8.38514 55.7736 9.7368 55.7736 11.4284V19.7164H51.793V11.7764C51.793 11.0885 51.6261 10.5543 51.3004 10.1577C50.9746 9.76108 50.4979 9.56683 49.8782 9.56683C49.2267 9.56683 48.7182 9.79345 48.3527 10.2386C47.9872 10.6919 47.8124 11.307 47.8124 12.1002V19.7164H43.8318V11.7764C43.8318 11.0885 43.6649 10.5543 43.3392 10.1577C43.0134 9.76108 42.5367 9.56683 41.917 9.56683C41.2655 9.56683 40.757 9.79345 40.3915 10.2386C40.026 10.6919 39.8512 11.307 39.8512 12.1002V19.7164H35.8865V6.20792H39.8671V7.44626C40.5901 6.3698 41.774 5.82751 43.4186 5.82751C44.96 5.82751 46.1121 6.41836 46.8907 7.60814C47.7012 6.42645 48.9804 5.83561 50.7363 5.83561Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M69.8447 18.0248C68.4861 19.4007 66.8255 20.0887 64.863 20.0887C62.9005 20.0887 61.24 19.4007 59.8813 18.0248C58.5227 16.6489 57.8394 14.9573 57.8394 12.9581C57.8394 10.959 58.5227 9.27545 59.8813 7.89142C61.24 6.51548 62.9005 5.82751 64.863 5.82751C66.8255 5.82751 68.4861 6.51548 69.8447 7.89142C71.2034 9.26736 71.8867 10.959 71.8867 12.9581C71.8867 14.9654 71.2113 16.6489 69.8447 18.0248ZM62.686 15.2567C63.266 15.8476 63.997 16.147 64.863 16.147C65.7291 16.147 66.4521 15.8476 67.04 15.2567C67.628 14.6659 67.914 13.897 67.914 12.9581C67.914 12.0192 67.62 11.2584 67.04 10.6595C66.46 10.0605 65.7291 9.76917 64.863 9.76917C63.997 9.76917 63.274 10.0686 62.686 10.6595C62.098 11.2503 61.812 12.0192 61.812 12.9581C61.812 13.897 62.106 14.6659 62.686 15.2567Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M78.1157 8.61167C78.362 7.74564 78.8626 7.08195 79.6174 6.6287C80.3722 6.16736 81.1985 5.94073 82.0963 5.94073V10.5299C81.127 10.368 80.2212 10.538 79.379 11.0317C78.5368 11.5254 78.1237 12.3834 78.1237 13.6136V19.7163H74.1431V6.20783H78.1237V8.61167H78.1157Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M93.1798 6.20792H97.1604V19.7083H93.1798V18.4376C92.2423 19.5383 90.9234 20.0887 89.231 20.0887C87.483 20.0887 85.9893 19.4007 84.7498 18.0248C83.5104 16.6489 82.8906 14.9573 82.8906 12.9581C82.8906 10.959 83.5104 9.27545 84.7498 7.89142C85.9893 6.51548 87.483 5.82751 89.231 5.82751C90.9313 5.82751 92.2423 6.37789 93.1798 7.47864V6.20792ZM87.7452 15.37C88.3252 15.9609 89.088 16.2604 90.0255 16.2604C90.9631 16.2604 91.7258 15.9609 92.3058 15.37C92.8859 14.7792 93.1798 13.9779 93.1798 12.9662C93.1798 11.9545 92.8859 11.1532 92.3058 10.5624C91.7258 9.97152 90.9631 9.67205 90.0255 9.67205C89.088 9.67205 88.3252 9.97152 87.7452 10.5624C87.1652 11.1532 86.8712 11.9545 86.8712 12.9662C86.8633 13.9698 87.1573 14.7711 87.7452 15.37Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M100.069 19.7164V0H104.049V19.7164H100.069Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M110.636 4.30593C110.167 4.78346 109.603 5.01818 108.951 5.01818C108.3 5.01818 107.736 4.78346 107.267 4.30593C106.798 3.8284 106.568 3.25374 106.568 2.59005C106.568 1.92636 106.798 1.35171 107.267 0.874177C107.736 0.396645 108.3 0.161926 108.951 0.161926C109.603 0.161926 110.167 0.404739 110.636 0.874177C111.105 1.35171 111.335 1.92636 111.335 2.59005C111.335 3.26183 111.105 3.8284 110.636 4.30593ZM106.965 19.7164V6.20796H110.946V19.7083H106.965V19.7164Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M117.485 10.1577C117.485 10.4248 117.707 10.6514 118.16 10.8214C118.613 10.9913 119.153 11.1613 119.789 11.3313C120.425 11.5012 121.06 11.7198 121.696 11.995C122.331 12.2621 122.872 12.7072 123.325 13.3304C123.777 13.9537 124 14.7307 124 15.6695C124 17.1264 123.468 18.2272 122.411 18.9799C121.354 19.7245 120.043 20.0968 118.486 20.0968C115.689 20.0968 113.79 19.0284 112.789 16.8836L116.237 14.8844C116.587 15.9447 117.342 16.4789 118.494 16.4789C119.447 16.4789 119.924 16.2037 119.924 15.6453C119.924 15.3782 119.701 15.1515 119.249 14.9735C118.796 14.7954 118.255 14.6173 117.62 14.4474C116.984 14.2774 116.349 14.0508 115.713 13.7756C115.077 13.5004 114.537 13.0633 114.084 12.4644C113.631 11.8655 113.409 11.137 113.409 10.2791C113.409 8.87078 113.909 7.78621 114.91 7.00921C115.912 6.23221 117.143 5.85181 118.605 5.85181C119.701 5.85181 120.703 6.10271 121.6 6.59643C122.498 7.09015 123.229 7.8105 123.777 8.74128L120.385 10.6028C119.964 9.80965 119.368 9.41306 118.605 9.41306C117.858 9.39687 117.485 9.64778 117.485 10.1577Z",
    fill: "#041836"
  }));
};

var moralisLogoDefaultBlue = function moralisLogoDefaultBlue() {
  return React.createElement("svg", {
    width: "124",
    height: "24",
    viewBox: "0 0 124 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000794955 9.9629C0.111307 5.13346 3.82658 1.25555 8.3883 1.25555C12.957 1.25555 16.6653 5.13519 16.7758 9.9629C16.8119 11.5393 15.6401 12.8484 14.1585 12.8867C12.677 12.9251 11.4467 11.6783 11.4106 10.1019C11.3708 8.36267 10.0343 6.96593 8.3883 6.96593C6.75598 6.96593 5.42205 8.34747 5.36687 10.0703C5.37579 12.3802 6.19923 14.6527 7.13472 16.4591C7.59419 17.3464 8.05422 18.0703 8.39522 18.5666C8.56495 18.8136 8.70305 19.0011 8.79389 19.121C8.83925 19.1808 8.87263 19.2235 8.89205 19.2481C8.90176 19.2604 8.90795 19.2681 8.9104 19.2711L8.90943 19.27L8.90819 19.2684C8.90912 19.2696 8.91006 19.2707 8.91099 19.2719C9.881 20.4593 9.76544 22.2588 8.65135 23.2947C7.53541 24.3323 5.84022 24.211 4.86502 23.0236L6.8856 21.1448C4.86502 23.0236 4.8645 23.0229 4.86397 23.0223L4.86023 23.0177L4.8539 23.01C4.84917 23.0042 4.84342 22.9971 4.83669 22.9887C4.82323 22.972 4.80583 22.9503 4.78476 22.9236C4.74262 22.8703 4.68572 22.7972 4.61618 22.7055C4.47721 22.5221 4.28701 22.2631 4.06279 21.9367C3.61588 21.2863 3.02536 20.3564 2.43428 19.215C1.27377 16.974 0 13.7054 0 10.0324V9.99764L0.000794955 9.9629ZM8.90761 19.2677L8.90799 19.2682L8.90819 19.2684C8.908 19.2682 8.9078 19.268 8.90761 19.2677Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9012 9.9649V10.3426C16.9012 11.9002 15.6998 13.1629 14.2178 13.1629C12.7358 13.1629 11.5344 11.9002 11.5344 10.3426V9.89088L11.5352 9.85656C11.6457 5.0861 15.361 1.25555 19.9227 1.25555C24.4845 1.25555 28.1997 5.0861 28.3102 9.85656L28.311 9.89088V9.92521C28.311 12.9187 27.4215 15.6034 26.6026 17.4609C26.1861 18.4057 25.769 19.1786 25.4515 19.7225C25.2922 19.9953 25.1566 20.213 25.0565 20.3686C25.0064 20.4464 24.9652 20.5089 24.9341 20.5551C24.9186 20.5782 24.9057 20.5973 24.8955 20.6122C24.8904 20.6197 24.8859 20.6261 24.8822 20.6315L24.8772 20.6388L24.8741 20.6433C24.8737 20.6439 24.8732 20.6445 22.7975 19.0473L24.8732 20.6445C23.9977 21.9013 22.3186 22.1742 21.1229 21.254C19.9294 20.3356 19.6685 18.5759 20.5379 17.3196C20.5392 17.3177 20.5425 17.3129 20.5476 17.3052C20.5594 17.2877 20.5808 17.2554 20.6106 17.2091C20.6702 17.1165 20.7626 16.9688 20.8771 16.7727C21.107 16.3789 21.4198 15.8001 21.7332 15.0894C22.3697 13.6456 22.9366 11.8184 22.9442 9.96254C22.8889 8.26081 21.555 6.89619 19.9227 6.89619C18.2897 6.89619 16.9553 8.26208 16.9012 9.9649Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M22.7185 22.1659C24.2627 22.1659 25.5146 20.8519 25.5146 19.2311C25.5146 17.6103 24.2627 16.2963 22.7185 16.2963C21.1742 16.2963 19.9224 17.6103 19.9224 19.2311C19.9224 20.8519 21.1742 22.1659 22.7185 22.1659Z",
    fill: "#51A5DA"
  }), React.createElement("path", {
    d: "M50.7363 5.83561C52.2538 5.83561 53.4774 6.34551 54.3911 7.36533C55.3128 8.38514 55.7736 9.7368 55.7736 11.4284V19.7164H51.793V11.7764C51.793 11.0885 51.6261 10.5543 51.3004 10.1577C50.9746 9.76108 50.4979 9.56683 49.8782 9.56683C49.2267 9.56683 48.7182 9.79345 48.3527 10.2386C47.9872 10.6919 47.8124 11.307 47.8124 12.1002V19.7164H43.8318V11.7764C43.8318 11.0885 43.6649 10.5543 43.3392 10.1577C43.0134 9.76108 42.5367 9.56683 41.917 9.56683C41.2655 9.56683 40.757 9.79345 40.3915 10.2386C40.026 10.6919 39.8512 11.307 39.8512 12.1002V19.7164H35.8865V6.20792H39.8671V7.44626C40.5901 6.3698 41.774 5.82751 43.4186 5.82751C44.96 5.82751 46.1121 6.41836 46.8907 7.60814C47.7012 6.42645 48.9804 5.83561 50.7363 5.83561Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M69.8447 18.0248C68.4861 19.4007 66.8255 20.0887 64.863 20.0887C62.9005 20.0887 61.24 19.4007 59.8813 18.0248C58.5227 16.6489 57.8394 14.9573 57.8394 12.9581C57.8394 10.959 58.5227 9.27545 59.8813 7.89142C61.24 6.51548 62.9005 5.82751 64.863 5.82751C66.8255 5.82751 68.4861 6.51548 69.8447 7.89142C71.2034 9.26736 71.8867 10.959 71.8867 12.9581C71.8867 14.9654 71.2113 16.6489 69.8447 18.0248ZM62.686 15.2567C63.266 15.8476 63.997 16.147 64.863 16.147C65.7291 16.147 66.4521 15.8476 67.04 15.2567C67.628 14.6659 67.914 13.897 67.914 12.9581C67.914 12.0192 67.62 11.2584 67.04 10.6595C66.46 10.0605 65.7291 9.76917 64.863 9.76917C63.997 9.76917 63.274 10.0686 62.686 10.6595C62.098 11.2503 61.812 12.0192 61.812 12.9581C61.812 13.897 62.106 14.6659 62.686 15.2567Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M78.1157 8.61167C78.362 7.74564 78.8626 7.08195 79.6174 6.6287C80.3722 6.16736 81.1985 5.94073 82.0963 5.94073V10.5299C81.127 10.368 80.2212 10.538 79.379 11.0317C78.5368 11.5254 78.1237 12.3834 78.1237 13.6136V19.7163H74.1431V6.20783H78.1237V8.61167H78.1157Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M93.1798 6.20792H97.1604V19.7083H93.1798V18.4376C92.2423 19.5383 90.9234 20.0887 89.231 20.0887C87.483 20.0887 85.9893 19.4007 84.7498 18.0248C83.5104 16.6489 82.8906 14.9573 82.8906 12.9581C82.8906 10.959 83.5104 9.27545 84.7498 7.89142C85.9893 6.51548 87.483 5.82751 89.231 5.82751C90.9313 5.82751 92.2423 6.37789 93.1798 7.47864V6.20792ZM87.7452 15.37C88.3252 15.9609 89.088 16.2604 90.0255 16.2604C90.9631 16.2604 91.7258 15.9609 92.3058 15.37C92.8859 14.7792 93.1798 13.9779 93.1798 12.9662C93.1798 11.9545 92.8859 11.1532 92.3058 10.5624C91.7258 9.97152 90.9631 9.67205 90.0255 9.67205C89.088 9.67205 88.3252 9.97152 87.7452 10.5624C87.1652 11.1532 86.8712 11.9545 86.8712 12.9662C86.8633 13.9698 87.1573 14.7711 87.7452 15.37Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M100.069 19.7164V0H104.049V19.7164H100.069Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M110.636 4.30593C110.167 4.78346 109.603 5.01818 108.951 5.01818C108.3 5.01818 107.736 4.78346 107.267 4.30593C106.798 3.8284 106.568 3.25374 106.568 2.59005C106.568 1.92636 106.798 1.35171 107.267 0.874177C107.736 0.396645 108.3 0.161926 108.951 0.161926C109.603 0.161926 110.167 0.404739 110.636 0.874177C111.105 1.35171 111.335 1.92636 111.335 2.59005C111.335 3.26183 111.105 3.8284 110.636 4.30593ZM106.965 19.7164V6.20796H110.946V19.7083H106.965V19.7164Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M117.485 10.1577C117.485 10.4248 117.707 10.6514 118.16 10.8214C118.613 10.9913 119.153 11.1613 119.789 11.3313C120.425 11.5012 121.06 11.7198 121.696 11.995C122.331 12.2621 122.872 12.7072 123.325 13.3304C123.777 13.9537 124 14.7307 124 15.6695C124 17.1264 123.468 18.2272 122.411 18.9799C121.354 19.7245 120.043 20.0968 118.486 20.0968C115.689 20.0968 113.79 19.0284 112.789 16.8836L116.237 14.8844C116.587 15.9447 117.342 16.4789 118.494 16.4789C119.447 16.4789 119.924 16.2037 119.924 15.6453C119.924 15.3782 119.701 15.1515 119.249 14.9735C118.796 14.7954 118.255 14.6173 117.62 14.4474C116.984 14.2774 116.349 14.0508 115.713 13.7756C115.077 13.5004 114.537 13.0633 114.084 12.4644C113.631 11.8655 113.409 11.137 113.409 10.2791C113.409 8.87078 113.909 7.78621 114.91 7.00921C115.912 6.23221 117.143 5.85181 118.605 5.85181C119.701 5.85181 120.703 6.10271 121.6 6.59643C122.498 7.09015 123.229 7.8105 123.777 8.74128L120.385 10.6028C119.964 9.80965 119.368 9.41306 118.605 9.41306C117.858 9.39687 117.485 9.64778 117.485 10.1577Z",
    fill: "#2E7DAF"
  }));
};

var getVisaLogo = function getVisaLogo(size) {
  return size === 'regular' ? visaLogoRegular() : visaLogoSmall();
};

var visaLogoRegular = function visaLogoRegular() {
  return React.createElement("svg", {
    width: "45",
    height: "32",
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M23.2729 12.8118C23.2473 14.9083 25.0769 16.0784 26.4552 16.7739C27.8713 17.4877 28.3469 17.9454 28.3415 18.5835C28.3307 19.5604 27.2119 19.9915 26.1646 20.0083C24.3377 20.0377 23.2756 19.4974 22.4311 19.0888L21.773 22.2784C22.6203 22.6828 24.1891 23.0355 25.816 23.0509C29.6347 23.0509 32.1332 21.0985 32.1467 18.0713C32.1616 14.2295 27.0159 14.0168 27.0511 12.2996C27.0632 11.7789 27.5429 11.2233 28.5942 11.082C29.1145 11.0106 30.5509 10.956 32.1791 11.7328L32.8183 8.64675C31.9427 8.31646 30.8171 8.00016 29.4158 8.00016C25.8214 8.00016 23.2932 9.97912 23.2729 12.8118ZM38.9598 8.26607C38.2626 8.26607 37.6748 8.68734 37.4126 9.33393L31.9575 22.8242H35.7735L36.5329 20.6507H41.1962L41.6367 22.8242H45L42.065 8.26607H38.9598ZM39.4936 12.1988L40.5949 17.6654H37.5788L39.4936 12.1988ZM18.6462 8.26607L15.6382 22.8242H19.2745L22.2811 8.26607H18.6462ZM13.2668 8.26607L9.48186 18.1749L7.95087 9.7496C7.77115 8.8091 7.06174 8.26607 6.27395 8.26607H0.0864813L0 8.68874C1.27019 8.97425 2.71335 9.4347 3.58762 9.92734C4.12273 10.2282 4.27542 10.4914 4.45108 11.2065L7.35091 22.8242H11.1939L17.0855 8.26607H13.2668Z",
    fill: "white"
  }));
};

var visaLogoSmall = function visaLogoSmall() {
  return React.createElement("svg", {
    width: "33",
    height: "24",
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M17.0668 9.60889C17.048 11.1813 18.3897 12.0588 19.4005 12.5805C20.439 13.1158 20.7878 13.459 20.7838 13.9377C20.7759 14.6704 19.9554 14.9936 19.1874 15.0062C17.8477 15.0283 17.0688 14.6231 16.4495 14.3166L15.9669 16.7088C16.5882 17.0121 17.7387 17.2767 18.9317 17.2882C21.7321 17.2882 23.5644 15.8239 23.5743 13.5535C23.5852 10.6722 19.8117 10.5126 19.8375 9.22471C19.8464 8.83424 20.1982 8.41752 20.9691 8.3115C21.3506 8.25797 22.404 8.21704 23.598 8.7996L24.0668 6.48509C23.4246 6.23737 22.5992 6.00015 21.5716 6.00015C18.9357 6.00015 17.0817 7.48437 17.0668 9.60889ZM28.5705 6.19959C28.0592 6.19959 27.6282 6.51553 27.4359 7.00048L23.4355 17.1182H26.2339L26.7908 15.488H30.2105L30.5336 17.1182H33L30.8477 6.19959H28.5705ZM28.962 9.14913L29.7696 13.2491H27.5578L28.962 9.14913ZM13.6739 6.19959L11.4681 17.1182H14.1346L16.3395 6.19959H13.6739ZM9.72896 6.19959L6.95337 13.6312L5.83064 7.31223C5.69885 6.60685 5.17861 6.19959 4.60089 6.19959H0.0634196L0 6.51658C0.931476 6.73071 1.98979 7.07605 2.63092 7.44553C3.02333 7.67121 3.13531 7.86855 3.26413 8.40492L5.39067 17.1182H8.20888L12.5293 6.19959H9.72896Z",
    fill: "white"
  }));
};

var getMastercardLogo = function getMastercardLogo(size) {
  return size === 'regular' ? mastercardLogoRegular() : mastercardLogoSmall();
};

var mastercardLogoRegular = function mastercardLogoRegular() {
  return React.createElement("svg", {
    width: "34",
    height: "32",
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_244_13197)"
  }, React.createElement("path", {
    d: "M21.607 7.61462H12.3606V24.3869H21.607V7.61462Z",
    fill: "#FF5F00"
  }), React.createElement("path", {
    d: "M12.9553 16.0003C12.9538 14.385 13.3164 12.7905 14.0157 11.3376C14.7149 9.88471 15.7325 8.61142 16.9913 7.61415C15.4325 6.37731 13.5603 5.60813 11.5888 5.39454C9.61729 5.18095 7.62604 5.53155 5.84263 6.40629C4.05921 7.28103 2.55559 8.64462 1.50362 10.3412C0.451656 12.0377 -0.106201 13.9988 -0.106201 16.0003C-0.106201 18.0017 0.451656 19.9628 1.50362 21.6594C2.55559 23.3559 4.05921 24.7195 5.84263 25.5942C7.62604 26.469 9.61729 26.8196 11.5888 26.606C13.5603 26.3924 15.4325 25.6232 16.9913 24.3864C15.7325 23.3891 14.715 22.1158 14.0157 20.6629C13.3165 19.21 12.9538 17.6156 12.9553 16.0003Z",
    fill: "#EB001B"
  }), React.createElement("path", {
    d: "M34.0814 16.0003C34.0815 18.0017 33.5237 19.9628 32.4718 21.6593C31.4199 23.3559 29.9163 24.7195 28.1329 25.5942C26.3495 26.469 24.3583 26.8196 22.3868 26.606C20.4154 26.3924 18.5432 25.6232 16.9844 24.3864C18.2421 23.3881 19.2589 22.1146 19.958 20.6619C20.6572 19.2093 21.0204 17.6153 21.0204 16.0003C21.0204 14.3852 20.6572 12.7913 19.958 11.3386C19.2589 9.88592 18.2421 8.61243 16.9844 7.61415C18.5432 6.3773 20.4154 5.60812 22.3868 5.39454C24.3583 5.18095 26.3495 5.53157 28.1329 6.40632C29.9163 7.28107 31.4199 8.64465 32.4718 10.3412C33.5237 12.0378 34.0815 13.9988 34.0814 16.0003Z",
    fill: "#F79E1B"
  }), React.createElement("path", {
    d: "M33.0867 22.6121V22.2688H33.2238V22.1988H32.8745V22.2688H33.0117V22.6121H33.0867ZM33.7649 22.6121V22.1981H33.6578L33.5347 22.4829L33.4115 22.1981H33.3043V22.6121H33.3799V22.2998L33.4954 22.5691H33.5738L33.6893 22.2992V22.6121H33.7649Z",
    fill: "#F79E1B"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_244_13197"
  }, React.createElement("rect", {
    width: "34",
    height: "32",
    fill: "white"
  }))));
};

var mastercardLogoSmall = function mastercardLogoSmall() {
  return React.createElement("svg", {
    width: "26",
    height: "24",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_248_13976)"
  }, React.createElement("path", {
    d: "M16.5229 5.71094H9.45215V18.2901H16.5229V5.71094Z",
    fill: "#FF5F00"
  }), React.createElement("path", {
    d: "M9.90713 12.0002C9.90601 10.7888 10.1833 9.59293 10.718 8.50324C11.2528 7.41356 12.0309 6.4586 12.9935 5.71065C11.8014 4.78301 10.3698 4.20613 8.86217 4.04593C7.35456 3.88574 5.83184 4.14869 4.46805 4.80475C3.10426 5.46081 1.95443 6.48349 1.14999 7.75591C0.345542 9.02833 -0.0810547 10.4991 -0.0810547 12.0002C-0.0810547 13.5013 0.345542 14.9721 1.14999 16.2446C1.95443 17.517 3.10426 18.5397 4.46805 19.1957C5.83184 19.8518 7.35456 20.1147 8.86217 19.9545C10.3698 19.7943 11.8014 19.2175 12.9935 18.2898C12.0309 17.5419 11.2528 16.5869 10.7181 15.4972C10.1833 14.4075 9.90602 13.2117 9.90713 12.0002Z",
    fill: "#EB001B"
  }), React.createElement("path", {
    d: "M26.0622 12.0002C26.0623 13.5013 25.6357 14.9721 24.8313 16.2445C24.0269 17.5169 22.8771 18.5396 21.5134 19.1957C20.1496 19.8518 18.6269 20.1147 17.1193 19.9545C15.6117 19.7943 14.1801 19.2175 12.988 18.2898C13.9498 17.5411 14.7274 16.586 15.262 15.4965C15.7966 14.407 16.0744 13.2115 16.0744 12.0002C16.0744 10.789 15.7966 9.59349 15.262 8.50398C14.7274 7.41447 13.9498 6.45935 12.988 5.71064C14.1801 4.78301 15.6117 4.20612 17.1193 4.04593C18.6269 3.88574 20.1496 4.1487 21.5134 4.80477C22.8771 5.46083 24.0269 6.48352 24.8313 7.75593C25.6357 9.02835 26.0623 10.4992 26.0622 12.0002Z",
    fill: "#F79E1B"
  }), React.createElement("path", {
    d: "M25.3017 16.9591V16.7015H25.4065V16.6491H25.1394V16.7015H25.2443V16.9591H25.3017ZM25.8203 16.9591V16.6486H25.7384L25.6442 16.8621L25.55 16.6486H25.4681V16.9591H25.5259V16.7248L25.6142 16.9268H25.6742L25.7625 16.7243V16.9591H25.8203Z",
    fill: "#F79E1B"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_248_13976"
  }, React.createElement("rect", {
    width: "26",
    height: "24",
    fill: "white"
  }))));
};

var getAmexLogo = function getAmexLogo(size) {
  return size === 'regular' ? amexLogoRegular() : amexLogoSmall();
};

var amexLogoRegular = function amexLogoRegular() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "44",
    height: "15",
    viewBox: "0 0 44 15",
    fill: "none"
  }, React.createElement("path", {
    d: "M2.22743 0.299099L0.00830078 5.45869H1.45308L1.86254 4.42549H4.24293L4.65024 5.45869H6.12687L3.90976 0.299099H2.22743ZM3.04847 1.49985L3.77403 3.30534H2.3208L3.04847 1.49985ZM6.2796 5.45781V0.298218L8.33267 0.30583L9.52683 3.63244L10.6924 0.298218H12.7291V5.45781H11.4392V1.65601L10.0719 5.45781H8.94062L7.56949 1.65601V5.45781H6.2796ZM13.6116 5.45781V0.298218H17.8208V1.45233H14.9151V2.33488H17.7529V3.42115H14.9151V4.33767H17.8208V5.45781H13.6116ZM18.5676 0.299099V5.45869H19.8575V3.62566H20.4006L21.9472 5.45869H23.5235L21.8263 3.55777C22.5228 3.49899 23.2413 2.90116 23.2413 1.97298C23.2413 0.887244 22.3892 0.299099 21.4381 0.299099H18.5676ZM19.8575 1.45321H21.3319C21.6857 1.45321 21.943 1.72989 21.943 1.9963C21.943 2.33906 21.6096 2.53944 21.3511 2.53944H19.8575V1.45321ZM25.085 5.45781H23.7679V0.298218H25.085V5.45781ZM28.2079 5.45781H27.9236C26.5481 5.45781 25.713 4.3741 25.713 2.89922C25.713 1.38787 26.5387 0.298218 28.2758 0.298218H29.7014V1.52023H28.2237C27.5185 1.52023 27.0198 2.07053 27.0198 2.91194C27.0198 3.91118 27.5901 4.33085 28.4115 4.33085H28.751L28.2079 5.45781ZM31.0147 0.299099L28.7956 5.45869H30.2404L30.6498 4.42549H33.0302L33.4375 5.45869H34.9141L32.6971 0.299099H31.0147ZM31.8357 1.49985L32.5613 3.30534H31.108L31.8357 1.49985ZM35.0647 5.45781V0.298218H36.7047L38.7986 3.53995V0.298218H40.0886V5.45781H38.5016L36.3546 2.13125V5.45781H35.0647ZM9.40253 14.4871V9.32751H13.6116V10.4816H10.706V11.3642H13.5437V12.4504H10.706V13.367H13.6116V14.4871H9.40253ZM30.0274 14.4871V9.32751H34.2365V10.4816H31.3308V11.3642H34.155V12.4504H31.3308V13.367H34.2364V14.4871H30.0274ZM13.775 14.4871L15.8244 11.9392L13.7262 9.32751H15.3513L16.6009 10.942L17.8548 9.32751H19.4163L17.3456 11.9073L19.3988 14.4871H17.774L16.5606 12.8981L15.3768 14.4871H13.775ZM19.552 9.32839V14.488H20.8758V12.8587H22.2336C23.3825 12.8587 24.2533 12.2491 24.2533 11.0638C24.2533 10.0819 23.5703 9.32839 22.4012 9.32839H19.552ZM20.8758 10.4953H22.3057C22.6769 10.4953 22.9422 10.7227 22.9422 11.0893C22.9422 11.4336 22.6782 11.6833 22.3015 11.6833H20.8758V10.4953ZM24.8134 9.32751V14.4871H26.1033V12.6541H26.6465L28.193 14.4871H29.7693L28.0721 12.5862C28.7687 12.5274 29.4872 11.9296 29.4872 11.0014C29.4872 9.91566 28.635 9.32751 27.6839 9.32751H24.8134ZM26.1033 10.4816H27.5778C27.9315 10.4816 28.1888 10.7583 28.1888 11.0248C28.1888 11.3675 27.8554 11.5679 27.5969 11.5679H26.1033V10.4816ZM34.8339 14.4871V13.367H37.4154C37.7974 13.367 37.9628 13.1605 37.9628 12.9341C37.9628 12.7172 37.7979 12.498 37.4154 12.498H36.2488C35.2349 12.498 34.6701 11.8802 34.6701 10.9526C34.6701 10.1253 35.1873 9.32751 36.6941 9.32751H39.206L38.6629 10.4884H36.4904C36.0751 10.4884 35.9473 10.7063 35.9473 10.9145C35.9473 11.1283 36.1053 11.3642 36.4225 11.3642H37.6445C38.7749 11.3642 39.2654 12.0054 39.2654 12.845C39.2654 13.7478 38.7188 14.4871 37.583 14.4871H34.8339ZM39.5681 14.4871V13.367H42.1496C42.5316 13.367 42.697 13.1605 42.697 12.9341C42.697 12.7172 42.5321 12.498 42.1496 12.498H40.9831C39.9691 12.498 39.4044 11.8802 39.4044 10.9526C39.4044 10.1253 39.9215 9.32751 41.4283 9.32751H43.9402L43.3971 10.4884H41.2246C40.8094 10.4884 40.6815 10.7063 40.6815 10.9145C40.6815 11.1283 40.8395 11.3642 41.1568 11.3642H42.3788C43.5091 11.3642 43.9996 12.0054 43.9996 12.845C43.9996 13.7478 43.4531 14.4871 42.3172 14.4871H39.5681Z",
    fill: "white"
  }));
};

var amexLogoSmall = function amexLogoSmall() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "12",
    viewBox: "0 0 34 12",
    fill: "none"
  }, React.createElement("path", {
    d: "M2.38534 0.974293L0.745117 4.84399H1.813L2.11564 4.06909H3.87506L4.17611 4.84399H5.26754L3.62881 0.974293H2.38534ZM2.9922 1.87486L3.52848 3.22898H2.45436L2.9922 1.87486ZM5.38042 4.84333V0.973633L6.89791 0.979342L7.78055 3.4743L8.64205 0.973633H10.1474V4.84333H9.19404V1.99198L8.18339 4.84333H7.34726L6.33383 1.99198V4.84333H5.38042ZM10.7998 4.84333V0.973633H13.9109V1.83922H11.7632V2.50113H13.8607V3.31583H11.7632V4.00322H13.9109V4.84333H10.7998ZM14.4629 0.974293V4.84399H15.4163V3.46922H15.8177L16.9608 4.84399H18.1259L16.8714 3.4183C17.3863 3.37421 17.9174 2.92584 17.9174 2.22971C17.9174 1.4154 17.2875 0.974293 16.5845 0.974293H14.4629ZM15.4163 1.83988H16.5061C16.7675 1.83988 16.9577 2.04738 16.9577 2.2472C16.9577 2.50427 16.7113 2.65455 16.5202 2.65455H15.4163V1.83988ZM19.2801 4.84333H18.3066V0.973633H19.2801V4.84333ZM21.5883 4.84333H21.3782C20.3615 4.84333 19.7442 4.03054 19.7442 2.92439C19.7442 1.79088 20.3546 0.973633 21.6385 0.973633H22.6922V1.89014H21.6C21.0788 1.89014 20.7102 2.30287 20.7102 2.93393C20.7102 3.68335 21.1316 3.9981 21.7388 3.9981H21.9897L21.5883 4.84333ZM23.6629 0.974293L22.0227 4.84399H23.0906L23.3932 4.06909H25.1526L25.4537 4.84399H26.5451L24.9064 0.974293H23.6629ZM24.2698 1.87486L24.806 3.22898H23.7319L24.2698 1.87486ZM26.6564 4.84333V0.973633H27.8685L29.4162 3.40493V0.973633H30.3697V4.84333H29.1967L27.6098 2.34841V4.84333H26.6564ZM7.68868 11.6153V7.7456H10.7998V8.61119H8.6521V9.27314H10.7496V10.0878H8.6521V10.7752H10.7998V11.6153H7.68868ZM22.9331 11.6153V7.7456H26.0442V8.61119H23.8965V9.27314H25.984V10.0878H23.8965V10.7752H26.0442V11.6153H22.9331ZM10.9205 11.6153L12.4353 9.70434L10.8844 7.7456H12.0856L13.0092 8.95647L13.936 7.7456H15.0901L13.5597 9.68045L15.0772 11.6153H13.8763L12.9795 10.4235L12.1045 11.6153H10.9205ZM15.1905 7.74626V11.616H16.1689V10.394H17.1725C18.0217 10.394 18.6654 9.93683 18.6654 9.04784C18.6654 8.31139 18.1605 7.74626 17.2964 7.74626H15.1905ZM16.1689 8.62142H17.2258C17.5002 8.62142 17.6963 8.79203 17.6963 9.06692C17.6963 9.32518 17.5012 9.51245 17.2227 9.51245H16.1689V8.62142ZM19.0793 7.7456V11.6153H20.0327V10.2405H20.4342L21.5773 11.6153H22.7424L21.488 10.1896C22.0028 10.1456 22.5338 9.69715 22.5338 9.00102C22.5338 8.18671 21.904 7.7456 21.201 7.7456H19.0793ZM20.0327 8.61119H21.1226C21.384 8.61119 21.5742 8.81869 21.5742 9.01854C21.5742 9.27561 21.3278 9.42586 21.1367 9.42586H20.0327V8.61119ZM26.4858 11.6153V10.7752H28.3938C28.6762 10.7752 28.7984 10.6204 28.7984 10.4506C28.7984 10.2879 28.6766 10.1234 28.3938 10.1234H27.5316C26.7821 10.1234 26.3647 9.66012 26.3647 8.96445C26.3647 8.34396 26.747 7.7456 27.8607 7.7456H29.7173L29.3159 8.61631H27.7101C27.4032 8.61631 27.3087 8.77972 27.3087 8.93581C27.3087 9.09619 27.4255 9.27314 27.66 9.27314H28.5632C29.3987 9.27314 29.7612 9.75401 29.7612 10.3837C29.7612 11.0608 29.3572 11.6153 28.5177 11.6153H26.4858ZM29.985 11.6153V10.7752H31.893C32.1754 10.7752 32.2976 10.6204 32.2976 10.4506C32.2976 10.2879 32.1758 10.1234 31.893 10.1234H31.0308C30.2813 10.1234 29.864 9.66012 29.864 8.96445C29.864 8.34396 30.2462 7.7456 31.3599 7.7456H33.2165L32.8151 8.61631H31.2094C30.9024 8.61631 30.8079 8.77972 30.8079 8.93581C30.8079 9.09619 30.9247 9.27314 31.1592 9.27314H32.0624C32.8979 9.27314 33.2604 9.75401 33.2604 10.3837C33.2604 11.0608 32.8565 11.6153 32.0169 11.6153H29.985Z",
    fill: "white"
  }));
};

var getDinersLogo = function getDinersLogo(size) {
  return size === 'regular' ? dinersLogoRegular() : dinersLogoSmall();
};

var dinersLogoRegular = function dinersLogoRegular() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "23",
    viewBox: "0 0 34 23",
    fill: "none"
  }, React.createElement("circle", {
    cx: "11.2087",
    cy: "11.2088",
    r: "10.8352",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6216 8.30363C33.2451 6.89234 32.5895 5.5563 31.7007 4.40561C30.8117 3.25472 29.6891 2.28939 28.5179 1.57482C27.3467 0.860259 26.1267 0.396868 25.249 0.157996C24.3716 -0.080876 23.8495 0.0220542 23.3217 0.0220542H10.6789C10.3354 0.0220542 9.99342 0.0222593 9.11524 0.241242C8.23706 0.460225 6.82433 0.865795 5.56025 1.56006C4.29637 2.25433 3.18134 3.23709 2.29602 4.39659C1.40869 5.56047 0.757244 6.8878 0.378558 8.30343C0.00169206 9.71956 -0.095008 11.1962 0.0939301 12.6497C0.284795 14.103 0.758059 15.5045 1.48685 16.7747C2.21434 18.04 3.19298 19.1597 4.35211 20.0266C5.51125 20.8935 6.85067 21.5078 7.93426 21.889C9.01784 22.27 9.84559 22.4176 10.6784 22.4176H23.3211C24.1537 22.4176 24.9817 22.27 26.0651 21.889C27.1487 21.5078 28.4881 20.8937 29.6474 20.0266C30.8063 19.1595 31.785 18.04 32.5127 16.7747C33.2415 15.5045 33.7147 14.103 33.9056 12.6497C34.0951 11.1963 33.9986 9.71967 33.6216 8.30363ZM21.3273 13.9406C20.9671 15.2871 20.3475 16.5496 19.5035 17.6567C18.658 18.7628 17.6043 19.6913 16.4024 20.3895C15.1994 21.0857 13.8718 21.5377 12.4952 21.72C11.1185 21.9005 9.71989 21.8081 8.37855 21.4481C7.03772 21.0864 5.78055 20.4641 4.67819 19.6165C3.5768 18.7675 2.65226 17.7094 1.95708 16.5024C1.26376 15.2943 0.813593 13.9611 0.63215 12.5787C0.451859 11.2006 0.544557 9.78689 0.902893 8.44449C1.26123 7.1021 1.88459 5.83146 2.72663 4.72855C3.57213 3.62247 4.62578 2.69396 5.82773 1.99577C7.03072 1.29957 8.35818 0.847436 9.73472 0.665061C11.1115 0.48457 12.5101 0.57694 13.8514 0.936944C15.1923 1.29869 16.4495 1.92097 17.552 2.76857C18.6503 3.61436 19.5813 4.67913 20.2733 5.88272C20.9653 7.08631 21.4177 8.4285 21.598 9.80658C21.7783 11.1847 21.6854 12.5982 21.3273 13.9406Z",
    fill: "#383E93"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95427 7.32289C6.48248 7.84267 6.11047 8.44558 5.857 9.10121C5.60386 9.75709 5.47371 10.4543 5.47314 11.1578C5.47314 11.859 5.60443 12.5602 5.857 13.2143C6.10957 13.8682 6.48343 14.4747 6.95427 14.9926C7.42511 15.5106 7.99252 15.9395 8.61711 16.2532V6.0623C7.99077 6.37691 7.42718 6.80417 6.95427 7.32289ZM15.2987 7.29316C14.8176 6.77284 14.2446 6.34648 13.6089 6.03564V16.2799C14.2446 15.969 14.8175 15.5426 15.2987 15.0224C15.7788 14.501 16.1577 13.8942 16.416 13.2332C16.6739 12.5718 16.8065 11.868 16.8072 11.1578C16.8072 10.4496 16.6735 9.74175 16.416 9.08234C16.1577 8.4213 15.7788 7.81451 15.2987 7.29316Z",
    fill: "#383E93"
  }));
};

var dinersLogoSmall = function dinersLogoSmall() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "18",
    viewBox: "0 0 26 18",
    fill: "none"
  }, React.createElement("ellipse", {
    cx: "8.71954",
    cy: "9.15665",
    rx: "8.0086",
    ry: "8.12637",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2856 6.97772C25.0073 5.91925 24.5227 4.91722 23.8657 4.05421C23.2086 3.19104 22.3789 2.46704 21.5133 1.93112C20.6476 1.39519 19.7459 1.04765 19.0971 0.868497C18.4486 0.689343 18.0627 0.766541 17.6726 0.766541H8.32788C8.07404 0.766541 7.82125 0.766694 7.17216 0.930932C6.52307 1.09517 5.47888 1.39935 4.54456 1.92005C3.61039 2.44075 2.78624 3.17781 2.13187 4.04744C1.47602 4.92036 0.994516 5.91585 0.714618 6.97757C0.436065 8.03967 0.364591 9.14712 0.504241 10.2373C0.645315 11.3272 0.995119 12.3784 1.53379 13.331C2.0715 14.28 2.79484 15.1198 3.65159 15.77C4.50834 16.4201 5.49835 16.8809 6.29926 17.1667C7.10018 17.4525 7.71199 17.5632 8.32758 17.5632H17.6721C18.2876 17.5632 18.8995 17.4525 19.7003 17.1667C20.5012 16.8809 21.4912 16.4203 22.3481 15.77C23.2047 15.1196 23.9281 14.28 24.4659 13.331C25.0046 12.3784 25.3544 11.3272 25.4955 10.2373C25.6356 9.14721 25.5642 8.03976 25.2856 6.97772ZM16.1984 11.2055C15.9322 12.2153 15.4743 13.1622 14.8505 13.9926C14.2255 14.8221 13.4467 15.5185 12.5584 16.0421C11.6691 16.5643 10.6879 16.9033 9.67043 17.04C8.65284 17.1754 7.61908 17.1061 6.62766 16.8361C5.63661 16.5648 4.70739 16.0981 3.89261 15.4624C3.07854 14.8256 2.39518 14.032 1.88135 13.1268C1.3689 12.2207 1.03617 11.2208 0.902056 10.184C0.768797 9.15049 0.837313 8.09017 1.10217 7.08337C1.36703 6.07657 1.82777 5.1236 2.45015 4.29641C3.07509 3.46685 3.85387 2.77047 4.74226 2.24683C5.63143 1.72467 6.6126 1.38558 7.63004 1.2488C8.64763 1.11343 9.68139 1.18271 10.6728 1.45271C11.6639 1.72402 12.5932 2.19073 13.408 2.82643C14.2198 3.46077 14.908 4.25935 15.4194 5.16204C15.9309 6.06473 16.2653 7.07138 16.3986 8.10493C16.5318 9.13849 16.4632 10.1987 16.1984 11.2055Z",
    fill: "#383E93"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57497 6.24217C5.22625 6.632 4.95129 7.08418 4.76395 7.5759C4.57684 8.06782 4.48064 8.59075 4.48022 9.11832C4.48022 9.64425 4.57726 10.1702 4.76395 10.6607C4.95063 11.1511 5.22696 11.606 5.57497 11.9945C5.92298 12.3829 6.34238 12.7046 6.80403 12.9399V5.29673C6.34108 5.53269 5.92451 5.85313 5.57497 6.24217ZM11.7426 6.21987C11.387 5.82963 10.9635 5.50986 10.4936 5.27673V12.9599C10.9635 12.7267 11.3869 12.407 11.7426 12.0168C12.0974 11.6258 12.3775 11.1707 12.5684 10.6749C12.759 10.1789 12.8571 9.65099 12.8576 9.11832C12.8576 8.58716 12.7587 8.05631 12.5684 7.56176C12.3775 7.06598 12.0974 6.61088 11.7426 6.21987Z",
    fill: "#383E93"
  }));
};

var Logo = function Logo(_ref) {
  var theme = _ref.theme,
      color = _ref.color,
      size = _ref.size;

  switch (theme) {
    case 'amex':
      return React.createElement("div", {
        "data-testid": "test-logo-amex"
      }, getAmexLogo(size || 'regular'));

    case 'default':
      return React.createElement("div", {
        "data-testid": "test-logo-default"
      }, getMoralisDefault(color || 'white'));

    case 'diners':
      return React.createElement("div", {
        "data-testid": "test-logo-diners"
      }, getDinersLogo(size || 'regular'));

    case 'mastercard':
      return React.createElement("div", {
        "data-testid": "test-logo-mastercard"
      }, getMastercardLogo(size || 'regular'));

    case 'icon':
      return React.createElement("div", {
        "data-testid": "test-logo-icon"
      }, getMoralisLogo(color || 'white'));

    case 'visa':
      return React.createElement("div", {
        "data-testid": "test-logo-visa"
      }, getVisaLogo(size || 'regular'));
  }
};

var _templateObject$x, _templateObject2$m, _templateObject3$k, _templateObject4$i, _templateObject6$a, _templateObject7$9, _templateObject8$7, _templateObject9$6;

var getBgGradient = function getBgGradient(brand) {
  switch (brand) {
    case 'amex':
      return gradientColors.lightBlue;

    case 'diners':
      return gradientColors.purpleToPink;

    case 'mastercard':
      return gradientColors.blue;

    case 'visa':
      return gradientColors.goldShiny;
  }
};

var DivStyledCreditCard = /*#__PURE__*/styled.div(_templateObject$x || (_templateObject$x = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    background: ", ";\n    border: 2px solid ", ";\n    border-radius: 16px;\n    display: grid;\n    gap: 20%;\n    padding: 16px;\n    height: 154px;\n    width: 277px;\n\n    ", "\n"])), resetCSS, fonts.text, function (_ref) {
  var brand = _ref.brand;
  return getBgGradient(brand);
}, /*#__PURE__*/colorPercentage(color.white, 40), function (_ref2) {
  var isExpired = _ref2.isExpired,
      pressed = _ref2.pressed;
  return isExpired ? expiredStyles : pressed ? pressedStyles : '';
});
var DivStyledFlexEnd = /*#__PURE__*/styled.div(_templateObject2$m || (_templateObject2$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n"])));
var DivStyledFlex = /*#__PURE__*/styled.div(_templateObject3$k || (_templateObject3$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n\n    svg {\n        cursor: pointer;\n    }\n"])));
var DivStyledFlexText = /*#__PURE__*/styled.div(_templateObject4$i || (_templateObject4$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    color: white;\n    display: flex;\n    margin-right: 8px;\n"])));
var PStyledDigits = /*#__PURE__*/styled.p(_templateObject6$a || (_templateObject6$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    color: ", ";\n    font-size: 18px;\n    line-height: 24px;\n    margin: 0;\n"])), fonts.semiBold, color.white);
var PStyledText = /*#__PURE__*/styled.p(_templateObject7$9 || (_templateObject7$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    color: ", ";\n    font-size: 12px;\n    line-height: 16px;\n    margin: 0 0 0 5px;\n"])), fonts.semiBold, color.white);
var expiredStyles = /*#__PURE__*/css(_templateObject8$7 || (_templateObject8$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-color: ", ";\n"])), color.red);
var pressedStyles = /*#__PURE__*/css(_templateObject9$6 || (_templateObject9$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-color: ", ";\n"])), color.green);

var CreditCard = function CreditCard(_ref) {
  var expiresAt = _ref.expiresAt,
      isExpired = _ref.isExpired,
      lastDigits = _ref.lastDigits,
      name = _ref.name,
      onRemove = _ref.onRemove,
      brand = _ref.brand,
      pressed = _ref.pressed;
  return React.createElement(DivStyledCreditCard, {
    brand: brand,
    isExpired: isExpired,
    pressed: pressed
  }, React.createElement(DivStyledFlexEnd, null, React.createElement(Tooltip, {
    position: "bottom",
    children: React.createElement(Button, {
      onClick: function onClick() {
        return onRemove && onRemove();
      },
      isTransparent: true,
      theme: 'secondary',
      icon: iconTypes.bin,
      iconLayout: 'icon-only',
      size: 'small',
      iconColor: 'red'
    }),
    content: "Remove"
  })), React.createElement(PStyledDigits, null, "\u2022\u2022\u2022\u2022 " + lastDigits), React.createElement(DivStyledFlex, null, React.createElement(DivStyledFlexText, null, React.createElement(PStyledText, null, name), React.createElement(PStyledText, null, expiresAt.month + " / " + expiresAt.year)), React.createElement(Logo, {
    size: "small",
    theme: brand
  })));
};

var ethereumLogo = function ethereumLogo(width, height) {
  if (width === void 0) {
    width = '120';
  }

  if (height === void 0) {
    height = '160';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M60.6279 63.8676C60.6279 47.3579 60.6279 30.8482 60.6279 14.3385C60.5142 14.3385 60.5142 14.3385 60.4005 14.2255C59.8319 15.1301 59.2634 16.0347 58.6949 16.9394C54.6017 23.7242 50.5085 30.6221 46.3015 37.4069C42.4357 43.7393 38.5699 50.0718 34.704 56.4043C31.293 61.9452 27.9957 67.4861 24.5847 73.1401C22.9929 75.854 21.2873 78.568 19.6955 81.2819C19.4681 81.6211 19.2407 81.9604 19.2407 82.2996C19.6955 82.6388 20.0366 82.4127 20.3777 82.1865C27.1998 79.1334 33.9081 76.0802 40.7302 72.914C46.9837 70.087 53.1236 67.26 59.3771 64.433C59.9456 64.433 60.4005 64.3199 60.6279 63.8676Z",
    fill: "url(#paint0_linear_30_8567)",
    fillOpacity: "0.6"
  }), React.createElement("path", {
    d: "M59.6272 145.783C59.6272 145.457 59.6272 145.021 59.6272 144.694C59.6272 134.783 59.6272 124.872 59.6272 114.961C59.6272 113.981 59.4152 113.327 58.4614 112.892C53.2682 109.842 48.1809 106.684 43.0937 103.525C38.6424 100.802 34.191 98.0796 29.7397 95.3568C26.9841 93.6142 24.1226 91.9805 21.367 90.2379C21.473 90.4557 21.367 90.2379 21.261 90.3468V90.4557C21.367 90.5646 21.367 90.7825 21.473 90.8914C34.0851 109.189 46.8031 127.486 59.4152 145.783C59.4152 145.783 59.5212 145.783 59.6272 145.783Z",
    fill: "url(#paint1_linear_30_8567)",
    fillOpacity: "0.6"
  }), React.createElement("path", {
    d: "M60.3696 64.317C60.3696 48.4158 60.3696 32.5145 60.3696 16.6132C60.4756 16.6132 60.4756 16.6132 60.5816 16.5043C61.1115 17.3756 61.6414 18.2469 62.1714 19.1182C65.9868 25.653 69.8022 32.2967 73.7236 38.8314C77.3271 44.9305 80.9305 51.0297 84.534 57.1288C87.7135 62.4655 90.787 67.8022 93.9666 73.2479C95.4503 75.8618 97.0401 78.4757 98.5239 81.0896C98.7359 81.4163 98.9478 81.7431 98.9478 82.0698C98.5239 82.3966 98.2059 82.1787 97.888 81.9609C91.5289 79.0203 85.2759 76.0796 78.9168 73.0301C73.0877 70.3072 67.3646 67.5844 61.5355 64.8616C61.1115 64.8616 60.5816 64.7527 60.3696 64.317Z",
    fill: "url(#paint2_linear_30_8567)"
  }), React.createElement("path", {
    d: "M60.3697 64.3176C61.1116 64.6443 61.7475 64.8621 62.4894 65.1889C66.8348 67.2582 71.2861 69.3276 75.6314 71.288C77.7511 72.2682 79.9768 73.3573 82.0965 74.3375C85.17 75.7534 88.2435 77.1693 91.3171 78.5851C93.4368 79.5654 95.6624 80.6545 97.7821 81.6347C98.206 81.8525 98.524 82.0703 98.9479 82.0703C99.1599 82.3971 98.8419 82.506 98.63 82.6149C96.6163 83.813 94.6026 85.1199 92.4829 86.3179C89.1974 88.2784 85.9119 90.2388 82.7324 92.1992C79.0229 94.4864 75.3135 96.6647 71.604 98.9518C68.0006 101.13 64.3971 103.308 60.7937 105.487C60.1578 105.704 60.1578 105.269 60.0518 104.833C59.9458 104.289 59.9458 103.744 59.9458 103.199C59.9458 90.8923 59.9458 78.4762 59.9458 66.1691C60.0518 65.7334 59.8398 64.971 60.3697 64.3176Z",
    fill: "url(#paint3_linear_30_8567)"
  }), React.createElement("path", {
    d: "M60.3687 64.3176C60.3687 77.6049 60.3687 91.0012 60.3687 104.289C60.3687 104.724 60.0508 105.378 60.7927 105.596C60.4747 105.922 60.2627 105.813 59.9448 105.596C57.8251 104.289 55.8114 103.091 53.6917 101.784C50.7242 100.041 47.8626 98.1894 44.895 96.4468C40.6557 93.8329 36.5223 91.3279 32.2829 88.714C29.1034 86.7536 25.8179 84.7932 22.5324 82.8327C22.2145 82.6149 22.0025 82.506 21.7905 82.1793C22.1085 81.8525 22.5324 81.7436 22.8504 81.5258C27.1957 79.4564 31.647 77.3871 35.9924 75.4267C39.3839 73.9019 42.6694 72.2682 46.0609 70.7434C50.6182 68.5652 55.2815 66.3869 59.8388 64.3176C60.1567 64.4265 60.2627 64.4265 60.3687 64.3176Z",
    fill: "url(#paint4_linear_30_8567)",
    fillOpacity: "0.6"
  }), React.createElement("path", {
    d: "M59.522 145.783C59.522 145.457 59.522 145.021 59.522 144.694C59.522 134.783 59.522 124.872 59.522 114.961C59.522 113.981 59.7339 113.327 60.6878 112.892C65.881 109.842 70.9683 106.684 76.0555 103.525C80.5068 100.802 84.9581 98.0796 89.4095 95.3568C92.1651 93.6142 95.0266 91.9805 97.7822 90.2379C97.6762 90.4557 97.7822 90.2379 97.8882 90.3468V90.4557C97.7822 90.5646 97.7822 90.7825 97.6762 90.8914C85.0641 109.189 72.346 127.486 59.7339 145.783C59.628 145.783 59.628 145.783 59.522 145.783Z",
    fill: "url(#paint5_linear_30_8567)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4815 12.1895C60.9346 12.3668 61.2565 12.8174 61.2565 13.3453V62.5739C61.2565 62.7312 61.2273 62.887 61.1704 63.033C60.9591 63.5759 60.5939 63.9876 60.0985 64.2252C59.7771 64.3793 59.4496 64.4355 59.172 64.4546C56.2715 65.8366 53.3475 67.1928 50.43 68.5459L50.4268 68.5474C47.4318 69.9365 44.4436 71.3224 41.4829 72.735L41.4714 72.7405C38.1885 74.2641 34.9317 75.7877 31.673 77.3124L31.6712 77.3132L31.6697 77.3139C28.4198 78.8344 25.168 80.3559 21.8896 81.8774C21.8793 81.8829 21.8674 81.8892 21.8542 81.8964C21.7043 81.977 21.3699 82.1569 21.0384 82.2299C20.5052 82.3473 19.9658 82.2336 19.4815 81.8603C19.1785 81.6268 19.0002 81.2604 19.0002 80.8712C19.0002 80.4376 19.1392 80.0759 19.2597 79.8282C19.3726 79.5962 19.5137 79.3786 19.6105 79.2295C20.403 77.8724 21.1951 76.543 21.984 75.2188L21.9859 75.2157C22.7812 73.8807 23.5733 72.5512 24.3649 71.1954L24.374 71.18C26.393 67.8336 28.3654 64.4571 30.3521 61.0561C31.5968 58.9253 32.8471 56.785 34.118 54.6363C34.1183 54.6357 34.1187 54.6351 34.119 54.6345L45.2423 35.6923C45.2428 35.6914 45.2433 35.6905 45.2438 35.6897C47.2049 32.3128 49.1922 28.909 51.1788 25.5066C53.1661 22.1029 55.1527 18.7004 57.1125 15.3256C57.1342 15.2883 57.1578 15.2521 57.1832 15.2174C57.6066 14.6372 57.9652 14.0273 58.3441 13.3831C58.4979 13.1215 58.655 12.8543 58.8211 12.5811C59.0155 12.2616 59.341 12.0506 59.7052 12.0079C59.9791 11.9759 60.2525 12.0416 60.4815 12.1895ZM22.6759 78.7981C23.1293 78.0321 23.5831 77.2704 24.038 76.5068L24.0396 76.5042C24.832 75.1741 25.6277 73.8386 26.4238 72.4752C28.4472 69.1213 30.4371 65.7149 32.4311 62.3016C33.6745 60.1731 34.9195 58.0419 36.1752 55.9189L36.1772 55.9155L47.3055 36.9647L47.3086 36.9595C49.2682 33.585 51.2545 30.1831 53.2416 26.7797L53.2422 26.7786C55.1184 23.5652 56.9954 20.3504 58.8502 17.1583V61.9916C58.688 61.9967 58.5283 62.0356 58.3809 62.106C55.4202 63.5186 52.432 64.9045 49.437 66.2936L49.4331 66.2953C46.4432 67.6821 43.4465 69.072 40.4752 70.4895C37.1905 72.014 33.9325 73.5383 30.6764 75.0617L30.6742 75.0627C28.0119 76.3083 25.351 77.5533 22.6759 78.7981ZM60.0389 12.1089C60.035 12.1088 60.0333 12.1088 60.0334 12.1088L60.0389 12.1089Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6935 88.5773C20.0786 88.2029 20.6569 88.1317 21.1172 88.402C24.0928 90.1493 26.961 91.8959 29.8199 93.6369C34.3802 96.3615 39.0474 99.1957 43.6097 102.03C48.9066 105.296 54.1946 108.557 59.4812 111.708C60.1057 112.066 60.5974 112.527 60.9032 113.156C61.1983 113.762 61.2554 114.396 61.2554 114.961V146.655C61.2554 146.983 61.1287 147.297 60.9031 147.529C60.8857 147.547 60.8398 147.594 60.7942 147.637C60.7461 147.681 60.6393 147.776 60.4844 147.856C60.3089 147.946 60.1457 147.979 60.023 147.992C59.9384 148.001 59.8548 148 59.8419 148L59.8404 148C59.4525 148 59.0884 147.808 58.8625 147.484C49.574 134.167 40.3375 120.794 31.1185 107.446C27.3032 101.923 23.4909 96.4031 19.6791 90.8936C19.5723 90.7594 19.5071 90.63 19.4681 90.5418C19.4355 90.4682 19.4099 90.3958 19.3941 90.3486C19.2755 90.1536 19.2112 89.9269 19.2112 89.6932V89.5843C19.2112 89.2564 19.3379 88.942 19.5636 88.7101C19.5814 88.6917 19.6 88.6737 19.6194 88.6559C19.6428 88.6288 19.6675 88.6025 19.6935 88.5773ZM24.1235 93.0514C27.11 97.3707 30.0965 101.695 33.0844 106.021C41.6502 118.422 50.2277 130.841 58.8492 143.218V114.961C58.8492 114.545 58.8004 114.363 58.751 114.261C58.7141 114.186 58.6266 114.049 58.3022 113.864L58.2829 113.852C52.976 110.689 47.6704 107.418 42.3739 104.152L42.3699 104.15L42.3664 104.148C37.816 101.32 33.1587 98.492 28.6063 95.7721L28.5976 95.7669C27.1091 94.8604 25.6231 93.9555 24.1235 93.0514Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.295 12.0079C60.6593 12.0506 60.9848 12.2616 61.1791 12.5811C61.3452 12.8543 61.5024 13.1215 61.6562 13.3831C62.035 14.0273 62.3937 14.6372 62.8171 15.2174C62.8425 15.2521 62.8661 15.2883 62.8877 15.3256C64.8476 18.7004 66.834 22.1027 68.8214 25.5064L68.822 25.5075C70.8083 28.9095 72.7955 32.313 74.7563 35.6895C74.7569 35.6905 74.7574 35.6914 74.7579 35.6923L85.8812 54.6345C85.8815 54.635 85.8818 54.6356 85.8821 54.6361C87.1531 56.7848 88.4035 58.9253 89.6482 61.0561C91.6349 64.4571 93.6072 67.8336 95.6262 71.18L95.6353 71.1954C96.427 72.5512 97.2191 73.8807 98.0144 75.2157L98.0155 75.2175C98.8046 76.5421 99.597 77.872 100.39 79.2295C100.487 79.3785 100.628 79.5962 100.74 79.8282C100.861 80.0759 101 80.4376 101 80.8712C101 81.2604 100.822 81.6268 100.519 81.8603C100.034 82.2336 99.495 82.3473 98.9619 82.2299C98.6304 82.1569 98.296 81.977 98.1461 81.8964C98.1328 81.8892 98.1209 81.8828 98.1107 81.8774C94.8323 80.3559 91.5805 78.8344 88.3306 77.3139L88.329 77.3132L88.3276 77.3125C85.0688 75.7878 81.8119 74.2641 78.5288 72.7404L78.5173 72.7351C75.5566 71.3225 72.5685 69.9365 69.5734 68.5474L69.5704 68.546C66.6502 67.1916 63.7234 65.8341 60.8202 64.4508C60.5676 64.4276 60.2773 64.3672 59.9813 64.2252C59.5441 64.0155 59.1851 63.6722 58.9152 63.21C58.803 63.0178 58.7438 62.798 58.7438 62.5739V13.3453C58.7438 12.8174 59.0657 12.3668 59.5188 12.1895C59.7478 12.0416 60.0211 11.9759 60.295 12.0079ZM59.9669 12.1088C59.967 12.1088 59.9653 12.1088 59.9613 12.1089L59.9669 12.1088ZM97.3243 78.7981C96.871 78.0321 96.4171 77.2704 95.9622 76.5068L95.9615 76.5055C95.1687 75.1749 94.3728 73.8389 93.5764 72.4751C91.553 69.1211 89.5631 65.7148 87.5691 62.3015C86.3257 60.173 85.0808 58.0418 83.8251 55.9189L83.823 55.9155L72.6917 36.9595C70.7318 33.5847 68.7454 30.1824 66.758 26.7786L66.7574 26.7775C64.8814 23.5645 63.0046 20.3501 61.15 17.1583V61.9916C61.3122 61.9967 61.4719 62.0356 61.6194 62.106C64.5801 63.5186 67.5682 64.9045 70.5633 66.2936L70.5673 66.2954C73.5571 67.6821 76.5538 69.072 79.525 70.4895C82.8097 72.014 86.0678 73.5383 89.3238 75.0617L89.3261 75.0627C91.9883 76.3083 94.6493 77.5533 97.3243 78.7981Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0209 61.7827C59.3615 61.3627 59.9301 61.2224 60.4191 61.4378C60.7011 61.562 60.981 61.668 61.2864 61.7836C61.3442 61.8055 61.4028 61.8277 61.4626 61.8505C61.8131 61.9838 62.2019 62.1359 62.576 62.3259C64.8539 63.3605 67.1043 64.4216 69.3458 65.4785L69.3496 65.4802C71.603 66.5427 73.8475 67.601 76.1171 68.6316C76.1275 68.6363 76.1378 68.6412 76.1481 68.6462C77.2485 69.1847 78.3506 69.6971 79.4652 70.2152L79.4704 70.2177C80.5784 70.7328 81.6988 71.2536 82.8208 71.8026C85.0112 72.8529 87.1948 73.8483 89.3556 74.8332C90.3195 75.2726 91.279 75.71 92.2325 76.1492C92.2409 76.1531 92.2493 76.1571 92.2576 76.1612C93.3581 76.6997 94.4602 77.2121 95.5748 77.7302L95.5804 77.7328C96.6897 78.2485 97.8113 78.7699 98.9346 79.3196L98.9554 79.3301C99.1111 79.41 99.2484 79.4956 99.3471 79.5575L99.373 79.5737C99.4679 79.6333 99.5235 79.6682 99.5797 79.699C99.6334 79.7284 99.6597 79.7379 99.6707 79.7413C99.6779 79.7435 99.6813 79.7441 99.6892 79.7441C100.091 79.7441 100.467 79.9507 100.69 80.2947C100.83 80.5104 100.984 80.8438 100.96 81.2607C100.935 81.7008 100.725 82.0181 100.54 82.2087C100.372 82.3812 100.192 82.484 100.103 82.5326C100.052 82.5604 100.005 82.5839 99.9735 82.5991C99.9624 82.6046 99.9535 82.609 99.9461 82.6126C99.9456 82.6128 99.9451 82.6131 99.9447 82.6133C97.8438 83.9086 95.7339 85.2093 93.7268 86.4035C92.3939 87.2167 91.0745 88.0053 89.7667 88.7869C87.7107 90.0157 85.6836 91.2272 83.6784 92.4902L83.6559 92.504C81.7545 93.6439 79.8521 94.8114 77.9434 95.9828L77.9406 95.9845C76.0369 97.1529 74.1269 98.3251 72.216 99.4706C70.3582 100.616 68.5012 101.734 66.6506 102.848L66.6473 102.85C64.7917 103.967 62.9425 105.08 61.0941 106.219C61.0188 106.266 60.9388 106.303 60.8556 106.332C60.5842 106.425 60.2518 106.49 59.8946 106.43C59.5057 106.365 59.1882 106.167 58.9582 105.905C58.7511 105.668 58.6432 105.412 58.5837 105.243C58.5274 105.083 58.4878 104.92 58.464 104.822L58.46 104.805C58.4554 104.786 58.4512 104.767 58.4475 104.748C58.3179 104.082 58.318 103.433 58.3181 102.914L58.3181 64.6435C58.3181 64.5621 58.326 64.4809 58.3415 64.4011C58.3415 64.4011 58.3424 64.3963 58.3437 64.3856C58.345 64.3743 58.3466 64.3584 58.3481 64.3368C58.3513 64.2915 58.3533 64.2353 58.3548 64.1574C58.3553 64.1324 58.3557 64.1039 58.3562 64.0728C58.3582 63.935 58.361 63.744 58.3744 63.5584C58.4088 63.0816 58.5226 62.3973 59.0209 61.7827ZM98.9772 80.3473C98.9765 80.3477 98.9756 80.3481 98.9746 80.3486C98.9825 80.3439 98.9841 80.3435 98.9772 80.3473ZM97.39 81.3044C96.4589 80.8552 95.5254 80.4212 94.583 79.9831L94.578 79.9808C93.4727 79.4669 92.355 78.9474 91.2357 78.3998C90.3044 77.9709 89.3592 77.54 88.4048 77.105C86.2325 76.1147 84.0123 75.1027 81.799 74.0413L81.7905 74.0372C80.6901 73.4987 79.588 72.9863 78.4734 72.4681L78.4682 72.4657C77.3639 71.9523 76.2473 71.4332 75.129 70.8862C72.8479 69.8503 70.5945 68.7878 68.35 67.7295L68.3461 67.7277C66.0927 66.6652 63.8482 65.6069 61.5786 64.5764C61.5611 64.5685 61.5439 64.5601 61.5268 64.5513C61.3056 64.4377 61.0568 64.3348 60.7603 64.2203C60.7575 64.3557 60.7521 64.5454 60.7244 64.7451V102.872C60.7244 103.126 60.7251 103.352 60.7332 103.56C62.3007 102.6 63.867 101.657 65.4288 100.717L65.4312 100.716C67.2868 99.5991 69.1361 98.486 70.9844 97.3463L70.9972 97.3386C72.8987 96.1987 74.8011 95.0312 76.7097 93.8598L76.7118 93.8585C78.6142 92.691 80.5227 91.5197 82.4322 90.3749C84.4492 89.1048 86.5239 87.8646 88.6001 86.6235C89.9054 85.8432 91.2113 85.0626 92.5039 84.2739L92.5153 84.2669C94.0897 83.3303 95.7304 82.3261 97.39 81.3044Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4076 61.432C60.8571 61.6234 61.1503 62.0742 61.1503 62.5743V103.852C61.1503 103.978 61.1392 104.092 61.1297 104.175C61.1288 104.182 61.1279 104.19 61.127 104.197C61.3027 104.343 61.4383 104.54 61.5125 104.768C61.6566 105.213 61.5441 105.702 61.2218 106.033C60.9194 106.344 60.4511 106.658 59.8274 106.594C59.3764 106.547 59.0167 106.299 58.8781 106.203C56.7657 104.901 54.665 103.606 52.4613 102.312C52.4521 102.306 52.4429 102.301 52.4338 102.295C50.9547 101.372 49.4485 100.449 47.9375 99.5229L47.9355 99.5216C46.4294 98.5984 44.9186 97.6723 43.4335 96.7458C41.2586 95.4374 39.0845 94.1024 36.9159 92.7707L36.9144 92.7698C34.7409 91.4351 32.5729 90.1038 30.4057 88.8001L30.3848 88.7873C27.1218 86.7321 23.7501 84.7829 20.3552 82.8205C20.3288 82.8053 20.3029 82.7889 20.2777 82.7717C20.2321 82.7405 20.1837 82.7111 20.1009 82.6611L20.0944 82.6573C20.0236 82.6146 19.9132 82.548 19.8047 82.4699C19.5639 82.2967 19.2289 81.9955 19.0618 81.4804C18.9177 81.0362 19.0302 80.5464 19.3524 80.2152C19.651 79.9084 19.9767 79.7282 20.195 79.6161C20.3003 79.5619 20.3726 79.5263 20.426 79.5C20.5119 79.4576 20.5488 79.4393 20.5956 79.4073C20.6466 79.3724 20.7001 79.3415 20.7556 79.315C25.3186 77.134 29.7752 75.0622 34.3369 72.9908C36.0875 72.1731 37.811 71.3829 39.5301 70.5947L39.532 70.5939C41.2548 69.804 42.9732 69.0161 44.7175 68.2013L44.7267 68.197C47.8156 66.7863 50.8977 65.333 53.9585 63.8896C55.6192 63.1066 57.2735 62.3264 58.9194 61.5577C59.0757 61.4846 59.2455 61.4468 59.4172 61.4468C59.4301 61.4468 59.4421 61.4468 59.4533 61.4468C59.7503 61.3096 60.0953 61.2991 60.4076 61.432ZM58.744 103.238V64.3569C57.4983 64.9411 56.2434 65.5329 54.9822 66.1276C51.9133 67.5747 48.8076 69.0392 45.7086 70.4546C43.9576 71.2725 42.2336 72.0629 40.5139 72.8513L40.5124 72.852C38.7895 73.6419 37.0711 74.4298 35.3268 75.2446L35.3152 75.25C31.0033 77.2079 26.7871 79.1655 22.4862 81.2154C25.5567 82.9916 28.6365 84.7863 31.6318 86.6724C33.8056 87.9802 35.9787 89.3146 38.1463 90.6457L38.1487 90.6472C40.3221 91.9818 42.4901 93.3131 44.6573 94.6168L44.6739 94.627C46.153 95.5498 47.6592 96.4731 49.1702 97.3993L49.1725 97.4007C50.6767 98.3227 52.1856 99.2476 53.669 100.173C55.411 101.196 57.0876 102.219 58.744 103.238ZM21.1797 80.4406C21.1797 80.4406 21.1801 80.4409 21.1809 80.4415L21.1797 80.4406Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.08 88.4044L99.4788 89.4754L98.8738 88.4068C99.2464 88.184 99.7065 88.1831 100.08 88.4044ZM99.6063 89.7006L100.726 90.0842C100.742 90.0341 100.756 89.983 100.765 89.9312L99.6043 89.6972C100.765 89.9312 100.765 89.9314 100.765 89.9312L100.766 89.9298L100.767 89.9252L100.768 89.9185L100.77 89.9031C100.772 89.892 100.774 89.8788 100.777 89.8639C100.781 89.8352 100.786 89.795 100.789 89.7473L100.79 89.7435C100.794 89.6892 100.811 89.4558 100.726 89.1933C100.602 88.8121 100.339 88.5949 100.286 88.5506L100.281 88.5471C100.231 88.5056 100.187 88.4737 100.155 88.4522C100.139 88.441 100.124 88.4314 100.111 88.4236L100.094 88.4129L100.087 88.4084L100.083 88.4064L100.082 88.4054L100.08 88.4044C100.08 88.4043 100.08 88.4044 99.4788 89.4754L98.8738 88.4068L97.9176 88.9789C97.3262 89.333 96.5078 89.8234 95.5999 90.3682C93.7868 91.4561 91.6136 92.7634 90.1791 93.637C85.6188 96.3616 80.9516 99.1957 76.3894 102.03C71.0925 105.296 65.8045 108.557 60.5179 111.708C59.8934 112.066 59.4017 112.527 59.0959 113.156C58.8008 113.762 58.7437 114.396 58.7437 114.961V146.655C58.7437 146.983 58.8704 147.297 59.096 147.529C59.296 147.734 59.5163 147.856 59.7121 147.923C59.8079 147.956 59.8956 147.975 59.9704 147.986C60.0079 147.991 60.0426 147.995 60.074 147.997C60.0897 147.998 60.1046 147.999 60.1188 147.999L60.1394 148L60.1492 148L60.154 148L60.1564 148L60.1576 148C60.1582 148 60.1588 148 60.1587 146.764L60.1588 148C60.5466 148 60.9107 147.808 61.1366 147.484C70.4248 134.167 79.661 120.795 88.8797 107.448C92.6951 101.924 96.5075 96.404 100.319 90.8944C100.41 90.7813 100.47 90.6749 100.502 90.6153C100.554 90.5196 100.595 90.4272 100.624 90.3572C100.655 90.2848 100.679 90.2197 100.695 90.1734C100.704 90.1498 100.711 90.1298 100.716 90.1147L100.722 90.0956L100.725 90.0889L100.725 90.0863L100.726 90.0852L100.726 90.0842C100.726 90.0841 100.726 90.0842 99.6063 89.7006ZM95.8576 93.0773C92.8771 97.388 89.8966 101.703 86.9146 106.021C78.3489 118.422 69.7714 130.841 61.1499 143.218V114.961C61.1499 114.545 61.1987 114.363 61.2481 114.261C61.285 114.186 61.3725 114.049 61.6969 113.864L61.7162 113.852C67.0231 110.689 72.3287 107.418 77.6252 104.152L77.6292 104.15L77.6327 104.148C82.1831 101.32 86.8404 98.492 91.3928 95.7721L91.4015 95.7669C92.5848 95.0463 94.2787 94.0258 95.8576 93.0773Z",
    fill: "white"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_30_8567",
    x1: "39.9343",
    y1: "14.2255",
    x2: "39.9343",
    y2: "82.4726",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F2F6FF"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F2F6FF",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_30_8567",
    x1: "40.4441",
    y1: "90.2379",
    x2: "40.4441",
    y2: "145.783",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F2F6FF"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F2F6FF",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_30_8567",
    x1: "79.6587",
    y1: "16.5043",
    x2: "79.6587",
    y2: "82.2364",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_30_8567",
    x1: "79.4818",
    y1: "64.3176",
    x2: "79.4818",
    y2: "105.545",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_30_8567",
    x1: "41.2916",
    y1: "64.3176",
    x2: "41.2916",
    y2: "105.802",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F2F6FF"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F2F6FF",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_30_8567",
    x1: "78.7051",
    y1: "90.2379",
    x2: "78.7051",
    y2: "145.783",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  }))));
};

var binanceLogo = function binanceLogo(width, height) {
  if (width === void 0) {
    width = '120';
  }

  if (height === void 0) {
    height = '160';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M29.168 99.3139C32.9018 95.5571 36.6357 91.7039 40.3695 87.9471C40.4652 88.0434 40.561 88.1397 40.6567 88.2361C46.9755 94.5938 53.1986 100.855 59.5174 107.213C59.8046 107.502 59.7089 107.502 60.0919 107.213C66.4107 100.855 72.6337 94.5938 78.9526 88.2361C79.0483 88.1397 79.0483 88.0434 79.144 87.9471C82.9736 91.8002 86.7075 95.5571 90.4413 99.3139C90.4413 99.3139 90.3456 99.4102 90.2498 99.5066C80.1972 109.621 70.1445 119.736 60.0919 129.85C59.9004 130.043 59.9004 130.043 59.6132 129.85C49.5605 119.736 39.5078 109.621 29.4552 99.5066C29.2637 99.4102 29.168 99.4102 29.168 99.3139Z",
    fill: "url(#paint0_linear_30_8698)",
    fillOpacity: "0.7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3693 86.5276L59.8045 106.082L78.183 87.5907C78.2238 87.5122 78.3053 87.3714 78.4408 87.2351L79.1439 86.5276L91.8518 99.3138L91.1443 100.026L91.0779 99.9587C91.1443 100.026 91.1443 100.026 91.1443 100.026L60.7948 130.562C60.7924 130.565 60.7895 130.568 60.7861 130.571C60.751 130.607 60.6678 130.691 60.5789 130.759C60.4576 130.852 60.2213 131 59.8883 131C59.599 131 59.3831 130.884 59.3021 130.839C59.2204 130.794 59.1335 130.736 59.0759 130.697L58.9797 130.632L28.8833 100.351C28.8562 100.339 28.8243 100.325 28.7953 100.31C28.7311 100.278 28.5574 100.187 28.409 100C28.2319 99.7775 28.1719 99.5261 28.1719 99.3139V98.8965L28.4647 98.6019C30.329 96.7261 32.1937 94.8259 34.061 92.923L34.0621 92.9219C35.9282 91.0202 37.797 89.1158 39.6662 87.2351L40.3693 86.5276ZM30.6258 99.2651L59.8523 128.672L89.0304 99.3139L79.1917 89.4146L60.7447 107.975L60.688 108.018C60.678 108.026 60.6488 108.048 60.6145 108.075C60.5576 108.119 60.4864 108.174 60.4653 108.189C60.4644 108.19 60.4628 108.191 60.4607 108.193C60.4184 108.225 60.146 108.435 59.7686 108.435C59.3241 108.435 59.0441 108.159 58.991 108.107C58.9889 108.105 58.9871 108.103 58.9858 108.102C58.9502 108.067 58.9143 108.029 58.8934 108.007L58.8882 108.002C58.8629 107.975 58.8405 107.951 58.8142 107.925L40.3699 89.367C38.7396 91.0122 37.1089 92.674 35.4762 94.3379L35.4749 94.3392C33.86 95.9849 32.2431 97.6325 30.6258 99.2651ZM59.2962 106.562C59.2927 106.564 59.2933 106.564 59.2975 106.561C59.2971 106.561 59.2966 106.561 59.2962 106.562Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M40.3695 71.9566C36.6357 68.1997 32.9018 64.4429 29.168 60.6861C29.168 60.5898 29.2637 60.5898 29.3594 60.4934C39.4121 50.3789 49.4648 40.2643 59.5174 30.1498C59.7089 29.9571 59.8046 29.9571 59.9961 30.1498C70.0488 40.2643 80.1014 50.3789 90.1541 60.4934C90.2498 60.5898 90.2498 60.5898 90.3456 60.6861C86.6117 64.4429 82.8779 68.1997 79.144 71.9566C79.144 71.9566 79.0483 71.8603 78.9526 71.7639C72.6337 65.4062 66.4107 59.1448 60.0919 52.7871C59.8046 52.4981 59.9004 52.4981 59.5174 52.7871C53.1986 59.0485 46.8798 65.4062 40.6567 71.6676C40.561 71.7639 40.4652 71.8603 40.3695 71.9566Z",
    fill: "url(#paint1_linear_30_8698)",
    fillOpacity: "0.7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7567 31.3283L88.9348 60.6861L79.144 70.5372L60.7949 52.0751C60.7686 52.0487 60.7462 52.025 60.7208 51.9982C60.7011 51.9773 60.662 51.9356 60.6233 51.8982C60.6219 51.8969 60.6202 51.8952 60.6181 51.8931C60.5649 51.8408 60.285 51.5651 59.8405 51.5651C59.4631 51.5651 59.1906 51.7746 59.1483 51.8072C59.1462 51.8088 59.1447 51.8099 59.1438 51.8106C59.1227 51.8261 59.0515 51.8812 58.9945 51.9253C58.9602 51.9518 58.9311 51.9744 58.921 51.982L58.8674 52.0224L58.8197 52.0697C52.6385 58.1947 46.4578 64.4114 40.3695 70.5372L30.5786 60.6861L59.7567 31.3283ZM78.4409 72.6686L79.144 73.376L91.7562 60.6861L91.0021 59.9273L91.0013 59.9265L90.9998 59.925L90.9975 59.9227L90.9925 59.9176C90.9957 59.9209 90.9892 59.9143 90.9925 59.9176L90.9461 59.871L90.9439 59.8687L90.9334 59.8581L90.931 59.8557L90.9297 59.8545L90.8915 59.816L60.6936 29.4321C60.5949 29.3327 60.265 29 59.7567 29C59.2484 29 58.9185 29.3327 58.8199 29.4321L28.7022 59.7353C28.6947 59.7403 28.6862 59.746 28.6766 59.7525C28.6294 59.7841 28.4886 59.8797 28.3693 60.0512C28.2304 60.2509 28.172 60.475 28.172 60.6861V61.1034L40.3695 73.376L41.3598 72.3796C47.4475 66.2544 53.6237 60.0401 59.8015 53.9144L78.4409 72.6686ZM60.3129 53.4384C60.3164 53.4358 60.3158 53.4364 60.3116 53.4394C60.312 53.4391 60.3124 53.4387 60.3129 53.4384Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M59.7084 91.4151C55.9746 87.6582 52.145 83.8051 48.4111 80.0482C52.145 76.2914 55.9746 72.4382 59.8041 68.5851C63.538 72.3419 67.3676 76.1951 71.1014 79.9519C67.3676 83.8051 63.538 87.5619 59.7084 91.4151Z",
    fill: "url(#paint2_linear_30_8698)",
    fillOpacity: "0.7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.804 67.1656L72.5031 79.9429L71.8132 80.6548C69.3218 83.2258 66.783 85.7589 64.2369 88.2994C62.9618 89.5715 61.685 90.8455 60.4113 92.127L59.7082 92.8344L47.0002 80.0482L59.804 67.1656ZM49.8217 80.0482L59.7087 89.9961C60.7596 88.9417 61.8081 87.8956 62.853 86.8531C65.1562 84.5551 67.442 82.2744 69.6984 79.9598L59.804 70.0045L49.8217 80.0482Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M32.4228 79.952C32.4228 80.0483 32.3271 80.0483 32.3271 80.0483C32.3271 80.1446 32.2314 80.1446 32.2314 80.1446C28.689 83.7088 25.0509 87.3693 21.5085 90.9335C21.2213 91.2225 21.2213 91.2225 20.9341 90.9335C17.3917 87.3693 13.7536 83.7088 10.2113 80.1446C9.92404 79.8556 9.92404 79.8556 10.2113 79.663C13.7536 76.0988 17.3917 72.4383 20.9341 68.8741C21.1256 68.6815 21.1256 68.6815 21.4128 68.8741C24.9552 72.4383 28.5933 76.0988 32.1356 79.663C32.2314 79.7593 32.3271 79.8556 32.4228 79.952Z",
    fill: "url(#paint3_linear_30_8698)",
    fillOpacity: "0.7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1735 70.0527L31.0122 79.952L21.2214 89.803L11.3827 79.9038L21.1735 70.0527ZM32.8053 80.9867L22.2117 91.6454C22.2072 91.65 22.2024 91.6548 22.1973 91.6599C22.1407 91.7171 22.0493 91.8093 21.959 91.882C21.8661 91.9568 21.6053 92.1555 21.2214 92.1555C20.8375 92.1555 20.5767 91.9568 20.4838 91.882C20.3934 91.8093 20.3021 91.7171 20.2455 91.6599C20.2404 91.6548 20.2356 91.65 20.2311 91.6454L9.50824 80.8566C9.50371 80.852 9.49893 80.8472 9.49394 80.8422C9.4365 80.7845 9.35088 80.6986 9.28352 80.6167C9.28234 80.6152 9.28103 80.6137 9.27959 80.6119C9.22635 80.5476 9 80.2739 9 79.8677C9 79.3814 9.30825 79.0978 9.39515 79.0213C9.4543 78.9692 9.52226 78.9197 9.57697 78.8819L20.2311 68.1622C20.2335 68.1597 20.2364 68.1567 20.2398 68.1533C20.2749 68.1177 20.3581 68.0333 20.447 67.9652C20.5682 67.8723 20.8046 67.7244 21.1376 67.7244C21.4269 67.7244 21.6428 67.8399 21.7238 67.8849C21.8055 67.9303 21.8923 67.9887 21.95 68.0274C21.9549 68.0307 21.9596 68.0339 21.9641 68.0369L22.0462 68.0919L33.4189 79.5346V79.952C33.4189 80.1526 33.3661 80.3699 33.2358 80.5665C33.1795 80.6515 33.1163 80.7212 33.052 80.7782C32.9723 80.8693 32.8859 80.937 32.8053 80.9867Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M109.589 79.952C109.589 80.0483 109.494 80.0483 109.494 80.0483C109.494 80.1446 109.398 80.1446 109.398 80.1446C105.855 83.7088 102.217 87.3693 98.675 90.9335C98.3878 91.2225 98.3878 91.2225 98.1963 90.9335C94.6539 87.3693 91.0158 83.7088 87.4734 80.1446C87.282 79.952 87.282 79.952 87.4734 79.663C91.1115 76.0025 94.6539 72.4383 98.292 68.7778C98.4835 68.5851 98.5792 68.5851 98.7707 68.7778C102.409 72.4383 105.951 76.0025 109.589 79.663C109.398 79.8556 109.494 79.8556 109.589 79.952Z",
    fill: "url(#paint4_linear_30_8698)",
    fillOpacity: "0.7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5312 69.9564L108.322 79.8075L98.4355 89.7549L88.6446 79.9038L98.5312 69.9564ZM109.971 80.9867L99.3779 91.6455C99.3734 91.65 99.3686 91.6548 99.3637 91.6598C99.3063 91.7176 99.2209 91.8038 99.1395 91.8715C99.1381 91.8727 99.1366 91.874 99.1349 91.8754C99.0707 91.9291 98.8002 92.1555 98.3996 92.1555C97.9204 92.1555 97.6398 91.8477 97.5628 91.7592C97.5111 91.6997 97.4619 91.6313 97.4242 91.5762L86.7702 80.8566C86.7677 80.8542 86.7648 80.8512 86.7614 80.8478C86.7261 80.8126 86.6421 80.7288 86.5743 80.6392C86.482 80.5173 86.3337 80.278 86.3337 79.9399C86.3337 79.6464 86.4495 79.4277 86.4942 79.3463C86.5394 79.2639 86.5975 79.1763 86.636 79.1184C86.6393 79.1134 86.6424 79.1087 86.6454 79.1041L86.7003 79.0213L97.5887 68.0658C97.5905 68.0641 97.5924 68.0622 97.5944 68.0602C97.693 67.9607 98.0229 67.6281 98.5312 67.6281C99.0395 67.6281 99.3694 67.9607 99.468 68.0602C99.47 68.0622 99.4719 68.0641 99.4737 68.0658L111 79.663L110.577 80.0886C110.558 80.2487 110.503 80.4138 110.402 80.5665C110.346 80.6515 110.283 80.7213 110.218 80.7783C110.138 80.8693 110.052 80.937 109.971 80.9867Z",
    fill: "white"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_30_8698",
    x1: "59.8046",
    y1: "87.9471",
    x2: "59.8046",
    y2: "129.995",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_30_8698",
    x1: "59.7568",
    y1: "30.0053",
    x2: "59.7568",
    y2: "71.9566",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_30_8698",
    x1: "59.7563",
    y1: "68.5851",
    x2: "59.7563",
    y2: "91.4151",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_30_8698",
    x1: "21.2093",
    y1: "68.7296",
    x2: "21.2093",
    y2: "91.1502",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_30_8698",
    x1: "98.4596",
    y1: "68.6333",
    x2: "98.4596",
    y2: "91.1502",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  }))));
};

var polygonLogo = function polygonLogo(width, height) {
  if (width === void 0) {
    width = '120';
  }

  if (height === void 0) {
    height = '160';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M87.3956 62.2618C86.3447 61.7043 85.1717 61.4126 83.9803 61.4126C82.7889 61.4126 81.6158 61.7043 80.565 62.2618L65.1693 71.3015L54.4126 77.2366L39.0169 86.2829C37.9661 86.8405 36.793 87.1321 35.6016 87.1321C34.4102 87.1321 33.2372 86.8405 32.1863 86.2829L19.9505 79.2128C18.9439 78.6365 18.102 77.8148 17.5043 76.8253C16.9067 75.8358 16.5732 74.7113 16.5352 73.5581V59.4378C16.5131 58.272 16.8216 57.1236 17.4255 56.1236C18.0294 55.1237 18.9044 54.3126 19.9505 53.7831L32.1863 47C33.2372 46.4425 34.4102 46.1508 35.6016 46.1508C36.793 46.1508 37.9661 46.4425 39.0169 47L51.2527 53.7831C52.2593 54.3593 53.1012 55.1811 53.6989 56.1706C54.2965 57.1601 54.6301 58.2846 54.668 59.4378V68.4775L65.1693 62.2619V53.5026C65.1965 52.3424 64.896 51.1978 64.3019 50.1985C63.7078 49.1991 62.8439 48.3848 61.8078 47.8479L39.2993 34.8492C38.2484 34.2917 37.0754 34 35.884 34C34.6926 34 33.5195 34.2917 32.4687 34.8492L9.70463 47.8479C8.56833 48.2854 7.59961 49.0671 6.9359 50.0821C6.27218 51.0971 5.94718 52.2939 6.007 53.5027V79.7803C5.98992 80.9416 6.30083 82.0844 6.90447 83.0792C7.50812 84.0739 8.38035 84.8808 9.42227 85.4084L32.1863 98.4337C33.2372 98.9913 34.4102 99.283 35.6016 99.283C36.793 99.283 37.9661 98.9913 39.0169 98.4337L54.4126 89.6745L64.9408 83.4589L80.2826 74.7264C81.3335 74.1689 82.5065 73.8772 83.6979 73.8772C84.8893 73.8772 86.0623 74.1689 87.1132 74.7264L99.349 81.5095C100.356 82.0858 101.198 82.9075 101.795 83.897C102.393 84.8865 102.726 86.011 102.764 87.1642V101.011C102.786 102.177 102.478 103.325 101.874 104.325C101.27 105.325 100.395 106.136 99.349 106.666L87.1132 113.729C86.0624 114.287 84.8893 114.578 83.6979 114.578C82.5065 114.578 81.3335 114.287 80.2826 113.729L68.0468 106.946C67.0402 106.37 66.1983 105.548 65.6007 104.558C65.003 103.569 64.6695 102.444 64.6315 101.291V92.2181L54.4126 98.1466V107.186C54.3904 108.352 54.6989 109.5 55.3028 110.5C55.9068 111.5 56.7817 112.311 57.8278 112.841L80.5919 125.84C81.6427 126.397 82.8158 126.689 84.0072 126.689C85.1986 126.689 86.3716 126.397 87.4224 125.84L110.186 112.841C111.187 112.262 112.023 111.44 112.616 110.452C113.209 109.464 113.539 108.342 113.575 107.193V80.9086C113.597 79.7428 113.289 78.5943 112.685 77.5944C112.081 76.5944 111.206 75.7834 110.16 75.2538L87.3956 62.2618Z",
    fill: "url(#paint0_linear_30_8716)",
    fillOpacity: "0.7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8828 33.745C33.1144 33.0916 34.4886 32.75 35.884 32.75C37.2793 32.75 38.6535 33.0916 39.8851 33.745L39.9049 33.7555L62.4094 46.7518C63.6401 47.3958 64.6677 48.3675 65.3764 49.5597C66.0876 50.7561 66.449 52.1264 66.4193 53.5165V62.9746L53.418 70.6699V59.4594C53.384 58.5271 53.1128 57.618 52.6289 56.8168C52.143 56.0123 51.4584 55.3428 50.6389 54.872L38.4214 48.0991C37.5538 47.6408 36.5854 47.4008 35.6016 47.4008C34.6178 47.4008 33.6495 47.6408 32.7819 48.0991L20.536 54.8877L20.5151 54.8983C19.6773 55.3224 18.9778 55.9713 18.4955 56.7699C18.0133 57.5683 17.7673 58.4846 17.785 59.4141L17.7852 59.426V73.5364C17.8192 74.4687 18.0904 75.3778 18.5743 76.1791C19.0617 76.9859 19.7488 77.657 20.5715 78.128L20.5759 78.1305L32.7912 85.1888C33.6564 85.6439 34.6213 85.8821 35.6016 85.8821C36.5804 85.8821 37.5439 85.6446 38.4081 85.1908L53.7939 76.1503L64.5508 70.2151L79.9553 61.1703L79.9791 61.1576C81.2107 60.5042 82.5849 60.1626 83.9803 60.1626C85.3756 60.1626 86.7499 60.5042 87.9814 61.1576L87.9984 61.1667L110.753 74.1534C111.995 74.7886 113.035 75.7561 113.755 76.9481C114.478 78.146 114.849 79.522 114.825 80.9197V107.213L114.824 107.232C114.781 108.595 114.39 109.925 113.688 111.095C112.986 112.265 111.996 113.238 110.813 113.923L110.806 113.927L88.0254 126.935L88.0083 126.944C86.7767 127.597 85.4025 127.939 84.0072 127.939C82.6118 127.939 81.2376 127.597 80.006 126.944L79.9889 126.935L57.2341 113.941C55.9926 113.306 54.9528 112.339 54.2328 111.147C53.5094 109.949 53.1383 108.573 53.1626 107.175V97.4267L65.8815 90.0478V101.27C65.9155 102.202 66.1867 103.111 66.6706 103.912C67.1566 104.717 67.8413 105.386 68.6609 105.857C68.6632 105.858 68.6655 105.86 68.6679 105.861L80.8781 112.63C81.7457 113.088 82.7141 113.328 83.6979 113.328C84.6783 113.328 85.6432 113.09 86.5085 112.635L98.7538 105.566L98.7845 105.55C99.6223 105.126 100.322 104.477 100.804 103.679C101.286 102.88 101.532 101.964 101.515 101.034L101.514 101.023V87.186C101.48 86.2537 101.209 85.3445 100.725 84.5433C100.239 83.7387 99.5546 83.0691 98.735 82.5983C98.7326 82.5969 98.7303 82.5956 98.728 82.5943L86.5176 75.8255C85.65 75.3672 84.6817 75.1272 83.6979 75.1272C82.7164 75.1272 81.7502 75.3661 80.8841 75.8223L65.5678 84.5403L55.0394 90.756L39.619 99.5293L39.6028 99.5379C38.3712 100.191 36.997 100.533 35.6016 100.533C34.2063 100.533 32.832 100.191 31.6005 99.5379L31.5829 99.5286L8.82788 86.5085C7.59161 85.8756 6.55531 84.9133 5.83584 83.7276C5.11223 82.5352 4.73831 81.1649 4.757 79.7716V53.532C4.69146 52.07 5.08772 50.6245 5.88971 49.398C6.67944 48.1903 7.82297 47.2554 9.16307 46.7177L31.8657 33.7541L31.8828 33.745ZM33.0709 35.9448L10.2422 48.9804L10.1538 49.0144C9.2611 49.3581 8.50168 49.9716 7.98208 50.7662C7.46257 51.5607 7.20873 52.4964 7.25547 53.4409L7.257 53.4718V79.7895L7.25686 79.7987C7.24324 80.7246 7.49109 81.6364 7.97311 82.4307C8.45517 83.2251 9.15248 83.8707 9.98693 84.2932L10.0154 84.3076L32.789 97.3384C33.6548 97.7943 34.6205 98.033 35.6016 98.033C36.5832 98.033 37.5494 97.794 38.4156 97.3377L53.7857 88.593L64.3138 82.3775L79.6804 73.6309L79.6968 73.6222C80.9283 72.9688 82.3026 72.6272 83.6979 72.6272C85.0933 72.6272 86.4675 72.9688 87.699 73.6222L87.7092 73.6276L99.9626 80.4204L99.9701 80.4247C101.161 81.1062 102.157 82.0787 102.865 83.2508C103.573 84.423 103.969 85.7558 104.014 87.1231L104.014 87.1437V101C104.038 102.397 103.667 103.773 102.944 104.971C102.225 106.162 101.186 107.129 99.9456 107.764L87.7188 114.823L87.699 114.833C86.4675 115.487 85.0933 115.828 83.6979 115.828C82.3026 115.828 80.9283 115.487 79.6968 114.833L79.6866 114.828L67.4332 108.035L67.4257 108.031C66.2353 107.349 65.2386 106.377 64.5307 105.205C63.8227 104.032 63.4272 102.7 63.3822 101.332L63.3815 101.312V94.3884L55.6626 98.8665V107.198L55.6623 107.21C55.6447 108.139 55.8906 109.056 56.3728 109.854C56.8551 110.653 57.5546 111.302 58.3924 111.726L58.4204 111.74L81.1941 124.744C82.06 125.2 83.0259 125.439 84.0072 125.439C84.9885 125.439 85.9543 125.2 86.8203 124.744L109.56 111.759C109.562 111.758 109.563 111.758 109.564 111.757C110.38 111.284 111.061 110.613 111.544 109.809C112.024 109.009 112.292 108.102 112.325 107.172V80.8967L112.325 80.8848C112.343 79.9553 112.097 79.039 111.615 78.2406C111.132 77.4421 110.433 76.7931 109.595 76.369L109.567 76.3549L86.7934 63.3575C85.9275 62.9014 84.9616 62.6626 83.9803 62.6626C83.0014 62.6626 82.0379 62.9002 81.1736 63.354L65.7878 72.3878L55.0312 78.3229L39.6267 87.3744L39.6027 87.3871C38.3712 88.0406 36.997 88.3821 35.6016 88.3821C34.2063 88.3821 32.832 88.0406 31.6005 87.3871L31.5805 87.3766L19.3294 80.2976C19.3287 80.2972 19.3279 80.2968 19.3272 80.2964C18.1377 79.6149 17.1418 78.6429 16.4344 77.4715C15.7264 76.2993 15.3309 74.9665 15.2859 73.5992L15.2852 73.5786V59.4492C15.261 58.0514 15.632 56.6753 16.3555 55.4774C17.0768 54.2831 18.1193 53.3142 19.364 52.6789L31.5903 45.9012L31.6005 45.8958C32.832 45.2424 34.2063 44.9008 35.6016 44.9008C36.997 44.9008 38.3712 45.2424 39.6028 45.8958L39.6129 45.9012L51.8663 52.694L51.8738 52.6983C53.0642 53.3798 54.0609 54.3522 54.7689 55.5243C55.4768 56.6965 55.8723 58.0293 55.9173 59.3967L55.918 59.4172V66.285L63.9193 61.5492V53.488L63.9197 53.4734C63.9413 52.5483 63.7018 51.6352 63.2274 50.8372C62.753 50.0391 62.0624 49.3877 61.2327 48.9577L61.2074 48.9446L38.6945 35.9434C37.8293 35.4883 36.8643 35.25 35.884 35.25C34.9027 35.25 33.9368 35.4888 33.0709 35.9448Z",
    fill: "white"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_30_8716",
    x1: "59.788",
    y1: "34",
    x2: "59.788",
    y2: "126.689",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  }))));
};

var avalancheLogo = function avalancheLogo(width, height) {
  if (width === void 0) {
    width = '120';
  }

  if (height === void 0) {
    height = '160';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8478 120H17.5256C13.8846 120 12.0917 120 10.9884 119.313C9.80234 118.544 9.08518 117.281 9.00243 115.88C8.94727 114.589 9.82993 113.024 11.6228 109.865L54.3766 34.8295C56.197 31.6436 57.1073 30.0506 58.2658 29.4738C59.507 28.8421 60.9965 28.8421 62.2653 29.4738C63.4238 30.0506 64.334 31.6436 66.1545 34.8295L74.9535 50.1004L75.0087 50.1828C76.9671 53.5885 77.9601 55.3463 78.4014 57.159C78.8703 59.1365 78.8703 61.2513 78.4014 63.2289C77.9601 65.069 76.9671 66.7994 74.9811 70.2875L52.5285 109.81L52.4733 109.92C50.4874 113.381 49.4944 115.111 48.1152 116.429C46.5981 117.858 44.7777 118.929 42.7917 119.506C40.9712 120 38.93 120 34.8478 120ZM78.5945 120H103.419C107.088 120 108.908 120 110.012 119.286C111.198 118.517 111.942 117.226 111.998 115.825C112.053 114.589 111.17 113.079 109.46 110.112C109.405 110.003 109.35 109.92 109.267 109.81L96.8269 88.6344L96.689 88.3872C94.9512 85.4484 94.0686 83.9653 92.9377 83.3885C91.6964 82.7568 90.2069 82.7568 88.9657 83.3885C87.8348 83.9653 86.897 85.5308 85.0765 88.6619L72.7193 109.838L72.6641 109.92C70.8436 113.024 69.9334 114.589 70.0161 115.88C70.0989 117.281 70.8161 118.572 72.0021 119.341C73.0779 120 74.9259 120 78.5945 120Z",
    fill: "url(#paint0_linear_173_19026)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7082 30.5928C60.7863 30.1338 59.7139 30.1394 58.8327 30.5878L58.8229 30.5928C58.5343 30.7365 58.165 31.0625 57.5979 31.8836C57.0357 32.6975 56.3838 33.8362 55.4625 35.4485C55.4623 35.4489 55.4621 35.4493 55.4619 35.4497L12.7099 110.482C11.803 112.08 11.1652 113.208 10.7543 114.097C10.345 114.983 10.2386 115.475 10.2509 115.817C10.3136 116.822 10.8226 117.712 11.6581 118.258C11.9541 118.439 12.4365 118.588 13.4081 118.668C14.3858 118.749 15.683 118.75 17.5256 118.75H34.8477C38.9933 118.75 40.835 118.74 42.4534 118.302C44.2324 117.784 45.8761 116.82 47.2546 115.523C48.4675 114.362 49.3627 112.829 51.3719 109.328L51.4258 109.221L73.8942 69.67L73.8948 69.669C75.9193 66.1133 76.7957 64.5637 77.1857 62.9381C77.6087 61.1523 77.6089 59.2375 77.1861 57.4516C76.7975 55.8578 75.9221 54.2792 73.9463 50.8428L73.8914 50.7608L65.0714 35.4536L65.0692 35.4497C64.1476 33.8368 63.4955 32.6977 62.9331 31.8836C62.366 31.0625 61.9968 30.7365 61.7082 30.5928ZM57.7036 28.3573C59.304 27.5448 61.2083 27.5512 62.8224 28.3548C63.6923 28.7879 64.3574 29.5467 64.9902 30.4628C65.6206 31.3755 66.325 32.6083 67.2097 34.1567L67.2376 34.2055L67.2398 34.2094L76.0156 49.4399L76.0711 49.5227L76.0923 49.5596C78.017 52.9068 79.1229 54.8384 79.6159 56.8633L79.6177 56.8706C80.1315 59.0377 80.1315 61.3501 79.6177 63.5173L79.6169 63.5204C79.1391 65.5126 78.0813 67.3699 76.2422 70.5989C76.1847 70.6999 76.1264 70.8022 76.0674 70.906L53.6312 110.4L53.5748 110.512L53.4457 110.737C51.5665 114.012 50.4896 115.889 48.9789 117.333L48.972 117.34C47.3198 118.895 45.3277 120.071 43.1403 120.706L43.1298 120.709L43.1193 120.712C41.1368 121.25 38.9408 121.25 35.0693 121.25H17.4668C15.6962 121.25 14.2954 121.25 13.2027 121.16C12.1019 121.069 11.136 120.878 10.3279 120.375L10.3181 120.368L10.3084 120.362C8.7809 119.372 7.86023 117.742 7.7546 115.954L7.754 115.944L7.75356 115.934C7.71303 114.985 8.02218 114.05 8.48489 113.049C8.94978 112.043 9.64971 110.809 10.5357 109.248L10.5367 109.246L53.2905 34.2107L53.3214 34.1567C54.2061 32.6083 54.9105 31.3755 55.5409 30.4628C56.1724 29.5485 56.8363 28.7908 57.7036 28.3573ZM88.3987 82.2745C89.9962 81.4615 91.9072 81.4615 93.5046 82.2745L93.5056 82.275C94.3401 82.7006 94.9856 83.4121 95.6026 84.2752C96.2207 85.1397 96.9071 86.3002 97.7649 87.751L97.7729 87.7645L97.9116 88.0131L110.311 109.119C110.396 109.236 110.478 109.36 110.558 109.515L110.64 109.657C111.438 111.041 112.084 112.16 112.52 113.083C112.971 114.034 113.287 114.948 113.246 115.878C113.174 117.691 112.211 119.35 110.692 120.335L110.691 120.335C109.877 120.862 108.895 121.062 107.783 121.156C106.678 121.25 105.263 121.25 103.48 121.25H78.5389C76.7517 121.25 75.3325 121.25 74.2287 121.164C73.1263 121.078 72.1484 120.896 71.349 120.407L71.3354 120.398L71.3221 120.39C69.7878 119.395 68.8745 117.735 68.7685 115.957C68.7073 114.99 69.0255 114.041 69.4964 113.046C69.9704 112.043 70.6868 110.821 71.5859 109.288L71.6047 109.256L71.6591 109.174L83.9959 88.0336C84.8971 86.4835 85.6166 85.256 86.2584 84.3465C86.8946 83.4452 87.5554 82.7046 88.3978 82.275L88.3987 82.2745ZM89.5336 84.5021C89.2451 84.6492 88.8715 84.9798 88.3009 85.7882C87.736 86.5885 87.0763 87.7092 86.1571 89.2902L86.1561 89.2919L73.7794 110.501L73.7235 110.585C72.8121 112.139 72.1692 113.241 71.7565 114.114C71.3382 114.999 71.2429 115.477 71.2636 115.8L71.264 115.806C71.324 116.823 71.8392 117.739 72.6677 118.283C72.946 118.449 73.4305 118.594 74.4233 118.671C75.4181 118.749 76.7393 118.75 78.5945 118.75H103.419C105.276 118.75 106.585 118.749 107.572 118.665C108.562 118.581 109.043 118.424 109.332 118.237C110.184 117.684 110.71 116.763 110.749 115.776L110.749 115.77C110.762 115.465 110.665 115.006 110.261 114.153C109.868 113.323 109.268 112.282 108.427 110.824L108.359 110.706L108.343 110.673C108.333 110.655 108.326 110.638 108.268 110.562L108.225 110.505L95.7421 89.2556L95.605 89.01C94.7293 87.5291 94.1076 86.4827 93.5689 85.7291C93.0274 84.9717 92.6661 84.6532 92.3697 84.5021C91.4852 84.0523 90.4181 84.0523 89.5336 84.5021Z",
    fill: "white"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_173_19026",
    x1: "33.3469",
    y1: "120",
    x2: "70.5292",
    y2: "48.9727",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white",
    stopOpacity: "0.06"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.85"
  }))));
};

var fantomLogo = function fantomLogo(width, height) {
  if (width === void 0) {
    width = '120';
  }

  if (height === void 0) {
    height = '160';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M26 42.1622L59.6 24.0001L93.2 42.1622V80.0001V117.838L59.6 136L26 117.838V80.0001V42.1622Z",
    fill: "url(#paint0_linear_9446_42744)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6979 23.323C58.8848 22.6815 60.3152 22.6815 61.5021 23.323L91.5531 39.5668C93.4918 40.6148 94.7 42.6412 94.7 44.8451V115.155C94.7 117.359 93.4918 119.385 91.5531 120.433L62.4531 136.163C60.6728 137.125 58.5272 137.125 56.7469 136.163L27.6469 120.433C25.7082 119.385 24.5 117.359 24.5 115.155V44.8451C24.5 42.6412 25.7082 40.6148 27.6469 39.5668L57.6979 23.323ZM27.5 44.6781V77.3834L56.5423 60.3766L27.5 44.6781ZM58.1 62.941L28.9684 80L58.1 97.059V62.941ZM61.1 97.059L90.2316 80L61.1 62.941V97.059ZM59.6 58.6192L90.0455 42.1622L59.6 25.7051L29.1545 42.1622L59.6 58.6192ZM91.7 44.6781L62.6577 60.3766L91.7 77.3834V44.6781ZM91.7 82.6166L62.6319 99.6385C60.7594 100.735 58.4406 100.735 56.5681 99.6385L27.5 82.6166V114.559C27.5 116.028 28.3054 117.379 29.5979 118.078L57.6979 133.267C58.8848 133.908 60.3152 133.908 61.5021 133.267L89.6021 118.078C90.8945 117.379 91.7 116.028 91.7 114.559V82.6166Z",
    fill: "white"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_9446_42744",
    x1: "42.5",
    y1: "112.5",
    x2: "120.99",
    y2: "71.3123",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white",
    stopOpacity: "0.06"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.85"
  }))));
};

var arbitrum = function arbitrum(width, height) {
  if (width === void 0) {
    width = '120';
  }

  if (height === void 0) {
    height = '160';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    opacity: "0.3",
    d: "M9.09277 104.682V108.659L20.1229 115.042L24.4793 117.54L37.5487 125.033L53.1206 134.006C53.6767 134.283 54.1402 134.561 54.5109 134.746C55.0671 135.116 55.5305 135.301 55.6232 135.393C56.7355 135.948 58.3112 136.226 59.7943 136.226C61.0919 136.226 62.3896 135.948 63.5946 135.486L106.139 110.88C108.549 109.029 110.032 106.162 110.125 103.017V56.0242C110.032 52.6015 108.086 49.4564 105.212 47.6063L64.2434 24.1101C61.37 22.63 57.7551 22.63 54.8817 24.1101C54.5109 24.2951 15.0249 47.1437 15.0249 47.1437C14.4688 47.4213 13.9127 47.6988 13.4492 48.0688C10.8539 49.9189 9.27815 52.879 9.09277 56.0242L9.09277 104.682Z",
    fill: "url(#paint0_linear_173_19021)"
  }), React.createElement("path", {
    d: "M59.5161 25.7751C60.7211 25.7751 61.9261 26.0527 62.9457 26.5152L103.822 49.9189C105.954 51.3065 107.252 53.5266 107.437 56.0242V102.924C107.344 105.144 106.325 107.179 104.656 108.474L62.4822 132.896C61.648 133.173 60.7211 133.358 59.8869 133.358C58.8673 133.358 57.6623 133.173 57.0135 132.803C56.8281 132.711 56.55 132.526 55.9939 132.248C55.6231 132.063 55.1597 131.786 54.6962 131.508L39.1243 122.535L26.055 115.042L21.6986 112.545L11.8734 107.087V104.682V56.1167C11.9661 53.8041 13.1711 51.6765 15.1175 50.3814C15.4883 50.1039 15.8591 49.9189 16.2298 49.7339L16.3225 49.6414L16.4152 49.5489C29.6699 41.871 54.7889 27.3477 56.1793 26.6077C57.1989 26.0527 58.3112 25.7751 59.5161 25.7751ZM59.5161 23C57.8477 23 56.272 23.37 54.7889 24.1101C54.4182 24.2951 14.9322 47.1437 14.9322 47.1437C14.376 47.4213 13.8199 47.6988 13.3564 48.0688C10.7611 49.9189 9.18538 52.879 9 56.0242V104.682V108.659L20.0301 115.042L24.3866 117.54L37.4559 125.033L53.0278 134.006C53.584 134.283 54.0474 134.561 54.4182 134.746C54.9743 135.116 55.4378 135.301 55.5305 135.393C56.6427 135.948 58.2185 136.226 59.7015 136.226C60.9992 136.226 62.2968 135.948 63.5018 135.486L106.139 110.88C108.549 109.029 110.032 106.162 110.125 103.017V56.0242C110.032 52.6015 108.086 49.4564 105.212 47.6063L64.2433 24.1101C62.853 23.37 61.1846 23 59.5161 23Z",
    fill: "url(#paint1_linear_173_19021)"
  }), React.createElement("path", {
    opacity: "0.7",
    d: "M61.7406 96.3563L77.4052 120.87L91.8649 112.545L71.3804 80.168L61.7406 96.3563Z",
    fill: "url(#paint2_linear_173_19021)"
  }), React.createElement("path", {
    opacity: "0.7",
    d: "M105.027 102.647V95.9863L82.596 61.0195L74.2539 75.1727L95.9434 110.139L103.822 105.607C104.564 104.959 105.027 104.034 105.12 103.109L105.027 102.647Z",
    fill: "url(#paint3_linear_173_19021)"
  }), React.createElement("path", {
    d: "M20.4935 113.007L56.0865 56.1168L50.8032 55.9318C45.4272 55.8393 39.6804 57.2269 37.0851 61.5746L16.1371 93.9512L10.5757 102.462V108.012",
    fill: "url(#paint4_linear_173_19021)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2359 61.0461C39.1281 56.221 45.3738 54.8382 50.8204 54.9319L50.8293 54.9321L57.8534 55.178L21.3413 113.538L19.6458 112.477L54.3196 57.0555L50.7772 56.9315C45.4807 56.842 40.2451 58.2318 37.9437 62.0871L37.9345 62.1026L16.9767 94.4944L16.9742 94.4983L11.5757 102.759V108.012H9.57568V102.164L15.2975 93.408L15.3 93.4042L36.2359 61.0461Z",
    fill: "url(#paint5_linear_173_19021)"
  }), React.createElement("path", {
    d: "M37.5487 125.033L41.0709 119.02L78.2396 56.1167L63.5946 56.2092L25.4062 117.54",
    fill: "url(#paint6_linear_173_19021)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9985 55.1056L41.9336 119.525L41.9317 119.529L38.4114 125.538L36.6857 124.527L40.2079 118.515L40.2098 118.511L76.4805 57.1279L64.152 57.2058L26.255 118.068L24.5573 117.011L63.0369 55.2128L79.9985 55.1056Z",
    fill: "url(#paint7_linear_173_19021)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_173_19021",
    x1: "9.09278",
    y1: "79.6129",
    x2: "110.145",
    y2: "79.6129",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_173_19021",
    x1: "59.5625",
    y1: "23",
    x2: "59.5625",
    y2: "136.226",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white",
    stopOpacity: "0.2"
  }), React.createElement("stop", {
    offset: "0.348958",
    stopColor: "white"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_173_19021",
    x1: "61.7842",
    y1: "100.517",
    x2: "91.8902",
    y2: "100.517",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_173_19021",
    x1: "74.255",
    y1: "85.6105",
    x2: "105.056",
    y2: "85.6105",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_173_19021",
    x1: "10.5592",
    y1: "84.4857",
    x2: "56.0717",
    y2: "84.4857",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_173_19021",
    x1: "33.3311",
    y1: "55.9275",
    x2: "33.3311",
    y2: "113.007",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_173_19021",
    x1: "25.4314",
    y1: "90.5737",
    x2: "78.2591",
    y2: "90.5737",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_173_19021",
    x1: "51.8227",
    y1: "56.1168",
    x2: "51.8227",
    y2: "125.033",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  }))));
};

var comingSoon = function comingSoon(width, height) {
  if (width === void 0) {
    width = '491';
  }

  if (height === void 0) {
    height = '329';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 491 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    opacity: "0.7"
  }, React.createElement("path", {
    opacity: "0.7",
    d: "M379.591 182.084C389.402 101.415 331.941 28.068 251.248 18.2596C170.554 8.45125 97.1861 65.8954 87.3748 146.565C77.5635 227.234 135.025 300.581 215.718 310.389C296.411 320.198 369.779 262.754 379.591 182.084Z",
    fill: "#21BF96"
  })), React.createElement("path", {
    d: "M125.906 233.311C117.525 233.311 110.574 226.568 110.574 217.984V175.886C110.574 168.734 104.851 163.012 97.696 163.012H97.0827C94.0164 163.012 91.5634 160.559 91.5634 157.494C91.5634 154.429 94.0164 151.976 97.0827 151.976H97.696C110.779 151.976 121.613 162.603 121.613 175.886V217.984C121.613 220.232 123.453 222.072 125.701 222.072C127.95 222.072 129.79 220.232 129.79 217.984V185.696C129.79 176.091 137.558 168.325 147.166 168.325H161.884C164.95 168.325 167.403 170.777 167.403 173.843C167.403 176.908 164.95 179.361 161.884 179.361H147.166C143.69 179.361 140.829 182.222 140.829 185.696V218.189C141.033 226.568 134.287 233.311 125.906 233.311Z",
    fill: "url(#paint0_radial_202_9308)"
  }), React.createElement("path", {
    d: "M343.204 175.273H322.149C319.083 175.273 316.63 172.821 316.63 169.755C316.63 166.69 319.083 164.238 322.149 164.238H343.204C348.315 164.238 352.608 159.946 352.608 154.837V132.971C352.608 122.957 360.784 114.783 370.801 114.783H379.591C383.884 114.783 387.563 111.308 387.563 106.812V77.9978C387.563 74.9324 390.017 72.48 393.083 72.48C396.149 72.48 398.602 74.9324 398.602 77.9978V106.812C398.602 117.235 390.017 125.818 379.591 125.818H370.801C366.917 125.818 363.646 129.088 363.646 132.971V154.633C363.646 166.077 354.447 175.273 343.204 175.273Z",
    fill: "url(#paint1_radial_202_9308)"
  }), React.createElement("path", {
    d: "M399.215 78.2023H386.541C378.978 78.2023 372.845 72.0715 372.845 64.5102V59.4012C372.845 53.8835 377.342 49.3876 382.862 49.3876C384.293 49.3876 385.724 50.6137 385.724 52.2486C385.724 53.8835 384.497 55.1096 382.862 55.1096C380.409 55.1096 378.365 57.1532 378.365 59.6056V64.7145C378.365 69.2105 382.044 72.8889 386.541 72.8889H399.215C403.713 72.8889 407.392 69.2105 407.392 64.7145V59.6056C407.392 57.1532 405.348 55.1096 402.895 55.1096C401.464 55.1096 400.033 53.8835 400.033 52.2486C400.033 50.6137 401.26 49.3876 402.895 49.3876C408.414 49.3876 412.912 53.8835 412.912 59.4012V64.7145C412.912 72.0715 406.779 78.2023 399.215 78.2023Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M308.453 259.673H167.403C163.928 259.673 161.066 256.812 161.066 253.338V165.259C161.066 161.785 163.928 158.924 167.403 158.924H308.453C311.928 158.924 314.79 161.785 314.79 165.259V253.338C314.79 256.812 311.928 259.673 308.453 259.673Z",
    fill: "url(#paint2_radial_202_9308)"
  }), React.createElement("path", {
    d: "M154.729 153.407C150.641 153.407 147.37 156.677 147.37 160.764V183.244C147.37 187.331 150.641 190.601 154.729 190.601C158.818 190.601 162.088 187.331 162.088 183.244V160.968C162.088 156.881 158.818 153.407 154.729 153.407Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M322.149 153.407C318.061 153.407 314.79 156.677 314.79 160.764V183.244C314.79 187.331 318.061 190.601 322.149 190.601C326.238 190.601 329.508 187.331 329.508 183.244V160.968C329.508 156.881 326.238 153.407 322.149 153.407Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M208.287 178.236C208.287 180.211 209.889 181.812 211.865 181.812C213.84 181.812 215.442 180.211 215.442 178.236C215.442 176.261 213.84 174.66 211.865 174.66C209.889 174.66 208.287 176.261 208.287 178.236Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M208.287 191.52C208.287 193.495 209.889 195.096 211.865 195.096C213.84 195.096 215.442 193.495 215.442 191.52C215.442 189.544 213.84 187.943 211.865 187.943C209.889 187.943 208.287 189.544 208.287 191.52Z",
    fill: "#EB5757"
  }), React.createElement("path", {
    d: "M392.878 78.2023H386.541C378.978 78.2023 372.845 72.0715 372.845 64.5102V59.4012C372.845 53.8835 377.342 49.3876 382.862 49.3876C384.293 49.3876 385.724 50.6137 385.724 52.2486C385.724 53.8835 384.497 55.1096 382.862 55.1096C380.409 55.1096 378.365 57.1532 378.365 59.6056V64.7145C378.365 69.2105 382.044 72.8889 386.541 72.8889H392.878C394.309 72.8889 395.74 74.1151 395.74 75.75C395.74 76.9761 394.514 78.2023 392.878 78.2023Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M224.845 178.236C224.845 180.211 226.448 181.812 228.423 181.812C230.398 181.812 232 180.211 232 178.236C232 176.261 230.398 174.66 228.423 174.66C226.448 174.66 224.845 176.261 224.845 178.236Z",
    fill: "#F8FEFF"
  }), React.createElement("path", {
    d: "M224.845 191.52C224.845 193.495 226.448 195.096 228.423 195.096C230.398 195.096 232 193.495 232 191.52C232 189.544 230.398 187.943 228.423 187.943C226.448 187.943 224.845 189.544 224.845 191.52Z",
    fill: "#EB5757"
  }), React.createElement("path", {
    d: "M241.199 178.236C241.199 180.211 242.801 181.812 244.776 181.812C246.751 181.812 248.354 180.211 248.354 178.236C248.354 176.261 246.751 174.66 244.776 174.66C242.801 174.66 241.199 176.261 241.199 178.236Z",
    fill: "#EB5757"
  }), React.createElement("path", {
    d: "M241.199 191.52C241.199 193.495 242.801 195.096 244.776 195.096C246.751 195.096 248.354 193.495 248.354 191.52C248.354 189.544 246.751 187.943 244.776 187.943C242.801 187.943 241.199 189.544 241.199 191.52Z",
    fill: "#F8FEFF"
  }), React.createElement("path", {
    d: "M257.757 178.236C257.757 180.211 259.359 181.812 261.334 181.812C263.309 181.812 264.912 180.211 264.912 178.236C264.912 176.261 263.309 174.66 261.334 174.66C259.359 174.66 257.757 176.261 257.757 178.236Z",
    fill: "#F8FEFF"
  }), React.createElement("path", {
    d: "M257.757 191.52C257.757 193.495 259.359 195.096 261.334 195.096C263.309 195.096 264.912 193.495 264.912 191.52C264.912 189.544 263.309 187.943 261.334 187.943C259.359 187.943 257.757 189.544 257.757 191.52Z",
    fill: "#EB5757"
  }), React.createElement("path", {
    d: "M76.4363 178.747H71.3258C65.8065 178.747 61.3093 174.251 61.3093 168.733C61.3093 167.303 62.5358 165.872 64.1712 165.872C65.6021 165.872 67.033 167.099 67.033 168.733C67.033 171.186 69.0772 173.229 71.5303 173.229H76.6408C81.138 173.229 84.8176 169.551 84.8176 165.055V152.589C84.8176 148.093 81.138 144.415 76.6408 144.415H71.5303C68.8728 144.415 66.8286 146.458 66.8286 148.911C66.8286 150.341 65.6021 151.772 63.9667 151.772C62.5358 151.772 61.1049 150.545 61.1049 148.911C61.1049 143.393 65.6021 138.897 71.1214 138.897H76.2319C83.7955 138.897 89.9281 145.028 89.9281 152.589V165.259C90.1325 172.616 83.9999 178.747 76.4363 178.747Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M87.2707 167.917C81.9557 167.917 77.4585 163.625 77.4585 158.107C77.4585 152.794 81.7513 148.298 87.2707 148.298C92.79 148.298 97.0828 152.59 97.0828 158.107C97.0828 163.625 92.79 167.917 87.2707 167.917Z",
    fill: "url(#paint3_linear_202_9308)"
  }), React.createElement("path", {
    d: "M402.077 75.5457C402.077 70.2323 397.785 65.7364 392.265 65.7364C386.95 65.7364 382.453 70.0279 382.453 75.5457C382.453 80.859 386.746 85.3549 392.265 85.3549C397.785 85.1506 402.077 80.859 402.077 75.5457Z",
    fill: "url(#paint4_linear_202_9308)"
  }), React.createElement("path", {
    d: "M242.426 52.6575H231.591C224.232 52.6575 218.304 58.5839 218.304 65.9409V80.246H255.917V65.9409C255.713 58.7883 249.785 52.6575 242.426 52.6575Z",
    fill: "url(#paint5_radial_202_9308)"
  }), React.createElement("path", {
    d: "M260.415 146.867H213.602C212.785 146.867 211.967 147.48 211.967 148.502V157.29C211.967 158.107 212.58 158.925 213.602 158.925H260.415C261.232 158.925 262.05 158.312 262.05 157.29V148.502C261.845 147.48 261.232 146.867 260.415 146.867Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M323.58 109.265H302.934V113.148H323.58V109.265Z",
    fill: "url(#paint6_radial_202_9308)"
  }), React.createElement("path", {
    d: "M302.116 101.703H290.26V120.096H302.116C305.387 120.096 308.044 117.439 308.044 114.169V107.63C308.044 104.36 305.387 101.703 302.116 101.703Z",
    fill: "url(#paint7_radial_202_9308)"
  }), React.createElement("path", {
    d: "M329.508 110.899C329.508 113.352 327.464 115.395 325.011 115.395C322.558 115.395 320.514 113.352 320.514 110.899C320.514 108.447 322.558 106.403 325.011 106.403C327.464 106.403 329.508 108.447 329.508 110.899Z",
    fill: "url(#paint8_linear_202_9308)"
  }), React.createElement("path", {
    d: "M281.879 71.4583H191.934C186.006 71.4583 181.304 76.1585 181.304 82.085V138.284C181.304 144.21 186.006 148.911 191.934 148.911H281.879C287.807 148.911 292.508 144.21 292.508 138.284V82.085C292.508 76.1585 287.807 71.4583 281.879 71.4583Z",
    fill: "url(#paint9_radial_202_9308)"
  }), React.createElement("path", {
    d: "M271.044 80.8594H202.972C198.475 80.8594 195 84.5378 195 88.8294V131.336C195 135.832 198.679 139.306 202.972 139.306H271.044C275.541 139.306 279.016 135.628 279.016 131.336V89.0338C279.016 84.5378 275.337 80.8594 271.044 80.8594Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M235.054 17.6228V55.225H238.938V17.6228H235.054Z",
    fill: "url(#paint10_radial_202_9308)"
  }), React.createElement("path", {
    d: "M171.901 120.096H183.757V101.703H171.901C168.63 101.703 165.973 104.36 165.973 107.63V114.374C165.973 117.439 168.63 120.096 171.901 120.096Z",
    fill: "url(#paint11_radial_202_9308)"
  }), React.createElement("path", {
    d: "M150.323 112.516H170.969V108.633H150.323V112.516Z",
    fill: "url(#paint12_radial_202_9308)"
  }), React.createElement("path", {
    d: "M144.304 110.899C144.304 108.447 146.348 106.403 148.801 106.403C151.254 106.403 153.298 108.447 153.298 110.899C153.298 113.352 151.254 115.395 148.801 115.395C146.348 115.395 144.304 113.352 144.304 110.899Z",
    fill: "url(#paint13_linear_202_9308)"
  }), React.createElement("path", {
    d: "M237.111 11.5811C239.564 11.5811 241.608 13.6247 241.608 16.077C241.608 18.5293 239.564 20.5729 237.111 20.5729C234.658 20.5729 232.614 18.5293 232.614 16.077C232.614 13.6247 234.658 11.5811 237.111 11.5811Z",
    fill: "url(#paint14_linear_202_9308)"
  }), React.createElement("path", {
    d: "M215.646 103.543C218.582 103.543 220.961 100.706 220.961 97.2076C220.961 93.7088 218.582 90.8724 215.646 90.8724C212.711 90.8724 210.331 93.7088 210.331 97.2076C210.331 100.706 212.711 103.543 215.646 103.543Z",
    fill: "url(#paint15_linear_202_9308)"
  }), React.createElement("path", {
    d: "M255.917 103.543C258.853 103.543 261.232 100.706 261.232 97.2076C261.232 93.7088 258.853 90.8724 255.917 90.8724C252.982 90.8724 250.602 93.7088 250.602 97.2076C250.602 100.706 252.982 103.543 255.917 103.543Z",
    fill: "url(#paint16_linear_202_9308)"
  }), React.createElement("path", {
    d: "M221.166 121.322C221.166 121.322 235.68 135.219 250.602 122.549",
    stroke: "#2E7DAF",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M285.967 259.674H192.138V275.205H285.967V259.674Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M299 203.581H179C174.582 203.581 171 207.163 171 211.581V241.581C171 245.999 174.582 249.581 179 249.581H299C303.418 249.581 307 245.999 307 241.581V211.581C307 207.163 303.418 203.581 299 203.581Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M247 213.581H243C242.448 213.581 242 214.029 242 214.581V220.581C242 221.133 242.448 221.581 243 221.581H247C247.552 221.581 248 221.133 248 220.581V214.581C248 214.029 247.552 213.581 247 213.581Z",
    fill: "url(#paint17_linear_202_9308)"
  }), React.createElement("path", {
    d: "M254 213.581H250C249.448 213.581 249 214.029 249 214.581V220.581C249 221.133 249.448 221.581 250 221.581H254C254.552 221.581 255 221.133 255 220.581V214.581C255 214.029 254.552 213.581 254 213.581Z",
    fill: "url(#paint18_linear_202_9308)"
  }), React.createElement("path", {
    d: "M261 213.581H257C256.448 213.581 256 214.029 256 214.581V220.581C256 221.133 256.448 221.581 257 221.581H261C261.552 221.581 262 221.133 262 220.581V214.581C262 214.029 261.552 213.581 261 213.581Z",
    fill: "url(#paint19_linear_202_9308)"
  }), React.createElement("path", {
    d: "M268 213.581H264C263.448 213.581 263 214.029 263 214.581V220.581C263 221.133 263.448 221.581 264 221.581H268C268.552 221.581 269 221.133 269 220.581V214.581C269 214.029 268.552 213.581 268 213.581Z",
    fill: "url(#paint20_linear_202_9308)"
  }), React.createElement("path", {
    d: "M275 213.581H271C270.448 213.581 270 214.029 270 214.581V220.581C270 221.133 270.448 221.581 271 221.581H275C275.552 221.581 276 221.133 276 220.581V214.581C276 214.029 275.552 213.581 275 213.581Z",
    fill: "url(#paint21_linear_202_9308)"
  }), React.createElement("path", {
    d: "M282 213.581H278C277.448 213.581 277 214.029 277 214.581V220.581C277 221.133 277.448 221.581 278 221.581H282C282.552 221.581 283 221.133 283 220.581V214.581C283 214.029 282.552 213.581 282 213.581Z",
    fill: "url(#paint22_linear_202_9308)",
    fillOpacity: "0.6"
  }), React.createElement("path", {
    d: "M289 213.581H285C284.448 213.581 284 214.029 284 214.581V220.581C284 221.133 284.448 221.581 285 221.581H289C289.552 221.581 290 221.133 290 220.581V214.581C290 214.029 289.552 213.581 289 213.581Z",
    fill: "url(#paint23_linear_202_9308)",
    fillOpacity: "0.6"
  }), React.createElement("path", {
    d: "M296 213.581H292C291.448 213.581 291 214.029 291 214.581V220.581C291 221.133 291.448 221.581 292 221.581H296C296.552 221.581 297 221.133 297 220.581V214.581C297 214.029 296.552 213.581 296 213.581Z",
    fill: "url(#paint24_linear_202_9308)",
    fillOpacity: "0.6"
  }), React.createElement("path", {
    d: "M392.47 194.279H359.762V297.072H392.47V194.279Z",
    fill: "url(#paint25_radial_202_9308)"
  }), React.createElement("path", {
    d: "M430.083 288.488H359.762V300.546H430.083V288.488Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 216.35H359.762V218.802H392.47V216.35Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 224.933H359.762V227.385H392.47V224.933Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 233.516H359.762V235.969H392.47V233.516Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 242.1H359.762V244.552H392.47V242.1Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 250.887H359.762V253.339H392.47V250.887Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 259.47H359.762V261.923H392.47V259.47Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 268.052H359.762V270.505H392.47V268.052Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 276.636H359.762V279.088H392.47V276.636Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M392.47 285.219H359.762V287.671H392.47V285.219Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M438.055 169.96C437.851 169.96 437.851 169.96 437.646 169.96C436.215 169.96 434.784 169.143 433.967 168.121L435.602 166.895C436.215 167.508 436.829 167.916 437.851 167.916C439.486 168.121 441.53 167.099 442.961 165.873C445.619 163.216 447.05 159.333 446.845 155.45C444.188 156.064 441.939 155.859 440.099 154.837C438.668 154.02 437.646 152.181 437.442 150.546C437.237 149.115 437.851 147.889 438.873 146.867C440.304 145.641 442.552 145.641 444.392 146.663C445.823 147.48 446.845 148.911 447.663 150.75C447.867 151.363 448.072 152.181 448.276 152.794C451.547 151.568 454.409 148.911 455.226 145.846C455.022 145.846 454.818 145.641 454.613 145.437C452.364 144.211 450.934 141.758 450.934 139.306C450.934 138.489 451.342 137.058 452.16 136.445C452.773 136.036 453.387 136.036 454 136.241C454.818 136.445 455.022 137.262 455.226 137.671C456.248 139.51 457.271 141.35 457.475 143.598C457.475 143.802 457.475 144.006 457.475 144.211C458.702 144.415 459.928 144.211 460.746 143.598L461.768 145.437C460.337 146.254 458.701 146.459 457.066 146.254C456.044 150.137 452.364 153.203 448.48 154.633C448.889 159.129 447.254 163.829 443.983 167.099C442.757 168.938 440.304 169.96 438.055 169.96ZM441.735 147.889C441.121 147.889 440.713 148.094 440.304 148.298C439.69 148.911 439.486 149.728 439.69 150.137C439.69 151.159 440.508 152.385 441.326 152.794C442.961 153.816 445.005 153.611 446.641 153.203C446.436 152.589 446.232 151.976 446.027 151.363C445.414 149.933 444.597 148.707 443.574 148.094C442.961 148.094 442.348 147.889 441.735 147.889ZM453.387 138.284C453.387 138.284 453.182 138.897 453.182 139.306C453.182 141.145 454.204 142.78 455.635 143.598C455.431 141.758 454.409 140.124 453.591 138.693C453.591 138.693 453.387 138.489 453.387 138.284Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 162.398H420.475V265.191H453.182V162.398Z",
    fill: "url(#paint26_radial_202_9308)"
  }), React.createElement("path", {
    d: "M490.795 256.609H420.475V268.666H490.795V256.609Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 184.47H420.475V186.922H453.182V184.47Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 193.257H420.475V195.71H453.182V193.257Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 201.84H420.475V204.293H453.182V201.84Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 210.423H420.475V212.875H453.182V210.423Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 219.006H420.475V221.458H453.182V219.006Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 227.589H420.475V230.042H453.182V227.589Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 236.173H420.475V238.625H453.182V236.173Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 244.756H420.475V247.208H453.182V244.756Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M453.182 253.338H420.475V255.791H453.182V253.338Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M275.541 307.698C275.337 307.698 275.132 307.698 274.928 307.698C271.657 307.493 268.591 305.245 267.16 301.976C265.934 299.115 265.729 295.845 266.751 292.371L268.795 292.984C267.978 295.845 267.978 298.706 269.204 301.158C270.431 303.815 272.884 305.45 275.337 305.654C276.972 305.859 278.608 305.245 280.039 304.224C278.812 302.793 277.79 300.75 277.177 298.297C276.155 294.823 275.95 291.145 276.359 287.466C276.359 286.444 276.563 285.423 277.381 284.81C278.608 283.379 281.061 283.583 282.287 284.605C283.514 285.627 284.331 287.057 284.74 288.488C286.376 293.188 286.58 297.275 285.353 300.954C284.945 302.18 284.127 303.406 283.105 304.632C286.171 306.472 290.464 305.45 292.917 303.202C293.121 302.998 293.326 302.793 293.53 302.589C292.508 301.567 291.895 300.136 291.282 298.706C289.033 293.597 289.237 287.466 291.69 282.562C291.895 282.153 292.304 281.131 293.326 280.927C293.939 280.722 294.757 280.927 295.574 281.335C300.072 284.196 300.072 290.532 299.663 292.984C299.254 295.845 298.436 299.523 296.188 302.589C297.21 303.406 298.232 304.019 299.254 304.224C302.934 305.245 306.818 302.998 309.271 300.545C307.022 297.889 306.204 293.597 306.818 287.875C307.022 286.036 307.226 283.992 308.453 282.357C309.679 280.518 311.928 279.292 314.381 280.109C317.039 281.131 317.856 284.401 317.652 287.057C317.243 291.962 315.403 296.662 312.132 300.341C315.199 302.793 320.105 301.976 323.171 299.932C325.011 298.706 326.646 296.867 328.077 294.823C327.464 294.006 327.055 293.188 326.646 292.371C325.42 290.123 323.58 287.058 323.784 283.583C323.989 281.54 325.011 279.701 326.442 278.474C327.668 277.453 329.099 277.044 330.53 277.248C333.392 277.657 335.232 280.927 335.232 283.583C335.232 286.24 334.005 288.488 332.779 290.94C332.166 292.166 331.348 293.597 330.53 294.823C331.144 295.641 331.757 296.458 332.574 297.071C334.21 298.297 336.663 299.115 338.503 298.297L339.32 300.136C336.867 301.158 333.597 300.75 331.144 298.706C330.326 298.093 329.713 297.48 329.099 296.662C327.668 298.502 326.033 300.341 324.193 301.567C320.514 304.019 314.586 305.041 310.702 301.771C307.022 305.45 302.525 307.085 298.641 306.063C297.21 305.654 295.983 305.041 294.757 304.019C294.552 304.224 294.144 304.632 293.939 304.837C290.668 307.698 285.149 308.924 281.265 306.063C279.63 306.88 277.79 307.698 275.541 307.698ZM279.425 285.627C279.016 285.627 278.608 285.831 278.403 286.036C277.994 286.444 277.994 287.057 277.994 287.671C277.585 291.145 277.994 294.414 278.812 297.889C279.425 300.137 280.243 301.771 281.265 302.998C282.083 302.18 282.696 301.158 283.105 299.932C284.536 296.049 283.514 291.758 282.492 288.897C282.083 287.875 281.674 286.649 280.856 286.036C280.447 285.831 279.834 285.627 279.425 285.627ZM293.735 282.357C293.735 282.357 293.53 282.357 293.326 282.97C291.077 287.466 291.077 292.984 292.917 297.48C293.326 298.706 293.939 299.728 294.757 300.545C296.597 297.889 297.21 294.619 297.619 292.166C297.823 290.532 298.232 284.605 294.552 282.357C293.939 282.357 293.735 282.357 293.735 282.357ZM312.746 281.335C311.724 281.335 310.702 282.153 310.088 282.97C309.271 284.196 309.066 286.036 308.862 287.671C308.248 292.575 308.862 296.254 310.497 298.502C313.359 295.027 314.994 290.94 315.403 286.444C315.608 284.605 315.199 282.153 313.563 281.54C313.359 281.335 312.95 281.335 312.746 281.335ZM329.304 278.883C328.486 278.883 327.873 279.292 327.26 279.701C326.237 280.518 325.42 281.949 325.42 283.379C325.215 285.831 326.442 288.284 328.077 290.94C328.282 291.553 328.69 291.962 329.099 292.575C329.713 291.553 330.326 290.532 330.735 289.51C331.961 287.466 332.983 285.423 332.779 283.175C332.779 281.335 331.552 279.087 329.713 278.883C329.713 278.883 329.508 278.883 329.304 278.883Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M69.9835 272.74C70.1879 272.74 70.3923 272.74 70.5967 272.944C73.663 273.762 76.3205 276.623 77.3426 279.892C78.1602 282.958 77.7514 286.227 76.116 289.497L74.2763 288.475C75.7072 285.819 76.1161 282.958 75.2984 280.301C74.4807 277.644 72.4365 275.396 69.9835 274.783C68.3481 274.375 66.7127 274.579 65.0774 275.396C66.0995 277.031 66.7127 279.075 66.9172 281.732C67.1216 285.41 66.9172 289.088 65.8951 292.563C65.6906 293.584 65.2818 294.402 64.4641 295.015C62.8288 296.241 60.7846 295.628 59.558 294.402C58.5359 293.176 58.1271 291.541 57.9227 290.315C57.105 285.41 57.7183 281.323 59.558 278.053C60.1713 276.827 61.1934 275.805 62.2155 274.783C59.558 272.331 55.2652 272.74 52.4033 274.375C52.1989 274.579 51.7901 274.783 51.5857 274.988C52.1989 276.214 52.8122 277.644 53.221 279.279C54.4475 284.797 53.221 290.723 49.9503 295.219C49.7459 295.628 48.9282 296.445 47.9061 296.65C47.2928 296.65 46.4752 296.445 45.8619 295.832C41.7735 292.154 43.2044 286.023 43.8177 283.571C44.6354 280.914 46.0663 277.236 48.9282 274.783C48.1105 273.762 47.2928 273.148 46.2707 272.535C42.7956 270.9 38.7072 272.331 35.8453 274.375C37.4807 277.44 37.4807 281.732 36.0497 287.249C35.4365 289.088 34.8232 290.928 33.3923 292.563C31.9613 293.993 29.3039 295.015 27.2597 293.789C24.8067 292.358 24.6022 288.884 25.4199 286.227C26.6464 281.527 29.3039 277.236 33.1879 273.966C30.5304 270.9 25.6243 270.9 22.3536 272.535C20.3094 273.557 18.2652 274.988 16.6299 276.623C17.0387 277.644 17.2431 278.462 17.652 279.484C18.4696 281.936 19.6962 285.41 18.8785 288.475C18.4696 290.315 17.0387 292.154 15.4033 293.176C13.9724 293.993 12.5415 293.993 11.3149 293.584C8.45306 292.563 7.22654 289.088 7.8398 286.432C8.24864 283.775 9.884 281.732 11.5194 279.688C12.337 278.462 13.3591 277.44 14.3812 276.214C13.9724 275.396 13.3591 274.375 12.7459 273.557C11.5194 272.127 9.27074 270.696 7.02212 271.309L6.61328 269.266C9.27074 268.653 12.337 269.674 14.3812 272.127C14.9945 272.944 15.6078 273.557 16.0166 274.375C17.652 272.74 19.4917 271.309 21.7404 270.287C25.8288 268.448 31.7569 268.448 35.0276 272.331C39.3205 269.266 44.0221 268.448 47.4973 270.287C48.7238 270.9 49.9503 271.922 50.9724 272.944C51.1768 272.74 51.5857 272.535 51.7901 272.331C55.4696 270.083 61.1934 269.879 64.4641 273.353C65.8951 272.74 67.9393 272.331 69.9835 272.74ZM62.4199 293.789C62.8288 293.789 63.2376 293.789 63.442 293.584C63.8509 293.176 64.0553 292.563 64.2597 292.154C65.2818 288.884 65.4862 285.41 65.2818 281.936C65.0774 279.688 64.6685 277.849 63.8509 276.418C63.0332 277.031 62.2155 278.053 61.6022 279.075C59.558 282.549 59.7625 287.045 60.1713 289.906C60.3757 291.132 60.5801 292.154 61.3978 292.971C61.3978 293.584 61.8067 293.789 62.4199 293.789ZM47.7017 294.606C47.7017 294.606 47.9061 294.606 48.3149 293.993C51.1768 289.906 52.4033 284.593 51.1768 279.688C50.9724 278.462 50.5636 277.44 49.9503 276.418C47.7017 278.666 46.4752 281.732 45.8619 284.184C45.4531 285.819 44.0221 291.541 47.2928 294.402C47.4973 294.606 47.7017 294.606 47.7017 294.606ZM28.6906 292.154C29.7127 292.358 30.9392 291.745 31.5525 291.132C32.5746 289.906 33.1879 288.271 33.5967 286.841C35.0276 282.14 35.0276 278.462 33.8011 275.805C30.5304 278.666 28.0774 282.549 26.8509 286.841C26.442 288.68 26.2376 291.132 27.8729 291.95C28.2818 292.154 28.4862 292.154 28.6906 292.154ZM11.9282 291.745C12.7459 291.95 13.5636 291.541 13.9724 291.336C15.1989 290.723 16.221 289.293 16.4254 288.067C17.0387 285.614 16.221 282.958 15.1989 280.097C14.9945 279.484 14.7901 278.87 14.5857 278.257C13.768 279.075 13.1547 280.097 12.337 280.914C10.9061 282.753 9.47516 284.593 9.06632 286.636C8.65748 288.475 9.47516 290.928 11.3149 291.541C11.7238 291.745 11.9282 291.745 11.9282 291.745Z",
    fill: "#2E7DAF"
  }), React.createElement("g", {
    clipPath: "url(#clip0_202_9308)"
  }, React.createElement("path", {
    d: "M83.6933 220.678L80.0386 220.326C84.5634 212.572 73.2513 207.462 67.1601 212.044C65.7678 211.691 64.2015 211.339 62.8093 210.986C62.6352 205.7 56.5441 208.519 52.7154 208.519C49.2347 208.519 48.7126 210.458 48.1905 212.925C46.7982 213.101 45.2319 213.453 44.0137 213.982C37.5745 209.224 26.2623 212.572 30.9612 220.326C25.9143 220.502 23.3038 221.03 24.1739 226.669C23.3038 232.308 26.0883 232.837 31.1352 233.013C26.7844 240.766 37.9225 245.876 44.0137 241.295C45.406 241.647 46.7982 242 48.1905 242.176C48.3645 247.638 54.4557 246.405 58.2844 246.581C61.7651 246.581 62.2872 244.643 62.8093 242.176C64.3756 242 65.7678 241.647 67.1601 241.119C73.2513 245.7 84.5634 240.414 80.0386 232.837C82.127 232.66 87.522 232.66 86.9999 229.665C86.3038 226.317 88.9143 221.03 83.6933 220.678ZM55.4999 229.841C51.6712 229.841 48.1905 228.608 46.7982 226.669C49.5828 222.44 61.417 222.44 64.3756 226.669C62.8093 228.431 59.5027 229.841 55.4999 229.841Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M55.4999 229.841C42.9695 230.017 42.9695 218.916 55.4999 218.916C68.0303 218.74 68.0303 229.841 55.4999 229.841ZM83.6933 220.678L79.3425 220.326C78.8204 219.445 78.2983 218.74 77.6021 217.859C83.5193 214.158 80.2126 212.749 75.8618 210.282C72.7292 208.872 70.2928 210.81 67.3342 211.339C66.116 211.515 62.9834 210.81 62.9834 210.81C62.9834 210.81 63.1574 208.343 61.243 207.286C58.8066 206.405 54.6298 206.581 52.7154 206.581C49.2347 206.581 48.7126 208.52 48.1905 210.987C43.8397 213.454 39.6629 208.696 35.3121 210.81C30.9613 213.277 27.6546 214.158 33.5718 217.859C32.7016 218.564 32.1795 219.445 31.8314 220.326C27.3066 220.678 23.1298 220.15 24.174 225.965C24.174 228.432 29.9171 228.255 31.8314 228.608C32.3535 229.489 32.8756 230.194 33.5718 231.075C27.6546 234.775 30.9613 235.832 35.3121 238.123C39.4889 240.238 43.6657 235.48 48.1905 237.771C48.3646 243.233 54.4557 242 58.2845 242.176C61.7651 242.176 62.2872 240.238 62.8093 237.771C67.3342 235.304 71.337 240.062 75.6878 237.947C80.0386 235.48 83.3452 234.599 77.4281 230.899C78.1242 230.194 78.8204 229.313 79.1684 228.432C81.0828 228.079 86.8259 228.432 86.8259 225.788C86.9999 223.498 87.522 220.854 83.6933 220.678Z",
    fill: "url(#paint27_radial_202_9308)"
  })), React.createElement("path", {
    d: "M183.88 221.581C183.504 221.581 183.212 221.489 183.004 221.305C182.804 221.113 182.684 220.849 182.644 220.513H182.584C182.472 220.897 182.252 221.197 181.924 221.413C181.596 221.621 181.192 221.725 180.712 221.725C180.088 221.725 179.592 221.561 179.224 221.233C178.856 220.905 178.672 220.449 178.672 219.865C178.672 218.617 179.588 217.993 181.42 217.993H182.512V217.585C182.512 217.193 182.416 216.897 182.224 216.697C182.032 216.497 181.72 216.397 181.288 216.397C180.896 216.397 180.58 216.473 180.34 216.625C180.1 216.777 179.896 216.973 179.728 217.213L178.852 216.469C179.044 216.125 179.352 215.837 179.776 215.605C180.208 215.365 180.764 215.245 181.444 215.245C182.26 215.245 182.896 215.437 183.352 215.821C183.816 216.197 184.048 216.761 184.048 217.513V220.429H184.78V221.581H183.88ZM181.228 220.669C181.596 220.669 181.9 220.585 182.14 220.417C182.388 220.241 182.512 220.005 182.512 219.709V218.881H181.456C180.616 218.881 180.196 219.145 180.196 219.673V219.913C180.196 220.161 180.288 220.349 180.472 220.477C180.656 220.605 180.908 220.669 181.228 220.669Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M188.771 221.725C188.091 221.725 187.503 221.621 187.007 221.413C186.511 221.197 186.123 220.909 185.843 220.549L186.743 219.733C186.999 220.013 187.291 220.229 187.619 220.381C187.955 220.533 188.343 220.609 188.783 220.609C189.167 220.609 189.475 220.545 189.707 220.417C189.939 220.289 190.055 220.093 190.055 219.829C190.055 219.605 189.975 219.453 189.815 219.373C189.663 219.293 189.459 219.233 189.203 219.193L188.207 219.037C187.951 218.997 187.699 218.941 187.451 218.869C187.211 218.789 186.995 218.681 186.803 218.545C186.619 218.409 186.471 218.237 186.359 218.029C186.247 217.813 186.191 217.553 186.191 217.249C186.191 216.601 186.431 216.105 186.911 215.761C187.399 215.417 188.067 215.245 188.915 215.245C189.515 215.245 190.023 215.329 190.439 215.497C190.863 215.665 191.211 215.901 191.483 216.205L190.679 217.093C190.503 216.901 190.267 216.733 189.971 216.589C189.683 216.437 189.315 216.361 188.867 216.361C188.083 216.361 187.691 216.605 187.691 217.093C187.691 217.317 187.771 217.473 187.931 217.561C188.091 217.641 188.299 217.701 188.555 217.741L189.539 217.897C189.803 217.937 190.055 217.997 190.295 218.077C190.543 218.149 190.759 218.253 190.943 218.389C191.135 218.525 191.287 218.697 191.399 218.905C191.511 219.113 191.567 219.369 191.567 219.673C191.567 220.313 191.319 220.817 190.823 221.185C190.335 221.545 189.651 221.725 188.771 221.725Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M195.967 221.725C195.287 221.725 194.699 221.621 194.203 221.413C193.707 221.197 193.319 220.909 193.039 220.549L193.939 219.733C194.195 220.013 194.487 220.229 194.815 220.381C195.151 220.533 195.539 220.609 195.979 220.609C196.363 220.609 196.671 220.545 196.903 220.417C197.135 220.289 197.251 220.093 197.251 219.829C197.251 219.605 197.171 219.453 197.011 219.373C196.859 219.293 196.655 219.233 196.399 219.193L195.403 219.037C195.147 218.997 194.895 218.941 194.647 218.869C194.407 218.789 194.191 218.681 193.999 218.545C193.815 218.409 193.667 218.237 193.555 218.029C193.443 217.813 193.387 217.553 193.387 217.249C193.387 216.601 193.627 216.105 194.107 215.761C194.595 215.417 195.263 215.245 196.111 215.245C196.711 215.245 197.219 215.329 197.635 215.497C198.059 215.665 198.407 215.901 198.679 216.205L197.875 217.093C197.699 216.901 197.463 216.733 197.167 216.589C196.879 216.437 196.511 216.361 196.063 216.361C195.279 216.361 194.887 216.605 194.887 217.093C194.887 217.317 194.967 217.473 195.127 217.561C195.287 217.641 195.495 217.701 195.751 217.741L196.735 217.897C196.999 217.937 197.251 217.997 197.491 218.077C197.739 218.149 197.955 218.253 198.139 218.389C198.331 218.525 198.483 218.697 198.595 218.905C198.707 219.113 198.763 219.369 198.763 219.673C198.763 220.313 198.515 220.817 198.019 221.185C197.531 221.545 196.847 221.725 195.967 221.725Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M203.33 221.725C202.834 221.725 202.394 221.649 202.01 221.497C201.626 221.345 201.302 221.129 201.038 220.849C200.782 220.569 200.586 220.233 200.45 219.841C200.314 219.441 200.246 218.993 200.246 218.497C200.246 217.993 200.314 217.541 200.45 217.141C200.594 216.741 200.794 216.401 201.05 216.121C201.306 215.841 201.614 215.625 201.974 215.473C202.342 215.321 202.754 215.245 203.21 215.245C203.658 215.245 204.062 215.321 204.422 215.473C204.782 215.617 205.086 215.825 205.334 216.097C205.59 216.369 205.786 216.697 205.922 217.081C206.058 217.465 206.126 217.889 206.126 218.353V218.857H201.782V219.013C201.782 219.461 201.922 219.825 202.202 220.105C202.482 220.377 202.874 220.513 203.378 220.513C203.762 220.513 204.09 220.437 204.362 220.285C204.642 220.125 204.874 219.917 205.058 219.661L205.934 220.537C205.71 220.865 205.382 221.145 204.95 221.377C204.526 221.609 203.986 221.725 203.33 221.725ZM203.222 216.373C202.79 216.373 202.442 216.509 202.178 216.781C201.914 217.053 201.782 217.413 201.782 217.861V217.945H204.59V217.837C204.59 217.389 204.466 217.033 204.218 216.769C203.978 216.505 203.646 216.373 203.222 216.373Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M207.225 221.581V215.389H208.497V216.241H208.569C208.665 215.969 208.801 215.737 208.977 215.545C209.161 215.345 209.417 215.245 209.745 215.245C210.057 215.245 210.305 215.337 210.489 215.521C210.673 215.697 210.793 215.949 210.849 216.277H210.909C211.013 215.997 211.165 215.757 211.365 215.557C211.573 215.349 211.865 215.245 212.241 215.245C212.697 215.245 213.025 215.409 213.225 215.737C213.425 216.065 213.525 216.549 213.525 217.189V221.581H212.265V217.369C212.265 217.009 212.213 216.757 212.109 216.613C212.013 216.469 211.865 216.397 211.665 216.397C211.481 216.397 211.325 216.457 211.197 216.577C211.077 216.697 211.017 216.881 211.017 217.129V221.581H209.745V217.369C209.745 217.009 209.697 216.757 209.601 216.613C209.505 216.469 209.357 216.397 209.157 216.397C208.965 216.397 208.805 216.457 208.677 216.577C208.557 216.697 208.497 216.881 208.497 217.129V221.581H207.225Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M214.805 212.701H216.341V216.481H216.425C216.593 216.105 216.821 215.805 217.109 215.581C217.405 215.357 217.793 215.245 218.273 215.245C218.625 215.245 218.945 215.313 219.233 215.449C219.529 215.577 219.781 215.777 219.989 216.049C220.197 216.313 220.357 216.649 220.469 217.057C220.581 217.465 220.637 217.941 220.637 218.485C220.637 219.029 220.581 219.505 220.469 219.913C220.357 220.321 220.197 220.661 219.989 220.933C219.781 221.197 219.529 221.397 219.233 221.533C218.945 221.661 218.625 221.725 218.273 221.725C217.793 221.725 217.405 221.613 217.109 221.389C216.821 221.165 216.593 220.865 216.425 220.489H216.341V221.581H214.805V212.701ZM217.625 220.501C218.073 220.501 218.417 220.365 218.657 220.093C218.905 219.821 219.029 219.449 219.029 218.977V217.993C219.029 217.521 218.905 217.149 218.657 216.877C218.417 216.605 218.073 216.469 217.625 216.469C217.273 216.469 216.969 216.557 216.713 216.733C216.465 216.901 216.341 217.161 216.341 217.513V219.457C216.341 219.809 216.465 220.073 216.713 220.249C216.969 220.417 217.273 220.501 217.625 220.501Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M222.036 220.369H224.004V213.913H222.036V212.701H225.54V220.369H227.52V221.581H222.036V220.369Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M233.659 215.389H235.219L232.255 222.685C232.087 223.109 231.863 223.429 231.583 223.645C231.303 223.869 230.907 223.981 230.395 223.981H229.267V222.769H230.743L231.211 221.521L228.715 215.389H230.347L231.295 217.981L231.955 219.949H232.039L232.699 217.981L233.659 215.389Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M181.984 230.429C181.624 230.429 181.368 230.353 181.216 230.201C181.072 230.049 181 229.865 181 229.649V229.361C181 229.145 181.072 228.961 181.216 228.809C181.368 228.657 181.624 228.581 181.984 228.581C182.344 228.581 182.596 228.657 182.74 228.809C182.892 228.961 182.968 229.145 182.968 229.361V229.649C182.968 229.865 182.892 230.049 182.74 230.201C182.596 230.353 182.344 230.429 181.984 230.429ZM179.176 236.369H181.216V232.601H179.176V231.389H182.752V236.369H184.648V237.581H179.176V236.369Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M186.095 237.581V231.389H187.631V232.481H187.691C187.827 232.145 188.035 231.857 188.315 231.617C188.603 231.369 188.999 231.245 189.503 231.245C190.111 231.245 190.603 231.449 190.979 231.857C191.363 232.257 191.555 232.833 191.555 233.585V237.581H190.019V233.801C190.019 232.905 189.631 232.457 188.855 232.457C188.695 232.457 188.543 232.477 188.399 232.517C188.255 232.557 188.123 232.621 188.003 232.709C187.891 232.789 187.799 232.889 187.727 233.009C187.663 233.129 187.631 233.273 187.631 233.441V237.581H186.095Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M200.414 231.389H201.95V232.481H202.034C202.202 232.105 202.43 231.805 202.718 231.581C203.014 231.357 203.402 231.245 203.882 231.245C204.234 231.245 204.554 231.313 204.842 231.449C205.138 231.577 205.39 231.777 205.598 232.049C205.806 232.313 205.966 232.649 206.078 233.057C206.19 233.465 206.246 233.941 206.246 234.485C206.246 235.029 206.19 235.505 206.078 235.913C205.966 236.321 205.806 236.661 205.598 236.933C205.39 237.197 205.138 237.397 204.842 237.533C204.554 237.661 204.234 237.725 203.882 237.725C203.402 237.725 203.014 237.613 202.718 237.389C202.43 237.165 202.202 236.865 202.034 236.489H201.95V239.981H200.414V231.389ZM203.234 236.501C203.682 236.501 204.026 236.365 204.266 236.093C204.514 235.821 204.638 235.449 204.638 234.977V233.993C204.638 233.521 204.514 233.149 204.266 232.877C204.026 232.605 203.682 232.469 203.234 232.469C202.882 232.469 202.578 232.557 202.322 232.733C202.074 232.901 201.95 233.161 201.95 233.513V235.457C201.95 235.809 202.074 236.073 202.322 236.249C202.578 236.417 202.882 236.501 203.234 236.501Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M207.681 236.369H209.217V232.601H207.681V231.389H210.753V233.081H210.849C210.905 232.865 210.981 232.657 211.077 232.457C211.181 232.249 211.309 232.069 211.461 231.917C211.621 231.757 211.813 231.629 212.037 231.533C212.261 231.437 212.529 231.389 212.841 231.389H213.513V232.829H212.241C211.777 232.829 211.413 232.965 211.149 233.237C210.885 233.509 210.753 233.857 210.753 234.281V236.369H212.901V237.581H207.681V236.369Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M217.577 237.725C217.105 237.725 216.681 237.649 216.305 237.497C215.937 237.345 215.621 237.129 215.357 236.849C215.101 236.569 214.901 236.229 214.757 235.829C214.621 235.429 214.553 234.981 214.553 234.485C214.553 233.989 214.621 233.541 214.757 233.141C214.901 232.741 215.101 232.401 215.357 232.121C215.621 231.841 215.937 231.625 216.305 231.473C216.681 231.321 217.105 231.245 217.577 231.245C218.041 231.245 218.461 231.321 218.837 231.473C219.213 231.625 219.529 231.841 219.785 232.121C220.049 232.401 220.249 232.741 220.385 233.141C220.529 233.541 220.601 233.989 220.601 234.485C220.601 234.981 220.529 235.429 220.385 235.829C220.249 236.229 220.049 236.569 219.785 236.849C219.529 237.129 219.213 237.345 218.837 237.497C218.461 237.649 218.041 237.725 217.577 237.725ZM217.577 236.549C218.017 236.549 218.365 236.417 218.621 236.153C218.877 235.881 219.005 235.485 219.005 234.965V234.005C219.005 233.485 218.877 233.093 218.621 232.829C218.365 232.557 218.017 232.421 217.577 232.421C217.137 232.421 216.789 232.557 216.533 232.829C216.277 233.093 216.149 233.485 216.149 234.005V234.965C216.149 235.485 216.277 235.881 216.533 236.153C216.789 236.417 217.137 236.549 217.577 236.549Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M228.084 238.229C228.084 238.877 227.812 239.353 227.268 239.657C226.732 239.969 225.892 240.125 224.748 240.125C224.188 240.125 223.72 240.089 223.344 240.017C222.968 239.953 222.664 239.857 222.432 239.729C222.208 239.601 222.048 239.445 221.952 239.261C221.856 239.085 221.808 238.885 221.808 238.661C221.808 238.317 221.908 238.053 222.108 237.869C222.308 237.685 222.588 237.549 222.948 237.461V237.365C222.708 237.285 222.516 237.173 222.372 237.029C222.236 236.885 222.168 236.685 222.168 236.429C222.168 236.125 222.268 235.897 222.468 235.745C222.676 235.593 222.948 235.477 223.284 235.397V235.337C222.916 235.161 222.628 234.913 222.42 234.593C222.212 234.273 222.108 233.885 222.108 233.429C222.108 233.085 222.168 232.781 222.288 232.517C222.416 232.245 222.592 232.017 222.816 231.833C223.048 231.641 223.324 231.497 223.644 231.401C223.964 231.297 224.32 231.245 224.712 231.245C225.128 231.245 225.504 231.301 225.84 231.413V231.149C225.84 230.909 225.916 230.709 226.068 230.549C226.228 230.389 226.448 230.309 226.728 230.309H227.844V231.461H226.38V231.665C226.684 231.849 226.916 232.089 227.076 232.385C227.244 232.673 227.328 233.021 227.328 233.429C227.328 233.773 227.264 234.081 227.136 234.353C227.016 234.625 226.84 234.853 226.608 235.037C226.384 235.221 226.108 235.365 225.78 235.469C225.46 235.565 225.104 235.613 224.712 235.613C224.552 235.613 224.396 235.609 224.244 235.601C224.1 235.585 223.96 235.557 223.824 235.517C223.712 235.557 223.604 235.621 223.5 235.709C223.396 235.797 223.344 235.913 223.344 236.057C223.344 236.249 223.436 236.369 223.62 236.417C223.804 236.457 224.024 236.477 224.28 236.477H225.684C226.116 236.477 226.484 236.521 226.788 236.609C227.092 236.689 227.34 236.809 227.532 236.969C227.724 237.121 227.864 237.305 227.952 237.521C228.04 237.737 228.084 237.973 228.084 238.229ZM226.644 238.337C226.644 238.153 226.568 238.005 226.416 237.893C226.272 237.789 226 237.737 225.6 237.737H223.464C223.224 237.873 223.104 238.073 223.104 238.337C223.104 238.553 223.192 238.733 223.368 238.877C223.552 239.021 223.86 239.093 224.292 239.093H225.288C226.192 239.093 226.644 238.841 226.644 238.337ZM224.712 234.605C225.104 234.605 225.392 234.513 225.576 234.329C225.76 234.137 225.852 233.889 225.852 233.585V233.273C225.852 232.969 225.76 232.725 225.576 232.541C225.392 232.349 225.104 232.253 224.712 232.253C224.328 232.253 224.044 232.349 223.86 232.541C223.676 232.725 223.584 232.969 223.584 233.273V233.585C223.584 233.889 223.676 234.137 223.86 234.329C224.044 234.513 224.328 234.605 224.712 234.605Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M229.267 236.369H230.803V232.601H229.267V231.389H232.339V233.081H232.435C232.491 232.865 232.567 232.657 232.663 232.457C232.767 232.249 232.895 232.069 233.047 231.917C233.207 231.757 233.399 231.629 233.623 231.533C233.847 231.437 234.115 231.389 234.427 231.389H235.099V232.829H233.827C233.363 232.829 232.999 232.965 232.735 233.237C232.471 233.509 232.339 233.857 232.339 234.281V236.369H234.487V237.581H229.267V236.369Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M239.306 237.725C238.81 237.725 238.37 237.649 237.986 237.497C237.602 237.345 237.278 237.129 237.014 236.849C236.758 236.569 236.562 236.233 236.426 235.841C236.29 235.441 236.222 234.993 236.222 234.497C236.222 233.993 236.29 233.541 236.426 233.141C236.57 232.741 236.77 232.401 237.026 232.121C237.282 231.841 237.59 231.625 237.95 231.473C238.318 231.321 238.73 231.245 239.186 231.245C239.634 231.245 240.038 231.321 240.398 231.473C240.758 231.617 241.062 231.825 241.31 232.097C241.566 232.369 241.762 232.697 241.898 233.081C242.035 233.465 242.102 233.889 242.102 234.353V234.857H237.758V235.013C237.758 235.461 237.898 235.825 238.178 236.105C238.458 236.377 238.85 236.513 239.354 236.513C239.738 236.513 240.066 236.437 240.338 236.285C240.618 236.125 240.85 235.917 241.034 235.661L241.91 236.537C241.686 236.865 241.358 237.145 240.926 237.377C240.502 237.609 239.962 237.725 239.306 237.725ZM239.198 232.373C238.766 232.373 238.418 232.509 238.154 232.781C237.89 233.053 237.758 233.413 237.758 233.861V233.945H240.566V233.837C240.566 233.389 240.442 233.033 240.194 232.769C239.954 232.505 239.622 232.373 239.198 232.373Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M246.334 237.725C245.654 237.725 245.066 237.621 244.57 237.413C244.074 237.197 243.686 236.909 243.406 236.549L244.306 235.733C244.562 236.013 244.854 236.229 245.182 236.381C245.518 236.533 245.906 236.609 246.346 236.609C246.73 236.609 247.038 236.545 247.27 236.417C247.502 236.289 247.618 236.093 247.618 235.829C247.618 235.605 247.538 235.453 247.378 235.373C247.226 235.293 247.022 235.233 246.766 235.193L245.77 235.037C245.514 234.997 245.262 234.941 245.014 234.869C244.774 234.789 244.558 234.681 244.366 234.545C244.182 234.409 244.034 234.237 243.922 234.029C243.81 233.813 243.754 233.553 243.754 233.249C243.754 232.601 243.994 232.105 244.474 231.761C244.962 231.417 245.63 231.245 246.478 231.245C247.078 231.245 247.586 231.329 248.002 231.497C248.426 231.665 248.774 231.901 249.046 232.205L248.242 233.093C248.066 232.901 247.83 232.733 247.534 232.589C247.246 232.437 246.878 232.361 246.43 232.361C245.646 232.361 245.254 232.605 245.254 233.093C245.254 233.317 245.334 233.473 245.494 233.561C245.654 233.641 245.862 233.701 246.118 233.741L247.102 233.897C247.366 233.937 247.618 233.997 247.858 234.077C248.106 234.149 248.322 234.253 248.506 234.389C248.698 234.525 248.85 234.697 248.962 234.905C249.074 235.113 249.13 235.369 249.13 235.673C249.13 236.313 248.882 236.817 248.386 237.185C247.898 237.545 247.214 237.725 246.334 237.725Z",
    fill: "#CEE4F3"
  }), React.createElement("path", {
    d: "M253.529 237.725C252.849 237.725 252.261 237.621 251.765 237.413C251.269 237.197 250.881 236.909 250.601 236.549L251.501 235.733C251.757 236.013 252.049 236.229 252.377 236.381C252.713 236.533 253.101 236.609 253.541 236.609C253.925 236.609 254.233 236.545 254.465 236.417C254.697 236.289 254.813 236.093 254.813 235.829C254.813 235.605 254.733 235.453 254.573 235.373C254.421 235.293 254.217 235.233 253.961 235.193L252.965 235.037C252.709 234.997 252.457 234.941 252.209 234.869C251.969 234.789 251.753 234.681 251.561 234.545C251.377 234.409 251.229 234.237 251.117 234.029C251.005 233.813 250.949 233.553 250.949 233.249C250.949 232.601 251.189 232.105 251.669 231.761C252.157 231.417 252.825 231.245 253.673 231.245C254.273 231.245 254.781 231.329 255.197 231.497C255.621 231.665 255.969 231.901 256.241 232.205L255.437 233.093C255.261 232.901 255.025 232.733 254.729 232.589C254.441 232.437 254.073 232.361 253.625 232.361C252.841 232.361 252.449 232.605 252.449 233.093C252.449 233.317 252.529 233.473 252.689 233.561C252.849 233.641 253.057 233.701 253.313 233.741L254.297 233.897C254.561 233.937 254.813 233.997 255.053 234.077C255.301 234.149 255.517 234.253 255.701 234.389C255.893 234.525 256.045 234.697 256.157 234.905C256.269 235.113 256.325 235.369 256.325 235.673C256.325 236.313 256.077 236.817 255.581 237.185C255.093 237.545 254.409 237.725 253.529 237.725Z",
    fill: "#CEE4F3"
  }), React.createElement("g", {
    clipPath: "url(#clip1_202_9308)"
  }, React.createElement("path", {
    d: "M185 298.581C180 295.581 134.134 277.812 132.467 275.197C132.77 271.35 133.315 270.043 128.01 267.889C121.948 265.581 109.064 262.889 104.214 267.504C104.214 269.043 104.214 270.581 104.214 272.12C98.9093 270.889 97.6968 269.504 98.1515 276.274C96.7874 289.966 116.34 285.812 125.282 287.658C132.709 288.735 181.514 318.581 185.151 305.197C185 302.889 185 300.735 185 298.581Z",
    fill: "#2E7DAF"
  }), React.createElement("path", {
    d: "M177.725 301.658C168.631 302.428 129.223 279.043 119.826 279.812C112.399 280.428 99.061 279.812 98 271.966C98.3031 271.197 99.9704 271.197 100.88 271.351C104.669 272.274 114.369 275.966 116.037 270.581C86.784 265.351 121.038 263.043 128.01 267.043C136.801 270.274 130.89 274.12 134.831 276.274L182.272 295.812C188.031 298.428 183.787 301.658 177.725 301.658Z",
    fill: "url(#paint28_radial_202_9308)"
  })), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.081 148.041) rotate(86.1122) scale(86.7823 86.5379)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(343.129 67.5062) rotate(86.6736) scale(109.609 93.5934)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.761 154.049) rotate(83.6544) scale(107.91 174.736)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_202_9308",
    x1: "61.3493",
    y1: "136.605",
    x2: "96.5996",
    y2: "152.427",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_202_9308",
    x1: "366.344",
    y1: "54.0429",
    x2: "401.594",
    y2: "69.8649",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.464 51.3225) rotate(84.3253) scale(29.5131 42.8073)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(309.608 109.077) rotate(68.8162) scale(4.4329 22.0175)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.009 100.813) rotate(85.9687) scale(19.6275 20.2897)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_202_9308",
    x1: "313.13",
    y1: "101.044",
    x2: "329.287",
    y2: "108.296",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.254 67.7106) rotate(84.026) scale(82.8994 126.493)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.867 43.0691) rotate(-35.2077) scale(5.06019 35.1383)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.722 100.813) rotate(85.9687) scale(19.6275 20.2898)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.295 112.704) rotate(-111.184) scale(4.43289 22.0175)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_202_9308",
    x1: "136.921",
    y1: "101.044",
    x2: "153.077",
    y2: "108.296",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_202_9308",
    x1: "225.23",
    y1: "6.22152",
    x2: "241.387",
    y2: "13.4733",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_202_9308",
    x1: "201.606",
    y1: "83.3204",
    x2: "221.699",
    y2: "90.8845",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_202_9308",
    x1: "241.876",
    y1: "83.3204",
    x2: "261.97",
    y2: "90.8845",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_202_9308",
    x1: "243.69",
    y1: "230.844",
    x2: "254.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_202_9308",
    x1: "250.69",
    y1: "230.844",
    x2: "261.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_202_9308",
    x1: "257.69",
    y1: "230.844",
    x2: "268.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint20_linear_202_9308",
    x1: "264.69",
    y1: "230.844",
    x2: "275.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_202_9308",
    x1: "271.69",
    y1: "230.844",
    x2: "282.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint22_linear_202_9308",
    x1: "278.69",
    y1: "230.844",
    x2: "289.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_202_9308",
    x1: "285.69",
    y1: "230.844",
    x2: "296.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_202_9308",
    x1: "292.69",
    y1: "230.844",
    x2: "303.754",
    y2: "220.587",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("radialGradient", {
    id: "paint25_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.336 189.305) rotate(88.6715) scale(109.454 37.397)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint26_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.048 157.424) rotate(88.6715) scale(109.454 37.397)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint27_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.3587 204.844) rotate(82.6607) scale(38.2261 71.3929)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint28_radial_202_9308",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.125 263.242) rotate(80.1872) scale(39.6057 98.0457)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("clipPath", {
    id: "clip0_202_9308"
  }, React.createElement("rect", {
    width: "63",
    height: "40",
    fill: "white",
    transform: "translate(24 206.581)"
  })), React.createElement("clipPath", {
    id: "clip1_202_9308"
  }, React.createElement("rect", {
    width: "87",
    height: "44",
    fill: "white",
    transform: "translate(98 264.581)"
  }))));
};

var confirmed = function confirmed(width, height) {
  if (width === void 0) {
    width = '491';
  }

  if (height === void 0) {
    height = '329';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 491 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M189.762 64.7126C181.111 72.8261 147.059 69.4147 133.438 54.9394C119.817 40.4641 131.966 20.4569 140.525 12.3434C149.176 4.22986 167.122 9.39301 180.743 23.7761C194.363 38.3436 198.321 56.599 189.762 64.7126Z",
    fill: "url(#paint0_linear_322_19075)"
  }), React.createElement("path", {
    d: "M90.1823 58.3506C92.7591 63.2372 87.1452 78.1735 79.0464 82.5068C70.9476 86.8402 63.4009 79.0033 60.824 74.2089C58.2471 69.3223 62.6647 61.8542 70.8555 57.5208C79.0464 53.1875 87.6054 53.4641 90.1823 58.3506Z",
    fill: "url(#paint1_linear_322_19075)"
  }), React.createElement("path", {
    d: "M403.553 187.338C403.553 260.913 345.112 333.935 211.942 319.091C122.947 309.133 60.181 246.438 60.181 172.77C60.181 123.167 78.5874 79.9258 120.738 74.6704C141.169 72.1811 165.006 77.3442 199.149 97.3514C298.544 155.714 403.553 113.763 403.553 187.338Z",
    fill: "url(#paint2_radial_322_19075)"
  }), React.createElement("path", {
    d: "M152.027 279.353C150.186 253.537 175.403 240.721 179.36 215.92C182.489 191.026 165.463 176.09 151.751 157.558C134.357 133.678 140.062 99.8409 159.941 79.1883C32.2009 40.5568 21.8013 259.714 158.469 305.076C154.696 297.055 152.763 288.388 152.027 279.353Z",
    fill: "url(#paint3_linear_322_19075)"
  }), React.createElement("path", {
    d: "M105.735 264.416C107.3 262.296 108.68 259.991 109.876 257.686C110.337 256.303 110.705 254.827 110.981 253.352C111.257 248.742 111.073 244.132 110.613 239.522C108.312 225.693 103.894 212.324 100.397 198.77C93.8629 173.784 91.8382 147.969 98.0964 122.706C101.41 109.429 107.484 97.4434 116.319 87.0249C120.46 82.1383 125.89 77.8972 131.504 74.9468C131.688 74.8546 131.872 74.7624 132.056 74.6702C49.8716 74.0248 35.6066 200.153 101.594 269.211C102.974 267.643 104.355 266.076 105.735 264.416Z",
    fill: "url(#paint4_linear_322_19075)"
  }), React.createElement("path", {
    d: "M353.67 139.302C349.897 141.699 346.123 144.004 342.258 146.217C336.368 149.628 330.386 152.671 324.864 156.543C319.71 160.876 314.74 165.671 310.415 170.834C308.666 173.323 307.194 175.905 305.813 178.579C305.077 180.884 304.433 183.096 303.973 185.494C303.696 189.182 303.788 192.869 304.157 196.65C305.721 205.593 308.39 214.352 311.335 222.926C315.108 233.898 319.434 244.685 321.551 256.21C324.68 273.175 325.232 289.955 320.998 306.92C320.998 307.012 320.906 307.104 320.906 307.197C377.782 284.516 403.643 236.664 403.643 187.522C403.551 155.621 383.948 145.295 353.67 139.302Z",
    fill: "url(#paint5_linear_322_19075)"
  }), React.createElement("path", {
    d: "M370.602 266.26C364.712 255.196 374.835 222.742 391.217 213.891C407.599 205.04 424.072 223.203 429.962 234.267C435.852 245.331 427.386 261.373 411.004 270.224C394.622 279.076 376.492 277.232 370.602 266.26Z",
    fill: "url(#paint6_linear_322_19075)"
  }), React.createElement("path", {
    d: "M367.84 112.354L226.203 228.708C214.975 237.931 196.752 237.931 185.525 228.708L155.706 204.212L117.697 172.988L117.237 173.366C110.979 178.507 110.979 186.824 117.237 191.965L155.614 223.491L185.432 247.987C196.66 257.21 214.883 257.21 226.111 247.987L368.3 131.331C374.558 126.19 374.558 117.873 368.3 112.732L367.84 112.354Z",
    fill: "#B7E803"
  }), React.createElement("path", {
    opacity: "0.16",
    d: "M367.84 112.354L226.203 228.708C214.975 237.931 196.752 237.931 185.525 228.708L155.706 204.212L117.697 172.988L117.237 173.366C110.979 178.507 110.979 186.824 117.237 191.965L155.614 223.491L185.432 247.987C196.66 257.21 214.883 257.21 226.111 247.987L368.3 131.331C374.558 126.19 374.558 117.873 368.3 112.732L367.84 112.354Z",
    fill: "url(#paint7_linear_322_19075)"
  }), React.createElement("path", {
    d: "M185.616 228.708C196.844 237.932 215.066 237.932 226.294 228.708L367.932 112.354L340.874 90.127C334.616 84.986 324.493 84.986 318.234 90.127L212.213 177.146C208.716 180.019 203.102 180.019 199.605 177.146L167.486 150.761C161.228 145.62 151.104 145.62 144.846 150.761L117.789 172.988L155.798 204.212L185.616 228.708Z",
    fill: "url(#paint8_linear_322_19075)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_322_19075",
    x1: "127.29",
    y1: "38.7857",
    x2: "194.277",
    y2: "38.7857",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A4E9D9"
  }), React.createElement("stop", {
    offset: "0.4009",
    stopColor: "#81D7CC"
  }), React.createElement("stop", {
    offset: "0.7779",
    stopColor: "#66C9C3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#5CC4BF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_322_19075",
    x1: "60.086",
    y1: "69.064",
    x2: "90.8682",
    y2: "69.064",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A4E9D9"
  }), React.createElement("stop", {
    offset: "0.4009",
    stopColor: "#81D7CC"
  }), React.createElement("stop", {
    offset: "0.7779",
    stopColor: "#66C9C3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#5CC4BF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_322_19075",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.08 258.377) scale(234.999 235.426)"
  }, React.createElement("stop", {
    stopColor: "#5CC4BF"
  }), React.createElement("stop", {
    offset: "0.2221",
    stopColor: "#66C9C3"
  }), React.createElement("stop", {
    offset: "0.5991",
    stopColor: "#81D7CC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E9D9"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_322_19075",
    x1: "57.8677",
    y1: "178.948",
    x2: "182.108",
    y2: "194.095",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A4E9D9"
  }), React.createElement("stop", {
    offset: "0.4009",
    stopColor: "#81D7CC"
  }), React.createElement("stop", {
    offset: "0.7779",
    stopColor: "#66C9C3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#5CC4BF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_322_19075",
    x1: "165.874",
    y1: "218.35",
    x2: "2.3236",
    y2: "64.2676",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A4E9D9"
  }), React.createElement("stop", {
    offset: "0.4009",
    stopColor: "#81D7CC"
  }), React.createElement("stop", {
    offset: "0.7779",
    stopColor: "#66C9C3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#5CC4BF"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_322_19075",
    x1: "460.367",
    y1: "287.901",
    x2: "314.706",
    y2: "207.712",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A4E9D9"
  }), React.createElement("stop", {
    offset: "0.4009",
    stopColor: "#81D7CC"
  }), React.createElement("stop", {
    offset: "0.7779",
    stopColor: "#66C9C3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#5CC4BF"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_322_19075",
    x1: "368.892",
    y1: "243.683",
    x2: "431.876",
    y2: "243.683",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A4E9D9"
  }), React.createElement("stop", {
    offset: "0.4009",
    stopColor: "#81D7CC"
  }), React.createElement("stop", {
    offset: "0.7779",
    stopColor: "#66C9C3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#5CC4BF"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_322_19075",
    x1: "112.667",
    y1: "183.64",
    x2: "372.989",
    y2: "183.64",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3BBFFF"
  }), React.createElement("stop", {
    offset: "0.2913",
    stopColor: "#2F93F0"
  }), React.createElement("stop", {
    offset: "0.6027",
    stopColor: "#256BE2"
  }), React.createElement("stop", {
    offset: "0.8498",
    stopColor: "#1E52D9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1C49D6"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_322_19075",
    x1: "128.941",
    y1: "174.652",
    x2: "347.428",
    y2: "186.013",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D5F364"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B7E803"
  }))));
};

var looking = function looking(width, height) {
  if (width === void 0) {
    width = '323';
  }

  if (height === void 0) {
    height = '391';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 323 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    opacity: "0.7",
    d: "M292.365 226.24C301.592 150.424 247.556 81.4911 171.672 72.2729C95.7889 63.0547 26.7939 117.042 17.5674 192.858C8.34092 268.673 62.377 337.607 138.26 346.825C214.144 356.043 283.139 302.055 292.365 226.24Z",
    fill: "#21BF96"
  }), React.createElement("g", {
    clipPath: "url(#clip0_461_44785)"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M152.134 389.706C186.658 386.777 213.866 376.174 212.968 366.026C212.027 355.877 183.321 350.018 148.797 352.948C114.316 355.877 87.1072 366.479 88.0056 376.628C88.904 386.777 117.653 392.635 152.134 389.706Z",
    fill: "url(#paint0_radial_461_44785)"
  }), React.createElement("path", {
    d: "M281.162 270.684C247.664 280.915 217.59 236.978 194.317 232.233C176.221 228.562 163.472 242.919 169.932 258.059C166.509 254.553 166.338 253.893 163.044 251.5C160.477 233.925 173.697 218.702 198.381 223.735C224.948 229.139 250.616 265.362 275.686 257.688L281.162 270.684Z",
    fill: "url(#paint1_linear_461_44785)"
  }), React.createElement("path", {
    d: "M169.802 257.853C169.845 257.936 169.845 258.019 169.888 258.061C169.845 258.019 169.845 258.019 169.802 257.978C169.802 257.978 169.802 257.895 169.802 257.853Z",
    fill: "url(#paint2_linear_461_44785)"
  }), React.createElement("path", {
    d: "M281.16 270.685C280.818 270.808 280.476 270.85 280.091 270.973L277.182 264.125C252.07 271.799 226.444 235.576 199.877 230.172C177.802 225.675 164.882 237.35 164.241 252.491C163.856 252.202 163.471 251.913 163 251.542C160.433 233.967 173.653 218.744 198.337 223.777C224.904 229.182 250.572 265.404 275.642 257.73L281.16 270.685Z",
    fill: "#123161"
  }), React.createElement("path", {
    d: "M285.952 254.099C285.438 251.046 280.262 252.779 275.727 254.883C271.406 256.863 266.144 260.411 265.759 265.238L267.77 264.908C268.241 262.804 275.856 260.617 278.166 259.957C281.674 258.967 286.508 257.152 285.952 254.099Z",
    fill: "url(#paint3_radial_461_44785)"
  }), React.createElement("path", {
    d: "M271.535 259.71L277.182 253.769L285.396 269.157L278.38 271.096C274.187 268.91 271.706 265.609 271.535 259.71Z",
    fill: "url(#paint4_radial_461_44785)"
  }), React.createElement("path", {
    d: "M291.855 259.215C293.438 262.02 288.39 264.578 283.599 266.476C279.021 268.25 273.588 264.99 270.166 261.566L271.92 260.287C273.631 261.566 280.048 261.896 282.144 260.659C285.438 258.72 290.273 256.409 291.855 259.215Z",
    fill: "url(#paint5_radial_461_44785)"
  }), React.createElement("path", {
    d: "M275.385 247.292C274.7 244.28 269.609 246.26 265.16 248.529C260.925 250.716 259.257 256.904 259.085 261.731L261.096 261.319C261.438 259.215 265.588 254.223 267.813 253.48C271.321 252.366 276.069 250.345 275.385 247.292Z",
    fill: "url(#paint6_radial_461_44785)"
  }), React.createElement("path", {
    d: "M154.573 355.794C154.573 355.794 117.525 337.023 108.156 325.719C99.728 304.513 83.9847 251.83 92.5408 205.087C92.5408 205.087 117.953 187.1 170.102 188.255C215.407 189.245 233.418 204.138 233.418 204.138C233.418 204.138 232.348 280.131 205.824 334.795C183.45 348.12 154.573 355.794 154.573 355.794Z",
    fill: "url(#paint7_radial_461_44785)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M140.755 224.271C140.755 224.271 117.525 337.023 108.156 325.719C99.728 304.513 83.9847 251.83 92.5408 205.087C92.5408 205.087 117.953 187.1 170.102 188.255C215.407 189.245 233.418 204.138 233.418 204.138L140.755 224.271Z",
    fill: "url(#paint8_radial_461_44785)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M205.824 333.434L154.572 355.794L233.417 204.139C228.668 250.923 221.225 295.438 205.824 333.434Z",
    fill: "url(#paint9_radial_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.557 249.149L225.289 267.59L221.225 282.608L191.492 264.166L195.557 249.149Z",
    fill: "url(#paint10_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.599 248.984L200.648 248.736L229.054 265.899L225.033 282.112L221.353 282.648L221.268 282.483L225.289 267.549L195.813 249.273C195.685 249.149 195.599 248.984 195.599 248.984Z",
    fill: "url(#paint11_radial_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.396 235.494L259.128 253.935L255.064 268.952L225.332 250.552L229.396 235.494Z",
    fill: "url(#paint12_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.439 235.37L234.487 235.081L262.893 252.243L258.872 268.457L255.15 268.993L255.064 268.869L259.086 253.893L229.61 235.658C229.524 235.493 229.439 235.37 229.439 235.37Z",
    fill: "url(#paint13_radial_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.124 262.433L263.792 244.281C263.792 244.281 305.76 269.941 306.145 274.108C306.53 278.275 300.455 300.883 297.888 306.948C295.364 312.971 275.6 319.077 275.6 319.077L243.985 312.022L203.087 286.939C203.129 286.98 200.434 275.8 206.124 262.433Z",
    fill: "#123161"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.187 275.016C305.888 280.833 300.327 301.254 297.931 306.989C295.407 313.012 275.642 319.118 275.642 319.118L244.241 312.146L249.631 291.188L306.187 275.016Z",
    fill: "#123161"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.038 293.87C300.498 299.398 298.958 304.514 297.888 306.948C295.364 312.971 275.599 319.077 275.599 319.077L243.984 312.022L203.086 286.939C203.086 286.939 200.434 276.089 205.91 262.887C212.669 267.755 238.423 286.237 247.535 290.28C258.059 294.942 276.113 302.987 276.113 302.987L302.038 293.87Z",
    fill: "url(#paint14_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.038 293.87C300.498 299.398 298.958 304.514 297.888 306.948C295.364 312.971 275.599 319.077 275.599 319.077L244.198 312.105L249.546 291.229C260.198 295.974 276.07 302.987 276.07 302.987L302.038 293.87Z",
    fill: "url(#paint15_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.904 317.798C271.193 313.425 274.958 303.895 276.54 301.956C278.123 300.017 298.23 290.858 302.166 293.004C302.893 293.416 305.631 295.561 306.958 296.964C312.776 303.111 322.572 316.726 321.417 320.232C319.963 324.523 308.369 334.383 304.134 332.774C300.327 331.33 274.444 321.8 272.904 317.798Z",
    fill: "url(#paint16_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.043 297.005C308.369 298.408 309.824 300.141 311.364 302.08C306.872 302.121 302.936 302.864 299.342 304.184C295.193 305.752 291.514 308.186 288.048 311.362C284.797 314.291 282.829 318.706 281.246 323.285C279.407 322.378 277.695 321.511 276.369 320.686C278.123 315.777 280.391 310.991 284.284 307.484C288.262 303.854 292.54 301.09 297.375 299.233C300.369 298.161 303.578 297.377 307.043 297.005ZM316.455 309.011C317.695 310.826 318.808 312.6 319.621 314.25C317.952 314.126 310.252 313.961 303.834 320.108C300.883 322.955 298.744 326.668 297.289 330.175C295.749 329.556 294.038 328.896 292.241 328.153C293.952 324.11 296.433 319.737 299.941 316.354C305.674 310.867 312.262 309.341 316.455 309.011Z",
    fill: "url(#paint17_linear_461_44785)"
  }), React.createElement("path", {
    d: "M156.54 310.99C151.963 303.069 146.872 277.615 151.492 223.817C109.952 226.045 92.5404 205.087 92.5404 205.087C83.9842 251.83 99.7275 304.513 108.155 325.719C117.567 337.023 154.572 355.794 154.572 355.794C154.572 355.794 183.407 348.12 205.738 334.877C207.792 331.371 209.631 328.029 210.401 323.408C194.144 322.006 159.834 316.642 156.54 310.99Z",
    fill: "url(#paint18_radial_461_44785)"
  }), React.createElement("path", {
    d: "M149.31 223.941C144.433 280.132 146.572 306.906 151.236 314.662C154.53 320.191 191.834 324.523 209.759 326.132C210.016 325.265 210.23 324.358 210.401 323.367C194.102 321.965 159.834 316.601 156.54 310.908C151.963 302.987 146.872 277.532 151.492 223.735C150.765 223.859 150.038 223.9 149.31 223.941Z",
    fill: "url(#paint19_radial_461_44785)"
  }), React.createElement("path", {
    d: "M163 356.165C160.348 355.299 152.433 342.386 152.433 342.386L159.022 335.455C164.883 328.606 186.444 327.658 188.54 334.341C189.866 338.755 167.449 357.65 163 356.165Z",
    fill: "#C6A98D"
  }), React.createElement("path", {
    d: "M173.481 337.766C178.615 335.703 183.749 334.589 188.455 334.259C186.145 327.699 164.84 328.648 159.022 335.455L152.433 342.386C152.433 342.386 154.444 345.646 156.754 348.987C160.647 344.614 166.465 340.571 173.481 337.766Z",
    fill: "#AF8461"
  }), React.createElement("path", {
    d: "M175.92 356.537C176.947 346.182 171.086 339.127 163 338.385C154.957 337.642 147.77 343.5 146.744 353.814C145.717 364.169 151.578 371.224 159.663 371.967C167.706 372.709 174.85 366.851 175.92 356.537Z",
    fill: "#123161"
  }), React.createElement("path", {
    d: "M174.765 361.694C171.128 361.859 167.963 357.692 167.706 352.411C167.492 347.997 169.417 344.202 172.155 343.005C169.845 340.365 166.637 338.715 163 338.385C154.957 337.642 147.77 343.5 146.744 353.814C145.717 364.169 151.578 371.224 159.663 371.967C166.251 372.585 172.241 368.79 174.765 361.694Z",
    fill: "url(#paint20_linear_461_44785)"
  }), React.createElement("path", {
    d: "M166.722 354.597C167.364 348.203 163.984 343.871 159.278 343.458C154.615 343.005 150.423 346.676 149.781 353.03C149.139 359.424 152.562 363.756 157.225 364.169C161.888 364.623 166.08 360.992 166.722 354.597Z",
    fill: "url(#paint21_radial_461_44785)"
  }), React.createElement("path", {
    d: "M159.621 355.217C159.877 352.576 158.465 350.761 156.54 350.596C154.615 350.431 152.861 351.916 152.605 354.556C152.348 357.197 153.76 359.012 155.685 359.177C157.61 359.342 159.364 357.857 159.621 355.217Z",
    fill: "#123161"
  }), React.createElement("path", {
    d: "M156.155 355.794C162.915 356.578 177.374 325.1 177.374 325.1C177.374 325.1 116.369 308.639 108.369 326.049C113.546 333.268 144.177 354.391 156.155 355.794Z",
    fill: "url(#paint22_radial_461_44785)"
  }), React.createElement("path", {
    d: "M145.802 311.444C141.225 303.523 136.134 278.068 140.754 224.271C109.268 222.786 92.5404 205.087 92.5404 205.087C83.9842 251.83 99.7275 304.513 108.155 325.719C117.567 337.023 154.572 355.794 154.572 355.794C154.572 355.794 183.407 348.12 205.738 334.877C207.792 331.371 209.631 328.029 210.401 323.408C194.144 322.006 149.096 317.096 145.802 311.444Z",
    fill: "url(#paint23_linear_461_44785)"
  }), React.createElement("path", {
    d: "M93.7384 240.774C92.8827 220.806 94.6368 216.928 97.717 202.117C94.2517 203.891 92.5405 205.088 92.5405 205.088C83.9844 251.83 108.327 325.925 108.412 326.008C113.246 332.732 140.284 351.628 153.589 355.258C154.23 355.588 154.615 355.794 154.615 355.794C154.615 355.794 154.829 355.753 155.171 355.629C155.514 355.712 155.856 355.753 156.198 355.794C157.139 355.918 158.209 355.382 159.364 354.433C127.45 324.028 98.487 352.453 93.7384 240.774Z",
    fill: "url(#paint24_radial_461_44785)"
  }), React.createElement("path", {
    d: "M129.461 246.673C129.333 234.874 123.771 226.995 117.482 227.077C111.194 227.16 106.531 235.163 106.702 247.004C106.83 258.803 112.049 268.333 118.338 268.25C124.627 268.126 129.632 258.473 129.461 246.673Z",
    fill: "url(#paint25_linear_461_44785)"
  }), React.createElement("path", {
    d: "M119.108 243.332C122.83 243.166 126.381 244.28 129.461 246.302C129.204 234.709 123.728 226.994 117.482 227.036C111.194 227.118 106.531 235.122 106.702 246.962C106.702 247.787 106.744 248.571 106.787 249.355C110.124 245.807 114.359 243.538 119.108 243.332Z",
    fill: "url(#paint26_linear_461_44785)"
  }), React.createElement("path", {
    d: "M126.893 247.499C126.807 238.835 122.786 233.018 118.294 233.059C113.802 233.1 110.465 239 110.551 247.705C110.679 256.369 114.401 263.382 118.893 263.299C123.428 263.258 126.979 256.162 126.893 247.499Z",
    fill: "url(#paint27_linear_461_44785)"
  }), React.createElement("path", {
    d: "M109.695 294.983C102.936 276.501 108.07 255.131 123.214 245.105C125.866 244.817 127.449 248.076 125.31 249.974C116.583 255.254 112.134 277.656 117.096 291.188C124.112 310.331 151.449 318.293 220.711 293.292L224.348 305.421C183.963 319.984 125.524 338.178 109.695 294.983Z",
    fill: "#123161"
  }), React.createElement("path", {
    d: "M119.107 248.365C112.861 256.657 103.62 273.943 107.428 284.917C108.155 287.021 115.514 288.672 116.84 290.528C112.219 276.955 116.711 255.172 125.268 249.933C127.449 248.035 125.866 244.776 123.171 245.065C121.759 246.096 120.391 247.21 119.107 248.365Z",
    fill: "url(#paint28_linear_461_44785)"
  }), React.createElement("path", {
    d: "M221.909 297.335C184.476 310.248 130.315 327.452 110.636 297.253C127.663 337.601 184.69 319.696 224.305 305.38L221.909 297.335Z",
    fill: "url(#paint29_linear_461_44785)"
  }), React.createElement("path", {
    d: "M220.925 307.113L228.241 307.526L223.492 290.652L217.888 294.117C216.647 298.656 217.246 302.74 220.925 307.113Z",
    fill: "url(#paint30_linear_461_44785)"
  }), React.createElement("path", {
    d: "M225.674 307.525H227C227.642 307.525 228.069 306.865 227.898 306.205L223.791 291.601C223.663 291.064 223.15 290.776 222.679 290.941L221.567 291.271C221.224 291.353 221.011 291.683 220.925 292.013C220.027 296.428 221.695 302.946 225.032 307.154C225.16 307.402 225.417 307.525 225.674 307.525Z",
    fill: "url(#paint31_radial_461_44785)"
  }), React.createElement("path", {
    d: "M239.15 281.74C238.337 278.605 233.545 280.214 229.353 282.194C225.674 283.927 221.652 288.878 221.524 293.498C221.524 294.117 221.995 294.612 222.551 294.53L222.765 294.488C223.107 294.447 223.406 294.158 223.535 293.828C224.262 291.559 230.209 287.929 232.134 287.434C235.471 286.526 239.963 284.835 239.15 281.74Z",
    fill: "url(#paint32_radial_461_44785)"
  }), React.createElement("path", {
    d: "M245.353 303.895C246.85 306.577 242.444 308.639 238.166 310.042C234.486 311.28 227.385 308.227 224.176 305.215C223.706 304.761 223.749 303.978 224.262 303.606L224.305 303.565C224.561 303.359 224.904 303.359 225.203 303.524C227.214 304.638 234.872 305.545 236.626 304.638C239.577 303.029 243.855 301.213 245.353 303.895Z",
    fill: "url(#paint33_radial_461_44785)"
  }), React.createElement("path", {
    d: "M244.882 293.045C246.508 295.644 242.187 297.913 237.994 299.563C234.444 300.966 227 301.585 223.62 299.439C223.021 299.068 223.021 298.16 223.535 297.748C223.749 297.583 224.048 297.5 224.305 297.583C226.358 298.16 234.486 295.231 236.198 294.159C239.064 292.508 243.256 290.446 244.882 293.045Z",
    fill: "url(#paint34_radial_461_44785)"
  }), React.createElement("path", {
    d: "M164.925 350.555C168.177 346.924 190.123 331.412 190.123 331.412L205.781 333.433C205.824 333.433 170.358 351.916 164.925 350.555Z",
    fill: "url(#paint35_radial_461_44785)"
  }), React.createElement("path", {
    d: "M174.508 212.555C188.498 211.358 199.492 207.068 199.107 202.983C198.722 198.858 187.086 196.506 173.139 197.703C159.193 198.899 148.155 203.19 148.54 207.274C148.883 211.358 160.519 213.751 174.508 212.555Z",
    fill: "url(#paint36_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.422 183.14L230.294 77.1956L215.877 71.0898L101.653 75.7104C98.7435 75.7929 95.0216 75.6692 94.2088 78.392C90.5296 90.8512 81.1607 126.414 85.1393 153.065C90.0591 185.945 103.792 214.618 103.792 214.618L114.872 216.392C117.481 216.805 120.134 216.887 122.786 216.557C150.166 213.133 199.193 205.665 238.422 183.14Z",
    fill: "url(#paint37_radial_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.422 183.139C247.877 146.752 250.914 109.828 230.294 77.1949L215.877 71.0891C215.877 71.0891 153.332 211.111 161.631 209.502C187.128 204.551 214.38 196.919 238.422 183.139Z",
    fill: "url(#paint38_radial_461_44785)"
  }), React.createElement("path", {
    opacity: "0.4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.422 183.139C247.877 146.752 250.914 109.828 230.294 77.1949L215.877 71.0891C215.877 71.0891 153.332 211.111 161.631 209.502C187.128 204.551 214.38 196.919 238.422 183.139Z",
    fill: "url(#paint39_radial_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.46 93.9446C105.161 123.319 105.674 167.668 132.284 191.308C134.637 193.371 137.845 194.237 140.925 193.494L222.166 174.929C225.118 174.269 227.599 172.248 228.754 169.525C239.963 142.874 237.909 116.388 222.551 89.9428C220.754 86.8899 217.332 85.0334 213.695 85.2396C201.118 85.941 152.134 89.1589 136.989 90.1491C134.08 90.3553 131.3 91.7168 129.46 93.9446Z",
    fill: "url(#paint40_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.706 186.522L222.893 174.764C225.417 174.228 227.471 172.536 228.412 170.185C240.647 140.316 237.225 113.458 222.037 88.87C220.54 86.4359 217.759 85.0745 214.85 85.2808L209.845 85.6521L167.706 186.522Z",
    fill: "url(#paint41_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.797 105.579L157.054 105.208C158.765 105.125 160.262 106.487 160.305 108.219L161.674 138.336C161.759 139.945 160.562 141.389 158.979 141.554L150.722 142.585C148.925 142.833 147.3 141.43 147.214 139.615L145.802 108.838C145.759 107.147 147.086 105.661 148.797 105.579ZM195.898 102.774L201.973 102.485C203.684 102.402 205.182 103.764 205.267 105.496L206.679 134.54C206.765 136.273 205.438 137.717 203.727 137.8L197.652 138.088C195.941 138.171 194.444 136.809 194.358 135.077L192.947 106.033C192.861 104.341 194.187 102.856 195.898 102.774Z",
    fill: "url(#paint42_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.679 103.516L158.936 103.145C160.647 103.062 162.144 104.424 162.187 106.156L163.556 136.273C163.642 137.882 162.444 139.326 160.861 139.491L152.604 140.522C150.808 140.77 149.182 139.367 149.096 137.552L147.685 106.775C147.642 105.084 148.968 103.598 150.679 103.516ZM197.781 100.711L203.856 100.422C205.567 100.339 207.064 101.701 207.15 103.433L208.562 132.477C208.647 134.21 207.321 135.654 205.61 135.737L199.535 136.025C197.824 136.108 196.326 134.746 196.241 133.014L194.829 103.97C194.743 102.278 196.07 100.793 197.781 100.711Z",
    fill: "url(#paint43_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.449 106.197L156.583 105.95C157.653 105.909 158.551 106.734 158.594 107.806L159.278 122.452C159.321 123.442 158.594 124.35 157.61 124.474L152.519 125.134C151.407 125.258 150.38 124.432 150.337 123.277L149.653 108.219C149.567 107.146 150.38 106.239 151.449 106.197ZM198.508 103.681L202.273 103.516C203.342 103.475 204.241 104.3 204.283 105.372L204.968 120.596C205.011 121.668 204.198 122.576 203.128 122.617L199.364 122.782C198.294 122.823 197.396 121.998 197.353 120.926L196.669 105.702C196.626 104.671 197.439 103.763 198.508 103.681Z",
    fill: "url(#paint44_radial_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.995 77.071L216.904 71.5015C216.219 71.2127 215.449 71.0477 214.679 71.0889L96.134 74.7194C96.134 74.7194 95.0645 75.0907 94.2944 76.9885C89.9736 87.6737 71.749 116.223 75.8987 143.946C80.0057 171.423 96.4334 204.262 100.113 211.894C100.797 213.338 102.209 214.37 103.835 214.7L109.482 215.772C111.535 216.185 113.246 214.246 112.519 212.348C108.54 201.787 94.6794 178.601 93.011 143.946C91.9843 122.823 104.134 97.7813 108.925 87.5086C110.936 83.2181 115.043 80.1239 119.877 79.3813C136.476 76.6997 179.086 71.5427 229.995 77.071Z",
    fill: "url(#paint45_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.995 77.0712L215.834 71.0479C169.973 66.6748 138.487 66.2622 96.1339 74.6784L113.76 81.7331C115.556 80.0828 122.016 79.0102 131.214 77.855C156.198 74.7196 201.546 73.3994 229.995 77.0712Z",
    fill: "url(#paint46_linear_461_44785)"
  }), React.createElement("path", {
    d: "M179.219 170.321C187.09 168.918 195.176 162.235 196.887 152.003C197.101 150.559 196.032 149.487 194.663 149.734L190.128 150.559C189.016 150.766 187.903 151.797 187.689 152.952C186.663 157.903 182.855 160.254 179.689 160.832C176.524 161.41 172.887 160.378 172.245 155.716C172.16 154.602 171.09 153.984 169.978 154.149L165.443 154.974C164.074 155.221 162.919 156.706 162.962 158.068C163.732 167.969 171.518 171.724 179.219 170.321Z",
    fill: "url(#paint47_linear_461_44785)"
  }), React.createElement("path", {
    d: "M180.642 170.762C188.514 169.36 196.6 162.676 198.311 152.445C198.525 151.001 197.455 149.928 196.086 150.176L191.551 151.001C190.439 151.207 189.327 152.239 189.113 153.394C188.086 158.344 184.279 160.696 181.113 161.273C177.947 161.851 174.311 160.82 173.669 156.158C173.584 155.044 172.514 154.425 171.402 154.59L166.867 155.415C165.498 155.663 164.343 157.148 164.386 158.509C165.113 168.411 172.899 172.165 180.642 170.762Z",
    fill: "url(#paint48_linear_461_44785)"
  }), React.createElement("g", {
    clipPath: "url(#clip1_461_44785)"
  }, React.createElement("path", {
    opacity: "0.1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.817 73.1225C165.05 72.1937 166.051 70.5971 166.98 70.8297L181.256 74.9062C182.186 75.1388 178.942 74.3268 181.256 74.9062C176.374 74.8677 180.482 74.8677 172.079 74.9062L166.078 75.2257C165.149 74.993 164.584 74.0514 164.817 73.1225Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M167.291 71.9996C167.291 71.9996 166.06 43.279 186.675 24.4473",
    stroke: "#A4E4F3",
    strokeWidth: "4.4348",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("path", {
    d: "M187.727 13.4548C192.005 13.4548 195.684 16.9616 195.684 21.1284C195.684 25.2539 192.048 28.8019 187.727 28.8019C183.449 28.8019 179.77 25.2952 179.77 21.1284C179.77 17.0028 183.278 13.4548 187.727 13.4548Z",
    fill: "url(#paint49_linear_461_44785)"
  }), React.createElement("path", {
    d: "M187.086 14.9814C190.251 14.9814 192.947 17.5805 192.947 20.6334C192.947 23.6863 190.251 26.2854 187.086 26.2854C183.92 26.2854 181.225 23.6863 181.225 20.6334C181.225 17.5805 183.92 14.9814 187.086 14.9814Z",
    fill: "url(#paint50_radial_461_44785)"
  }), React.createElement("path", {
    d: "M308.155 305.545C315.471 303.523 319.92 307.649 318.08 314.703C316.241 321.758 308.882 329.143 301.567 331.123C294.251 333.145 289.802 329.019 291.642 321.964C293.439 314.91 300.84 307.566 308.155 305.545Z",
    fill: "#E9F5FB"
  }), React.createElement("path", {
    d: "M321.16 313.796C321.16 313.837 321.16 313.837 321.16 313.796L316.412 309.34C310.979 304.266 297.118 312.682 294.551 322.707C293.096 328.359 295.791 329.597 300.626 334.176C300.583 334.135 300.54 334.052 300.454 333.97C305.717 339.457 319.877 330.958 322.487 320.809C323.299 317.715 322.7 315.281 321.16 313.796Z",
    fill: "#FFFBF3"
  }), React.createElement("path", {
    d: "M321.16 313.837C317.995 310.867 312.262 312.724 308.412 315.281C300.54 320.521 296.476 330.051 300.54 334.053C300.198 333.723 300.283 333.805 299.428 333.021H299.385C298.957 332.691 296.091 329.927 295.62 329.515H295.577C285.909 319.985 307.727 301.296 315.257 308.351C315.299 308.392 316.027 309.093 316.454 309.506H316.497C318.166 311.073 320.604 313.301 321.16 313.837Z",
    fill: "url(#paint51_linear_461_44785)"
  }), React.createElement("path", {
    d: "M312.946 315.364C317.524 314.044 320.347 316.725 319.192 321.346C318.037 325.967 313.374 330.752 308.797 332.031C304.219 333.351 301.396 330.67 302.551 326.049C303.706 321.47 308.369 316.684 312.946 315.364Z",
    fill: "#AAD9F0"
  }), React.createElement("path", {
    d: "M317.952 317.261C317.267 316.106 316.069 315.611 314.658 315.653C310.636 315.735 304.861 320.191 303.62 325.636C303.449 326.338 303.406 326.998 303.406 327.534C303.535 334.836 316.241 330.092 318.337 321.14C318.679 319.943 318.679 318.334 317.952 317.261Z",
    fill: "#005995"
  }), React.createElement("path", {
    d: "M318.381 321.139C316.284 330.092 303.536 334.836 303.45 327.534C306.402 330.422 314.231 325.554 315.557 319.613C315.942 317.839 315.643 316.436 314.701 315.652C316.113 315.611 317.311 316.106 317.996 317.261C318.68 318.334 318.68 319.943 318.381 321.139Z",
    fill: "url(#paint52_linear_461_44785)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.353 284.958L266.444 275.304L258.144 280.832L244.241 259.091L262.551 269.033L272.262 264.495C272.262 264.536 285.267 284.752 285.353 284.958Z",
    fill: "url(#paint53_linear_461_44785)"
  }), React.createElement("path", {
    d: "M266.273 250.097C266.059 253.191 269.866 252.16 273.332 250.716C276.626 249.355 275.898 245.064 272.647 245.394C270.08 245.889 266.487 247.003 266.273 250.097Z",
    fill: "url(#paint54_radial_461_44785)"
  }), React.createElement("path", {
    d: "M278.08 256.121C277.866 259.215 280.775 258.843 284.241 257.399C287.535 256.038 286.808 251.747 283.556 252.077C280.989 252.573 278.294 253.026 278.08 256.121Z",
    fill: "url(#paint55_radial_461_44785)"
  }), React.createElement("path", {
    d: "M285.439 261.071C285.738 262.391 287.535 263.216 290.273 262.103C292.84 261.03 292.283 257.647 289.759 257.894C287.706 258.266 285.139 259.71 285.439 261.071Z",
    fill: "url(#paint56_radial_461_44785)"
  })), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.471 371.308) rotate(-4.33852) scale(46.36 44.7265)"
  }, React.createElement("stop", {
    offset: "0.00504299",
    stopColor: "#A4E4F3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_461_44785",
    x1: "162.774",
    y1: "250.38",
    x2: "279.961",
    y2: "245.008",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_461_44785",
    x1: "169.802",
    y1: "257.97",
    x2: "169.881",
    y2: "257.966",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.815 258.765) rotate(-2.44098) scale(8.55423 8.2504)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.379 262.416) rotate(-2.44098) scale(7.94111 7.65906)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.215 262.608) rotate(-2.44098) scale(8.41615 8.11723)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.232 253.72) rotate(-2.44098) scale(8.24102 7.94833)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.044 271.736) rotate(-2.44098) scale(79.8375 77.0019)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.549 241.85) scale(42.283 40.7757)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#94BBD6"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.989 231.611) scale(120.591 116.292)"
  }, React.createElement("stop", {
    offset: "0.323",
    stopColor: "#F8F5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9AD6EA"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_461_44785",
    x1: "191.604",
    y1: "266.571",
    x2: "225.151",
    y2: "265.033",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#7EB0D7"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B7D4E1"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.679 265.635) rotate(-2.44098) scale(17.1942 16.5835)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#F1FAFF"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BFFDFF"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_461_44785",
    x1: "225.437",
    y1: "252.95",
    x2: "258.992",
    y2: "251.412",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#7EB0D7"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B7D4E1"
  })), React.createElement("radialGradient", {
    id: "paint13_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.528 251.992) rotate(-2.44098) scale(17.2007 16.5898)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#F1FAFF"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BFFDFF"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_461_44785",
    x1: "252.616",
    y1: "283.777",
    x2: "241.87",
    y2: "304.097",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_461_44785",
    x1: "285.642",
    y1: "289.291",
    x2: "261.823",
    y2: "311.334",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_461_44785",
    x1: "302.748",
    y1: "305.212",
    x2: "295.46",
    y2: "317.699",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_461_44785",
    x1: "303.964",
    y1: "308.553",
    x2: "287.707",
    y2: "327.946",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("radialGradient", {
    id: "paint18_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.163 279.311) rotate(-2.44098) scale(69.6104 67.138)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint19_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.168 275.142) rotate(-2.44098) scale(44.2158 42.6454)"
  }, React.createElement("stop", {
    offset: "0.323",
    stopColor: "#F8F5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9AD6EA"
  })), React.createElement("linearGradient", {
    id: "paint20_linear_461_44785",
    x1: "146.572",
    y1: "355.79",
    x2: "174.431",
    y2: "354.513",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("radialGradient", {
    id: "paint21_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.242 353.816) rotate(-2.44098) scale(9.74068 9.39472)"
  }, React.createElement("stop", {
    stopColor: "#F8F5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9AD6EA"
  })), React.createElement("radialGradient", {
    id: "paint22_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.395 336.907) rotate(-2.44098) scale(28.2424 27.2393)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_461_44785",
    x1: "156.896",
    y1: "257.303",
    x2: "94.7381",
    y2: "366.462",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#7EB0D7"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B7D4E1"
  })), React.createElement("radialGradient", {
    id: "paint24_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.36 279.08) rotate(-2.44098) scale(61.3809 59.2008)"
  }, React.createElement("stop", {
    offset: "0.323",
    stopColor: "#F8F5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9AD6EA"
  })), React.createElement("linearGradient", {
    id: "paint25_linear_461_44785",
    x1: "106.717",
    y1: "248.099",
    x2: "129.515",
    y2: "247.054",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F8F5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9AD6EA"
  })), React.createElement("linearGradient", {
    id: "paint26_linear_461_44785",
    x1: "106.277",
    y1: "238.445",
    x2: "129.063",
    y2: "237.401",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F8F5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9AD6EA"
  })), React.createElement("linearGradient", {
    id: "paint27_linear_461_44785",
    x1: "118.087",
    y1: "248.82",
    x2: "124.018",
    y2: "238.79",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint28_linear_461_44785",
    x1: "106.044",
    y1: "268.421",
    x2: "127.233",
    y2: "267.45",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint29_linear_461_44785",
    x1: "111.263",
    y1: "310.548",
    x2: "224.332",
    y2: "305.365",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint30_linear_461_44785",
    x1: "225.592",
    y1: "299.167",
    x2: "218.771",
    y2: "300.682",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#7EB0D7"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B7D4E1"
  })), React.createElement("radialGradient", {
    id: "paint31_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(224.274 299.226) scale(5.94971 6.52369)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint32_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.352 287.197) rotate(-2.77498) scale(7.83028 8.5825)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint33_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.856 306.636) rotate(-2.775) scale(8.06377 8.8385)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint34_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.202 296.444) rotate(-2.77499) scale(8.32504 9.12481)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint35_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.31 340.709) rotate(-2.44098) scale(16.1551 15.5813)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("linearGradient", {
    id: "paint36_linear_461_44785",
    x1: "148.506",
    y1: "207.022",
    x2: "199.104",
    y2: "202.894",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("radialGradient", {
    id: "paint37_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.579 108.88) rotate(-2.44098) scale(101.314 101.791)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint38_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.907 139.704) rotate(-2.44098) scale(57.1513 57.4206)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint39_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.263 136.503) scale(88.8518 85.6843)"
  }, React.createElement("stop", {
    offset: "0.323",
    stopColor: "#F8F5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9AD6EA"
  })), React.createElement("linearGradient", {
    id: "paint40_linear_461_44785",
    x1: "111.552",
    y1: "140.096",
    x2: "235.896",
    y2: "134.396",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint41_linear_461_44785",
    x1: "165.41",
    y1: "136.127",
    x2: "235.847",
    y2: "132.898",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1407",
    stopColor: "#123161"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#041836"
  })), React.createElement("linearGradient", {
    id: "paint42_linear_461_44785",
    x1: "172.343",
    y1: "106.876",
    x2: "174.02",
    y2: "140.221",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.0155217",
    stopColor: "#123161",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#051938"
  })), React.createElement("linearGradient", {
    id: "paint43_linear_461_44785",
    x1: "174.629",
    y1: "104.97",
    x2: "174.218",
    y2: "125.272",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("radialGradient", {
    id: "paint44_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.307 114.328) rotate(8.54163) scale(22.3924 21.6529)"
  }, React.createElement("stop", {
    stopColor: "#D7FFFF"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint45_linear_461_44785",
    x1: "135.788",
    y1: "168.675",
    x2: "150.873",
    y2: "104.489",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#7EB0D7"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B7D4E1"
  })), React.createElement("linearGradient", {
    id: "paint46_linear_461_44785",
    x1: "156.131",
    y1: "91.8228",
    x2: "153.89",
    y2: "97.3568",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#7EB0D7"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B7D4E1"
  })), React.createElement("linearGradient", {
    id: "paint47_linear_461_44785",
    x1: "188.437",
    y1: "147.648",
    x2: "170.132",
    y2: "169.58",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.0155217",
    stopColor: "#123161",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#051938"
  })), React.createElement("linearGradient", {
    id: "paint48_linear_461_44785",
    x1: "189.834",
    y1: "148.091",
    x2: "171.528",
    y2: "170.023",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("linearGradient", {
    id: "paint49_linear_461_44785",
    x1: "163.71",
    y1: "10.7285",
    x2: "191.94",
    y2: "23.8674",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6BFFE8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#68F8E5"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#49B6C8"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#358DB6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF"
  })), React.createElement("radialGradient", {
    id: "paint50_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.214 18.8729) scale(5.05929 4.87894)"
  }, React.createElement("stop", {
    stopColor: "#D7FFFF"
  }), React.createElement("stop", {
    offset: "0.1145",
    stopColor: "#CFF9FB",
    stopOpacity: "0.8855"
  }), React.createElement("stop", {
    offset: "0.2944",
    stopColor: "#B8E7F0",
    stopOpacity: "0.7056"
  }), React.createElement("stop", {
    offset: "0.5171",
    stopColor: "#94CBDF",
    stopOpacity: "0.4829"
  }), React.createElement("stop", {
    offset: "0.7713",
    stopColor: "#61A5C7",
    stopOpacity: "0.2287"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2E7DAF",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint51_linear_461_44785",
    x1: "111.303",
    y1: "273.013",
    x2: "348.037",
    y2: "334.669",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#128EF9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A9D4F3"
  })), React.createElement("linearGradient", {
    id: "paint52_linear_461_44785",
    x1: "111.578",
    y1: "274.913",
    x2: "347.382",
    y2: "336.327",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#128EF9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A9D4F3"
  })), React.createElement("linearGradient", {
    id: "paint53_linear_461_44785",
    x1: "281.533",
    y1: "283.473",
    x2: "270.351",
    y2: "243.724",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FCDE00"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FDE1A9"
  })), React.createElement("radialGradient", {
    id: "paint54_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.9 248.812) rotate(-168.237) scale(3.61946 5.09966)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint55_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(282.239 255.323) rotate(-168.238) scale(3.32991 4.6917)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("radialGradient", {
    id: "paint56_radial_461_44785",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(288.71 260.214) rotate(-168.237) scale(2.57527 3.62846)"
  }, React.createElement("stop", {
    offset: "0.387",
    stopColor: "#D8E8F8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A4E4F3"
  })), React.createElement("clipPath", {
    id: "clip0_461_44785"
  }, React.createElement("rect", {
    width: "247.7",
    height: "377.076",
    fill: "white",
    transform: "translate(75.2997 13.2488)"
  })), React.createElement("clipPath", {
    id: "clip1_461_44785"
  }, React.createElement("rect", {
    width: "27.5109",
    height: "54.3107",
    fill: "white",
    transform: "translate(164.766 26.3135)"
  }))));
};

var servers = function servers(width, height) {
  if (width === void 0) {
    width = '323';
  }

  if (height === void 0) {
    height = '398';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 323 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    opacity: "0.7",
    d: "M292.365 226.24C301.592 150.424 247.556 81.4911 171.672 72.2729C95.789 63.0547 26.7939 117.042 17.5674 192.858C8.34098 268.673 62.377 337.607 138.26 346.825C214.144 356.043 283.139 302.055 292.365 226.24Z",
    fill: "#21BF96"
  }), React.createElement("g", {
    clipPath: "url(#clip0_8801_37918)"
  }, React.createElement("path", {
    d: "M121.923 110.553C120.613 110.553 118.008 109.257 118.008 107.976V71.8593C118.076 70.8486 118.513 69.8981 119.234 69.1871C119.955 68.4762 120.911 68.0539 121.923 67.9999C122.449 67.921 122.987 67.9661 123.493 68.1314C123.999 68.2968 124.46 68.5779 124.839 68.9525C125.217 69.3271 125.503 69.7849 125.674 70.2895C125.845 70.794 125.896 71.3315 125.823 71.8593V107.99C127.147 109.257 125.823 110.553 121.923 110.553Z",
    fill: "url(#paint0_linear_8801_37918)"
  }), React.createElement("path", {
    opacity: "0.61",
    d: "M55.9292 276.763V340.37L154.667 397.971V334.393L55.9292 276.763Z",
    fill: "url(#paint1_linear_8801_37918)"
  }), React.createElement("path", {
    opacity: "0.61",
    d: "M154.667 334.393V398L267.338 334.077V268.972L154.667 334.393Z",
    fill: "url(#paint2_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M168.585 212.263L55.9003 276.057V277.353L154.667 334.393L267.338 269.275V267.993L168.585 212.263ZM238.35 254.025L250.426 260.994V261.498L238.35 268.468H238.062L226 261.498V260.994L238.062 254.025H238.35ZM156.308 269.534V269.044L168.384 262.074H168.672L180.748 269.044V269.534L168.672 276.504H168.384L156.308 269.534ZM166.815 277.08V277.584L154.753 284.553H154.466L142.39 277.584V277.08L154.466 270.11H154.753L166.815 277.08ZM170.241 261.498V260.994L182.302 254.025H182.59L194.666 260.994V261.498L182.59 268.468H182.302L170.241 261.498ZM180.748 253.449L168.672 260.418H168.384L156.365 253.434V252.945L168.441 245.96H168.729L180.805 252.945L180.748 253.449ZM166.815 260.994V261.498L154.753 268.468H154.466L142.39 261.498V260.994L154.466 254.025H154.753L166.815 260.994ZM152.897 269.044V269.534L140.821 276.504H140.533L128.457 269.534V269.044L140.533 262.074H140.821L152.897 269.044ZM138.964 277.08V277.584L126.902 284.553H126.615L114.539 277.584V277.08L126.615 270.11H126.902L138.964 277.08ZM128.586 285.115L140.662 278.145H140.95L153.026 285.115V285.605L140.95 292.589H140.662L128.586 285.605V285.115ZM142.519 293.151L154.595 286.181H154.883L166.945 293.151V293.755L154.883 300.725H154.595L142.519 293.755V293.151ZM156.437 285.605V285.115L168.513 278.145H168.801L180.877 285.115V285.605L168.801 292.589H168.513L156.437 285.605ZM170.37 277.569V277.065L182.432 270.095H182.72L194.796 277.065V277.569L182.72 284.539H182.432L170.37 277.569ZM184.288 269.519V269.03L196.235 262.074H196.523L208.584 269.044V269.534L196.523 276.504H196.235L184.288 269.519ZM198.221 261.484V260.98L210.283 254.01H210.571L222.647 260.98V261.484L210.571 268.454H210.283L198.221 261.484ZM208.714 253.434L196.652 260.404H196.364L184.288 253.434V252.945L196.364 245.96H196.652L208.714 252.945V253.434ZM194.796 245.399L182.72 252.369H182.432L170.37 245.399V244.895L182.432 237.925H182.72L194.796 244.895V245.399ZM180.877 237.349L168.801 244.319H168.513L156.437 237.349V236.845L168.513 229.875H168.801L180.877 236.845V237.349ZM166.945 244.895V245.399L154.883 252.369H154.595L142.519 245.399V244.895L154.595 237.925H154.883L166.945 244.895ZM153.026 252.945V253.434L140.95 260.404H140.662L128.586 253.434V252.945L140.662 245.96H140.95L153.026 252.945ZM139.093 260.98V261.484L127.032 268.454H126.744L114.668 261.484V260.98L126.744 254.01H127.032L139.093 260.98ZM125.175 269.03V269.519L113.099 276.489H112.811L100.75 269.519V269.03L112.754 262.074H113.042L125.175 269.03ZM111.243 277.065V277.569L99.1809 284.539H98.893L86.8171 277.569V277.065L98.893 270.095H99.1809L111.243 277.065ZM100.75 285.115L112.811 278.145H113.099L125.175 285.115V285.605L113.099 292.589H112.811L100.75 285.605V285.115ZM114.668 293.151L126.744 286.181H127.032L139.093 293.151V293.755L127.032 300.725H126.744L114.668 293.755V293.151ZM128.586 301.2L140.662 294.231H140.95L153.026 301.2V301.704L140.95 308.674H140.662L128.586 301.704V301.2ZM142.519 309.25L154.595 302.266H154.883L166.945 309.25V309.74L154.883 316.71H154.595L142.519 309.74V309.25ZM156.437 301.704V301.2L168.513 294.231H168.801L180.877 301.2V301.704L168.801 308.674H168.513L156.437 301.704ZM170.327 293.755V293.251L182.389 286.282H182.676L194.752 293.251V293.755L182.676 300.725H182.389L170.327 293.755ZM184.245 285.706V285.115L196.321 278.145H196.609L208.671 285.115V285.605L196.609 292.589H196.321L184.245 285.706ZM198.178 277.67V277.166L210.24 270.196H210.527L222.603 277.166V277.67L210.527 284.64H210.24L198.178 277.67ZM212.096 269.62V269.131L224.172 262.161H224.46L236.522 269.131V269.62L224.46 276.59H224.172L212.096 269.62ZM224.46 246.061L236.522 253.045V253.434L224.46 260.404H224.172L212.068 253.434V252.945L224.143 245.96L224.46 246.061ZM210.527 238.026L222.603 244.996V245.5L210.527 252.469H210.24L198.178 245.5V244.996L210.24 238.026H210.527ZM196.609 229.976L208.671 236.946V237.45L196.609 244.42H196.321L184.245 237.45V236.946L196.321 229.976H196.609ZM182.676 221.941L194.752 228.91V229.4L182.676 236.384H182.389L170.327 229.4V228.91L182.389 221.941H182.676ZM156.394 220.86L168.47 213.891H168.758L180.834 220.86V221.365L168.758 228.334H168.47L156.394 221.365V220.86ZM142.476 228.91L154.552 221.941H154.84L166.901 228.91V229.4L154.84 236.384H154.552L142.476 229.4V228.91ZM128.586 236.874L140.662 229.904H140.95L153.026 236.874V237.378L140.95 244.348H140.662L128.586 237.378V236.874ZM114.668 244.924L126.744 237.954H127.032L139.093 244.924V245.428L127.032 252.397H126.744L114.668 245.428V244.924ZM100.75 252.973L112.811 245.989H113.099L125.175 252.973V253.434L113.099 260.404H112.811L100.75 253.434V252.973ZM86.8171 261.009L98.893 254.039H99.1809L111.243 261.009V261.513L99.1809 268.483H98.893L86.8171 261.513V261.009ZM72.8987 269.059L84.9603 262.089H85.2482L97.3242 269.059V269.548L85.2482 276.518H84.9603L72.8987 269.548V269.059ZM71.0132 284.568L58.9372 277.598V277.094L71.0132 270.124H71.3011L83.3627 277.094V277.598L71.3011 284.568H71.0132ZM84.9316 292.618L72.87 285.634V285.115L84.9316 278.145H85.2194L97.2954 285.115V285.605L85.2194 292.589L84.9316 292.618ZM98.8643 300.653L86.7883 293.683V293.179L98.8643 286.21H99.1521L111.214 293.179V293.755L99.1521 300.725L98.8643 300.653ZM112.783 308.703L100.721 301.733V301.229L112.783 294.259H113.07L125.146 301.229V301.733L113.07 308.703H112.783ZM126.715 316.738L114.639 309.769V309.279L126.715 302.295H127.003L139.065 309.279V309.769L127.003 316.738H126.715ZM140.634 324.788L128.558 317.818V317.314L140.634 310.345H140.921L152.997 317.314V317.818L140.921 324.788H140.634ZM166.916 325.854L154.854 332.824H154.566L142.49 325.854V325.436L154.566 318.466H154.854L166.916 325.436V325.854ZM180.848 317.818L168.772 324.788H168.485L156.409 317.818V317.314L168.485 310.345H168.772L180.848 317.314V317.818ZM194.767 309.769L182.691 316.738H182.403L170.341 309.769V309.279L182.403 302.295H182.691L194.767 309.279V309.769ZM208.685 301.733L196.624 308.703H196.336L184.26 301.733V301.229L196.336 294.259H196.624L208.685 301.229V301.733ZM222.618 293.683L210.542 300.653H210.254L198.192 293.683V293.179L210.254 286.21H210.542L222.618 293.179V293.683ZM236.536 285.634L224.475 292.618H224.187L212.111 285.634V285.115L224.187 278.145H224.475L236.536 285.115V285.634ZM250.469 277.598L238.393 284.568H238.105L226.043 277.598V277.094L238.105 270.124H238.393L250.469 277.094V277.598ZM252.326 276.518H252.038L239.962 269.548V269.059L252.038 262.089H252.326L264.387 269.059V269.548L252.326 276.518Z",
    fill: "url(#paint3_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M154.178 332.708L56.8361 276.489L169.248 211.558L266.59 267.777L154.178 332.708Z",
    fill: "url(#paint4_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M55.9003 276.057L168.585 210.982L267.338 268.022L154.667 333.112L55.9003 276.057ZM142.447 324.083V324.572L154.523 331.542H154.811L166.873 324.572V324.083L154.811 317.098H154.523L142.447 324.083ZM156.365 316.033V316.537L168.441 323.507H168.729L180.805 316.537V316.033L168.729 309.063H168.441L156.365 316.033ZM128.514 316.033V316.537L140.59 323.507H140.878L152.954 316.537V316.033L140.878 309.063H140.59L128.514 316.033ZM170.255 307.983V308.487L182.317 315.457H182.604L194.68 308.487V307.983L182.604 301.013H182.317L170.255 307.983ZM142.404 307.983V308.487L154.48 315.457H154.768L166.829 308.487V307.983L154.768 301.013H154.48L142.404 307.983ZM114.553 307.983V308.487L126.629 315.457H126.917L138.978 308.487V307.983L126.917 301.013H126.629L114.553 307.983ZM196.235 292.978L184.159 299.947V300.437L196.235 307.421H196.523L208.584 300.437V299.947L196.523 292.978H196.235ZM168.384 292.978L156.308 299.947V300.437L168.384 307.421H168.672L180.748 300.437V299.947L168.672 292.978H168.384ZM128.586 299.947V300.437L140.662 307.421H140.95L153.026 300.437V299.947L140.95 292.978H140.662L128.586 299.947ZM112.754 292.978L100.692 299.947V300.437L112.754 307.421H113.042L125.118 300.437V299.947L113.042 292.978H112.754ZM198.164 291.898V292.402L210.225 299.371H210.513L222.589 292.402V291.898L210.513 284.928H210.225L198.164 291.898ZM170.313 291.898V292.402L182.374 299.371H182.662L194.738 292.402V291.898L182.662 284.928H182.374L170.313 291.898ZM142.462 291.898V292.402L154.538 299.371H154.825L166.887 292.402V291.898L154.825 284.928H154.538L142.462 291.898ZM114.611 291.898V292.402L126.686 299.371H126.974L139.036 292.402V291.898L126.974 284.928H126.686L114.611 291.898ZM86.7595 291.898V292.402L98.8354 299.371H99.1233L111.185 292.402V291.898L99.1233 284.928H98.8354L86.7595 291.898ZM212.082 283.862V284.352L224.158 291.322H224.446L236.507 284.352V283.862L224.446 276.892H224.158L212.082 283.862ZM184.231 283.862V284.352L196.307 291.322H196.595L208.656 284.352V283.862L196.595 276.892H196.307L184.231 283.862ZM156.38 283.862V284.352L168.456 291.322H168.744L180.82 284.352V283.862L168.744 276.892H168.456L156.38 283.862ZM128.529 283.862V284.352L140.605 291.322H140.893L152.969 284.352V283.862L140.893 276.892H140.605L128.529 283.862ZM100.692 283.862V284.352L112.754 291.322H113.042L125.118 284.352V283.862L113.042 276.892H112.754L100.692 283.862ZM72.8412 283.862V284.352L84.9028 291.322H85.1906L97.2666 284.352V283.862L85.1906 276.892H84.9028L72.8412 283.862ZM226.015 275.812V276.316L238.076 283.286H238.364L250.44 276.316V275.812L238.364 268.843H238.076L226.015 275.812ZM210.182 268.843L198.12 275.812V276.316L210.182 283.286H210.47L222.546 276.316V275.812L210.47 268.843H210.182ZM170.327 275.812V276.316L182.389 283.286H182.676L194.752 276.316V275.812L182.676 268.843H182.389L170.327 275.812ZM142.476 275.812V276.316L154.552 283.286H154.84L166.901 276.316V275.812L154.84 268.843H154.552L142.476 275.812ZM114.625 275.812V276.316L126.701 283.286H126.989L139.05 276.316V275.812L126.989 268.843H126.701L114.625 275.812ZM86.7739 275.812V276.316L98.8499 283.286H99.1377L111.199 276.316V275.812L99.1377 268.843H98.8499L86.7739 275.812ZM70.9413 268.843L58.8653 275.812V276.316L70.9413 283.286H71.2291L83.2907 276.316V275.812L71.2291 268.843H70.9413ZM239.89 267.777V268.267L251.966 275.236H252.254L264.315 268.267V267.835L252.254 260.85H251.966L239.89 267.777ZM212.068 267.835V268.324L224.143 275.294H224.431L236.493 268.324V267.835L224.431 260.85H224.143L212.068 267.835ZM184.216 267.835V268.324L196.292 275.294H196.58L208.642 268.324V267.835L196.58 260.85H196.292L184.216 267.835ZM156.365 267.835V268.324L168.441 275.294H168.729L180.805 268.324V267.835L168.729 260.85H168.441L156.365 267.835ZM128.586 267.835V268.324L140.662 275.294H140.95L153.026 268.324V267.835L140.95 260.85H140.662L128.586 267.835ZM100.75 267.835V268.324L112.811 275.294H113.099L125.175 268.324V267.835L113.099 260.85H112.811L100.75 267.835ZM72.8987 267.835V268.324L84.9603 275.294H85.2482L97.3242 268.324V267.835L85.2482 260.85H84.9603L72.8987 267.835ZM226.072 259.785V260.289L238.134 267.259H238.422L250.498 260.289V259.785L238.422 252.815H238.134L226.072 259.785ZM198.221 259.785V260.289L210.283 267.259H210.571L222.647 260.289V259.785L210.571 252.815H210.283L198.221 259.785ZM170.37 259.785V260.289L182.432 267.259H182.72L194.796 260.289V259.785L182.72 252.815H182.432L170.37 259.785ZM142.519 259.785V260.289L154.595 267.259H154.883L166.945 260.289V259.785L154.883 252.815H154.595L142.519 259.785ZM114.668 259.785V260.289L126.744 267.259H127.032L139.093 260.289V259.785L127.032 252.815H126.744L114.668 259.785ZM86.8171 259.785V260.289L98.893 267.259H99.1809L111.243 260.289V259.785L99.1809 252.815H98.893L86.8171 259.785ZM212.139 251.735V252.239L224.215 259.209H224.503L236.565 252.239V251.735L224.503 244.765H224.215L212.139 251.735ZM196.307 244.765L184.231 251.735V252.239L196.235 259.194H196.523L208.584 252.225V251.72L196.523 244.751L196.307 244.765ZM168.456 244.765L156.38 251.735V252.239L168.456 259.209H168.744L180.82 252.239V251.735L168.744 244.765H168.456ZM128.586 251.677V252.181L140.662 259.151H140.95L153.026 252.181V251.677L140.95 244.707H140.662L128.586 251.677ZM112.754 244.707L100.692 251.677V252.181L112.754 259.194H113.042L125.118 252.225V251.72L113.042 244.751L112.754 244.707ZM198.164 243.642V244.131L210.225 251.116H210.513L222.589 244.131V243.642L210.513 236.672H210.225L198.164 243.642ZM170.313 243.642V244.131L182.374 251.116H182.662L194.738 244.131V243.642L182.662 236.672H182.374L170.313 243.642ZM142.462 243.642V244.131L154.538 251.116H154.825L166.887 244.131V243.642L154.825 236.672H154.538L142.462 243.642ZM114.611 243.642V244.131L126.686 251.116H126.974L139.036 244.131V243.642L126.974 236.672H126.686L114.611 243.642ZM184.231 235.592V236.154L196.307 243.123H196.595L208.656 236.154V235.65L196.595 228.68H196.307L184.231 235.592ZM156.38 235.592V236.154L168.456 243.123H168.744L180.82 236.154V235.65L168.744 228.68H168.456L156.38 235.592ZM128.529 235.592V236.154L140.605 243.123H140.893L152.969 236.154V235.65L140.893 228.68H140.605L128.529 235.592ZM170.269 227.557V228.046L182.331 235.016H182.619L194.695 228.046V227.513L182.619 220.544H182.331L170.269 227.557ZM142.418 227.557V228.046L154.494 235.016H154.782L166.844 228.046V227.513L154.782 220.544H154.494L142.418 227.557ZM168.413 212.537L156.337 219.507V220.011L168.413 226.981H168.701L180.776 220.011V219.507L168.701 212.537H168.413Z",
    fill: "url(#paint5_radial_8801_37918)"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M158.755 289.666L95.2086 252.959L168.586 210.564L232.132 247.285L158.755 289.666Z",
    fill: "url(#paint6_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M266.057 201.838L168.586 145.532L55.3248 210.953L154.639 268.324L267.885 202.903L266.057 201.838Z",
    fill: "#007BC4"
  }), React.createElement("path", {
    d: "M267.914 202.903C267.914 202.903 200.668 166.7 168.6 148.182C131.753 169.465 55.3391 210.967 55.3391 210.967V213.603L154.653 270.974L267.899 205.553L267.914 202.903Z",
    fill: "url(#paint7_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M266.057 201.838L168.586 145.532L55.3248 210.953L154.639 268.324L267.885 202.903L266.057 201.838Z",
    fill: "url(#paint8_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M174.645 175.557L155.444 164.468C154.538 163.95 154.653 163.028 155.704 162.424C156.24 162.129 156.838 161.963 157.45 161.938C158.062 161.913 158.671 162.03 159.23 162.28L178.431 173.368C179.323 173.901 179.222 174.808 178.171 175.413C177.636 175.71 177.038 175.878 176.425 175.903C175.813 175.928 175.203 175.81 174.645 175.557Z",
    fill: "#FFEC55"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M225.151 216.108L145.6 170.157C144.693 169.638 144.808 168.717 145.844 168.126C146.379 167.826 146.976 167.656 147.589 167.628C148.201 167.601 148.811 167.717 149.371 167.968L228.937 213.934C229.843 214.452 229.728 215.374 228.678 215.964C228.143 216.265 227.545 216.435 226.932 216.46C226.319 216.485 225.709 216.364 225.151 216.108Z",
    fill: "url(#paint9_radial_8801_37918)"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M215.306 221.753L135.783 175.845C134.876 175.326 134.991 174.405 136.042 173.814C136.577 173.514 137.175 173.344 137.788 173.319C138.401 173.294 139.011 173.414 139.569 173.67L219.12 219.622C220.027 220.14 219.912 221.062 218.876 221.652C218.331 221.95 217.723 222.114 217.103 222.132C216.482 222.149 215.867 222.02 215.306 221.753Z",
    fill: "url(#paint10_radial_8801_37918)"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M205.447 227.513L125.895 181.547C124.988 181.029 125.104 180.107 126.14 179.517C126.676 179.219 127.274 179.051 127.886 179.026C128.498 179.001 129.108 179.12 129.666 179.373L209.189 225.31C210.096 225.843 209.981 226.75 208.93 227.355C208.401 227.648 207.811 227.814 207.207 227.842C206.603 227.869 206 227.757 205.447 227.513Z",
    fill: "url(#paint11_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M122.613 225.181L86.4861 204.3C85.5793 203.782 85.6945 202.86 86.7308 202.269C87.2655 201.969 87.8638 201.799 88.4767 201.774C89.0896 201.749 89.6997 201.869 90.2571 202.125L126.399 222.992C127.305 223.51 127.19 224.432 126.14 225.037C125.604 225.334 125.006 225.502 124.394 225.527C123.781 225.552 123.172 225.433 122.613 225.181Z",
    fill: "url(#paint12_linear_8801_37918)"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M185.742 238.875L106.191 192.952C105.284 192.434 105.399 191.512 106.435 190.908C106.972 190.613 107.57 190.447 108.182 190.422C108.793 190.397 109.402 190.514 109.962 190.764L189.528 236.73C190.435 237.248 190.319 238.17 189.269 238.76C188.732 239.056 188.132 239.221 187.519 239.241C186.906 239.261 186.298 239.136 185.742 238.875Z",
    fill: "url(#paint13_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M175.897 244.564L156.711 233.49C155.804 232.957 155.919 232.05 156.956 231.445C157.491 231.147 158.089 230.979 158.702 230.954C159.314 230.929 159.924 231.048 160.482 231.301L179.668 242.389C180.575 242.908 180.46 243.829 179.424 244.42C178.889 244.72 178.291 244.89 177.678 244.915C177.065 244.94 176.455 244.82 175.897 244.564Z",
    fill: "url(#paint14_linear_8801_37918)"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M146.305 227.513L96.3313 198.713C95.4245 198.194 95.5397 197.273 96.5904 196.682C97.1251 196.382 97.7225 196.212 98.3348 196.184C98.9471 196.157 99.5573 196.273 100.117 196.524L150.076 225.325C150.983 225.843 150.868 226.765 149.831 227.355C149.298 227.658 148.7 227.83 148.087 227.858C147.474 227.885 146.863 227.767 146.305 227.513Z",
    fill: "url(#paint15_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M203.014 191.944L183.813 180.842C182.907 180.323 183.022 179.402 184.058 178.811C184.594 178.514 185.192 178.346 185.804 178.321C186.417 178.296 187.026 178.414 187.585 178.667L206.785 189.756C207.692 190.274 207.577 191.196 206.541 191.786C206.006 192.086 205.408 192.256 204.796 192.284C204.184 192.311 203.574 192.195 203.014 191.944Z",
    fill: "url(#paint16_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M135.236 198.324L116.036 187.236C115.129 186.703 115.244 185.795 116.295 185.191C116.83 184.893 117.428 184.725 118.041 184.7C118.653 184.675 119.263 184.794 119.821 185.047L139.022 196.135C139.914 196.653 139.799 197.575 138.763 198.18C138.226 198.474 137.628 198.64 137.016 198.665C136.405 198.69 135.795 198.573 135.236 198.324Z",
    fill: "url(#paint17_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M178.632 223.395L144.419 203.609C143.512 203.09 143.627 202.169 144.664 201.578C145.198 201.278 145.797 201.108 146.41 201.083C147.023 201.058 147.633 201.178 148.19 201.434L182.432 221.206C183.339 221.724 183.223 222.646 182.173 223.251C181.634 223.547 181.034 223.715 180.419 223.74C179.805 223.765 179.193 223.647 178.632 223.395Z",
    fill: "#DD80A6"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M158.755 224.619L95.2086 187.912L168.586 145.517L232.132 182.224L158.755 224.619Z",
    fill: "url(#paint18_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M257.896 134.872C257.368 134.951 256.828 134.905 256.32 134.739C255.812 134.573 255.35 134.291 254.97 133.915C254.59 133.539 254.303 133.079 254.132 132.573C253.96 132.067 253.908 131.528 253.981 130.998V121.911C253.908 121.382 253.96 120.842 254.132 120.336C254.303 119.83 254.59 119.371 254.97 118.995C255.35 118.619 255.812 118.336 256.32 118.17C256.828 118.004 257.368 117.959 257.896 118.038C258.424 117.961 258.962 118.009 259.468 118.176C259.974 118.343 260.434 118.626 260.812 119.001C261.19 119.377 261.476 119.835 261.647 120.34C261.818 120.845 261.869 121.383 261.797 121.911V130.926C261.752 131.951 261.328 132.922 260.607 133.651C259.886 134.381 258.92 134.816 257.896 134.872Z",
    fill: "url(#paint19_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M267.914 137.885C267.914 137.885 200.668 101.683 168.6 83.1637C131.753 104.448 55.3391 145.95 55.3391 145.95V148.585L154.653 205.97L267.899 140.549L267.914 137.885Z",
    fill: "url(#paint20_radial_8801_37918)"
  }), React.createElement("path", {
    d: "M266.057 136.791L168.586 80.4851L55.3248 145.906L154.639 203.278L267.885 137.856L266.057 136.791Z",
    fill: "url(#paint21_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M152.364 176.291L100.117 146.05C98.3318 145.028 98.5621 143.17 100.62 142.033L160.943 107.184C162.002 106.592 163.186 106.257 164.399 106.207C165.611 106.157 166.819 106.393 167.923 106.896L220.157 137.064C221.941 138.101 221.711 139.945 219.653 141.097L159.331 175.946C158.278 176.547 157.099 176.891 155.889 176.951C154.678 177.011 153.471 176.785 152.364 176.291Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M188.189 152.271L141.699 125.414C140.835 124.91 140.936 123.974 141.943 123.456L157.416 114.513C157.933 114.228 158.509 114.068 159.099 114.046C159.689 114.023 160.276 114.139 160.813 114.384L207.303 141.226C208.181 141.73 208.066 142.666 207.059 143.199L191.6 152.127C191.082 152.415 190.504 152.577 189.912 152.602C189.32 152.627 188.73 152.514 188.189 152.271Z",
    fill: "#F7F8FA"
  }), React.createElement("path", {
    d: "M163.13 130.512L151.242 123.643C149.673 122.736 149.802 121.152 151.673 120.101C152.604 119.58 153.643 119.286 154.708 119.241C155.773 119.196 156.834 119.401 157.805 119.842L169.708 126.711C171.277 127.618 171.076 129.202 169.262 130.253C168.332 130.773 167.292 131.068 166.227 131.113C165.162 131.158 164.101 130.952 163.13 130.512Z",
    fill: "url(#paint22_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M166.772 164.641L120.296 137.784C119.418 137.28 119.519 136.344 120.541 135.826L135.999 126.883C136.516 126.598 137.092 126.438 137.682 126.416C138.272 126.393 138.859 126.509 139.396 126.754L185.886 153.596C186.764 154.1 186.649 155.036 185.642 155.569L170.183 164.497C169.665 164.785 169.087 164.947 168.495 164.972C167.902 164.997 167.313 164.884 166.772 164.641Z",
    fill: "#F7F8FA"
  }), React.createElement("path", {
    d: "M146.924 167.622L115.129 149.247C113.114 148.095 113.359 146.05 115.69 144.711C116.883 144.045 118.215 143.668 119.58 143.611C120.945 143.553 122.304 143.816 123.549 144.38L155.358 162.712C157.373 163.878 157.114 165.908 154.797 167.248C153.606 167.924 152.273 168.31 150.905 168.375C149.537 168.44 148.173 168.182 146.924 167.622Z",
    fill: "url(#paint23_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M141.641 142.882L129.752 136.013C128.183 135.106 128.313 133.522 130.199 132.471C131.129 131.95 132.168 131.656 133.233 131.611C134.298 131.566 135.359 131.771 136.33 132.212L148.219 139.081C149.788 139.988 149.658 141.572 147.773 142.623C146.842 143.143 145.803 143.438 144.738 143.483C143.673 143.528 142.612 143.322 141.641 142.882Z",
    fill: "url(#paint24_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M164.356 144.864C168.901 144.309 172.331 141.773 172.018 139.2C171.704 136.626 167.765 134.989 163.22 135.543C158.675 136.098 155.245 138.633 155.558 141.207C155.872 143.781 159.811 145.418 164.356 144.864Z",
    fill: "#F7F8FA",
    stroke: "white",
    strokeWidth: "0.58",
    strokeMiterlimit: "10"
  }), React.createElement("path", {
    d: "M201.992 114.758L162.439 91.9047C160.784 90.9543 161 89.2839 162.9 88.175L163.317 87.9446C164.297 87.3999 165.39 87.0916 166.509 87.0441C167.629 86.9966 168.744 87.2112 169.766 87.671L209.318 110.524C210.974 111.475 210.758 113.145 208.858 114.254L208.44 114.485C207.461 115.029 206.368 115.338 205.249 115.385C204.129 115.433 203.014 115.218 201.992 114.758Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M173.508 96.9448L164.613 91.8182C163.447 91.127 163.591 89.9462 164.944 89.1686C165.64 88.7774 166.418 88.5554 167.216 88.5204C168.013 88.4854 168.808 88.6383 169.536 88.9669L178.431 94.1079C179.611 94.7847 179.453 95.98 178.1 96.7576C177.404 97.1508 176.625 97.3729 175.826 97.4055C175.028 97.438 174.234 97.2801 173.508 96.9448Z",
    fill: "url(#paint25_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M187.398 104.966L178.503 99.8249C177.322 99.1481 177.466 97.9672 178.834 97.1752C179.529 96.7898 180.305 96.5722 181.1 96.5397C181.895 96.5072 182.686 96.6607 183.411 96.988L192.306 102.129C193.486 102.806 193.342 104.001 191.989 104.779C191.291 105.164 190.512 105.382 189.715 105.414C188.919 105.447 188.125 105.293 187.398 104.966Z",
    fill: "#F7F8FA"
  }), React.createElement("path", {
    d: "M223.438 125.789L214.543 120.648C213.363 119.971 213.507 118.79 214.874 117.998C215.57 117.613 216.346 117.395 217.141 117.363C217.935 117.33 218.727 117.484 219.451 117.811L228.347 122.952C229.527 123.629 229.383 124.81 228.015 125.602C227.32 125.987 226.544 126.205 225.749 126.237C224.954 126.27 224.163 126.116 223.438 125.789Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M250.368 141.341L247.95 139.901C247.216 139.484 247.302 138.749 248.152 138.26L250.023 137.18C250.458 136.932 250.947 136.792 251.448 136.772C251.949 136.752 252.447 136.852 252.901 137.064L255.334 138.504C256.053 138.922 255.967 139.656 255.118 140.146L253.261 141.226C252.824 141.478 252.333 141.619 251.829 141.639C251.325 141.659 250.824 141.557 250.368 141.341Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M245.057 136.92L229.93 128.151C229.21 127.733 229.311 127.013 230.131 126.538C230.557 126.299 231.032 126.164 231.519 126.141C232.006 126.119 232.492 126.21 232.938 126.408L248.065 135.149C248.771 135.567 248.684 136.287 247.864 136.776C247.439 137.015 246.964 137.152 246.477 137.177C245.99 137.202 245.504 137.114 245.057 136.92Z",
    fill: "url(#paint26_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M201.589 113.174L192.694 108.033C191.528 107.356 191.672 106.161 193.025 105.384C193.724 104.998 194.502 104.78 195.299 104.748C196.096 104.715 196.889 104.869 197.617 105.196L206.512 110.337C207.692 111.014 207.534 112.195 206.181 112.987C205.482 113.373 204.704 113.59 203.907 113.623C203.11 113.655 202.317 113.502 201.589 113.174Z",
    fill: "#F7F8FA"
  }), React.createElement("path", {
    d: "M246.424 227.038C245.896 227.117 245.356 227.072 244.848 226.905C244.341 226.739 243.878 226.457 243.498 226.081C243.118 225.705 242.831 225.246 242.66 224.74C242.488 224.233 242.437 223.694 242.509 223.164V176.752C242.437 176.222 242.488 175.683 242.66 175.177C242.831 174.67 243.118 174.211 243.498 173.835C243.878 173.459 244.341 173.177 244.848 173.011C245.356 172.845 245.896 172.799 246.424 172.878C246.952 172.802 247.49 172.849 247.996 173.016C248.502 173.184 248.962 173.466 249.34 173.842C249.719 174.217 250.004 174.676 250.175 175.181C250.346 175.686 250.397 176.224 250.325 176.752V223.193C250.256 224.2 249.821 225.147 249.103 225.855C248.384 226.563 247.432 226.984 246.424 227.038Z",
    fill: "url(#paint27_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M255.809 254.082C255.28 254.161 254.741 254.116 254.233 253.949C253.725 253.783 253.263 253.501 252.883 253.125C252.503 252.749 252.216 252.29 252.044 251.784C251.872 251.277 251.821 250.738 251.894 250.209V241.179C251.823 240.651 251.877 240.113 252.049 239.609C252.222 239.104 252.51 238.647 252.889 238.273C253.269 237.899 253.73 237.618 254.237 237.453C254.743 237.287 255.282 237.242 255.809 237.32C256.335 237.241 256.873 237.286 257.379 237.452C257.885 237.617 258.346 237.898 258.725 238.273C259.103 238.647 259.39 239.105 259.56 239.61C259.731 240.114 259.782 240.652 259.709 241.179V250.209C259.647 251.22 259.216 252.174 258.496 252.889C257.777 253.603 256.821 254.028 255.809 254.082Z",
    fill: "url(#paint28_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M41.8382 288.298C39.2474 288.298 37.9376 287.002 37.9376 285.72V254.773C38.0028 253.763 38.4355 252.81 39.154 252.097C39.8726 251.383 40.8274 250.957 41.8382 250.9C42.3667 250.821 42.9063 250.866 43.4142 251.032C43.9221 251.199 44.3844 251.481 44.7643 251.857C45.1442 252.233 45.4314 252.692 45.603 253.198C45.7747 253.704 45.8261 254.244 45.7532 254.773V284.424C45.8261 284.953 45.7747 285.493 45.603 285.999C45.4314 286.505 45.1442 286.965 44.7643 287.341C44.3844 287.717 43.9221 287.999 43.4142 288.165C42.9063 288.331 42.3667 288.376 41.8382 288.298Z",
    fill: "url(#paint29_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M75.4754 253.535C72.8702 253.535 71.5748 252.239 71.5748 250.957V220.011C71.6369 218.999 72.0686 218.045 72.7878 217.331C73.507 216.617 74.4635 216.192 75.4754 216.137C76.0039 216.058 76.5435 216.104 77.0514 216.27C77.5593 216.436 78.0215 216.718 78.4015 217.094C78.7814 217.47 79.0685 217.929 79.2402 218.436C79.4119 218.942 79.4633 219.481 79.3904 220.011V249.661C79.4633 250.191 79.4119 250.73 79.2402 251.237C79.0685 251.743 78.7814 252.202 78.4015 252.578C78.0215 252.954 77.5593 253.236 77.0514 253.402C76.5435 253.568 76.0039 253.614 75.4754 253.535Z",
    fill: "url(#paint30_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M52.2158 196.409C50.906 196.409 48.3152 195.127 48.3152 193.831V157.729C48.3773 156.717 48.809 155.763 49.5282 155.049C50.2474 154.335 51.2039 153.91 52.2158 153.855C52.7432 153.779 53.2811 153.826 53.7871 153.993C54.2931 154.161 54.7534 154.443 55.1316 154.819C55.5098 155.194 55.7957 155.653 55.9665 156.158C56.1374 156.663 56.1887 157.201 56.1163 157.729V193.831C57.4261 195.127 56.1163 196.409 52.2158 196.409Z",
    fill: "url(#paint31_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M260.185 226.275C260.185 228.954 261.494 230.293 264.1 230.293C266.705 230.293 268 228.954 268 226.275C268 223.597 266.705 222.257 264.1 222.257C263.069 222.333 262.102 222.784 261.381 223.524C260.66 224.264 260.234 225.243 260.185 226.275Z",
    fill: "url(#paint32_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M45.3212 138.562C45.6683 138.558 46.0113 138.486 46.3303 138.349C46.6494 138.212 46.9384 138.014 47.1805 137.765C47.4226 137.516 47.6131 137.222 47.7411 136.899C47.8691 136.576 47.9321 136.231 47.9263 135.884C47.9321 135.536 47.8691 135.191 47.7411 134.868C47.6131 134.546 47.4226 134.251 47.1805 134.002C46.9384 133.753 46.6494 133.555 46.3303 133.418C46.0113 133.281 45.6683 133.209 45.3212 133.205C44.6213 133.216 43.9543 133.505 43.4662 134.007C42.978 134.508 42.7083 135.183 42.716 135.884C42.7083 136.584 42.978 137.259 43.4662 137.761C43.9543 138.263 44.6213 138.551 45.3212 138.562Z",
    fill: "url(#paint33_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M32.9891 155C34.6048 154.972 36.1435 154.324 37.2695 153.198C38.3955 152.072 39.0174 150.559 38.9996 148.989C39.0173 147.422 38.3947 145.911 37.2681 144.788C36.1415 143.666 34.6028 143.023 32.9891 143C31.3792 143.028 29.8462 143.674 28.7243 144.796C27.6025 145.918 26.9829 147.425 27.0007 148.989C26.977 150.557 27.594 152.07 28.7164 153.197C29.8389 154.323 31.3754 154.972 32.9891 155Z",
    fill: "url(#paint34_linear_8801_37918)"
  }), React.createElement("path", {
    d: "M68.8256 185.752C69.1728 185.748 69.5157 185.676 69.8348 185.539C70.1539 185.402 70.4428 185.204 70.6849 184.955C70.927 184.706 71.1175 184.412 71.2455 184.089C71.3735 183.766 71.4365 183.421 71.4308 183.074C71.4365 182.726 71.3735 182.381 71.2455 182.059C71.1175 181.736 70.927 181.441 70.6849 181.193C70.4428 180.944 70.1539 180.745 69.8348 180.608C69.5157 180.471 69.1728 180.399 68.8256 180.395C68.4785 180.399 68.1355 180.471 67.8164 180.608C67.4973 180.745 67.2084 180.944 66.9663 181.193C66.7242 181.441 66.5337 181.736 66.4057 182.059C66.2777 182.381 66.2147 182.726 66.2204 183.074C66.2147 183.421 66.2777 183.766 66.4057 184.089C66.5337 184.412 66.7242 184.706 66.9663 184.955C67.2084 185.204 67.4973 185.402 67.8164 185.539C68.1355 185.676 68.4785 185.748 68.8256 185.752Z",
    fill: "url(#paint35_linear_8801_37918)"
  })), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_8801_37918",
    x1: "122.167",
    y1: "66.9343",
    x2: "122.167",
    y2: "109.963",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_8801_37918",
    x1: "105.08",
    y1: "311.86",
    x2: "90.1101",
    y2: "357.928",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#86D6F5"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#86D6F5",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_8801_37918",
    x1: "210.754",
    y1: "306.333",
    x2: "226.806",
    y2: "355.597",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#86D6F5"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#86D6F5",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.497 323.334) scale(180.233 180.322)"
  }, React.createElement("stop", {
    stopColor: "#490F66"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#212C6B"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_8801_37918",
    x1: "86.1696",
    y1: "272.126",
    x2: "238.364",
    y2: "272.126",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.497 322.052) scale(180.233 180.322)"
  }, React.createElement("stop", {
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.678 250.122) scale(55.9036 55.9312)"
  }, React.createElement("stop", {
    stopColor: "#168B99"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-52673.8 35701.5) scale(12818.2 7404.38)"
  }, React.createElement("stop", {
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_8801_37918",
    x1: "168.802",
    y1: "265.862",
    x2: "150.101",
    y2: "112.384",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-19323.5 13714) scale(2027.77 1171.15)"
  }, React.createElement("stop", {
    stopColor: "#168B99"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-19912.5 13906.8) scale(2027.77 1170.66)"
  }, React.createElement("stop", {
    stopColor: "#168B99"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-20490.3 14106.7) scale(2026.74 1170.77)"
  }, React.createElement("stop", {
    stopColor: "#168B99"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_8801_37918",
    x1: "85.8672",
    y1: "213.646",
    x2: "127.003",
    y2: "213.646",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FAF1C2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5E48C"
  })), React.createElement("radialGradient", {
    id: "paint13_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-21678.2 14504.7) scale(2027.77 1170.81)"
  }, React.createElement("stop", {
    stopColor: "#168B99"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_8801_37918",
    x1: "-5935.22",
    y1: "4550.2",
    x2: "-5528.71",
    y2: "4550.2",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FAF1C2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5E48C"
  })), React.createElement("radialGradient", {
    id: "paint15_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15006.3 9421.46) scale(856.957 493.912)"
  }, React.createElement("stop", {
    stopColor: "#168B99"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_8801_37918",
    x1: "-5456.11",
    y1: "3987.83",
    x2: "-5049.37",
    y2: "3987.83",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FAF1C2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5E48C"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_8801_37918",
    x1: "-6663.36",
    y1: "4056.47",
    x2: "-6256.59",
    y2: "4056.47",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FAF1C2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F5E48C"
  })), React.createElement("radialGradient", {
    id: "paint18_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12716.8 6575.68) scale(5318.11 3072.3)"
  }, React.createElement("stop", {
    stopColor: "#168B99"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_8801_37918",
    x1: "257.892",
    y1: "117.592",
    x2: "257.892",
    y2: "134.675",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint20_radial_8801_37918",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-52673.8 30095.9) scale(12818.2 7405.25)"
  }, React.createElement("stop", {
    stopColor: "#304B7F"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#42206D"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#490F66"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_8801_37918",
    x1: "55.3248",
    y1: "141.903",
    x2: "267.914",
    y2: "141.903",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F7F8FA"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E5D4E7"
  })), React.createElement("linearGradient", {
    id: "paint22_linear_8801_37918",
    x1: "150.105",
    y1: "125.184",
    x2: "170.701",
    y2: "125.184",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E66BAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E8006F"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_8801_37918",
    x1: "-11968.4",
    y1: "6397.2",
    x2: "-10686.7",
    y2: "6397.2",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E66BAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E8006F"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_8801_37918",
    x1: "-5460.4",
    y1: "2978.31",
    x2: "-5165.2",
    y2: "2978.31",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E66BAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E8006F"
  })), React.createElement("linearGradient", {
    id: "paint25_linear_8801_37918",
    x1: "-3632.16",
    y1: "1943.48",
    x2: "-3467.4",
    y2: "1943.48",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E66BAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E8006F"
  })), React.createElement("linearGradient", {
    id: "paint26_linear_8801_37918",
    x1: "-3607.17",
    y1: "2726.32",
    x2: "-3353.79",
    y2: "2726.32",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E66BAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E8006F"
  })), React.createElement("linearGradient", {
    id: "paint27_linear_8801_37918",
    x1: "246.42",
    y1: "171.532",
    x2: "246.42",
    y2: "226.324",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint28_linear_8801_37918",
    x1: "255.804",
    y1: "236.876",
    x2: "255.804",
    y2: "253.886",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint29_linear_8801_37918",
    x1: "41.8644",
    y1: "249.958",
    x2: "41.8644",
    y2: "287.816",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint30_linear_8801_37918",
    x1: "75.5016",
    y1: "215.195",
    x2: "75.5016",
    y2: "253.053",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint31_linear_8801_37918",
    x1: "52.4646",
    y1: "152.792",
    x2: "52.4646",
    y2: "195.818",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint32_linear_8801_37918",
    x1: "264.1",
    y1: "230.091",
    x2: "264.1",
    y2: "222.905",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3C88C4",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  })), React.createElement("linearGradient", {
    id: "paint33_linear_8801_37918",
    x1: "-1669.01",
    y1: "-68.8058",
    x2: "-1673.67",
    y2: "-51.835",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3C88C4",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  })), React.createElement("linearGradient", {
    id: "paint34_linear_8801_37918",
    x1: "33.0044",
    y1: "142.71",
    x2: "33.0044",
    y2: "154.834",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint35_linear_8801_37918",
    x1: "68.8275",
    y1: "180.266",
    x2: "68.8275",
    y2: "185.678",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("clipPath", {
    id: "clip0_8801_37918"
  }, React.createElement("rect", {
    width: "237",
    height: "330",
    fill: "white",
    transform: "translate(31 68)"
  }))));
};

var token = function token(width, height) {
  if (width === void 0) {
    width = '284';
  }

  if (height === void 0) {
    height = '398';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 284 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M278.986 226.283C282.288 199.191 277.483 171.729 265.178 147.368C252.874 123.008 233.622 102.843 209.857 89.4226C186.093 76.0026 158.882 69.9305 131.667 71.974C104.452 74.0175 78.4533 84.0849 56.9592 100.903C35.4652 117.722 19.4406 140.536 10.9117 166.461C2.38273 192.386 1.73247 220.258 9.04309 246.552C16.3537 272.847 31.2969 296.383 51.9833 314.186C72.6696 331.988 98.1702 343.257 125.261 346.568C143.253 348.766 161.502 347.399 178.966 342.543C196.429 337.688 212.765 329.44 227.041 318.27C241.316 307.1 253.251 293.227 262.164 277.444C271.077 261.66 276.793 244.276 278.986 226.283Z",
    fill: "#36CEA2"
  }), React.createElement("path", {
    d: "M251.86 191.45C253.493 184.897 249.504 178.262 242.951 176.629C236.399 174.997 229.763 178.985 228.131 185.538C226.498 192.091 230.487 198.726 237.039 200.359C243.592 201.991 250.228 198.003 251.86 191.45Z",
    fill: "url(#paint0_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M240.443 188.477H239.159V328.467H240.443V188.477Z",
    fill: "url(#paint1_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M243.235 186.552C242.721 185.696 241.89 185.077 240.922 184.831C239.954 184.584 238.928 184.73 238.068 185.236C237.554 185.435 237.091 185.744 236.709 186.14C236.327 186.537 236.036 187.012 235.857 187.532C235.677 188.053 235.613 188.606 235.67 189.154C235.726 189.701 235.901 190.23 236.182 190.703C236.464 191.176 236.845 191.582 237.3 191.893C237.754 192.204 238.271 192.412 238.814 192.502C239.357 192.593 239.913 192.564 240.444 192.417C240.974 192.271 241.467 192.011 241.887 191.655C242.731 191.147 243.344 190.33 243.596 189.377C243.848 188.424 243.718 187.411 243.235 186.552Z",
    fill: "#A7F9EF"
  }), React.createElement("path", {
    d: "M23.0123 205.615C23.0123 205.615 23.0123 205.615 23.0123 205.808L17.4923 209.017V200.352C17.4715 200.324 17.4602 200.29 17.4602 200.256C17.4602 200.221 17.4715 200.187 17.4923 200.159L23.0123 196.95V205.615Z",
    fill: "url(#paint2_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M23.0121 218.26C23.0264 218.29 23.0338 218.323 23.0338 218.356C23.0338 218.389 23.0264 218.422 23.0121 218.452L17.4921 221.662V212.997C17.4752 212.967 17.4663 212.934 17.4663 212.9C17.4663 212.867 17.4752 212.833 17.4921 212.804L23.0121 209.595V218.26Z",
    fill: "url(#paint3_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M31.4207 207.412C31.435 207.442 31.4424 207.475 31.4424 207.509C31.4424 207.542 31.435 207.575 31.4207 207.605L25.9007 210.814V199.902C25.8864 199.872 25.879 199.84 25.879 199.806C25.879 199.773 25.8864 199.74 25.9007 199.71L31.4528 196.501L31.4207 207.412Z",
    fill: "url(#paint4_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M44.932 130.132C44.9461 130.157 44.9535 130.184 44.9535 130.212C44.9535 130.241 44.9461 130.268 44.932 130.293L39.412 133.502V124.837C39.3979 124.812 39.3905 124.785 39.3905 124.757C39.3905 124.728 39.3979 124.701 39.412 124.676L44.932 121.467V130.132Z",
    fill: "url(#paint5_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M44.9319 142.777C44.9462 142.807 44.9536 142.84 44.9536 142.873C44.9536 142.907 44.9462 142.939 44.9319 142.969L39.4119 146.179V137.514C39.395 137.484 39.3861 137.451 39.3861 137.417C39.3861 137.384 39.395 137.35 39.4119 137.321L44.9319 134.112V142.777Z",
    fill: "url(#paint6_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M53.34 131.929C53.3543 131.96 53.3617 131.992 53.3617 132.026C53.3617 132.059 53.3543 132.092 53.34 132.122L47.82 135.331V124.259C47.8057 124.229 47.7983 124.196 47.7983 124.163C47.7983 124.13 47.8057 124.097 47.82 124.067L53.34 121.05V131.929Z",
    fill: "url(#paint7_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M23.0121 231.065L17.3638 234.306V225.545L23.0121 222.271V231.065Z",
    fill: "url(#paint8_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M189.222 277.118L186.301 278.819V277.728L189.222 276.027V277.118Z",
    fill: "url(#paint9_linear_9599_45580)"
  }), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M137.841 302.6C136.584 301.867 135.156 301.481 133.701 301.481C132.246 301.481 130.818 301.867 129.561 302.6L80.202 331.035C80.029 331.137 79.8856 331.282 79.786 331.457C79.6864 331.631 79.634 331.829 79.634 332.03C79.634 332.23 79.6864 332.428 79.786 332.602C79.8856 332.777 80.029 332.922 80.202 333.024L129.978 361.908C131.09 362.554 132.352 362.893 133.637 362.893C134.922 362.893 136.184 362.554 137.295 361.908L187.136 333.024C187.316 332.925 187.467 332.778 187.572 332.6C187.677 332.423 187.732 332.22 187.732 332.014C187.732 331.807 187.677 331.605 187.572 331.427C187.467 331.249 187.316 331.103 187.136 331.003L137.841 302.6Z",
    fill: "url(#paint10_linear_9599_45580)"
  })), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M137.841 294.352C136.582 293.626 135.155 293.243 133.701 293.243C132.248 293.243 130.82 293.626 129.561 294.352L80.2021 322.69C80.0295 322.797 79.8871 322.945 79.7883 323.122C79.6894 323.299 79.6376 323.499 79.6376 323.701C79.6376 323.904 79.6894 324.103 79.7883 324.28C79.8871 324.457 80.0295 324.606 80.2021 324.712L129.978 353.596C131.09 354.241 132.352 354.581 133.637 354.581C134.922 354.581 136.184 354.241 137.296 353.596L187.136 324.712C187.317 324.612 187.467 324.466 187.572 324.288C187.677 324.11 187.732 323.908 187.732 323.701C187.732 323.495 187.677 323.292 187.572 323.115C187.467 322.937 187.317 322.79 187.136 322.69L137.841 294.352Z",
    fill: "url(#paint11_linear_9599_45580)"
  })), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M137.841 285.944C136.582 285.217 135.155 284.835 133.701 284.835C132.248 284.835 130.82 285.217 129.561 285.944L80.2021 314.378C80.0295 314.485 79.8871 314.633 79.7883 314.81C79.6894 314.987 79.6376 315.187 79.6376 315.389C79.6376 315.592 79.6894 315.791 79.7883 315.968C79.8871 316.145 80.0295 316.294 80.2021 316.4L129.978 345.284C131.095 345.914 132.355 346.245 133.637 346.245C134.919 346.245 136.179 345.914 137.296 345.284L187.136 316.4C187.317 316.3 187.467 316.154 187.572 315.976C187.677 315.798 187.732 315.596 187.732 315.389C187.732 315.183 187.677 314.98 187.572 314.802C187.467 314.625 187.317 314.478 187.136 314.378L137.841 285.944Z",
    fill: "url(#paint12_linear_9599_45580)"
  })), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M137.841 277.632C136.582 276.905 135.155 276.522 133.701 276.522C132.248 276.522 130.82 276.905 129.561 277.632L80.2021 306.066C80.0295 306.172 79.8871 306.321 79.7883 306.498C79.6894 306.675 79.6376 306.874 79.6376 307.077C79.6376 307.28 79.6894 307.479 79.7883 307.656C79.8871 307.833 80.0295 307.982 80.2021 308.088L129.978 336.972C131.095 337.602 132.355 337.933 133.637 337.933C134.919 337.933 136.179 337.602 137.296 336.972L187.136 308.248C187.317 308.148 187.467 308.002 187.572 307.824C187.677 307.646 187.732 307.444 187.732 307.237C187.732 307.031 187.677 306.828 187.572 306.651C187.467 306.473 187.317 306.326 187.136 306.227L137.841 277.632Z",
    fill: "url(#paint13_linear_9599_45580)"
  })), React.createElement("path", {
    d: "M187.136 306.098L137.841 277.632C136.583 276.905 135.155 276.522 133.701 276.522C132.248 276.522 130.82 276.905 129.561 277.632L80.2022 306.066C80.0227 306.17 79.8743 306.32 79.7726 306.5C79.671 306.681 79.6199 306.886 79.6246 307.093V332.029C79.6256 332.231 79.6794 332.429 79.7808 332.604C79.8821 332.778 80.0274 332.923 80.2022 333.024L129.979 361.908C131.09 362.553 132.352 362.893 133.637 362.893C134.922 362.893 136.184 362.553 137.296 361.908L187.136 333.024C187.319 332.93 187.473 332.788 187.58 332.612C187.688 332.437 187.745 332.235 187.746 332.029V307.189C187.764 306.967 187.715 306.745 187.607 306.551C187.498 306.357 187.334 306.199 187.136 306.098Z",
    fill: "url(#paint14_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M187.136 306.098L137.841 277.632C136.583 276.905 135.155 276.522 133.701 276.522C132.248 276.522 130.82 276.905 129.561 277.632L80.2022 306.066C80.0227 306.17 79.8743 306.32 79.7726 306.5C79.671 306.681 79.6199 306.886 79.6246 307.093L130.139 335.977C131.256 336.622 132.524 336.961 133.814 336.961C135.104 336.961 136.371 336.622 137.488 335.977L187.746 307.093C187.745 306.887 187.688 306.686 187.58 306.51C187.473 306.335 187.319 306.192 187.136 306.098Z",
    fill: "url(#paint15_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M187.136 306.965L137.296 335.688C136.179 336.318 134.919 336.649 133.637 336.649C132.355 336.649 131.095 336.318 129.979 335.688L80.2023 306.804C80.0238 306.7 79.8704 306.557 79.753 306.387C79.6121 306.657 79.5801 306.97 79.6637 307.263C79.7473 307.556 79.9401 307.805 80.2023 307.96L129.979 336.843C131.095 337.473 132.355 337.804 133.637 337.804C134.919 337.804 136.179 337.473 137.296 336.843L187.136 308.12C187.407 307.965 187.606 307.71 187.69 307.41C187.774 307.11 187.736 306.788 187.585 306.515C187.487 306.709 187.33 306.866 187.136 306.965Z",
    fill: "white"
  }), React.createElement("path", {
    opacity: "0.2",
    d: "M133.669 310.463C137.586 310.463 140.762 308.624 140.762 306.355C140.762 304.086 137.586 302.247 133.669 302.247C129.752 302.247 126.576 304.086 126.576 306.355C126.576 308.624 129.752 310.463 133.669 310.463Z",
    fill: "#180D5B"
  }), React.createElement("g", {
    opacity: "0.61"
  }, React.createElement("path", {
    opacity: "0.61",
    d: "M137.135 278.563C136.096 277.963 134.917 277.647 133.717 277.647C132.517 277.647 131.338 277.963 130.299 278.563L89.5732 302.023C89.4265 302.107 89.3047 302.229 89.22 302.375C89.1353 302.522 89.0907 302.688 89.0907 302.857C89.0907 303.026 89.1353 303.192 89.22 303.339C89.3047 303.485 89.4265 303.607 89.5732 303.691L130.62 327.376C131.535 327.912 132.576 328.194 133.637 328.194C134.697 328.194 135.739 327.912 136.654 327.376L177.765 303.691C177.911 303.607 178.033 303.485 178.118 303.339C178.203 303.192 178.247 303.026 178.247 302.857C178.247 302.688 178.203 302.522 178.118 302.375C178.033 302.229 177.911 302.107 177.765 302.023L137.135 278.563Z",
    fill: "url(#paint16_linear_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.61",
    d: "M137.135 271.695C136.096 271.095 134.917 270.779 133.717 270.779C132.517 270.779 131.338 271.095 130.299 271.695L89.5732 295.155C89.4265 295.239 89.3047 295.361 89.22 295.507C89.1353 295.654 89.0907 295.82 89.0907 295.989C89.0907 296.158 89.1353 296.324 89.22 296.471C89.3047 296.617 89.4265 296.739 89.5732 296.823L130.62 320.508C131.535 321.044 132.576 321.327 133.637 321.327C134.697 321.327 135.739 321.044 136.654 320.508L177.765 296.856C177.911 296.771 178.033 296.65 178.118 296.503C178.203 296.357 178.247 296.19 178.247 296.021C178.247 295.852 178.203 295.686 178.118 295.539C178.033 295.393 177.911 295.271 177.765 295.187L137.135 271.695Z",
    fill: "url(#paint17_linear_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.61",
    d: "M137.135 264.859C136.096 264.259 134.917 263.943 133.717 263.943C132.517 263.943 131.338 264.259 130.299 264.859L89.5732 288.287C89.4265 288.371 89.3047 288.493 89.22 288.639C89.1353 288.786 89.0907 288.952 89.0907 289.121C89.0907 289.29 89.1353 289.457 89.22 289.603C89.3047 289.75 89.4265 289.871 89.5732 289.956L130.62 313.608C131.556 314.152 132.619 314.439 133.701 314.439C134.783 314.439 135.846 314.152 136.782 313.608L177.893 289.923C178.04 289.839 178.162 289.717 178.246 289.571C178.331 289.424 178.376 289.258 178.376 289.089C178.376 288.92 178.331 288.754 178.246 288.607C178.162 288.461 178.04 288.339 177.893 288.255L137.135 264.859Z",
    fill: "url(#paint18_linear_9599_45580)"
  })), React.createElement("rect", {
    x: "213.484",
    y: "345.156",
    width: "1.54046",
    height: "1.54046",
    fill: "url(#pattern0)"
  }), React.createElement("rect", {
    x: "221.187",
    y: "291.239",
    width: "1.54046",
    height: "1.54046",
    fill: "url(#pattern1)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M213.24 224.352C213.614 216.509 207.559 209.848 199.716 209.474C191.873 209.1 185.212 215.155 184.838 222.998C184.464 230.841 190.519 237.502 198.362 237.876C206.205 238.25 212.866 232.195 213.24 224.352Z",
    fill: "url(#paint19_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M202.861 221.437C202.423 220.688 201.773 220.085 200.992 219.705C200.212 219.325 199.336 219.184 198.476 219.301C197.616 219.418 196.809 219.786 196.158 220.36C195.507 220.935 195.041 221.689 194.818 222.528C194.595 223.367 194.625 224.253 194.905 225.075C195.184 225.896 195.701 226.617 196.39 227.145C197.078 227.674 197.908 227.987 198.774 228.045C199.64 228.103 200.504 227.903 201.257 227.47C202.267 226.88 203.002 225.915 203.303 224.784C203.604 223.654 203.445 222.451 202.861 221.437Z",
    fill: "url(#paint20_radial_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M235.789 245.667C235.088 244.457 234.044 243.483 232.789 242.867C231.533 242.251 230.124 242.022 228.738 242.209C227.352 242.395 226.053 242.989 225.005 243.915C223.957 244.84 223.208 246.056 222.852 247.408C222.496 248.76 222.549 250.188 223.005 251.509C223.461 252.831 224.3 253.988 225.414 254.832C226.528 255.677 227.868 256.172 229.263 256.254C230.659 256.337 232.048 256.003 233.254 255.295C234.054 254.831 234.754 254.213 235.314 253.477C235.875 252.741 236.285 251.902 236.52 251.008C236.756 250.113 236.812 249.181 236.687 248.265C236.561 247.348 236.256 246.466 235.789 245.667Z",
    fill: "url(#paint21_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M231.585 248.138C231.442 247.889 231.251 247.671 231.024 247.496C230.796 247.321 230.536 247.192 230.259 247.118C229.982 247.043 229.693 247.024 229.408 247.062C229.123 247.099 228.849 247.192 228.6 247.336C228.098 247.626 227.731 248.103 227.581 248.662C227.43 249.222 227.509 249.819 227.798 250.321C228.087 250.823 228.564 251.19 229.124 251.34C229.684 251.491 230.28 251.412 230.783 251.123C231.032 250.98 231.25 250.789 231.425 250.562C231.6 250.334 231.729 250.075 231.803 249.797C231.878 249.52 231.897 249.231 231.859 248.946C231.822 248.661 231.729 248.387 231.585 248.138Z",
    fill: "url(#paint22_radial_9599_45580)"
  }), React.createElement("g", {
    opacity: "0.5"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M226.642 250.738C226.172 249.951 225.479 249.32 224.651 248.925C223.823 248.531 222.897 248.389 221.989 248.519C221.081 248.649 220.231 249.045 219.547 249.656C218.863 250.267 218.375 251.067 218.144 251.955C217.914 252.843 217.95 253.779 218.25 254.646C218.55 255.513 219.099 256.272 219.828 256.828C220.558 257.383 221.436 257.711 222.351 257.77C223.267 257.828 224.179 257.615 224.974 257.157C225.508 256.848 225.976 256.437 226.35 255.946C226.724 255.455 226.997 254.894 227.152 254.297C227.307 253.699 227.342 253.077 227.255 252.466C227.167 251.855 226.959 251.268 226.642 250.738Z",
    fill: "url(#paint23_radial_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.5",
    d: "M223.818 252.375C223.624 252.042 223.306 251.799 222.934 251.697C222.563 251.595 222.166 251.642 221.828 251.829C221.497 252.025 221.256 252.344 221.16 252.718C221.063 253.091 221.119 253.487 221.315 253.819C221.511 254.151 221.83 254.391 222.203 254.488C222.577 254.584 222.973 254.528 223.305 254.332C223.63 254.138 223.866 253.825 223.962 253.459C224.058 253.092 224.006 252.703 223.818 252.375Z",
    fill: "url(#paint24_radial_9599_45580)"
  })), React.createElement("path", {
    d: "M220.224 247.785C219.836 247.135 219.208 246.663 218.476 246.471C217.744 246.279 216.965 246.382 216.308 246.758C215.986 246.95 215.704 247.203 215.48 247.504C215.255 247.805 215.092 248.146 215 248.51C214.908 248.874 214.888 249.252 214.942 249.623C214.995 249.994 215.122 250.351 215.314 250.674C215.496 251.001 215.743 251.288 216.039 251.518C216.335 251.748 216.675 251.915 217.037 252.011C217.4 252.107 217.778 252.129 218.149 252.076C218.52 252.022 218.876 251.895 219.197 251.701C219.522 251.512 219.806 251.26 220.034 250.961C220.262 250.661 220.428 250.32 220.524 249.956C220.619 249.593 220.642 249.213 220.59 248.841C220.539 248.468 220.414 248.11 220.224 247.785Z",
    fill: "url(#paint25_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M218.395 248.78C218.335 248.679 218.256 248.591 218.162 248.521C218.068 248.452 217.961 248.402 217.847 248.375C217.733 248.348 217.614 248.344 217.499 248.364C217.383 248.384 217.273 248.428 217.175 248.491C217.075 248.547 216.987 248.623 216.918 248.715C216.849 248.806 216.799 248.911 216.772 249.022C216.745 249.134 216.741 249.249 216.761 249.362C216.78 249.475 216.823 249.583 216.886 249.679C216.943 249.778 217.018 249.865 217.109 249.935C217.199 250.005 217.303 250.057 217.413 250.087C217.523 250.116 217.639 250.124 217.752 250.109C217.865 250.094 217.975 250.057 218.074 250C218.276 249.879 218.424 249.684 218.484 249.456C218.544 249.228 218.512 248.985 218.395 248.78Z",
    fill: "url(#paint26_radial_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M223.594 209.338C222.839 208.034 221.714 206.983 220.362 206.319C219.009 205.656 217.49 205.408 215.997 205.609C214.504 205.81 213.104 206.449 211.975 207.447C210.845 208.444 210.038 209.755 209.655 211.212C209.271 212.669 209.329 214.207 209.821 215.631C210.313 217.055 211.217 218.301 212.418 219.21C213.619 220.12 215.063 220.653 216.567 220.74C218.071 220.828 219.567 220.468 220.866 219.704C222.597 218.686 223.855 217.025 224.366 215.083C224.877 213.141 224.599 211.076 223.594 209.338Z",
    fill: "url(#paint27_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M219.068 211.97C218.753 211.429 218.237 211.036 217.632 210.876C217.027 210.717 216.384 210.804 215.843 211.119C215.303 211.434 214.909 211.951 214.75 212.556C214.59 213.16 214.678 213.804 214.993 214.344C215.308 214.885 215.824 215.278 216.429 215.438C217.034 215.597 217.677 215.51 218.218 215.195C218.758 214.88 219.152 214.363 219.311 213.758C219.471 213.153 219.383 212.51 219.068 211.97Z",
    fill: "url(#paint28_radial_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M206.456 203.914C205.693 202.627 204.567 201.594 203.218 200.946C201.87 200.298 200.36 200.064 198.878 200.274C197.397 200.483 196.011 201.127 194.895 202.123C193.778 203.12 192.982 204.424 192.607 205.872C192.232 207.321 192.293 208.848 192.785 210.261C193.276 211.674 194.175 212.91 195.368 213.813C196.561 214.716 197.995 215.245 199.488 215.334C200.982 215.423 202.468 215.067 203.76 214.312C204.622 213.809 205.376 213.14 205.978 212.344C206.581 211.548 207.02 210.64 207.27 209.674C207.521 208.708 207.578 207.701 207.438 206.713C207.298 205.724 206.964 204.773 206.456 203.914Z",
    fill: "url(#paint29_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M201.159 209.762C202.254 209.074 202.583 207.627 201.894 206.532C201.205 205.437 199.759 205.107 198.664 205.796C197.569 206.485 197.239 207.931 197.928 209.027C198.617 210.122 200.063 210.451 201.159 209.762Z",
    fill: "url(#paint30_radial_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M55.394 245.827C65.0361 245.827 72.8526 238.011 72.8526 228.369C72.8526 218.727 65.0361 210.91 55.394 210.91C45.7519 210.91 37.9354 218.727 37.9354 228.369C37.9354 238.011 45.7519 245.827 55.394 245.827Z",
    fill: "url(#paint31_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M60.0477 225.641C59.5081 224.722 58.708 223.983 57.7485 223.518C56.7891 223.053 55.7133 222.883 54.6573 223.029C53.6012 223.176 52.6123 223.632 51.8155 224.34C51.0186 225.049 50.4497 225.977 50.1806 227.009C49.9115 228.041 49.9542 229.129 50.3035 230.136C50.6528 231.144 51.2928 232.025 52.1428 232.668C52.9927 233.312 54.0144 233.689 55.0787 233.752C56.143 233.815 57.2021 233.561 58.1221 233.023C58.7335 232.665 59.2683 232.19 59.6959 231.625C60.1236 231.06 60.4358 230.417 60.6146 229.731C60.7935 229.045 60.8354 228.331 60.7382 227.63C60.6409 226.928 60.4063 226.252 60.0477 225.641Z",
    fill: "url(#paint32_radial_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M77.1269 279.733C80.8193 275.288 80.2097 268.692 75.7653 265C71.3209 261.307 64.7246 261.917 61.0321 266.361C57.3397 270.806 57.9493 277.402 62.3937 281.094C66.8381 284.787 73.4344 284.177 77.1269 279.733Z",
    fill: "url(#paint33_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M89.7658 232.605C89.5065 232.08 89.1418 231.613 88.6943 231.234C88.2468 230.856 87.7261 230.574 87.1647 230.405C86.6033 230.237 86.0132 230.185 85.4312 230.255C84.8492 230.325 84.2877 230.513 83.7818 230.809C83.2759 231.105 82.8364 231.502 82.4907 231.976C82.145 232.449 81.9005 232.988 81.7724 233.56C81.6443 234.132 81.6353 234.725 81.7462 235.3C81.857 235.876 82.0851 236.422 82.4165 236.906C82.6757 237.432 83.0404 237.898 83.4879 238.277C83.9354 238.655 84.4561 238.938 85.0175 239.106C85.5789 239.275 86.169 239.326 86.751 239.256C87.333 239.187 87.8945 238.998 88.4004 238.702C88.9063 238.406 89.3458 238.009 89.6915 237.536C90.0372 237.062 90.2818 236.523 90.4099 235.951C90.538 235.379 90.5469 234.787 90.4361 234.211C90.3252 233.636 90.0971 233.089 89.7658 232.605Z",
    fill: "url(#paint34_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M87.2306 234.082C87.0508 233.785 86.761 233.571 86.4244 233.487C86.0879 233.403 85.7317 233.455 85.4334 233.633C85.2805 233.716 85.1462 233.829 85.0386 233.966C84.9309 234.103 84.8522 234.26 84.8071 234.428C84.7621 234.596 84.7517 234.771 84.7766 234.944C84.8015 235.116 84.8612 235.281 84.952 235.43C85.1265 235.732 85.4139 235.952 85.7509 236.043C86.0879 236.133 86.447 236.086 86.7492 235.911C87.0535 235.73 87.2746 235.437 87.3647 235.095C87.4547 234.753 87.4066 234.389 87.2306 234.082Z",
    fill: "url(#paint35_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M87.3266 220.153C86.7267 219.129 85.8367 218.306 84.7692 217.788C83.7016 217.27 82.5044 217.08 81.3289 217.242C80.1534 217.404 79.0523 217.911 78.1648 218.699C77.2774 219.487 76.6433 220.52 76.3429 221.668C76.0424 222.816 76.0891 224.027 76.4769 225.149C76.8647 226.27 77.5762 227.251 78.5216 227.969C79.467 228.686 80.6038 229.107 81.7883 229.178C82.9728 229.249 84.1518 228.968 85.1764 228.369C85.8606 227.974 86.4596 227.447 86.9388 226.819C87.4179 226.191 87.7676 225.474 87.9676 224.71C88.1676 223.946 88.2139 223.15 88.1039 222.367C87.9939 221.585 87.7297 220.833 87.3266 220.153Z",
    fill: "url(#paint36_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M83.7321 222.239C83.6124 222.026 83.4512 221.839 83.2579 221.689C83.0646 221.539 82.8432 221.43 82.6068 221.367C82.3705 221.304 82.1239 221.289 81.8817 221.323C81.6395 221.357 81.4066 221.44 81.1968 221.565C80.986 221.69 80.8019 221.854 80.6548 222.05C80.5077 222.245 80.4005 222.468 80.3394 222.705C80.2783 222.942 80.2645 223.188 80.2987 223.431C80.3329 223.673 80.4145 223.906 80.5389 224.117C80.6632 224.328 80.8278 224.512 81.0233 224.659C81.2188 224.806 81.4414 224.913 81.6783 224.974C81.9152 225.035 82.1619 225.049 82.4041 225.015C82.6464 224.981 82.8795 224.899 83.0903 224.775C83.3009 224.652 83.485 224.489 83.6316 224.295C83.7783 224.1 83.8847 223.878 83.9445 223.642C84.0043 223.406 84.0163 223.16 83.9798 222.919C83.9433 222.678 83.8591 222.447 83.7321 222.239Z",
    fill: "url(#paint37_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M82.545 232.894C82.2802 232.411 81.877 232.019 81.3873 231.767C80.8976 231.515 80.3437 231.416 79.7969 231.481C79.2501 231.546 78.7354 231.774 78.319 232.134C77.9026 232.495 77.6034 232.971 77.4601 233.503C77.3168 234.035 77.3358 234.597 77.5147 235.118C77.6936 235.639 78.0242 236.094 78.464 236.426C78.9038 236.757 79.4327 236.949 79.9827 236.978C80.5326 237.006 81.0785 236.869 81.5501 236.585C82.1602 236.217 82.6044 235.628 82.7899 234.94C82.9753 234.252 82.8875 233.519 82.545 232.894Z",
    fill: "url(#paint38_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M80.908 233.857C80.852 233.757 80.776 233.67 80.6846 233.6C80.5933 233.531 80.4886 233.481 80.3772 233.454C80.2658 233.427 80.15 233.423 80.037 233.443C79.924 233.462 79.8163 233.505 79.7206 233.568C79.6215 233.621 79.5347 233.694 79.4656 233.782C79.3965 233.871 79.3467 233.973 79.3195 234.082C79.2923 234.191 79.2882 234.304 79.3075 234.415C79.3269 234.525 79.3692 234.63 79.4318 234.724C79.4852 234.822 79.5579 234.908 79.6454 234.978C79.733 235.048 79.8336 235.099 79.9414 235.129C80.0492 235.159 80.1619 235.167 80.2728 235.152C80.3838 235.138 80.4906 235.101 80.5871 235.044C80.7815 234.924 80.923 234.735 80.9826 234.514C81.0422 234.294 81.0155 234.059 80.908 233.857Z",
    fill: "url(#paint39_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M112.744 222.175C112.561 221.861 112.317 221.587 112.028 221.367C111.738 221.147 111.408 220.986 111.057 220.894C110.705 220.801 110.339 220.779 109.978 220.828C109.618 220.877 109.271 220.997 108.957 221.18C108.643 221.364 108.368 221.607 108.148 221.897C107.928 222.186 107.768 222.516 107.675 222.868C107.583 223.22 107.561 223.586 107.61 223.946C107.659 224.306 107.779 224.653 107.962 224.967C108.142 225.286 108.383 225.564 108.672 225.787C108.961 226.01 109.292 226.173 109.645 226.266C109.998 226.359 110.367 226.38 110.728 226.327C111.089 226.275 111.437 226.151 111.749 225.962C112.064 225.78 112.34 225.537 112.56 225.247C112.781 224.958 112.942 224.628 113.034 224.276C113.127 223.924 113.149 223.557 113.099 223.197C113.049 222.836 112.929 222.489 112.744 222.175Z",
    fill: "url(#paint40_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M111.108 223.138C110.988 222.943 110.796 222.803 110.573 222.748C110.351 222.694 110.116 222.73 109.92 222.849C109.821 222.902 109.734 222.975 109.665 223.063C109.596 223.152 109.546 223.254 109.519 223.362C109.492 223.471 109.488 223.585 109.507 223.695C109.526 223.806 109.569 223.911 109.631 224.004C109.685 224.103 109.757 224.189 109.845 224.259C109.933 224.328 110.033 224.38 110.141 224.41C110.249 224.44 110.361 224.448 110.472 224.433C110.583 224.419 110.69 224.382 110.787 224.325C110.981 224.205 111.123 224.016 111.182 223.795C111.242 223.574 111.215 223.339 111.108 223.138Z",
    fill: "url(#paint41_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M272.918 181.36C274.55 174.807 270.562 168.171 264.009 166.539C257.456 164.906 250.821 168.895 249.188 175.448C247.556 182 251.544 188.636 258.097 190.268C264.65 191.901 271.285 187.912 272.918 181.36Z",
    fill: "url(#paint42_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M261.495 178.4H260.212V318.39H261.495V178.4Z",
    fill: "url(#paint43_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M264.32 176.475C263.945 175.825 263.387 175.302 262.715 174.97C262.043 174.639 261.287 174.514 260.544 174.612C259.801 174.71 259.104 175.026 258.541 175.52C257.977 176.015 257.574 176.665 257.38 177.389C257.187 178.113 257.213 178.878 257.454 179.588C257.696 180.297 258.143 180.919 258.738 181.374C259.333 181.829 260.05 182.098 260.798 182.146C261.546 182.193 262.291 182.018 262.94 181.642C263.8 181.133 264.427 180.306 264.685 179.34C264.943 178.374 264.812 177.345 264.32 176.475Z",
    fill: "#A7F9EF"
  }), React.createElement("path", {
    d: "M263.627 165.576C265.26 159.024 261.271 152.388 254.719 150.755C248.166 149.123 241.53 153.111 239.898 159.664C238.265 166.217 242.254 172.852 248.807 174.485C255.359 176.118 261.995 172.129 263.627 165.576Z",
    fill: "url(#paint44_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M252.22 162.578H250.937V302.568H252.22V162.578Z",
    fill: "url(#paint45_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M255.013 160.685C254.62 160.054 254.052 159.553 253.377 159.244C252.702 158.934 251.951 158.83 251.218 158.943C250.484 159.057 249.8 159.384 249.251 159.883C248.701 160.382 248.311 161.032 248.127 161.751C247.944 162.471 247.977 163.228 248.22 163.929C248.464 164.631 248.909 165.245 249.499 165.695C250.089 166.146 250.798 166.413 251.539 166.464C252.28 166.514 253.019 166.346 253.665 165.98C254.109 165.728 254.497 165.39 254.807 164.984C255.117 164.578 255.341 164.114 255.467 163.62C255.593 163.125 255.618 162.61 255.54 162.106C255.462 161.601 255.282 161.118 255.013 160.685Z",
    fill: "#A7F9EF"
  }), React.createElement("path", {
    d: "M40.5198 267.499C42.1524 260.946 38.1638 254.31 31.6111 252.678C25.0584 251.045 18.4229 255.034 16.7904 261.587C15.1578 268.139 19.1464 274.775 25.6991 276.407C32.2518 278.04 38.8873 274.051 40.5198 267.499Z",
    fill: "url(#paint46_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M28.1792 264.538H29.4629L29.4629 124.548H28.1792L28.1792 264.538Z",
    fill: "url(#paint47_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M25.3871 266.431C25.7645 267.079 26.3258 267.601 26.9998 267.929C27.6739 268.258 28.4304 268.379 29.1734 268.278C29.9164 268.176 30.6125 267.856 31.1734 267.358C31.7343 266.86 32.1348 266.207 32.3241 265.482C32.5134 264.756 32.483 263.99 32.2367 263.282C31.9904 262.574 31.5394 261.954 30.9408 261.503C30.3421 261.051 29.6229 260.787 28.8741 260.745C28.1254 260.702 27.3809 260.883 26.735 261.264C25.8798 261.779 25.2599 262.607 25.008 263.573C24.756 264.539 24.8921 265.565 25.3871 266.431Z",
    fill: "#A7F9EF"
  }), React.createElement("path", {
    d: "M47.8235 281.33C49.456 274.778 45.4674 268.142 38.9147 266.51C32.362 264.877 25.7265 268.866 24.094 275.418C22.4614 281.971 26.45 288.607 33.0027 290.239C39.5554 291.872 46.1909 287.883 47.8235 281.33Z",
    fill: "url(#paint48_radial_9599_45580)"
  }), React.createElement("path", {
    d: "M35.4964 278.37H36.7802L36.7802 138.38H35.4964L35.4964 278.37Z",
    fill: "url(#paint49_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M32.7043 280.296C33.0824 280.94 33.643 281.459 34.3153 281.786C34.9877 282.113 35.7417 282.233 36.4824 282.132C37.2232 282.031 37.9174 281.713 38.4778 281.219C39.0381 280.724 39.4395 280.074 39.6313 279.352C39.8231 278.629 39.7967 277.866 39.5555 277.158C39.3143 276.451 38.8691 275.83 38.276 275.375C37.6828 274.92 36.9683 274.651 36.2223 274.601C35.4764 274.552 34.7325 274.724 34.0843 275.097C33.6507 275.346 33.2707 275.678 32.9663 276.075C32.6619 276.472 32.4391 276.925 32.3108 277.408C32.1825 277.892 32.1512 278.396 32.2188 278.891C32.2863 279.387 32.4513 279.864 32.7043 280.296Z",
    fill: "#A7F9EF"
  }), React.createElement("path", {
    d: "M217.015 80.2278L186.526 62.673C170.865 53.2376 149.17 54.3288 125.1 68.225C78.0199 95.3757 39.8292 161.263 39.8292 215.307C39.8292 243.228 50.0669 262.516 66.4343 270.892L97.1152 288.544L106.486 272.24C112.978 270.121 119.219 267.302 125.1 263.832C172.085 236.585 210.371 170.891 210.371 116.846C210.427 109.688 209.651 102.548 208.061 95.5683L217.015 80.2278Z",
    fill: "url(#paint50_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M215.771 218.822C249.28 161.501 249.625 99.3567 216.543 80.0172C183.461 60.6778 129.478 91.4672 95.9696 148.787C62.4611 206.107 62.1154 268.252 95.1977 287.592C128.28 306.931 182.262 276.142 215.771 218.822Z",
    fill: "url(#paint51_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M194.132 74.2583V75.6062C222.278 75.6062 239.768 98.0713 239.768 134.561C239.768 188.092 201.834 253.53 155.203 280.456C143.872 287.533 130.878 291.507 117.526 291.977C89.3804 291.977 71.9218 269.512 71.9218 233.022C71.9218 179.523 109.856 114.054 156.487 87.1276C167.809 80.0554 180.791 76.0823 194.132 75.6062V74.2583ZM194.132 74.2583C180.636 74.7835 167.508 78.8092 156.038 85.9402C108.957 113.155 70.7665 179.01 70.7665 233.022C70.7665 271.277 90.0223 293.357 117.751 293.357C131.327 292.814 144.525 288.732 156.038 281.515C203.118 254.332 241.309 188.445 241.309 134.433C241.148 96.3383 222.021 74.2583 194.132 74.2583Z",
    fill: "#DEFCF2"
  }), React.createElement("path", {
    d: "M201.53 210.497C227.068 166.81 227.329 119.445 202.112 104.703C176.895 89.9618 135.749 113.426 110.211 157.112C84.6721 200.799 84.4117 248.164 109.629 262.905C134.846 277.647 175.992 254.183 201.53 210.497Z",
    fill: "url(#paint52_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M200.583 103.88C207.772 111.743 211.976 123.81 211.976 139.471C211.976 180.679 182.868 230.872 146.988 251.572C129.657 261.585 113.932 262.869 102.282 256.932C113.996 269.769 133.637 271.213 155.877 258.376C191.757 237.644 220.866 187.45 220.866 146.275C220.866 124.965 213.067 110.267 200.583 103.88Z",
    fill: "url(#paint53_linear_9599_45580)"
  }), React.createElement("path", {
    opacity: "0.2",
    d: "M171.025 210.365L191.18 190.628L146.442 128.72L145.576 146.821L102.699 231.963L102.057 248.588L171.025 210.365Z",
    fill: "url(#paint54_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M183.06 185.557L154.562 133.759L146.442 128.72L102.699 231.963L110.819 237.002L183.06 185.557Z",
    fill: "url(#paint55_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M191.18 190.628L154.562 133.759L110.819 237.002L191.18 190.628Z",
    fill: "url(#paint56_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M191.18 190.628L154.562 133.759V186.038L191.18 190.628Z",
    fill: "url(#paint57_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M191.18 190.628L154.562 133.759V186.038L191.18 190.628Z",
    fill: "url(#paint58_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M154.562 186.038V133.759L110.819 237.002L154.562 186.038Z",
    fill: "url(#paint59_linear_9599_45580)"
  }), React.createElement("path", {
    d: "M191.18 190.628L153.952 135.909L154.626 136.583L110.819 237.002L154.562 133.759L191.18 190.628Z",
    fill: "#DEFCF2"
  }), React.createElement("defs", null, React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, React.createElement("use", {
    transform: "scale(0.5 0.333333)"
  })), React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, React.createElement("use", {
    transform: "scale(0.5 0.333333)"
  })), React.createElement("radialGradient", {
    id: "paint0_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.973 226.869) rotate(-30.2031) scale(12.2787)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_9599_45580",
    x1: "239.801",
    y1: "191.269",
    x2: "239.801",
    y2: "326.702",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_9599_45580",
    x1: "20.1881",
    y1: "208.985",
    x2: "20.1881",
    y2: "196.95",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_9599_45580",
    x1: "82.4387",
    y1: "853.247",
    x2: "82.4387",
    y2: "808.116",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_9599_45580",
    x1: "105.528",
    y1: "911.603",
    x2: "105.528",
    y2: "847.908",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_9599_45580",
    x1: "142.362",
    y1: "432.93",
    x2: "142.362",
    y2: "387.799",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_9599_45580",
    x1: "142.44",
    y1: "493.949",
    x2: "142.44",
    y2: "448.818",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_9599_45580",
    x1: "165.296",
    y1: "498.65",
    x2: "165.296",
    y2: "435.098",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_9599_45580",
    x1: "83.2802",
    y1: "911.75",
    x2: "83.2802",
    y2: "866.619",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_9599_45580",
    x1: "372.889",
    y1: "474.713",
    x2: "372.889",
    y2: "472.284",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_9599_45580",
    x1: "79.6243",
    y1: "332.126",
    x2: "187.746",
    y2: "332.126",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_9599_45580",
    x1: "3343.01",
    y1: "5518.04",
    x2: "6984.71",
    y2: "5518.04",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_9599_45580",
    x1: "3343.01",
    y1: "5356.09",
    x2: "6984.71",
    y2: "5356.09",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_9599_45580",
    x1: "3343.01",
    y1: "5188.72",
    x2: "6984.71",
    y2: "5188.72",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_9599_45580",
    x1: "79.6246",
    y1: "319.641",
    x2: "187.746",
    y2: "319.641",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_9599_45580",
    x1: "79.6246",
    y1: "306.804",
    x2: "187.746",
    y2: "306.804",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_9599_45580",
    x1: "4282.12",
    y1: "4696.02",
    x2: "4282.12",
    y2: "4166.28",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_9599_45580",
    x1: "4276.77",
    y1: "4591.6",
    x2: "4279.35",
    y2: "3947.6",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_9599_45580",
    x1: "4288.16",
    y1: "4389.94",
    x2: "4288.16",
    y2: "3969.31",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint19_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.936 245.714) rotate(-30.4853) scale(14.2747)"
  }, React.createElement("stop", {
    stopColor: "#53A5F8"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#446AB6"
  }), React.createElement("stop", {
    offset: "0.79",
    stopColor: "#312061"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A023F"
  })), React.createElement("radialGradient", {
    id: "paint20_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.956 190.531) rotate(-30.1735) scale(4.37382)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint21_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11008.1 26409) rotate(-30.1735) scale(31.0704 31.0446)"
  }, React.createElement("stop", {
    stopColor: "#53A5F8"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#446AB6"
  }), React.createElement("stop", {
    offset: "0.79",
    stopColor: "#312061"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A023F"
  })), React.createElement("radialGradient", {
    id: "paint22_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1404.05 -11139.1) scale(2.9729)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint23_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6260.43 14734.3) rotate(-30.1735) scale(13.4248)"
  }, React.createElement("stop", {
    stopColor: "#53A5F8"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#446AB6"
  }), React.createElement("stop", {
    offset: "0.79",
    stopColor: "#312061"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A023F"
  })), React.createElement("radialGradient", {
    id: "paint24_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-866.756 -7274.13) scale(1.30298 1.30039)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint25_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.387 216.006) rotate(-30.1736) scale(2.84138)"
  }, React.createElement("stop", {
    stopColor: "#41E5DE"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#39B8C3"
  }), React.createElement("stop", {
    offset: "0.13",
    stopColor: "#3190AA"
  }), React.createElement("stop", {
    offset: "0.2",
    stopColor: "#2A6C95"
  }), React.createElement("stop", {
    offset: "0.27",
    stopColor: "#254E83"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#203674"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#1C2469"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#1A1761"
  }), React.createElement("stop", {
    offset: "0.7",
    stopColor: "#180F5C"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#180D5B"
  })), React.createElement("radialGradient", {
    id: "paint26_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-447.724 -4344.75) scale(0.494255)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint27_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12030.2 28922.1) rotate(-30.1735) scale(35.7134)"
  }, React.createElement("stop", {
    stopColor: "#53A5F8"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#446AB6"
  }), React.createElement("stop", {
    offset: "0.79",
    stopColor: "#312061"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A023F"
  })), React.createElement("radialGradient", {
    id: "paint28_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1535.05 -12019.5) scale(3.44359)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint29_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11875.2 28754.5) rotate(-30.1735) scale(35.5627)"
  }, React.createElement("stop", {
    stopColor: "#53A5F8"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#446AB6"
  }), React.createElement("stop", {
    offset: "0.79",
    stopColor: "#312061"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A023F"
  })), React.createElement("radialGradient", {
    id: "paint30_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1787.85 3536.98) rotate(-30.4516) scale(3.42201)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint31_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29388.7 76754.8) rotate(-30.1735) scale(188.959)"
  }, React.createElement("stop", {
    stopColor: "#53A5F8"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#446AB6"
  }), React.createElement("stop", {
    offset: "0.79",
    stopColor: "#312061"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A023F"
  })), React.createElement("radialGradient", {
    id: "paint32_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4444.45 -27504.6) scale(18.1159)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint33_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16784.6 43301.1) rotate(-30.3948) scale(68.187)"
  }, React.createElement("stop", {
    stopColor: "#53A5F8"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#446AB6"
  }), React.createElement("stop", {
    offset: "0.79",
    stopColor: "#312061"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A023F"
  })), React.createElement("radialGradient", {
    id: "paint34_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3540.24 -23129.6) scale(11.7623 12.0519)"
  }, React.createElement("stop", {
    stopColor: "#41E5DE"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#39B8C3"
  }), React.createElement("stop", {
    offset: "0.13",
    stopColor: "#3190AA"
  }), React.createElement("stop", {
    offset: "0.2",
    stopColor: "#2A6C95"
  }), React.createElement("stop", {
    offset: "0.27",
    stopColor: "#254E83"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#203674"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#1C2469"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#1A1761"
  }), React.createElement("stop", {
    offset: "0.7",
    stopColor: "#180F5C"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#180D5B"
  })), React.createElement("radialGradient", {
    id: "paint35_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-998.719 -6570.55) scale(1.0847 1.08214)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint36_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4835.24 -30679.9) scale(22.4676 22.4452)"
  }, React.createElement("stop", {
    stopColor: "#41E5DE"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#39B8C3"
  }), React.createElement("stop", {
    offset: "0.13",
    stopColor: "#3190AA"
  }), React.createElement("stop", {
    offset: "0.2",
    stopColor: "#2A6C95"
  }), React.createElement("stop", {
    offset: "0.27",
    stopColor: "#254E83"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#203674"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#1C2469"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#1A1761"
  }), React.createElement("stop", {
    offset: "0.7",
    stopColor: "#180F5C"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#180D5B"
  })), React.createElement("radialGradient", {
    id: "paint37_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1440.39 -9374.73) scale(2.15761 2.16214)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint38_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2191.69 -13992.7) scale(4.7472)"
  }, React.createElement("stop", {
    stopColor: "#41E5DE"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#39B8C3"
  }), React.createElement("stop", {
    offset: "0.13",
    stopColor: "#3190AA"
  }), React.createElement("stop", {
    offset: "0.2",
    stopColor: "#2A6C95"
  }), React.createElement("stop", {
    offset: "0.27",
    stopColor: "#254E83"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#203674"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#1C2469"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#1A1761"
  }), React.createElement("stop", {
    offset: "0.7",
    stopColor: "#180F5C"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#180D5B"
  })), React.createElement("radialGradient", {
    id: "paint39_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-626.977 -4221.71) scale(0.463907 0.466808)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint40_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2115.61 -14098.1) scale(4.76485 4.77535)"
  }, React.createElement("stop", {
    stopColor: "#41E5DE"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#39B8C3"
  }), React.createElement("stop", {
    offset: "0.13",
    stopColor: "#3190AA"
  }), React.createElement("stop", {
    offset: "0.2",
    stopColor: "#2A6C95"
  }), React.createElement("stop", {
    offset: "0.27",
    stopColor: "#254E83"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#203674"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#1C2469"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#1A1761"
  }), React.createElement("stop", {
    offset: "0.7",
    stopColor: "#180F5C"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#180D5B"
  })), React.createElement("radialGradient", {
    id: "paint41_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-579.939 -4202.79) scale(0.463907 0.463367)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("radialGradient", {
    id: "paint42_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2369.54 1141.2) scale(93.173)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint43_linear_9599_45580",
    x1: "371.459",
    y1: "5881.58",
    x2: "371.459",
    y2: "11789.1",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint44_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21642.1 51434.7) rotate(-30.203) scale(93.5636)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint45_linear_9599_45580",
    x1: "358.474",
    y1: "5175.61",
    x2: "358.474",
    y2: "11083.2",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint46_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72336.3 28533.7) rotate(180) scale(93.173)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint47_linear_9599_45580",
    x1: "28.821",
    y1: "261.746",
    x2: "28.821",
    y2: "126.313",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint48_radial_9599_45580",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53355.6 -21393.8) rotate(149.797) scale(93.5636)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint49_linear_9599_45580",
    x1: "36.1383",
    y1: "275.578",
    x2: "36.1383",
    y2: "140.145",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint50_linear_9599_45580",
    x1: "187.746",
    y1: "64.1171",
    x2: "58.5394",
    y2: "274.391",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#3A8FA2"
  }), React.createElement("stop", {
    offset: "0.84",
    stopColor: "#387E97"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#385397"
  })), React.createElement("linearGradient", {
    id: "paint51_linear_9599_45580",
    x1: "235.181",
    y1: "63.7286",
    x2: "87.5848",
    y2: "287.256",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.17",
    stopColor: "#AAF4F1"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#BDF7F4"
  }), React.createElement("stop", {
    offset: "0.38",
    stopColor: "#E6FCFB"
  }), React.createElement("stop", {
    offset: "0.5",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.63",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.84",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#DAFAF9"
  })), React.createElement("linearGradient", {
    id: "paint52_linear_9599_45580",
    x1: "198.177",
    y1: "106.669",
    x2: "80.6527",
    y2: "320.954",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint53_linear_9599_45580",
    x1: "135.755",
    y1: "262.709",
    x2: "253.761",
    y2: "51.2156",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.06",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#3A8FA2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#387E97"
  })), React.createElement("linearGradient", {
    id: "paint54_linear_9599_45580",
    x1: "152.764",
    y1: "232.862",
    x2: "142.43",
    y2: "210.525",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#180D5B"
  })), React.createElement("linearGradient", {
    id: "paint55_linear_9599_45580",
    x1: "4820.69",
    y1: "3325.2",
    x2: "1190.27",
    y2: "8367.27",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.06",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#3A8FA2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#387E97"
  })), React.createElement("linearGradient", {
    id: "paint56_linear_9599_45580",
    x1: "165.923",
    y1: "146.917",
    x2: "128.855",
    y2: "313.223",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A54D3"
  })), React.createElement("linearGradient", {
    id: "paint57_linear_9599_45580",
    x1: "180.332",
    y1: "128.624",
    x2: "163.195",
    y2: "205.551",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2A54D3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#43E8E1"
  })), React.createElement("linearGradient", {
    id: "paint58_linear_9599_45580",
    x1: "139.189",
    y1: "137.642",
    x2: "201.321",
    y2: "227.695",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2A54D3",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint59_linear_9599_45580",
    x1: "133.284",
    y1: "185.685",
    x2: "151.609",
    y2: "194.222",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2E6DD5"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  })), React.createElement("image", {
    id: "image0_9599_45580",
    width: "2",
    height: "3"
  })));
};

var lazyNft = function lazyNft(width, height) {
  if (width === void 0) {
    width = '289';
  }

  if (height === void 0) {
    height = '398';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 289 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M279.639 225.452C282.949 198.296 278.132 170.769 265.798 146.35C253.464 121.932 234.167 101.718 210.346 88.2667C186.525 74.8148 159.25 68.7283 131.97 70.7767C104.69 72.8251 78.63 82.9164 57.0849 99.7746C35.5398 116.633 19.4772 139.501 10.9281 165.488C2.3789 191.474 1.72709 219.412 9.05506 245.769C16.383 272.126 31.3617 295.719 52.0972 313.563C72.8326 331.408 98.3937 342.704 125.548 346.022C143.583 348.226 161.876 346.855 179.381 341.988C196.886 337.121 213.261 328.854 227.57 317.657C241.879 306.461 253.843 292.555 262.777 276.734C271.711 260.913 277.441 243.487 279.639 225.452Z",
    fill: "#FF6CD0"
  }), React.createElement("path", {
    d: "M83.8893 133.126L104.349 130.392L118.053 123.186C118.053 123.186 135.199 126.403 117.796 110.318C107.148 100.506 99.7165 101.665 83.1172 89.3115C70.5391 79.9181 65.5529 73.8703 58.6365 74.1599C52.1061 85.9981 79.4499 122.51 83.8893 133.126Z",
    fill: "url(#paint0_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M55.4196 165.392C55.4196 165.392 42.0694 152.138 45.7689 120.162C47.3096 104.65 51.2038 89.4639 57.3176 75.125C57.477 74.8147 57.7261 74.5596 58.0326 74.3929C58.339 74.2262 58.6885 74.1556 59.0356 74.1903C59.3827 74.225 59.7114 74.3634 59.9787 74.5875C60.246 74.8116 60.4397 75.111 60.5345 75.4467C63.3011 85.8695 86.7846 101.986 99.5557 123.7L55.4196 165.392Z",
    fill: "url(#paint1_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M226.174 74.192C219.225 73.9024 214.271 79.9502 201.661 89.3436C185.094 101.697 177.662 100.667 167.014 110.318C149.45 126.403 166.628 123.186 166.628 123.186L180.3 130.456L200.792 133.19C205.231 122.51 232.575 85.9981 226.174 74.192Z",
    fill: "url(#paint2_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M185.094 123.668C197.961 102.018 221.348 85.9017 224.115 75.4146C224.21 75.0789 224.403 74.7795 224.671 74.5554C224.938 74.3313 225.267 74.1929 225.614 74.1582C225.961 74.1234 226.31 74.194 226.617 74.3608C226.923 74.5275 227.172 74.7826 227.332 75.0929C233.432 89.4362 237.326 104.621 238.88 120.13C242.58 152.106 229.23 165.36 229.23 165.36L185.094 123.668Z",
    fill: "url(#paint3_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M232.414 252.603C274.234 204.349 204.91 105.493 143.306 107.552C119.983 105.847 65.1991 127.979 47.7634 180.158C-1.77711 294.262 186.702 308.03 232.414 252.603Z",
    fill: "url(#paint4_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M183.549 186.302C196.697 186.302 207.355 176.926 207.355 165.359C207.355 153.793 196.697 144.417 183.549 144.417C170.402 144.417 159.744 153.793 159.744 165.359C159.744 176.926 170.402 186.302 183.549 186.302Z",
    fill: "url(#paint5_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M101.1 186.302C114.247 186.302 124.905 176.926 124.905 165.359C124.905 153.793 114.247 144.417 101.1 144.417C87.9526 144.417 77.2946 153.793 77.2946 165.359C77.2946 176.926 87.9526 186.302 101.1 186.302Z",
    fill: "url(#paint6_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M150.544 209.335C148.922 209.412 147.326 208.91 146.04 207.92C144.976 206.995 144.317 205.69 144.206 204.284V196.886C144.206 196.752 144.233 196.62 144.285 196.496C144.337 196.373 144.414 196.262 144.51 196.169C144.606 196.076 144.72 196.003 144.844 195.955C144.969 195.907 145.102 195.884 145.236 195.888C145.503 195.888 145.761 195.992 145.953 196.178C146.145 196.365 146.257 196.618 146.265 196.886V204.252C146.352 205.079 146.756 205.84 147.391 206.375C148.076 206.826 148.847 207.13 149.656 207.268C150.464 207.407 151.292 207.376 152.088 207.18C153.847 206.902 155.437 205.975 156.545 204.581C157.653 203.187 158.198 201.428 158.071 199.652C158.063 199.384 158.158 199.124 158.339 198.926C158.519 198.727 158.769 198.607 159.036 198.591C159.173 198.565 159.314 198.572 159.447 198.61C159.581 198.648 159.704 198.716 159.807 198.81C159.91 198.903 159.989 199.019 160.04 199.148C160.09 199.278 160.11 199.417 160.098 199.556C160.269 201.842 159.568 204.109 158.135 205.899C156.703 207.69 154.646 208.871 152.377 209.206C151.77 209.295 151.157 209.338 150.544 209.335Z",
    fill: "#051140"
  }), React.createElement("path", {
    d: "M138.963 209.335C138.363 209.382 137.761 209.382 137.162 209.335C134.887 209.007 132.822 207.829 131.383 206.037C129.944 204.246 129.239 201.975 129.409 199.684C129.425 199.417 129.546 199.166 129.744 198.986C129.942 198.806 130.203 198.71 130.47 198.719C130.741 198.735 130.994 198.854 131.18 199.052C131.365 199.249 131.468 199.51 131.468 199.781C131.349 201.555 131.896 203.31 133.003 204.702C134.109 206.095 135.695 207.024 137.451 207.308C138.247 207.503 139.075 207.532 139.883 207.394C140.691 207.255 141.462 206.953 142.148 206.504C142.791 205.96 143.195 205.187 143.274 204.349V196.885C143.274 196.612 143.382 196.351 143.575 196.157C143.768 195.964 144.03 195.856 144.303 195.856C144.576 195.856 144.838 195.964 145.031 196.157C145.224 196.351 145.333 196.612 145.333 196.885V204.252C145.289 204.952 145.108 205.637 144.799 206.266C144.49 206.895 144.059 207.457 143.531 207.919C142.228 208.925 140.606 209.427 138.963 209.335Z",
    fill: "#051140"
  }), React.createElement("path", {
    d: "M156.656 190.741C155.787 188.296 154.147 187.717 144.593 187.717C135.038 187.717 133.43 188.296 132.561 190.741C131.693 193.186 133.88 195.245 144.593 197.818C155.273 195.245 157.364 192.928 156.656 190.741Z",
    fill: "url(#paint7_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M146.973 192.06C148.807 192.06 150.19 191.417 150.19 190.613C150.19 189.808 148.71 189.165 146.973 189.165C145.236 189.165 143.756 189.808 143.756 190.613C143.756 191.417 145.139 192.06 146.973 192.06Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M101.711 178.131C93.4651 178.428 85.3746 175.833 78.8388 170.796C78.7206 170.693 78.6238 170.567 78.5541 170.426C78.4845 170.285 78.4432 170.132 78.4328 169.975C78.4223 169.818 78.4428 169.661 78.4932 169.512C78.5436 169.363 78.6227 169.226 78.7262 169.107C78.8297 168.989 78.9555 168.892 79.0964 168.823C79.2373 168.753 79.3905 168.712 79.5474 168.701C79.7042 168.691 79.8616 168.711 80.0104 168.762C80.1593 168.812 80.2968 168.891 80.4151 168.995C86.5232 173.63 94.0487 176.006 101.711 175.718C109.374 176.012 116.902 173.635 123.007 168.995C123.246 168.786 123.558 168.68 123.875 168.701C124.192 168.722 124.487 168.869 124.696 169.107C124.905 169.346 125.011 169.658 124.989 169.975C124.968 170.292 124.822 170.587 124.583 170.796C118.048 175.833 109.957 178.428 101.711 178.131Z",
    fill: "#051140"
  }), React.createElement("path", {
    d: "M183.035 178.131C174.789 178.427 166.698 175.833 160.162 170.796C160.049 170.685 159.958 170.553 159.896 170.406C159.835 170.26 159.803 170.103 159.803 169.944C159.803 169.785 159.835 169.628 159.896 169.481C159.958 169.335 160.049 169.202 160.162 169.091C160.391 168.869 160.696 168.745 161.015 168.745C161.333 168.745 161.639 168.869 161.867 169.091C167.973 173.732 175.5 176.108 183.163 175.815C190.826 176.103 198.351 173.727 204.459 169.091C204.698 168.882 205.01 168.777 205.327 168.798C205.644 168.819 205.939 168.965 206.148 169.204C206.357 169.443 206.463 169.755 206.442 170.072C206.421 170.388 206.274 170.684 206.036 170.893C199.452 175.924 191.313 178.485 183.035 178.131Z",
    fill: "#051140"
  }), React.createElement("path", {
    d: "M142.727 152.653C158.521 152.653 171.325 139.849 171.325 124.054C171.325 108.26 158.521 95.4561 142.727 95.4561C126.932 95.4561 114.128 108.26 114.128 124.054C114.128 139.849 126.932 152.653 142.727 152.653Z",
    fill: "url(#paint8_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M141.15 138.659C152.095 138.659 160.967 129.787 160.967 118.843C160.967 107.899 152.095 99.0267 141.15 99.0267C130.206 99.0267 121.334 107.899 121.334 118.843C121.334 129.787 130.206 138.659 141.15 138.659Z",
    fill: "url(#paint9_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M141.15 124.891C150.673 124.891 158.393 117.171 158.393 107.648C158.393 98.1251 150.673 90.4053 141.15 90.4053C131.628 90.4053 123.908 98.1251 123.908 107.648C123.908 117.171 131.628 124.891 141.15 124.891Z",
    fill: "url(#paint10_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M141.15 112.28C149.252 112.28 155.819 105.713 155.819 97.6113C155.819 89.5097 149.252 82.9421 141.15 82.9421C133.049 82.9421 126.481 89.5097 126.481 97.6113C126.481 105.713 133.049 112.28 141.15 112.28Z",
    fill: "url(#paint11_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M141.151 100.828C147.831 100.828 153.246 95.413 153.246 88.7328C153.246 82.0526 147.831 76.6372 141.151 76.6372C134.47 76.6372 129.055 82.0526 129.055 88.7328C129.055 95.413 134.47 100.828 141.151 100.828Z",
    fill: "url(#paint12_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M141.15 87.0598C146.409 87.0598 150.673 82.7966 150.673 77.5377C150.673 72.2788 146.409 68.0156 141.15 68.0156C135.892 68.0156 131.628 72.2788 131.628 77.5377C131.628 82.7966 135.892 87.0598 141.15 87.0598Z",
    fill: "url(#paint13_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M141.15 75.8971C144.988 75.8971 148.099 72.7861 148.099 68.9485C148.099 65.111 144.988 62 141.15 62C137.313 62 134.202 65.111 134.202 68.9485C134.202 72.7861 137.313 75.8971 141.15 75.8971Z",
    fill: "url(#paint14_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M142.534 245.654C179.11 245.654 208.77 253.889 208.77 264.055C208.77 274.22 179.11 282.455 142.534 282.455C105.957 282.455 76.3296 274.381 76.3296 264.055C76.3296 253.728 105.99 245.654 142.534 245.654Z",
    fill: "url(#paint15_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M238.012 251.895H237.98C236.612 251.895 235.503 253.004 235.503 254.372V320.898C235.503 322.266 236.612 323.375 237.98 323.375H238.012C239.38 323.375 240.489 322.266 240.489 320.898V254.372C240.489 253.004 239.38 251.895 238.012 251.895Z",
    fill: "url(#paint16_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M246.054 256.013C246.355 253.975 245.893 251.898 244.758 250.179C243.622 248.461 241.892 247.222 239.9 246.7C237.907 246.178 235.792 246.41 233.96 247.35C232.127 248.291 230.707 249.875 229.97 251.798C229.748 252.274 229.617 252.787 229.584 253.31C229.283 255.348 229.744 257.425 230.88 259.143C232.016 260.862 233.746 262.101 235.738 262.623C237.731 263.145 239.846 262.913 241.678 261.973C243.51 261.032 244.931 259.448 245.668 257.525C245.89 257.049 246.021 256.536 246.054 256.013Z",
    fill: "url(#paint17_radial_9907_50791)"
  }), React.createElement("path", {
    opacity: "0.25",
    d: "M103.287 260.966H185.351V291.012C185.834 292.91 181.845 323.825 173.384 325.272C154.179 327.998 134.685 327.998 115.48 325.272C107.051 323.825 103.062 292.91 103.513 291.012L103.287 260.966Z",
    fill: "url(#paint18_linear_9907_50791)"
  }), React.createElement("path", {
    opacity: "0.25",
    d: "M109.464 238.995H179.11V290.176C179.496 291.785 176.118 322.345 168.945 323.632C152.609 325.948 136.029 325.948 119.694 323.632C112.52 322.41 109.142 291.785 109.528 290.176L109.464 238.995Z",
    fill: "url(#paint19_linear_9907_50791)"
  }), React.createElement("path", {
    opacity: "0.6",
    d: "M142.96 297.394C200.311 296.821 246.723 288.391 246.625 278.566C246.526 268.741 199.955 261.242 142.605 261.815C85.2542 262.389 38.8422 270.818 38.9404 280.643C39.0387 290.468 85.61 297.968 142.96 297.394Z",
    fill: "url(#paint20_radial_9907_50791)"
  }), React.createElement("path", {
    opacity: "0.6",
    d: "M142.379 316.805C188.499 316.443 225.837 309.755 225.775 301.867C225.713 293.978 188.275 287.878 142.154 288.24C96.0339 288.602 58.696 295.29 58.758 303.178C58.8199 311.066 96.2582 317.167 142.379 316.805Z",
    fill: "url(#paint21_radial_9907_50791)"
  }), React.createElement("path", {
    opacity: "0.6",
    d: "M142.344 328.804C176.384 328.536 203.941 323.596 203.896 317.768C203.85 311.941 176.218 307.434 142.179 307.701C108.139 307.969 80.5815 312.909 80.6272 318.736C80.673 324.564 108.305 329.071 142.344 328.804Z",
    fill: "url(#paint22_radial_9907_50791)"
  }), React.createElement("g", {
    opacity: "0.7"
  }, React.createElement("path", {
    opacity: "0.7",
    d: "M118.246 332.896H167.014V259.068H118.246V332.896Z",
    fill: "url(#paint23_linear_9907_50791)"
  })), React.createElement("path", {
    d: "M200.181 330.58L200.406 351.844H190.466C188.536 352.327 186.412 352.809 184.032 353.26C157.687 357.226 130.912 357.432 104.51 353.871C102.033 353.485 99.8773 353.034 98.0759 352.584H88.1034L87.8782 331.32C87.8782 328.875 93.3148 326.366 104.285 324.404C130.639 320.427 157.424 320.21 183.839 323.76C194.648 325.851 200.149 328.103 200.181 330.58Z",
    fill: "url(#paint24_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M88.1999 331.61L88.4251 352.713H87.9104L87.6852 331.449C87.6852 329.262 92.0924 327.01 100.875 325.176C92.4141 327.074 88.1677 329.358 88.1999 331.61Z",
    fill: "#DEFCF2"
  }), React.createElement("path", {
    d: "M199.537 351.844L199.28 330.773C199.28 328.296 193.779 325.884 182.745 324.082C156.342 320.521 129.568 320.727 103.223 324.694L100.006 325.337C101.261 325.047 102.612 324.79 104.027 324.533C130.381 320.555 157.167 320.339 183.582 323.889C194.583 325.691 200.084 328.103 200.117 330.58L200.342 351.844H199.537Z",
    fill: "#DEFCF2"
  }), React.createElement("path", {
    d: "M144.921 361.585C175.995 361.274 201.142 356.716 201.089 351.404C201.036 346.092 175.802 342.037 144.729 342.348C113.655 342.659 88.5078 347.217 88.5609 352.529C88.614 357.841 113.847 361.896 144.921 361.585Z",
    fill: "url(#paint25_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M105.957 359.308C119.327 361.221 132.826 362.082 146.33 361.881C132.345 362.204 118.358 361.375 104.51 359.404C87.3637 356.605 83.4069 352.23 93.1542 348.66C84.6937 352.295 89.0043 356.541 105.957 359.308Z",
    fill: "#DEFCF2"
  }), React.createElement("path", {
    d: "M184 358.793C178.177 359.822 171.357 360.594 164.119 361.141C170.553 360.594 176.73 359.887 182.038 358.922C203.945 354.997 203.913 348.885 182.038 345.314C162.263 342.633 142.261 342.051 122.364 343.577C142.874 341.888 163.507 342.416 183.903 345.153C205.875 348.756 205.939 354.804 184 358.793Z",
    fill: "#DEFCF2"
  }), React.createElement("path", {
    d: "M54.4868 240.475C54.4868 239.231 53.4858 238.223 52.251 238.223C51.0162 238.223 50.0153 239.231 50.0153 240.475V300.245C50.0153 301.489 51.0162 302.497 52.251 302.497C53.4858 302.497 54.4868 301.489 54.4868 300.245V240.475Z",
    fill: "url(#paint26_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M59.5373 241.922C59.8094 240.088 59.3949 238.218 58.3731 236.67C57.3514 235.122 55.7943 234.006 54.0005 233.536C52.2068 233.066 50.3025 233.274 48.6528 234.121C47.0031 234.968 45.7242 236.394 45.0612 238.126C44.8457 238.545 44.7249 239.006 44.7073 239.477C44.4352 241.312 44.8497 243.182 45.8715 244.729C46.8932 246.277 48.4503 247.393 50.2441 247.863C52.0378 248.334 53.9421 248.125 55.5918 247.278C57.2415 246.431 58.5204 245.005 59.1834 243.273C59.3799 242.847 59.4997 242.39 59.5373 241.922Z",
    fill: "url(#paint27_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M256.22 200.585C256.22 199.714 255.514 199.008 254.643 199.008C253.773 199.008 253.067 199.714 253.067 200.585V242.887C253.067 243.758 253.773 244.463 254.643 244.463C255.514 244.463 256.22 243.758 256.22 242.887V200.585Z",
    fill: "url(#paint28_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M259.79 201.614C259.89 200.373 259.551 199.137 258.832 198.121C258.113 197.105 257.059 196.374 255.856 196.056C254.653 195.738 253.376 195.853 252.249 196.381C251.121 196.909 250.215 197.816 249.689 198.944C249.526 199.228 249.437 199.549 249.432 199.877C249.275 201.158 249.588 202.452 250.312 203.52C251.035 204.588 252.121 205.358 253.369 205.688C254.616 206.018 255.941 205.884 257.098 205.313C258.255 204.741 259.165 203.77 259.662 202.579C259.753 202.266 259.797 201.94 259.79 201.614Z",
    fill: "url(#paint29_radial_9907_50791)"
  }), React.createElement("g", {
    opacity: "0.7"
  }, React.createElement("path", {
    opacity: "0.7",
    d: "M35.0243 180.962C35.0243 179.665 33.9801 178.613 32.692 178.613C31.4039 178.613 30.3597 179.665 30.3597 180.962V243.37C30.3597 244.667 31.4039 245.718 32.692 245.718C33.9801 245.718 35.0243 244.667 35.0243 243.37V180.962Z",
    fill: "url(#paint30_linear_9907_50791)"
  })), React.createElement("path", {
    d: "M41.0721 182.313C41.3729 180.275 40.9113 178.198 39.7756 176.48C38.64 174.761 36.9101 173.522 34.9176 173C32.9251 172.478 30.81 172.71 28.9777 173.651C27.1453 174.591 25.7245 176.175 24.9875 178.099C24.7623 178.562 24.631 179.065 24.6015 179.578C24.3007 181.616 24.7623 183.693 25.898 185.412C27.0336 187.13 28.7635 188.369 30.756 188.891C32.7485 189.413 34.8636 189.181 36.6959 188.241C38.5283 187.3 39.9491 185.716 40.6861 183.793C40.9039 183.327 41.0348 182.826 41.0721 182.313Z",
    fill: "url(#paint31_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M15.7551 237.258H15.7229C14.8701 237.258 14.1788 237.949 14.1788 238.802V280.429C14.1788 281.282 14.8701 281.973 15.7229 281.973H15.7551C16.6079 281.973 17.2992 281.282 17.2992 280.429V238.802C17.2992 237.949 16.6079 237.258 15.7551 237.258Z",
    fill: "url(#paint32_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M23.2182 240.539C23.4561 238.723 23.0237 236.882 22.0019 235.362C20.9802 233.842 19.4392 232.746 17.6677 232.281C15.8962 231.815 14.0157 232.012 12.3786 232.833C10.7415 233.655 9.45998 235.045 8.77424 236.743C8.57775 237.169 8.45796 237.627 8.42038 238.094C8.14825 239.929 8.5628 241.799 9.58455 243.346C10.6063 244.894 12.1633 246.01 13.9571 246.48C15.7509 246.951 17.6552 246.742 19.3049 245.895C20.9545 245.048 22.2335 243.622 22.8965 241.89C23.1008 241.469 23.2106 241.007 23.2182 240.539Z",
    fill: "url(#paint33_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M272.915 238.03C272.915 237.053 272.123 236.261 271.146 236.261C270.169 236.261 269.377 237.053 269.377 238.03V285.126C269.377 286.103 270.169 286.895 271.146 286.895C272.123 286.895 272.915 286.103 272.915 285.126V238.03Z",
    fill: "url(#paint34_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M276.84 239.188C277.063 237.742 276.742 236.264 275.94 235.04C275.137 233.816 273.909 232.933 272.494 232.561C271.079 232.19 269.576 232.355 268.275 233.027C266.975 233.698 265.969 234.827 265.452 236.196C265.295 236.531 265.197 236.89 265.163 237.258C264.977 238.693 265.321 240.146 266.13 241.346C266.939 242.546 268.157 243.41 269.557 243.777C270.957 244.143 272.442 243.987 273.735 243.338C275.028 242.689 276.041 241.591 276.583 240.25C276.747 239.92 276.835 239.557 276.84 239.188Z",
    fill: "url(#paint35_radial_9907_50791)"
  }), React.createElement("path", {
    d: "M219.129 148.31L228.425 137.855H219.45V133.512H235.535V137.244L226.206 147.699H235.503V152.138H219.129V148.31Z",
    fill: "url(#paint36_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M254.901 96.0029L274.202 74.2566H255.544V65.2814H289V73.002L269.699 94.7483H289V103.884H254.901V96.0029Z",
    fill: "url(#paint37_linear_9907_50791)"
  }), React.createElement("path", {
    d: "M241.486 132.29L255.705 116.205H241.969V109.643H266.546V115.369L252.359 131.454H266.546V137.984H241.486V132.29Z",
    fill: "url(#paint38_linear_9907_50791)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_9907_50791",
    x1: "84.7257",
    y1: "107.101",
    x2: "95.8884",
    y2: "93.1075",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9EAAEA"
  }), React.createElement("stop", {
    offset: "0.14",
    stopColor: "#8192DF"
  }), React.createElement("stop", {
    offset: "0.3",
    stopColor: "#5066C9"
  }), React.createElement("stop", {
    offset: "0.44",
    stopColor: "#233EB4"
  }), React.createElement("stop", {
    offset: "0.52",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_9907_50791",
    x1: "94.3122",
    y1: "117.138",
    x2: "56.256",
    y2: "119.84",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2525C6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4D91EE"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_9907_50791",
    x1: "190.176",
    y1: "115.143",
    x2: "175.7",
    y2: "100.667",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9EAAEA"
  }), React.createElement("stop", {
    offset: "0.14",
    stopColor: "#8192DF"
  }), React.createElement("stop", {
    offset: "0.3",
    stopColor: "#5066C9"
  }), React.createElement("stop", {
    offset: "0.44",
    stopColor: "#233EB4"
  }), React.createElement("stop", {
    offset: "0.52",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_9907_50791",
    x1: "195.002",
    y1: "111.926",
    x2: "230.388",
    y2: "116.752",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2525C6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4D91EE"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.53 200.391) rotate(90) scale(86.8568 127.839)"
  }, React.createElement("stop", {
    stopColor: "#B2E5F5"
  }), React.createElement("stop", {
    offset: "0.251083",
    stopColor: "#A2D5FC"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#66AFF9"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#4593E3"
  }), React.createElement("stop", {
    offset: "0.91",
    stopColor: "#3389E2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#9CFFFC"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.914 171.973) scale(17.7895 25.4391)"
  }, React.createElement("stop", {
    stopColor: "#65AEF8",
    stopOpacity: "0.5"
  }), React.createElement("stop", {
    offset: "0.26",
    stopColor: "#6BB2F9",
    stopOpacity: "0.33"
  }), React.createElement("stop", {
    offset: "0.58",
    stopColor: "#72B6F9",
    stopOpacity: "0.15"
  }), React.createElement("stop", {
    offset: "0.83",
    stopColor: "#76B9FA",
    stopOpacity: "0.04"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "#77BAFA",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67244.9 -190.063) rotate(180) scale(263.285 331.217)"
  }, React.createElement("stop", {
    stopColor: "#65AEF8",
    stopOpacity: "0.5"
  }), React.createElement("stop", {
    offset: "0.26",
    stopColor: "#6BB2F9",
    stopOpacity: "0.33"
  }), React.createElement("stop", {
    offset: "0.58",
    stopColor: "#72B6F9",
    stopOpacity: "0.15"
  }), React.createElement("stop", {
    offset: "0.83",
    stopColor: "#76B9FA",
    stopOpacity: "0.04"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "#77BAFA",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.138 198.783) rotate(-63.4349) scale(10.7899 13.8604)"
  }, React.createElement("stop", {
    offset: "0.47",
    stopColor: "#051140"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.903 127.368) scale(22.2289)"
  }, React.createElement("stop", {
    stopColor: "#2F42D0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3684A6",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.343 129.33) scale(17.9826)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFB9D7"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.148 116.977) scale(17.2427)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFC0E1"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.408 103.981) scale(14.6691)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCDC"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.665 93.1078) scale(12.0956)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCDE"
  })), React.createElement("radialGradient", {
    id: "paint13_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.665 81.012) scale(9.52208)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCD5"
  })), React.createElement("radialGradient", {
    id: "paint14_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.279 70.75) scale(6.94854)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCC8"
  })), React.createElement("radialGradient", {
    id: "paint15_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.747 264.731) rotate(1.36393) scale(67.5744 17.8321)"
  }, React.createElement("stop", {
    offset: "0.32",
    stopColor: "#9CFFFC"
  }), React.createElement("stop", {
    offset: "0.33",
    stopColor: "#9BFEFC",
    stopOpacity: "0.98"
  }), React.createElement("stop", {
    offset: "0.52",
    stopColor: "#88ECF9",
    stopOpacity: "0.64"
  }), React.createElement("stop", {
    offset: "0.69",
    stopColor: "#78DEF7",
    stopOpacity: "0.37"
  }), React.createElement("stop", {
    offset: "0.84",
    stopColor: "#6DD4F5",
    stopOpacity: "0.17"
  }), React.createElement("stop", {
    offset: "0.94",
    stopColor: "#67CDF4",
    stopOpacity: "0.05"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#64CBF4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_9907_50791",
    x1: "237.98",
    y1: "253.342",
    x2: "237.98",
    y2: "322.506",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint17_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.576 220.422) rotate(-30.1735) scale(8.12837)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_9907_50791",
    x1: "144.271",
    y1: "327.299",
    x2: "144.271",
    y2: "260.934",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#9CFFFC"
  }), React.createElement("stop", {
    offset: "0.04",
    stopColor: "#94F1F1"
  }), React.createElement("stop", {
    offset: "0.19",
    stopColor: "#72B6C2"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#558499"
  }), React.createElement("stop", {
    offset: "0.49",
    stopColor: "#3D5A78"
  }), React.createElement("stop", {
    offset: "0.63",
    stopColor: "#2B3A5E"
  }), React.createElement("stop", {
    offset: "0.76",
    stopColor: "#1E244C"
  }), React.createElement("stop", {
    offset: "0.89",
    stopColor: "#161641"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#13113D"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_9907_50791",
    x1: "144.271",
    y1: "325.369",
    x2: "144.271",
    y2: "239.059",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#70E8FC"
  }), React.createElement("stop", {
    offset: "0.15",
    stopColor: "#5AB5CF"
  }), React.createElement("stop", {
    offset: "0.3",
    stopColor: "#4584A3"
  }), React.createElement("stop", {
    offset: "0.46",
    stopColor: "#335A7E"
  }), React.createElement("stop", {
    offset: "0.6",
    stopColor: "#253A62"
  }), React.createElement("stop", {
    offset: "0.75",
    stopColor: "#1B244D"
  }), React.createElement("stop", {
    offset: "0.88",
    stopColor: "#151641"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#13113D"
  })), React.createElement("radialGradient", {
    id: "paint20_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.785 279.036) rotate(-0.122938) scale(103.172 17.5392)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint21_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8344.74 681.871) scale(4307.51 125.243)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint22_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6199.18 629.158) rotate(0.122939) scale(2345.99 68.2668)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_9907_50791",
    x1: "142.662",
    y1: "331.449",
    x2: "142.662",
    y2: "260.033",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.44",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.86",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_9907_50791",
    x1: "94.6798",
    y1: "339.134",
    x2: "189.772",
    y2: "338.183",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint25_linear_9907_50791",
    x1: "163.095",
    y1: "323.171",
    x2: "122.633",
    y2: "386.924",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint26_linear_9907_50791",
    x1: "146.734",
    y1: "4040.67",
    x2: "146.734",
    y2: "5283.09",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint27_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6501.92 -38840.3) scale(34.1841 33.7888)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint28_linear_9907_50791",
    x1: "519.585",
    y1: "2328.58",
    x2: "519.585",
    y2: "2949.95",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint29_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3667.21 -26341.2) scale(16.7683 16.0761)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint30_linear_9907_50791",
    x1: "102.893",
    y1: "2905.76",
    x2: "102.893",
    y2: "4260.6",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint31_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7175.46 -42851.2) scale(42.1246 41.5849)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint32_linear_9907_50791",
    x1: "46.2566",
    y1: "2863.38",
    x2: "46.2566",
    y2: "3464.8",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint33_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6658.54 -38418) scale(34.0703 33.4995)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint34_linear_9907_50791",
    x1: "586.684",
    y1: "3196.85",
    x2: "586.684",
    y2: "3968.01",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint35_radial_9907_50791",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4187.68 -30752.9) scale(21.2319 20.8867)"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint36_linear_9907_50791",
    x1: "219.129",
    y1: "142.777",
    x2: "235.503",
    y2: "142.777",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint37_linear_9907_50791",
    x1: "3140.39",
    y1: "488.756",
    x2: "3501.84",
    y2: "488.756",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0.3"
  })), React.createElement("linearGradient", {
    id: "paint38_linear_9907_50791",
    x1: "2257.55",
    y1: "767.155",
    x2: "2452.76",
    y2: "767.155",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A7F9EF"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0.3"
  }))));
};

var pack = function pack(width, height) {
  if (width === void 0) {
    width = '300';
  }

  if (height === void 0) {
    height = '398';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 300 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M296.004 225.257C299.318 198.067 294.495 170.505 282.146 146.056C269.796 121.608 250.475 101.369 226.624 87.9006C202.773 74.432 175.465 68.3379 148.151 70.3889C120.837 72.4398 94.7442 82.5437 73.1722 99.4229C51.6003 116.302 35.5176 139.199 26.9578 165.218C18.398 191.237 17.7454 219.21 25.0825 245.6C32.4196 271.99 47.4169 295.611 68.1782 313.478C88.9396 331.345 114.533 342.655 141.721 345.977C159.779 348.184 178.094 346.812 195.621 341.939C213.148 337.066 229.543 328.788 243.87 317.577C258.197 306.367 270.175 292.444 279.12 276.603C288.066 260.763 293.803 243.315 296.004 225.257Z",
    fill: "#EDC418"
  }), React.createElement("path", {
    d: "M133.959 106.759L25.156 114.682L19.9059 127.373L135.344 116.422L133.959 106.759Z",
    fill: "url(#paint0_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M133.959 144.669L36.0424 149.984L19.9377 127.437L135.344 116.422L133.959 144.669Z",
    fill: "url(#paint1_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M147.777 136.359L36.0425 148.857L60.5215 164.349L170.194 152.078C170.342 152.054 170.48 151.987 170.589 151.884C170.698 151.781 170.773 151.647 170.804 151.501C170.836 151.354 170.822 151.202 170.765 151.063C170.708 150.924 170.61 150.806 170.484 150.725L147.777 136.359Z",
    fill: "url(#paint2_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M147.777 136.359L36.0425 148.856L20.8075 126.567L135.344 116.422L147.777 136.359Z",
    fill: "url(#paint3_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M133.959 106.759L25.1558 114.682L20.8075 126.568L135.344 116.422L133.959 106.759Z",
    fill: "url(#paint4_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M147.777 136.359L36.0425 148.857L60.5215 164.349L170.033 152.078C170.2 152.067 170.359 152.002 170.487 151.893C170.614 151.784 170.702 151.637 170.738 151.474C170.775 151.31 170.757 151.139 170.688 150.987C170.619 150.834 170.502 150.709 170.355 150.628L147.777 136.359ZM40.7128 149.919L147.39 138.002L167.585 150.886L60.8758 162.707L40.7128 149.919Z",
    fill: "url(#paint5_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M154.058 272.379V139.612C154.063 138.956 153.928 138.305 153.661 137.705C153.394 137.105 153.002 136.568 152.511 136.132C152.019 135.696 151.441 135.37 150.813 135.176C150.186 134.981 149.524 134.924 148.872 135.007L55.465 143.542C54.065 143.667 52.7588 144.299 51.792 145.319C50.8252 146.339 50.2643 147.677 50.2149 149.082V281.881C50.209 282.537 50.3442 283.186 50.6113 283.785C50.8784 284.384 51.2712 284.918 51.7631 285.352C52.2549 285.786 52.8343 286.109 53.4619 286.299C54.0895 286.489 54.7507 286.542 55.4006 286.455L148.808 277.919C150.208 277.794 151.514 277.162 152.481 276.142C153.447 275.122 154.008 273.784 154.058 272.379Z",
    fill: "url(#paint6_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M148.421 270.382V137.583C148.422 136.929 148.283 136.282 148.014 135.686C147.745 135.089 147.352 134.557 146.862 134.124C146.371 133.692 145.794 133.368 145.169 133.176C144.543 132.984 143.884 132.927 143.235 133.009L49.8283 141.545C48.4373 141.678 47.1427 142.314 46.1878 143.334C45.2328 144.354 44.6834 145.688 44.6426 147.085V279.852C44.6374 280.508 44.7727 281.159 45.0396 281.759C45.3064 282.359 45.6985 282.896 46.1897 283.332C46.6809 283.768 47.2596 284.094 47.8872 284.288C48.5148 284.483 49.1766 284.54 49.8283 284.458L143.235 275.922C144.624 275.783 145.914 275.144 146.868 274.125C147.822 273.107 148.373 271.777 148.421 270.382Z",
    fill: "url(#paint7_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M150.321 271.542V138.743C150.322 138.089 150.183 137.442 149.914 136.845C149.645 136.249 149.253 135.717 148.762 135.284C148.271 134.851 147.694 134.528 147.069 134.336C146.444 134.144 145.784 134.087 145.136 134.169L51.7285 142.705C50.3343 142.837 49.0359 143.472 48.0757 144.491C47.1155 145.511 46.5592 146.845 46.5106 148.245V281.011C46.5054 281.668 46.6408 282.319 46.9076 282.919C47.1744 283.519 47.5666 284.055 48.0577 284.492C48.5489 284.928 49.1277 285.254 49.7552 285.448C50.3828 285.642 51.0447 285.7 51.6963 285.617L145.103 277.082C146.5 276.956 147.802 276.323 148.764 275.302C149.726 274.281 150.28 272.944 150.321 271.542Z",
    fill: "url(#paint8_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M152.672 272.766V139.967C152.673 139.312 152.534 138.666 152.265 138.069C151.997 137.473 151.604 136.941 151.113 136.508C150.623 136.075 150.045 135.752 149.42 135.56C148.795 135.367 148.136 135.311 147.487 135.393L54.0798 143.928C52.6887 144.061 51.3941 144.698 50.4392 145.718C49.4843 146.738 48.9348 148.072 48.8941 149.468V282.235C48.8888 282.892 49.0242 283.542 49.291 284.143C49.5579 284.743 49.95 285.279 50.4412 285.715C50.9323 286.152 51.5111 286.478 52.1387 286.672C52.7662 286.866 53.4281 286.924 54.0798 286.841L147.487 278.306C148.878 278.173 150.172 277.536 151.127 276.516C152.082 275.496 152.632 274.162 152.672 272.766Z",
    fill: "url(#paint9_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M154.218 273.861V141.094C154.224 140.437 154.088 139.787 153.821 139.186C153.555 138.586 153.162 138.05 152.671 137.614C152.18 137.177 151.601 136.851 150.974 136.657C150.346 136.463 149.684 136.405 149.033 136.488L55.6257 145.024C54.2373 145.163 52.9465 145.801 51.9929 146.82C51.0393 147.839 50.4876 149.169 50.44 150.564V283.362C50.4341 284.018 50.5693 284.668 50.8364 285.267C51.1035 285.865 51.4963 286.4 51.9882 286.834C52.48 287.268 53.0594 287.59 53.687 287.781C54.3146 287.971 54.9758 288.024 55.6257 287.936L149.033 279.401C150.421 279.261 151.712 278.623 152.665 277.604C153.619 276.585 154.171 275.255 154.218 273.861Z",
    fill: "url(#paint10_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M156.022 275.02V142.189C156.028 141.532 155.892 140.882 155.625 140.282C155.359 139.681 154.966 139.145 154.475 138.709C153.984 138.273 153.405 137.947 152.778 137.752C152.15 137.558 151.488 137.501 150.837 137.583L57.4298 146.119C56.0234 146.278 54.7256 146.951 53.7861 148.01C52.8466 149.068 52.3317 150.437 52.3407 151.852V284.522C52.3401 285.176 52.4788 285.823 52.7477 286.42C53.0165 287.016 53.4093 287.548 53.8999 287.981C54.3906 288.414 54.9677 288.737 55.593 288.929C56.2183 289.121 56.8774 289.178 57.5264 289.096L150.933 280.56C152.307 280.406 153.578 279.76 154.514 278.742C155.449 277.724 155.985 276.402 156.022 275.02Z",
    fill: "url(#paint11_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M158.213 276.212V143.445C158.2 142.799 158.051 142.163 157.776 141.579C157.501 140.994 157.107 140.473 156.617 140.051C156.128 139.629 155.556 139.314 154.937 139.128C154.319 138.941 153.668 138.887 153.027 138.968L59.8776 147.375C58.4859 147.514 57.1913 148.151 56.2324 149.169C55.2735 150.187 54.7149 151.517 54.6597 152.915V285.714C54.6436 286.378 54.7726 287.038 55.0374 287.647C55.3023 288.257 55.6968 288.801 56.1934 289.242C56.6901 289.684 57.2769 290.012 57.9132 290.203C58.5494 290.395 59.2197 290.446 59.8776 290.352L153.285 281.816C154.64 281.624 155.881 280.954 156.785 279.926C157.689 278.898 158.195 277.581 158.213 276.212Z",
    fill: "url(#paint12_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M160.854 277.468V144.702C160.86 144.046 160.724 143.396 160.457 142.797C160.19 142.199 159.797 141.664 159.306 141.23C158.814 140.796 158.234 140.473 157.607 140.283C156.979 140.093 156.318 140.04 155.668 140.128L62.3577 148.631C60.9667 148.764 59.6721 149.4 58.7172 150.42C57.7623 151.441 57.2128 152.774 57.172 154.171V287.131C57.1668 287.788 57.3021 288.438 57.569 289.039C57.8358 289.639 58.228 290.175 58.7191 290.611C59.2103 291.048 59.7891 291.374 60.4166 291.568C61.0442 291.762 61.706 291.82 62.3577 291.737L155.765 283.169C157.165 283.011 158.459 282.342 159.398 281.29C160.336 280.239 160.855 278.878 160.854 277.468Z",
    fill: "url(#paint13_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M163.366 278.499V145.7C163.366 145.046 163.228 144.399 162.959 143.803C162.69 143.206 162.297 142.674 161.806 142.241C161.316 141.808 160.739 141.485 160.113 141.293C159.488 141.101 158.829 141.044 158.18 141.126L64.773 149.662C63.4148 149.806 62.1525 150.43 61.2136 151.422C60.2747 152.414 59.7209 153.709 59.6518 155.073V287.968C59.6465 288.625 59.7819 289.276 60.0487 289.876C60.3156 290.476 60.7077 291.012 61.1989 291.449C61.69 291.885 62.2688 292.211 62.8964 292.405C63.5239 292.599 64.1858 292.657 64.8375 292.574L158.244 284.039C159.621 283.885 160.897 283.24 161.837 282.223C162.777 281.205 163.32 279.884 163.366 278.499Z",
    fill: "url(#paint14_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M165.878 217.172V84.3733C165.88 83.7161 165.74 83.0661 165.469 82.4672C165.199 81.8683 164.803 81.3343 164.309 80.9011C163.814 80.4678 163.233 80.1454 162.604 79.9554C161.975 79.7654 161.312 79.7123 160.661 79.7996L67.2536 88.3351C65.88 88.4899 64.6086 89.1357 63.6734 90.1537C62.7383 91.1717 62.2025 92.4933 62.1646 93.8751V226.642C62.164 227.3 62.3035 227.951 62.574 228.551C62.8445 229.152 63.2397 229.687 63.7333 230.123C64.2269 230.559 64.8076 230.885 65.4368 231.078C66.066 231.272 66.7292 231.33 67.3825 231.248L160.693 222.712C162.084 222.579 163.378 221.943 164.333 220.923C165.288 219.903 165.838 218.569 165.878 217.172Z",
    fill: "url(#paint15_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M137.307 184.176C155.1 171.23 159.733 147.278 147.655 130.679C135.578 114.08 111.363 111.119 93.5695 124.065C75.7764 137.012 71.1432 160.963 83.221 177.562C95.2987 194.162 119.514 197.123 137.307 184.176Z",
    fill: "url(#paint16_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M134.666 135.006L114.246 136.745L114.342 141.448L110.445 141.77L101.813 142.511L102.006 151.529L96.8206 151.98L96.9816 159.614L97.046 161.707L97.0782 163.254L102.232 162.835L102.844 192.854L117.112 191.662L116.919 183.223L131.703 181.967L131.607 177.297L135.504 176.975L134.666 135.006Z",
    fill: "#BCFAFF"
  }), React.createElement("path", {
    d: "M125.133 157.391L121.396 157.713L121.622 167.956L125.358 167.634L125.133 157.391Z",
    fill: "#76E4E7"
  }), React.createElement("path", {
    d: "M104.325 152.366L100.621 152.689V156.199L104.358 155.877L104.325 152.366Z",
    fill: "#76E4E7"
  }), React.createElement("path", {
    d: "M114.922 171.66L131.832 170.211L131.896 173.882L114.987 175.3L114.922 171.66Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M100.653 156.006L96.917 156.296L96.8526 153.011L100.589 152.689L100.524 149.21L96.7882 149.532L96.8526 153.011L93.1163 153.333L93.1808 156.811L96.917 156.489L97.0781 163.253L100.621 162.963L101.265 193.176L105.002 192.854L104.293 159.002L100.718 159.292L100.653 156.006Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M131.864 180.324L118.691 181.419L115.115 181.741H114.954L115.148 191.984L118.884 191.694L118.755 185.059L132.09 183.932L132.025 180.453L135.601 180.163L135.536 176.717L131.8 177.007L131.864 180.324Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M141.656 145.57L138.628 145.828L138.435 135.908L134.699 136.23L134.892 146.15L131.156 146.44L127.935 146.73L121.171 147.31L117.982 147.567L110.67 148.179L107.449 148.469L104.261 148.727L104.132 142.317L100.396 142.607L100.589 152.689L104.325 152.367L107.546 152.109L107.611 155.394L110.831 155.137L110.896 158.583L118.207 157.971L118.111 154.492L121.332 154.235L121.235 150.949L128.031 150.37L128.096 153.655L131.284 153.397L131.381 156.876L135.117 156.554L135.536 176.717L139.272 176.395L138.789 152.753L141.785 152.495L141.656 145.57Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M138.274 128.983L134.538 129.273L134.473 125.987L106.87 128.338L106.934 131.463L103.552 131.753L103.617 135.392L100.235 135.682L100.299 139.161L93.3743 139.741L90.3466 139.998L89.799 140.03L86.0627 140.353L86.1594 143.831L89.8957 143.509L90.0889 153.591L93.6641 153.301L93.5675 149.79L96.7884 149.532L96.724 146.569L100.46 146.279L100.396 142.8L103.778 142.511L107.16 142.221L120.688 141.061L120.784 144.733L131.639 143.799L131.574 140.159L134.763 139.869L134.699 136.391L138.435 136.101L138.274 128.983Z",
    fill: "#49B6C8"
  }), React.createElement("path", {
    d: "M65.5141 318.761L60.5217 164.349L36.0426 148.857L35.7205 297.567C35.5935 299.675 36.1069 301.772 37.1933 303.582C38.2798 305.393 39.8884 306.833 41.8081 307.713L65.5141 318.761Z",
    fill: "url(#paint17_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M65.5141 318.761L0.805664 301.496V253.182L35.8172 254.922V297.728C35.6901 299.836 36.2035 301.933 37.29 303.744C38.3764 305.554 39.9851 306.994 41.9047 307.874L65.5141 318.761Z",
    fill: "url(#paint18_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M168.648 149.565L60.8758 162.707L40.6806 149.919L36.0425 148.857L60.5215 164.349L168.745 153.946H172.223L172.062 151.723L168.648 149.565Z",
    fill: "url(#paint19_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M172.224 154.236L171.901 298.855C171.91 301.343 171.001 303.746 169.35 305.606C167.698 307.466 165.418 308.652 162.947 308.937L69.9269 319.34C68.7064 319.477 67.4708 319.353 66.3015 318.978C65.1321 318.602 64.0556 317.983 63.1428 317.162C62.2299 316.34 61.5014 315.335 61.0052 314.211C60.5091 313.088 60.2565 311.872 60.2641 310.644L60.5862 164.349L114.376 158.294L169.84 152.078C170.143 152.04 170.45 152.069 170.741 152.161C171.032 152.253 171.299 152.407 171.525 152.612C171.751 152.816 171.931 153.067 172.051 153.348C172.172 153.628 172.23 153.931 172.224 154.236Z",
    fill: "url(#paint20_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M75.5312 309.903C73.88 309.902 72.2866 309.295 71.0541 308.196C70.3545 307.573 69.7947 306.809 69.4117 305.954C69.0286 305.099 68.8309 304.172 68.8317 303.235L69.186 178.167C69.1917 176.522 69.8021 174.937 70.9009 173.714C71.9997 172.49 73.5102 171.714 75.1447 171.532L156.022 162.449C156.96 162.352 157.909 162.451 158.807 162.74C159.705 163.028 160.533 163.499 161.24 164.124C161.944 164.75 162.506 165.52 162.889 166.38C163.272 167.241 163.468 168.174 163.463 169.116L163.205 293.251C163.21 294.911 162.606 296.516 161.508 297.763C160.41 299.009 158.894 299.81 157.246 300.015L76.272 309.871L75.5312 309.903ZM75.2413 172.273C73.8033 172.445 72.4771 173.135 71.5109 174.214C70.5446 175.292 70.0044 176.686 69.9912 178.135L69.5403 303.235C69.5362 304.057 69.7048 304.869 70.0349 305.621C70.3651 306.373 70.8495 307.047 71.4569 307.6C72.0642 308.153 72.7808 308.571 73.5604 308.829C74.3399 309.087 75.165 309.179 75.9821 309.098L157.15 299.145C158.593 298.958 159.92 298.255 160.885 297.166C161.85 296.076 162.388 294.674 162.4 293.218L162.657 169.084C162.652 168.266 162.476 167.457 162.143 166.71C161.809 165.963 161.325 165.293 160.72 164.742C160.115 164.192 159.402 163.772 158.627 163.511C157.852 163.249 157.031 163.151 156.215 163.222L75.2413 172.273Z",
    fill: "url(#paint21_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M162.947 308.937L99.6237 316.119L83.809 317.891L75.9821 318.696L72.0204 319.115C70.7131 319.345 69.3846 319.431 68.0586 319.372C66.7477 319.201 65.4907 318.743 64.3772 318.03C63.2637 317.318 62.3212 316.368 61.6168 315.25C60.9144 314.118 60.4844 312.839 60.3606 311.513C60.3606 310.193 60.3606 308.872 60.3606 307.551V291.64L60.6505 164.349C60.9404 185.543 61.2302 206.769 61.198 227.995L61.3913 291.64V307.551C61.3913 308.808 61.3913 310.322 61.3913 311.417C61.4846 312.559 61.849 313.664 62.4542 314.638C63.0685 315.631 63.8956 316.476 64.8759 317.111C65.8562 317.746 66.9653 318.155 68.123 318.309C68.7131 318.342 69.3045 318.342 69.8946 318.309L71.8915 318.084L75.8211 317.665L83.7445 316.86L99.5593 315.185L131.221 311.964L162.947 308.937Z",
    fill: "url(#paint22_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M60.5219 164.349L124.683 157.166L156.892 153.559L164.912 152.657L168.906 152.206C169.566 152.077 170.244 152.077 170.903 152.206C171.221 152.316 171.509 152.498 171.744 152.738C171.978 152.979 172.154 153.271 172.256 153.591C172.449 158.97 172.256 164.349 172.256 169.696L171.966 298.823C171.708 277.307 171.451 255.791 171.483 234.404L171.322 169.825V155.62C171.364 155.052 171.364 154.481 171.322 153.913C171.268 153.744 171.177 153.589 171.054 153.46C170.931 153.332 170.78 153.233 170.613 153.172C170.434 153.121 170.245 153.121 170.066 153.172H169.067L165.041 153.591L157.021 154.461L124.812 157.682L92.6023 161.096L60.5219 164.349Z",
    fill: "url(#paint23_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M153.124 228.735L153.285 235.338L146.295 236.047L146.811 256.628L140.369 257.305L139.821 236.659L132.799 237.367L132.606 230.732L153.124 228.735Z",
    fill: "url(#paint24_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M104.488 233.438L105.228 260.913L99.4629 261.525L88.8016 247.417L89.2525 262.555L82.6496 263.232L81.8766 235.596L88.0608 235.016L98.3355 248.609L97.949 234.05L104.488 233.438Z",
    fill: "url(#paint25_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M129.289 231.055L129.45 237.69L117.146 238.882L117.275 243.552L128.387 242.457L128.58 248.705L117.436 249.833L117.693 259.624L111.123 260.301L110.382 232.858L129.289 231.055Z",
    fill: "url(#paint26_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M153.703 262.942L147.616 271.992L154.444 282.46L148.872 283.04L144.459 276.212L142.817 278.563L142.945 283.62L138.307 284.103L137.792 264.488L142.43 264.037L142.656 271.992L148.196 263.489L153.703 262.942Z",
    fill: "url(#paint27_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M127.259 265.132C128.05 265.017 128.852 265.017 129.643 265.132C130.325 265.253 130.986 265.47 131.607 265.776C132.199 266.095 132.751 266.484 133.25 266.935C133.738 267.399 134.171 267.918 134.539 268.481L131.124 271.96C130.889 271.65 130.619 271.369 130.319 271.122C130.066 270.862 129.772 270.645 129.449 270.478C128.819 270.105 128.081 269.957 127.356 270.06C126.769 270.114 126.205 270.314 125.713 270.639C125.212 270.953 124.783 271.37 124.457 271.863C124.11 272.399 123.849 272.986 123.684 273.603C123.497 274.273 123.41 274.968 123.426 275.664C123.455 276.364 123.574 277.056 123.781 277.725C123.976 278.305 124.282 278.841 124.682 279.304C125.009 279.745 125.437 280.102 125.93 280.343C126.424 280.584 126.968 280.703 127.517 280.689C127.922 280.63 128.322 280.533 128.709 280.399C129.052 280.244 129.377 280.05 129.675 279.819C129.97 279.556 130.25 279.277 130.512 278.982C130.792 278.64 131.04 278.273 131.253 277.886L134.861 280.463C134.487 281.125 134.067 281.761 133.604 282.364C133.133 282.953 132.593 283.483 131.994 283.942C131.386 284.411 130.713 284.791 129.997 285.069C129.189 285.374 128.344 285.569 127.485 285.649C126.399 285.719 125.312 285.554 124.296 285.166C123.223 284.779 122.253 284.151 121.462 283.33C120.601 282.47 119.931 281.439 119.497 280.302C118.982 279.032 118.709 277.678 118.692 276.308C118.653 274.922 118.849 273.539 119.271 272.218C119.654 270.947 120.266 269.758 121.075 268.707C121.832 267.72 122.773 266.889 123.845 266.259C124.894 265.653 126.056 265.269 127.259 265.132Z",
    fill: "url(#paint28_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M109.866 267.064L117.661 286.39L112.604 286.905L111.412 283.33L104.681 283.91L103.553 287.549L98.5286 288.161L105.26 267.515L109.866 267.064ZM105.937 279.594L109.802 279.207L107.74 273.796L105.937 279.594Z",
    fill: "url(#paint29_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M90.7017 269.061C91.6933 268.96 92.6949 269.025 93.6649 269.255C94.5054 269.462 95.2874 269.859 95.9518 270.414C96.6129 270.971 97.1319 271.678 97.4656 272.476C98.1797 274.431 98.1797 276.576 97.4656 278.531C97.1624 279.422 96.6676 280.235 96.0162 280.914C95.3614 281.604 94.5721 282.152 93.6971 282.525C92.7636 282.926 91.7759 283.186 90.7661 283.298L88.3826 283.523L88.5436 289.192L83.7767 289.675L83.1969 269.802L90.7017 269.061ZM93.2784 276.115C93.2785 275.739 93.2018 275.366 93.0529 275.02C92.9362 274.722 92.7482 274.456 92.5054 274.247C92.2348 274.05 91.9285 273.908 91.6035 273.828C91.2188 273.776 90.8287 273.776 90.444 273.828L88.2215 274.054V279.304L90.5084 279.078C90.8987 279.051 91.2807 278.953 91.6357 278.789C91.9522 278.641 92.2367 278.433 92.4732 278.177C92.7052 277.927 92.8809 277.63 92.9885 277.307C93.1121 276.956 93.1667 276.584 93.1496 276.212",
    fill: "url(#paint30_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M140.304 214.885L119.207 178.424L95.3398 220.908L140.304 214.885Z",
    fill: "url(#paint31_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M140.304 214.885L119.207 178.424L119.626 204.707L140.304 214.885Z",
    fill: "url(#paint32_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M140.304 214.885L119.207 178.424L119.626 204.707L140.304 214.885Z",
    fill: "url(#paint33_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M119.626 204.707L119.207 178.424L95.3398 220.908L119.626 204.707Z",
    fill: "url(#paint34_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M95.3076 220.908L140.207 214.467L139.917 215.046L119.207 178.424L140.658 214.692C140.724 214.768 140.76 214.865 140.76 214.966C140.76 215.066 140.724 215.164 140.658 215.24H140.401L95.3076 220.908Z",
    fill: "url(#paint35_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M264.439 340.373L105.84 333.416L159.146 320.854L234.742 276.405V319.211C234.614 321.311 235.124 323.4 236.205 325.205C237.285 327.01 238.886 328.446 240.797 329.325L264.439 340.373Z",
    fill: "url(#paint36_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M268.284 335.469L289.931 181.444C290.387 178.203 288.129 175.206 284.887 174.75L179.44 159.931C176.198 159.475 173.202 161.733 172.746 164.975L151.099 319C150.644 322.241 152.902 325.238 156.143 325.693L261.591 340.513C264.832 340.968 267.829 338.71 268.284 335.469Z",
    fill: "url(#paint37_linear_10025_65883)"
  }), React.createElement("path", {
    d: "M221.311 291.705C246.802 291.705 267.466 271.04 267.466 245.549C267.466 220.057 246.802 199.393 221.311 199.393C195.819 199.393 175.155 220.057 175.155 245.549C175.155 271.04 195.819 291.705 221.311 291.705Z",
    fill: "#1EC5F9"
  }), React.createElement("path", {
    d: "M239.541 276.244C242.762 260.816 253.649 219.524 228.268 217.817C222.755 217.469 217.24 218.459 212.193 220.702C207.146 222.946 202.715 226.376 199.279 230.7C196.61 234.331 194.158 238.117 191.936 242.038C190.723 244.277 189.356 246.43 187.845 248.48C187.649 248.976 187.424 249.46 187.169 249.929C187.083 252.511 186.051 254.971 184.269 256.842C182.487 258.713 180.08 259.863 177.506 260.075C179.572 266.404 182.984 272.21 187.508 277.094C192.032 281.978 197.56 285.824 203.712 288.368C209.864 290.911 216.495 292.092 223.147 291.828C229.799 291.565 236.315 289.863 242.247 286.841C240.989 285.415 240.088 283.711 239.618 281.868C239.148 280.026 239.121 278.099 239.541 276.244Z",
    fill: "#2E7EAF"
  }), React.createElement("path", {
    d: "M249.59 260.88L247.304 260.558L251.33 231.924L207.879 225.804L201.083 273.86L244.566 279.98L246.144 268.771L248.431 269.093L249.59 260.88Z",
    fill: "#BCFAFF"
  }), React.createElement("path", {
    d: "M259.318 228.768L258.673 233.567L250.396 232.407L227.366 229.154V229.122L217.993 227.801V227.833L198.603 225.096L199.247 220.458L202.339 220.876L204.594 221.198L204.916 218.879L206.365 219.105L207.074 214.177L209.619 214.531L209.973 211.986L215.03 212.695L215.352 210.344L222.148 211.31L222.47 208.894L236.868 210.924L236.546 213.339L243.857 214.37L243.535 216.721L245.983 217.076L245.629 219.427L247.948 219.749L247.561 222.326L249.88 222.68L249.494 225.225L252.167 225.611L251.877 227.737L259.318 228.768Z",
    fill: "#DF7DE2"
  }), React.createElement("path", {
    d: "M244.308 278.982L243.76 282.783L240.894 282.364V282.75L237.351 282.235L236.932 285.23L227.656 283.91L227.463 285.198L230.265 285.585L230.039 287.002L220.924 285.746L207.493 283.91L207.783 281.784L200.117 280.689L200.6 277.178L197.766 276.792L198.249 273.571L194.802 273.088L195.318 269.512L192.87 269.19L193.353 265.647L189.778 265.132L190.261 261.589L179.696 260.075L180.501 254.406L182.434 254.696L183.014 250.444L184.753 250.67L186.331 239.397L188.972 239.751L189.488 236.337L191.936 236.691L192.29 234.243L195.06 234.63L195.414 232.085L197.766 232.407L198.41 227.801L217.735 230.507L217.381 232.955L212.389 232.246L212.099 234.436L200.31 232.761L199.988 235.016L197.476 234.662L197.121 237.11L194.577 236.723L194.158 239.493L191.807 239.171L190.357 248.48L192.741 248.802L192.354 251.475L195.157 251.701L194.802 254.148L197.315 254.503L197.025 256.693L203.853 257.659L204.143 255.469L206.752 255.856L207.138 253.086L204.53 252.731L204.143 255.469L197.315 254.503L197.669 252.055L195.157 251.701L195.543 249.027L192.805 248.641L194.126 239.171L196.703 239.525L197.089 236.788L201.598 237.528L201.212 240.105L206.527 240.846L206.881 238.301L208.91 238.559L207.557 248.222L209.522 248.48L209.2 250.928L211.648 251.25L211.358 253.472L219.024 254.535L218.669 257.015L216.254 256.693L215.899 259.302L213.387 258.948L212.067 268.353L214.579 268.707L214.225 271.219L216.544 271.542L216.189 274.118L218.637 274.44L218.347 276.47L239.283 279.433L239.573 277.404L242.15 277.79L242.536 275.213L244.92 275.568L244.405 279.111L244.308 278.982ZM202.436 249.993L202.758 247.61L200.568 247.288L200.89 245.065L203.08 245.355L203.402 243.004L198.99 242.36L198.023 249.349L202.436 249.993Z",
    fill: "#2E7EAF"
  }), React.createElement("path", {
    d: "M249.913 236.015L249.719 237.335L248.141 237.11L248.495 234.662L250.041 234.887L249.913 236.015Z",
    fill: "#2E7EAF"
  }), React.createElement("path", {
    d: "M241.312 233.664L240.958 236.112L238.091 235.693L237.769 237.883L235.933 237.625L233.518 237.271L231.166 236.949L231.488 234.759L226.657 234.082L227.011 231.635L241.312 233.664Z",
    fill: "#2E7EAF"
  }), React.createElement("path", {
    d: "M207.461 250.573L204.852 250.187L205.174 247.836L202.629 247.481L202.307 249.833L198.893 249.349L199.537 244.743L205.754 245.645L206.43 240.814L201.148 240.073L201.502 237.529L196.993 236.917L196.638 239.429L194.126 239.075L193.45 243.874L192.644 249.414L195.382 249.8L195.028 252.28L197.54 252.635L197.154 255.437L201.438 256.049L203.982 256.403L204.369 253.601L206.978 253.955L207.461 250.573Z",
    fill: "#BCFAFF"
  }), React.createElement("path", {
    d: "M259.344 228.865L258.667 233.649L260.581 233.92L261.257 229.136L259.344 228.865Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M258.319 236.08L258.158 237.175L256.226 236.885L255.839 239.558L251.072 238.882L250.943 239.751L252.972 240.041H253.069L254.841 240.299L254.229 244.615L252.489 244.357L252.425 244.744L252.328 244.712L251.652 249.285L249.236 248.963L248.882 251.443L248.592 251.411L240.057 250.187L240.089 249.801L241.377 249.962L241.538 248.963L242.827 249.157L242.955 248.126L244.276 248.319L244.598 245.936H244.63L244.92 243.906L246.209 244.1L246.498 241.942L247.787 242.135L248.077 240.106L246.788 239.912L246.885 239.172L247.851 239.3L248.141 237.11L249.719 237.336L249.913 236.015L250.041 234.888L248.495 234.662L248.141 237.11L240.958 236.112L241.313 233.664L227.012 231.635L226.657 234.083L217.317 232.762L217.639 230.314L198.442 227.609L197.766 232.214L195.447 231.892L195.06 234.469L192.29 234.05L192.644 231.474L193.289 231.57L194.126 225.547L195.704 225.773L195.833 224.71L196.51 220.072L199.247 220.458L198.603 225.096L217.993 227.834V227.802L227.366 229.122V229.155L250.396 232.408L258.674 233.567L258.319 236.08Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M252.186 225.647L251.888 227.752L259.351 228.806L259.649 226.701L252.186 225.647Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M256.999 242.779H256.612C256.838 242.586 256.999 242.586 256.999 242.779Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M251.781 262.008L250.814 268.997L249.043 268.739L248.495 268.675L249.494 261.686L251.781 262.008Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M249.043 268.74L248.366 273.603L246.112 273.281L245.79 275.6L245.757 275.665L247.529 275.89L247.046 279.369L245.274 279.111L244.727 282.912L244.566 284.039L243.632 283.91L242.15 283.717L241.764 286.39L236.964 285.714L236.9 285.263L237.319 282.267L240.829 282.751L240.894 282.364L243.76 282.783L244.308 278.982L244.791 275.503L244.823 275.471L242.44 275.117L242.762 272.798L245.145 273.152H245.242L245.919 268.353V268.321L248.495 268.675L249.043 268.74Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M247.585 258.715L247.201 261.426L249.497 261.751L249.881 259.04L247.585 258.715Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M245.851 253.899L245.215 258.396L247.607 258.734L248.243 254.237L245.851 253.899Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M249.859 222.679L249.494 225.262L252.173 225.64L252.538 223.057L249.859 222.679Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M245.919 268.321V268.353L222.084 265.003L222.406 262.62L246.241 266.002L245.919 268.321Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M246.808 239.915L246.52 241.956L247.795 242.137L248.084 240.095L246.808 239.915Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M247.946 219.763L247.581 222.346L249.877 222.67L250.242 220.087L247.946 219.763Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M239.82 274.769L239.459 277.32L242.043 277.685L242.403 275.133L239.82 274.769Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M246.498 241.941L246.208 244.099L244.92 243.906L245.5 239.751L246.788 239.912L246.498 241.941Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M246.885 239.171L246.788 239.912L245.5 239.751L244.211 239.558L243.438 244.969H243.406L242.118 244.808L240.829 244.615L240.088 249.801L240.056 250.187L236.706 249.704L237.061 247.224L234.613 246.902L235.257 242.296L232.841 241.974L232.197 246.547L229.749 246.193L229.395 248.673L220.602 247.449L220.666 247.031L221.955 247.224L222.083 246.225L223.404 246.386L223.533 245.388L224.821 245.549L225.176 243.198L225.465 241.168L226.754 241.329L227.076 239.204L228.364 239.397L228.622 237.368L227.366 237.174L226.077 236.981L226.174 236.24L226.335 236.273L226.657 234.082L231.489 234.759L231.166 236.949L233.518 237.271L235.933 237.625L237.769 237.883L238.091 235.693L240.958 236.112L240.668 238.302L246.885 239.171Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M244.92 243.906L244.63 245.935H244.598L244.727 245.162L243.439 244.969L244.212 239.558L245.5 239.751L244.92 243.906Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M244.598 245.935L244.276 248.319L242.955 248.126L243.406 244.969H243.438L243.342 245.774L244.598 245.935Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M243.445 245.008L243.337 245.773L244.612 245.953L244.72 245.188L243.445 245.008Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M243.181 253.826L242.569 258.239L240.185 257.917L240.507 255.727L238.253 255.405L237.931 257.595L235.579 257.273L235.869 255.083L236.191 252.86L238.543 253.182L240.797 253.504L243.181 253.826Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M245.983 217.161L245.649 219.521L247.946 219.846L248.279 217.486L245.983 217.161Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M218.527 274.373L218.243 276.383L239.197 279.342L239.48 277.333L218.527 274.373Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M242.955 248.125L242.826 249.156L241.538 248.963L242.118 244.808L243.406 244.969L242.955 248.125Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M179.052 263.489H179.986C180.417 262.32 180.922 261.179 181.5 260.075L179.567 259.817L180.373 254.149L182.273 254.406L182.885 250.122L184.624 250.38L186.235 239.075L184.624 238.817L183.916 243.648L182.015 243.391L180.727 252.538L179.052 252.409L177.667 262.072L179.406 262.33L179.052 263.489Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M241.538 248.963L241.377 249.961L240.089 249.8L240.829 244.615L242.118 244.808L241.538 248.963Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M243.885 214.374L243.552 216.734L245.976 217.076L246.309 214.716L243.885 214.374Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M243.555 216.761L243.226 219.089L245.65 219.431L245.978 217.103L243.555 216.761Z",
    fill: "#B3D8F9"
  }), React.createElement("path", {
    d: "M241.59 214.089L241.261 216.417L243.557 216.742L243.886 214.413L241.59 214.089Z",
    fill: "#B3D8F9"
  }), React.createElement("path", {
    d: "M236.905 211.008L236.562 213.432L243.897 214.469L244.24 212.046L236.905 211.008Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M234.398 210.623L234.056 213.047L236.543 213.399L236.886 210.975L234.398 210.623Z",
    fill: "#B3D8F9"
  }), React.createElement("path", {
    d: "M233.614 252.506L233.002 256.887L230.651 256.564L230.941 254.374L228.686 254.052L228.364 256.242L226.013 255.92L226.303 253.73L226.625 251.508L229.009 251.83L231.263 252.152L233.614 252.506Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M222.786 206.745L222.48 208.913L236.863 210.945L237.17 208.776L222.786 206.745Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M227.365 237.183L227.077 239.224L228.353 239.405L228.641 237.364L227.365 237.183Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M227.076 239.204L226.754 241.329L225.465 241.168L226.077 236.981L227.366 237.174L227.076 239.204Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M225.466 241.168L225.176 243.197L225.272 242.424L224.016 242.231L224.757 236.82L226.078 236.981L225.466 241.168Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M226.174 236.24L226.078 236.981L224.757 236.82L224.016 242.231H223.984L222.696 242.038L221.375 241.877L220.666 247.03L220.602 247.449L217.252 246.966L217.607 244.486L215.159 244.132L215.803 239.558L211.39 238.946L210.037 248.48L211.905 248.738L211.551 251.153L209.103 250.831L209.425 248.383L207.461 248.126L208.781 238.559L206.784 238.302L206.43 240.846L201.115 240.105L201.502 237.529L199.537 237.271L197.025 236.917L197.379 234.469L199.891 234.823L200.213 232.568L209.458 233.889L211.97 234.243L212.292 232.053L217.317 232.762L216.995 234.952L218.927 235.21L226.174 236.24Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M225.176 243.198L224.821 245.549L223.533 245.388L223.984 242.231H224.016L223.887 243.004L225.176 243.198Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M224.006 242.244L223.898 243.009L225.174 243.189L225.282 242.424L224.006 242.244Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M220.45 259.809L220.094 262.328L222.391 262.653L222.746 260.133L220.45 259.809Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M223.533 245.388L223.404 246.386L222.084 246.225L222.696 242.038L223.984 242.231L223.533 245.388Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M218.916 254.46L218.564 256.947L221.084 257.303L221.435 254.816L218.916 254.46Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M216.469 271.478L216.108 274.029L218.564 274.376L218.924 271.825L216.469 271.478Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M222.084 246.225L221.955 247.224L220.666 247.031L221.375 241.877L222.696 242.038L222.084 246.225Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M218.186 259.463V259.56L215.803 259.206L216.189 256.597L218.573 256.919L218.186 259.463Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M211.555 251.171L211.244 253.371L218.898 254.453L219.209 252.252L211.555 251.171Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M214.473 268.619L214.117 271.138L216.445 271.467L216.801 268.947L214.473 268.619Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M213.32 258.887L211.991 268.296L214.479 268.647L215.808 259.239L213.32 258.887Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M215.696 207.932L215.353 210.355L222.146 211.315L222.489 208.891L215.696 207.932Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M210.312 209.657L209.983 211.985L215.022 212.697L215.351 210.369L210.312 209.657Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M204.502 252.856L204.115 255.599L206.698 255.964L207.085 253.221L204.502 252.856Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M197.279 254.686L196.973 256.855L203.798 257.819L204.104 255.65L197.279 254.686Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M207.43 211.609L207.065 214.193L209.617 214.553L209.982 211.97L207.43 211.609Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M202.694 247.481L202.372 249.833L200.149 249.543L197.927 249.221L198.281 246.869L198.603 244.615L198.925 242.231L203.338 242.875L203.016 245.227L200.826 244.937L200.503 247.159L202.694 247.481Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M207.074 214.177L206.365 219.105L204.916 218.88L204.594 221.199L202.339 220.876L199.247 220.458L199.601 217.881L202.693 218.3L202.855 217.108L204.207 217.301L204.723 213.855L207.074 214.177Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M195.091 251.859L194.744 254.314L197.264 254.67L197.61 252.215L195.091 251.859Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M192.757 248.806L192.379 251.485L195.122 251.872L195.5 249.193L192.757 248.806Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M194.459 236.618L194.071 239.36L196.654 239.726L197.042 236.983L194.459 236.618Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M191.709 238.994L190.371 248.466L192.763 248.804L194.101 239.332L191.709 238.994Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M189.823 233.75L189.48 236.174L191.936 236.521L192.279 234.097L189.823 233.75Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M186.843 235.812L186.361 239.224L189.008 239.598L189.49 236.186L186.843 235.812Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M243.149 286.261L238.607 288.323V285.102H242.955L243.149 286.261Z",
    fill: "#041836"
  }), React.createElement("path", {
    d: "M97.6258 103.892L97.3682 105.824H98.5277V107.467H97.0783L96.8206 109.432L95.1135 109.593L95.3712 107.628L93.4708 107.789L93.2132 109.754L91.5061 109.915L91.7637 107.95H90.7653V106.308H92.0536L92.3113 104.375H91.1518V102.7H92.6012L92.8589 100.8L94.566 100.639L94.3083 102.539H96.2086L96.4341 100.639L98.1734 100.478L97.9157 102.378H98.9142V104.021L97.6258 103.892ZM94.0184 104.214L93.7607 106.147L95.6611 105.953L95.9187 104.021L94.0184 104.214Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M100.75 100.188L107.192 99.608V101.09L103.391 108.981L101.137 109.206L104.97 101.508L100.686 101.895L100.75 100.188Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M116.179 106.437C116.029 106.787 115.797 107.096 115.503 107.339C115.174 107.609 114.804 107.826 114.408 107.983C113.963 108.147 113.496 108.244 113.023 108.273C112.554 108.355 112.074 108.355 111.606 108.273C111.205 108.212 110.821 108.07 110.478 107.854C110.16 107.665 109.895 107.399 109.705 107.081C109.508 106.774 109.407 106.415 109.415 106.05C109.363 105.569 109.465 105.085 109.705 104.665C109.991 104.263 110.366 103.933 110.8 103.699C110.443 103.546 110.132 103.301 109.898 102.99C109.681 102.641 109.559 102.242 109.544 101.831C109.542 101.488 109.608 101.149 109.737 100.832C109.893 100.503 110.112 100.207 110.382 99.9626C110.668 99.7076 110.995 99.5009 111.348 99.3506C111.769 99.1831 112.215 99.0852 112.668 99.0607C113.094 98.9789 113.531 98.9789 113.957 99.0607C114.335 99.1458 114.696 99.2985 115.02 99.5116C115.301 99.7011 115.533 99.9551 115.696 100.252C115.849 100.541 115.937 100.86 115.954 101.187C115.978 101.61 115.889 102.033 115.696 102.41C115.474 102.751 115.19 103.046 114.859 103.28C115.286 103.438 115.671 103.692 115.986 104.021C116.271 104.388 116.42 104.844 116.405 105.309C116.45 105.699 116.371 106.094 116.179 106.437ZM113.989 104.568C113.64 104.397 113.248 104.33 112.862 104.375C112.459 104.405 112.071 104.538 111.734 104.762C111.599 104.862 111.49 104.993 111.417 105.145C111.344 105.296 111.309 105.463 111.316 105.631C111.323 105.787 111.368 105.939 111.446 106.073C111.525 106.208 111.635 106.321 111.767 106.404C112.134 106.586 112.544 106.664 112.953 106.63C113.362 106.596 113.753 106.451 114.086 106.211C114.211 106.111 114.311 105.983 114.378 105.838C114.445 105.693 114.477 105.534 114.472 105.374C114.481 105.207 114.44 105.041 114.354 104.897C114.268 104.753 114.141 104.639 113.989 104.568ZM113.699 100.864C113.419 100.667 113.072 100.586 112.733 100.639C112.375 100.647 112.031 100.784 111.767 101.025C111.561 101.23 111.445 101.508 111.445 101.799C111.455 101.946 111.494 102.091 111.561 102.224C111.627 102.356 111.719 102.474 111.831 102.572C112.113 102.766 112.458 102.847 112.797 102.797C113.145 102.784 113.477 102.647 113.731 102.41C113.839 102.306 113.923 102.181 113.978 102.042C114.034 101.903 114.059 101.755 114.053 101.605C114.052 101.463 114.02 101.323 113.959 101.195C113.898 101.067 113.809 100.954 113.699 100.864Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M126.131 104.279C125.977 104.844 125.726 105.378 125.39 105.857C125.106 106.34 124.734 106.766 124.295 107.113C123.792 107.405 123.231 107.581 122.652 107.629C122.084 107.672 121.514 107.595 120.977 107.403C120.479 107.214 120.028 106.917 119.657 106.534C119.287 106.128 118.992 105.659 118.787 105.149C118.58 104.557 118.461 103.939 118.433 103.313C118.427 102.683 118.502 102.055 118.658 101.445C118.837 100.894 119.098 100.372 119.431 99.8986C119.778 99.4491 120.203 99.067 120.688 98.7712C121.192 98.4904 121.754 98.3254 122.33 98.2881C122.896 98.2193 123.47 98.2855 124.005 98.4813C124.494 98.6713 124.934 98.9685 125.293 99.351C125.686 99.7521 125.983 100.236 126.163 100.768C126.398 101.341 126.518 101.953 126.517 102.572C126.489 103.159 126.358 103.737 126.131 104.279ZM124.295 101.477C124.19 101.166 124.038 100.872 123.844 100.607C123.678 100.374 123.456 100.186 123.2 100.06C122.938 99.9385 122.65 99.8832 122.362 99.8986C122.074 99.9266 121.797 100.026 121.557 100.188C121.307 100.354 121.097 100.574 120.945 100.833C120.776 101.134 120.656 101.46 120.591 101.799C120.54 102.184 120.54 102.574 120.591 102.958C120.603 103.341 120.668 103.721 120.784 104.086C120.871 104.398 121.013 104.693 121.203 104.955C121.38 105.199 121.612 105.397 121.879 105.535C122.154 105.605 122.442 105.605 122.717 105.535C123.004 105.502 123.28 105.403 123.522 105.245C123.757 105.063 123.964 104.846 124.134 104.601C124.2 104.368 124.254 104.131 124.295 103.893C124.328 103.517 124.328 103.14 124.295 102.765C124.34 102.337 124.34 101.905 124.295 101.477Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M134.634 97.0963L134.859 102.636H136.051V104.247H134.859V106.179L132.927 106.373V104.408L128.482 104.794L128.095 103.442L132.895 97.2574L134.634 97.0963ZM132.83 99.9951L130.511 103.023L132.927 102.797L132.83 99.9951Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M214.482 182.548L213.87 184.416H214.998L214.772 186.058L213.355 185.833L212.743 187.733L211.036 187.476L211.648 185.608L209.812 185.318L209.2 187.186L207.493 186.928L208.105 185.06H207.139L207.396 183.385L208.653 183.578L209.232 181.742L208.041 181.581L208.298 179.939L209.715 180.164L210.295 178.328L212.002 178.586L211.39 180.422L213.258 180.68L213.87 178.876L215.545 179.101L214.933 180.937H215.932L215.674 182.58L214.482 182.548ZM210.939 182.032L210.327 183.868L212.196 184.158L212.808 182.29L210.939 182.032Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M224.693 186.96C224.429 187.467 224.08 187.924 223.662 188.313C223.256 188.684 222.771 188.959 222.245 189.118C221.692 189.233 221.122 189.233 220.57 189.118C220.003 189.042 219.462 188.832 218.991 188.506C218.538 188.203 218.154 187.808 217.864 187.346C217.567 186.853 217.37 186.306 217.284 185.736C217.188 185.117 217.188 184.487 217.284 183.868C217.377 183.243 217.562 182.635 217.832 182.064C218.093 181.556 218.442 181.098 218.863 180.711C219.277 180.352 219.759 180.078 220.28 179.906C220.831 179.776 221.404 179.776 221.955 179.906C222.519 179.971 223.06 180.17 223.533 180.486C223.979 180.797 224.362 181.191 224.66 181.645C224.953 182.141 225.149 182.688 225.24 183.256C225.337 183.875 225.337 184.505 225.24 185.124C225.154 185.761 224.969 186.38 224.693 186.96ZM223.243 183.739C223.208 183.405 223.121 183.079 222.985 182.773C222.868 182.511 222.692 182.279 222.47 182.096C222.246 181.896 221.964 181.772 221.665 181.742C221.392 181.662 221.101 181.662 220.827 181.742C220.564 181.842 220.331 182.009 220.151 182.225C219.918 182.48 219.732 182.774 219.603 183.095C219.465 183.459 219.368 183.837 219.314 184.222C219.265 184.607 219.265 184.997 219.314 185.382C219.349 185.715 219.436 186.041 219.571 186.348C219.697 186.614 219.872 186.855 220.087 187.057C220.321 187.234 220.599 187.345 220.892 187.379C221.163 187.474 221.458 187.474 221.729 187.379C221.998 187.271 222.239 187.106 222.438 186.896C222.66 186.639 222.835 186.344 222.953 186.026C223.088 185.672 223.185 185.305 223.243 184.931C223.294 184.524 223.294 184.113 223.243 183.707V183.739Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M229.975 183.288C229.603 183.506 229.257 183.765 228.944 184.061L227.72 182.741C227.964 182.478 228.233 182.24 228.525 182.032C228.774 181.841 229.044 181.679 229.33 181.549C229.627 181.421 229.943 181.345 230.264 181.323C230.628 181.276 230.996 181.276 231.36 181.323C231.796 181.384 232.221 181.514 232.616 181.71C232.952 181.883 233.248 182.124 233.485 182.419C233.716 182.713 233.881 183.053 233.969 183.417C234.05 183.799 234.05 184.194 233.969 184.577C233.946 184.927 233.847 185.267 233.679 185.575C233.529 185.855 233.345 186.114 233.131 186.348C232.866 186.604 232.575 186.831 232.261 187.025L231.102 187.733L229.491 188.635L233.389 189.215L233.131 190.922L226.496 189.956L226.754 188.377L229.975 186.38L230.812 185.865L231.36 185.382C231.487 185.259 231.595 185.118 231.682 184.963C231.783 184.81 231.839 184.631 231.843 184.448C231.883 184.288 231.887 184.12 231.853 183.959C231.82 183.797 231.75 183.645 231.649 183.514C231.433 183.274 231.134 183.125 230.812 183.095C230.52 183.073 230.228 183.141 229.975 183.288Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M243.277 189.762C243.019 190.272 242.67 190.73 242.247 191.115C241.841 191.469 241.371 191.743 240.862 191.92C240.3 192.051 239.716 192.051 239.155 191.92C238.595 191.835 238.058 191.638 237.576 191.34C237.131 191.025 236.758 190.619 236.481 190.149C236.189 189.665 235.992 189.129 235.902 188.57C235.788 187.942 235.788 187.298 235.902 186.67C235.991 186.051 236.188 185.451 236.481 184.899C236.723 184.378 237.075 183.917 237.512 183.546C237.913 183.168 238.399 182.892 238.929 182.74C239.468 182.577 240.037 182.536 240.594 182.62C241.151 182.703 241.683 182.909 242.15 183.224C242.607 183.512 242.983 183.911 243.245 184.383C243.543 184.877 243.74 185.424 243.825 185.994C243.938 186.611 243.938 187.244 243.825 187.862C243.756 188.523 243.571 189.166 243.277 189.762ZM241.86 186.541C241.825 186.208 241.738 185.882 241.603 185.575C241.476 185.3 241.289 185.058 241.055 184.866C240.831 184.685 240.565 184.563 240.282 184.512C240.007 184.447 239.72 184.447 239.445 184.512C239.176 184.635 238.936 184.81 238.736 185.027C238.522 185.278 238.348 185.561 238.221 185.865C238.06 186.223 237.952 186.603 237.898 186.992C237.867 187.378 237.867 187.766 237.898 188.152C237.937 188.499 238.035 188.837 238.188 189.15C238.304 189.413 238.48 189.645 238.704 189.827C238.927 190.008 239.193 190.13 239.477 190.181C239.752 190.248 240.039 190.248 240.314 190.181C240.589 190.069 240.832 189.892 241.023 189.665C241.249 189.424 241.425 189.139 241.538 188.828C241.702 188.471 241.811 188.091 241.86 187.701C241.91 187.305 241.91 186.905 241.86 186.509V186.541Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M246.692 185.511L246.949 183.804L253.037 184.738L252.811 186.219L250.202 188.055C250.506 188.151 250.798 188.281 251.072 188.442C251.348 188.58 251.59 188.778 251.781 189.022C251.97 189.261 252.112 189.534 252.199 189.827C252.283 190.198 252.283 190.583 252.199 190.954C252.132 191.353 251.99 191.735 251.781 192.081C251.595 192.428 251.33 192.726 251.008 192.951C250.664 193.171 250.281 193.324 249.88 193.402C249.422 193.484 248.953 193.484 248.495 193.402C247.838 193.31 247.209 193.074 246.653 192.712C246.096 192.351 245.626 191.871 245.274 191.308L246.82 190.213C247.05 190.576 247.345 190.892 247.69 191.147C248.03 191.398 248.43 191.553 248.85 191.598C249.17 191.665 249.504 191.608 249.784 191.437C249.911 191.354 250.02 191.245 250.103 191.118C250.186 190.99 250.242 190.847 250.267 190.696C250.302 190.526 250.291 190.349 250.234 190.185C250.177 190.021 250.077 189.875 249.945 189.762C249.585 189.477 249.147 189.309 248.688 189.279H247.851V187.959L250.331 186.123L246.692 185.511Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M186.879 307.552C186.601 307.707 186.31 307.837 186.009 307.938C185.673 308.037 185.327 308.101 184.978 308.132C184.582 308.162 184.183 308.162 183.787 308.132C183.158 308.04 182.556 307.82 182.015 307.487C181.496 307.187 181.046 306.781 180.694 306.296C180.332 305.808 180.079 305.248 179.954 304.653C179.822 304.037 179.822 303.401 179.954 302.785C180.04 302.16 180.248 301.558 180.566 301.013C180.863 300.502 181.257 300.054 181.725 299.693C182.209 299.311 182.769 299.036 183.368 298.888C184.007 298.773 184.661 298.773 185.3 298.888L186.428 299.145C186.744 299.263 187.046 299.414 187.33 299.596C187.592 299.742 187.831 299.926 188.038 300.144C188.266 300.346 188.472 300.573 188.65 300.82L187.169 302.076C186.896 301.726 186.57 301.422 186.202 301.174C185.853 300.92 185.441 300.764 185.01 300.723C184.661 300.643 184.297 300.643 183.948 300.723C183.613 300.812 183.305 300.978 183.046 301.207C182.76 301.431 182.529 301.718 182.369 302.044C182.185 302.361 182.065 302.711 182.015 303.075C181.934 303.446 181.934 303.831 182.015 304.202C182.076 304.557 182.207 304.897 182.402 305.201C182.59 305.491 182.844 305.734 183.142 305.909C183.428 306.136 183.777 306.271 184.141 306.296C184.584 306.412 185.05 306.412 185.494 306.296C185.899 306.13 186.287 305.925 186.653 305.684L187.716 307.133C187.452 307.302 187.172 307.442 186.879 307.552Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M195.962 307.648C195.711 308.033 195.395 308.371 195.028 308.647C194.642 308.933 194.205 309.141 193.739 309.259C192.731 309.506 191.665 309.344 190.776 308.808C190.351 308.587 189.987 308.266 189.713 307.874C189.424 307.514 189.215 307.097 189.101 306.65C188.991 306.173 188.991 305.677 189.101 305.2C189.164 304.72 189.329 304.259 189.584 303.848C189.834 303.453 190.15 303.104 190.518 302.817C190.916 302.559 191.35 302.364 191.807 302.237C192.815 301.99 193.881 302.152 194.77 302.688C195.2 302.901 195.567 303.223 195.833 303.622C196.122 303.982 196.331 304.399 196.445 304.846C196.541 305.324 196.541 305.817 196.445 306.296C196.382 306.776 196.217 307.237 195.962 307.648ZM194.545 306.006C194.593 305.761 194.593 305.509 194.545 305.265C194.501 305.02 194.402 304.789 194.255 304.588C194.116 304.386 193.942 304.211 193.739 304.073C193.521 303.944 193.281 303.856 193.031 303.815C192.775 303.767 192.513 303.767 192.258 303.815L191.646 304.138C191.479 304.297 191.338 304.482 191.227 304.685C191.108 304.908 191.021 305.146 190.969 305.394C190.921 305.638 190.921 305.89 190.969 306.134C191.026 306.375 191.125 306.604 191.259 306.811C191.387 307.002 191.551 307.167 191.742 307.294C191.966 307.443 192.218 307.542 192.483 307.584C192.738 307.633 193.001 307.633 193.256 307.584C193.476 307.509 193.682 307.4 193.868 307.262C194.035 307.102 194.176 306.917 194.287 306.714C194.41 306.496 194.486 306.255 194.512 306.006H194.545Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M204.465 308.904C204.233 309.312 203.914 309.664 203.531 309.935C203.146 310.221 202.708 310.429 202.243 310.547C201.732 310.644 201.207 310.644 200.697 310.547C200.195 310.489 199.712 310.324 199.279 310.064C198.875 309.814 198.516 309.498 198.217 309.13C197.937 308.752 197.729 308.327 197.605 307.874C197.491 307.408 197.491 306.922 197.605 306.456C197.662 305.975 197.827 305.512 198.088 305.104C198.338 304.71 198.654 304.361 199.022 304.073C199.412 303.782 199.864 303.584 200.342 303.493C200.84 303.373 201.359 303.373 201.856 303.493C202.358 303.551 202.841 303.716 203.273 303.976C203.693 304.205 204.056 304.524 204.336 304.91C204.616 305.288 204.824 305.714 204.948 306.167C205.046 306.645 205.046 307.138 204.948 307.616C204.882 308.075 204.717 308.515 204.465 308.904ZM203.048 307.262C203.096 307.017 203.096 306.765 203.048 306.521C202.998 306.288 202.899 306.068 202.758 305.877C202.629 305.667 202.452 305.491 202.243 305.361C202.031 305.218 201.788 305.13 201.534 305.104C201.279 305.056 201.017 305.056 200.761 305.104C200.536 305.165 200.327 305.275 200.149 305.426C199.975 305.579 199.833 305.765 199.73 305.973C199.608 306.192 199.531 306.433 199.505 306.682C199.457 306.926 199.457 307.178 199.505 307.423C199.568 307.651 199.666 307.868 199.795 308.067C199.915 308.284 200.093 308.462 200.31 308.582C200.755 308.85 201.288 308.931 201.792 308.808C202.017 308.746 202.225 308.636 202.404 308.486C202.586 308.332 202.739 308.146 202.855 307.938C202.954 307.71 203.029 307.473 203.08 307.229L203.048 307.262Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M205.946 311.223L207.331 301.818L209.296 302.108L208.04 311.513L205.946 311.223Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M220.441 313.382L219.925 311.256L216.125 310.676L215.03 312.576L213 312.286L218.186 303.783L220.022 304.073L222.502 313.736L220.441 313.382ZM218.734 306.457L217.091 309.194L219.475 309.549L218.734 306.457Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M230.909 312.898C230.692 313.279 230.408 313.617 230.071 313.897C229.745 314.148 229.373 314.333 228.976 314.444C228.571 314.508 228.158 314.508 227.752 314.444C227.298 314.378 226.866 314.201 226.496 313.929C226.215 313.682 225.966 313.401 225.755 313.091L225.337 316.023L223.372 315.733L224.692 306.778L226.657 307.101V308.067C226.944 307.78 227.283 307.551 227.656 307.39C228.088 307.271 228.544 307.271 228.976 307.39C229.372 307.467 229.753 307.609 230.104 307.809C230.455 308.028 230.761 308.312 231.005 308.647C231.248 309.021 231.422 309.435 231.521 309.871C231.619 310.392 231.619 310.927 231.521 311.449C231.425 311.971 231.216 312.465 230.909 312.898ZM229.459 311.095C229.509 310.828 229.509 310.555 229.459 310.289C229.427 310.047 229.339 309.815 229.202 309.613C229.083 309.423 228.916 309.268 228.719 309.162C228.537 309.031 228.327 308.943 228.107 308.904C227.882 308.872 227.654 308.872 227.43 308.904C227.217 308.972 227.02 309.081 226.85 309.226C226.675 309.387 226.523 309.571 226.399 309.774C226.276 310.017 226.189 310.278 226.142 310.547C226.093 310.813 226.093 311.086 226.142 311.352C226.173 311.585 226.262 311.806 226.399 311.996C226.527 312.188 226.691 312.352 226.883 312.48C227.006 312.657 227.172 312.801 227.366 312.898C227.589 312.946 227.819 312.946 228.042 312.898C228.257 312.836 228.455 312.726 228.622 312.576C228.813 312.432 228.968 312.244 229.073 312.029C229.211 311.791 229.299 311.528 229.331 311.256L229.459 311.095Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M239.187 313.124V313.349L234.42 312.64C234.411 312.842 234.444 313.043 234.516 313.231C234.588 313.42 234.698 313.591 234.838 313.736C235.11 314.024 235.475 314.206 235.869 314.251C236.166 314.316 236.474 314.316 236.771 314.251C237.084 314.165 237.378 314.023 237.641 313.832L238.607 314.992C238.231 315.346 237.779 315.61 237.286 315.765C236.747 315.897 236.183 315.897 235.644 315.765C235.148 315.682 234.669 315.519 234.226 315.282C233.826 315.052 233.476 314.746 233.196 314.38C232.927 314 232.73 313.575 232.616 313.124C232.534 312.633 232.534 312.132 232.616 311.642C232.745 310.702 233.215 309.842 233.937 309.226C234.283 308.954 234.676 308.746 235.096 308.614C235.563 308.517 236.046 308.517 236.513 308.614C237.027 308.682 237.521 308.857 237.963 309.13C238.338 309.396 238.656 309.736 238.897 310.128C239.126 310.523 239.269 310.962 239.315 311.417C239.38 311.898 239.38 312.385 239.315 312.866C239.25 312.939 239.206 313.028 239.187 313.124ZM237.029 310.74C236.925 310.583 236.787 310.452 236.625 310.357C236.463 310.263 236.282 310.206 236.095 310.193C235.917 310.155 235.733 310.156 235.555 310.195C235.377 310.234 235.21 310.31 235.064 310.418C234.753 310.684 234.519 311.029 234.387 311.417L237.318 311.867C237.349 311.47 237.247 311.074 237.029 310.74Z",
    fill: "black"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_10025_65883",
    x1: "77.5735",
    y1: "121.093",
    x2: "76.74",
    y2: "111.936",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3C88C4"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2D5382"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_10025_65883",
    x1: "4281.88",
    y1: "-2494.71",
    x2: "4266.5",
    y2: "-2719.94",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3C88C4"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2D5382"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_10025_65883",
    x1: "103.129",
    y1: "135.562",
    x2: "103.708",
    y2: "161.661",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_10025_65883",
    x1: "4877.37",
    y1: "-2455.66",
    x2: "4866.76",
    y2: "-2674.89",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_10025_65883",
    x1: "4050.19",
    y1: "-1594.61",
    x2: "4047.88",
    y2: "-1651.57",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_10025_65883",
    x1: "102.091",
    y1: "143.222",
    x2: "113.645",
    y2: "203.867",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#297EA4"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#25A6C4"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_10025_65883",
    x1: "57.6996",
    y1: "211.59",
    x2: "49.8105",
    y2: "211.722",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_10025_65883",
    x1: "3262.81",
    y1: "-8579.51",
    x2: "3008.25",
    y2: "-8551.41",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_10025_65883",
    x1: "3332.12",
    y1: "-8535.92",
    x2: "3077.65",
    y2: "-8508.54",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_10025_65883",
    x1: "3414.43",
    y1: "-8493.79",
    x2: "3159.87",
    y2: "-8465.69",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_10025_65883",
    x1: "3468.91",
    y1: "-8450.52",
    x2: "3214.51",
    y2: "-8423.16",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_10025_65883",
    x1: "3531.91",
    y1: "-8411.89",
    x2: "3276.55",
    y2: "-8383.86",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_10025_65883",
    x1: "3604.5",
    y1: "-8361.35",
    x2: "3350.64",
    y2: "-8334.1",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_10025_65883",
    x1: "3701.6",
    y1: "-8331.63",
    x2: "3447.25",
    y2: "-8303.61",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_10025_65883",
    x1: "5955.8",
    y1: "-9347.18",
    x2: "3937.6",
    y2: "-8431.03",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_10025_65883",
    x1: "94.7274",
    y1: "160.763",
    x2: "198.741",
    y2: "132.572",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#B2F5F2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F0FDFC"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_10025_65883",
    x1: "130.391",
    y1: "131.684",
    x2: "97.0185",
    y2: "192.442",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5D1780"
  }), React.createElement("stop", {
    offset: "0.25",
    stopColor: "#6C2E93"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#946AC3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A584D8"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_10025_65883",
    x1: "804.269",
    y1: "-5073.99",
    x2: "660.938",
    y2: "-4992.14",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_10025_65883",
    x1: "52.727",
    y1: "327.232",
    x2: "24.7372",
    y2: "287.292",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_10025_65883",
    x1: "5996.68",
    y1: "-1089.78",
    x2: "6009.76",
    y2: "-751.983",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#297EA4"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#25A6C4"
  })), React.createElement("linearGradient", {
    id: "paint20_linear_10025_65883",
    x1: "62.2186",
    y1: "313.009",
    x2: "176.478",
    y2: "144.095",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#38AFDB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_10025_65883",
    x1: "68.8317",
    y1: "236.144",
    x2: "163.463",
    y2: "236.144",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.04",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.62",
    stopColor: "white",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.68",
    stopColor: "white",
    stopOpacity: "0.01"
  }), React.createElement("stop", {
    offset: "0.73",
    stopColor: "white",
    stopOpacity: "0.05"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "white",
    stopOpacity: "0.12"
  }), React.createElement("stop", {
    offset: "0.82",
    stopColor: "white",
    stopOpacity: "0.21"
  }), React.createElement("stop", {
    offset: "0.86",
    stopColor: "white",
    stopOpacity: "0.33"
  }), React.createElement("stop", {
    offset: "0.9",
    stopColor: "white",
    stopOpacity: "0.48"
  }), React.createElement("stop", {
    offset: "0.94",
    stopColor: "white",
    stopOpacity: "0.65"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "white",
    stopOpacity: "0.85"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  })), React.createElement("linearGradient", {
    id: "paint22_linear_10025_65883",
    x1: "49.4094",
    y1: "239.783",
    x2: "170.742",
    y2: "256.725",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_10025_65883",
    x1: "1971.52",
    y1: "7454.02",
    x2: "6477.07",
    y2: "7933.42",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_10025_65883",
    x1: "1350.3",
    y1: "-381.605",
    x2: "1484.01",
    y2: "-362.696",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint25_linear_10025_65883",
    x1: "1084.87",
    y1: "-345.785",
    x2: "1275.53",
    y2: "-318.824",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint26_linear_10025_65883",
    x1: "1106.25",
    y1: "-380.645",
    x2: "1224.46",
    y2: "-363.927",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint27_linear_10025_65883",
    x1: "1108.2",
    y1: "102.538",
    x2: "1205.03",
    y2: "116.231",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint28_linear_10025_65883",
    x1: "967.679",
    y1: "129.003",
    x2: "1051.99",
    y2: "140.925",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint29_linear_10025_65883",
    x1: "997.689",
    y1: "155.222",
    x2: "1107.05",
    y2: "170.687",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint30_linear_10025_65883",
    x1: "688.325",
    y1: "154.407",
    x2: "758.77",
    y2: "164.369",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint31_linear_10025_65883",
    x1: "129.748",
    y1: "186.991",
    x2: "88.7824",
    y2: "250.492",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E8B414"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7830A"
  })), React.createElement("linearGradient", {
    id: "paint32_linear_10025_65883",
    x1: "138.115",
    y1: "181.477",
    x2: "119.746",
    y2: "209.938",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2A54D3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#43E8E1"
  })), React.createElement("linearGradient", {
    id: "paint33_linear_10025_65883",
    x1: "116.846",
    y1: "176.335",
    x2: "133.273",
    y2: "239.796",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#EDC418"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#C95900"
  })), React.createElement("linearGradient", {
    id: "paint34_linear_10025_65883",
    x1: "113.133",
    y1: "200.155",
    x2: "123.719",
    y2: "206.296",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D7830A"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#EABC16"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  })), React.createElement("linearGradient", {
    id: "paint35_linear_10025_65883",
    x1: "94.9211",
    y1: "199.65",
    x2: "140.691",
    y2: "199.65",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint36_linear_10025_65883",
    x1: "13296.5",
    y1: "5587.64",
    x2: "8364.04",
    y2: "4154.09",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint37_linear_10025_65883",
    x1: "285.364",
    y1: "260.257",
    x2: "147.831",
    y2: "239.054",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#B2F5F2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  }))));
};

var marketplace = function marketplace(width, height) {
  if (width === void 0) {
    width = '292';
  }

  if (height === void 0) {
    height = '398';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 292 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M279.726 225.434C283.044 198.214 278.216 170.62 265.852 146.143C253.489 121.666 234.145 101.405 210.267 87.9211C186.389 74.4371 159.049 68.336 131.704 70.3893C104.359 72.4426 78.2366 82.558 56.6401 99.4565C35.0435 116.355 18.9425 139.278 10.3728 165.327C1.80324 191.375 1.14988 219.38 8.49537 245.8C15.8409 272.22 30.8553 295.869 51.6404 313.756C72.4254 331.644 98.0476 342.966 125.267 346.293C143.345 348.502 161.681 347.128 179.228 342.249C196.775 337.371 213.189 329.083 227.533 317.86C241.876 306.637 253.868 292.698 262.824 276.839C271.779 260.98 277.522 243.513 279.726 225.434Z",
    fill: "#ED1818"
  }), React.createElement("path", {
    d: "M238.064 323.559L84.3468 337.103C77.834 337.68 71.3507 335.712 66.258 331.612C61.1653 327.511 57.8594 321.597 57.0343 315.111L31.7534 116.056C31.3693 112.608 31.7403 109.119 32.8408 105.829C33.9412 102.54 35.7446 99.5293 38.1258 97.007C40.5069 94.4848 43.4086 92.5111 46.6294 91.2233C49.8501 89.9355 53.3126 89.3643 56.7764 89.5495L209.429 97.9012C214.882 98.198 220.068 100.359 224.118 104.021C228.168 107.684 230.837 112.627 231.679 118.023L260.701 294.248C261.269 297.676 261.125 301.185 260.276 304.556C259.428 307.926 257.893 311.085 255.769 313.836C253.645 316.587 250.976 318.87 247.93 320.543C244.883 322.216 241.525 323.243 238.064 323.559Z",
    fill: "url(#paint0_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M238.193 322.301L82.7992 336.844C76.596 337.104 70.525 335.002 65.8097 330.963C61.0945 326.924 58.0855 321.248 57.3893 315.078L31.7859 114.056C31.257 110.056 31.907 105.988 33.6562 102.351C32.5921 103.705 27.9809 82.4229 27.9809 82.4229L24.4338 81.9714L28.4968 120.248L54.2937 320.173C54.9899 326.343 57.9989 332.019 62.7141 336.058C67.4294 340.097 73.5004 342.199 79.7036 341.939L235.098 327.396C239.604 327.208 243.972 325.781 247.721 323.273C251.47 320.764 254.455 317.27 256.348 313.176C254.153 315.91 251.396 318.14 248.264 319.715C245.131 321.289 241.697 322.171 238.193 322.301Z",
    fill: "url(#paint1_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M35.494 144.658L61.2586 198.863L228.584 196.284L236.129 145.851L248.254 128.18L228.197 113.25L52.5844 109.219L35.494 144.658Z",
    fill: "url(#paint2_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M266.183 340.23L46.8125 352L14.7277 112.057L275.889 122.763L266.183 340.23Z",
    fill: "url(#paint3_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M130.394 127.567C97.6968 127.987 74.7053 159.072 79.6067 195.284C82.8313 221.081 100.309 245.653 125.106 254.714C133.415 257.441 142.192 258.451 150.903 257.68C159.505 256.438 167.651 253.028 174.572 247.77C181.494 242.513 186.964 235.581 190.469 227.627C191.756 224.852 192.834 221.985 193.693 219.05C194.841 215.209 195.619 211.268 196.015 207.28C200.626 166.94 167.929 126.536 130.394 127.567Z",
    fill: "url(#paint4_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M182.955 152.59L177.183 155.009L175.861 143.174L181.601 140.724L182.955 152.59Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M181.601 140.724L175.861 143.174L170.444 143.271L176.216 140.82L181.601 140.724Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M176.216 140.821L170.444 143.271L169.831 137.79L175.603 135.371L176.216 140.821Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M190.405 180.193L184.632 182.611L183.343 171.067L189.115 168.649L190.405 180.193Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M184.761 168.713L178.989 171.164L177.183 155.009L182.956 152.59L184.761 168.713Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M189.115 168.649L183.343 171.067L178.99 171.164L184.762 168.713L189.115 168.649Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M182.956 152.59L177.184 155.009L171.766 155.106L177.538 152.687L182.956 152.59Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M178.183 158.427L172.411 160.878L171.766 155.106L177.538 152.687L178.183 158.427Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M190.405 180.193L184.633 182.611L180.279 182.676L186.051 180.257L190.405 180.193Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M179.312 168.81L173.572 171.261L172.411 160.877L178.183 158.427L179.312 168.81Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M178.183 158.427L172.411 160.877L167.8 160.942L173.54 158.524L178.183 158.427Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M178.2 158.394L178.168 158.398L179.33 168.781L179.362 168.777L178.2 158.394Z",
    fill: "url(#paint5_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M179.312 168.81L173.572 171.261L172.411 160.877L178.151 158.459L179.312 168.81Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M179.332 168.831L173.566 171.259L173.579 171.289L179.344 168.861L179.332 168.831Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M174.217 164.586L168.477 167.037L167.8 160.942L173.54 158.524L174.217 164.586Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M179.312 168.81L173.572 171.261L168.155 171.358L173.927 168.907L179.312 168.81Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M173.927 168.907L168.155 171.357L163.511 171.422L169.283 169.003L173.927 168.907Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M190.437 219.501L184.665 221.952L180.279 182.676L186.051 180.258L190.437 219.501Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M181.279 186.126L175.507 188.545L170.089 188.642L175.862 186.223L181.279 186.126Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M175.861 186.223L170.089 188.642L169.444 182.87L175.216 180.451L175.861 186.223Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M170.573 180.515L164.801 182.966L164.221 177.484L169.96 175.066L170.573 180.515Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M175.217 180.451L169.445 182.87L164.801 182.966L170.573 180.516L175.217 180.451Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M185.019 219.598L179.279 222.016L175.507 188.545L181.279 186.126L185.019 219.598Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M190.437 219.501L184.665 221.952L179.28 222.016L185.019 219.598L190.437 219.501Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M185.019 219.598L179.279 222.016L175.507 188.545L181.247 186.126L185.019 219.598Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M185.664 225.37L179.924 227.788L179.28 222.016L185.019 219.598L185.664 225.37Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M174.217 164.586L168.477 167.037L152.741 167.295L158.513 164.876L174.217 164.586Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M158.513 164.876L152.741 167.295L152.064 161.233L157.836 158.814L158.513 164.876Z",
    fill: "#27606A"
  }), React.createElement("path", {
    d: "M179.28 214.503L173.54 216.921L172.83 210.859L178.602 208.44L179.28 214.503Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M169.283 169.004L163.511 171.422L153.74 171.583L159.48 169.165L169.283 169.004Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M185.02 219.598L179.248 222.016L173.83 222.145L179.602 219.695L185.02 219.598Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M179.667 220.146L173.895 222.564L173.83 222.145L179.602 219.694L179.667 220.146Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M179.667 220.146L173.895 222.564H173.637L179.409 220.146H179.667Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M169.961 175.066L164.221 177.484L154.418 177.678L160.19 175.259L169.961 175.066Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M185.664 225.37L179.924 227.788L174.765 227.885L180.505 225.467L185.664 225.37Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M180.215 225.176L174.443 227.627L173.894 222.564L179.666 220.146L180.215 225.176Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M179.409 220.146H179.667L180.215 225.176H179.989L179.409 220.146Z",
    fill: "url(#paint6_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M179.989 225.176L174.217 227.627L173.637 222.564L179.409 220.146L179.989 225.176Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M180.215 225.176L174.443 227.627H174.217L179.989 225.176H180.215Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M160.803 180.709L155.031 183.128L154.418 177.678L160.19 175.26L160.803 180.709Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M181.15 231.239L175.41 233.657L174.765 227.885L180.505 225.467L181.15 231.239Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M159.481 169.165L153.741 171.583L149.13 171.68L154.902 169.262L159.481 169.165Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M168.735 203.152L162.963 205.571L161.093 188.803L166.865 186.384L168.735 203.152Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M166.865 186.384L161.093 188.803L155.708 188.899L161.447 186.481L166.865 186.384Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M160.803 180.709L155.031 183.127L150.42 183.224L156.192 180.773L160.803 180.709Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M175.603 135.371L169.831 137.79L129.911 138.499L135.65 136.081L175.603 135.371Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M156.837 186.546L151.064 188.996L150.42 183.224L156.192 180.774L156.837 186.546Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M163.35 203.217L157.578 205.668L155.708 188.9L161.447 186.481L163.35 203.217Z",
    fill: "#3E787A"
  }), React.createElement("path", {
    d: "M163.35 203.217L161.447 186.481L166.865 186.384L168.735 203.152L163.35 203.217Z",
    fill: "url(#paint7_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M168.735 203.152L162.963 205.571L157.578 205.668L163.35 203.217L168.735 203.152Z",
    fill: "#3B7274"
  }), React.createElement("path", {
    d: "M136.231 141.272L130.491 143.69L129.911 138.499L135.65 136.08L136.231 141.272Z",
    fill: "#27606A"
  }), React.createElement("path", {
    d: "M154.901 169.262L149.129 171.68L138.553 171.841L144.293 169.423L154.901 169.262Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M136.231 141.272L130.491 143.69L125.622 143.787L131.362 141.336L136.231 141.272Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M157.836 158.814L152.064 161.233L132.49 161.555L138.263 159.137L157.836 158.814Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M132.039 147.399L126.299 149.817L125.622 143.787L131.362 141.337L132.039 147.399Z",
    fill: "#27606A"
  }), React.createElement("path", {
    d: "M144.293 169.423L138.553 171.841L133.91 171.938L139.682 169.52L144.293 169.423Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M156.836 186.546L151.064 188.996L140.487 189.19L146.227 186.739L156.836 186.546Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M146.227 186.739L140.488 189.19L139.843 183.386L145.582 180.967L146.227 186.739Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M138.263 159.136L132.491 161.555L128.105 161.652L133.877 159.201L138.263 159.136Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M133.877 159.201L128.105 161.652H127.621L133.361 159.233L133.877 159.201Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M179.989 225.176L174.217 227.627L155.417 227.949L161.19 225.531L179.989 225.176Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M178.603 208.44L172.83 210.859L148.388 211.278L154.16 208.86L178.603 208.44Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M132.039 147.399L126.299 149.817L121.366 149.914L127.138 147.463L132.039 147.399Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M145.582 180.967L139.843 183.386L135.199 183.482L140.971 181.032L145.582 180.967Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M140.971 181.031L135.199 183.482L134.587 178.032L140.359 175.582L140.971 181.031Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M181.15 231.239L175.41 233.657L156.095 234.012L161.867 231.561L181.15 231.239Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M179.28 214.503L173.54 216.921L149.065 217.373L154.837 214.922L179.28 214.503Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M154.837 214.922L154.16 208.86L178.602 208.44L179.279 214.503L154.837 214.922Z",
    fill: "#041735"
  }), React.createElement("path", {
    d: "M154.837 214.922L149.065 217.373L148.388 211.278L154.16 208.86L154.837 214.922Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M135.038 169.584L129.266 172.035L128.105 161.652L133.877 159.201L135.038 169.584Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M174.249 164.586L173.54 158.395H178.151L179.312 168.778L135.038 169.552L133.877 159.169L157.836 158.75L158.513 164.844L174.249 164.586Z",
    fill: "url(#paint8_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M139.681 169.52L133.909 171.938L129.266 172.035L135.038 169.584L139.681 169.52Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M127.783 153.268L122.011 155.686L121.366 149.914L127.138 147.463L127.783 153.268Z",
    fill: "#27606A"
  }), React.createElement("path", {
    d: "M140.358 175.582L134.586 178.032L129.943 178.097L135.715 175.679L140.358 175.582Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M133.361 159.233L127.621 161.651L122.72 161.748L128.492 159.297L133.361 159.233Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M161.189 225.531L155.417 227.949L150.258 228.046L156.03 225.595L161.189 225.531Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M156.03 225.595L150.258 228.046H150L155.772 225.595H156.03Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M136.36 181.483L130.62 183.902L129.943 178.097L135.715 175.679L136.36 181.483Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M164.124 247.684L158.352 250.103L156.095 234.012L161.867 231.561L164.124 247.684Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M129.105 165.102L123.333 167.52L122.72 161.748L128.492 159.297L129.105 165.102Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M164.124 247.684L158.352 250.103H157.933L163.705 247.652H164.124",
    fill: "#020C1C"
  }), React.createElement("path", {
    d: "M129.137 165.102L123.365 167.52L117.947 167.617L123.687 165.199L129.137 165.102Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M130.104 174.034L124.332 176.485L123.333 167.52L129.105 165.102L130.104 174.034Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M130.298 175.775L124.526 178.194L124.332 176.485L130.104 174.034L130.298 175.775Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M135.715 175.679L129.943 178.097L124.526 178.194L130.298 175.776L135.715 175.679Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M127.783 153.268L122.011 155.686L111.982 155.88L117.754 153.429L127.783 153.268Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M124.235 170.068L118.496 172.519L117.947 167.617L123.687 165.199L124.235 170.068Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M129.653 169.971L123.881 172.422L118.496 172.518L124.236 170.068L129.653 169.971Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M124.687 174.131L118.947 176.549L118.496 172.519L124.236 170.068L124.687 174.131Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M117.754 153.429L111.982 155.88L107.629 155.944L113.369 153.526L117.754 153.429Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M124.235 170.068L118.496 172.519L113.852 172.583L119.624 170.165L124.235 170.068Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M113.369 153.526L107.629 155.944H106.823L112.595 153.526H113.369Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M120.269 175.937L114.497 178.355L113.852 172.583L119.624 170.165L120.269 175.937Z",
    fill: "#3F0F56"
  }), React.createElement("path", {
    d: "M112.595 153.526L106.823 155.944L101.438 156.041L107.177 153.622L112.595 153.526Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M175.539 135.371L176.152 140.821H181.537L182.891 152.687H177.474L178.119 158.427H173.475L174.185 164.489L158.513 164.844L157.836 158.75L128.492 159.265L129.137 165.07H123.687L124.236 169.939H119.624L120.269 175.711H115.11L113.24 158.975H107.822L107.177 153.203L127.783 152.848L127.17 147.496H132.071L131.394 141.433H136.263L135.683 136.242L175.539 135.371Z",
    fill: "url(#paint9_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M182.956 152.59L184.762 168.713H189.115L190.405 180.257H186.051L190.437 219.662H185.02L181.279 186.126H175.862L175.217 180.354H170.573L169.961 174.905H160.287L160.899 180.386H156.288L156.933 186.159L146.324 186.352L145.583 180.967H140.971L140.359 175.517L130.395 175.775C129.911 171.422 129.04 163.618 128.589 159.298H133.974L135.135 169.681L179.409 168.907C179.022 165.231 178.054 156.395 177.635 152.784L182.956 152.59Z",
    fill: "#041735"
  }), React.createElement("path", {
    d: "M136.36 181.483L130.62 183.901L125.203 183.998L130.975 181.58L136.36 181.483Z",
    fill: "#3B7274"
  }), React.createElement("path", {
    d: "M130.975 181.579L125.203 183.998L124.558 178.194L130.33 175.775L130.975 181.579Z",
    fill: "#3E787A"
  }), React.createElement("path", {
    d: "M130.975 181.58L130.33 175.776L135.715 175.679L136.36 181.483L130.975 181.58Z",
    fill: "url(#paint10_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M179.602 219.662H185.019L185.664 225.434H180.505L181.15 231.239L161.802 231.561L164.059 247.684C162.286 247.91 160.48 248.039 158.706 248.103L155.708 225.531L180.15 225.08L179.602 220.049V219.662Z",
    fill: "#041735"
  }), React.createElement("path", {
    d: "M131.523 186.707L125.751 189.125L125.138 183.676L130.91 181.257L131.523 186.707Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M136.683 186.61L130.91 189.061L125.751 189.125L131.523 186.707L136.683 186.61Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M129.653 169.971L124.235 170.068L123.687 165.199L129.105 165.102L129.653 169.971Z",
    fill: "url(#paint11_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M130.104 174.034L130.298 175.775H124.881L124.236 169.971H129.653L130.104 174.034Z",
    fill: "#041735"
  }), React.createElement("path", {
    d: "M130.298 175.775L124.526 178.194L119.141 178.29L124.913 175.872L130.298 175.775Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M124.913 175.872L119.141 178.291L118.947 176.549L124.687 174.131L124.913 175.872Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M125.493 181.354L119.753 183.772L119.141 178.291L124.913 175.872L125.493 181.354Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M130.911 181.257L125.139 183.676L119.753 183.772L125.493 181.354L130.911 181.257Z",
    fill: "#5E7D80"
  }), React.createElement("path", {
    d: "M120.269 175.937L119.624 170.165H124.236L124.881 175.969L120.269 175.937Z",
    fill: "url(#paint12_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M124.913 175.872L119.141 178.291L114.497 178.355L120.269 175.937L124.913 175.872Z",
    fill: "#3C0E52"
  }), React.createElement("path", {
    d: "M126.783 192.866L121.043 195.316L119.786 184.03L125.526 181.612L126.783 192.866Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M143.873 246.427L138.101 248.877L130.911 189.061L136.683 186.61L143.873 246.427Z",
    fill: "#638487"
  }), React.createElement("path", {
    d: "M131.974 192.769L126.202 195.22L121.043 195.316L126.783 192.866L131.974 192.769Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M125.525 181.612L119.786 184.03L114.368 184.127L120.14 181.709L125.525 181.612Z",
    fill: "#020C1B"
  }), React.createElement("path", {
    d: "M120.269 175.937L114.497 178.355L109.338 178.452L115.11 176.034L120.269 175.937Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M120.14 181.709L114.368 184.127L113.723 178.387L119.495 175.969L120.14 181.709Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M115.11 176.033L109.338 178.452L107.468 161.716L113.24 159.297L115.11 176.033Z",
    fill: "#27606A"
  }), React.createElement("path", {
    d: "M107.822 159.394L102.082 161.813L101.438 156.041L107.177 153.622L107.822 159.394Z",
    fill: "#27606A"
  }), React.createElement("path", {
    d: "M113.24 159.297L107.468 161.716L102.083 161.813L107.822 159.394L113.24 159.297Z",
    fill: "#255B64"
  }), React.createElement("path", {
    d: "M155.772 225.628L158.771 248.2C153.753 248.334 148.741 247.781 143.873 246.556L136.844 186.61H131.684L131.072 181.161H125.687L125.042 175.679H130.459L131.136 181.483H136.521L135.876 175.679H140.52L140.971 180.967H145.582L146.227 186.739L156.836 186.546L156.191 180.774H160.803L160.19 175.292H169.864L170.476 180.741H175.12L175.765 186.513H181.15L185.019 219.662H179.602V220.114H179.409L179.989 225.144L155.772 225.628ZM154.16 208.86L154.837 214.922L179.28 214.503L178.764 208.441L154.321 208.86H154.16ZM161.609 186.481L163.479 203.217H168.896L167.026 186.481H161.609Z",
    fill: "url(#paint13_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M138.263 244.717L132.491 247.136L126.203 195.22L131.975 192.769L138.263 244.717Z",
    fill: "#020D1D"
  }), React.createElement("path", {
    d: "M131.523 186.707H136.682L143.873 246.555C141.971 246.072 140.1 245.491 138.23 244.814L131.974 192.898H126.815L125.525 181.644H120.14L119.495 175.872H124.88L125.525 181.354H130.91L131.523 186.707Z",
    fill: "#041735"
  }), React.createElement("path", {
    d: "M92.7634 185.288C87.862 149.043 110.853 117.99 143.551 117.571C181.118 116.475 213.815 156.911 209.204 197.251C208.816 201.238 208.049 205.179 206.914 209.021C206.06 211.958 204.982 214.826 203.69 217.598C200.177 225.55 194.705 232.48 187.785 237.742C180.866 243.003 172.725 246.424 164.124 247.684L161.867 231.561L181.214 231.238L180.569 225.434H185.729L185.019 219.662H190.437L186.051 180.257H190.404L189.115 168.713H184.761L181.537 140.724H176.152L175.539 135.371L135.586 136.08L136.167 141.272H131.297L131.975 147.334H127.073L127.718 153.106L107.113 153.461L107.758 159.233H113.175L115.045 175.969H119.431L120.076 181.741H125.461L126.751 192.994H131.91L138.166 244.911C113.433 235.785 96.0202 211.02 92.7634 185.288Z",
    fill: "url(#paint14_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M138.23 244.717C95.7945 230.723 76.4791 170.842 105.339 135.822C109.954 130.13 115.776 125.533 122.385 122.366C128.993 119.198 136.223 117.538 143.551 117.507C136.291 117.728 129.166 119.523 122.669 122.769C116.171 126.015 110.456 130.634 105.92 136.306C77.5755 171.519 97.6648 228.627 138.166 244.685L138.23 244.717Z",
    fill: "#D2EBF3"
  }), React.createElement("path", {
    d: "M174.249 245.459L176.667 244.427H176.377L174.636 245.169L176.377 244.427L173.926 245.459H173.41L172.798 245.685L172.153 245.878C169.53 246.689 166.844 247.282 164.124 247.652L158.352 250.07C161.083 249.701 163.779 249.108 166.413 248.297L167.026 248.103L167.638 247.91L168.187 247.716C168.864 247.491 170.089 247.007 171.411 246.459L170.637 246.781H170.928L171.637 246.459L174.249 245.459Z",
    fill: "#3E0F55"
  }), React.createElement("path", {
    d: "M162.995 247.813H162.318H161.609H160.899H158.771H152.644H151.935H151.064C148.642 247.525 146.24 247.083 143.873 246.491C141.971 246.007 140.101 245.427 138.23 244.75C113.433 235.785 96.0202 211.02 92.7634 185.288C88.8616 156.524 102.663 130.663 125.009 121.408C99.2126 129.857 82.8316 156.105 87.0235 187.706C90.2482 213.503 107.726 238.075 132.523 247.136C134.362 247.813 136.234 248.395 138.134 248.877C140.501 249.466 142.902 249.908 145.324 250.199H146.195H147.066H148.968H155.16H155.869H156.578H157.256H157.965L163.737 247.749L162.995 247.813Z",
    fill: "url(#paint15_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M218.878 314.272L90.7639 325.494C88.48 325.724 86.1958 325.06 84.3917 323.641C82.5875 322.221 81.404 320.158 81.0901 317.884L76.2209 283.703C76.0477 282.408 76.1508 281.091 76.5234 279.838C76.896 278.585 77.5296 277.426 78.3825 276.436C79.2355 275.446 80.2884 274.648 81.4721 274.094C82.6557 273.54 83.9432 273.243 85.2498 273.223L214.234 270.256C216.387 270.19 218.491 270.909 220.152 272.28C221.814 273.65 222.919 275.579 223.263 277.705L227.197 303.502C227.411 304.763 227.362 306.054 227.052 307.295C226.742 308.535 226.179 309.698 225.397 310.71C224.616 311.722 223.633 312.561 222.511 313.174C221.388 313.787 220.151 314.161 218.878 314.272Z",
    fill: "url(#paint16_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M223.328 307.984L95.214 316.949C92.9171 317.119 90.6411 316.412 88.8456 314.969C87.05 313.527 85.8687 311.457 85.5401 309.177L80.7032 274.9C80.3831 273.34 80.4073 271.73 80.7744 270.181C81.1414 268.632 81.8423 267.182 82.8282 265.932C83.814 264.682 85.0609 263.662 86.4818 262.944C87.9026 262.227 89.4632 261.828 91.0542 261.776L218.62 263.872C220.798 263.849 222.911 264.618 224.566 266.035C226.22 267.453 227.304 269.422 227.616 271.578L231.55 297.601C231.741 298.83 231.675 300.085 231.358 301.287C231.04 302.489 230.478 303.613 229.706 304.588C228.934 305.563 227.969 306.368 226.871 306.952C225.774 307.536 224.567 307.888 223.328 307.984Z",
    fill: "#28B287"
  }), React.createElement("path", {
    d: "M226.359 304.921L98.1482 313.885C95.8562 314.057 93.5843 313.354 91.7896 311.918C89.9948 310.482 88.8103 308.42 88.4744 306.146L83.6375 271.869C83.4556 270.576 83.5559 269.26 83.9315 268.01C84.3072 266.761 84.9493 265.607 85.8136 264.63C86.6779 263.652 87.7438 262.873 88.938 262.347C90.1321 261.821 91.4262 261.56 92.7309 261.582L221.715 260.84C223.89 260.831 225.996 261.605 227.647 263.02C229.299 264.435 230.387 266.397 230.712 268.547L234.646 294.57C234.826 295.801 234.752 297.055 234.426 298.256C234.101 299.456 233.532 300.577 232.754 301.548C231.977 302.519 231.008 303.32 229.907 303.9C228.807 304.48 227.599 304.828 226.359 304.921Z",
    fill: "#36CEA2"
  }), React.createElement("path", {
    opacity: "0.6",
    d: "M226.359 304.921L98.1482 313.885C95.8562 314.057 93.5843 313.354 91.7896 311.918C89.9948 310.482 88.8103 308.42 88.4744 306.146L83.6375 271.869C83.4556 270.576 83.5559 269.26 83.9315 268.01C84.3072 266.761 84.9493 265.607 85.8136 264.63C86.6779 263.652 87.7438 262.873 88.938 262.347C90.1321 261.821 91.4262 261.56 92.7309 261.582L221.715 260.84C223.89 260.831 225.996 261.605 227.647 263.02C229.299 264.435 230.387 266.397 230.712 268.547L234.646 294.57C234.826 295.801 234.752 297.055 234.426 298.256C234.101 299.456 233.532 300.577 232.754 301.548C231.977 302.519 231.008 303.32 229.907 303.9C228.807 304.48 227.599 304.828 226.359 304.921Z",
    fill: "url(#paint17_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M88.6679 306.146C87.2813 297.891 86.1204 289.636 84.8951 281.381C84.0268 277.278 83.5838 273.096 83.573 268.902C83.9786 266.792 85.1237 264.895 86.8023 263.553C88.4809 262.212 90.5831 261.513 92.7309 261.582C90.6788 261.69 88.722 262.482 87.173 263.832C85.624 265.182 84.5722 267.013 84.1857 269.031C84.274 273.164 84.6945 277.283 85.4433 281.349C86.5396 289.604 87.7005 297.859 88.6679 306.178V306.146Z",
    fill: "#D2EBF3"
  }), React.createElement("path", {
    d: "M54.0033 92.2257L27.9485 82.4229L213.879 98.1912L253.445 106.124L54.0033 92.2257Z",
    fill: "url(#paint18_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M54.0033 92.2257L27.9485 82.4229L42.1368 83.616L78.8328 94.0959L54.0033 92.2257Z",
    fill: "url(#paint19_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.8",
    d: "M103.727 95.676L66.5471 85.6797L42.1368 83.616L78.8329 94.0959L103.727 95.676Z",
    fill: "url(#paint20_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.8",
    d: "M103.727 95.6762L66.547 85.6799L89.6674 87.6469L128.524 97.4175L103.727 95.6762Z",
    fill: "url(#paint21_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M128.524 97.4173L89.6998 87.6467L121.043 90.3876L153.579 99.1586L128.524 97.4173Z",
    fill: "url(#paint22_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.8",
    d: "M178.602 100.9L145.453 92.387L121.043 90.3877L153.579 99.1586L178.602 100.9Z",
    fill: "url(#paint23_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.8",
    d: "M175.249 100.255L144.906 92.29L161.029 93.9023L200.078 101.996L175.249 100.255Z",
    fill: "url(#paint24_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M201.335 101.964L161.027 93.3862L194.885 97.1273L229.003 103.899L201.335 101.964Z",
    fill: "url(#paint25_linear_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.8",
    d: "M252.929 106.156L215.846 98.7393L191.661 97.127L229.003 103.899L252.929 106.156Z",
    fill: "url(#paint26_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M255.477 121.699L232.163 145.593L227.39 112.637L255.477 121.699Z",
    fill: "url(#paint27_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.129 145.851L232.163 145.593L252.929 123.601L254.058 127.309L236.129 145.851Z",
    fill: "#197DE3"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.494 144.658L40.2342 144.367L60.8394 117.99L58.034 111.315L35.494 144.658Z",
    fill: "url(#paint28_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.965 124.762C64.0966 124.407 57.5507 117.571 56.3898 109.509L53.9069 92.2256L78.8331 94.0959L81.316 110.993C82.4769 118.958 77.8657 125.117 70.965 124.762Z",
    fill: "url(#paint29_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8911 126.149C88.9904 125.794 82.4767 119.054 81.3159 111.09L78.8007 94.0959L103.759 95.8372L106.21 112.476C107.403 120.344 102.759 126.407 95.8911 126.149Z",
    fill: "url(#paint30_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.721 127.341C113.852 126.987 107.338 120.344 106.178 112.476L103.727 95.8369L128.653 97.546L131.104 113.959C132.297 121.731 127.686 127.728 120.721 127.341Z",
    fill: "url(#paint31_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.711 128.664C142.009 128.149 138.58 126.43 135.951 123.773C133.323 121.115 131.642 117.667 131.168 113.959L128.718 97.5461L153.676 99.2552L156.094 115.378C157.223 123.117 152.58 129.018 145.711 128.664Z",
    fill: "url(#paint32_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.605 129.954C166.952 129.445 163.565 127.754 160.962 125.14C158.36 122.525 156.684 119.131 156.191 115.475L153.773 99.3523L178.699 101.061L181.118 117.184C182.149 124.504 177.474 130.309 170.605 129.954Z",
    fill: "url(#paint33_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.531 131.244C191.88 130.785 188.482 129.137 185.859 126.556C183.237 123.974 181.537 120.602 181.021 116.958L178.602 100.835L203.561 102.577L205.947 118.313C207.075 125.858 202.4 131.598 195.531 131.244Z",
    fill: "url(#paint34_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.425 132.598C216.804 132.152 213.428 130.534 210.814 127.989C208.199 125.444 206.49 122.114 205.947 118.506L203.561 102.77L228.519 104.479L230.873 119.989C231.969 127.245 227.294 132.888 220.425 132.598Z",
    fill: "url(#paint35_linear_10025_65882)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.319 133.823C241.722 133.407 238.361 131.822 235.751 129.311C233.142 126.801 231.428 123.503 230.873 119.925L228.519 104.415L253.445 106.124L255.799 121.44C256.175 122.977 256.182 124.581 255.819 126.121C255.456 127.661 254.734 129.093 253.712 130.3C252.69 131.508 251.397 132.457 249.938 133.069C248.48 133.681 246.897 133.939 245.319 133.823Z",
    fill: "url(#paint36_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M54.0033 92.2257L27.9485 82.4229L35.4941 144.658L57.2602 112.96L54.0033 92.2257Z",
    fill: "url(#paint37_linear_10025_65882)"
  }), React.createElement("path", {
    d: "M150.645 285.186C151.163 285.342 151.661 285.559 152.128 285.831C152.565 286.077 152.966 286.381 153.321 286.734C153.663 287.12 153.945 287.555 154.159 288.024C154.399 288.569 154.562 289.144 154.643 289.733C154.793 290.478 154.793 291.245 154.643 291.99C154.454 292.65 154.099 293.249 153.611 293.732C153.089 294.27 152.449 294.678 151.741 294.925C150.873 295.247 149.958 295.422 149.032 295.441L139.907 295.989L137.391 276.254H146.42C146.925 276.22 147.431 276.22 147.936 276.254C148.374 276.31 148.806 276.407 149.226 276.544L150.354 277.06C150.693 277.271 151.007 277.52 151.29 277.802L151.805 278.382C151.986 278.598 152.138 278.837 152.257 279.092C152.384 279.352 152.492 279.622 152.579 279.898C152.678 280.191 152.743 280.494 152.773 280.801C152.838 281.293 152.838 281.792 152.773 282.284C152.718 282.702 152.587 283.107 152.386 283.477C151.998 284.165 151.43 284.734 150.741 285.122L150.645 285.186ZM149.742 289.249C149.716 289 149.639 288.758 149.516 288.54C149.387 288.33 149.21 288.153 149 288.024C148.773 287.854 148.507 287.743 148.226 287.701C147.872 287.664 147.516 287.664 147.162 287.701H143.486L143.937 291.313L147.71 291.12C148.031 291.171 148.357 291.171 148.678 291.12C148.917 291.037 149.137 290.905 149.323 290.733C149.508 290.583 149.643 290.381 149.709 290.152C149.775 289.909 149.775 289.653 149.709 289.411L149.742 289.249ZM142.486 280.672L142.938 283.896H146.162C146.48 283.883 146.794 283.828 147.098 283.735C147.35 283.695 147.585 283.583 147.775 283.413C147.939 283.264 148.062 283.075 148.129 282.865C148.198 282.622 148.198 282.365 148.129 282.123C148.088 281.877 148.012 281.638 147.904 281.413C147.776 281.222 147.612 281.057 147.42 280.93C147.203 280.784 146.963 280.675 146.711 280.607C146.389 280.572 146.065 280.572 145.743 280.607H142.519",
    fill: "#F2F6FF"
  }), React.createElement("path", {
    d: "M187.696 275.706L184.116 286.605L185.181 293.312L181.15 293.57L180.086 286.831L172.701 275.867L177.409 275.835L181.408 282.155L183.342 275.77L187.696 275.706Z",
    fill: "#F2F6FF"
  }), React.createElement("path", {
    d: "M170.508 275.899L172.024 285.863C172.215 287.135 172.215 288.429 172.024 289.701C171.88 290.673 171.516 291.599 170.96 292.409C170.428 293.145 169.718 293.733 168.896 294.118C167.958 294.527 166.952 294.757 165.929 294.796C164.842 294.887 163.747 294.766 162.705 294.441C161.744 294.164 160.861 293.667 160.125 292.99C159.311 292.265 158.663 291.375 158.223 290.378C157.669 289.172 157.299 287.889 157.126 286.573L155.643 276.061H160.222L161.705 286.347C161.78 286.948 161.943 287.535 162.189 288.088C162.361 288.545 162.625 288.962 162.963 289.314C163.242 289.625 163.598 289.858 163.995 289.991C164.382 290.152 164.802 290.218 165.22 290.184C165.634 290.176 166.041 290.077 166.413 289.894C166.74 289.719 167.018 289.464 167.219 289.153C167.429 288.774 167.561 288.357 167.606 287.927C167.686 287.371 167.686 286.807 167.606 286.25L166.091 275.996L170.508 275.899Z",
    fill: "#F2F6FF"
  }), React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("path", {
    d: "M273.406 205.474C275.936 205.679 278.307 206.79 280.084 208.602C281.861 210.415 282.925 212.808 283.079 215.341L285.337 235.785C285.524 236.945 285.465 238.132 285.162 239.267C284.86 240.402 284.321 241.461 283.582 242.374C282.842 243.287 281.918 244.034 280.87 244.565C279.823 245.097 278.674 245.402 277.501 245.459L206.559 246.781C204.056 246.595 201.702 245.516 199.926 243.741C198.151 241.965 197.072 239.611 196.886 237.107L194.886 213.826C194.704 212.666 194.767 211.482 195.072 210.349C195.376 209.215 195.915 208.159 196.654 207.247C197.392 206.335 198.314 205.588 199.359 205.055C200.405 204.522 201.55 204.214 202.722 204.152L273.406 205.474Z",
    fill: "url(#paint38_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M273.406 205.474C275.936 205.679 278.307 206.79 280.084 208.602C281.861 210.415 282.925 212.808 283.079 215.341L285.337 235.785C285.524 236.945 285.465 238.132 285.162 239.267C284.86 240.402 284.321 241.461 283.582 242.374C282.842 243.287 281.918 244.034 280.87 244.565C279.823 245.097 278.674 245.402 277.501 245.459L206.559 246.781C204.056 246.595 201.702 245.516 199.926 243.741C198.151 241.965 197.072 239.611 196.886 237.107L194.886 213.826C194.704 212.666 194.767 211.482 195.072 210.349C195.376 209.215 195.915 208.159 196.654 207.247C197.392 206.335 198.314 205.588 199.359 205.055C200.405 204.522 201.55 204.214 202.722 204.152L273.406 205.474Z",
    fill: "url(#paint39_radial_10025_65882)"
  }))), React.createElement("path", {
    d: "M277.501 245.653L206.56 246.975C204.056 246.788 201.702 245.709 199.926 243.934C198.151 242.159 197.072 239.805 196.886 237.301L194.886 213.826C194.616 211.938 194.959 210.014 195.865 208.337C196.77 206.659 198.191 205.316 199.917 204.507L195.951 206.119C194.214 206.916 192.785 208.256 191.877 209.937C190.97 211.619 190.634 213.549 190.92 215.438L193.145 238.784C193.344 241.283 194.427 243.63 196.2 245.403C197.973 247.176 200.32 248.259 202.819 248.458H223.585C224.585 248.458 275.566 246.942 276.437 246.588L280.403 245.008C279.484 245.401 278.5 245.62 277.501 245.653Z",
    fill: "url(#paint40_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M277.501 245.653L206.56 246.975C204.056 246.788 201.702 245.709 199.926 243.934C198.151 242.159 197.072 239.805 196.886 237.301L194.886 213.826C194.616 211.938 194.959 210.014 195.865 208.337C196.77 206.659 198.191 205.316 199.917 204.507L195.951 206.119C194.214 206.916 192.785 208.256 191.877 209.937C190.97 211.619 190.634 213.549 190.92 215.438L193.145 238.784C193.344 241.283 194.427 243.63 196.2 245.403C197.973 247.176 200.32 248.259 202.819 248.458H223.585C224.585 248.458 275.566 246.942 276.437 246.588L280.403 245.008C279.484 245.401 278.5 245.62 277.501 245.653Z",
    fill: "url(#paint41_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M211.009 216.76C213.299 216.76 214.685 218.34 214.976 221.468L215.814 230.368C216.104 233.238 215.427 235.237 212.589 235.237C209.752 235.237 208.881 233.27 208.623 230.4L207.785 221.629C207.43 218.372 208.559 216.76 211.009 216.76ZM213.654 230.561L212.783 221.306C212.783 219.759 212.073 219.017 211.138 219.017C210.203 219.017 209.784 219.694 209.945 221.371L210.816 230.626C210.816 232.173 211.461 232.947 212.46 232.947C213.46 232.947 213.815 232.27 213.654 230.561Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M220.812 231.045L221.167 235.011H218.974L218.587 231.045H220.812Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M225.843 216.76C228.326 216.76 229.293 218.501 229.519 220.984V221.661C229.713 223.725 229.197 224.692 228.326 225.112C229.033 225.429 229.626 225.954 230.029 226.616C230.432 227.278 230.625 228.046 230.583 228.82V230.303C230.873 233.205 230.261 235.237 227.359 235.237C224.456 235.237 223.683 233.592 223.425 231.077V230.529H225.456V231.077C225.456 232.173 225.972 233.205 227.133 233.205C228.294 233.205 228.519 232.27 228.39 230.626L228.197 228.852C228.036 227.014 227.391 226.337 226.004 226.337H225.327L225.134 224.176H225.779C226.972 224.176 227.423 223.628 227.262 221.919V220.92C227.262 219.759 226.843 218.824 225.843 218.824C224.843 218.824 224.618 219.759 224.714 220.823V221.5H222.941V220.984C222.715 219.081 223.005 216.76 225.843 216.76Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M239.773 228.304H241.031V230.368H240.031L240.45 235.011H238.419L237.967 230.368H233.453L233.259 228.53L235.807 216.986H238.741L239.773 228.304ZM237.387 224.628C237.193 222.855 237.097 221.081 236.968 219.308C236.452 222.339 235.904 225.305 235.323 228.304H237.709L237.387 224.628Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M253.091 216.502L253.284 218.791H249.415L249.931 224.048H253.575L253.8 226.337H250.124L250.737 232.722H254.929L254.864 235.011H248.738L246.996 216.502H253.091Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M262.829 216.502L263.055 218.791H260.411L261.958 235.011H259.733L258.186 218.791H255.509L255.316 216.502H262.829Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M272.728 216.502L274.502 235.011H272.277L271.439 226.208H268.407L269.246 235.011H267.021L265.28 216.502H267.505L268.182 223.983H271.213L270.503 216.502H272.728Z",
    fill: "white"
  }), React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("path", {
    d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
    fill: "url(#paint42_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
    fill: "url(#paint43_radial_10025_65882)"
  })), React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("path", {
    d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
    fill: "url(#paint44_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
    fill: "url(#paint45_radial_10025_65882)"
  })))), React.createElement("path", {
    d: "M286.562 281.994H272.212C270.62 281.872 269.126 281.178 268.005 280.04C266.885 278.902 266.214 277.397 266.118 275.803L264.699 261.098C264.529 259.903 264.751 258.685 265.333 257.626C265.914 256.568 266.823 255.727 267.924 255.229L265.408 256.229C264.306 256.732 263.395 257.579 262.814 258.643C262.233 259.707 262.012 260.93 262.184 262.13L263.603 276.834C263.668 278.455 264.324 279.995 265.446 281.165C266.569 282.335 268.081 283.054 269.697 283.187H282.789C283.816 283.136 284.834 282.963 285.82 282.671L288.335 281.671C287.771 281.895 287.169 282.005 286.562 281.994Z",
    fill: "url(#paint46_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M286.562 281.994H272.212C270.62 281.872 269.126 281.178 268.005 280.04C266.885 278.902 266.214 277.397 266.118 275.803L264.699 261.098C264.529 259.903 264.751 258.685 265.333 257.626C265.914 256.568 266.823 255.727 267.924 255.229L265.408 256.229C264.306 256.732 263.395 257.579 262.814 258.643C262.233 259.707 262.012 260.93 262.184 262.13L263.603 276.834C263.668 278.455 264.324 279.995 265.446 281.165C266.569 282.335 268.081 283.054 269.697 283.187H282.789C283.816 283.136 284.834 282.963 285.82 282.671L288.335 281.671C287.771 281.895 287.169 282.005 286.562 281.994Z",
    fill: "url(#paint47_radial_10025_65882)"
  }), React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("path", {
    d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
    fill: "url(#paint48_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
    fill: "url(#paint49_radial_10025_65882)"
  })), React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("path", {
    d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
    fill: "url(#paint50_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
    fill: "url(#paint51_radial_10025_65882)"
  })))), React.createElement("path", {
    d: "M259.229 291.829H251.619C250.786 291.763 250.004 291.402 249.413 290.811C248.822 290.22 248.461 289.438 248.394 288.605L247.749 280.93C247.622 280.266 247.734 279.578 248.064 278.989C248.394 278.399 248.922 277.944 249.555 277.706L248.201 278.222C247.607 278.501 247.121 278.968 246.818 279.551C246.515 280.133 246.412 280.799 246.524 281.446L247.298 289.25C247.358 290.085 247.717 290.871 248.309 291.463C248.901 292.055 249.687 292.414 250.522 292.474H257.455C258 292.438 258.539 292.352 259.068 292.216L260.39 291.668C260.023 291.82 259.623 291.876 259.229 291.829Z",
    fill: "url(#paint52_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M259.229 291.829H251.619C250.786 291.763 250.004 291.402 249.413 290.811C248.822 290.22 248.461 289.438 248.394 288.605L247.749 280.93C247.622 280.266 247.734 279.578 248.064 278.989C248.394 278.399 248.922 277.944 249.555 277.706L248.201 278.222C247.607 278.501 247.121 278.968 246.818 279.551C246.515 280.133 246.412 280.799 246.524 281.446L247.298 289.25C247.358 290.085 247.717 290.871 248.309 291.463C248.901 292.055 249.687 292.414 250.522 292.474H257.455C258 292.438 258.539 292.352 259.068 292.216L260.39 291.668C260.023 291.82 259.623 291.876 259.229 291.829Z",
    fill: "url(#paint53_radial_10025_65882)"
  }), React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("path", {
    d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
    fill: "url(#paint54_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
    fill: "url(#paint55_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
    fill: "url(#paint56_radial_10025_65882)"
  })), React.createElement("g", {
    opacity: "0.6"
  }, React.createElement("path", {
    d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
    fill: "url(#paint57_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
    fill: "url(#paint58_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
    fill: "url(#paint59_radial_10025_65882)"
  })))), React.createElement("path", {
    d: "M47.1175 199.8L24.9322 200.09C22.4552 199.897 20.1331 198.809 18.4002 197.028C16.6673 195.248 15.6421 192.897 15.5164 190.416L13.3236 167.844C13.0577 166.003 13.3905 164.125 14.2731 162.488C15.1556 160.85 16.5411 159.54 18.225 158.75L14.42 160.234C12.7353 161.014 11.3478 162.317 10.4645 163.95C9.58124 165.583 9.24943 167.458 9.51859 169.295L11.7113 191.867C11.8302 194.351 12.8532 196.705 14.5875 198.487C16.3217 200.269 18.6477 201.355 21.1272 201.541H41.3455C42.9272 201.451 44.4948 201.192 46.0211 200.767L49.8907 199.187C49.0191 199.582 48.0745 199.791 47.1175 199.8Z",
    fill: "url(#paint60_radial_10025_65882)"
  }), React.createElement("path", {
    opacity: "0.6",
    d: "M51.053 212.408C54.5016 212.68 57.7366 214.186 60.1648 216.65C62.5931 219.113 64.0519 222.37 64.2739 225.822L68.0467 256.778C68.3226 258.37 68.2574 260.003 67.8555 261.567C67.4535 263.132 66.724 264.594 65.715 265.856C64.7061 267.118 63.4408 268.151 62.0028 268.888C60.5648 269.624 58.9869 270.047 57.3733 270.128L26.3848 270.515C22.9451 270.257 19.715 268.763 17.2908 266.31C14.8667 263.856 13.4123 260.608 13.1961 257.165L10.165 225.435C9.45557 218.051 14.228 212.021 20.7739 212.021L51.053 212.408Z",
    fill: "url(#paint61_radial_10025_65882)"
  }), React.createElement("path", {
    d: "M57.373 270.128L26.3846 270.515C22.9449 270.257 19.7148 268.763 17.2906 266.31C14.8665 263.856 13.4121 260.608 13.1959 257.165L10.1648 225.435C9.77389 222.867 10.2295 220.241 11.4628 217.955C12.6961 215.669 14.6401 213.846 17.001 212.762L11.6481 215.052C9.29976 216.129 7.36064 217.934 6.1178 220.199C4.87497 222.464 4.39447 225.069 4.74744 227.628L7.77857 259.358C8.00134 262.798 9.45793 266.043 11.8808 268.495C14.3036 270.947 17.53 272.443 20.9672 272.708H49.2148C51.399 272.587 53.5625 272.219 55.664 271.612L61.0813 269.451C59.8961 269.898 58.6399 270.128 57.373 270.128Z",
    fill: "url(#paint62_radial_10025_65882)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_10025_65882",
    x1: "31.6244",
    y1: "213.374",
    x2: "261.152",
    y2: "213.374",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#B2F5F2"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_10025_65882",
    x1: "24.4016",
    y1: "212.02",
    x2: "256.348",
    y2: "212.02",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_10025_65882",
    x1: "143.002",
    y1: "186.83",
    x2: "142.813",
    y2: "109.207",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D6FAF8",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.16",
    stopColor: "#C1E9EF",
    stopOpacity: "0.13"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#8CBED7",
    stopOpacity: "0.47"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3879B2"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.392 214.244) rotate(-0.572939) scale(121.413 109.248)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_10025_65882",
    x1: "114.948",
    y1: "267.967",
    x2: "140.229",
    y2: "184.353",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#BAE3EB",
    stopOpacity: "0.18"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#A4D1E2",
    stopOpacity: "0.32"
  }), React.createElement("stop", {
    offset: "0.99",
    stopColor: "#80B4D2",
    stopOpacity: "0.55"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_10025_65882",
    x1: "174.81",
    y1: "109.23",
    x2: "183.156",
    y2: "193.603",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5D1780"
  }), React.createElement("stop", {
    offset: "0.25",
    stopColor: "#6C2E93"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#946AC3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A584D8"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_10025_65882",
    x1: "237.403",
    y1: "338.905",
    x2: "291.117",
    y2: "445.224",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5D1780"
  }), React.createElement("stop", {
    offset: "0.25",
    stopColor: "#6C2E93"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#946AC3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A584D8"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_10025_65882",
    x1: "160.738",
    y1: "171.874",
    x2: "166.413",
    y2: "201.766",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#47B2C4"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#5EC9D3"
  }), React.createElement("stop", {
    offset: "0.75",
    stopColor: "#73DFE2"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_10025_65882",
    x1: "156.718",
    y1: "161.256",
    x2: "160.027",
    y2: "189.578",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.06",
    stopColor: "#95D3E0"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#B8F5F9"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_10025_65882",
    x1: "144.118",
    y1: "134.475",
    x2: "148.455",
    y2: "194.873",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00728B"
  }), React.createElement("stop", {
    offset: "0.24",
    stopColor: "#17879E"
  }), React.createElement("stop", {
    offset: "0.66",
    stopColor: "#47B2C4"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_10025_65882",
    x1: "412.715",
    y1: "410.599",
    x2: "422.894",
    y2: "465.382",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#47B2C4"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#5EC9D3"
  }), React.createElement("stop", {
    offset: "0.75",
    stopColor: "#73DFE2"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_10025_65882",
    x1: "378.488",
    y1: "284.518",
    x2: "389.411",
    y2: "414.295",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5D1780"
  }), React.createElement("stop", {
    offset: "0.25",
    stopColor: "#6C2E93"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#946AC3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A584D8"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_10025_65882",
    x1: "338.282",
    y1: "319.5",
    x2: "354.175",
    y2: "470.597",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5D1780"
  }), React.createElement("stop", {
    offset: "0.25",
    stopColor: "#6C2E93"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#946AC3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A584D8"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_10025_65882",
    x1: "151.311",
    y1: "161.88",
    x2: "154.62",
    y2: "190.202",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.06",
    stopColor: "#B8F5F9"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#B8F5F9"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_10025_65882",
    x1: "5788.58",
    y1: "4300.86",
    x2: "6145.7",
    y2: "7689.68",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5D1780"
  }), React.createElement("stop", {
    offset: "0.25",
    stopColor: "#6C2E93"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#946AC3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A584D8"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_10025_65882",
    x1: "127.105",
    y1: "230.4",
    x2: "117.657",
    y2: "162.812",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.1",
    stopColor: "#572C5F"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3E0F55"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_10025_65882",
    x1: "122.461",
    y1: "329.794",
    x2: "126.278",
    y2: "291.478",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#BAE3EB",
    stopOpacity: "0.18"
  }), React.createElement("stop", {
    offset: "0.36",
    stopColor: "#A4D1E2",
    stopOpacity: "0.32"
  }), React.createElement("stop", {
    offset: "0.99",
    stopColor: "#80B4D2",
    stopOpacity: "0.55"
  })), React.createElement("radialGradient", {
    id: "paint17_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.505 259.477) rotate(-4.51) scale(84.388 61.6033)"
  }, React.createElement("stop", {
    stopColor: "#3CD1A9",
    stopOpacity: "0.6"
  }), React.createElement("stop", {
    offset: "0.01",
    stopColor: "#3ED1AA",
    stopOpacity: "0.61"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D4E8E6"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_10025_65882",
    x1: "27.9485",
    y1: "94.2572",
    x2: "253.445",
    y2: "94.2572",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_10025_65882",
    x1: "752.032",
    y1: "225.418",
    x2: "1554.99",
    y2: "225.418",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint20_linear_10025_65882",
    x1: "1189.56",
    y1: "236.537",
    x2: "2365.93",
    y2: "236.537",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_10025_65882",
    x1: "73.8991",
    y1: "84.7448",
    x2: "118.012",
    y2: "97.4175",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#EAAFBD"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E03760"
  })), React.createElement("linearGradient", {
    id: "paint22_linear_10025_65882",
    x1: "2222",
    y1: "247.086",
    x2: "3487.45",
    y2: "247.086",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_10025_65882",
    x1: "2601.85",
    y1: "243.235",
    x2: "3628.7",
    y2: "243.235",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_10025_65882",
    x1: "3279.46",
    y1: "237.918",
    x2: "3557.44",
    y2: "659.814",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#EAAFBD"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#ED1818"
  })), React.createElement("linearGradient", {
    id: "paint25_linear_10025_65882",
    x1: "3271.89",
    y1: "271.167",
    x2: "4074.84",
    y2: "271.167",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint26_linear_10025_65882",
    x1: "4207.98",
    y1: "283.477",
    x2: "5384.35",
    y2: "283.477",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint27_linear_10025_65882",
    x1: "2363.92",
    y1: "933.888",
    x2: "2608.83",
    y2: "933.888",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint28_linear_10025_65882",
    x1: "35.494",
    y1: "127.986",
    x2: "60.8394",
    y2: "127.986",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#29A2D9",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3879B2"
  })), React.createElement("linearGradient", {
    id: "paint29_linear_10025_65882",
    x1: "668.567",
    y1: "695.393",
    x2: "904.444",
    y2: "695.393",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint30_linear_10025_65882",
    x1: "906.961",
    y1: "703.887",
    x2: "1142.91",
    y2: "703.887",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint31_linear_10025_65882",
    x1: "103.791",
    y1: "111.605",
    x2: "131.33",
    y2: "111.605",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.18",
    stopColor: "#E05986"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#E03760"
  })), React.createElement("linearGradient", {
    id: "paint32_linear_10025_65882",
    x1: "1381.51",
    y1: "718.643",
    x2: "1616.75",
    y2: "718.643",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint33_linear_10025_65882",
    x1: "1616.65",
    y1: "724.551",
    x2: "1851.11",
    y2: "724.551",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint34_linear_10025_65882",
    x1: "1855.5",
    y1: "736.385",
    x2: "2090.19",
    y2: "736.385",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.18",
    stopColor: "#EF296B"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#ED1818"
  })), React.createElement("linearGradient", {
    id: "paint35_linear_10025_65882",
    x1: "2090.6",
    y1: "740.117",
    x2: "2324.66",
    y2: "740.117",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint36_linear_10025_65882",
    x1: "2335.46",
    y1: "746.7",
    x2: "2570.06",
    y2: "746.7",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint37_linear_10025_65882",
    x1: "445.054",
    y1: "1332.72",
    x2: "711.497",
    y2: "1332.72",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("radialGradient", {
    id: "paint38_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.03 219.662) rotate(1.36393) scale(67.736 31.6774)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.833401",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint39_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.658 213.622) scale(93.3566 43.6163)"
  }, React.createElement("stop", {
    stopColor: "#BCDBD5",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BDE9DC"
  })), React.createElement("radialGradient", {
    id: "paint40_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6604.02 2346.26) scale(2290.62 1123.84)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint41_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.529 220.498) rotate(1.4231) scale(66.9333 32.659)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.833401",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint42_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2758.17 2023.66) scale(231.795 231.005)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint43_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.47 261.1) scale(27.755 27.4829)"
  }, React.createElement("stop", {
    stopColor: "#BCDBD5",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BDE9DC"
  })), React.createElement("radialGradient", {
    id: "paint44_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2758.17 2023.66) scale(231.795 231.005)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint45_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.47 261.1) scale(27.755 27.4829)"
  }, React.createElement("stop", {
    stopColor: "#BCDBD5",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BDE9DC"
  })), React.createElement("radialGradient", {
    id: "paint46_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2591.27 2054.28) scale(280.168 298.864)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint47_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.207 265.402) rotate(3.09178) scale(19.6047 20.7505)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.833401",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint48_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1457.51 1303.19) scale(64.8943 64.1104)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint49_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.011 280.829) scale(14.6547 14.3848)"
  }, React.createElement("stop", {
    stopColor: "#BCDBD5",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BDE9DC"
  })), React.createElement("radialGradient", {
    id: "paint50_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1457.51 1303.19) scale(64.8943 64.1104)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint51_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.011 280.829) scale(14.6547 14.3848)"
  }, React.createElement("stop", {
    stopColor: "#BCDBD5",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BDE9DC"
  })), React.createElement("radialGradient", {
    id: "paint52_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1402.11 1343.27) scale(78.7295 83.5909)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint53_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(253.422 283.079) rotate(3.07736) scale(10.4048 10.9618)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.833401",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint54_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6049 167.52) scale(42.7906)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint55_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint56_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint57_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6049 167.52) scale(42.7906)"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint58_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint59_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint60_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0263 168.257) scale(41.6671 43.7813)"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint61_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.9911 225.016) scale(59.8487)"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  })), React.createElement("radialGradient", {
    id: "paint62_radial_10025_65882",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5552 226.08) scale(58.1264 61.3334)"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#D7F9EF"
  }))));
};

var chest = function chest(width, height) {
  if (width === void 0) {
    width = '298';
  }

  if (height === void 0) {
    height = '398';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 298 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M293.983 225.39C297.294 198.224 292.476 170.687 280.138 146.26C267.799 121.832 248.495 101.612 224.665 88.1553C200.836 74.6986 173.551 68.6099 146.261 70.659C118.972 72.7082 92.9022 82.8031 71.3494 99.6674C49.7966 116.532 33.7282 139.408 25.1759 165.404C16.6237 191.4 15.9716 219.348 23.3022 245.715C30.6329 272.081 45.6169 295.682 66.3598 313.533C87.1028 331.384 112.673 342.684 139.838 346.003C157.879 348.208 176.178 346.837 193.689 341.968C211.201 337.1 227.581 328.829 241.896 317.628C256.21 306.428 268.178 292.517 277.115 276.691C286.052 260.864 291.784 243.432 293.983 225.39Z",
    fill: "#1EC5F9"
  }), React.createElement("path", {
    d: "M292.986 300.468C293.436 298.73 292.986 287.145 292.986 279.807C292.986 277.008 292.986 274.047 292.986 274.047C292.986 274.047 216.846 326.888 186.146 329.72C150.264 333.163 113.417 331.554 78.6298 321.868C51.0509 314.691 23.9226 297.443 24.4696 279.357L24.9202 301.69C25.1776 316.172 39.5302 330.363 67.7206 340.533C119.21 358.007 180.707 357.524 233.13 343.397C254.562 336.928 287.837 324.796 292.986 300.468Z",
    fill: "url(#paint0_linear_10025_65881)"
  }), React.createElement("path", {
    d: "M159.806 331.305C233.958 329.829 293.583 304.188 292.983 274.033C292.383 243.878 231.785 220.629 157.633 222.105C83.4813 223.58 23.8558 249.222 24.4559 279.376C25.0559 309.531 85.6543 332.78 159.806 331.305Z",
    fill: "url(#paint1_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9758 176.636C45.8338 207.688 46.5777 239.049 44.1963 270.25L169.701 319.036L281.047 275.302C278.461 243.74 279.227 211.994 283.332 180.594L128.864 147.416L41.9758 176.636Z",
    fill: "url(#paint2_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8472 176.636L169.862 218.792L283.332 180.594L128.703 147.416L41.8472 176.636Z",
    fill: "url(#paint3_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2687 176.604L128.928 151.503L268.528 181.431L169.83 214.641L54.2687 176.604Z",
    fill: "url(#paint4_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.637 319.036L169.862 216.991L41.9758 176.636C44.5004 207.773 45.2418 239.028 44.1963 270.25L169.701 319.036H169.637Z",
    fill: "url(#paint5_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.862 216.991L169.637 319.036L281.047 275.302C280.135 243.715 280.898 212.101 283.332 180.594L169.862 216.991Z",
    fill: "url(#paint6_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.587 305.52L169.766 319.036L281.047 275.303L280.628 251.811C293.082 262.977 295.914 271.956 287.451 290.428L257.587 305.52Z",
    fill: "url(#paint7_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1115 206.95L141.929 232.18L142.38 284.924L67.3665 257.152L66.1115 206.95Z",
    fill: "#B3B3B3"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.473 232.02L258.198 211.649L257.329 262.302L197.151 284.893L197.473 232.02Z",
    fill: "#B3B3B3"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1018 256.219L142.348 282.993L141.929 232.18L68.9111 207.884L70.1018 256.219Z",
    fill: "url(#paint8_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.473 232.019L197.151 282.768L254.304 261.303L255.141 212.646L197.473 232.019Z",
    fill: "url(#paint9_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1115 206.95L67.3665 257.152L70.1019 256.219L68.9112 207.883L66.1115 206.95Z",
    fill: "url(#paint10_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.348 282.993L70.1019 256.219L67.3665 257.152L142.38 284.924L142.348 282.993Z",
    fill: "url(#paint11_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.304 261.304L197.151 282.768V284.892L257.329 262.301L254.304 261.304Z",
    fill: "url(#paint12_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.141 212.647L254.305 261.304L257.33 262.302L258.198 211.649L255.141 212.647Z",
    fill: "url(#paint13_linear_10025_65881)"
  }), React.createElement("g", {
    opacity: "0.3"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1042 215.639C75.9909 210.233 135.3 231.15 141.994 239.903V232.18L68.9111 207.884L69.1042 215.639Z",
    fill: "#041836"
  })), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9758 176.636L169.862 216.991L281.401 181.238C276.96 183.684 253.918 191.343 228.013 199.774C207.932 206.21 184.504 212.904 169.862 218.793C151.616 211.552 118.373 202.348 92.3065 194.046C65.4678 185.486 43.4883 178.277 41.9758 176.636Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M119.403 257.635C176.187 257.635 222.22 211.602 222.22 154.818C222.22 98.033 176.187 52 119.403 52C62.6182 52 16.5852 98.033 16.5852 154.818C16.5852 211.602 62.6182 257.635 119.403 257.635Z",
    fill: "url(#paint14_radial_10025_65881)"
  }), React.createElement("path", {
    d: "M107.303 202.799C132.896 202.799 153.643 182.052 153.643 156.459C153.643 130.866 132.896 110.119 107.303 110.119C81.7099 110.119 60.9626 130.866 60.9626 156.459C60.9626 182.052 81.7099 202.799 107.303 202.799Z",
    fill: "url(#paint15_radial_10025_65881)"
  }), React.createElement("path", {
    d: "M74.0599 202.799C99.6529 202.799 120.4 182.052 120.4 156.459C120.4 130.866 99.6529 110.119 74.0599 110.119C48.4669 110.119 27.7196 130.866 27.7196 156.459C27.7196 182.052 48.4669 202.799 74.0599 202.799Z",
    fill: "url(#paint16_radial_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5942 172.484L182.091 157.424C181.737 139.531 180.418 121.349 170.409 104.1C157.827 82.5393 137.649 73.3678 117.408 80.1901C93.8835 88.0744 76.7312 114.27 70.7456 138.115C68.3328 149.37 66.9434 160.819 66.5942 172.324V172.484Z",
    fill: "url(#paint17_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.245 180.659L220.643 105.452L143.023 83.2476H142.669C135.093 81.1426 127.054 81.4008 119.628 83.9877C96.6832 91.518 80.0779 117.005 74.1566 140.368C73.9635 141.044 73.8026 141.752 73.6417 142.46L138.518 164.697L185.148 180.787L185.245 180.659Z",
    fill: "url(#paint18_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.862 207.208L283.332 180.015C282.978 162.476 281.69 144.809 271.843 129.201C259.582 109.893 239.662 103.457 219.775 112.886C196.669 123.827 179.838 152.05 173.917 176.282C171.563 186.435 170.194 196.791 169.83 207.208H169.862Z",
    fill: "url(#paint19_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.531 167.4L70.0696 141.205C70.2627 140.24 70.5202 139.242 70.7454 138.277C76.7311 114.27 93.8834 88.0424 117.408 80.3512C124.712 77.8232 132.592 77.4655 140.095 79.3214L116.7 72.4669L113.707 71.598C106.433 69.8729 98.8181 70.2638 91.7595 72.7243C68.6537 80.4477 51.8231 106.192 45.9341 129.781C43.6039 140.837 42.2791 152.082 41.9758 163.378L169.862 207.208C170.216 196.793 171.574 186.436 173.917 176.282C179.806 151.889 196.637 123.827 219.742 112.886C228.32 108.557 238.179 107.494 247.482 109.893L220.579 102.202L217.972 101.43C209.089 99.4381 199.791 100.575 191.649 104.648C168.929 115.299 152.452 142.911 146.595 166.885C146.61 167.046 146.61 167.207 146.595 167.368L146.531 167.4Z",
    fill: "url(#paint20_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.007 179.757L262.285 161.704C257.33 145.614 249.928 136.313 241.625 132.42C220.643 127.882 196.057 152.339 190.007 179.757Z",
    fill: "url(#paint21_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.497 132.42C249.799 136.314 257.201 145.485 262.157 161.704L267.273 163.442C261.32 143.973 251.859 134.672 241.529 132.42H241.497Z",
    fill: "url(#paint22_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.286 161.704L190.008 179.758C189.782 180.82 189.557 181.882 189.396 182.976L267.563 163.507L262.286 161.704Z",
    fill: "url(#paint23_linear_10025_65881)"
  }), React.createElement("path", {
    opacity: "0.65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.972 101.43C210.537 99.7226 202.761 100.272 195.639 103.006C205.409 104.192 214.92 106.964 223.797 111.213C231.368 108.292 239.666 107.83 247.514 109.893L217.972 101.43ZM117.408 80.1903C123.89 77.9564 130.834 77.4137 137.585 78.6134C138.422 78.7743 139.258 78.9352 140.095 79.1605L113.707 71.598C106.433 69.8729 98.8181 70.2638 91.7595 72.7243C100.559 74.3901 109.179 76.89 117.504 80.1903H117.408Z",
    fill: "url(#paint24_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3725 117.874C82.6624 109.238 88.3003 101.341 95.0743 94.4788C90.8587 94.7362 71.7755 90.424 69.8124 86.7554C63.1593 93.5016 57.6292 101.27 53.4324 109.765C58.9675 109.765 75.251 115.171 78.3725 117.874ZM173.048 118.26C166.029 125.566 160.149 133.887 155.606 142.943C163.104 142.557 180.225 149.379 183.089 151.889C187.719 142.66 193.707 134.178 200.852 126.724C195.864 126.917 175.591 120.803 173.048 118.26Z",
    fill: "url(#paint25_radial_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.67 86.8517L142.798 83.1187C136.012 81.2046 128.828 81.2046 122.042 83.1187C146.176 88.5857 169.949 95.5393 193.225 103.94C193.998 103.586 194.77 103.296 195.542 103.006C198.384 101.965 201.329 101.231 204.328 100.818L155.67 86.8517Z",
    fill: "url(#paint26_linear_10025_65881)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.747 191.6L169.862 207.208L217.232 195.944L171.214 204.44C172.244 176.604 175.397 166.209 188.785 141.977C174.818 162.798 170.087 176.926 168.865 204.569L123.747 191.6Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2689 176.604L5.67596 133.096L0.140869 104.616L200.724 126.724C180.838 147.847 169.447 175.567 168.736 204.569L243.363 189.734L169.83 214.642L54.2689 176.604Z",
    fill: "url(#paint27_linear_10025_65881)"
  }), React.createElement("path", {
    d: "M168.736 317.684C168.414 283.894 168.124 250.555 168.253 216.991L169.379 218.503L41.9758 176.636C45.0227 207.765 46.3012 239.041 45.8053 270.314L44.7756 268.769C86.0957 284.828 127.223 301.143 168.736 317.684ZM170.538 320.355C128.349 304.265 85.7417 288.174 43.4883 271.762C43.1728 271.641 42.9035 271.423 42.7186 271.14C42.5338 270.857 42.4428 270.523 42.4585 270.185C44.0675 239.018 43.9063 207.785 41.9758 176.636L170.345 215.446C170.671 215.543 170.956 215.743 171.159 216.015C171.362 216.288 171.472 216.619 171.471 216.958C171.439 251.456 171.021 286.115 170.699 320.355H170.538Z",
    fill: "url(#paint28_linear_10025_65881)"
  }), React.createElement("path", {
    d: "M171.15 217.924V319.036L168.961 317.523C168.961 317.523 282.045 274.111 280.661 275.302C279.893 243.708 280.785 212.095 283.332 180.594C245.648 193.241 208.351 205.759 171.15 217.924ZM168.543 216.025C207.16 203.957 245.358 192.211 283.332 180.626C281.042 212.13 280.409 243.732 281.433 275.302C281.723 276.139 170.377 320.098 170.216 320.548C169.972 320.643 169.708 320.676 169.447 320.645C169.187 320.614 168.938 320.52 168.722 320.371C168.507 320.222 168.331 320.022 168.21 319.789C168.089 319.557 168.026 319.298 168.028 319.036L168.543 216.057V216.025Z",
    fill: "#AAF4F1"
  }), React.createElement("path", {
    d: "M204.167 101.076L164.552 89.5872L144.729 83.8912C138.197 81.7048 131.203 81.2829 124.455 82.6683C98.7106 88.654 82.2018 113.53 75.0255 137.376L74.3497 139.886C74.0923 140.69 73.867 141.527 75.3152 142.718C75.2695 142.925 75.1832 143.122 75.0613 143.296C74.9393 143.47 74.7841 143.618 74.6046 143.731C74.4251 143.845 74.2248 143.922 74.0154 143.958C73.8059 143.994 73.5914 143.988 73.3843 143.941C73.178 143.899 72.9823 143.816 72.8085 143.697C72.6347 143.578 72.4865 143.426 72.3725 143.249C72.2585 143.072 72.1812 142.874 72.1449 142.667C72.1087 142.459 72.1143 142.247 72.1614 142.042C73.9957 141.527 74.1566 140.722 74.3497 139.886L75.0255 137.376C83.1351 107.898 110.682 73.0141 144.826 83.505C157.505 87.1093 191.262 96.6026 204.36 100.271C204.778 100.271 204.65 101.108 204.167 100.979V101.076Z",
    fill: "#AAF4F1"
  }), React.createElement("path", {
    d: "M170.892 205.985C207.996 197.103 245.326 188.543 283.332 180.015C283.283 170.627 282.356 161.265 280.564 152.05C278.76 142.871 275.019 134.181 269.59 126.563C264.273 118.861 256.503 113.189 247.547 110.472C238.541 108.15 228.999 109.155 220.676 113.304C212.356 117.407 204.956 123.154 198.921 130.199C192.802 137.233 187.64 145.045 183.571 153.434C179.506 161.775 176.48 170.583 174.561 179.661C173.602 184.19 172.882 188.766 172.404 193.37C172.168 195.687 171.975 198.004 171.825 200.321L171.6 203.829V204.698C171.6 204.987 171.6 205.341 171.6 205.341C171.6 205.341 171.214 205.631 170.892 205.985ZM168.832 208.463C168.527 207.539 168.375 206.572 168.382 205.599C168.358 205.224 168.358 204.847 168.382 204.472V203.603L168.639 200.096C168.832 197.747 169.058 195.397 169.347 193.048C169.898 188.344 170.693 183.671 171.729 179.05C173.852 169.798 177.094 160.84 181.383 152.372C185.688 143.896 191.099 136.029 197.473 128.976C203.742 121.816 211.408 116.012 220 111.92C228.706 107.752 238.623 106.86 247.933 109.41C257.117 112.265 265.059 118.154 270.459 126.112C275.814 133.842 279.477 142.615 281.208 151.857C282.843 161.098 283.629 170.47 283.557 179.854C245.68 189.605 207.353 199.291 168.832 208.463Z",
    fill: "url(#paint29_linear_10025_65881)"
  }), React.createElement("path", {
    d: "M147.336 168.816C121.591 160.288 95.3958 151.632 69.5547 142.75C69.1831 142.63 68.8703 142.375 68.6793 142.035C68.4883 141.695 68.4331 141.295 68.5249 140.915C70.5377 132.39 73.6647 124.167 77.8251 116.458C81.9112 108.744 87.0684 101.648 93.1432 95.3795C99.1935 89.0661 106.523 84.1179 114.64 80.866C122.733 77.5748 131.673 76.9878 140.127 79.1926L120.819 73.8828C117.601 73.0783 114.382 71.9519 111.164 71.437C107.911 70.8959 104.599 70.7877 101.317 71.1152C88.0586 72.4668 76.4092 80.3833 67.7526 90.1019C59.0683 100.063 52.5774 111.74 48.7015 124.374C44.7111 136.893 44.0997 150.119 43.3917 163.474L42.2976 161.865L170.345 205.695L168.221 207.111C168.8 195.316 170.711 183.625 173.917 172.259C177.303 160.93 182.404 150.186 189.042 140.4C195.497 130.506 203.988 122.102 213.95 115.75C218.816 112.478 224.316 110.266 230.093 109.257C235.87 108.248 241.794 108.465 247.482 109.893L230.973 105.162L222.703 102.813C219.985 101.911 217.197 101.233 214.368 100.786C208.68 100.094 202.909 100.676 197.473 102.491C192.063 104.348 186.972 107.029 182.38 110.44C173.3 117.417 165.743 126.178 160.176 136.185C157.299 141.084 154.845 146.22 152.838 151.535C151.809 154.174 150.908 156.877 150.103 159.58C149.717 160.964 149.299 162.283 149.009 163.667L148.526 165.727L148.301 166.789V167.304C148.129 167.889 147.794 168.414 147.336 168.816ZM145.759 165.984C145.616 166.007 145.482 166.067 145.369 166.157C145.256 166.247 145.169 166.365 145.115 166.499L145.276 165.984L145.598 164.954L146.241 162.863C146.66 161.479 147.207 160.127 147.657 158.743C148.623 156.008 149.653 153.305 150.875 150.698C153.243 145.426 155.963 140.319 159.017 135.412C165.066 125.625 172.918 117.075 182.155 110.215C186.809 106.824 191.968 104.185 197.441 102.395C202.919 100.62 208.724 100.092 214.432 100.85C217.248 101.327 220.023 102.016 222.735 102.91L231.006 105.259L247.514 109.99C241.833 108.658 235.934 108.543 230.205 109.652C224.475 110.762 219.046 113.07 214.272 116.426C204.586 122.896 196.399 131.367 190.265 141.269C183.958 151.014 179.193 161.673 176.137 172.871C173.288 184.124 171.733 195.666 171.503 207.272C171.478 207.696 171.29 208.094 170.978 208.382C170.666 208.67 170.255 208.826 169.83 208.817C169.691 208.835 169.55 208.835 169.412 208.817L41.3 164.922C40.9699 164.809 40.6866 164.59 40.4944 164.299C40.3023 164.008 40.2121 163.661 40.238 163.313C41.2034 150.087 42.1045 136.507 46.4811 123.666C50.6841 110.845 57.5491 99.0556 66.6262 89.0721C75.669 79.4179 87.7368 71.437 101.317 70.3429C104.662 70.095 108.024 70.268 111.325 70.8578C114.543 71.4692 117.761 72.6599 120.98 73.5288L140.095 79.2248C131.656 77.2852 122.815 78.132 114.897 81.6383C107.047 85.0787 100.016 90.1462 94.2695 96.5059C88.5233 102.819 83.7018 109.916 79.9491 117.584C76.1405 125.199 73.349 133.281 71.6464 141.623L70.5845 139.757C95.7176 148.285 120.593 157.07 145.759 165.984Z",
    fill: "url(#paint30_linear_10025_65881)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_10025_65881",
    x1: "24.4374",
    y1: "313.951",
    x2: "293.34",
    y2: "313.951",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_10025_65881",
    x1: "24.4382",
    y1: "276.725",
    x2: "292.954",
    y2: "276.725",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_10025_65881",
    x1: "82.2983",
    y1: "163.442",
    x2: "274.417",
    y2: "309.767",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.34",
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_10025_65881",
    x1: "143.764",
    y1: "206.789",
    x2: "182.928",
    y2: "148.188",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.29",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.77",
    stopColor: "#7FEFEA",
    stopOpacity: "0.32"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_10025_65881",
    x1: "149.749",
    y1: "182.975",
    x2: "233.837",
    y2: "161.865",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_10025_65881",
    x1: "92.3709",
    y1: "291.167",
    x2: "119.596",
    y2: "202.863",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.5",
    stopColor: "#AAF4F1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_10025_65881",
    x1: "152.002",
    y1: "218.664",
    x2: "324.716",
    y2: "290.878",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_10025_65881",
    x1: "337.234",
    y1: "349.865",
    x2: "235.447",
    y2: "291.393",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#29A2D9",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3879B2"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_10025_65881",
    x1: "1711.69",
    y1: "4791.09",
    x2: "3387.51",
    y2: "4791.09",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_10025_65881",
    x1: "3805.27",
    y1: "4541.27",
    x2: "4850.25",
    y2: "4541.27",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_10025_65881",
    x1: "151.905",
    y1: "3061.44",
    x2: "156.853",
    y2: "3061.44",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_10025_65881",
    x1: "67.3665",
    y1: "270.572",
    x2: "142.38",
    y2: "270.572",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_10025_65881",
    x1: "3941.43",
    y1: "1903.54",
    x2: "5066.76",
    y2: "1903.54",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_10025_65881",
    x1: "568.111",
    y1: "3567.89",
    x2: "568.111",
    y2: "2770.61",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("radialGradient", {
    id: "paint14_radial_10025_65881",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.403 154.818) scale(102.818)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint15_radial_10025_65881",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.303 156.459) scale(46.3403)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.13",
    stopColor: "white",
    stopOpacity: "0.98"
  }), React.createElement("stop", {
    offset: "0.26",
    stopColor: "white",
    stopOpacity: "0.94"
  }), React.createElement("stop", {
    offset: "0.38",
    stopColor: "white",
    stopOpacity: "0.86"
  }), React.createElement("stop", {
    offset: "0.5",
    stopColor: "white",
    stopOpacity: "0.75"
  }), React.createElement("stop", {
    offset: "0.63",
    stopColor: "white",
    stopOpacity: "0.61"
  }), React.createElement("stop", {
    offset: "0.75",
    stopColor: "white",
    stopOpacity: "0.44"
  }), React.createElement("stop", {
    offset: "0.87",
    stopColor: "white",
    stopOpacity: "0.24"
  }), React.createElement("stop", {
    offset: "0.99",
    stopColor: "white",
    stopOpacity: "0.01"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint16_radial_10025_65881",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.0599 156.459) scale(46.3403)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.13",
    stopColor: "white",
    stopOpacity: "0.83"
  }), React.createElement("stop", {
    offset: "0.37",
    stopColor: "white",
    stopOpacity: "0.54"
  }), React.createElement("stop", {
    offset: "0.59",
    stopColor: "white",
    stopOpacity: "0.31"
  }), React.createElement("stop", {
    offset: "0.77",
    stopColor: "white",
    stopOpacity: "0.14"
  }), React.createElement("stop", {
    offset: "0.92",
    stopColor: "white",
    stopOpacity: "0.04"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_10025_65881",
    x1: "66.5942",
    y1: "123.353",
    x2: "182.091",
    y2: "123.353",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.06",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#3A8FA2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#387E97"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_10025_65881",
    x1: "96.6837",
    y1: "153.659",
    x2: "148.173",
    y2: "90.9064",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#153A61"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_10025_65881",
    x1: "6269.4",
    y1: "-216.217",
    x2: "10271.5",
    y2: "-216.217",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint20_linear_10025_65881",
    x1: "124.037",
    y1: "37.8077",
    x2: "16.9113",
    y2: "268.205",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_10025_65881",
    x1: "4523.07",
    y1: "73.0144",
    x2: "6150.05",
    y2: "73.0144",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint22_linear_10025_65881",
    x1: "2274.25",
    y1: "-126.027",
    x2: "2338.4",
    y2: "102.212",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#90CFEB"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_10025_65881",
    x1: "4860.66",
    y1: "451.329",
    x2: "6759.34",
    y2: "451.329",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint24_linear_10025_65881",
    x1: "164.295",
    y1: "110.44",
    x2: "170.892",
    y2: "86.6586",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.64",
    stopColor: "white",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.76",
    stopColor: "#CDD1EA",
    stopOpacity: "0.32"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#616DBE"
  })), React.createElement("radialGradient", {
    id: "paint25_radial_10025_65881",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.753 67.5805) rotate(2.86241) scale(184.948 184.487)"
  }, React.createElement("stop", {
    stopColor: "#B18654"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#000505"
  })), React.createElement("linearGradient", {
    id: "paint26_linear_10025_65881",
    x1: "151.391",
    y1: "81.251",
    x2: "149.106",
    y2: "90.0251",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#153A61"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint27_linear_10025_65881",
    x1: "9415.27",
    y1: "5029.38",
    x2: "9423.24",
    y2: "2970.67",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint28_linear_10025_65881",
    x1: "40.2381",
    y1: "248.496",
    x2: "171.471",
    y2: "248.496",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#AAF4F1"
  })), React.createElement("linearGradient", {
    id: "paint29_linear_10025_65881",
    x1: "6301.48",
    y1: "3515.19",
    x2: "10478.5",
    y2: "3515.19",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#AAF4F1"
  })), React.createElement("linearGradient", {
    id: "paint30_linear_10025_65881",
    x1: "9463.21",
    y1: "6940.49",
    x2: "9499.36",
    y2: "940.353",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  }))));
};

var bundle = function bundle(width, height) {
  if (width === void 0) {
    width = '303';
  }

  if (height === void 0) {
    height = '398';
  }

  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 303 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M284.732 225.46C288.042 198.31 283.226 170.788 270.895 146.375C258.564 121.962 239.27 101.754 215.455 88.3048C191.639 74.856 164.37 68.7708 137.096 70.8187C109.822 72.8666 83.7682 82.9557 62.2279 99.8102C40.6876 116.665 24.6286 139.528 16.0813 165.509C7.53404 191.489 6.88238 219.421 14.2087 245.772C21.5351 272.124 36.5104 295.711 57.2413 313.551C77.9721 331.392 103.528 342.685 130.676 346.003C148.707 348.206 166.995 346.836 184.497 341.97C201.998 337.104 218.369 328.838 232.675 317.644C246.981 306.45 258.942 292.548 267.874 276.73C276.806 260.913 282.535 243.491 284.732 225.46Z",
    fill: "#8227B7"
  }), React.createElement("path", {
    opacity: "0.4",
    d: "M190.465 151.294C188.632 152.291 184.869 153.385 183.036 154.51C176.359 157.682 170.421 162.218 165.604 167.825C155.956 180.176 156.856 195.581 169.689 210.022C188.986 231.603 228.288 238.968 259.421 228.515C289.364 217.162 298.208 190.403 279.265 169.916C271.482 160.685 257.073 153.513 242.182 149.332C234.505 147.201 226.575 146.119 218.607 146.116C210.824 147.113 201.143 149.204 190.465 151.294Z",
    fill: "url(#paint0_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M184.355 108.615L199.664 109.837L216.356 113.857C216.356 113.857 222.563 110.963 213.14 94.721C207.157 84.397 201.69 84.6543 191.848 71.5322C183.679 61.4655 181.524 55.9336 176.282 55.4512C169.528 64.1028 182.972 99.5132 184.355 108.615Z",
    fill: "url(#paint1_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M156.888 135.47C156.888 135.47 150.198 117.717 158.561 91.8907C162.418 79.1035 168.036 66.9152 175.253 55.6763C176.217 54.2612 177.44 55.3868 177.89 56.1587C177.89 65.2606 191.784 82.4351 197.187 102.987L156.888 135.47Z",
    fill: "url(#paint2_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M264.213 204.844C289.943 167.279 249.386 110.963 220.215 102.89C191.044 94.8175 162.967 115.273 148.333 150.683C136.401 179.404 150.584 204.394 170.203 217.226C201.079 237.488 246.202 233.854 264.213 204.844Z",
    fill: "url(#paint3_radial_10025_65880)"
  }), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M208.669 159.881C214.008 161.2 218.317 166.314 220.215 174.805C223.11 187.477 215.326 201.274 202.011 198.379C190.465 195.935 186.606 189.631 186.606 179.082C186.606 168.533 196.672 155.379 208.669 159.881Z",
    fill: "#318CB6"
  }))), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M161.294 138.558C171.715 134.988 178.469 148.206 176.378 161.94C175.092 172.457 168.145 179.982 162.613 176.863C152.193 170.848 149.941 162.583 150.585 156.601C151.228 150.619 153.125 141.292 161.294 138.558Z",
    fill: "#3493B9"
  }))), React.createElement("path", {
    d: "M257.748 151.584L258.005 152.163C259.215 150.223 259.923 148.012 260.064 145.73V145.216C260.097 143.271 259.56 141.359 258.52 139.716C258.942 141.263 259.222 142.846 259.356 144.444C259.292 146.906 258.746 149.332 257.748 151.584Z",
    fill: "#744984"
  }), React.createElement("path", {
    d: "M231.247 176.895L170.879 143.865C168.659 142.675 166.858 144.09 166.858 147.081L148.655 162.39C146.21 162.39 144.634 187.541 147.272 190.886L196.222 217.998C204.842 222.598 222.563 214.3 227.902 201.917C232.726 190.725 234.592 184.936 234.592 184.936C234.703 183.427 234.459 181.913 233.878 180.517C233.297 179.12 232.395 177.879 231.247 176.895Z",
    fill: "url(#paint4_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M224.396 191.626L233.82 185.901L228.803 182.524L222.627 183.875L224.396 191.626Z",
    fill: "url(#paint5_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M154.734 126.915L164.382 121.094L167.952 133.444C167.952 133.444 162.71 135.856 162.838 135.888C162.967 135.921 154.734 126.915 154.734 126.915Z",
    fill: "url(#paint6_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M190.723 159.141C190.723 159.141 199.438 172.231 204.938 175.222C210.438 178.213 230.668 185.868 230.668 185.868C233.241 187.283 235.363 185.611 235.363 182.169V164.319C235.363 160.589 236.007 159.206 233.788 157.887C231.72 156.964 229.565 156.253 227.355 155.764C221.148 154.478 193.81 141.388 182.328 135.341C172.68 130.228 168.949 128.587 167.566 123.056C167.701 122.013 168.04 121.008 168.563 120.097C168.563 120.097 162.13 120.933 162.13 123.506L162.516 142.803C162.87 146.116 188.117 157.726 190.723 159.141Z",
    fill: "url(#paint7_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M212.27 198.701L224.234 191.722L210.758 179.082L208.828 180.112L212.27 198.701Z",
    fill: "url(#paint8_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M142.96 133.798L155.15 126.658L161.55 144.476L142.96 133.798Z",
    fill: "url(#paint9_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M162.547 154.189L221.404 191.465C223.977 192.848 226.099 191.175 226.099 187.734V169.884C226.075 168.147 225.636 166.441 224.82 164.909C224.003 163.376 222.832 162.06 221.404 161.072L158.302 126.69C155.729 125.275 153.606 126.948 153.606 130.389L157.755 145.377C157.776 147.124 158.224 148.841 159.059 150.376C159.894 151.912 161.092 153.221 162.547 154.189Z",
    fill: "url(#paint10_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M146.05 164.287L209.087 198.668C211.66 200.051 213.783 198.379 213.783 194.938V177.088C213.764 175.346 213.328 173.633 212.511 172.094C211.694 170.556 210.52 169.235 209.087 168.243L146.05 133.894C143.477 132.511 141.354 134.151 141.354 137.625V155.378C141.363 157.131 141.794 158.857 142.612 160.407C143.429 161.958 144.608 163.289 146.05 164.287Z",
    fill: "url(#paint11_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M207.254 201.756L212.271 198.54L210.76 195.002C210.76 195.002 204.745 197.736 204.745 197.929C204.745 198.122 207.254 201.756 207.254 201.756Z",
    fill: "url(#paint12_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M138.105 136.724L142.962 133.798L145.02 135.792L140.518 140.037L138.105 136.724Z",
    fill: "url(#paint13_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M141.097 167.279L204.134 201.66C206.707 203.075 208.83 201.403 208.83 197.961V180.111C208.785 178.401 208.337 176.725 207.521 175.222C206.705 173.718 205.544 172.429 204.134 171.46L141.097 136.918C138.524 135.503 136.401 137.175 136.401 140.616V158.595C136.44 160.311 136.886 161.993 137.703 163.502C138.519 165.012 139.682 166.306 141.097 167.279Z",
    fill: "url(#paint14_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M204.134 171.46L161.327 148.239C154.219 144.444 147.047 140.359 139.971 136.853C139.547 136.739 139.099 136.751 138.682 136.888C138.264 137.025 137.897 137.282 137.623 137.625C137.057 138.388 136.752 139.313 136.755 140.262V146.309C136.755 150.361 136.755 154.414 136.497 158.466V140.23C136.515 139.194 136.84 138.187 137.43 137.336C137.758 136.92 138.202 136.61 138.705 136.444C139.208 136.278 139.749 136.264 140.26 136.403C147.529 140.037 154.508 144.122 161.648 147.949L204.134 171.46Z",
    fill: "url(#paint15_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M202.815 172.811L142.415 139.812C140.228 138.59 138.427 140.038 138.427 143.029V158.306C138.449 159.786 138.822 161.24 139.515 162.548C140.209 163.857 141.202 164.982 142.415 165.832L202.815 198.765C205.002 199.988 206.836 198.54 206.836 195.549V180.369C206.812 178.88 206.436 177.419 205.737 176.105C205.038 174.791 204.036 173.662 202.815 172.811Z",
    fill: "url(#paint16_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M202.815 172.81L163.031 151.197L143.155 140.391C142.423 139.844 141.527 139.561 140.614 139.587C140.188 139.686 139.798 139.9 139.486 140.207C139.174 140.513 138.952 140.9 138.845 141.324C138.626 142.228 138.54 143.16 138.588 144.09V146.92C138.588 150.683 138.588 154.446 138.588 158.241C138.588 154.446 138.588 150.683 138.588 146.92V144.09C138.513 143.128 138.6 142.16 138.845 141.227C138.956 140.73 139.21 140.276 139.576 139.922C139.941 139.567 140.403 139.328 140.904 139.233C141.897 139.2 142.873 139.506 143.67 140.101L163.481 151.004L202.815 172.81Z",
    fill: "url(#paint17_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M156.567 151.937L187.056 168.661V166.506L156.567 149.782V151.937Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M223.174 187.219L217.996 190.435C216.999 191.046 216.195 190.435 216.195 189.148V182.201C216.205 181.522 216.373 180.855 216.686 180.252C216.998 179.649 217.447 179.127 217.996 178.728L223.174 175.512C224.171 174.9 224.975 175.512 224.975 176.798V183.713C224.97 184.397 224.805 185.071 224.492 185.68C224.179 186.289 223.728 186.816 223.174 187.219Z",
    fill: "url(#paint18_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M223.142 174.547L222.467 174.161L222.241 174.386L222.917 174.965L223.142 174.547Z",
    fill: "#BFB9DB"
  }), React.createElement("path", {
    d: "M222.627 186.994L217.449 190.21C216.452 190.789 215.648 190.21 215.648 188.891V181.944C215.668 181.267 215.84 180.603 216.152 180.001C216.464 179.4 216.907 178.877 217.449 178.471L222.627 175.254C223.624 174.675 224.428 175.254 224.428 176.541V183.488C224.414 184.171 224.244 184.841 223.932 185.448C223.62 186.056 223.174 186.584 222.627 186.994Z",
    fill: "url(#paint19_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M222.628 181.365C222.611 182.202 222.405 183.024 222.026 183.77C221.648 184.516 221.106 185.167 220.441 185.675C219.218 186.415 218.221 185.675 218.221 184.067C218.242 183.232 218.453 182.413 218.838 181.672C219.222 180.931 219.77 180.287 220.441 179.789C221.502 179.05 222.628 179.757 222.628 181.365Z",
    fill: "url(#paint20_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M234.142 164.963L231.569 166.603V184.131L234.142 182.555V164.963Z",
    fill: "url(#paint21_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M259.581 158.595V145.73C259.462 148.011 258.765 150.224 257.555 152.162C255.759 154.969 253.405 157.377 250.64 159.238C245.263 162.867 239.393 165.705 233.209 167.664L232.855 168.147L233.209 181.108C248.711 176.316 259.581 168.018 259.581 158.595Z",
    fill: "url(#paint22_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M260.128 158.595V145.73C259.967 148.017 259.238 150.228 258.005 152.162C256.173 155.01 253.776 157.451 250.962 159.334C245.354 163.095 239.234 166.031 232.79 168.05V181.912C248.871 177.088 260.064 168.597 260.064 159.013L260.128 158.595Z",
    fill: "url(#paint23_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M231.569 166.603L230.668 166.153V183.617L231.569 184.132V166.603Z",
    fill: "url(#paint24_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M230.668 166.153L231.569 166.603L234.141 164.963L233.305 164.545L230.668 166.153Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M178.63 200.984V203.171C178.63 206.999 176.475 208.703 173.677 206.999C172.136 205.905 170.879 204.458 170.012 202.78C169.145 201.101 168.692 199.239 168.692 197.35V194.134L171.618 197.35L174.224 197.832C175.253 199.762 176.282 201.274 178.63 200.984Z",
    fill: "#FA4A76"
  }), React.createElement("path", {
    d: "M174.127 198.186L171.522 197.704L168.595 194.488V197.704C168.628 199.541 169.114 201.342 170.01 202.946C170.056 201.804 170.489 200.711 171.236 199.847C171.984 198.982 173.003 198.397 174.127 198.186Z",
    fill: "#020A21"
  }), React.createElement("path", {
    d: "M180.817 190.757C180.173 189.116 179.723 187.541 175.124 185.096C170.525 182.652 167.276 182.395 166.89 183.456V183.713C166.472 184.935 167.694 186.929 172.133 190.853L172.776 191.496H173.033C172.776 191.496 172.776 191.496 172.776 191.754H173.291C173.516 192.011 173.516 192.011 173.677 192.011C173.837 192.011 174.352 192.236 174.513 192.236C176.121 193.458 181.138 193.458 180.817 190.757Z",
    fill: "url(#paint25_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M175.092 186.64C176.025 187.09 177.247 188.055 176.957 188.795C176.668 189.535 175.735 189.277 175.092 188.795C174.449 188.312 173.194 187.38 173.194 186.64C173.194 185.9 174.127 185.965 175.092 186.64Z",
    fill: "#CCCCCC"
  }), React.createElement("path", {
    d: "M182.007 197.607C182.235 197.769 182.423 197.98 182.557 198.226C182.69 198.471 182.766 198.744 182.779 199.023C182.751 199.804 182.482 200.557 182.007 201.177C181.556 202.11 180.334 202.593 177.986 201.949L176.571 201.177C175.887 200.694 175.261 200.133 174.706 199.505C174.223 198.733 173.773 198.09 173.484 197.607C173.219 197.017 173.056 196.387 173.001 195.742V192.526C173.001 192.043 173.291 191.754 173.773 192.043C173.995 192.208 174.177 192.421 174.305 192.666C174.433 192.911 174.504 193.182 174.513 193.459C174.513 193.459 174.802 195.613 174.802 195.806C174.658 196.582 174.658 197.378 174.802 198.154C174.914 198.514 175.096 198.847 175.34 199.135C175.583 199.422 175.881 199.657 176.218 199.827C178.823 201.531 179.755 200.599 180.238 199.827C180.519 199.417 180.685 198.939 180.72 198.444C180.817 197.447 181.749 197.607 182.007 197.607Z",
    fill: "#020A21"
  }), React.createElement("path", {
    d: "M174.384 191.432C174.615 191.583 174.806 191.788 174.941 192.029C175.075 192.27 175.149 192.54 175.156 192.815V196.031C175.127 196.452 175.029 196.865 174.867 197.254C174.577 197.704 174.384 198.476 173.452 198.669C172.794 198.721 172.137 198.551 171.586 198.186C169.202 196.743 167.351 194.565 166.312 191.979C165.833 191.089 165.579 190.095 165.572 189.084C165.572 188.602 165.861 188.313 166.312 188.602C166.543 188.76 166.734 188.971 166.868 189.217C167.002 189.463 167.076 189.737 167.084 190.017C167.368 192.272 168.522 194.326 170.3 195.742C170.664 196.105 171.075 196.419 171.522 196.675C171.972 196.964 172.455 197.157 172.744 196.964C172.864 196.949 172.975 196.893 173.057 196.805C173.139 196.716 173.188 196.602 173.194 196.482C173.41 196.112 173.511 195.687 173.484 195.26V192.043C173.387 191.239 173.87 190.95 174.384 191.432Z",
    fill: "#020A21"
  }), React.createElement("path", {
    d: "M279.554 95.6539C275.695 92.4377 271.868 93.4991 259.743 106.911C247.618 120.322 241.346 116.559 231.311 126.819C228.254 129.437 226.162 133.005 225.369 136.951C224.576 140.898 225.128 144.997 226.937 148.593C229.253 153.571 232.533 158.042 236.586 161.747L246.91 167.954L255.272 148.335C258.52 137.336 285.537 107.393 279.554 95.6539Z",
    fill: "url(#paint26_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M240.124 138.268C251.863 116.495 269.327 117.427 276.724 97.1652C276.852 96.8205 277.082 96.5232 277.384 96.3133C277.686 96.1034 278.045 95.9908 278.412 95.9908C278.78 95.9908 279.139 96.1034 279.441 96.3133C279.743 96.5232 279.973 96.8205 280.101 97.1652C283.317 103.823 288.463 112.732 290.907 135.181C291.574 140.141 291.173 145.186 289.731 149.979C288.288 154.771 285.839 159.2 282.545 162.969C267.654 181.848 223.624 168.887 240.124 138.268Z",
    fill: "url(#paint27_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M152.997 161.393C153.106 161.452 153.197 161.541 153.26 161.648C153.322 161.756 153.354 161.879 153.351 162.004V165.863L150.134 163.934C150.025 163.866 149.934 163.772 149.872 163.659C149.81 163.546 149.779 163.419 149.781 163.29V159.431L152.997 161.393Z",
    fill: "url(#paint28_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M160.49 157.437C160.6 157.504 160.69 157.598 160.752 157.711C160.814 157.824 160.846 157.951 160.844 158.08V161.811L157.628 159.881C157.52 159.812 157.431 159.716 157.369 159.604C157.308 159.492 157.275 159.366 157.274 159.238V155.378L160.49 157.437Z",
    fill: "url(#paint29_linear_10025_65880)"
  }), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M170.75 169.916C170.854 169.983 170.94 170.073 171.001 170.179C171.063 170.285 171.098 170.405 171.104 170.527V174.387L167.888 172.457C167.778 172.39 167.688 172.295 167.626 172.182C167.563 172.07 167.532 171.942 167.534 171.814V167.986L170.75 169.916Z",
    fill: "url(#paint30_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M200.113 176.606C200.222 176.666 200.313 176.754 200.376 176.862C200.438 176.97 200.47 177.093 200.466 177.217V181.077L197.25 179.147C197.14 179.08 197.05 178.985 196.988 178.872C196.926 178.76 196.894 178.633 196.896 178.504V174.677L200.113 176.606Z",
    fill: "url(#paint31_linear_10025_65880)"
  })), React.createElement("path", {
    d: "M185.673 168.951C185.787 169.017 185.882 169.11 185.95 169.223C186.017 169.335 186.055 169.463 186.059 169.594V173.422L182.843 171.492C182.733 171.433 182.642 171.344 182.58 171.236C182.517 171.129 182.486 171.006 182.489 170.881V167.021L185.673 168.951Z",
    fill: "url(#paint32_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M189.243 180.465C189.353 180.524 189.444 180.612 189.507 180.72C189.569 180.828 189.6 180.951 189.597 181.076V184.935L186.381 183.005C186.271 182.938 186.181 182.843 186.119 182.731C186.057 182.618 186.025 182.491 186.027 182.362V178.535L189.243 180.465Z",
    fill: "url(#paint33_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M203.329 186.255C203.439 186.322 203.529 186.416 203.591 186.529C203.653 186.642 203.685 186.769 203.683 186.898V190.725L200.467 188.795C200.357 188.736 200.266 188.648 200.203 188.54C200.141 188.432 200.11 188.309 200.113 188.184V184.325L203.329 186.255Z",
    fill: "url(#paint34_linear_10025_65880)"
  }), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M189.436 175.962C189.546 176.021 189.637 176.11 189.699 176.218C189.762 176.326 189.793 176.449 189.79 176.573V180.433L186.574 178.503C186.464 178.436 186.373 178.341 186.311 178.228C186.249 178.115 186.218 177.988 186.22 177.86V174L189.436 175.962Z",
    fill: "url(#paint35_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M157.789 161.072C157.951 161.11 158.093 161.207 158.188 161.343C158.282 161.48 158.324 161.646 158.303 161.811V165.671L155.087 163.741C154.974 163.676 154.878 163.582 154.811 163.47C154.743 163.357 154.706 163.229 154.701 163.098V159.142L157.789 161.072Z",
    fill: "url(#paint36_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M166.087 160.621C166.196 160.68 166.287 160.769 166.35 160.876C166.412 160.984 166.444 161.107 166.44 161.232V165.027L163.224 163.097C163.109 163.036 163.015 162.942 162.952 162.828C162.889 162.714 162.861 162.584 162.87 162.454V158.595L166.087 160.621Z",
    fill: "url(#paint37_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M171.811 163.837C171.921 163.904 172.012 163.999 172.074 164.112C172.136 164.225 172.167 164.352 172.165 164.48V168.243L168.788 166.281C168.679 166.222 168.588 166.134 168.525 166.026C168.463 165.918 168.431 165.795 168.434 165.67V161.811L171.811 163.837Z",
    fill: "url(#paint38_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M178.79 166.346C178.904 166.404 178.999 166.491 179.067 166.598C179.135 166.706 179.173 166.83 179.176 166.957V170.816L175.96 168.887C175.85 168.819 175.76 168.725 175.698 168.612C175.636 168.499 175.604 168.372 175.606 168.243V164.384L178.79 166.346Z",
    fill: "url(#paint39_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M204.07 183.97C204.18 184.03 204.271 184.118 204.333 184.226C204.396 184.334 204.427 184.457 204.424 184.582V188.441L201.208 186.511C201.098 186.444 201.007 186.349 200.945 186.237C200.883 186.124 200.852 185.997 200.854 185.868V182.041L204.07 183.97Z",
    fill: "url(#paint40_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.4"
  }, React.createElement("path", {
    opacity: "0.4",
    d: "M180.817 175.094C180.93 175.152 181.026 175.239 181.093 175.346C181.161 175.454 181.199 175.578 181.203 175.705V179.564L177.986 177.635C177.876 177.567 177.786 177.473 177.724 177.36C177.662 177.247 177.63 177.12 177.633 176.991V173.164L180.817 175.094Z",
    fill: "url(#paint41_linear_10025_65880)"
  })), React.createElement("path", {
    opacity: "0.4",
    d: "M217.405 312.652C215.317 313.191 211.909 313.798 209.793 314.361C201.936 316.346 194.274 318.82 186.876 321.759C170.389 328.506 158.436 337.142 155.605 345.148C151.428 357.134 172.917 361.16 202.786 355.425C232.628 349.128 260.492 334.286 263.899 322.906C265.988 317.779 261.783 313.911 254.859 311.482C250.398 310.229 245.696 309.65 240.982 309.773C234.717 310.335 226.418 311.482 217.405 312.652Z",
    fill: "url(#paint42_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M235.653 239L221.437 240.126L205.807 243.889C205.807 243.889 200.018 241.187 209.023 226.071C214.619 216.422 219.701 216.712 228.867 204.49C236.457 195.131 238.516 189.985 243.34 189.535C249.386 197.415 236.972 230.349 235.653 239Z",
    fill: "url(#paint43_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M235.653 239L221.437 240.126L205.807 243.889C205.807 243.889 200.018 241.187 209.023 226.071C214.619 216.422 219.701 216.712 228.867 204.49C236.457 195.131 238.516 189.985 243.34 189.535C249.386 197.415 236.972 230.349 235.653 239Z",
    fill: "url(#paint44_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M256.687 261.996C256.687 261.996 266.335 246.687 258.552 222.662C252.763 205.101 247.714 194.52 244.111 189.631C243.243 188.313 242.117 189.374 241.667 190.082C241.667 198.54 228.802 214.525 223.689 233.693L256.687 261.996Z",
    fill: "url(#paint45_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M161.262 328.411C137.237 293.451 175.06 241.026 202.205 233.5C229.349 225.975 255.497 245.047 269.102 277.981C280.198 304.739 267.011 327.96 248.775 339.957C217.482 360.476 178.019 355.33 161.262 328.411Z",
    fill: "url(#paint46_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M154.605 272.48C153.929 271.773 153.318 271.162 153.929 270.744C154.54 270.326 155.216 269.425 155.666 270.036C156.374 270.036 156.374 271.355 156.374 271.773C156.17 272.039 155.898 272.245 155.586 272.37C155.275 272.494 154.936 272.532 154.605 272.48Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M133.313 242.73C136.883 239.836 149.169 231.152 166.666 240.833C184.162 250.514 185.545 246.333 194.872 255.788C210.406 270.454 189.983 288.304 189.983 288.304L180.334 294.061L172.583 275.793C169.624 265.501 133.539 245.432 133.313 242.73Z",
    fill: "url(#paint47_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M186.735 266.466C175.832 246.172 144.442 242.184 141.708 241.798C138.974 241.412 134.214 241.155 133.249 242.73C130.033 248.938 141.708 242.73 139.424 263.571C138.825 268.167 139.209 272.837 140.551 277.273C141.892 281.709 144.161 285.809 147.208 289.301C161.166 306.926 202.108 294.929 186.735 266.466Z",
    fill: "url(#paint48_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M240.027 324.84V326.834C240.027 330.437 242.021 331.98 244.658 330.437C246.079 329.415 247.238 328.073 248.043 326.52C248.848 324.966 249.275 323.245 249.29 321.495V318.633L246.588 321.849L244.144 322.267C243.179 323.682 242.31 325.001 240.027 324.84Z",
    fill: "#030922"
  }), React.createElement("path", {
    d: "M240.027 324.84V326.834C240.027 330.437 242.021 331.98 244.658 330.437C246.079 329.415 247.238 328.073 248.043 326.52C248.848 324.966 249.275 323.245 249.29 321.495V318.633L246.588 321.849L244.144 322.267C243.179 323.682 242.31 325.001 240.027 324.84Z",
    fill: "#FF6CD0"
  }), React.createElement("path", {
    d: "M244.305 322.106L246.749 321.688L249.451 318.472V321.367C249.439 323.082 248.985 324.766 248.132 326.255C247.988 325.258 247.545 324.327 246.862 323.587C246.179 322.846 245.287 322.33 244.305 322.106Z",
    fill: "#030922"
  }), React.createElement("path", {
    d: "M236.714 315.481C237.108 314.036 237.834 312.702 238.833 311.586C239.832 310.469 241.078 309.601 242.471 309.049C247.36 306.154 251.123 306.605 251.541 307.73V307.988C251.991 309.306 250.673 311.204 245.977 315.578L245.141 316.189C245.398 316.189 245.398 316.189 245.398 316.446H244.883C244.594 316.736 244.594 316.736 244.433 316.736C244.272 316.736 243.726 316.993 243.565 316.993C241.603 318.344 236.264 318.344 236.714 315.481Z",
    fill: "url(#paint49_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M243.34 311.461C242.471 311.911 241.313 312.779 241.603 313.455C241.892 314.13 242.729 313.905 243.34 313.455C243.951 313.005 245.076 312.168 245.076 311.461C245.076 310.753 244.305 310.753 243.34 311.461Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M236.972 321.689C236.756 321.835 236.578 322.031 236.455 322.261C236.332 322.49 236.266 322.747 236.264 323.007C236.289 323.729 236.536 324.425 236.972 325.001C237.422 325.87 238.548 326.32 240.735 325.709L242.021 325.001C242.666 324.542 243.259 324.013 243.79 323.425C244.208 322.718 244.658 322.107 244.916 321.689C245.166 321.129 245.319 320.531 245.366 319.92V317.057C245.366 316.607 245.077 316.35 244.658 316.607C244.442 316.753 244.265 316.949 244.142 317.179C244.019 317.409 243.953 317.665 243.951 317.926C243.951 317.926 243.694 319.92 243.694 320.113C243.822 320.836 243.822 321.576 243.694 322.3C243.589 322.637 243.418 322.949 243.192 323.22C242.966 323.49 242.688 323.713 242.375 323.876C239.931 325.452 239.159 324.551 238.644 323.876C238.381 323.483 238.226 323.028 238.194 322.557C238.185 322.414 238.144 322.274 238.074 322.149C238.004 322.023 237.907 321.915 237.79 321.832C237.673 321.748 237.538 321.692 237.397 321.668C237.255 321.643 237.11 321.65 236.972 321.689Z",
    fill: "#030922"
  }), React.createElement("path", {
    d: "M244.047 315.899C243.837 316.051 243.664 316.248 243.541 316.477C243.418 316.705 243.349 316.959 243.34 317.218V320.113C243.365 320.499 243.452 320.879 243.597 321.238C243.886 321.689 244.047 322.364 244.916 322.557C245.528 322.604 246.139 322.446 246.652 322.107C248.888 320.79 250.62 318.763 251.573 316.35C252.03 315.522 252.273 314.593 252.281 313.648C252.281 313.198 252.023 312.94 251.573 313.198C251.367 313.351 251.199 313.55 251.081 313.778C250.964 314.007 250.901 314.26 250.898 314.516C250.573 316.651 249.417 318.571 247.681 319.855C247.326 320.169 246.95 320.459 246.556 320.724C246.106 320.981 245.687 321.142 245.398 320.981C245.284 320.973 245.178 320.922 245.1 320.838C245.023 320.755 244.98 320.645 244.98 320.531C244.788 320.188 244.699 319.797 244.723 319.405V316.51C244.916 315.642 244.497 315.481 244.047 315.899Z",
    fill: "#030922"
  }), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M257.684 265.148C247.199 261.546 240.542 274.797 242.568 288.562C243.854 299.047 250.769 306.573 256.365 303.517C266.85 297.471 269.037 289.27 268.426 283.223C267.815 277.177 265.885 267.753 257.684 265.148Z",
    fill: "#5DA7F3"
  }))), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M262.734 267.592C261.298 266.166 259.486 265.179 257.509 264.746C255.533 264.313 253.474 264.452 251.573 265.148C245.141 267.946 241.442 277.594 242.729 288.047C243.887 296.506 249.901 302.552 256.269 299.818C265.371 295.38 268.072 288.722 267.815 279.813C267.903 277.53 267.494 275.255 266.617 273.145C265.739 271.035 264.414 269.14 262.734 267.592Z",
    fill: "white"
  })), React.createElement("path", {
    d: "M254.339 268.3C249.451 270.744 245.881 275.633 246.138 285.41C246.138 292.068 252.152 298.95 258.199 296.506C263.345 294.319 269.102 287.597 266.657 276.951C265.081 270.551 258.359 266.274 254.339 268.3Z",
    fill: "url(#paint50_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M254.339 268.3C249.451 270.744 245.881 275.633 246.138 285.41C246.138 292.068 252.152 298.95 258.199 296.506C263.345 294.319 269.102 287.597 266.657 276.951C265.081 270.551 258.359 266.274 254.339 268.3Z",
    fill: "url(#paint51_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M258.295 272.384C258.295 272.384 258.295 272.384 258.102 272.384C257.569 272.599 257.099 272.944 256.734 273.388C256.368 273.832 256.12 274.36 256.012 274.925C256.012 275.697 256.269 277.015 257.137 277.176C258.006 277.337 259.324 275.697 259.678 274.828C260.032 273.96 259.775 271.966 258.295 272.384Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M252.763 278.848V279.041C252.763 279.749 253.374 280.617 254.082 280.521C254.79 280.424 255.208 279.556 255.401 278.945C255.432 278.748 255.414 278.545 255.349 278.356C255.284 278.167 255.174 277.997 255.028 277.861C254.882 277.724 254.705 277.625 254.512 277.573C254.319 277.521 254.116 277.517 253.921 277.562C253.64 277.669 253.388 277.842 253.187 278.066C252.986 278.289 252.84 278.558 252.763 278.848Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M261.415 292.742C260.739 293.193 260.128 293.45 259.421 293.9C257.52 295.132 255.733 296.531 254.082 298.081C250.319 301.683 247.649 305.414 247.875 308.148C247.875 312.329 253.921 312.329 261.672 307.891C269.423 303.452 275.502 296.505 275.502 292.324C275.536 291.893 275.476 291.46 275.326 291.055C275.176 290.649 274.941 290.281 274.635 289.975C274.329 289.669 273.961 289.433 273.555 289.284C273.15 289.134 272.717 289.074 272.286 289.108C271.012 289.139 269.752 289.378 268.555 289.816C266.011 290.332 263.589 291.325 261.415 292.742Z",
    fill: "url(#paint52_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M264.438 269.328C264.438 269.328 258.874 261.995 251.573 265.147C245.141 267.945 241.346 277.594 242.632 288.047C242.917 289.735 243.358 291.393 243.951 293C244.814 289.623 245.888 286.304 247.167 283.062C249 278.334 252.41 272.127 258.778 270.197C260.617 269.655 262.521 269.363 264.438 269.328Z",
    fill: "url(#paint53_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M244.047 293.032C244.598 290.243 245.329 287.493 246.234 284.798C247.053 282.062 248.289 279.469 249.901 277.112C251.538 274.722 253.651 272.696 256.108 271.162C256.72 270.802 257.354 270.479 258.005 270.197C258.687 269.901 259.385 269.643 260.096 269.425C261.517 269.077 262.975 268.904 264.438 268.91C265.052 268.824 265.642 268.616 266.175 268.299C266.657 267.981 267.029 267.52 267.236 266.98C267.442 266.409 267.442 265.783 267.236 265.212C267.152 264.903 266.998 264.618 266.786 264.378C266.574 264.138 266.31 263.95 266.014 263.829C266.366 263.895 266.699 264.04 266.988 264.251C267.277 264.462 267.516 264.736 267.686 265.051C268.047 265.684 268.162 266.429 268.008 267.141C267.935 267.512 267.79 267.866 267.58 268.18C267.37 268.495 267.1 268.765 266.786 268.975C266.178 269.367 265.502 269.64 264.792 269.779C263.414 269.774 262.041 269.947 260.707 270.293C259.378 270.664 258.11 271.228 256.944 271.966C254.426 273.365 252.233 275.284 250.512 277.594C248.874 279.872 247.574 282.374 246.652 285.023C245.622 287.637 244.752 290.312 244.047 293.032Z",
    fill: "#0D1276"
  }), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M210.245 289.076C204.906 290.298 200.596 294.865 198.731 302.359C195.836 313.648 203.62 325.869 216.967 323.328C228.513 321.141 232.34 315.642 232.34 306.122C232.34 296.602 222.306 284.991 210.245 289.076Z",
    fill: "#5090CD"
  }), React.createElement("path", {
    opacity: "0.8",
    d: "M210.502 287.95C205.163 289.172 200.853 293.707 198.988 301.233C196.093 312.522 203.877 324.744 217.224 322.203C228.77 320.016 232.597 314.516 232.597 304.996C232.597 295.476 222.917 284.027 210.502 287.95Z",
    fill: "white"
  }))), React.createElement("path", {
    d: "M214.104 293.032C205.613 294.769 203.008 303.678 204.038 310.432C204.831 313.741 206.804 316.648 209.587 318.607C212.369 320.567 215.77 321.445 219.154 321.077C222.873 320.408 226.173 318.288 228.33 315.185C230.486 312.082 231.321 308.249 230.652 304.53C229.982 300.811 227.862 297.51 224.759 295.354C221.656 293.198 217.823 292.363 214.104 293.032Z",
    fill: "url(#paint54_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M214.104 293.032C205.613 294.769 203.008 303.678 204.038 310.432C204.831 313.741 206.804 316.648 209.587 318.607C212.369 320.567 215.77 321.445 219.154 321.077C222.873 320.408 226.173 318.288 228.33 315.185C230.486 312.082 231.321 308.249 230.652 304.53C229.982 300.811 227.862 297.51 224.759 295.354C221.656 293.198 217.823 292.363 214.104 293.032Z",
    fill: "url(#paint55_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M217.835 297.664L217.224 298.082C216.098 299.047 213.815 303.324 217.417 303.324C217.94 303.402 218.471 303.402 218.993 303.324C219.52 303.021 219.972 302.603 220.317 302.103C220.662 301.602 220.891 301.03 220.987 300.43C221.148 299.401 220.28 297.214 218.543 297.632C218.307 297.591 218.066 297.602 217.835 297.664Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M220.022 317.765L217.578 318.376C215.082 319.064 212.632 319.913 210.245 320.917C204.938 323.265 201.175 326.223 200.114 329.054C198.795 333.17 205.71 334.553 215.23 332.656C224.75 330.758 233.659 325.291 234.785 321.367C235.492 319.63 234.077 318.151 231.89 317.443C230.459 316.977 228.956 316.77 227.452 316.832C225.619 316.961 222.917 317.411 220.022 317.765Z",
    fill: "url(#paint56_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M210.245 286.729C204.906 287.951 200.596 293.643 198.892 301.137C198.613 302.497 198.409 303.872 198.281 305.254C198.281 305.254 201.497 305.962 210.502 298.436C217.932 292.003 231.536 298.436 231.536 298.436C231.536 298.436 225.522 283.512 210.245 286.729Z",
    fill: "url(#paint57_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M195.129 300.269C194.997 300.818 194.984 301.388 195.089 301.942C195.195 302.497 195.416 303.023 195.74 303.485C196.033 303.886 196.415 304.214 196.856 304.443C197.296 304.671 197.784 304.795 198.281 304.804C198.569 304.846 198.861 304.846 199.149 304.804L200.178 304.546C200.886 304.289 201.497 304 202.205 303.678C203.52 302.95 204.797 302.156 206.032 301.298C207.254 300.43 208.476 299.561 209.634 298.596C210.237 298.086 210.871 297.614 211.532 297.181L212.593 296.667C212.929 296.486 213.285 296.346 213.654 296.248C216.629 295.363 219.773 295.209 222.82 295.798C224.328 296.052 225.812 296.428 227.259 296.924C228.7 297.384 230.108 297.942 231.472 298.596C228.658 297.487 225.721 296.72 222.724 296.313C219.806 295.8 216.805 296.044 214.008 297.02C213.662 297.111 213.335 297.263 213.043 297.471L212.078 297.985C211.466 298.393 210.875 298.834 210.309 299.304C209.184 300.269 207.962 301.201 206.739 302.102C205.492 303.01 204.18 303.827 202.816 304.546C202.104 304.906 201.374 305.228 200.629 305.511C200.275 305.511 199.857 305.768 199.503 305.833C199.069 305.931 198.618 305.931 198.184 305.833C197.523 305.837 196.873 305.66 196.305 305.32C195.738 304.979 195.275 304.489 194.968 303.903C194.663 303.342 194.518 302.708 194.55 302.07C194.52 301.746 194.556 301.42 194.656 301.11C194.755 300.801 194.916 300.514 195.129 300.269Z",
    fill: "#0D1276"
  }), React.createElement("path", {
    d: "M210.341 301.33C210.001 301.577 209.741 301.919 209.593 302.312C209.445 302.706 209.415 303.134 209.507 303.545C209.6 303.955 209.81 304.329 210.113 304.621C210.415 304.914 210.796 305.111 211.21 305.189C211.42 305.218 211.635 305.192 211.832 305.113C212.03 305.034 212.203 304.905 212.335 304.739C213.043 304.321 213.043 304.128 213.236 302.905C213.282 302.663 213.276 302.414 213.22 302.174C213.164 301.934 213.059 301.708 212.91 301.512C212.762 301.315 212.574 301.151 212.359 301.031C212.143 300.911 211.905 300.838 211.66 300.815C211.196 300.917 210.751 301.091 210.341 301.33Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M294.928 199.216C294.181 198.891 293.364 198.762 292.554 198.841C291.743 198.92 290.966 199.204 290.296 199.666L266.271 213.624C264.069 215.205 262.268 217.279 261.012 219.68C259.755 222.082 259.078 224.744 259.035 227.454V248.649C258.904 249.805 259.089 250.974 259.57 252.034C260.052 253.093 260.811 254.001 261.768 254.663C262.991 255.242 266.496 256.528 266.496 256.528L269.712 252.122C269.873 252.122 270.002 252.122 270.002 252.347V262.703C269.982 262.902 270.037 263.101 270.156 263.262C270.275 263.422 270.449 263.533 270.645 263.572L274.987 265.373L279.876 246.301L280.133 246.076L290.168 240.061C292.396 238.478 294.221 236.392 295.495 233.973C296.769 231.554 297.456 228.869 297.5 226.135L299.109 200.856C299.109 200.856 295.249 199.441 294.928 199.216Z",
    fill: "url(#paint58_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M294.896 201.499L270.87 215.393C268.651 216.986 266.84 219.081 265.582 221.506C264.325 223.932 263.657 226.619 263.634 229.351V250.257C263.634 255.595 266.85 258.008 270.87 255.724L274.312 253.762C274.312 253.762 274.601 253.762 274.601 253.987V264.344C274.601 265.566 275.695 265.501 276.338 264.344L284.475 248.07L284.7 247.844L294.896 241.991C297.094 240.4 298.893 238.319 300.149 235.913C301.404 233.508 302.084 230.843 302.132 228.129V206.999C302.132 201.66 298.851 199.215 294.896 201.499Z",
    fill: "url(#paint59_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M290.94 216.261C289.106 214.91 286.148 216.582 284.314 220.12L283.253 222.082C282.963 222.532 282.545 222.79 282.32 222.597L281.323 221.825C279.49 220.442 276.499 222.146 274.698 225.652C272.897 229.158 272.865 233.178 274.698 234.561L282.385 240.382C282.642 240.382 283.06 240.382 283.285 239.868L290.972 225.17C292.805 221.664 292.805 217.676 290.94 216.261Z",
    fill: "url(#paint60_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M290.94 216.261C289.106 214.91 286.148 216.582 284.314 220.12L283.253 222.082C282.963 222.532 282.545 222.79 282.32 222.597L281.323 221.825C279.49 220.442 276.499 222.146 274.698 225.652C272.897 229.158 272.865 233.178 274.698 234.561L282.385 240.382C282.642 240.382 283.06 240.382 283.285 239.868L290.972 225.17C292.805 221.664 292.805 217.676 290.94 216.261Z",
    fill: "#FFF5F5"
  }), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M66.0305 268.814C64.769 268.086 63.3381 267.702 61.8816 267.702C60.425 267.702 58.9941 268.086 57.7327 268.814L8.23528 297.309C8.06237 297.416 7.9196 297.565 7.82057 297.742C7.72154 297.92 7.66956 298.119 7.66956 298.323C7.66956 298.526 7.72154 298.725 7.82057 298.903C7.9196 299.08 8.06237 299.229 8.23528 299.336L58.1508 328.121C59.2585 328.768 60.5183 329.109 61.8012 329.109C63.084 329.109 64.3439 328.768 65.4515 328.121L115.431 299.368C115.604 299.261 115.747 299.112 115.846 298.935C115.945 298.758 115.997 298.558 115.997 298.355C115.997 298.152 115.945 297.952 115.846 297.774C115.747 297.597 115.604 297.448 115.431 297.342L66.0305 268.814Z",
    fill: "url(#paint61_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M66.0305 260.484C64.769 259.756 63.3381 259.373 61.8816 259.373C60.425 259.373 58.9941 259.756 57.7327 260.484L8.23528 288.98C8.06237 289.086 7.9196 289.235 7.82057 289.413C7.72154 289.59 7.66956 289.79 7.66956 289.993C7.66956 290.196 7.72154 290.396 7.82057 290.573C7.9196 290.75 8.06237 290.899 8.23528 291.006L58.1508 319.952C59.2585 320.599 60.5183 320.94 61.8012 320.94C63.084 320.94 64.3439 320.599 65.4515 319.952L115.431 291.199C115.604 291.092 115.747 290.943 115.846 290.766C115.945 290.589 115.997 290.389 115.997 290.186C115.997 289.983 115.945 289.783 115.846 289.606C115.747 289.428 115.604 289.279 115.431 289.173L66.0305 260.484Z",
    fill: "url(#paint62_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M66.0305 252.154C64.769 251.426 63.3381 251.042 61.8816 251.042C60.425 251.042 58.9941 251.426 57.7327 252.154L8.23528 280.811C8.06237 280.917 7.9196 281.066 7.82057 281.243C7.72154 281.421 7.66956 281.621 7.66956 281.824C7.66956 282.027 7.72154 282.226 7.82057 282.404C7.9196 282.581 8.06237 282.73 8.23528 282.837L58.1508 311.783C59.2585 312.43 60.5183 312.771 61.8012 312.771C63.084 312.771 64.3439 312.43 65.4515 311.783L115.431 282.837C115.604 282.73 115.747 282.581 115.846 282.404C115.945 282.226 115.997 282.027 115.997 281.824C115.997 281.621 115.945 281.421 115.846 281.243C115.747 281.066 115.604 280.917 115.431 280.811L66.0305 252.154Z",
    fill: "url(#paint63_linear_10025_65880)"
  })), React.createElement("g", {
    opacity: "0.11"
  }, React.createElement("path", {
    opacity: "0.11",
    d: "M66.0302 243.824C64.771 243.09 63.3392 242.703 61.8813 242.703C60.4235 242.703 58.9917 243.09 57.7324 243.824L8.23507 272.32C8.0617 272.422 7.91802 272.568 7.8182 272.743C7.71839 272.918 7.66589 273.116 7.66589 273.317C7.66589 273.518 7.71839 273.716 7.8182 273.891C7.91802 274.066 8.0617 274.212 8.23507 274.314L58.1505 303.26C59.2582 303.907 60.5181 304.248 61.8009 304.248C63.0838 304.248 64.3436 303.907 65.4513 303.26L115.431 274.314C115.604 274.207 115.747 274.058 115.846 273.881C115.945 273.704 115.997 273.504 115.997 273.301C115.997 273.098 115.945 272.898 115.846 272.721C115.747 272.543 115.604 272.394 115.431 272.288L66.0302 243.824Z",
    fill: "url(#paint64_linear_10025_65880)"
  })), React.createElement("path", {
    d: "M115.431 272.32L66.0303 243.825C64.7711 243.09 63.3393 242.703 61.8814 242.703C60.4235 242.703 58.9918 243.09 57.7325 243.825L8.23515 272.32C8.05536 272.416 7.9059 272.56 7.80362 272.736C7.70133 272.912 7.65028 273.114 7.65623 273.317V298.307C7.65151 298.515 7.70277 298.72 7.80462 298.901C7.90648 299.082 8.05519 299.232 8.23515 299.336L58.1506 328.121C59.2583 328.768 60.5181 329.109 61.801 329.109C63.0839 329.109 64.3437 328.768 65.4514 328.121L115.431 299.368C115.609 299.262 115.756 299.111 115.857 298.931C115.959 298.75 116.012 298.546 116.01 298.339V273.349C116.012 273.142 115.959 272.938 115.857 272.758C115.756 272.577 115.609 272.427 115.431 272.32Z",
    fill: "url(#paint65_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M115.431 272.32L66.0303 243.825C64.7711 243.09 63.3393 242.703 61.8814 242.703C60.4235 242.703 58.9918 243.09 57.7325 243.825L8.23515 272.32C8.05536 272.416 7.9059 272.56 7.80362 272.736C7.70133 272.912 7.65028 273.114 7.65623 273.317L58.2793 302.263C59.4038 302.912 60.6794 303.254 61.9779 303.254C63.2764 303.254 64.552 302.912 65.6765 302.263L116.01 273.317C116.006 273.116 115.951 272.918 115.849 272.744C115.748 272.57 115.604 272.424 115.431 272.32Z",
    fill: "url(#paint66_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M115.431 273.188L65.4517 302.134C64.344 302.781 63.0842 303.122 61.8013 303.122C60.5184 303.122 59.2586 302.781 58.1509 302.134L8.23541 273.188C8.06404 273.071 7.92115 272.917 7.8173 272.738C7.66509 273.002 7.62362 273.316 7.70193 273.612C7.78024 273.907 7.97198 274.159 8.23541 274.314L58.1509 303.259C59.2586 303.906 60.5184 304.248 61.8013 304.248C63.0842 304.248 64.344 303.906 65.4517 303.259L115.431 274.314C115.565 274.24 115.683 274.14 115.777 274.02C115.871 273.9 115.939 273.763 115.978 273.615C116.017 273.468 116.026 273.314 116.004 273.163C115.982 273.012 115.929 272.867 115.85 272.738C115.758 272.926 115.612 273.082 115.431 273.188Z",
    fill: "white"
  }), React.createElement("path", {
    opacity: "0.2",
    d: "M61.8491 276.694C65.7747 276.694 68.957 274.851 68.957 272.577C68.957 270.304 65.7747 268.461 61.8491 268.461C57.9236 268.461 54.7413 270.304 54.7413 272.577C54.7413 274.851 57.9236 276.694 61.8491 276.694Z",
    fill: "#180D5B"
  }), React.createElement("g", {
    opacity: "0.61"
  }, React.createElement("path", {
    opacity: "0.61",
    d: "M65.2907 244.724C64.2492 244.123 63.0679 243.807 61.8654 243.807C60.6629 243.807 59.4816 244.123 58.4401 244.724L17.6587 268.235C17.5117 268.319 17.3896 268.441 17.3047 268.588C17.2199 268.735 17.1752 268.902 17.1752 269.071C17.1752 269.241 17.2199 269.407 17.3047 269.554C17.3896 269.701 17.5117 269.823 17.6587 269.907L58.7939 293.675C59.7162 294.196 60.7577 294.471 61.8172 294.471C62.8766 294.471 63.9181 294.196 64.8404 293.675L106.04 269.939C106.187 269.855 106.309 269.733 106.394 269.586C106.479 269.439 106.523 269.273 106.523 269.103C106.523 268.934 106.479 268.767 106.394 268.62C106.309 268.473 106.187 268.352 106.04 268.267L65.2907 244.724Z",
    fill: "url(#paint67_linear_10025_65880)"
  }), React.createElement("path", {
    opacity: "0.61",
    d: "M65.2907 237.874C64.2492 237.272 63.0679 236.956 61.8654 236.956C60.6629 236.956 59.4816 237.272 58.4401 237.874L17.6587 261.513C17.5117 261.597 17.3896 261.719 17.3047 261.866C17.2199 262.013 17.1752 262.179 17.1752 262.349C17.1752 262.518 17.2199 262.685 17.3047 262.832C17.3896 262.979 17.5117 263.101 17.6587 263.185L58.7939 286.953C59.7162 287.474 60.7577 287.748 61.8172 287.748C62.8766 287.748 63.9181 287.474 64.8404 286.953L106.04 263.217C106.187 263.133 106.309 263.011 106.394 262.864C106.479 262.717 106.523 262.551 106.523 262.381C106.523 262.211 106.479 262.045 106.394 261.898C106.309 261.751 106.187 261.629 106.04 261.545L65.2907 237.874Z",
    fill: "url(#paint68_linear_10025_65880)"
  }), React.createElement("path", {
    opacity: "0.61",
    d: "M65.2907 230.991C64.2492 230.39 63.0679 230.073 61.8654 230.073C60.6629 230.073 59.4816 230.39 58.4401 230.991L17.6587 254.502C17.5117 254.586 17.3896 254.708 17.3047 254.855C17.2199 255.002 17.1752 255.168 17.1752 255.338C17.1752 255.508 17.2199 255.674 17.3047 255.821C17.3896 255.968 17.5117 256.09 17.6587 256.174L58.7939 279.91C59.7109 280.447 60.7545 280.73 61.8172 280.73C62.8799 280.73 63.9234 280.447 64.8404 279.91L106.04 256.174C106.187 256.09 106.309 255.968 106.394 255.821C106.479 255.674 106.523 255.508 106.523 255.338C106.523 255.168 106.479 255.002 106.394 254.855C106.309 254.708 106.187 254.586 106.04 254.502L65.2907 230.991Z",
    fill: "url(#paint69_linear_10025_65880)"
  })), React.createElement("path", {
    d: "M40.5582 141.903L55.4492 143.093L71.7553 147.017C71.7553 147.017 77.7696 144.186 68.5391 128.363C62.6856 118.296 57.3789 118.553 47.7946 105.849C39.8184 96.2006 37.7279 90.6687 32.6141 90.1863C26.1174 98.5162 39.3038 133.026 40.5582 141.903Z",
    fill: "url(#paint70_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M13.7672 168.243C13.7672 168.243 7.3348 150.94 15.4075 125.757C19.1504 113.312 24.629 101.456 31.6815 90.5398C32.582 89.1569 33.772 90.2504 34.2544 90.9901C34.2544 99.8668 47.7946 116.72 53.1014 136.66L13.7672 168.243Z",
    fill: "url(#paint71_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M13.7672 168.243C13.7672 168.243 7.3348 150.94 15.4075 125.757C19.1504 113.312 24.629 101.456 31.6815 90.5398C32.582 89.1569 33.772 90.2504 34.2544 90.9901C34.2544 99.8668 47.7946 116.72 53.1014 136.66L13.7672 168.243Z",
    fill: "url(#paint72_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M118.39 235.784C143.541 199.119 103.949 144.186 75.4859 136.307C47.0225 128.427 19.7169 148.399 5.43699 182.909C-6.1735 210.922 7.62401 235.237 26.7604 247.78C56.8641 267.528 100.83 263.99 118.39 235.784Z",
    fill: "url(#paint73_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M47.0547 189.503C51.6742 189.509 56.1918 188.145 60.0359 185.583C63.8799 183.021 66.8777 179.377 68.6499 175.111C70.4221 170.845 70.8891 166.149 69.9918 161.617C69.0945 157.086 66.8732 152.922 63.609 149.654C60.3448 146.385 56.1843 144.158 51.654 143.254C47.1238 142.351 42.4273 142.811 38.1588 144.578C33.8904 146.344 30.2418 149.337 27.6746 153.177C25.1075 157.018 23.7373 161.533 23.7373 166.153C23.7288 169.219 24.3259 172.256 25.4943 175.091C26.6627 177.926 28.3795 180.502 30.5459 182.671C32.7124 184.841 35.2861 186.561 38.1191 187.733C40.9521 188.906 43.9888 189.507 47.0547 189.503Z",
    fill: "url(#paint74_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M49.1455 176.863C52.0629 176.882 54.9202 176.035 57.3553 174.428C59.7903 172.821 61.6933 170.527 62.823 167.837C63.9527 165.147 64.2582 162.182 63.7008 159.319C63.1434 156.455 61.7481 153.821 59.692 151.752C57.6358 149.682 55.0113 148.269 52.1514 147.693C49.2914 147.117 46.3247 147.403 43.6275 148.515C40.9302 149.627 38.624 151.515 37.0011 153.939C35.3782 156.364 34.5118 159.215 34.5118 162.133C34.5032 166.025 36.0391 169.763 38.7826 172.524C41.526 175.286 45.2529 176.846 49.1455 176.863Z",
    fill: "url(#paint75_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M46.8617 166.442C49.363 166.449 51.8099 165.713 53.8927 164.328C55.9755 162.943 57.6006 160.971 58.5622 158.662C59.5238 156.353 59.7787 153.811 59.2946 151.357C58.8105 148.903 57.6093 146.647 55.8429 144.877C54.0765 143.106 51.8243 141.899 49.3716 141.408C46.9189 140.918 44.3758 141.166 42.0643 142.122C39.7529 143.078 37.7769 144.698 36.3866 146.777C34.9963 148.856 34.2542 151.301 34.2542 153.803C34.25 155.461 34.5729 157.104 35.2046 158.637C35.8363 160.171 36.7643 161.564 37.9355 162.738C39.1066 163.913 40.4979 164.844 42.0296 165.48C43.5613 166.115 45.2034 166.442 46.8617 166.442Z",
    fill: "url(#paint76_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M46.8617 166.442C49.363 166.449 51.8099 165.713 53.8927 164.328C55.9755 162.943 57.6006 160.971 58.5622 158.662C59.5238 156.353 59.7787 153.811 59.2946 151.357C58.8105 148.903 57.6093 146.647 55.8429 144.877C54.0765 143.106 51.8243 141.899 49.3716 141.408C46.9189 140.918 44.3758 141.166 42.0643 142.122C39.7529 143.078 37.7769 144.698 36.3866 146.777C34.9963 148.856 34.2542 151.301 34.2542 153.803C34.25 155.461 34.5729 157.104 35.2046 158.637C35.8363 160.171 36.7643 161.564 37.9355 162.738C39.1066 163.913 40.4979 164.844 42.0296 165.48C43.5613 166.115 45.2034 166.442 46.8617 166.442Z",
    fill: "url(#paint77_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M44.932 155.186C47.0198 155.192 49.0625 154.579 50.8015 153.423C52.5405 152.268 53.8976 150.623 54.701 148.696C55.5044 146.769 55.7179 144.647 55.3145 142.598C54.9111 140.55 53.9089 138.667 52.4349 137.189C50.9609 135.71 49.0812 134.702 47.034 134.292C44.9868 133.883 42.8641 134.09 40.9346 134.887C39.0051 135.685 37.3557 137.037 36.1951 138.772C35.0345 140.508 34.415 142.549 34.415 144.637C34.4065 146.022 34.6725 147.394 35.1976 148.676C35.7227 149.958 36.4966 151.123 37.4744 152.103C38.4523 153.084 39.6148 153.862 40.8948 154.391C42.1748 154.92 43.547 155.19 44.932 155.186Z",
    fill: "url(#paint78_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M44.932 155.186C47.0198 155.192 49.0625 154.579 50.8015 153.423C52.5405 152.268 53.8976 150.623 54.701 148.696C55.5044 146.769 55.7179 144.647 55.3145 142.598C54.9111 140.55 53.9089 138.667 52.4349 137.189C50.9609 135.71 49.0812 134.702 47.034 134.292C44.9868 133.883 42.8641 134.09 40.9346 134.887C39.0051 135.685 37.3557 137.037 36.1951 138.772C35.0345 140.508 34.415 142.549 34.415 144.637C34.4065 146.022 34.6725 147.394 35.1976 148.676C35.7227 149.958 36.4966 151.123 37.4744 152.103C38.4523 153.084 39.6148 153.862 40.8948 154.391C42.1748 154.92 43.547 155.19 44.932 155.186Z",
    fill: "url(#paint79_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M44.0314 146.116C45.7376 146.122 47.4072 145.622 48.8289 144.679C50.2505 143.735 51.3603 142.391 52.0176 140.817C52.675 139.243 52.8503 137.509 52.5213 135.834C52.1924 134.16 51.374 132.621 50.1698 131.413C48.9657 130.204 47.4299 129.38 45.757 129.045C44.0842 128.71 42.3494 128.878 40.7726 129.53C39.1957 130.181 37.8476 131.286 36.8991 132.704C35.9505 134.122 35.4442 135.79 35.4442 137.496C35.4225 138.631 35.6295 139.759 36.0529 140.813C36.4764 141.866 37.1076 142.824 37.9089 143.628C38.7103 144.432 39.6653 145.067 40.7172 145.494C41.7691 145.922 42.8962 146.133 44.0314 146.116Z",
    fill: "url(#paint80_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M44.0314 146.116C45.7376 146.122 47.4072 145.622 48.8289 144.679C50.2505 143.735 51.3603 142.391 52.0176 140.817C52.675 139.243 52.8503 137.509 52.5213 135.834C52.1924 134.16 51.374 132.621 50.1698 131.413C48.9657 130.204 47.4299 129.38 45.757 129.045C44.0842 128.71 42.3494 128.878 40.7726 129.53C39.1957 130.181 37.8476 131.286 36.8991 132.704C35.9505 134.122 35.4442 135.79 35.4442 137.496C35.4225 138.631 35.6295 139.759 36.0529 140.813C36.4764 141.866 37.1076 142.824 37.9089 143.628C38.7103 144.432 39.6653 145.067 40.7172 145.494C41.7691 145.922 42.8962 146.133 44.0314 146.116Z",
    fill: "url(#paint81_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M42.5197 137.689C43.8633 137.696 45.1785 137.303 46.2987 136.561C47.4189 135.819 48.2937 134.762 48.8122 133.522C49.3308 132.283 49.4698 130.917 49.2116 129.599C48.9534 128.28 48.3096 127.068 47.3618 126.116C46.4141 125.164 45.205 124.514 43.8877 124.25C42.5704 123.985 41.2043 124.118 39.9624 124.63C38.7205 125.143 37.6588 126.013 36.9117 127.13C36.1645 128.246 35.7657 129.56 35.7657 130.903C35.7615 131.793 35.933 132.674 36.2706 133.498C36.6081 134.321 37.1049 135.069 37.7325 135.7C38.3601 136.33 39.1061 136.831 39.9276 137.172C40.7492 137.514 41.6301 137.689 42.5197 137.689Z",
    fill: "url(#paint82_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M42.5197 137.689C43.8633 137.696 45.1785 137.303 46.2987 136.561C47.4189 135.819 48.2937 134.762 48.8122 133.522C49.3308 132.283 49.4698 130.917 49.2116 129.599C48.9534 128.28 48.3096 127.068 47.3618 126.116C46.4141 125.164 45.205 124.514 43.8877 124.25C42.5704 123.985 41.2043 124.118 39.9624 124.63C38.7205 125.143 37.6588 126.013 36.9117 127.13C36.1645 128.246 35.7657 129.56 35.7657 130.903C35.7615 131.793 35.933 132.674 36.2706 133.498C36.6081 134.321 37.1049 135.069 37.7325 135.7C38.3601 136.33 39.1061 136.831 39.9276 137.172C40.7492 137.514 41.6301 137.689 42.5197 137.689Z",
    fill: "url(#paint83_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M41.4584 130.903C42.5298 130.909 43.5788 130.597 44.4723 130.006C45.3658 129.415 46.0633 128.571 46.4762 127.582C46.8892 126.594 46.9989 125.505 46.7914 124.454C46.584 123.403 46.0687 122.437 45.3111 121.679C44.5535 120.922 43.5878 120.406 42.5367 120.199C41.4856 119.991 40.3965 120.101 39.4079 120.514C38.4193 120.927 37.5758 121.625 36.9845 122.518C36.3933 123.412 36.081 124.461 36.0873 125.532C36.0742 126.241 36.2042 126.945 36.4695 127.603C36.7348 128.26 37.1299 128.858 37.6313 129.359C38.1327 129.86 38.73 130.256 39.3876 130.521C40.0451 130.786 40.7494 130.916 41.4584 130.903Z",
    fill: "url(#paint84_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M41.4584 130.903C42.5298 130.909 43.5788 130.597 44.4723 130.006C45.3658 129.415 46.0633 128.571 46.4762 127.582C46.8892 126.594 46.9989 125.505 46.7914 124.454C46.584 123.403 46.0687 122.437 45.3111 121.679C44.5535 120.922 43.5878 120.406 42.5367 120.199C41.4856 119.991 40.3965 120.101 39.4079 120.514C38.4193 120.927 37.5758 121.625 36.9845 122.518C36.3933 123.412 36.081 124.461 36.0873 125.532C36.0742 126.241 36.2042 126.945 36.4695 127.603C36.7348 128.26 37.1299 128.858 37.6313 129.359C38.1327 129.86 38.73 130.256 39.3876 130.521C40.0451 130.786 40.7494 130.916 41.4584 130.903Z",
    fill: "url(#paint85_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M130.194 129.263C126.431 126.24 122.7 127.173 110.897 140.263C99.093 153.353 92.9501 149.911 83.1728 159.56C66.8988 174.933 88.2866 193.587 88.2866 193.587L98.3533 199.634L106.49 180.53C109.707 169.916 136.047 140.713 130.194 129.263Z",
    fill: "url(#paint86_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M91.7925 170.817C103.21 149.59 120.224 150.49 127.46 130.743C127.591 130.423 127.813 130.15 128.1 129.957C128.386 129.765 128.723 129.662 129.068 129.662C129.413 129.662 129.751 129.765 130.037 129.957C130.323 130.15 130.546 130.423 130.676 130.743C133.893 137.175 138.813 145.923 141.193 167.794C141.848 172.632 141.46 177.554 140.057 182.23C138.653 186.906 136.267 191.228 133.056 194.906C118.583 213.271 75.6793 200.663 91.7925 170.817Z",
    fill: "url(#paint87_linear_10025_65880)"
  }), React.createElement("path", {
    d: "M38.4354 222.18C38.036 220.656 37.2834 219.247 36.2385 218.068C35.1937 216.89 33.8859 215.973 32.4211 215.393C27.2752 212.37 23.3514 212.821 22.7725 214.01V214.3C22.3222 215.683 23.673 217.773 28.626 222.244L29.6552 222.919C29.3979 222.919 29.3979 222.919 29.3979 223.209H29.9446C30.2019 223.466 30.2019 223.466 30.3949 223.466C30.5879 223.466 31.1346 223.756 31.2954 223.756C33.3216 225.171 38.9178 225.171 38.4354 222.18Z",
    fill: "url(#paint88_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M38.4354 222.18C38.036 220.656 37.2834 219.247 36.2385 218.068C35.1937 216.89 33.8859 215.973 32.4211 215.393C27.2752 212.37 23.3514 212.821 22.7725 214.01V214.3C22.3222 215.683 23.673 217.773 28.626 222.244L29.6552 222.919C29.3979 222.919 29.3979 222.919 29.3979 223.209H29.9446C30.2019 223.466 30.2019 223.466 30.3949 223.466C30.5879 223.466 31.1346 223.756 31.2954 223.756C33.3216 225.171 38.9178 225.171 38.4354 222.18Z",
    fill: "url(#paint89_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M31.4885 217.934C32.4212 218.416 33.6112 219.317 33.3217 220.057C33.0323 220.796 32.1317 220.507 31.4885 220.057C30.8453 219.606 29.6553 218.674 29.6553 217.934C29.6553 217.194 30.588 217.323 31.4885 217.934Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M38.2744 228.676C38.491 228.829 38.6681 229.031 38.7911 229.266C38.9141 229.501 38.9796 229.762 38.982 230.027C38.9572 230.788 38.7113 231.526 38.2744 232.15C37.792 233.05 36.602 233.5 34.3185 232.857L32.8712 232.15C32.1963 231.666 31.5809 231.105 31.038 230.477C30.5877 229.77 30.1053 229.126 29.848 228.676C29.5997 228.093 29.4476 227.474 29.3977 226.843V223.82C29.3977 223.369 29.655 223.08 30.1053 223.369C30.3297 223.517 30.5145 223.717 30.6435 223.953C30.7725 224.188 30.8417 224.452 30.845 224.72C30.845 224.72 31.1345 226.843 31.1345 227.004C30.9892 227.769 30.9892 228.554 31.1345 229.319C31.3576 230.019 31.8412 230.606 32.4853 230.96C35.0582 232.6 35.9588 231.667 36.4412 230.96C36.7053 230.544 36.8601 230.068 36.8915 229.577C37.0844 228.483 37.985 228.676 38.2744 228.676Z",
    fill: "#030922"
  }), React.createElement("path", {
    d: "M30.7807 222.629C31.0013 222.78 31.1833 222.982 31.3118 223.216C31.4403 223.451 31.5118 223.713 31.5204 223.98V227.003C31.4952 227.414 31.3972 227.817 31.2309 228.193C30.9415 228.676 30.7807 229.383 29.848 229.576C29.2056 229.613 28.567 229.456 28.0147 229.126C25.7035 227.714 23.9099 225.593 22.901 223.079C22.4252 222.211 22.1711 221.239 22.1613 220.249C22.1613 219.799 22.4507 219.509 22.901 219.799C23.1216 219.95 23.3036 220.151 23.4321 220.386C23.5606 220.621 23.6321 220.882 23.6407 221.15C23.941 223.363 25.0953 225.372 26.8569 226.746C27.223 227.084 27.6216 227.386 28.0469 227.646C28.5293 227.936 28.9796 228.097 29.2369 227.936C29.3573 227.929 29.4716 227.881 29.5598 227.798C29.648 227.716 29.7044 227.605 29.7193 227.486C29.9068 227.118 29.9955 226.708 29.9766 226.296V223.272C29.848 222.436 30.3304 222.179 30.7807 222.629Z",
    fill: "#030922"
  }), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M64.2614 191.851C69.4716 193.138 73.7492 198.283 75.486 206.42C78.3484 218.771 70.7581 232.15 57.7647 229.384C46.508 227.004 42.745 220.893 42.745 210.537C42.745 200.181 52.5544 187.541 64.2614 191.851Z",
    fill: "#5090CD"
  }), React.createElement("path", {
    opacity: "0.8",
    d: "M64.0687 190.757C69.279 192.012 73.7173 197.19 75.3254 205.295C78.1557 217.645 70.5654 231.024 57.572 228.258C46.3153 225.717 42.5201 219.703 42.5201 209.25C42.5201 198.798 51.9115 186.287 64.0687 190.757Z",
    fill: "white"
  }))), React.createElement("path", {
    d: "M59.5016 190.757C67.7351 192.654 70.3724 202.464 69.1502 209.861C67.9281 217.258 60.2735 222.726 54.42 221.6C50.5613 220.622 47.2489 218.151 45.2106 214.732C43.1722 211.313 42.5747 207.224 43.5492 203.364C45.2217 195.163 51.0752 188.827 59.5016 190.757Z",
    fill: "url(#paint90_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M59.7588 193.619C60.9373 194.502 61.7774 195.762 62.1388 197.189C62.2879 197.87 62.1712 198.582 61.8124 199.18C61.4537 199.778 60.8802 200.216 60.209 200.405C59.6894 200.427 59.1694 200.373 58.6653 200.245C57.1858 199.762 56.5426 197.028 56.7355 195.742C56.7799 195.249 56.9554 194.778 57.2439 194.376C57.5324 193.975 57.9233 193.658 58.3758 193.458C58.6013 193.367 58.8462 193.333 59.0879 193.361C59.3296 193.39 59.5604 193.478 59.7588 193.619Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M65.0333 200.76C65.3257 200.911 65.5776 201.13 65.7679 201.398C65.9582 201.667 66.0812 201.977 66.1268 202.303C66.1931 202.869 66.0543 203.44 65.7356 203.912C65.417 204.384 64.9395 204.726 64.39 204.876C63.2 205.134 62.396 203.3 62.396 202.303C62.4028 201.851 62.5441 201.41 62.8018 201.038C63.0595 200.666 63.422 200.379 63.8433 200.213C63.8433 200.213 64.1327 200.213 64.2292 200.213L64.583 200.374C64.692 200.544 64.8486 200.678 65.0333 200.76Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M53.9052 223.337L56.2852 223.98C58.7383 224.728 61.1263 225.674 63.4251 226.811C67.6395 228.474 71.0806 231.651 73.0738 235.72C74.3602 240.287 67.6705 241.734 58.3435 239.643C49.0165 237.553 40.3328 231.571 39.2393 227.293C38.596 225.363 39.8825 223.82 42.0696 222.983C43.4532 222.501 44.9151 222.283 46.3793 222.34C48.4055 222.533 51.0749 222.919 53.9052 223.337Z",
    fill: "url(#paint91_radial_10025_65880)"
  }), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M18.0446 171.105C28.2078 167.632 34.801 180.432 32.8713 193.973C31.5848 204.232 24.8308 211.565 19.4276 208.542C9.20002 202.592 7.14166 194.519 7.62409 188.666C8.10652 182.812 10.1006 173.743 18.0446 171.105Z",
    fill: "#5DA7F3"
  }))), React.createElement("g", {
    opacity: "0.8"
  }, React.createElement("path", {
    opacity: "0.8",
    d: "M13.1238 173.486C14.517 172.089 16.2824 171.122 18.2097 170.7C20.137 170.278 22.145 170.419 23.9945 171.106C30.4269 173.647 33.9648 183.263 32.6783 193.426C31.5848 201.66 25.7313 207.513 19.4275 204.972C10.5508 200.663 7.9135 193.973 8.1708 185.386C8.08587 183.162 8.48476 180.946 9.33991 178.892C10.1951 176.837 11.4861 174.993 13.1238 173.486Z",
    fill: "white"
  })), React.createElement("path", {
    d: "M21.3573 171.267C26.1173 173.647 29.5908 178.407 29.3978 188.023C29.3978 194.456 23.5443 201.306 17.6908 198.926C14.2709 197.232 11.5648 194.377 10.0564 190.872C8.54806 187.366 8.33572 183.438 9.45736 179.79C10.9368 173.486 17.4014 169.337 21.3573 171.267Z",
    fill: "url(#paint92_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M22.451 174.386C22.7287 174.415 22.9944 174.515 23.2229 174.676C23.9715 175.231 24.4872 176.045 24.6701 176.959C24.6701 177.409 24.4129 179.146 23.6731 179.146C23.4802 179.146 23.0299 179.339 22.8369 179.146C22.6439 178.953 21.5826 178.053 21.1002 176.766C20.6177 175.48 20.8429 174.579 21.8399 174.29C22.0487 174.254 22.2634 174.288 22.451 174.386Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M25.8281 181.816C26.214 182.62 26.214 183.713 25.2813 183.713C25.0883 183.713 24.4772 183.906 23.5445 182.62C23.4563 182.402 23.4295 182.164 23.4671 181.931C23.5047 181.699 23.6052 181.482 23.7577 181.303C23.9102 181.124 24.1089 180.99 24.3322 180.916C24.5554 180.842 24.7947 180.83 25.024 180.883C25.2138 180.976 25.3828 181.107 25.5209 181.267C25.659 181.428 25.7635 181.614 25.8281 181.816Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M14.5712 200.212C15.2144 200.663 15.8577 200.823 16.5009 201.306C18.3848 202.481 20.1322 203.862 21.7111 205.423C25.3776 208.896 28.1436 212.563 27.7576 215.071C27.7576 219.188 21.9041 219.188 14.3139 214.878C6.72364 210.568 0.87015 203.943 0.87015 199.826C0.854279 199.408 0.92819 198.992 1.0869 198.605C1.24562 198.218 1.48545 197.869 1.79023 197.583C2.09501 197.296 2.45766 197.078 2.85375 196.944C3.24983 196.809 3.67014 196.761 4.08635 196.803C5.33563 196.814 6.57453 197.031 7.75283 197.446C10.1936 197.883 12.516 198.825 14.5712 200.212Z",
    fill: "url(#paint93_radial_10025_65880)"
  }), React.createElement("path", {
    d: "M52.8119 255.917C48.2579 255.945 43.7188 255.394 39.3038 254.277L39.529 253.505C39.7219 253.505 57.8613 258.619 71.9805 250.482C75.8487 248.11 79.1834 244.962 81.774 241.236C84.3647 237.511 86.1551 233.289 87.0323 228.837L87.8042 229.062C86.9029 233.618 85.0654 237.937 82.408 241.746C79.7506 245.555 76.3312 248.771 72.3664 251.189C66.3661 254.428 59.6291 256.057 52.8119 255.917Z",
    fill: "url(#paint94_linear_10025_65880)",
    fillOpacity: "0.4"
  }), React.createElement("path", {
    d: "M60.0484 258.748C57.4148 258.769 54.7827 258.618 52.1687 258.297V257.493C59.8247 258.401 67.5794 257.999 75.1002 256.303C90.9883 252.508 100.83 243.085 104.593 228.258L105.365 228.451C100.669 247.33 86.4213 254.438 75.261 257.075C70.2722 258.221 65.167 258.782 60.0484 258.748Z",
    fill: "url(#paint95_linear_10025_65880)",
    fillOpacity: "0.4"
  }), React.createElement("path", {
    d: "M67.2526 260.388V259.584C68.6999 259.584 108.388 259.166 117.104 224.206L117.876 224.399C109.031 259.97 68.7642 260.388 67.2526 260.388Z",
    fill: "url(#paint96_linear_10025_65880)",
    fillOpacity: "0.4"
  }), React.createElement("path", {
    d: "M68.2496 254.823C51.5964 254.525 35.2259 250.468 20.3604 242.956L20.7141 242.216C53.5837 257.943 84.3306 257.975 112.344 242.216L112.762 242.923C99.2137 250.698 83.8701 254.8 68.2496 254.823Z",
    fill: "url(#paint97_linear_10025_65880)",
    fillOpacity: "0.4"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_10025_65880",
    x1: "257.266",
    y1: "150.522",
    x2: "191.495",
    y2: "228.869",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#031D36",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.94",
    stopColor: "#031D36"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_10025_65880",
    x1: "190.047",
    y1: "89.7037",
    x2: "201.24",
    y2: "80.6662",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#73CFD7"
  }), React.createElement("stop", {
    offset: "0.14",
    stopColor: "#50B7C3"
  }), React.createElement("stop", {
    offset: "0.3",
    stopColor: "#3280B0"
  }), React.createElement("stop", {
    offset: "0.44",
    stopColor: "#164E9D"
  }), React.createElement("stop", {
    offset: "0.52",
    stopColor: "#083596"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3A9076"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_10025_65880",
    x1: "194.003",
    y1: "99.288",
    x2: "165.926",
    y2: "95.1713",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3D93C1"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.373 169.729) rotate(-0.861679) scale(84.1982 84.2879)"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#A0ECE7"
  }), React.createElement("stop", {
    offset: "0.33",
    stopColor: "#93F0EF"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#59CEE7"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#30A6C6"
  }), React.createElement("stop", {
    offset: "0.91",
    stopColor: "#239BC5"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#896DAE"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_10025_65880",
    x1: "180.141",
    y1: "202.131",
    x2: "190.198",
    y2: "176.156",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#49BFDA",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.5",
    stopColor: "#2E7B9A",
    stopOpacity: "0.52"
  }), React.createElement("stop", {
    offset: "0.99",
    stopColor: "#153B5E"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_10025_65880",
    x1: "220.923",
    y1: "179.809",
    x2: "204.059",
    y2: "159.069",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_10025_65880",
    x1: "1069.72",
    y1: "1159.97",
    x2: "991.166",
    y2: "1070.35",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_10025_65880",
    x1: "5480",
    y1: "4602.27",
    x2: "5144.5",
    y2: "4129.23",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.837 122.678) rotate(85.2233) scale(77.4618 94.7552)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.837 122.678) rotate(85.2233) scale(77.4618 94.7552)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.837 122.678) rotate(85.2233) scale(77.4618 94.7552)"
  }, React.createElement("stop", {
    offset: "0.00520833",
    stopColor: "#ECF5FC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CEE4F3"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_10025_65880",
    x1: "4836.2",
    y1: "4916.69",
    x2: "4604.64",
    y2: "4505.38",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_10025_65880",
    x1: "710.712",
    y1: "676.294",
    x2: "686.998",
    y2: "633.801",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_10025_65880",
    x1: "560.602",
    y1: "602.129",
    x2: "538.632",
    y2: "562.976",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_10025_65880",
    x1: "133.86",
    y1: "128.71",
    x2: "206.605",
    y2: "206.216",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#3A8FA2"
  }), React.createElement("stop", {
    offset: "0.84",
    stopColor: "#387E97"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#385397"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_10025_65880",
    x1: "136.047",
    y1: "155.057",
    x2: "203.587",
    y2: "152.677",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint16_linear_10025_65880",
    x1: "140.485",
    y1: "137.549",
    x2: "208.281",
    y2: "206.309",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#37A0DA"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "white"
  })), React.createElement("linearGradient", {
    id: "paint17_linear_10025_65880",
    x1: "3142.41",
    y1: "1266.16",
    x2: "4418.26",
    y2: "1181.6",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "#CFF9FC"
  }), React.createElement("stop", {
    offset: "0.41",
    stopColor: "#96F2F1",
    stopOpacity: "0.3"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint18_linear_10025_65880",
    x1: "852.851",
    y1: "1239.27",
    x2: "890.976",
    y2: "1251.7",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "0.06",
    stopColor: "#43E8E1"
  }), React.createElement("stop", {
    offset: "0.45",
    stopColor: "#3A8FA2"
  }), React.createElement("stop", {
    offset: "0.84",
    stopColor: "#387E97"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#385397"
  })), React.createElement("linearGradient", {
    id: "paint19_linear_10025_65880",
    x1: "784.782",
    y1: "1295.68",
    x2: "721.554",
    y2: "1237.57",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint20_linear_10025_65880",
    x1: "535.16",
    y1: "608.894",
    x2: "538.321",
    y2: "624.795",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint21_linear_10025_65880",
    x1: "418.186",
    y1: "1336.35",
    x2: "456.892",
    y2: "1344.06",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.01",
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint22_linear_10025_65880",
    x1: "2268.89",
    y1: "2232.77",
    x2: "2490.99",
    y2: "2232.77",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3D93C1"
  })), React.createElement("linearGradient", {
    id: "paint23_linear_10025_65880",
    x1: "2315.38",
    y1: "2285.8",
    x2: "2547.2",
    y2: "2285.8",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3D93C1"
  })), React.createElement("radialGradient", {
    id: "paint24_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.696 164.524) scale(0.925764 18.4823)"
  }, React.createElement("stop", {
    stopColor: "#D3FFF8"
  }), React.createElement("stop", {
    offset: "0.0474436",
    stopColor: "#D2FDF7"
  }), React.createElement("stop", {
    offset: "0.5011",
    stopColor: "#C8E9EF"
  }), React.createElement("stop", {
    offset: "0.8307",
    stopColor: "#C2DDE9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#C0D8E7"
  })), React.createElement("radialGradient", {
    id: "paint25_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.823 188.049) scale(8.72717 8.73585)"
  }, React.createElement("stop", {
    offset: "0.47",
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3A9076"
  })), React.createElement("linearGradient", {
    id: "paint26_linear_10025_65880",
    x1: "258.006",
    y1: "129.07",
    x2: "246.042",
    y2: "114.115",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#95F1EF"
  }), React.createElement("stop", {
    offset: "0.22",
    stopColor: "#50B7C3"
  }), React.createElement("stop", {
    offset: "0.38",
    stopColor: "#3280B0"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#164E9D"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#083596"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3A9076"
  })), React.createElement("linearGradient", {
    id: "paint27_linear_10025_65880",
    x1: "4569.72",
    y1: "-160704",
    x2: "5199.67",
    y2: "-160736",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#041836"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3D93C1"
  })), React.createElement("linearGradient", {
    id: "paint28_linear_10025_65880",
    x1: "151.517",
    y1: "165.863",
    x2: "151.517",
    y2: "159.431",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint29_linear_10025_65880",
    x1: "347.238",
    y1: "380.77",
    x2: "347.238",
    y2: "367.905",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint30_linear_10025_65880",
    x1: "368.887",
    y1: "417.02",
    x2: "368.887",
    y2: "404.284",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint31_linear_10025_65880",
    x1: "439.677",
    y1: "444.511",
    x2: "439.677",
    y2: "431.775",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint32_linear_10025_65880",
    x1: "400.45",
    y1: "414.135",
    x2: "400.45",
    y2: "401.399",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint33_linear_10025_65880",
    x1: "407.921",
    y1: "448.561",
    x2: "407.921",
    y2: "435.824",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint34_linear_10025_65880",
    x1: "443.536",
    y1: "466.575",
    x2: "443.536",
    y2: "453.839",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint35_linear_10025_65880",
    x1: "408.328",
    y1: "436.378",
    x2: "408.328",
    y2: "423.513",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint36_linear_10025_65880",
    x1: "343.611",
    y1: "395.227",
    x2: "343.611",
    y2: "382.235",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint37_linear_10025_65880",
    x1: "359.147",
    y1: "390.29",
    x2: "359.147",
    y2: "377.489",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint38_linear_10025_65880",
    x1: "380.1",
    y1: "400.003",
    x2: "380.1",
    y2: "387.138",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint39_linear_10025_65880",
    x1: "385.92",
    y1: "407.529",
    x2: "385.92",
    y2: "394.664",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint40_linear_10025_65880",
    x1: "439.206",
    y1: "459.043",
    x2: "439.206",
    y2: "446.307",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint41_linear_10025_65880",
    x1: "390.053",
    y1: "432.502",
    x2: "390.053",
    y2: "419.766",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C1E8E0",
    stopOpacity: "0.8"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#B2E0F9"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#96D6F7"
  })), React.createElement("linearGradient", {
    id: "paint42_linear_10025_65880",
    x1: "264.421",
    y1: "333.903",
    x2: "155.083",
    y2: "333.903",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.06",
    stopColor: "#051937"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "#051937",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint43_linear_10025_65880",
    x1: "230.314",
    y1: "221.247",
    x2: "219.862",
    y2: "212.82",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9EAAEA"
  }), React.createElement("stop", {
    offset: "0.14",
    stopColor: "#8192DF"
  }), React.createElement("stop", {
    offset: "0.3",
    stopColor: "#5066C9"
  }), React.createElement("stop", {
    offset: "0.44",
    stopColor: "#233EB4"
  }), React.createElement("stop", {
    offset: "0.52",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint44_linear_10025_65880",
    x1: "228.063",
    y1: "218.867",
    x2: "219.347",
    y2: "213.206",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FCA4F3"
  }), React.createElement("stop", {
    offset: "0.22",
    stopColor: "#DF81DB"
  }), React.createElement("stop", {
    offset: "0.38",
    stopColor: "#C750C9"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#B423A5"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#AC0D9C"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint45_linear_10025_65880",
    x1: "226.358",
    y1: "228.965",
    x2: "251.573",
    y2: "225.267",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6726A5"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#DA4DEF"
  })), React.createElement("radialGradient", {
    id: "paint46_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.977 282.42) rotate(-119.578) scale(68.4152 65.6231)"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#F0B2F5"
  }), React.createElement("stop", {
    offset: "0.33",
    stopColor: "#FCA2F3"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#F966E1"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#E345D3"
  }), React.createElement("stop", {
    offset: "0.91",
    stopColor: "#E233D0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint47_linear_10025_65880",
    x1: "3926.62",
    y1: "-124395",
    x2: "4118.52",
    y2: "-124115",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FCA4F3"
  }), React.createElement("stop", {
    offset: "0.22",
    stopColor: "#DF81DB"
  }), React.createElement("stop", {
    offset: "0.38",
    stopColor: "#C750C9"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#B423A5"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#AC0D9C"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint48_linear_10025_65880",
    x1: "3646.91",
    y1: "-121036",
    x2: "2974.92",
    y2: "-121085",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6726A5"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#DA4DEF"
  })), React.createElement("radialGradient", {
    id: "paint49_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.747 316.189) rotate(-135) scale(11.371 11.4044)"
  }, React.createElement("stop", {
    offset: "0.47",
    stopColor: "#051140"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint50_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.561 274.204) rotate(53.1301) scale(16.75 13.4324)"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#0D1276"
  }), React.createElement("stop", {
    offset: "0.47",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint51_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.452 282.317) rotate(53.148) scale(16.8068 13.4897)"
  }, React.createElement("stop", {
    offset: "0.0221768",
    stopColor: "#0D1276"
  }), React.createElement("stop", {
    offset: "0.471",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint52_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.743 284.865) rotate(142.406) scale(14.9681 6.76012)"
  }, React.createElement("stop", {
    stopColor: "#FF6CD0"
  }), React.createElement("stop", {
    offset: "0.21",
    stopColor: "#FC6ED1",
    stopOpacity: "0.78"
  }), React.createElement("stop", {
    offset: "0.37",
    stopColor: "#F374D3",
    stopOpacity: "0.62"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#E37DD7",
    stopOpacity: "0.48"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#CC8BDC",
    stopOpacity: "0.35"
  }), React.createElement("stop", {
    offset: "0.76",
    stopColor: "#AF9DE3",
    stopOpacity: "0.22"
  }), React.createElement("stop", {
    offset: "0.87",
    stopColor: "#8BB3EB",
    stopOpacity: "0.11"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "#64CBF4",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint53_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424319 -133643) rotate(180) scale(118.94 329.1)"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#F0B2F5"
  }), React.createElement("stop", {
    offset: "0.33",
    stopColor: "#FCA2F3"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#F966E1"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#E345D3"
  }), React.createElement("stop", {
    offset: "0.91",
    stopColor: "#E233D0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint54_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257627 -353545) rotate(124.579) scale(134.132 142.298)"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#0D1276"
  }), React.createElement("stop", {
    offset: "0.47",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint55_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.058 306.901) rotate(45.2967) scale(18.3612 15.3533)"
  }, React.createElement("stop", {
    offset: "0.0221768",
    stopColor: "#0D1276"
  }), React.createElement("stop", {
    offset: "0.471",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint56_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(636423 -210574) rotate(160.477) scale(181.315 42.3436)"
  }, React.createElement("stop", {
    stopColor: "#FF6CD0"
  }), React.createElement("stop", {
    offset: "0.21",
    stopColor: "#FC6ED1",
    stopOpacity: "0.78"
  }), React.createElement("stop", {
    offset: "0.37",
    stopColor: "#F374D3",
    stopOpacity: "0.62"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#E37DD7",
    stopOpacity: "0.48"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#CC8BDC",
    stopOpacity: "0.35"
  }), React.createElement("stop", {
    offset: "0.76",
    stopColor: "#AF9DE3",
    stopOpacity: "0.22"
  }), React.createElement("stop", {
    offset: "0.87",
    stopColor: "#8BB3EB",
    stopOpacity: "0.11"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "#64CBF4",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint57_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(827899 -38257.4) rotate(180) scale(225.433 129.735)"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#F0B2F5"
  }), React.createElement("stop", {
    offset: "0.33",
    stopColor: "#FCA2F3"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#F966E1"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#E345D3"
  }), React.createElement("stop", {
    offset: "0.91",
    stopColor: "#E233D0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint58_linear_10025_65880",
    x1: "292.387",
    y1: "208.446",
    x2: "272.382",
    y2: "236.17",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C74966"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#CC305A"
  })), React.createElement("linearGradient", {
    id: "paint59_linear_10025_65880",
    x1: "282.899",
    y1: "200.663",
    x2: "282.899",
    y2: "265.244",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FF7999"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#F42058"
  })), React.createElement("linearGradient", {
    id: "paint60_linear_10025_65880",
    x1: "282.835",
    y1: "215.811",
    x2: "282.835",
    y2: "240.447",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#EF7C97"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#E53866"
  })), React.createElement("linearGradient", {
    id: "paint61_linear_10025_65880",
    x1: "7.65637",
    y1: "298.403",
    x2: "116.01",
    y2: "298.403",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint62_linear_10025_65880",
    x1: "674.967",
    y1: "4869.55",
    x2: "4324.52",
    y2: "4869.55",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint63_linear_10025_65880",
    x1: "674.967",
    y1: "4713.38",
    x2: "4324.52",
    y2: "4713.38",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint64_linear_10025_65880",
    x1: "674.985",
    y1: "4532.42",
    x2: "4324.66",
    y2: "4532.42",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5761D7"
  }), React.createElement("stop", {
    offset: "0.07",
    stopColor: "#5472D8"
  }), React.createElement("stop", {
    offset: "0.28",
    stopColor: "#4E9CDB"
  }), React.createElement("stop", {
    offset: "0.48",
    stopColor: "#49BDDD"
  }), React.createElement("stop", {
    offset: "0.67",
    stopColor: "#45D5DF"
  }), React.createElement("stop", {
    offset: "0.85",
    stopColor: "#43E3E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#42E8E0"
  })), React.createElement("linearGradient", {
    id: "paint65_linear_10025_65880",
    x1: "675.119",
    y1: "6600.5",
    x2: "4325.58",
    y2: "6600.5",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2D5382"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3C88C4"
  })), React.createElement("linearGradient", {
    id: "paint66_linear_10025_65880",
    x1: "7.65623",
    y1: "273.06",
    x2: "116.01",
    y2: "273.06",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#1D9DD7"
  })), React.createElement("linearGradient", {
    id: "paint67_linear_10025_65880",
    x1: "61.8493",
    y1: "297.245",
    x2: "61.8493",
    y2: "263.571",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint68_linear_10025_65880",
    x1: "2067.72",
    y1: "4055.53",
    x2: "2070.03",
    y2: "3408.93",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint69_linear_10025_65880",
    x1: "2073.08",
    y1: "3847.45",
    x2: "2073.08",
    y2: "3425.99",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#42E8E0",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "0.18",
    stopColor: "#42E8E0",
    stopOpacity: "0.25"
  }), React.createElement("stop", {
    offset: "0.71",
    stopColor: "#42E8E0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#A7F9EF"
  })), React.createElement("linearGradient", {
    id: "paint70_linear_10025_65880",
    x1: "806.948",
    y1: "-120342",
    x2: "982.079",
    y2: "-120235",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9EAAEA"
  }), React.createElement("stop", {
    offset: "0.14",
    stopColor: "#8192DF"
  }), React.createElement("stop", {
    offset: "0.3",
    stopColor: "#5066C9"
  }), React.createElement("stop", {
    offset: "0.44",
    stopColor: "#233EB4"
  }), React.createElement("stop", {
    offset: "0.52",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint71_linear_10025_65880",
    x1: "49.9495",
    y1: "132.801",
    x2: "22.5796",
    y2: "128.813",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2525C6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4D91EE"
  })), React.createElement("linearGradient", {
    id: "paint72_linear_10025_65880",
    x1: "49.0785",
    y1: "126.784",
    x2: "19.8519",
    y2: "128.637",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2525C6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4D91EE"
  })), React.createElement("radialGradient", {
    id: "paint73_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.0315 189.149) rotate(-3.9005) scale(70.9208 70.9952)"
  }, React.createElement("stop", {
    offset: "0.02",
    stopColor: "#B2E5F5"
  }), React.createElement("stop", {
    offset: "0.33",
    stopColor: "#A2D5FC"
  }), React.createElement("stop", {
    offset: "0.56",
    stopColor: "#66AFF9"
  }), React.createElement("stop", {
    offset: "0.78",
    stopColor: "#4593E3"
  }), React.createElement("stop", {
    offset: "0.91",
    stopColor: "#3389E2"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BBEEF8"
  })), React.createElement("radialGradient", {
    id: "paint74_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0877 159.107) scale(17.774)"
  }, React.createElement("stop", {
    stopColor: "#3781E8"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#3D8EE3",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint75_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0264 162.127) scale(14.4904 14.4078)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF8FE7"
  })), React.createElement("radialGradient", {
    id: "paint76_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8698 153.059) scale(12.4814)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFB1E2"
  })), React.createElement("radialGradient", {
    id: "paint77_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7023 153.638) scale(12.5342 12.5406)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFB1E2"
  })), React.createElement("radialGradient", {
    id: "paint78_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.2327 139.852) scale(10.6135)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFBAE0"
  })), React.createElement("radialGradient", {
    id: "paint79_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8157 144.147) scale(10.6784 10.6838)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFBAE0"
  })), React.createElement("radialGradient", {
    id: "paint80_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4704 129.515) scale(8.7455)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCDE"
  })), React.createElement("radialGradient", {
    id: "paint81_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8437 137.653) scale(8.79994 8.80422)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCDE"
  })), React.createElement("radialGradient", {
    id: "paint82_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0717 119.173) scale(6.87753)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCD5"
  })), React.createElement("radialGradient", {
    id: "paint83_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1847 131.188) scale(6.92443 6.92778)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCD5"
  })), React.createElement("radialGradient", {
    id: "paint84_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8632 107.57) scale(5.00956)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCC8"
  })), React.createElement("radialGradient", {
    id: "paint85_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.338 125.755) scale(5.04204 5.0446)"
  }, React.createElement("stop", {
    stopColor: "white"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FFCCC8"
  })), React.createElement("linearGradient", {
    id: "paint86_linear_10025_65880",
    x1: "109.192",
    y1: "161.843",
    x2: "97.5493",
    y2: "147.274",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A4D7FC"
  }), React.createElement("stop", {
    offset: "0.22",
    stopColor: "#8192DF"
  }), React.createElement("stop", {
    offset: "0.38",
    stopColor: "#5066C9"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#233EB4"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("linearGradient", {
    id: "paint87_linear_10025_65880",
    x1: "97.925",
    y1: "160.232",
    x2: "132.267",
    y2: "165.896",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2525C6"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#4D91EE"
  })), React.createElement("radialGradient", {
    id: "paint88_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-92405.3 26822.7) scale(47.1942 34.7247)"
  }, React.createElement("stop", {
    offset: "0.47",
    stopColor: "#051140"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint89_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3151 222.907) rotate(-135.124) scale(11.9824 12.0175)"
  }, React.createElement("stop", {
    offset: "0.47",
    stopColor: "#051140"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint90_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9774 205.987) rotate(48.916) scale(19.1379 15.8543)"
  }, React.createElement("stop", {
    offset: "0.0221768",
    stopColor: "#0D1276"
  }), React.createElement("stop", {
    offset: "0.471",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint91_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-423699 -139751) rotate(21.8562) scale(175.218 50.1608)"
  }, React.createElement("stop", {
    stopColor: "#FF6CD0"
  }), React.createElement("stop", {
    offset: "0.21",
    stopColor: "#FC6ED1",
    stopOpacity: "0.78"
  }), React.createElement("stop", {
    offset: "0.37",
    stopColor: "#F374D3",
    stopOpacity: "0.62"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#E37DD7",
    stopOpacity: "0.48"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#CC8BDC",
    stopOpacity: "0.35"
  }), React.createElement("stop", {
    offset: "0.76",
    stopColor: "#AF9DE3",
    stopOpacity: "0.22"
  }), React.createElement("stop", {
    offset: "0.87",
    stopColor: "#8BB3EB",
    stopOpacity: "0.11"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "#64CBF4",
    stopOpacity: "0"
  })), React.createElement("radialGradient", {
    id: "paint92_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8523 185.017) rotate(53.1763) scale(16.4563 13.2046)"
  }, React.createElement("stop", {
    offset: "0.0221768",
    stopColor: "#0D1276"
  }), React.createElement("stop", {
    offset: "0.471",
    stopColor: "#0D2AAC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#FF6CD0"
  })), React.createElement("radialGradient", {
    id: "paint93_radial_10025_65880",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-239314 -171408) rotate(37.6024) scale(122.321 43.809)"
  }, React.createElement("stop", {
    stopColor: "#FF6CD0"
  }), React.createElement("stop", {
    offset: "0.21",
    stopColor: "#FC6ED1",
    stopOpacity: "0.78"
  }), React.createElement("stop", {
    offset: "0.37",
    stopColor: "#F374D3",
    stopOpacity: "0.62"
  }), React.createElement("stop", {
    offset: "0.51",
    stopColor: "#E37DD7",
    stopOpacity: "0.48"
  }), React.createElement("stop", {
    offset: "0.64",
    stopColor: "#CC8BDC",
    stopOpacity: "0.35"
  }), React.createElement("stop", {
    offset: "0.76",
    stopColor: "#AF9DE3",
    stopOpacity: "0.22"
  }), React.createElement("stop", {
    offset: "0.87",
    stopColor: "#8BB3EB",
    stopOpacity: "0.11"
  }), React.createElement("stop", {
    offset: "0.98",
    stopColor: "#64CBF4",
    stopOpacity: "0"
  })), React.createElement("linearGradient", {
    id: "paint94_linear_10025_65880",
    x1: "63.554",
    y1: "228.837",
    x2: "63.554",
    y2: "255.926",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E6EDFF",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BCEEF9"
  })), React.createElement("linearGradient", {
    id: "paint95_linear_10025_65880",
    x1: "78.7667",
    y1: "228.258",
    x2: "78.7667",
    y2: "258.75",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E6EDFF",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BCEEF9"
  })), React.createElement("linearGradient", {
    id: "paint96_linear_10025_65880",
    x1: "92.5641",
    y1: "224.206",
    x2: "92.5641",
    y2: "260.388",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E6EDFF",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BCEEF9"
  })), React.createElement("linearGradient", {
    id: "paint97_linear_10025_65880",
    x1: "66.5611",
    y1: "242.216",
    x2: "66.5611",
    y2: "254.823",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E6EDFF",
    stopOpacity: "0"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#BCEEF9"
  }))));
};

var _templateObject$y;

var getLogo = function getLogo(logo, width, height) {
  switch (logo) {
    case 'ethereum':
      return ethereumLogo(width, height);

    case 'binance':
      return binanceLogo(width, height);

    case 'polygon':
      return polygonLogo(width, height);

    case 'avalanche':
      return avalancheLogo(width, height);

    case 'fantom':
      return fantomLogo(width, height);

    case 'arbitrum':
      return arbitrum(width, height);

    case 'comingSoon':
      return comingSoon(width, height);

    case 'confirmed':
      return confirmed(width, height);

    case 'looking':
      return looking(width, height);

    case 'servers':
      return servers(width, height);

    case 'token':
      return token(width, height);

    case 'lazyNft':
      return lazyNft(width, height);

    case 'pack':
      return pack(width, height);

    case 'marketplace':
      return marketplace(width, height);

    case 'chest':
      return chest(width, height);

    case 'bundle':
      return bundle(width, height);

    default:
      return ethereumLogo();
  }
};

var StyledIllustration = /*#__PURE__*/styled.div(_templateObject$y || (_templateObject$y = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n"])), resetCSS, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});

var Illustration = function Illustration(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Date.now()) : _ref$id,
      logo = _ref.logo,
      width = _ref.width,
      height = _ref.height;
  return React.createElement(StyledIllustration, {
    width: width,
    height: height,
    id: id
  }, getLogo(logo, width, height));
};

var _templateObject$z, _templateObject2$n, _templateObject3$l, _templateObject4$j, _templateObject5$e, _templateObject6$b, _templateObject7$a, _templateObject8$8;
var DivStyledCryptoCard = /*#__PURE__*/styled.div(_templateObject$z || (_templateObject$z = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    align-items: center;\n    background: ", ";\n    border-radius: 16px;\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    left: 20px;\n    max-width: 256px;\n    overflow: hidden;\n    padding: 24px, 40px, 24px, 40px;\n    position: relative;\n    top: 20px;\n    width: 100%;\n\n    :after {\n        content: '';\n        display: block;\n        height: 100%;\n        left: 0;\n        pointer-events: none;\n        position: absolute;\n        top: 0;\n        transition: all 0.3s ease;\n        width: 100%;\n        z-index: 0;\n    }\n\n    :hover {\n        box-shadow: 0px 0px 400px 400px rgba(4, 24, 54, 0.2) inset;\n    }\n    background: ", ";\n"])), resetCSS, function (props) {
  return props.color;
}, /*#__PURE__*/getShade('light', 10), function (props) {
  return props.color;
});
var DivStyledImage = /*#__PURE__*/styled.div(_templateObject2$n || (_templateObject2$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    flex-grow: 0;\n    flex: none;\n    height: 160px;\n    left: 21px;\n    order: 0;\n    position: static;\n    top: 0px;\n    width: 120px;\n"])));
var DivStyledInfo = /*#__PURE__*/styled.div(_templateObject3$l || (_templateObject3$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 0;\n    flex: none;\n    height: 224px;\n    left: 51.5px;\n    margin: 16px 0px;\n    order: 0;\n    padding: 0px;\n    position: static;\n    top: 28px;\n    width: 162px;\n"])));
var DivStyledLogo = /*#__PURE__*/styled.div(_templateObject4$j || (_templateObject4$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 0px;\n    height: 136px;\n"])));
var DivStyledNetworkInfo = /*#__PURE__*/styled.div(_templateObject5$e || (_templateObject5$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    bottom: 0%;\n    color: ", ";\n    flex-grow: 0;\n    flex: none;\n    height: 64px;\n    left: calc(50% - 162px / 2);\n    margin: 0px 0px;\n    order: 1;\n    overflow: hidden;\n    position: static;\n    text-align: center;\n    top: 71.43%;\n    width: 100%;\n"])), color.white);
var DivStyledButton = /*#__PURE__*/styled.div(_templateObject6$b || (_templateObject6$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    flex-grow: 0;\n    flex: none;\n    height: 40px;\n    justify-content: center;\n    left: 39px;\n    margin: 16px 0px;\n    order: 1;\n    position: static;\n    top: 268px;\n    width: 187px;\n"])));
var PStyledChainName = /*#__PURE__*/styled.p(_templateObject7$a || (_templateObject7$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    font-size: 32px;\n    height: 55%;\n    margin: 0;\n    overflow: hidden;\n    word-break: break-all;\n"])), fonts.montserrat, fonts.textBold500);
var PStyledNetwork = /*#__PURE__*/styled.p(_templateObject8$8 || (_templateObject8$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    font-size: 20px;\n    height: 36px;\n    line-height: 36px;\n    margin: 0;\n    overflow: hidden;\n    word-break: break-all;\n"])), fonts.openSans, fonts.textBold700);

var CryptoCards = function CryptoCards(_ref) {
  var bgColor = _ref.bgColor,
      btnText = _ref.btnText,
      chain = _ref.chain,
      chainType = _ref.chainType,
      onClick = _ref.onClick,
      settingsIcon = _ref.settingsIcon;
  return React.createElement(DivStyledCryptoCard, {
    color: bgColor,
    "data-testid": 'test-crypto-card'
  }, React.createElement(DivStyledInfo, null, React.createElement(DivStyledImage, null, React.createElement(DivStyledLogo, null, React.createElement(Illustration, {
    logo: chain
  }))), React.createElement(DivStyledNetworkInfo, null, React.createElement(PStyledChainName, {
    "data-testid": 'test-chain-name'
  }, "" + chain.charAt(0).toUpperCase() + chain.slice(1)), React.createElement(PStyledNetwork, null, chainType || 'Network'))), React.createElement(DivStyledButton, null, React.createElement(Button, {
    icon: settingsIcon || iconTypes.cog,
    onClick: onClick,
    text: btnText,
    theme: "translucent"
  })));
};

var bgConfig = {
  arbitrum: 'linear-gradient(113.54deg, rgba(60, 87, 140, 0.5) 14.91%, rgba(70, 86, 169, 0.5) 43.21%, rgba(125, 150, 217, 0.345) 44.27%, rgba(129, 161, 225, 0.185) 55.76%), linear-gradient(151.07deg, #141659 33.25%, #4152A7 98.24%)',
  fantom: 'linear-gradient(113.54deg, rgba(117, 183, 251, 0.531738) 14.91%, rgba(10, 41, 255, 0.6) 42.57%, rgba(25, 105, 255, 0.336) 45.98%, rgba(25, 105, 255, 0.03) 55.76%), linear-gradient(160.75deg, #071AFF 41.37%, #45D4FF 98.29%)',
  avalanche: 'linear-gradient(113.54deg, rgba(119, 0, 1, 0.5) 14.91%, rgba(216, 43, 44, 0.5) 43.21%, rgba(255, 130, 130, 0.345) 44.27%, rgba(220, 96, 97, 0.185) 55.76%), linear-gradient(151.07deg, #8F0E0F 33.25%, #FA4A4B 98.24%)',
  polygon: 'linear-gradient(113.54deg, rgba(103, 58, 194, 0.6) 14.91%, rgba(122, 74, 221, 0.498) 44.27%, rgba(170, 129, 255, 0.222) 45.98%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #7A4ADD 41.37%, #D57BFF 98.29%)',
  binance: 'linear-gradient(113.54deg, rgba(217, 166, 54, 0.6) 14.91%, rgba(230, 166, 26, 0.6) 44.27%, rgba(207, 168, 28, 0) 45.98%, rgba(250, 228, 30, 0) 55.76%, rgba(245, 223, 30, 0) 55.76%), linear-gradient(147.17deg, #F5D116 48.73%, #CD9614 98.22%)',
  ethereum: 'linear-gradient(113.54deg, rgba(117, 183, 251, 0.531738) 14.91%, rgba(215, 38, 243, 0.6) 42.57%, rgba(252, 84, 255, 0.336) 45.98%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #AB42CB 41.37%, #45FFFF 98.29%)'
};

var _templateObject$A, _templateObject2$o;

var getBackground = function getBackground(chain) {
  return bgConfig[chain];
};

var getSize = function getSize(size) {
  return css(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n    width: ", ";\n    height: ", ";\n"])), size, size);
};

var DivStyledCryptoLogo = /*#__PURE__*/styled.div(_templateObject2$o || (_templateObject2$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    align-items: center;\n    background: ", ";\n    border-radius: 100%;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    ", "\n"])), resetCSS, function (props) {
  return (props == null ? void 0 : props.bgColor) || getBackground(props.chain);
}, function (props) {
  return getSize(props.size);
});

var CryptoLogos = function CryptoLogos(_ref) {
  var chain = _ref.chain,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '48px' : _ref$size,
      bgColor = _ref.bgColor;
  return React.createElement(DivStyledCryptoLogo, {
    chain: chain,
    "data-testid": 'test-crypto-logo',
    size: size,
    bgColor: bgColor
  }, React.createElement(Illustration, {
    logo: chain,
    width: "90%",
    height: "90%"
  }));
};

var _templateObject$B;
var SpanStyled$1 = /*#__PURE__*/styled.span(_templateObject$B || (_templateObject$B = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    align-items: center;\n    background-color: ", ";\n    border-radius: 50%;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    padding: 5px;\n    pointer-events: none;\n    position: absolute;\n    right: 10px;\n    top: 0;\n"])), resetCSS, color.white);

var _templateObject$C, _templateObject2$p, _templateObject3$m, _templateObject4$k, _templateObject5$f, _templateObject6$c, _templateObject7$b, _templateObject8$9, _templateObject9$7, _templateObject10$4;
var DivWrapperStyled = /*#__PURE__*/styled.div(_templateObject$C || (_templateObject$C = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    border-radius: 16px;\n    display: flex;\n    max-width: 100%;\n    min-width: fit-content;\n    outline: 1px solid;\n    position: relative;\n    transition: all 0.1s linear;\n\n    outline-color: ", ";\n\n    & > * > * > * {\n        ", ";\n    }\n\n    &:hover {\n        outline-color: ", ";\n\n        strong {\n            overflow: visible;\n            text-overflow: unset;\n            white-space: pre-wrap;\n        }\n    }\n\n    &:hover > .input_prefixIcon > svg {\n        fill: ", ";\n    }\n\n    input {\n        & + label {\n            color: ", ";\n        }\n    }\n\n    &:hover {\n        ", "\n        ", "\n\n        label {\n            ", "\n        }\n    }\n\n    &:focus-within {\n        outline: 2px solid ", ";\n\n        label {\n            font-weight: 600;\n            ", "\n        }\n\n        ", "\n        ", "\n    }\n\n    ", "\n"])), resetCSS, function (_ref) {
  var state = _ref.state;

  switch (state) {
    case 'error':
      return color.red;

    case 'confirmed':
      return color.green;

    case 'disabled':
      return color.greyDisabled;

    default:
      return color.greyLight;
  }
}, function (p) {
  return p.state === 'disabled' && " fill: " + color.greyDisabled + ";";
}, function (p) {
  return p.state !== 'disabled' && color.blue;
}, function (p) {
  return !(p != null && p.state) && color.blue;
}, function (_ref2) {
  var state = _ref2.state;

  switch (state) {
    case 'error':
      return color.red;

    case 'confirmed':
      return color.green;

    case 'disabled':
      return color.greyDisabled;

    default:
      return color.grey;
  }
}, function (p) {
  return p.state === 'error' && "outline-color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "outline-color: " + color.green + ";";
}, function (p) {
  return !(p != null && p.state) && "color: " + color.blue + ";";
}, color.blue, function (p) {
  return !(p != null && p.state) && "color: " + color.blue + ";";
}, function (p) {
  return p.state === 'error' && "outline-color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "outline-color: " + color.green + ";";
}, function (_ref3) {
  var size = _ref3.size;

  switch (size) {
    case 'large':
      return css(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["\n                    height: 56px;\n                    padding: 14px 16px;\n                    & > label {\n                        top: 15px;\n                    }\n                "])));

    case 'regular':
    default:
      return css(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteralLoose(["\n                    height: 40px;\n                    padding: 8px 16px;\n                    & > label {\n                        top: 8px;\n                    }\n                "])));
  }
});
var LabelStyled = /*#__PURE__*/styled.label(_templateObject4$k || (_templateObject4$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: ", ";\n    height: 24px;\n    left: ", ";\n    pointer-events: none;\n    position: absolute;\n    transition: all 0.1s ease-out;\n    z-index: 1;\n"])), resetCSS, fonts.text, function (_ref4) {
  var labelBgColor = _ref4.labelBgColor;
  return labelBgColor || color.white;
}, function (_ref5) {
  var hasPrefix = _ref5.hasPrefix;
  return hasPrefix ? '48px' : '16px';
});
var InputStyled = /*#__PURE__*/styled.input(_templateObject5$f || (_templateObject5$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: transparent;\n    overflow: hidden;\n    transition: all 0.1s ease-out;\n    width: 100%;\n\n    &:focus,\n    .input_filled & {\n        + label {\n            font-size: 14px;\n            height: 18px;\n            line-height: 1;\n            padding: 2px 4px;\n            top: -13px;\n            left: 12px;\n        }\n    }\n\n    &:focus {\n        &::placeholder {\n            display: none;\n            visibility: visible;\n            color: ", ";\n        }\n    }\n\n    &:-webkit-autofill,\n    :-webkit-autofill:focus {\n        transition: background-color 600000s 0s, color 600000s 0s;\n    }\n"])), resetCSS, fonts.text, color.grey);
var inputIconStyle = /*#__PURE__*/css(_templateObject6$c || (_templateObject6$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-width: 24px;\n    width: 100%;\n\n    & :first-child {\n        fill: ", ";\n        transition: fill 0.2s ease-out;\n        width: 100%;\n        height: 100%;\n    }\n"])), resetCSS, color.grey);
var DivStyled$5 = /*#__PURE__*/styled.div(_templateObject7$b || (_templateObject7$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    margin-right: 12px;\n"])), inputIconStyle);
var CopyContainerStyled = /*#__PURE__*/styled.div(_templateObject8$9 || (_templateObject8$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    height: 100%;\n    justify-content: center;\n    margin-left: 24px;\n    max-width: 24px;\n    position: relative;\n    width: 100%;\n\n    & :first-child {\n        width: 100%;\n        height: 100%;\n    }\n\n    &:before {\n        border-left: 1px solid ", ";\n        content: '';\n        height: 24px;\n        left: -12px;\n        position: absolute;\n        width: 0;\n    }\n"])), color.paleBlue2);
var VisibilityIcon = /*#__PURE__*/styled.button(_templateObject9$7 || (_templateObject9$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    position: relative;\n    margin-left: 12px;\n\n    &:hover > svg {\n        fill: ", ";\n    }\n"])), resetButtonCSS, inputIconStyle, color.blue);
var StrongStyled = /*#__PURE__*/styled.strong(_templateObject10$4 || (_templateObject10$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    bottom: -23px;\n    color: ", ";\n    font-size: 12px;\n    height: 24px;\n    left: 16px;\n    overflow: hidden;\n    pointer-events: none;\n    position: absolute;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: calc(100% - 26px);\n"])), resetCSS, fonts.text, color.red);

var DatePicker = function DatePicker(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      id = _ref.id,
      label = _ref.label,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'Select a date' : _ref$name,
      onChange = _ref.onChange,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? disabled ? 'disabled' : undefined : _ref$state,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'date' : _ref$type,
      validation = _ref.validation,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? new Date().toISOString().substring(0, type === 'date' ? 10 : 7) : _ref$value;

  var _useState = useState(value),
      current = _useState[0],
      setCurrent = _useState[1];

  var _useState2 = useState(state),
      currentState = _useState2[0],
      setCurrentState = _useState2[1];

  var _useState3 = useState(''),
      invalidMessage = _useState3[0],
      setInvalidMessage = _useState3[1];

  useEffect(function () {
    return setCurrentState(state);
  }, [state]);

  var dateChanged = function dateChanged(event) {
    var _event$target, _event$target2, _event$target3;

    setCurrent(event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value);
    onChange && (event == null ? void 0 : (_event$target2 = event.target) == null ? void 0 : _event$target2.valueAsDate) && onChange({
      date: event == null ? void 0 : (_event$target3 = event.target) == null ? void 0 : _event$target3.valueAsDate,
      event: event
    });
  };

  var hasValidation = function hasValidation() {
    return Boolean((validation == null ? void 0 : validation.required) || (validation == null ? void 0 : validation.max) || (validation == null ? void 0 : validation.min) || (validation == null ? void 0 : validation.required));
  };

  var validate = function validate(event) {
    if (!hasValidation()) return; // check for HTML validation

    if (!(event != null && event.target.checkValidity())) {
      setInvalidMessage(event == null ? void 0 : event.target.validationMessage);
      setCurrentState('error');
      return;
    } // if all pass but the Input is in error state


    if (currentState === 'error') {
      setCurrentState('confirmed');
      setTimeout(function () {
        return setCurrentState('initial');
      }, 3000);
    }
  };

  return React.createElement(DivWrapperStyled, {
    className: label && 'input_filled',
    "data-testid": "test-date-picker",
    state: currentState
  }, React.createElement(InputStyled, {
    "data-testid": "date-picker_input",
    disabled: currentState == 'disabled',
    id: id,
    max: validation == null ? void 0 : validation.max,
    min: validation == null ? void 0 : validation.min,
    name: name,
    onBlur: function onBlur(event) {
      return validate(event);
    },
    onChange: dateChanged,
    required: validation == null ? void 0 : validation.required,
    type: type,
    value: current
  }), label && React.createElement(LabelStyled, {
    "data-testid": "date-picker_label",
    hasPrefix: false,
    htmlFor: id,
    labelBgColor: "white"
  }, label), React.createElement(SpanStyled$1, {
    "data-testid": "date-picker_icon"
  }, React.createElement(Icon, {
    svg: iconTypes.calendar,
    fill: color.greyDark,
    size: 24
  })), currentState === 'error' && React.createElement(StrongStyled, {
    "data-testid": "date-picker_feedback"
  }, invalidMessage));
};

var _templateObject$D, _templateObject2$q, _templateObject3$n, _templateObject4$l, _templateObject5$g, _templateObject6$d, _templateObject7$c;
var StyledSelectParentDiv = /*#__PURE__*/styled.div(_templateObject$D || (_templateObject$D = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    display: flex;\n    fill: ", ";\n    flex-direction: column;\n    height: fit-content;\n    position: relative;\n    row-gap: 16px;\n    ", "\n"])), resetCSS, color.grey, function (props) {
  return props.isDisabled && 'opacity: 50%;';
});
var DivStyledSelected = /*#__PURE__*/styled.div(_templateObject2$q || (_templateObject2$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 16px;\n    border: 1px solid ", ";\n    color: ", ";\n    cursor: pointer;\n    height: 40px;\n    min-height: fit-content;\n    min-width: fit-content;\n    outline: 0px solid transparent;\n    transition: all 0.3s ease;\n    width: ", ";\n    & > div {\n        align-items: center;\n        color: inherit;\n        display: flex;\n        gap: 2px;\n        padding: 8px;\n        transition: all 0.3s ease;\n        & :nth-child(2) {\n            margin-right: auto;\n            white-space: nowrap;\n        }\n        & :nth-child(3) {\n            margin-left: auto;\n        }\n    }\n    &:hover {\n        border-color: ", ";\n    }\n    &:focus {\n        border: 2px solid ", ";\n    }\n    ", ";\n"])), function (p) {
  return p.hasOutline ? color.greyLight : 'transparent';
}, color.blue, function (props) {
  return props.width;
}, function (p) {
  return p.hasOutline ? color.blueSky : 'transparent';
}, color.blueSky, function (props) {
  return props.isOpen && css(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteralLoose(["\n            ", ";\n            border-color: ", ";\n        "])), props.hasOutline && 'outline: 4px solid rgba(158, 204, 234, 0.3)', props.hasOutline ? color.blue : 'transparent');
});
var DivStyledOptionsContainer = /*#__PURE__*/styled.div(_templateObject4$l || (_templateObject4$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: #f2f6ff;\n    border-radius: 16px;\n    border: 2px solid ", ";\n    display: flex;\n    flex-direction: column;\n    margin-top: -8px;\n    overflow: hidden;\n    position: absolute;\n    top: 56px;\n    transition: all 0.3s ease;\n    width: ", ";\n    z-index: 999;\n    display: ", ";\n"])), color.blueSky, function (props) {
  return props.width;
}, function (props) {
  return !props.isOpen ? 'none' : 'block';
});
var DivInnerStyledOptionsContainer = /*#__PURE__*/styled.div(_templateObject5$g || (_templateObject5$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: 8px;\n"])));
var DivStyledOptionItem = /*#__PURE__*/styled.div(_templateObject6$d || (_templateObject6$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    color: #041836;\n    cursor: pointer;\n    display: flex;\n    grid-gap: 8px;\n    padding: 6px 16px 6px 16px;\n    transition: all 0.3s ease;\n    &:hover {\n        border-radius: 8px;\n        background-color: #ebeff9;\n    }\n"])));
var DivStyledNoData = /*#__PURE__*/styled.div(_templateObject7$c || (_templateObject7$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 5px 0px;\n"])));

var Dropdown = function Dropdown(_ref) {
  var _options$selectedInde, _options$selectedInde2, _options$selectedInde3;

  var defaultOptionIndex = _ref.defaultOptionIndex,
      _ref$hasOutline = _ref.hasOutline,
      hasOutline = _ref$hasOutline === void 0 ? true : _ref$hasOutline,
      _ref$hideSelected = _ref.hideSelected,
      hideSelected = _ref$hideSelected === void 0 ? true : _ref$hideSelected,
      icon = _ref.icon,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isLabelFixed = _ref.isLabelFixed,
      isLabelFixed = _ref$isLabelFixed === void 0 ? true : _ref$isLabelFixed,
      _ref$isLabelVisible = _ref.isLabelVisible,
      isLabelVisible = _ref$isLabelVisible === void 0 ? true : _ref$isLabelVisible,
      label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      selectedState = _ref.selectedState,
      _ref$showSelected = _ref.showSelected,
      showSelected = _ref$showSelected === void 0 ? true : _ref$showSelected,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '250px' : _ref$width;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(defaultOptionIndex),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  useEffect(function () {
    if (isDisabled) {
      setIsOpen(false);
    }
  }, [isDisabled, isOpen]);
  useEffect(function () {
    if (typeof selectedState == 'number') {
      setSelectedIndex(selectedState);
    }
  }, [selectedState, selectedIndex]);

  var handleSelectOptionClick = function handleSelectOptionClick(selectedOption) {
    setIsOpen(false);
    var indexOf = options.indexOf(selectedOption);
    setSelectedIndex(indexOf);
    onChange(selectedOption);
  };

  var RenderOptions = useCallback(function () {
    if (options.length == 0 || options.length == 1 && selectedIndex != null && hideSelected) {
      return React.createElement(DivStyledOptionsContainer, {
        width: width,
        isOpen: isOpen
      }, React.createElement(DivInnerStyledOptionsContainer, null, React.createElement(DivStyledNoData, null, React.createElement(Illustration, {
        logo: "looking",
        width: '100%',
        height: '100px'
      }), React.createElement(Typography, {
        variant: "caption14",
        weight: "400"
      }, "No Data"))));
    }

    return React.createElement(DivStyledOptionsContainer, {
      isOpen: isOpen,
      "data-testid": "optionsContainer",
      width: width
    }, React.createElement(DivInnerStyledOptionsContainer, null, options.filter(function (optionItem) {
      return options.indexOf(optionItem) != selectedIndex || !hideSelected;
    }).map(function (option) {
      return React.createElement(DivStyledOptionItem, {
        onClick: function onClick() {
          handleSelectOptionClick(option);
        },
        key: option.id
      }, option == null ? void 0 : option.prefix, isLabelVisible && React.createElement(Typography, {
        variant: "caption14",
        weight: "400",
        color: "#041836"
      }, option.label));
    })));
  }, [isOpen]);
  return React.createElement(StyledSelectParentDiv, {
    width: width,
    "data-testid": "popoverSelect",
    isDisabled: isDisabled
  }, React.createElement(DivStyledSelected, {
    width: width,
    onClick: function onClick() {
      if (!isDisabled) {
        setIsOpen(!isOpen);
      }
    },
    isOpen: !!isOpen,
    hasOutline: hasOutline
  }, React.createElement("div", null, React.createElement("span", null, icon && React.createElement(Icon, {
    size: 24,
    svg: icon,
    style: {
      fill: 'currentColor'
    }
  }), typeof selectedIndex == 'number' && ((_options$selectedInde = options[selectedIndex]) == null ? void 0 : _options$selectedInde.prefix) && ((_options$selectedInde2 = options[selectedIndex]) == null ? void 0 : _options$selectedInde2.prefix)), isLabelVisible && React.createElement(Typography, {
    variant: "caption14",
    weight: "400"
  }, (isLabelFixed || typeof selectedIndex != 'number') && label, typeof selectedIndex === 'number' && showSelected && ((_options$selectedInde3 = options[selectedIndex]) == null ? void 0 : _options$selectedInde3.label)), React.createElement(Icon, {
    size: 24,
    svg: isOpen ? 'chevronUp' : 'chevronDown',
    style: {
      fill: 'currentColor'
    }
  }))), React.createElement(RenderOptions, null));
};

var Input = function Input(_ref) {
  var _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? true : _ref$autoComplete,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? 'Sorry this is not valid' : _ref$errorMessage,
      _ref$hasCopyButton = _ref.hasCopyButton,
      hasCopyButton = _ref$hasCopyButton === void 0 ? false : _ref$hasCopyButton,
      id = _ref.id,
      _ref$inputHidden = _ref.inputHidden,
      inputHidden = _ref$inputHidden === void 0 ? false : _ref$inputHidden,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      prefixIcon = _ref.prefixIcon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? disabled ? 'disabled' : undefined : _ref$state,
      style = _ref.style,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      validation = _ref.validation,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '320px' : _ref$width,
      labelBgColor = _ref.labelBgColor;

  var _useState = useState(value),
      currentValue = _useState[0],
      setCurrentValue = _useState[1];

  var _useState2 = useState(state),
      currentState = _useState2[0],
      setCurrentState = _useState2[1];

  var _useState3 = useState(type),
      mainType = _useState3[0],
      setMainType = _useState3[1];

  var _useState4 = useState(inputHidden),
      isInputHidden = _useState4[0],
      setIsInputHidden = _useState4[1];

  var _useState5 = useState(errorMessage),
      invalidMessage = _useState5[0],
      setInvalidMessage = _useState5[1];

  useEffect(function () {
    return setIsInputHidden(type === 'password');
  }, [inputHidden]);
  useEffect(function () {
    return setCurrentState(state);
  }, [state]);
  useEffect(function () {
    return setMainType(type);
  }, [type]);

  var valueChanged = function valueChanged(event) {
    setCurrentValue(event.target.value);
    onChange && onChange(event);
  };

  var canToggleHideInput = function canToggleHideInput() {
    return mainType === 'password';
  };

  var toggleHideInput = function toggleHideInput() {
    if (currentState === 'disabled') return;
    setIsInputHidden(!isInputHidden);
  };

  var hasValidation = function hasValidation() {
    return Boolean((validation == null ? void 0 : validation.required) || (validation == null ? void 0 : validation.numberMax) || (validation == null ? void 0 : validation.numberMin) || (validation == null ? void 0 : validation.characterMaxLength) || (validation == null ? void 0 : validation.characterMinLength) || (validation == null ? void 0 : validation.regExp));
  };

  var validate = function validate(event) {
    if (!hasValidation()) return; // check for HTML validation

    if (!(event != null && event.target.checkValidity())) {
      setInvalidMessage((event == null ? void 0 : event.target.validationMessage) || errorMessage);
      setCurrentState('error');
      return;
    } // check for the value passes the custom RegExp


    if (validation != null && validation.regExp) {
      var re = new RegExp(validation == null ? void 0 : validation.regExp);

      if (!re.test(event == null ? void 0 : event.target.value)) {
        setInvalidMessage((validation == null ? void 0 : validation.regExpInvalidMessage) || errorMessage);
        setCurrentState('error');
        return;
      }
    } // finally if all pass but the Input is in error state


    if (currentState === 'error') {
      setCurrentState('confirmed');
      setTimeout(function () {
        return setCurrentState('initial');
      }, 3000);
    }
  };

  return React.createElement(DivWrapperStyled, {
    state: currentState,
    className: "input input_" + (currentValue && (currentValue == null ? void 0 : currentValue.length) > 0 ? 'filled' : 'empty'),
    "data-testid": "test-div",
    style: _extends({}, style, {
      width: width
    }),
    size: size
  }, prefixIcon && React.createElement(DivStyled$5, {
    className: "input_prefixIcon"
  }, React.createElement(Icon, {
    svg: prefixIcon
  })), React.createElement(InputStyled, {
    autoComplete: "" + autoComplete,
    autoFocus: autoFocus,
    "data-testid": "test-input",
    disabled: currentState == 'disabled',
    id: id,
    max: type === 'number' ? validation == null ? void 0 : validation.numberMax : undefined,
    maxLength: validation == null ? void 0 : validation.characterMaxLength,
    min: type === 'number' ? validation == null ? void 0 : validation.numberMin : undefined,
    minLength: validation == null ? void 0 : validation.characterMinLength,
    name: name,
    onBlur: function onBlur(event) {
      return validate(event);
    },
    onChange: function onChange(event) {
      return valueChanged(event);
    },
    pattern: validation == null ? void 0 : validation.regExp,
    placeholder: placeholder,
    required: validation == null ? void 0 : validation.required,
    type: mainType !== 'password' ? type : isInputHidden ? 'password' : 'text',
    value: currentValue
  }), label && React.createElement(LabelStyled, {
    "data-testid": "test-label",
    htmlFor: id,
    hasPrefix: typeof prefixIcon !== 'undefined',
    labelBgColor: labelBgColor
  }, label, (validation == null ? void 0 : validation.required) && '*'), currentState === 'error' && React.createElement(StrongStyled, {
    "data-testid": "test-invalid-feedback"
  }, invalidMessage), canToggleHideInput() && React.createElement(VisibilityIcon, {
    className: "input_visibility",
    onClick: function onClick() {
      return toggleHideInput();
    },
    type: "button"
  }, isInputHidden ? React.createElement(Icon, {
    svg: iconTypes.eyeClosed
  }) : React.createElement(Icon, {
    svg: iconTypes.eye
  })), hasCopyButton && React.createElement(CopyContainerStyled, null, React.createElement(CopyButton, {
    text: currentValue
  })));
};

var _templateObject$E, _templateObject2$r, _templateObject3$o, _templateObject4$m, _templateObject5$h;
var FieldsetStyled = /*#__PURE__*/styled.fieldset(_templateObject$E || (_templateObject$E = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n"])), resetCSS);
var LegendStyled = /*#__PURE__*/styled.legend(_templateObject2$r || (_templateObject2$r = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", "\n    ", "\n    color: ", ";\n    display: block;\n    margin-bottom: 4px;\n"])), resetCSS, fonts.heading, fonts.h3, color.grey);
var DivStyled$6 = /*#__PURE__*/styled.div(_templateObject3$o || (_templateObject3$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: relative;\n    opacity: ", ";\n"])), function (props) {
  return props.disabled && 0.5;
});
var LabelStyled$1 = /*#__PURE__*/styled.label(_templateObject4$m || (_templateObject4$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", "\n    ", "\n    align-content: center;\n    color: ", ";\n    display: flex;\n    line-height: 20px;\n    margin-bottom: 12px;\n    padding-left: ", ";\n    position: relative;\n    width: fit-content;\n\n    &:before {\n        background-color: ", ";\n        border-radius: 50%;\n        border: 1px solid ", ";\n        content: '';\n        display: block;\n        height: 18px;\n        left: ", ";\n        position: absolute;\n        top: ", ";\n        transition: all 0.1s ease-out;\n        width: 18px;\n    }\n\n    &:after {\n        background-color: ", ";\n        border-radius: 50%;\n        content: '';\n        display: block;\n        height: 8px;\n        left: ", ";\n        opacity: 0;\n        position: absolute;\n        top: ", ";\n        transition: all 0.2s ease-out;\n        width: 8px;\n    }\n\n    &:hover {\n        &:before {\n            filter: brightness(95%);\n        }\n    }\n\n    &:active {\n        &:before {\n            filter: brightness(90%);\n        }\n    }\n"])), resetCSS, fonts.heading, fonts.text, color.greyDark, function (p) {
  return p.isCreditCardMode ? '0' : '28px';
}, color.blueLight, color.blueSky, function (p) {
  return p.isCreditCardMode ? '20px' : '0';
}, function (p) {
  return p.isCreditCardMode ? '20px' : '0';
}, color.white, function (p) {
  return p.isCreditCardMode ? '26px' : '6px';
}, function (p) {
  return p.isCreditCardMode ? '26px' : '6px';
});
var RadioButtonStyled = /*#__PURE__*/styled.input(_templateObject5$h || (_templateObject5$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: absolute;\n    left: -100px;\n\n    &:checked {\n        & + label {\n            &:before {\n                background-color: ", ";\n                border-color: ", ";\n            }\n            &:after {\n                opacity: 1;\n            }\n        }\n    }\n"])), color.green, color.greenLight);

var Radios = function Radios(_ref) {
  var id = _ref.id,
      items = _ref.items,
      _onChange = _ref.onChange,
      onCreditCardRemoved = _ref.onCreditCardRemoved,
      title = _ref.title,
      validation = _ref.validation,
      setWhichIsChecked = _ref.setWhichIsChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var formattedID = id.replace(/\s/g, '-');
  var isCreditCards = Boolean(typeof items[0] === 'object');

  var _useState = useState(setWhichIsChecked || items.length),
      whichIsChecked = _useState[0],
      setChecked = _useState[1];

  var renderCreditCard = function renderCreditCard(item, arrayIndex) {
    return React.createElement(CreditCard, {
      brand: item.brand,
      expiresAt: {
        month: '11',
        year: '21'
      },
      fingerprint: item.fingerprint,
      id: item.id,
      isExpired: item.isExpired,
      lastDigits: item.lastDigits,
      name: item.name,
      onRemove: function onRemove() {
        return onCreditCardRemoved && onCreditCardRemoved(arrayIndex);
      }
    });
  };

  return React.createElement(FieldsetStyled, {
    id: "" + formattedID,
    "data-testid": "test-fieldset"
  }, title && React.createElement(LegendStyled, {
    "data-testid": "test-legend"
  }, title), items.map(function (item, i) {
    return React.createElement(DivStyled$6, {
      key: formattedID + "_" + i,
      disabled: disabled
    }, React.createElement(RadioButtonStyled, {
      checked: i === whichIsChecked,
      "data-testid": "test-input-" + i,
      id: formattedID + "_" + i,
      name: formattedID + "_group",
      onChange: function onChange(e) {
        if (disabled) {
          return;
        }

        _onChange(e);

        setChecked(i);
      },
      required: validation == null ? void 0 : validation.required,
      type: "radio",
      value: i
    }), React.createElement(LabelStyled$1, {
      "data-testid": "test-label-" + i,
      htmlFor: formattedID + "_" + i,
      isCreditCardMode: isCreditCards
    }, typeof item === 'string' ? item : renderCreditCard(item, i)));
  }));
};

var _templateObject$F, _templateObject2$s, _templateObject3$p, _templateObject4$n, _templateObject5$i, _templateObject6$e, _templateObject7$d, _templateObject8$a, _templateObject9$8, _templateObject10$5, _templateObject11$4, _templateObject12$4;
var DivStyledWrapper = /*#__PURE__*/styled.div(_templateObject$F || (_templateObject$F = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    display: inline-block;\n    position: relative;\n"])), resetCSS);
var LabelStyled$2 = /*#__PURE__*/styled.label(_templateObject2$s || (_templateObject2$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: ", ";\n    height: 24px;\n    left: 12px;\n    line-height: 1;\n    pointer-events: none;\n    position: absolute;\n    padding: 0 4px;\n    transition: all 0.1s ease-out;\n    ", ";\n"])), resetCSS, fonts.text, color.white, function (_ref) {
  var hasSelectedIndex = _ref.hasSelectedIndex;
  return hasSelectedIndex ? 'top: -9px; font-size: 14px;' : 'top: 20px;';
});
var PrefixSpan = /*#__PURE__*/styled.span(_templateObject3$p || (_templateObject3$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    margin-right: px;\n"])));
var SelectedItem = /*#__PURE__*/styled.div(_templateObject4$n || (_templateObject4$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: ", ";\n    border-radius: 16px;\n    border: 2px solid;\n    cursor: pointer;\n    display: flex;\n    height: 56px;\n    overflow: hidden;\n    padding: 14px 50px 14px 16px;\n    transition: all 0.1s linear;\n\n    border-color: ", ";\n\n    ", ";\n\n    &:hover {\n        border-color: ", ";\n    }\n\n    &:focus {\n        border-color: ", ";\n\n        & + label {\n            color: ", ";\n        }\n    }\n\n    &:hover {\n        ", "\n        ", "\n\n        & + label {\n            ", "\n        }\n    }\n\n    &:focus {\n        ", "\n        ", "\n        & + label {\n            ", "\n            ", "\n        }\n    }\n\n    & + label {\n        color: ", ";\n    }\n"])), resetCSS, fonts.text, color.white, function (_ref2) {
  var state = _ref2.state;

  switch (state) {
    case 'error':
      return color.red;

    case 'confirmed':
      return color.green;

    case 'disabled':
      return color.greyDisabled;

    default:
      return color.greyLight;
  }
}, function (_ref3) {
  var state = _ref3.state;
  return state === 'disabled' && "& * {fill: " + color.greyDisabled + ";} color: " + color.greyDisabled + " !important;";
}, function (p) {
  return p.state !== 'disabled' && color.blueSky;
}, color.blue, color.blue, function (p) {
  return p.state === 'error' && "border-color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "border-color: " + color.green + ";";
}, function (p) {
  return !(p != null && p.state) && "color: " + color.blue + ";";
}, function (p) {
  return p.state === 'error' && "border-color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "border-color: " + color.green + ";";
}, function (p) {
  return p.state === 'error' && "color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "color: " + color.green + ";";
}, function (_ref4) {
  var state = _ref4.state;

  switch (state) {
    case 'error':
      return color.red;

    case 'confirmed':
      return color.green;

    case 'disabled':
      return color.greyDisabled;

    default:
      return color.grey;
  }
});
var iconStyle = /*#__PURE__*/css(_templateObject5$i || (_templateObject5$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-height: 24px;\n    max-width: 24px;\n    width: 100%;\n"])));
var PrefixIcon = /*#__PURE__*/styled.div(_templateObject6$e || (_templateObject6$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    margin-right: 8px;\n    & :first-child {\n        width: 100%;\n        height: 100%;\n    }\n"])), resetCSS, iconStyle);
var DropDownIcon = /*#__PURE__*/styled.div(_templateObject7$d || (_templateObject7$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    position: absolute;\n    right: 16px;\n"])), iconStyle);
var ErrorLabel = /*#__PURE__*/styled.label(_templateObject8$a || (_templateObject8$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    bottom: -23px;\n    color: ", ";\n    font-size: 12px;\n    height: 24px;\n    left: 16px;\n    pointer-events: none;\n    position: absolute;\n"])), resetCSS, fonts.text, color.red);
var Options = /*#__PURE__*/styled.div(_templateObject9$8 || (_templateObject9$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: ", ";\n    border-radius: 16px;\n    border: 2px solid ", ";\n    left: 0;\n    margin-top: 10px;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 10;\n    max-height: 265px;\n    overflow: auto;\n\n    &::-webkit-scrollbar {\n        background: none;\n        height: 0;\n        width: 20px;\n    }\n    &::-webkit-scrollbar-thumb {\n        background-clip: padding-box;\n        background-color: ", ";\n        border-radius: 30px;\n        border: 8px solid transparent;\n    }\n    &::-webkit-scrollbar-button {\n        display: none;\n    }\n    &::-webkit-scrollbar-corner {\n        background-color: transparent;\n    }\n"])), resetCSS, fonts.text, color.blueLight, color.blueSky, color.greyIcons);
var Option = /*#__PURE__*/styled.div(_templateObject10$5 || (_templateObject10$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    padding: 13px 20px;\n    &:hover {\n        background-color: rgba(128, 128, 128, 0.1);\n    }\n    &:first-child {\n        border-top-right-radius: 7px;\n        border-top-left-radius: 7px;\n    }\n    &:last-child {\n        border-bottom-right-radius: 7px;\n        border-bottom-left-radius: 7px;\n    }\n"])), resetCSS);
var NoDataTextStyled = /*#__PURE__*/styled.p(_templateObject11$4 || (_templateObject11$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    text-align: center;\n    margin-top: -12px;\n    margin-bottom: 5px;\n"])));
var SelectStyled = /*#__PURE__*/styled.select(_templateObject12$4 || (_templateObject12$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: transparent;\n    overflow: hidden;\n    transition: all 0.1s ease-out;\n    width: 100%;\n\n    &:focus,\n    .input_filled & {\n        + label {\n            font-size: 14px;\n            height: 18px;\n            line-height: 1;\n            padding: 2px 4px;\n            top: -13px;\n            left: 12px;\n        }\n    }\n"])), resetCSS, fonts.text);
var SelectStyles = {
  DivStyledWrapper: DivStyledWrapper,
  DropDownIcon: DropDownIcon,
  ErrorLabel: ErrorLabel,
  LabelStyled: LabelStyled$2,
  NoDataTextStyled: NoDataTextStyled,
  Option: Option,
  Options: Options,
  PrefixIcon: PrefixIcon,
  PrefixSpan: PrefixSpan,
  SelectedItem: SelectedItem,
  SelectStyled: SelectStyled
};

var DivStyledWrapper$1 = SelectStyles.DivStyledWrapper,
    DropDownIcon$1 = SelectStyles.DropDownIcon,
    ErrorLabel$1 = SelectStyles.ErrorLabel,
    LabelStyled$3 = SelectStyles.LabelStyled,
    NoDataTextStyled$1 = SelectStyles.NoDataTextStyled,
    Option$1 = SelectStyles.Option,
    Options$1 = SelectStyles.Options,
    PrefixIcon$1 = SelectStyles.PrefixIcon,
    PrefixSpan$1 = SelectStyles.PrefixSpan,
    SelectedItem$1 = SelectStyles.SelectedItem,
    SelectStyled$1 = SelectStyles.SelectStyled;

var Select = function Select(_ref) {
  var _ref$customNoDataText = _ref.customNoDataText,
      customNoDataText = _ref$customNoDataText === void 0 ? 'No Data' : _ref$customNoDataText,
      defaultOptionIndex = _ref.defaultOptionIndex,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Date.now()) : _ref$id,
      label = _ref.label,
      onChange = _ref.onChange,
      onChangeTraditional = _ref.onChangeTraditional,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      prefixText = _ref.prefixText,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? disabled ? 'disabled' : undefined : _ref$state,
      style = _ref.style,
      _ref$traditionalHTML = _ref.traditionalHTML5,
      traditionalHTML5 = _ref$traditionalHTML === void 0 ? false : _ref$traditionalHTML,
      validation = _ref.validation,
      value = _ref.value,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '200px' : _ref$width;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(defaultOptionIndex),
      selectedOptionIndex = _useState2[0],
      setSelectedOptionIndex = _useState2[1];

  var toggling = function toggling(event) {
    if (disabled) return;
    setIsOpen(!isOpen);
    event.stopPropagation();
  };

  var onOptionClicked = function onOptionClicked(selectedIndex) {
    return function () {
      setSelectedOptionIndex(selectedIndex);
      setIsOpen(false);

      if (onChange) {
        onChange(options[selectedIndex]);
      }
    };
  };

  useEffect(function () {
    var handleClickOutside = function handleClickOutside() {
      setIsOpen(false);
    };

    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  useEffect(function () {
    if (value) {
      var valueOptionItem = options.find(function (optionItem) {
        return optionItem.id == value;
      });
      setSelectedOptionIndex(valueOptionItem ? options.indexOf(valueOptionItem) : 0);
    }
  }, [selectedOptionIndex, value]);

  var renderFancySelectMode = function renderFancySelectMode() {
    var _options$selectedOpti, _options$selectedOpti2, _options$selectedOpti3;

    return React.createElement(DivStyledWrapper$1, {
      "aria-label": "select",
      "data-testid": "test-wrapper",
      id: id,
      state: state,
      style: _extends({}, style, {
        width: width
      })
    }, React.createElement(SelectedItem$1, {
      "data-testid": "test-selected",
      state: state,
      onClick: toggling,
      "aria-label": "option-selected"
    }, typeof selectedOptionIndex !== 'undefined' && React.createElement(React.Fragment, null, prefixText && React.createElement(PrefixSpan$1, null, prefixText), ((_options$selectedOpti = options[selectedOptionIndex]) == null ? void 0 : _options$selectedOpti.prefix) && React.createElement(PrefixIcon$1, null, (_options$selectedOpti2 = options[selectedOptionIndex]) == null ? void 0 : _options$selectedOpti2.prefix), (_options$selectedOpti3 = options[selectedOptionIndex]) == null ? void 0 : _options$selectedOpti3.label), React.createElement(DropDownIcon$1, null, React.createElement(Icon, {
      svg: isOpen ? iconTypes.triangleUp : iconTypes.triangleDown,
      fill: color.grey
    }))), label && React.createElement(LabelStyled$3, {
      "data-testid": "test-label",
      htmlFor: id,
      hasSelectedIndex: typeof selectedOptionIndex !== 'undefined'
    }, label), isOpen && React.createElement(Options$1, {
      "aria-label": "select-options",
      "data-testid": "test-options"
    }, options != null && options.length ? options.map(function (option, index) {
      return index !== selectedOptionIndex && React.createElement(Option$1, {
        onClick: onOptionClicked(index),
        key: option == null ? void 0 : option.label,
        "data-testid": "test-option",
        "aria-label": "select-option"
      }, React.createElement(PrefixIcon$1, null, option == null ? void 0 : option.prefix), option == null ? void 0 : option.label);
    }) : React.createElement(React.Fragment, null, React.createElement(Illustration, {
      logo: "servers",
      width: "100%",
      height: "60px"
    }), React.createElement(NoDataTextStyled$1, null, customNoDataText))), errorMessage && React.createElement(ErrorLabel$1, null, errorMessage));
  };

  var renderTraditionalSelect = function renderTraditionalSelect() {
    return React.createElement(DivWrapperStyled, {
      className: "input_filled",
      style: _extends({}, style, {
        width: width
      })
    }, React.createElement(SelectStyled$1, {
      defaultValue: "Please choose",
      id: id,
      onChange: function onChange(event) {
        return onChangeTraditional && onChangeTraditional(event);
      },
      required: validation == null ? void 0 : validation.required
    }, React.createElement("option", {
      disabled: true
    }, "Please choose"), options.map(function (option, index) {
      return index !== selectedOptionIndex && React.createElement("option", {
        key: option == null ? void 0 : option.id,
        id: String(option == null ? void 0 : option.id)
      }, option == null ? void 0 : option.label);
    })), label && React.createElement(LabelStyled, {
      hasPrefix: false,
      htmlFor: id
    }, label));
  };

  return traditionalHTML5 ? renderTraditionalSelect() : renderFancySelectMode();
};

var _templateObject$G, _templateObject2$t, _templateObject3$q;
var TextAreaWrapper = /*#__PURE__*/styled.div(_templateObject$G || (_templateObject$G = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background-color: ", ";\n    border-radius: 16px;\n    border: 1px solid ", ";\n    display: inline-block;\n    max-width: 100%;\n    padding: 12px;\n    position: relative;\n    transition: all 0.1s linear;\n    width: ", ";\n\n    &:hover {\n        border-color: ", ";\n    }\n\n    &:focus {\n        border-color: ", ";\n\n        + label {\n            color: ", ";\n        }\n    }\n\n    ", "\n    ", "\n\n    &:hover {\n        ", "\n        ", "\n\n        label {\n            ", "\n        }\n    }\n\n    &:focus {\n        ", "\n        ", "\n        & + label {\n            ", "\n            ", "\n        }\n    }\n\n    textarea {\n        & + label {\n            ", "\n            ", "\n        }\n    }\n"])), resetCSS, color.white, color.greyLight, function (p) {
  return p.width ? p.width : '294px';
}, function (p) {
  return p.state === 'disabled' ? color.greyLight : color.blue;
}, color.blue, color.blue, function (p) {
  return p.state === 'error' && "border-color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "border-color: " + color.green + ";";
}, function (p) {
  return p.state === 'error' && "border-color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "border-color: " + color.green + ";";
}, function (p) {
  return p.state !== 'error' && p.state !== 'confirmed' && p.state !== 'disabled' && "color: " + color.blue + ";";
}, function (p) {
  return p.state === 'error' && "border-color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "border-color: " + color.green + ";";
}, function (p) {
  return p.state === 'error' && "color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "color: " + color.green + ";";
}, function (p) {
  return p.state === 'error' && "color: " + color.red + ";";
}, function (p) {
  return p.state === 'confirmed' && "color: " + color.green + ";";
});
var LabelStyled$4 = /*#__PURE__*/styled.label(_templateObject2$t || (_templateObject2$t = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: ", ";\n    height: 24px;\n    left: 12px;\n    padding: 0 4px;\n    pointer-events: none;\n    position: absolute;\n    top: 14px;\n    transition: all 0.1s ease-out;\n"])), resetCSS, fonts.text, color.white);
var TextAreaStyled$2 = /*#__PURE__*/styled.textarea(_templateObject3$q || (_templateObject3$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    background-color: transparent;\n    display: block;\n    max-width: 100%;\n    min-height: 128px;\n    overflow: hidden;\n    padding: 2px;\n    width: 100%;\n\n    ::-webkit-resizer {\n        visibility: hidden;\n    }\n\n    &::placeholder {\n        visibility: hidden;\n        display: none;\n    }\n\n    &:focus,\n    .filled & {\n        + label {\n            font-size: 14px;\n            height: 18px;\n            line-height: 1;\n            padding: 2px 4px;\n            top: -10px;\n        }\n    }\n\n    &:focus {\n        &::placeholder {\n            display: none;\n            visibility: visible;\n            color: ", ";\n        }\n    }\n"])), resetCSS, fonts.text, color.grey);
var TextAreaStyles = {
  TextAreaStyled: TextAreaStyled$2,
  LabelStyled: LabelStyled$4,
  TextAreaWrapper: TextAreaWrapper
};

var TextAreaStyled$3 = TextAreaStyles.TextAreaStyled,
    LabelStyled$5 = TextAreaStyles.LabelStyled,
    TextAreaWrapper$1 = TextAreaStyles.TextAreaWrapper;

var TextArea = function TextArea(_ref) {
  var _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? true : _ref$autoComplete,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Date.now()) : _ref$id,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      state = _ref.state,
      validation = _ref.validation,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '300px' : _ref$width;

  var _useState = useState(value),
      currentValue = _useState[0],
      setCurrentValue = _useState[1];

  var textareaRef = useRef(null);

  var valueChanged = function valueChanged(event) {
    setCurrentValue(event.target.value);
    onChange && onChange(event);
  };

  useEffect(function () {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = '0px';
      var scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + 'px';
    }
  }, [currentValue]);
  return React.createElement(TextAreaWrapper$1, {
    className: currentValue.length > 0 ? 'filled' : 'empty',
    "data-testid": "test-textarea-wrapper",
    state: state,
    width: width
  }, React.createElement(Icon, {
    svg: iconTypes.expand,
    style: {
      position: 'absolute',
      bottom: '10px',
      right: '10px',
      zIndex: '-1'
    },
    fill: color.blue
  }), React.createElement(TextAreaStyled$3, {
    autoComplete: "" + autoComplete,
    "data-testid": "test-textarea",
    disabled: state === 'disabled',
    id: id,
    maxLength: validation == null ? void 0 : validation.characterMaxLength,
    minLength: validation == null ? void 0 : validation.characterMinLength,
    name: name,
    onChange: function onChange(event) {
      return valueChanged(event);
    },
    placeholder: placeholder,
    ref: textareaRef,
    required: validation == null ? void 0 : validation.required,
    rows: 4,
    value: currentValue
  }), label && React.createElement(LabelStyled$5, {
    "data-testid": "test-label",
    htmlFor: id
  }, label));
};

var _templateObject$H, _templateObject2$u, _templateObject3$r;
var H3Styled = /*#__PURE__*/styled.h3(_templateObject$H || (_templateObject$H = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", ";\n    margin-bottom: 18px;\n"])), resetCSS, fonts.heading, fonts.h3);
var H4Styled$2 = /*#__PURE__*/styled.h4(_templateObject2$u || (_templateObject2$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", ";\n    margin-bottom: 12px;\n    margin-top: 32px;\n"])), resetCSS, fonts.heading, fonts.h4);
var FormStyled = /*#__PURE__*/styled.form(_templateObject3$r || (_templateObject3$r = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background-color: ", ";\n    border-radius: 16px;\n    padding: 16px;\n\n    .form-item + .form-item {\n        margin-top: 30px;\n    }\n\n    > button[type='submit'],\n    .customFooter {\n        margin-top: 32px;\n    }\n"])), resetCSS, color.white);

var Form = function Form(_ref) {
  var buttonConfig = _ref.buttonConfig,
      data = _ref.data,
      id = _ref.id,
      onSubmit = _ref.onSubmit,
      title = _ref.title,
      customFooter = _ref.customFooter,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;

  var formSubmitted = function formSubmitted(event) {
    event.preventDefault();
    event.stopPropagation();
    var form = event.target;

    if (form.checkValidity()) {
      var dataReturned = data.map(function (item) {
        return {
          inputName: item.name,
          inputResult: item.selectedCard || item.selected || item.value,
          key: item.key
        };
      });
      onSubmit && onSubmit({
        id: id,
        data: dataReturned
      });
    } else {
      form.reportValidity();
    }
  };

  var optionAdded = function optionAdded(elementIndex, opt, isRadio) {
    if (isRadio) {
      // @ts-ignore:next-line
      var selectRadioValue = data[elementIndex].options[Number(opt)];

      if (typeof selectRadioValue === 'string') {
        data[elementIndex].selected = [selectRadioValue];
      } else {
        data[elementIndex].selectedCard = selectRadioValue;
      }

      return;
    }

    if (!data[elementIndex].selected) {
      data[elementIndex].selected = [String(opt)];
    } else {
      var _data$elementIndex, _data$elementIndex$se;

      (_data$elementIndex = data[elementIndex]) == null ? void 0 : (_data$elementIndex$se = _data$elementIndex.selected) == null ? void 0 : _data$elementIndex$se.push(String(opt));
    }
  };

  var optionToggled = function optionToggled(event, elementIndex, opt) {
    var isRadio = Boolean(event.target.type === 'radio');

    if (event.target.checked) {
      optionAdded(elementIndex, opt, isRadio);
    } else {
      var _data$elementIndex2, _data$elementIndex2$s;

      var filtered = (_data$elementIndex2 = data[elementIndex]) == null ? void 0 : (_data$elementIndex2$s = _data$elementIndex2.selected) == null ? void 0 : _data$elementIndex2$s.filter(function (item) {
        return item !== opt;
      });
      data[elementIndex].selected = filtered;
    }
  };

  var renderDatePicker = function renderDatePicker(input, type, index) {
    var _input$validation;

    return React.createElement(DatePicker, {
      id: type + "_" + index,
      label: input.name,
      onChange: function onChange(e) {
        return data[index].selected = [String(e.date)];
      },
      validation: {
        required: (_input$validation = input.validation) == null ? void 0 : _input$validation.required
      },
      disabled: isDisabled
    });
  };

  var renderInput = function renderInput(input, type, index) {
    var _input$validation2, _input$validation3, _input$validation4, _input$validation5, _input$validation6, _input$validation7, _input$validation8;

    return React.createElement(Input, {
      key: "input_" + index,
      id: "input_" + index,
      value: input.value,
      label: input.name,
      name: input.name,
      onChange: function onChange(e) {
        return data[index].value = e.target.value;
      },
      type: type,
      width: input.inputWidth,
      disabled: isDisabled,
      validation: {
        characterMaxLength: (_input$validation2 = input.validation) == null ? void 0 : _input$validation2.characterMaxLength,
        characterMinLength: (_input$validation3 = input.validation) == null ? void 0 : _input$validation3.characterMinLength,
        numberMax: (_input$validation4 = input.validation) == null ? void 0 : _input$validation4.numberMax,
        numberMin: (_input$validation5 = input.validation) == null ? void 0 : _input$validation5.numberMin,
        regExp: (_input$validation6 = input.validation) == null ? void 0 : _input$validation6.regExp,
        regExpInvalidMessage: (_input$validation7 = input.validation) == null ? void 0 : _input$validation7.regExpInvalidMessage,
        required: (_input$validation8 = input.validation) == null ? void 0 : _input$validation8.required
      }
    });
  };

  var renderCheckbox = function renderCheckbox(input, layout, index) {
    return React.createElement(Fragment, {
      key: "cb-group_" + index
    }, React.createElement(H4Styled$2, null, input.value), (input.options || []).map(function (opt, i) {
      var _input$validation9;

      return React.createElement(Checkbox, {
        key: "cb_" + index + "-" + i,
        label: String(opt),
        layout: layout,
        name: input.name,
        onChange: function onChange(e) {
          return optionToggled(e, index, String(opt));
        },
        validation: {
          required: (_input$validation9 = input.validation) == null ? void 0 : _input$validation9.required
        },
        disabled: isDisabled
      });
    }));
  };

  var renderRadioGroup = function renderRadioGroup(input, index) {
    var _input$validation10;

    return React.createElement(Fragment, {
      key: input.name + "_" + index
    }, React.createElement(H4Styled$2, null, input.value), React.createElement(Radios, {
      id: input.name + "_" + index,
      items: input.options || [],
      onChange: function onChange(e) {
        return optionToggled(e, index, e.target.value);
      },
      validation: {
        required: (_input$validation10 = input.validation) == null ? void 0 : _input$validation10.required
      },
      disabled: isDisabled
    }));
  };

  var renderTextArea = function renderTextArea(input, index) {
    var _input$validation11, _input$validation12, _input$validation13;

    return React.createElement(Fragment, {
      key: input.name + "_" + index
    }, React.createElement(H4Styled$2, null, input.value), React.createElement(TextArea, {
      id: "textarea_" + index,
      name: input.name,
      onChange: function onChange(e) {
        return data[index].value = e.target.value;
      },
      value: input.value,
      width: input.inputWidth,
      state: isDisabled ? 'disabled' : undefined,
      validation: {
        characterMaxLength: (_input$validation11 = input.validation) == null ? void 0 : _input$validation11.characterMaxLength,
        characterMinLength: (_input$validation12 = input.validation) == null ? void 0 : _input$validation12.characterMinLength,
        required: (_input$validation13 = input.validation) == null ? void 0 : _input$validation13.required
      }
    }));
  };

  var renderSelect = function renderSelect(input, type, index) {
    var _input$validation14;

    return React.createElement(Select, {
      id: input.name + "_" + index,
      label: input.name,
      onChangeTraditional: function onChangeTraditional(e) {
        return data[index].value = e.target.value;
      },
      options: input.selectOptions,
      traditionalHTML5: type === 'traditional',
      validation: {
        required: Boolean((_input$validation14 = input.validation) == null ? void 0 : _input$validation14.required)
      },
      width: input.inputWidth,
      disabled: isDisabled
    });
  };

  var renderInputType = function renderInputType(input, index) {
    switch (input.type) {
      case 'text':
        return renderInput(input, 'text', index);

      case 'tel':
        return renderInput(input, 'tel', index);

      case 'password':
        return renderInput(input, 'password', index);

      case 'email':
        return renderInput(input, 'email', index);

      case 'number':
        return renderInput(input, 'number', index);

      case 'box':
        return renderCheckbox(input, 'box', index);

      case 'switch':
        return renderCheckbox(input, 'switch', index);

      case 'radios':
        return renderRadioGroup(input, index);

      case 'select':
        return renderSelect(input, 'traditional', index);

      case 'textarea':
        return renderTextArea(input, index);

      case 'date':
        return renderDatePicker(input, 'date', index);

      default:
        return;
    }
  };

  return React.createElement(FormStyled, {
    onSubmit: formSubmitted,
    id: id,
    "data-testid": "test-form"
  }, title && React.createElement(H3Styled, {
    "data-testid": "test-form-title"
  }, title), data.map(function (input, i) {
    return React.createElement("div", {
      className: "form-item",
      "data-testclass": "form-ele",
      "data-testid": "form-ele-" + i,
      key: "form-ele-" + i
    }, renderInputType(input, i));
  }), customFooter ? React.createElement("div", {
    className: "customFooter"
  }, customFooter) : React.createElement(Button, Object.assign({}, buttonConfig, {
    id: "form-submit",
    type: "submit",
    disabled: isDisabled
  }), "Submit"));
};

var _templateObject$I, _templateObject2$v;
var Position;

(function (Position) {
  Position["left"] = "flex-start";
  Position["right"] = "flex-end";
  Position["center"] = "center";
})(Position || (Position = {}));

var SectionStyled$1 = /*#__PURE__*/styled.section(_templateObject$I || (_templateObject$I = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n\n    align-items: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    background-image: ", ";\n    height: ", ";\n    max-height: ", ";\n\n    h1 {\n        padding: 0px 40px;\n    }\n\n    > span {\n        padding: 20px 40px 0px;\n    }\n"])), function (_ref) {
  var _Position;

  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align;
  return ((_Position = Position) == null ? void 0 : _Position[align]) || Position.center;
}, function (p) {
  return p.rounded || '0px';
}, function (p) {
  return p.backgroundColor;
}, function (_ref2) {
  var backgroundURL = _ref2.backgroundURL,
      _ref2$linearGradient = _ref2.linearGradient,
      linearGradient = _ref2$linearGradient === void 0 ? '' : _ref2$linearGradient;
  return backgroundURL ? (linearGradient && linearGradient + ', ') + " url(" + backgroundURL + ")" : linearGradient;
}, function (_ref3) {
  var height = _ref3.height;
  return height || '80vh';
}, function (_ref4) {
  var height = _ref4.height;
  return height || '80vh';
});
var DivStyled$7 = /*#__PURE__*/styled.div(_templateObject2$v || (_templateObject2$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: 20px 40px 0px;\n"])));

var Hero = function Hero(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "" + color.greyLight : _ref$backgroundColor,
      backgroundURL = _ref.backgroundURL,
      children = _ref.children,
      _ref$customImage = _ref.customImage,
      customImage = _ref$customImage === void 0 ? null : _ref$customImage,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '80vh' : _ref$height,
      linearGradient = _ref.linearGradient,
      rounded = _ref.rounded,
      subTitle = _ref.subTitle,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? "" + color.greyDark : _ref$textColor,
      title = _ref.title;
  return React.createElement(SectionStyled$1, {
    backgroundColor: backgroundColor,
    linearGradient: linearGradient,
    backgroundURL: backgroundURL,
    "data-testid": "test-hero",
    height: height,
    rounded: rounded,
    align: align
  }, React.createElement(Typography, {
    color: textColor,
    "data-testid": "test-hero_title",
    variant: "h1"
  }, title), subTitle && React.createElement(Typography, {
    color: textColor,
    "data-testid": "test-hero_text",
    variant: "body16",
    weight: "regular"
  }, React.createElement("strong", null, subTitle)), (customImage == null ? void 0 : customImage.url) && React.createElement("img", {
    src: customImage.url,
    alt: 'Hero-image',
    style: customImage == null ? void 0 : customImage.styles
  }), children && React.createElement(DivStyled$7, {
    "data-testid": "test-hero_child"
  }, children));
};

var _templateObject$J, _templateObject2$w, _templateObject3$s;
var DivStyled$8 = /*#__PURE__*/styled.div(_templateObject$J || (_templateObject$J = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", ";\n    background-color: ", ";\n    border-radius: 16px;\n    border: 2px solid ", ";\n    display: grid;\n    grid-gap: 5px;\n    margin: 0;\n    padding: 16px;\n    width: 100%;\n"])), resetCSS, fonts.text, fonts.textBold, color.white, color.blueSkyLight);
var PStyledTopic = /*#__PURE__*/styled.p(_templateObject2$w || (_templateObject2$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    color: ", ";\n    margin: 0;\n"])), color.blue);
var PStyledInfo = /*#__PURE__*/styled.p(_templateObject3$s || (_templateObject3$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    color: ", ";\n    font-size: 24px;\n    margin: 0;\n"])), color.blueDark);

var Info = function Info(_ref) {
  var id = _ref.id,
      information = _ref.information,
      topic = _ref.topic;
  return React.createElement(DivStyled$8, {
    id: id,
    "data-testid": 'card-test-id'
  }, React.createElement(PStyledTopic, {
    "data-testid": 'topic-test-id'
  }, topic), React.createElement(PStyledInfo, {
    "data-testid": 'info-test-id'
  }, information));
};

var _templateObject$K, _templateObject2$x;
var LinkStyled = /*#__PURE__*/styled.a(_templateObject$K || (_templateObject$K = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    align-items: center;\n    color: ", ";\n    display: inline-block;\n    font-weight: 600;\n    width: fit-content;\n\n    &:hover {\n        filter: brightness(0.7);\n    }\n"])), resetCSS, fonts.text, color.blue);
var FlexSpanStyled = /*#__PURE__*/styled.span(_templateObject2$x || (_templateObject2$x = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: baseline;\n    display: flex;\n    flex-direction: ", ";\n    margin: ", ";\n\n    svg {\n        margin: ", ";\n    }\n"])), function (_ref) {
  var iconLayout = _ref.iconLayout;
  return iconLayout === 'leading' ? 'row' : 'row-reverse';
}, function (p) {
  return p.iconLayout === 'leading' ? '0 2px 0 4px' : '0 4px 0 2px';
}, function (p) {
  return p.iconLayout === 'leading' ? '0 4px 0 0' : '0 0 0 4px';
});

var LinkTo = function LinkTo(_ref) {
  var address = _ref.address,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'external' : _ref$type,
      _ref$iconLayout = _ref.iconLayout,
      iconLayout = _ref$iconLayout === void 0 ? 'leading' : _ref$iconLayout;
  return React.createElement(LinkStyled, {
    "data-testid": "test-link-to",
    href: "" + (type === 'email' ? 'mailto:' : '') + address,
    target: "" + (type === 'email' ? '_self' : '_blank')
  }, React.createElement(FlexSpanStyled, {
    iconLayout: iconLayout,
    "data-testid": "test-link-flex"
  }, React.createElement(Icon, {
    svg: type === 'email' ? iconTypes.mail : iconTypes.link,
    fill: color.blue,
    size: 14
  }), React.createElement("span", {
    "data-testid": "test-link-text"
  }, text || address)));
};

var _templateObject$L, _templateObject2$y, _templateObject3$t, _templateObject4$o, _templateObject5$j, _templateObject6$f;

var overflow = function overflow() {
  return "\n            overflow: auto;\n            ::-webkit-scrollbar {\n                display: none;\n            }\n            scrollbar-width: none;\n            -ms-overflow-style: none;\n        ";
};

var DivStyledWrap = /*#__PURE__*/styled.div(_templateObject$L || (_templateObject$L = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background-color: ", ";\n    border-radius: 20px;\n    box-shadow: 0 4px 10px rgba(48, 71, 105, 0.1);\n    left: 50%;\n    max-height: 100%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: ", ";\n    ", "\n"])), fonts.text, color.white, function (p) {
  return p.width;
}, function (p) {
  return !p.canOverflow && overflow();
});
var HeaderStyled$8 = /*#__PURE__*/styled.header(_templateObject2$y || (_templateObject2$y = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    align-items: center;\n    display: flex;\n    padding: 28px 32px 24px;\n    justify-content: ", ";\n    border-bottom: ", ";\n    \n    div {\n        border-color: ", ";\n        border-radius: 15px;\n    }\n\n    h3 {\n        color: ", ";\n        padding-right: 8px;\n        margin-block-start: 0;\n        margin-block-end: 0;\n    }\n\n    button {\n        min-width: 30px;\n    }\n"])), function (p) {
  return p.fixedMode && 'position: sticky;top: 0;background-color: white;';
}, function (p) {
  return p.title ? 'space-between' : 'flex-end';
}, function (p) {
  return p.headerHasBottomBorder ? "1px solid " + color.paleBlue2 : undefined;
}, color.blue, color.blue);
var DivStyledContent$1 = /*#__PURE__*/styled.div(_templateObject3$t || (_templateObject3$t = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: 5px 32px 15px;\n"])));
var FooterStyled$2 = /*#__PURE__*/styled.footer(_templateObject4$o || (_templateObject4$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    border-top: 1px solid ", ";\n    display: flex;\n    padding: 15px 32px 20px;\n    justify-content: ", ";\n"])), function (p) {
  return p.fixedMode && 'position: sticky;bottom: 0;background-color: white;';
}, color.paleBlue2, function (p) {
  return p.hasCancel ? 'space-between' : 'flex-end';
});
var DivStyled$9 = /*#__PURE__*/styled.div(_templateObject5$j || (_templateObject5$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background: rgba(0, 0, 0, 0.3);\n    bottom: 0;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 5;\n"])), function (p) {
  return p.isVisible ? 'display: grid;' : 'display: none;';
});
var CustomFooterStyled = /*#__PURE__*/styled.footer(_templateObject6$f || (_templateObject6$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    border-top: 1px solid ", ";\n    display: flex;\n    padding: 15px 32px 20px;\n"])), function (p) {
  return p.fixedMode && 'position: sticky;bottom: 0;background-color: white;';
}, color.paleBlue2);

var Modal = function Modal(_ref) {
  var _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      children = _ref.children,
      _ref$headerHasBottomB = _ref.headerHasBottomBorder,
      headerHasBottomBorder = _ref$headerHasBottomB === void 0 ? false : _ref$headerHasBottomB,
      _ref$fixedMode = _ref.fixedMode,
      fixedMode = _ref$fixedMode === void 0 ? false : _ref$fixedMode,
      _ref$hasCancel = _ref.hasCancel,
      hasCancel = _ref$hasCancel === void 0 ? true : _ref$hasCancel,
      _ref$hasFooter = _ref.hasFooter,
      hasFooter = _ref$hasFooter === void 0 ? true : _ref$hasFooter,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? String(Date.now()) : _ref$id,
      isCancelDisabled = _ref.isCancelDisabled,
      isOkDisabled = _ref.isOkDisabled,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
      _ref$okText = _ref.okText,
      okText = _ref$okText === void 0 ? 'Ok' : _ref$okText,
      okButtonColor = _ref.okButtonColor,
      onCancel = _ref.onCancel,
      onCloseButtonPressed = _ref.onCloseButtonPressed,
      onOk = _ref.onOk,
      title = _ref.title,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '70vw' : _ref$width,
      customFooter = _ref.customFooter,
      closeButton = _ref.closeButton,
      _ref$canOverflow = _ref.canOverflow,
      canOverflow = _ref$canOverflow === void 0 ? false : _ref$canOverflow;

  var _useState = useState(isVisible),
      visible = _useState[0],
      setVisible = _useState[1];

  useEffect(function () {
    document.addEventListener('click', handleContentClick);
    return function () {
      return document.removeEventListener('click', handleContentClick);
    };
  }, []);

  var handleContentClick = function handleContentClick(event) {
    var target = event.target;
    if (target.id === 'close') toggleVisibility();
  };

  useEffect(function () {
    setVisible(isVisible);
  }, [isVisible]);

  var toggleVisibility = function toggleVisibility() {
    setVisible(!visible);
  };

  return React.createElement(DivStyled$9, {
    id: id,
    isVisible: visible,
    "data-testid": "modal-test-id"
  }, React.createElement(DivStyledWrap, {
    width: width,
    canOverflow: canOverflow
  }, React.createElement(HeaderStyled$8, {
    "data-testid": 'modal-header-test-id',
    title: title,
    fixedMode: fixedMode,
    headerHasBottomBorder: headerHasBottomBorder
  }, typeof title == 'string' ? React.createElement("h3", null, title) : title, closeButton ? closeButton : React.createElement(Button, {
    iconColor: '#68738D',
    theme: 'secondary',
    radius: 40,
    id: 'close',
    "data-testid": 'modal-close-test-id',
    icon: iconTypes.x,
    iconLayout: 'icon-only',
    onClick: onCloseButtonPressed ? onCloseButtonPressed : toggleVisibility
  })), React.createElement(DivStyledContent$1, {
    id: 'content',
    "data-testid": 'modal-content-test-id'
  }, children), hasFooter && !customFooter && React.createElement(FooterStyled$2, {
    "data-testid": 'modal-footer-test-id',
    hasCancel: hasCancel,
    fixedMode: fixedMode
  }, hasCancel && React.createElement(Button, {
    "data-testid": 'modal-cancel-button-test-id',
    disabled: isCancelDisabled,
    text: cancelText,
    onClick: onCancel ? onCancel : function () {},
    theme: 'outline'
  }), React.createElement(Button, {
    color: okButtonColor,
    "data-testid": 'modal-ok-button-test-id',
    disabled: isOkDisabled,
    onClick: onOk ? onOk : function () {},
    text: okText,
    theme: okButtonColor ? 'colored' : 'primary'
  })), customFooter && React.createElement(CustomFooterStyled, {
    fixedMode: fixedMode
  }, customFooter)));
};

var _templateObject$M, _templateObject2$z, _templateObject3$u, _templateObject4$p, _templateObject5$k, _templateObject6$g;
var DivStyled$a = /*#__PURE__*/styled.div(_templateObject$M || (_templateObject$M = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    margin: auto;\n"])), resetCSS);
var DivStyledCardContainer = /*#__PURE__*/styled.div(_templateObject2$z || (_templateObject2$z = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background: ", ";\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    margin: auto;\n    width: 90%;\n    @media only screen and (max-width: 600px) {\n        width: 80%;\n    }\n"])), resetCSS, color.white);
DivStyledCardContainer.displayName = 'NftCollectionCard';
var DivStyledCardContent = /*#__PURE__*/styled.div(_templateObject3$u || (_templateObject3$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    gap: 20px;\n    justify-content: space-between;\n    margin: 4px 0;\n    padding: 0px 10px;\n    a {\n        text-decoration: none;\n    }\n    a:hover > span {\n        color: ", ";\n    }\n    #name {\n        word-break: break-all;\n    }\n"])), color.blue);
var DivStyledCardFooter = /*#__PURE__*/styled.div(_templateObject4$p || (_templateObject4$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 0 0 20px 20px;\n    border-top: 2px solid;\n    display: flex;\n    height: fit-content;\n    margin-top: auto;\n    padding: 10px;\n"])));
var SpanStyled$2 = /*#__PURE__*/styled.span(_templateObject5$k || (_templateObject5$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background-color: ", ";\n    background-size: cover;\n    background-position: center;\n    border-radius: 20px 20px 0 0;\n    height: 300px;\n    max-width: 100%;\n"])), resetCSS, color.greyDisabled);
SpanStyled$2.displayName = 'SpanStyled';
var SectionStyled$2 = /*#__PURE__*/styled.section(_templateObject6$g || (_templateObject6$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    display: block;\n"])), resetCSS);
SectionStyled$2.displayName = 'NftCollection';

var _templateObject$N, _templateObject2$A;
var RowDiv = /*#__PURE__*/styled.div(_templateObject$N || (_templateObject$N = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    display: flex;\n    flex-wrap: wrap;\n    width: ", ";\n    gap: ", ";\n    margin-left: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n"])), fonts.text, function (props) {
  return (props.width && props.width + "px") + " ";
}, function (props) {
  return props.rowGap ? props.rowGap + "px " + props.colGap + "px" : '15px 15px';
}, function (props) {
  return props.colGap && props.colGap / 2 + "px";
}, function (props) {
  return props.alignItems && props.alignItems;
}, function (props) {
  return props.justifyItems && props.justifyItems;
});

var getConfig = function getConfig(breakPointConfig, toGet, span) {
  if (Object.keys(breakPointConfig).includes(toGet)) {
    return breakPointConfig[toGet];
  }

  return span;
};

var ColDiv = /*#__PURE__*/styled.div(_templateObject2$A || (_templateObject2$A = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    color: white;\n    order: ", ";\n    ", "\n    // xSmall devices (landscape phones, 576px and up)\n        @media (max-width: 767px) {\n        flex: ", ";\n\n        max-width: ", ";\n        ", "\n    }\n\n    // sm devices (tablets, 768px and up)\n    @media (min-width: 768px) and (max-width: 991px) {\n        color: black;\n        flex: ", ";\n\n        max-width: ", ";\n        ", "\n    }\n\n    // Meduim(desktops, 992px and up)\n    @media (min-width: 992px) and (max-width: 1199px) {\n        flex: ", ";\n\n        max-width: ", ";\n        ", "\n    }\n\n    // large devices (large desktops, 1200px and up)\n    @media (min-width: 1200px) {\n        flex: ", ";\n\n        max-width: ", ";\n\n        ", "\n    }\n"])), function (props) {
  return props.order;
}, fonts.text, function (props) {
  return props.span ? 100 / (props.xs ? props.xs : 0) * getConfig(props.breakpointsConfig, 'xs', props.span) + "%" : '100%';
}, function (props) {
  return props.span ? "calc(" + 100 / (props.xs ? props.xs : 0) * getConfig(props.breakpointsConfig, 'xs', props.span) + "% - " + props.colGap + "px)" : '100%';
}, function (props) {
  return props.isFullWidth && "max-width: 100%; flex: 100%;";
}, function (props) {
  return props.span ? 100 / (props.sm ? props.sm : 0) * getConfig(props.breakpointsConfig, 'sm', props.span) + "%" : '100%';
}, function (props) {
  return props.span ? "calc(" + 100 / (props.sm ? props.sm : 0) * getConfig(props.breakpointsConfig, 'sm', props.span) + "% - " + props.colGap + "px)" : '100%';
}, function (props) {
  return props.isFullWidth && "max-width: 100%; flex: 100%;";
}, function (props) {
  return props.span ? getConfig(props.breakpointsConfig, 'md', props.span) * (100 / (props.md ? props.md : 0)) + "%" : '100%';
}, function (props) {
  return props.span ? "calc(" + 100 / (props.md ? props.md : 0) * getConfig(props.breakpointsConfig, 'md', props.span) + "% - " + props.colGap + "px)" : '100%';
}, function (props) {
  return props.isFullWidth && "max-width: 100%; flex: 100%;";
}, function (props) {
  return props.span ? 100 / (props.lg ? props.lg : 0) * getConfig(props.breakpointsConfig, 'lg', props.span) + "%" : '90%';
}, function (props) {
  return props.span ? "calc(" + 100 / (props.lg ? props.lg : 0) * getConfig(props.breakpointsConfig, 'lg', props.span) + "% - " + props.colGap + "px )" : '90%';
}, function (props) {
  return props.isFullWidth && "max-width: 100%; flex: 100%;";
});

var Context = /*#__PURE__*/createContext({
  lg: 0,
  md: 0,
  sm: 0,
  xs: 0,
  rowGap: 15,
  colGap: 15
});
function Col(_ref) {
  var children = _ref.children,
      _ref$span = _ref.span,
      span = _ref$span === void 0 ? 0 : _ref$span,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      _ref$breakpointsConfi = _ref.breakpointsConfig,
      breakpointsConfig = _ref$breakpointsConfi === void 0 ? {} : _ref$breakpointsConfi,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order;
  var prov = useContext(Context);
  return React.createElement(ColDiv, {
    isFullWidth: isFullWidth,
    order: order,
    span: span,
    lg: prov.lg,
    md: prov.md,
    sm: prov.sm,
    xs: prov.xs,
    rowGap: prov.rowGap,
    colGap: prov.colGap,
    breakpointsConfig: breakpointsConfig,
    role: "col"
  }, children);
}

function Row(_ref2) {
  var _ref2$alignItems = _ref2.alignItems,
      alignItems = _ref2$alignItems === void 0 ? 'start' : _ref2$alignItems,
      _ref2$justifyItems = _ref2.justifyItems,
      justifyItems = _ref2$justifyItems === void 0 ? 'flex-start' : _ref2$justifyItems,
      _ref2$colGap = _ref2.colGap,
      colGap = _ref2$colGap === void 0 ? 15 : _ref2$colGap,
      _ref2$rowGap = _ref2.rowGap,
      rowGap = _ref2$rowGap === void 0 ? 15 : _ref2$rowGap,
      children = _ref2.children,
      _ref2$xs = _ref2.xs,
      xs = _ref2$xs === void 0 ? 8 : _ref2$xs,
      _ref2$sm = _ref2.sm,
      sm = _ref2$sm === void 0 ? 16 : _ref2$sm,
      _ref2$md = _ref2.md,
      md = _ref2$md === void 0 ? 24 : _ref2$md,
      _ref2$lg = _ref2.lg,
      lg = _ref2$lg === void 0 ? 24 : _ref2$lg,
      width = _ref2.width;
  return React.createElement(Context.Provider, {
    value: {
      xs: xs,
      md: md,
      sm: sm,
      lg: lg,
      rowGap: rowGap,
      colGap: colGap
    }
  }, React.createElement(RowDiv, {
    alignItems: alignItems,
    justifyItems: justifyItems,
    colGap: colGap,
    rowGap: rowGap,
    "data-testid": "row",
    width: width
  }, children));
}

Row.Col = Col;

var _templateObject$O;

var DivStyled$b = /*#__PURE__*/styled.div(_templateObject$O || (_templateObject$O = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    animation: progress 1.5s linear infinite;\n    background: ", " no-repeat;\n    background-image: ", ";\n    background-size: 200px 100%;\n    box-sizing: border-box;\n    display: inline-block;\n    flex-shrink: 0;\n    outline: none;\n    overflow: hidden;\n    position: relative;\n    border-radius: ", ";\n    height: ", ";\n    width: ", ";\n    &:after,\n    &:before {\n        box-sizing: border-box;\n    }\n    @keyframes progress {\n        0% {\n            background-position: -300px 0;\n        }\n        100% {\n            background-position: calc(300px + 100%) 0;\n        }\n    }\n"])), resetCSS, color.white, gradientColors.lightGrey, function (_ref) {
  var borderRadius = _ref.borderRadius;
  return borderRadius;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
}, function (_ref3) {
  var width = _ref3.width;
  return width;
});

var getDefault = function getDefault(theme) {
  switch (theme) {
    case 'image':
      return {
        width: '60px',
        height: '60px'
      };

    case 'subtitle':
      return {
        width: '100%',
        height: '10px'
      };

    case 'text':
      return {
        width: '100%',
        height: '20px'
      };

    default:
      return {
        width: '100%',
        height: '20px'
      };
  }
};

var Skeleton = function Skeleton(_ref) {
  var _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? '10px' : _ref$borderRadius,
      theme = _ref.theme,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? getDefault(theme).height : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? getDefault(theme).width : _ref$width;
  return React.createElement(DivStyled$b, {
    borderRadius: borderRadius,
    "data-testid": "test-skeleton-id",
    height: height,
    theme: theme,
    width: width
  });
};

var _templateObject$P, _templateObject2$B, _templateObject3$v, _templateObject4$q, _templateObject5$l, _templateObject6$h, _templateObject7$e, _templateObject8$b;
var arrowSize = '10px';

var getContainerStyleByPosition = function getContainerStyleByPosition(position) {
  switch (position) {
    case 'top':
      return top;

    case 'bottom':
      return bottom;

    case 'left':
      return left;

    case 'right':
      return right;
  }
};

var bottom = /*#__PURE__*/css(_templateObject$P || (_templateObject$P = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    bottom: -0.25rem;\n    left: 50%;\n    position: absolute;\n    transform: translateX(", ") translateY(100%);\n    &:after {\n        position: absolute;\n        content: '';\n        bottom: 100%;\n        transform: translateX(", ") translateY(0%);\n        border: ", " solid transparent;\n        border-bottom-color: ", ";\n    }\n"])), color.blueDark, function (p) {
  return p.moveBody + "%";
}, function (p) {
  return p.move + "%";
}, arrowSize, color.blueDark);
var left = /*#__PURE__*/css(_templateObject2$B || (_templateObject2$B = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    left: -0.5rem;\n    position: absolute;\n    top: 50%;\n    transform: translateX(-100%) translateY(", ");\n    &:after {\n        position: absolute;\n        content: '';\n        left: 100%;\n        transform: translateY(", ");\n        border: ", " solid transparent;\n        border-left-color: ", ";\n    }\n"])), function (p) {
  return p.moveBody + "%";
}, function (p) {
  return p.move + "%";
}, arrowSize, color.blueDark);
var right = /*#__PURE__*/css(_templateObject3$v || (_templateObject3$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: absolute;\n    right: -0.5rem;\n    top: 50%;\n    transform: translateX(100%) translateY(", ");\n    &:after {\n        position: absolute;\n        content: '';\n        right: 100%;\n        transform: translateY(", ");\n        border: ", " solid transparent;\n        border-right-color: ", ";\n    }\n"])), function (p) {
  return p.moveBody + "%";
}, function (p) {
  return p.move + "%";
}, arrowSize, color.blueDark);
var top = /*#__PURE__*/css(_templateObject4$q || (_templateObject4$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    left: 50%;\n    position: absolute;\n    top: -0.5rem;\n    transform: translateX(", ") translateY(-100%);\n    &:after {\n        position: absolute;\n        content: '';\n        bottom: 0;\n        transform: translateX(", ") translateY(100%);\n        border: ", " solid transparent;\n        border-top-color: ", ";\n    }\n"])), function (p) {
  return p.moveBody + "%";
}, function (p) {
  return p.move + "%";
}, arrowSize, color.blueDark);
var DivStyledArrow = /*#__PURE__*/styled.div(_templateObject5$l || (_templateObject5$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    z-index: 999;\n    ", "\n"])), function (p) {
  return p.position ? getContainerStyleByPosition(p.position) : '';
});
var DivStyledFlex$1 = /*#__PURE__*/styled.div(_templateObject6$h || (_templateObject6$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: max-content;\n"])));
var DivStyledDropdown = /*#__PURE__*/styled.div(_templateObject7$e || (_templateObject7$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    border-radius: 20px;\n    height: auto;\n    overflow: hidden;\n    position: absolute;\n    width: max-content;\n    z-index: 999;\n    ", "\n"])), color.blueDark, function (p) {
  return getContainerStyleByPosition(p.position);
});
var DivStyledChild = /*#__PURE__*/styled.div(_templateObject8$b || (_templateObject8$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    cursor: pointer;\n    height: auto;\n    width: 100%;\n\n    :hover {\n        background: ", ";\n    }\n"])), color.blueDark2);

var PopoverDropdown = function PopoverDropdown(_ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$move = _ref.move,
      move = _ref$move === void 0 ? -50 : _ref$move,
      parent = _ref.parent,
      position = _ref.position,
      _ref$moveBody = _ref.moveBody,
      moveBody = _ref$moveBody === void 0 ? -50 : _ref$moveBody;

  var _useState = useState(false),
      showDropdown = _useState[0],
      setVisibility = _useState[1];

  return React.createElement(DivStyledFlex$1, {
    id: id,
    onMouseEnter: function onMouseEnter() {
      return setVisibility(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setVisibility(false);
    }
  }, React.createElement("div", {
    "data-testid": 'dropdown-parent-test-id'
  }, parent), showDropdown && React.createElement(React.Fragment, null, React.createElement(DivStyledArrow, {
    position: position,
    move: move,
    moveBody: moveBody
  }), React.createElement(DivStyledDropdown, {
    position: position,
    moveBody: moveBody,
    move: move
  }, children.map(function (child, index) {
    return React.createElement("div", {
      key: "dropdown-element-" + index
    }, React.createElement(DivStyledChild, null, child));
  }))));
};

var _templateObject$Q, _templateObject2$C, _templateObject3$w, _templateObject4$r;
var DivContainerStyled = /*#__PURE__*/styled.div(_templateObject$Q || (_templateObject$Q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: ", ";\n    cursor: pointer;\n    display: inline-block;\n"])), function (p) {
  return p.backgroundColor ? p.backgroundColor : '';
});
var DivStyled$c = /*#__PURE__*/styled.div(_templateObject2$C || (_templateObject2$C = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    height: ", ";\n    padding-left: 16px;\n    padding-right: 16px;\n    width: ", ";\n"])), function (p) {
  return p.height ? p.height + "px" : 'auto';
}, function (p) {
  return p.width ? p.width + "px" : 'auto';
});
var DivImageStyled = /*#__PURE__*/styled.div(_templateObject3$w || (_templateObject3$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    display: flex;\n    padding-right: 8px;\n"])));
var TextStyled$2 = /*#__PURE__*/styled.p(_templateObject4$r || (_templateObject4$r = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: center;\n    color: ", ";\n    display: flex;\n    font-size: ", ";\n    ", ";\n    ", ";\n"])), function (p) {
  return p.textColor ? p.textColor : color.white;
}, function (p) {
  return p.textSize ? p.textSize + "px" : '';
}, fonts.openSans, fonts.textBold);
var PopoverElementStyles = {
  DivContainerStyled: DivContainerStyled,
  DivImageStyled: DivImageStyled,
  DivStyled: DivStyled$c,
  TextStyled: TextStyled$2
};

var DivContainerStyled$1 = PopoverElementStyles.DivContainerStyled,
    DivStyled$d = PopoverElementStyles.DivStyled,
    DivImageStyled$1 = PopoverElementStyles.DivImageStyled,
    TextStyled$3 = PopoverElementStyles.TextStyled;

var PopoverElement = function PopoverElement(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor,
      height = _ref.height,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? iconTypes.check : _ref$icon,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'white' : _ref$iconColor,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 20 : _ref$iconSize,
      id = _ref.id,
      _onClick = _ref.onClick,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Text' : _ref$text,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? 'white' : _ref$textColor,
      _ref$textSize = _ref.textSize,
      textSize = _ref$textSize === void 0 ? 14 : _ref$textSize,
      width = _ref.width;
  return React.createElement(DivContainerStyled$1, {
    backgroundColor: backgroundColor,
    "data-testid": 'dropdown-element-test-id',
    icon: icon,
    iconColor: iconColor,
    id: id
  }, React.createElement(DivStyled$d, {
    "data-testid": 'dropdown-element-click-test-id',
    height: height,
    width: width,
    onClick: function onClick() {
      {
        _onClick ? _onClick() : '';
      }
    }
  }, icon ? React.createElement(DivImageStyled$1, null, React.createElement(Icon, {
    fill: iconColor,
    size: iconSize,
    svg: icon
  })) : '', React.createElement(TextStyled$3, {
    "data-testid": 'dropdown-element-text-test-id',
    textColor: textColor,
    textSize: textSize
  }, text)));
};

var shortenName = function shortenName(name, len) {
  return name.length > len ? name.slice(0, len + 1) + '...' : name;
}; // to fix ipfs links - add here if any more cases found


var fixUrl = function fixUrl(imgLink) {
  var ipfsLink = null;

  if (imgLink && imgLink.slice(0, 4) === 'ipfs') {
    var case1 = 'ipfs://ipfs/';
    var case2 = 'ipfs://';
    if (imgLink.slice(0, case1.length) === case1) ipfsLink = "https://ipfs.io/ipfs/" + imgLink.slice(case1.length);else if (imgLink.slice(0, case2.length) === case2) ipfsLink = "https://ipfs.io/ipfs/" + imgLink.slice(case2.length);
  }

  return ipfsLink;
}; // If image cannot be accessed using token_uri and use metadata


var fromMetadata = function fromMetadata(metadata) {
  var tempData = metadata && JSON.parse(metadata);
  return {
    name: tempData == null ? void 0 : tempData.name,
    image: tempData == null ? void 0 : tempData.image
  };
};

var NFTCard = function NFTCard(_ref) {
  var chain = _ref.chain,
      metadata = _ref.metadata,
      tokenAddress = _ref.tokenAddress,
      tokenId = _ref.tokenId,
      tokenUri = _ref.tokenUri;

  var _useState = useState({}),
      nft = _useState[0],
      setNft = _useState[1];

  var _useState2 = useState(false),
      isError = _useState2[0],
      setIsError = _useState2[1];

  var _useState3 = useState(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var fetchData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(url) {
      var res, _fromMetadata, name, image, data, ipfsLink;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(url);

            case 3:
              res = _context.sent;

              if (!(res.status != 200)) {
                _context.next = 9;
                break;
              }

              _fromMetadata = fromMetadata(metadata), name = _fromMetadata.name, image = _fromMetadata.image;
              return _context.abrupt("return", {
                name: shortenName(name, 50),
                image: fixUrl(image)
              });

            case 9:
              _context.next = 11;
              return res.json();

            case 11:
              data = _context.sent;
              ipfsLink = fixUrl(data.image);
              return _context.abrupt("return", {
                name: data != null && data.name ? shortenName(data.name, 50) : data == null ? void 0 : data.name,
                image: ipfsLink ? ipfsLink : data.image
              });

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", {
                name: null,
                image: null
              });

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    }));

    return function fetchData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (tokenUri) {
      setIsLoading(true);
      var res = fetchData(tokenUri);
      res.then(function (data) {
        setNft(data);
        setIsLoading(false);
      });
    }
  }, [tokenUri]);

  var renderReady = function renderReady() {
    return React.createElement(Row.Col, {
      breakpointsConfig: {
        xs: 24,
        sm: 8,
        md: 6,
        lg: 6
      },
      "data-testid": "test-NFTCollection-id",
      span: 24
    }, React.createElement(DivStyledCardContainer, null, !isError && nft.image ? nft.image.slice(-3) === 'mp4' ? React.createElement("video", {
      height: "200px",
      width: "100%",
      src: nft.image,
      onError: function onError() {
        return setIsError(true);
      }
    }) : React.createElement(SpanStyled$2, {
      "aria-label": "NFT image of " + nft.name,
      onError: function onError() {
        return setIsError(true);
      },
      role: "image",
      style: {
        backgroundImage: "url(" + nft.image + ")"
      }
    }) : React.createElement(Illustration, {
      logo: "lazyNft",
      width: "100%",
      height: "200px"
    }), React.createElement(DivStyledCardContent, null, React.createElement("a", {
      href: getExplorer(getChainHex(chain)) + "/address/" + tokenAddress,
      target: "_blank",
      referrerPolicy: "no-referrer"
    }, React.createElement(Typography, {
      variant: "caption14"
    }, React.createElement("span", null, getEllipsisTxt(tokenAddress, 4)))), React.createElement(Typography, {
      variant: "caption14"
    }, "ETH")), React.createElement(DivStyledCardContent, null, React.createElement(Typography, {
      variant: "body16",
      weight: "bold"
    }, nft.name && nft.name !== '' ? nft.name : React.createElement("span", {
      id: "name"
    }, '#' + shortenName(tokenId, 10))), React.createElement(Typography, {
      variant: "body16"
    }, "NA")), React.createElement(DivStyledCardFooter, null, React.createElement("div", {
      style: {
        marginLeft: 'auto'
      }
    }, React.createElement(PopoverDropdown, {
      position: "bottom",
      parent: React.createElement(Icon, {
        key: "4",
        svg: iconTypes.info,
        fill: color.grey,
        size: 20
      }),
      children: [React.createElement(PopoverElement, {
        key: "0",
        height: 30,
        width: 150,
        text: 'Buy on OpenSea',
        icon: iconTypes.link,
        textSize: 10,
        backgroundColor: 'transparent',
        textColor: color.white,
        onClick: function onClick() {
          return window.open("http://opensea.io/assets/" + tokenAddress + "/" + tokenId, '_blank');
        }
      }), React.createElement(PopoverElement, {
        key: "1",
        height: 30,
        width: 150,
        text: 'Watch on Block Explorer',
        icon: iconTypes.link,
        textSize: 10,
        backgroundColor: 'transparent',
        textColor: color.white,
        onClick: function onClick() {
          return window.open(getExplorer(getChainHex(chain)) + "/address/" + tokenAddress, '_blank');
        }
      })]
    })))));
  };

  var renderLoading = function renderLoading() {
    return React.createElement(Row.Col, {
      breakpointsConfig: {
        xs: 24,
        sm: 8,
        md: 6,
        lg: 6
      },
      span: 24
    }, React.createElement(Card, null, React.createElement(Skeleton, {
      theme: "image",
      width: "100%",
      height: "200px"
    }), React.createElement(Skeleton, {
      theme: "text",
      height: "50px"
    })));
  };

  return !isLoading ? renderReady() : renderLoading();
};

var NFTCollection = function NFTCollection(_ref) {
  var address = _ref.address,
      chain = _ref.chain,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 20 : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;

  var _useMoralis = useMoralis(),
      isInitialized = _useMoralis.isInitialized,
      Moralis = _useMoralis.Moralis;

  var _useState = useState([]),
      nfts = _useState[0],
      setNfts = _useState[1];

  var _useState2 = useState(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var fetchNFTS = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      var _yield$Moralis$Web3AP, result;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isInitialized) {
                _context.next = 7;
                break;
              }

              setIsLoading(true);
              _context.next = 4;
              return Moralis.Web3API.account.getNFTs({
                address: address,
                chain: chain,
                offset: offset,
                limit: limit
              });

            case 4:
              _yield$Moralis$Web3AP = _context.sent;
              result = _yield$Moralis$Web3AP.result;

              if (result) {
                setNfts(result);
                setIsLoading(false);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchNFTS() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    fetchNFTS();
  }, [isInitialized, address, chain]);
  return React.createElement(SectionStyled$2, null, React.createElement(Row, {
    justifyItems: "flex-start",
    alignItems: "stretch",
    rowGap: 40
  }, React.createElement(React.Fragment, null, !isLoading ? nfts.length > 0 ? nfts.map(function (item, index) {
    return item.token_uri && React.createElement(NFTCard, {
      chain: chain,
      key: item.block_number + index,
      metadata: item.metadata,
      tokenAddress: item.token_address,
      tokenId: item.token_id,
      tokenUri: item.token_uri
    });
  }) : React.createElement(DivStyled$a, null, React.createElement(Typography, null, "Given address has no NFT's")) : isLoading && React.createElement(DivStyled$a, null, React.createElement(Loading, {
    size: 40,
    spinnerColor: "#2E7DAF"
  })))));
};

var _templateObject$R, _templateObject2$D, _templateObject3$x, _templateObject4$s, _templateObject5$m, _templateObject6$i, _templateObject7$f, _templateObject8$c, _templateObject9$9, _templateObject10$6, _templateObject11$5, _templateObject12$5, _templateObject13$3, _templateObject14$3;
var error = /*#__PURE__*/css(_templateObject$R || (_templateObject$R = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-color: ", ";\n    & > svg {\n        fill: ", ";\n    }\n"])), color.red, color.red);
var info = /*#__PURE__*/css(_templateObject2$D || (_templateObject2$D = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-color: ", ";\n    & > svg {\n        fill: ", ";\n    }\n"])), color.blue, color.blue);
var success = /*#__PURE__*/css(_templateObject3$x || (_templateObject3$x = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-color: ", ";\n    & > svg {\n        fill: ", ";\n    }\n"])), color.green, color.green);
var warning = /*#__PURE__*/css(_templateObject4$s || (_templateObject4$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-color: ", ";\n    & > svg {\n        fill: ", ";\n    }\n"])), color.yellow, color.yellow);
var openRight = /*#__PURE__*/keyframes(_templateObject5$m || (_templateObject5$m = /*#__PURE__*/_taggedTemplateLiteralLoose([" \n    0% {\n        left: 150%;\n    }\n\n    100% {\n        left: 0;\n    }\n"])));
var closeRight = /*#__PURE__*/keyframes(_templateObject6$i || (_templateObject6$i = /*#__PURE__*/_taggedTemplateLiteralLoose([" \n    0% {\n        left: 0;\n    }\n\n    100% {\n        left: 150%;\n    }\n"])));
var openLeft = /*#__PURE__*/keyframes(_templateObject7$f || (_templateObject7$f = /*#__PURE__*/_taggedTemplateLiteralLoose([" \n    0% {\n        left: -150%;\n    }\n\n    100% {\n        left: 0;\n    }\n"])));
var closeLeft = /*#__PURE__*/keyframes(_templateObject8$c || (_templateObject8$c = /*#__PURE__*/_taggedTemplateLiteralLoose([" \n    0% {\n        left: 0;\n    }\n\n    100% {\n        left: -150%;\n    }\n"])));
var getNotificationTheme = function getNotificationTheme(type) {
  switch (type) {
    case 'error':
      return error;

    case 'success':
      return success;

    case 'warning':
      return warning;

    case 'info':
    default:
      return info;
  }
};
var getNotificationPosition = function getNotificationPosition(position) {
  switch (position) {
    case 'bottomL':
      return css(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteralLoose(["\n                left: 0;\n                bottom: 0;\n            "])));

    case 'topL':
      return css(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteralLoose(["\n                left: 0;\n                top: 0;\n            "])));

    case 'bottomR':
      return css(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteralLoose(["\n                right: 0;\n                bottom: 0;\n            "])));

    case 'topR':
    default:
      return css(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteralLoose(["\n                right: 0;\n                top: 0;\n            "])));
  }
};
var getNotificationColor = function getNotificationColor(type) {
  switch (type) {
    case 'error':
      return color.red;

    case 'success':
      return color.green;

    case 'warning':
      return color.yellow;

    case 'info':
    default:
      return color.blue;
  }
};
var getNotificationAnimation = function getNotificationAnimation(position, isClosing) {
  switch (position) {
    case 'bottomL':
    case 'topL':
      return css(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteralLoose(["\n                animation: ", " 1s;\n            "])), isClosing ? closeLeft : openLeft);

    case 'bottomR':
    case 'topR':
      return css(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteralLoose(["\n                animation: ", " 1s;\n            "])), isClosing ? closeRight : openRight);

    default:
      throw new Error('Make sure you provided position');
  }
};

var _templateObject$S, _templateObject2$E, _templateObject3$y, _templateObject4$t, _templateObject5$n, _templateObject6$j, _templateObject7$g, _templateObject8$d;
var NotificationContainerStyled = /*#__PURE__*/styled.div(_templateObject$S || (_templateObject$S = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: fixed;\n    z-index: 30;\n\n    ", "\n"])), function (p) {
  return getNotificationPosition(p.position);
});
var IconWrapperStyled = /*#__PURE__*/styled.div(_templateObject2$E || (_templateObject2$E = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    align-items: center;\n    border-radius: 100%;\n    display: flex;\n    height: 24px;\n    justify-content: center;\n    width: 24px;\n"])), resetCSS);
var TextContentStyled = /*#__PURE__*/styled.div(_templateObject3$y || (_templateObject3$y = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    margin-left: 10px;\n    width: 100%;\n    flex-wrap: wrap;\n"])));
var SpanStyled$3 = /*#__PURE__*/styled.span(_templateObject4$t || (_templateObject4$t = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    color: ", ";\n    display: inline-block;\n    word-break: break-word;\n"])), fonts.ibm, color.grey);
var TitleStyled$2 = /*#__PURE__*/styled.h5(_templateObject5$n || (_templateObject5$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    display: inline-block;\n    font-weight: 700;\n    line-height: 24px;\n    margin: 0;\n    word-break: break-word;\n"])), fonts.h5);
var CloseWrapperStyled = /*#__PURE__*/styled.div(_templateObject6$j || (_templateObject6$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    cursor: pointer;\n    position: absolute;\n    right: 16px;\n    top: 16px;\n"])), resetCSS);
var BarStyled = /*#__PURE__*/styled.div(_templateObject7$g || (_templateObject7$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: rgba(158, 204, 234, 0.3);\n    bottom: 0;\n    height: 6px;\n    left: 0;\n    position: absolute;\n"])));
var NotificationStyled = /*#__PURE__*/styled.div(_templateObject8$d || (_templateObject8$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    animation-fill-mode: forwards;\n    background-color: ", ";\n    border-radius: 20px;\n    box-shadow: 0px 4px 10px rgba(48, 71, 105, 0.1);\n    color: ", ";\n    display: flex;\n    margin: 18px;\n    padding: 16px 48px 16px 16px;\n    position: relative;\n    width: 320px;\n    overflow: hidden;\n    z-index: 9999;\n\n    ", "\n\n    & > ", " {\n        ", "\n    }\n    & > ", " > ", " {\n        color: ", ";\n    }\n"])), resetCSS, fonts.text, color.white, color.grey, function (p) {
  return getNotificationAnimation(p.position, p.isClosing);
}, IconWrapperStyled, function (p) {
  return getNotificationTheme(p.type);
}, TextContentStyled, TitleStyled$2, function (p) {
  return getNotificationColor(p.type);
});
var NotificationStyles = {
  CloseWrapperStyled: CloseWrapperStyled,
  IconWrapperStyled: IconWrapperStyled,
  NotificationStyled: NotificationStyled,
  SpanStyled: SpanStyled$3,
  TextContentStyled: TextContentStyled,
  TitleStyled: TitleStyled$2,
  NotificationContainerStyled: NotificationContainerStyled,
  BarStyled: BarStyled
};

var BarStyled$1 = NotificationStyles.BarStyled,
    CloseWrapperStyled$1 = NotificationStyles.CloseWrapperStyled,
    IconWrapperStyled$1 = NotificationStyles.IconWrapperStyled,
    NotificationStyled$1 = NotificationStyles.NotificationStyled,
    SpanStyled$4 = NotificationStyles.SpanStyled,
    TextContentStyled$1 = NotificationStyles.TextContentStyled,
    TitleStyled$3 = NotificationStyles.TitleStyled;

var Notification = function Notification(_ref) {
  var dispatch = _ref.dispatch,
      icon = _ref.icon,
      iconColor = _ref.iconColor,
      id = _ref.id,
      message = _ref.message,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'New Message' : _ref$title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'topL' : _ref$position;

  var _useState = useState(false),
      isClosing = _useState[0],
      setIsClosing = _useState[1];

  var _useState2 = useState(),
      intervalId = _useState2[0],
      setIntervalId = _useState2[1];

  var _useState3 = useState(0),
      barWidth = _useState3[0],
      setBarWidth = _useState3[1];

  var notificationWidth = 320;

  var startTimer = function startTimer() {
    if (isClosing) return;
    var idInt = setInterval(function () {
      setBarWidth(function (prev) {
        if (prev < notificationWidth) return prev + 1;
        clearInterval(idInt);
        return prev;
      });
    }, 20);
    setIntervalId(idInt);
  };

  var pauseTimer = function pauseTimer() {
    clearInterval(intervalId);
  };

  useEffect(function () {
    if (isClosing) return;
    if (barWidth === notificationWidth) closeNotification();
  }, [barWidth, isClosing]);
  useEffect(function () {
    return startTimer();
  }, []);

  var closeNotification = function closeNotification() {
    pauseTimer();
    setIsClosing(true);
    setTimeout(function () {
      // @ts-ignore
      dispatch({
        type: 'remove_notification',
        id: id
      });
    }, 400);
  };

  var getIcon = function getIcon() {
    if (icon) return icon;

    if (type === 'error' || type === 'warning') {
      return iconTypes.exclamation;
    }

    if (type === 'info') return iconTypes.info;
    return iconTypes.checkmark;
  };

  var getIconColor = function getIconColor() {
    if (iconColor) return iconColor;
    return color.grey;
  };

  return React.createElement(NotificationStyled$1, {
    "data-testid": 'test-notification-id',
    id: id,
    isClosing: isClosing,
    onMouseEnter: pauseTimer,
    onMouseLeave: startTimer,
    type: type,
    position: position
  }, React.createElement(IconWrapperStyled$1, {
    "data-testid": 'test-notification-icon-wrapper'
  }, React.createElement(Icon, {
    size: 24,
    svg: getIcon(),
    fill: getIconColor()
  })), React.createElement(TextContentStyled$1, null, React.createElement(TitleStyled$3, {
    "data-testid": 'test-notification-title'
  }, title), React.createElement(CloseWrapperStyled$1, {
    onClick: closeNotification,
    "data-testid": 'test-notification-x'
  }, React.createElement(Icon, {
    size: 24,
    svg: iconTypes.x,
    fill: color.greyIcons
  })), React.createElement(SpanStyled$4, {
    "data-testid": 'test-notification-message'
  }, message)), React.createElement(BarStyled$1, {
    style: {
      width: barWidth
    }
  }));
};

var NotificationContext = /*#__PURE__*/React.createContext();

var NotificationContainerStyled$1 = NotificationStyles.NotificationContainerStyled;
var initialState = [];

function reducer(state, action) {
  switch (action.type) {
    case 'add_notification':
      return [].concat(state, [_extends({}, action.payload)]);

    case 'remove_notification':
      console.log('action', action, 'state', state);
      return state.filter(function (toast) {
        return toast.id !== action.id;
      });

    case 'clear_notifications':
      return [];

    default:
      return state;
  }
}

var NotificationProvider = function NotificationProvider(props) {
  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var toasts = useMemo(function () {
    var toaster = {
      topR: [],
      topL: [],
      bottomR: [],
      bottomL: []
    };
    state.forEach(function (toast) {
      return toaster[toast.position].push(toast);
    });
    return Object.keys(toaster).map(function (pos) {
      var _toaster$pos;

      return React.createElement(NotificationContainerStyled$1, {
        position: pos,
        key: "container-" + pos
      }, toaster == null ? void 0 : (_toaster$pos = toaster[pos]) == null ? void 0 : _toaster$pos.map(function (toast) {
        return React.createElement(Notification, Object.assign({
          key: toast.id,
          id: toast.id || String(Date.now()),
          dispatch: dispatch
        }, toast));
      }));
    });
  }, [state]);
  return React.createElement(NotificationContext.Provider, {
    value: dispatch
  }, toasts, props.children);
};

var useNotification = function useNotification() {
  var dispatch = useContext(NotificationContext);

  if (dispatch === undefined) {
    throw new Error('useNotification hook must be used within a NotificationProvider');
  }

  return function (props) {
    // @ts-ignore
    dispatch({
      type: 'add_notification',
      payload: _extends({
        id: String(Date.now())
      }, props)
    });
  };
};

var _templateObject$T, _templateObject2$F, _templateObject3$z, _templateObject4$u, _templateObject5$o, _templateObject6$k, _templateObject7$h, _templateObject8$e, _templateObject9$a, _templateObject10$7;
var SectionStyled$3 = /*#__PURE__*/styled.section(_templateObject$T || (_templateObject$T = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-between;\n    position: relative;\n"])));
var OrderedListStyled = /*#__PURE__*/styled.ol(_templateObject2$F || (_templateObject2$F = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    list-style: none;\n    margin-bottom: 40px;\n    position: relative;\n    text-align: center;\n    width: 100%;\n"])), resetCSS);
var ListItemStyled$1 = /*#__PURE__*/styled.li(_templateObject3$z || (_templateObject3$z = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    align-items: center;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    color: ", ";\n    display: flex;\n    font-size: 24px;\n    height: 32px;\n    justify-content: center;\n    line-height: 0;\n    position: relative;\n    width: 32px;\n\n    background-color: ", ";\n    opacity: ", ";\n"])), resetCSS, fonts.text, color.green, color.white, function (p) {
  return p.activeStep <= p.thisStep ? color.green : color.white;
}, function (p) {
  return p.activeStep < p.thisStep ? '50%' : '100%';
});
var SpanStyled$5 = /*#__PURE__*/styled.span(_templateObject4$u || (_templateObject4$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: rgba(46, 125, 175, 0.3);\n    border: none;\n    display: block;\n    height: 2px;\n\n    &:last-of-type {\n        display: none;\n    }\n\n    width: calc(\n        (100% / ", ") -\n            (", ")\n    );\n"])), function (p) {
  return p.stepTotal - 1;
}, function (p) {
  return p.stepTotal === 2 ? '90px' : '64px';
});
var DivStyled$e = /*#__PURE__*/styled.div(_templateObject5$o || (_templateObject5$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    text-align: center;\n\n    div[role='spinner'] {\n        margin: 30px auto;\n    }\n"])));
var DivStyledContent$2 = /*#__PURE__*/styled.div(_templateObject6$k || (_templateObject6$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    display: inline-block;\n    margin: 20px 20px 32px;\n    p,\n    i {\n        ", ";\n        ", ";\n    }\n\n    :hover {\n        display: inline-block;\n        height: auto;\n    }\n"])), resetCSS, fonts.text, resetCSS, fonts.text);
var NavStyled$1 = /*#__PURE__*/styled.nav(_templateObject7$h || (_templateObject7$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n    margin-top: 12px;\n\n    button {\n        margin: 0 12px;\n    }\n"])));
var FooterStyled$3 = /*#__PURE__*/styled.footer(_templateObject8$e || (_templateObject8$e = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
var DivStyledHelper = /*#__PURE__*/styled.div(_templateObject9$a || (_templateObject9$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    margin-top: 26px;\n    text-align: center;\n\n    p,\n    i,\n    span {\n        ", ";\n        font-size: 12px;\n    }\n\n    img,\n    button {\n        margin: 0 auto;\n    }\n"])), fonts.text);
var HeaderStyled$9 = /*#__PURE__*/styled.header(_templateObject10$7 || (_templateObject10$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    width: 100%;\n"])), function (p) {
  return p.headerWidth && "max-width: " + p.headerWidth + "px";
});

var _templateObject2$G;
var H2Styled = /*#__PURE__*/styled.h2(_templateObject2$G || (_templateObject2$G = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", "\n    margin-bottom: 12px;\n\n    &:empty {\n        display: none;\n    }\n"])), resetCSS, fonts.heading, fonts.h2);

var Stepper = function Stepper(_ref) {
  var _ref$step = _ref.step,
      step = _ref$step === void 0 ? 0 : _ref$step,
      stepData = _ref.stepData,
      _ref$hasNavButtons = _ref.hasNavButtons,
      hasNavButtons = _ref$hasNavButtons === void 0 ? true : _ref$hasNavButtons,
      helperContent = _ref.helperContent,
      _ref$completeTitle = _ref.completeTitle,
      completeTitle = _ref$completeTitle === void 0 ? 'all done, nice!' : _ref$completeTitle,
      _ref$completeMessage = _ref.completeMessage,
      completeMessage = _ref$completeMessage === void 0 ? 'You should tell the user what to do next, or use the onComplete function to programmatically fire an event' : _ref$completeMessage,
      _ref$onComplete = _ref.onComplete,
      onComplete = _ref$onComplete === void 0 ? function () {
    return null;
  } : _ref$onComplete,
      headerWidth = _ref.headerWidth;

  var _useState = useState(step),
      activeStep = _useState[0],
      setActiveStep = _useState[1];

  var myStepRef = useRef(activeStep);
  useEffect(function () {
    // subscribe event
    document.addEventListener('prev', prevStep);
    document.addEventListener('next', nextStep);
    return function () {
      // unsubscribe event
      document.removeEventListener('prev', prevStep);
      document.removeEventListener('next', nextStep);
    };
  }, []);

  var setStep = function setStep(data) {
    myStepRef.current = data;
    setActiveStep(data);
  };

  var prevStep = function prevStep() {
    if (myStepRef.current <= 1) return;
    setStep(myStepRef.current - 1);
  };

  var nextStep = function nextStep() {
    if (activeStep === stepData.length + 1) {
      onComplete();
      return;
    }

    setStep(myStepRef.current + 1);
  };

  var handleContentClick = function handleContentClick(event) {
    var target = event.target;
    if (!target.id) return;
    if (target.id === 'prev') prevStep();
    if (target.id === 'next') nextStep();
    return;
  };

  var renderPreloader = function renderPreloader() {
    return React.createElement(DivStyled$e, null, React.createElement(H2Styled, {
      id: "stepper-load-title",
      "data-testid": "test-stepper_title"
    }, "Just one sec..."), React.createElement(Loading, {
      size: 20,
      spinnerColor: color.green
    }));
  };

  var renderContent = function renderContent() {
    return React.createElement(DivStyled$e, {
      id: "step-" + activeStep
    }, React.createElement(H2Styled, {
      id: "stepper-title",
      "data-testid": "test-stepper_title"
    }, activeStep <= stepData.length ? stepData[Number(activeStep - 1)].title || '' : completeTitle), React.createElement(DivStyledContent$2, {
      onClick: handleContentClick,
      "data-testid": "test-stepper_content",
      id: "stepper-content"
    }, activeStep <= stepData.length ? stepData[Number(activeStep - 1)].content : completeMessage));
  };

  var renderStepperNumbers = function renderStepperNumbers() {
    return React.createElement(OrderedListStyled, {
      "data-testid": "test-stepper_numbers"
    }, stepData.map(function (step, index) {
      return React.createElement(Fragment, {
        key: "step_" + index
      }, React.createElement(ListItemStyled$1, {
        activeStep: activeStep,
        "aria-label": "step " + Number(index + 1) + " " + step.title,
        stepTotal: stepData.length,
        thisStep: Number(index + 1)
      }, activeStep <= Number(index + 1) ? Number(index + 1) : React.createElement(Icon, {
        svg: "check",
        fill: color.green
      })), React.createElement(SpanStyled$5, {
        activeStep: activeStep,
        stepTotal: stepData.length,
        thisStep: Number(index + 1),
        "aria-hidden": "true"
      }));
    }));
  };

  return React.createElement(SectionStyled$3, {
    "data-testid": "test-stepper"
  }, React.createElement(HeaderStyled$9, {
    headerWidth: headerWidth,
    style: {
      alignSelf: 'center'
    }
  }, renderStepperNumbers()), activeStep === 0 ? renderPreloader() : renderContent(), React.createElement(FooterStyled$3, null, hasNavButtons && React.createElement(NavStyled$1, {
    "data-testid": "test-stepper_nav"
  }, React.createElement(Button, {
    disabled: activeStep === 0,
    onClick: prevStep,
    text: "Prev",
    theme: "secondary",
    type: "button"
  }), React.createElement(Button, {
    disabled: activeStep === 0,
    onClick: nextStep,
    text: activeStep === stepData.length + 1 ? 'Done!' : 'Next',
    theme: "primary",
    type: "button"
  })), helperContent && React.createElement(DivStyledHelper, {
    "data-testid": "test-stepper_helper"
  }, helperContent)));
};

function paginate(totalItems, currentPage, pageSize, maxPages) {
  if (currentPage === void 0) {
    currentPage = 1;
  }

  if (pageSize === void 0) {
    pageSize = 10;
  }

  if (maxPages === void 0) {
    maxPages = 10;
  }

  // calculate total pages
  var totalPages = Math.ceil(totalItems / pageSize); // ensure current page isn't out of range

  if (currentPage < 1) {
    currentPage = 1;
  } else if (currentPage > totalPages) {
    currentPage = totalPages;
  }

  var startPage, endPage;

  if (totalPages <= maxPages) {
    // total pages less than max so show all pages
    startPage = 1;
    endPage = totalPages;
  } else {
    // total pages more than max so calculate start and end pages
    var maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
    var maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;

    if (currentPage <= maxPagesBeforeCurrentPage) {
      // current page near the start
      startPage = 1;
      endPage = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // current page near the end
      startPage = totalPages - maxPages + 1;
      endPage = totalPages;
    } else {
      // current page somewhere in the middle
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  } // create an array of pages to ng-repeat in the pager control


  var pages = Array.from(Array(endPage + 1 - startPage).keys()).map(function (i) {
    return startPage + i;
  }); // return object with all pager properties required by the view

  return pages;
}

var getModuleAnimation = function getModuleAnimation(module) {
  switch (module) {
    case 'Token':
      return React.createElement(Illustration, {
        logo: 'token',
        width: '100%',
        height: '180px'
      });

    case 'NFT Marketplace':
      return React.createElement(Illustration, {
        logo: 'marketplace',
        width: '100%',
        height: '180px'
      });

    case 'NFT Collection':
      return React.createElement(Illustration, {
        logo: 'chest',
        width: '100%',
        height: '180px'
      });

    case 'Bundle':
      return React.createElement(Illustration, {
        logo: 'bundle',
        width: '100%',
        height: '180px'
      });

    case 'Lazy NFT':
      return React.createElement(Illustration, {
        logo: 'lazyNft',
        width: '100%',
        height: '180px'
      });

    case 'Pack':
      return React.createElement(Illustration, {
        logo: 'pack',
        width: '100%',
        height: '180px'
      });

    default:
      return React.createElement(Illustration, {
        logo: 'servers',
        width: '100%',
        height: '180px'
      });
  }
};

var _templateObject$U, _templateObject2$H, _templateObject3$A, _templateObject4$v, _templateObject5$p, _templateObject6$l, _templateObject7$i, _templateObject8$f, _templateObject9$b;
var TableParent = /*#__PURE__*/styled.div(_templateObject$U || (_templateObject$U = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n"])));
var NoData = /*#__PURE__*/styled.div(_templateObject2$H || (_templateObject2$H = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    display: grid;\n    min-height: fit-content;\n    align-items: flex-start;\n    justify-content: center;\n    grid-column: 1 / -1;\n    & > div {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding: 20px;\n    }\n"])), resetCSS, fonts.text);
var Divider = /*#__PURE__*/styled.div(_templateObject3$A || (_templateObject3$A = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding-top: 1px;\n    background: radial-gradient(\n        106.45% 108.64% at 32.33% -4.84%,\n        #ecf5fc 0.52%,\n        #cee4f3 100%\n    );\n    grid-column: 1 / -1;\n"])));
var Pagination = /*#__PURE__*/styled.div(_templateObject4$v || (_templateObject4$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    padding: 12px 0px;\n    > div {\n        display: flex;\n        flex-direction: row;\n        min-width: 50px;\n        justify-content: space-evenly;\n        align-items: center;\n    }\n"])), resetCSS, fonts.text);
var PaginationText = /*#__PURE__*/styled.div(_templateObject5$p || (_templateObject5$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    cursor: ", ";\n    color: ", ";\n"])), function (props) {
  return props.isActive ? 'pointer' : 'cursor';
}, function (props) {
  return props.isActive ? color.blue : color.greyLight;
});
var DivTableCell = /*#__PURE__*/styled.div(_templateObject6$l || (_templateObject6$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    align-items: ", ";\n    justify-content: ", ";\n    display: flex;\n"])), function (props) {
  return props.alignCellItems;
}, function (props) {
  return props.justifyCellItems;
});
var TableGrid = /*#__PURE__*/styled.div.attrs(function (props) {
  return {
    columns: props.columns
  };
})(_templateObject7$i || (_templateObject7$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    padding-bottom: 11px;\n    border-radius: 10px;\n    border: 2px solid transparent;\n    border-radius: 20px;\n    box-shadow: 0 4px 10px rgba(48, 71, 105, 0.1);\n    background-color: white;\n    display: grid;\n    grid-template-columns: ", ";\n    row-gap: 22px;\n    column-gap: 11px;\n    overflow: none;\n    min-height: fit-content;\n    min-width: fit-content;\n    & > .firstCol {\n        /* border: 2px dashed red; */\n        padding-left: 22px;\n    }\n    & > .lastCol {\n        /* border: 2px dashed red; */\n        padding-right: 22px;\n    }\n    & > div.table_header {\n        margin-bottom: -11px;\n    }\n"])), resetCSS, fonts.text, function (props) {
  return props.columns;
});
var PaginationTag = /*#__PURE__*/styled.div(_templateObject8$f || (_templateObject8$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    width: 32px;\n    height: 32px;\n    border: 2px solid transparent;\n    border-radius: 12px;\n    margin: 0px 5px;\n    display: grid;\n    align-items: center;\n    justify-content: center;\n    border-color: ", ";\n    background-color: ", ";\n    cursor: ", ";\n"])), function (props) {
  return props.active && color.blue;
}, function (props) {
  return !props.active && '#EBEFF9';
}, function (props) {
  return !props.active && 'pointer';
});
var DivSpinnerLoaderParent = /*#__PURE__*/styled.div(_templateObject9$b || (_templateObject9$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    grid-column: 1 / -1;\n    & > h3 {\n        margin-top: 29px;\n    }\n"])));

var Table = function Table(_ref) {
  var columnsConfig = _ref.columnsConfig,
      header = _ref.header,
      data = _ref.data,
      pageSize = _ref.pageSize,
      maxPages = _ref.maxPages,
      noPagination = _ref.noPagination,
      customPageNumber = _ref.customPageNumber,
      onPageNumberChanged = _ref.onPageNumberChanged,
      customNoDataComponent = _ref.customNoDataComponent,
      _ref$customNoDataText = _ref.customNoDataText,
      customNoDataText = _ref$customNoDataText === void 0 ? 'No Data' : _ref$customNoDataText,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      customLoadingContent = _ref.customLoadingContent,
      _ref$alignCellItems = _ref.alignCellItems,
      alignCellItems = _ref$alignCellItems === void 0 ? 'start' : _ref$alignCellItems,
      _ref$justifyCellItems = _ref.justifyCellItems,
      justifyCellItems = _ref$justifyCellItems === void 0 ? 'start' : _ref$justifyCellItems;

  var _useState = useState(customPageNumber ? customPageNumber : 0),
      pageNum = _useState[0],
      setPageNum = _useState[1];

  useEffect(function () {
    if (typeof onPageNumberChanged != 'undefined') {
      onPageNumberChanged(pageNum);
    }
  }, [pageNum]);
  useEffect(function () {
    handleSetPageNumber(customPageNumber ? customPageNumber : 0);
  }, [customPageNumber]);

  var handleSetPageNumber = function handleSetPageNumber(state) {
    if (typeof customPageNumber == 'number') {
      setPageNum(customPageNumber);
    } else {
      setPageNum(state);
    }
  };

  var computeCurrentData = function computeCurrentData() {
    if (noPagination) {
      return data;
    }

    var from = pageNum * pageSize;
    var to = from + pageSize;
    return data == null ? void 0 : data.slice(from, to);
  };

  var handlePrev = function handlePrev() {
    if (pageNum != 0) {
      handleSetPageNumber(pageNum - 1);
    }
  };

  var handleNext = function handleNext() {
    if (pageNum + 1 < Math.ceil((data == null ? void 0 : data.length) / pageSize)) {
      handleSetPageNumber(pageNum + 1);
    }
  };

  var RenderTableHeader = function RenderTableHeader() {
    return React.createElement(React.Fragment, null, header.map(function (col, key) {
      return React.createElement(DivTableCell, {
        key: "header_" + key,
        role: "table-header",
        className: "table_header",
        alignCellItems: alignCellItems,
        justifyCellItems: justifyCellItems
      }, col);
    }), React.createElement(Divider, null));
  };

  var RenderNoData = function RenderNoData() {
    if (customNoDataComponent) {
      return React.createElement(NoData, null, customNoDataComponent);
    }

    return React.createElement(NoData, null, React.createElement("div", null, getModuleAnimation(undefined), React.createElement("p", null, customNoDataText)));
  };

  var RenderTable = function RenderTable() {
    if (computeCurrentData().length == 0) {
      return React.createElement(RenderNoData, null);
    }

    return React.createElement(React.Fragment, null, computeCurrentData().map(function (row, rowKey, arr) {
      return React.createElement(React.Fragment, {
        key: "fragment_" + rowKey
      }, row.map(function (item, colKey, rowData) {
        return React.createElement(DivTableCell, {
          key: "tr_" + rowKey + "_" + colKey,
          role: "table-item",
          className: (colKey == 0 && 'firstCol') + " " + (colKey == rowData.length - 1 && 'lastCol'),
          alignCellItems: alignCellItems,
          justifyCellItems: justifyCellItems
        }, item);
      }), rowKey != arr.length - 1 && React.createElement(Divider, {
        key: "divider_" + rowKey
      }));
    }));
  };

  var RenderPagination = function RenderPagination() {
    if (noPagination || (data == null ? void 0 : data.length) == 0) {
      return React.createElement(React.Fragment, null);
    }

    return React.createElement(Pagination, null, React.createElement("div", null, React.createElement(PaginationText, {
      isActive: pageNum != 0,
      onClick: handlePrev,
      "data-testid": "pagination-prev"
    }, "Prev"), paginate(data == null ? void 0 : data.length, pageNum, pageSize, maxPages).map(function (key) {
      return React.createElement(PaginationTag, {
        key: "pagination_" + key,
        active: key - 1 == pageNum,
        onClick: function onClick() {
          return handleSetPageNumber(key - 1);
        },
        role: "pagination-item",
        "data-testid": "pagination_" + (key - 1 == pageNum)
      }, React.createElement("span", null, key));
    }), React.createElement(PaginationText, {
      isActive: pageNum + 1 < Math.ceil((data == null ? void 0 : data.length) / pageSize),
      onClick: handleNext,
      "data-testid": "pagination-next"
    }, "Next")));
  };

  var Loader = function Loader() {
    return React.createElement(DivSpinnerLoaderParent, null, customLoadingContent ? customLoadingContent : React.createElement(React.Fragment, null, React.createElement(Loading, {
      spinnerType: 'wave',
      spinnerColor: '#B0B5BF',
      size: 6
    }), React.createElement(Typography, {
      weight: "400",
      variant: "h3",
      color: '#B0B5BF'
    }, "Loading Content")));
  };

  return React.createElement(TableParent, {
    "data-testid": "test-table-parent"
  }, React.createElement(TableGrid, {
    columns: columnsConfig
  }, React.createElement(RenderTableHeader, null), isLoading ? React.createElement(Loader, null) : React.createElement(RenderTable, null)), React.createElement(RenderPagination, null));
};

var _templateObject$V, _templateObject2$I, _templateObject3$B, _templateObject4$w, _templateObject5$q, _templateObject6$m;

var StyleTabBarParent = /*#__PURE__*/styled.div(_templateObject$V || (_templateObject$V = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n    min-height: fit-content;\n    display: flex;\n    flex-direction: row;\n    ", "\n"])), resetCSS, fonts.text, function (props) {
  return !props.isVertical && 'flex-direction:column';
});
var StyledTabBar = /*#__PURE__*/styled.div(_templateObject2$I || (_templateObject2$I = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    ", "\n    max-width: fit-content;\n    height: 40px;\n    ", "\n"])), function (props) {
  return props.isVertical && 'flex-direction: column;';
}, function (props) {
  return props.haveBackground && "\n background-color: #f2f6ff;\n    border-radius: 16px;";
});
var StyledTabContent = /*#__PURE__*/styled.div(_templateObject3$B || (_templateObject3$B = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: ", ";\n"])), function (props) {
  return props.isVertical ? '0px 11px' : '11px 0px';
});
var StyledTab = /*#__PURE__*/styled.div(_templateObject4$w || (_templateObject4$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    transition-duration: 500ms;\n    transition-property: border;\n    transition-timing-function: ease-in-out;\n    margin: 0px 48px 0px 0px;\n    padding-bottom: 4px;\n    line-height: 24px;\n    padding-bottom: 4px;\n    margin-bottom: 11px;\n    cursor: pointer;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    line-height: ", ";\n    ", "\n"])), function (props) {
  return props.isActive && 'font-weight:600;';
}, function (props) {
  return props.isActive && 'border-bottom: 2px solid #21BF96;';
}, function (props) {
  return (props.isActive || props.isDisabled) && 'pointer-events: none;';
}, function (props) {
  return !props.isActive && "color:" + color.greyIcons + ";";
}, function (props) {
  return props.lineHeight && props.lineHeight + "px";
}, function (props) {
  return props.isDisabled && "color:" + color.greyDisabled + ";";
});
var BulbTab = /*#__PURE__*/styled.div(_templateObject5$q || (_templateObject5$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    transition-duration: 200ms;\n    transition-timing-function: ease-in-out;\n    border-radius: 16px;\n    padding: 8px 16px;\n    display: flex;\n    align-items: center;\n    background-color: #f2f6ff;\n    border: 2px solid transparent;\n    cursor: pointer;\n    color: ", ";\n    ", ";\n    ", ";\n    ", "\n    ", "\n    line-height: ", ";\n    &:hover {\n        background: #e5edff;\n    }\n\n    & > span {\n        font-weight: 600;\n        font-size: 14px;\n    }\n"])), color.blue, function (_ref) {
  var isActive = _ref.isActive;
  return isActive && css(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteralLoose(["\n            border-color: ", ";\n            background-color: transparent;\n        "])), color.blue);
}, function (props) {
  return (props.isActive || props.isDisabled) && 'pointer-events: none;';
}, function (props) {
  return props.hasMargin && 'margin-right:6px;';
}, function (props) {
  return props.isDisabled && "color:" + color.greyDisabled + ";";
}, function (props) {
  return props.lineHeight && props.lineHeight + "px";
});

// Importing React and its awesome hooks

var TabContenxt = /*#__PURE__*/React.createContext({
  selectedKey: 0,
  setSelectedKey: null,
  tabStyle: 'bar'
}); // Helper function for parsing tab components

var getTabs = function getTabs(children) {
  var data = {};
  React.Children.forEach(children, function (element) {
    if (element.type == Tab) {
      data[element.props.tabKey] = element.props.children;
    }
  });
  return data;
};

function TabList(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? React.createElement(React.Fragment, null) : _ref$children,
      _ref$defaultActiveKey = _ref.defaultActiveKey,
      defaultActiveKey = _ref$defaultActiveKey === void 0 ? 1 : _ref$defaultActiveKey,
      _ref$isVertical = _ref.isVertical,
      isVertical = _ref$isVertical === void 0 ? false : _ref$isVertical,
      onChange = _ref.onChange,
      _ref$tabStyle = _ref.tabStyle,
      tabStyle = _ref$tabStyle === void 0 ? 'bar' : _ref$tabStyle;

  var _useState = useState(getTabs(children)),
      tabChildren = _useState[0],
      setTabChildren = _useState[1];

  var _useState2 = useState(defaultActiveKey),
      selectedKey = _useState2[0],
      setSelectedKey = _useState2[1];

  useEffect(function () {
    if (onChange) {
      onChange(selectedKey);
    }
  }, [selectedKey]);
  useEffect(function () {
    setSelectedKey(defaultActiveKey);
  }, [defaultActiveKey]);
  useEffect(function () {
    setTabChildren(getTabs(children));
  }, [children]);
  return React.createElement(TabContenxt.Provider, {
    value: {
      selectedKey: selectedKey,
      setSelectedKey: setSelectedKey,
      tabStyle: tabStyle
    }
  }, React.createElement(StyleTabBarParent, {
    isVertical: isVertical,
    "data-testid": "tabs_list_parent"
  }, React.createElement(StyledTabBar, {
    haveBackground: tabStyle == 'bulbUnion',
    isVertical: isVertical
  }, children), React.createElement(StyledTabContent, {
    isVertical: isVertical
  }, tabChildren[selectedKey])));
}

function Tab(_ref2) {
  var activeState = _ref2.activeState,
      _ref2$isDisabled = _ref2.isDisabled,
      isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
      _ref2$lineHeight = _ref2.lineHeight,
      lineHeight = _ref2$lineHeight === void 0 ? 24 : _ref2$lineHeight,
      tabKey = _ref2.tabKey,
      tabName = _ref2.tabName;

  var _useContext = useContext(TabContenxt),
      selectedKey = _useContext.selectedKey,
      setSelectedKey = _useContext.setSelectedKey,
      tabStyle = _useContext.tabStyle;

  var handleTabClick = function handleTabClick(key) {
    if (isDisabled) {
      return;
    }

    setSelectedKey(key);
  };

  var RenderBulbTab = function RenderBulbTab() {
    return React.createElement(BulbTab, {
      role: "tab-Item",
      "data-testid": "tab_item_" + tabKey + "_" + (activeState ? activeState : tabKey == selectedKey),
      key: tabKey,
      isActive: activeState ? activeState : tabKey == selectedKey,
      onClick: function onClick() {
        handleTabClick(tabKey);
      },
      hasMargin: tabStyle == 'bulbSeperate',
      lineHeight: lineHeight,
      isDisabled: isDisabled
    }, React.createElement("span", null, tabName));
  };

  var RenderBarTab = function RenderBarTab() {
    return React.createElement(StyledTab, {
      role: "tab-Item",
      "data-testid": "tab_item_" + tabKey + "_" + (activeState ? activeState : tabKey == selectedKey),
      key: tabKey,
      isActive: activeState ? activeState : tabKey == selectedKey,
      onClick: function onClick() {
        handleTabClick(tabKey);
      },
      lineHeight: lineHeight,
      isDisabled: isDisabled
    }, React.createElement("span", {
      "data-testid": "disabled_" + isDisabled + "_" + tabKey
    }, tabName));
  };

  return React.createElement(React.Fragment, null, tabStyle == 'bar' ? React.createElement(RenderBarTab, null) : React.createElement(RenderBulbTab, null));
}
TabList.Tab = Tab;

var _templateObject$W, _templateObject2$J, _templateObject3$C;
var DivStyled$f = /*#__PURE__*/styled.section(_templateObject$W || (_templateObject$W = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    gap: 16px;\n    margin-bottom: 20px;\n"])));
var DivStyledContent$3 = /*#__PURE__*/styled.section(_templateObject2$J || (_templateObject2$J = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex; \n    flex-direction: ", ";\n    flex-wrap: wrap; \n    gap: 16px;\n"])), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? 'column' : 'row';
});
var SectionStyled$4 = /*#__PURE__*/styled.section(_templateObject3$C || (_templateObject3$C = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n"])));

var Todo = function Todo(_ref) {
  var _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Add' : _ref$buttonText,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      label = _ref.label,
      onAdd = _ref.onAdd,
      pattern = _ref.pattern,
      _ref$todos = _ref.todos,
      todos = _ref$todos === void 0 ? [] : _ref$todos;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState([]),
      lists = _useState2[0],
      setLists = _useState2[1];

  useEffect(function () {
    if (Array.isArray(todos) && (todos == null ? void 0 : todos.length) > 0) {
      setLists([].concat(todos));
    }
  }, [todos]);

  var handleInputChange = function handleInputChange(e) {
    setInputValue(e.target.value);
  };

  var _onCancelClick = function onCancelClick(id) {
    setLists(lists.filter(function (todo) {
      return todo.id !== id;
    }));
  };

  var addTodo = function addTodo() {
    var check = (onAdd == null ? void 0 : onAdd()) || true;

    if (check) {
      var todo = {
        id: Date.now(),
        text: inputValue
      };
      setLists(function (prevTodo) {
        return [].concat(prevTodo, [todo]);
      });
      setInputValue('');
    }
  };

  return React.createElement(SectionStyled$4, {
    "data-testid": "test-todo"
  }, React.createElement(DivStyled$f, null, React.createElement(Input, {
    label: label,
    onChange: handleInputChange,
    size: "large",
    validation: {
      regExp: pattern
    }
  }), React.createElement(Button, {
    disabled: !inputValue,
    icon: "plus",
    onClick: addTodo,
    size: "large",
    text: buttonText,
    theme: "primary"
  })), React.createElement(DivStyledContent$3, {
    fullWidth: fullWidth,
    "data-testid": "test-todo_content"
  }, lists.map(function (_ref2) {
    var id = _ref2.id,
        text = _ref2.text;
    return React.createElement(Tag, {
      color: "blueLight",
      hasCancel: true,
      key: id,
      onCancelClick: function onCancelClick() {
        return _onCancelClick(id);
      },
      text: text
    });
  })));
};

var _templateObject$X, _templateObject2$K;
var WidgetStyled = /*#__PURE__*/styled.div(_templateObject$X || (_templateObject$X = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 20px;\n    display: flex;\n    justify-content: space-between;\n    padding: 32px;\n    width: 100%;\n    :first-child {\n        :first-child {\n            ", ";\n        }\n        :nth-child(1) {\n            ", ";\n        }\n    }\n"])), resetCSS, color.white, color.paleBlue2, fonts.openSans, fonts.argentumSans);
var DivStyled$g = /*#__PURE__*/styled.div(_templateObject2$K || (_templateObject2$K = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: grid;\n    gap: 4px;\n"])));
var WidgetStyles = {
  DivStyled: DivStyled$g,
  WidgetStyled: WidgetStyled
};

var Widget = function Widget(_ref) {
  var children = _ref.children,
      info = _ref.info,
      title = _ref.title;
  return React.createElement(WidgetStyles.WidgetStyled, null, React.createElement("div", null, React.createElement(Typography, {
    "data-testid": "widget-title",
    color: color.blueDark,
    variant: "caption12",
    weight: "400"
  }, title), React.createElement(Typography, {
    "data-testid": "widget-info",
    variant: "h3",
    weight: "400",
    color: color.blueDark
  }, info)), children);
};

export { Accordion, Avatar, Badge, BannerStrip, Blockie, Breadcrumbs, Button, Card, Checkbox, CodeArea, ConnectButton, CopyButton, Credentials, CreditCard, CryptoCards, CryptoLogos, DatePicker, Dropdown, Form, Hero, HideButton, Icon, Illustration, Info as Information, Input, LinkTo, Loading, Logo, Modal, NFTCollection, NativeBalance, Notification, NotificationProvider, PopoverDropdown, PopoverElement, Radios, Row, Select, Skeleton, Stepper, Tab, TabList, Table, Tag, TextArea, Todo, Tooltip, Typography, WalletModal, Widget, c2, getChainById, getChainHex, getEllipsisTxt, getExplorer, getNativeByChain, getWrappedNative, iconTypes, n4, n6, networkConfigs, useCopyToClipboard, useNotification };
//# sourceMappingURL=web3uikit.esm.js.map
